import oe, { useState as O, useEffect as ne, useRef as dn, useMemo as Fi, createContext as Vu, useContext as Yi, memo as Fp, useReducer as Ap, createElement as Mp, useId as Xr, useCallback as ni } from "react";
import { Title as ys, Container as Hs, Card as cn, Grid as T, Space as $t, Slider as Yu, Input as Ku, Autocomplete as Ju, TextInput as Ko, Image as yi, Anchor as on, Group as ss, Text as Ce, Button as Jt, Paper as Jo, PasswordInput as Dp, Checkbox as $r, AppShell as mr, Loader as Bp, Textarea as Gl, Select as Vl, Radio as vt, useMantineTheme as Wp, Burger as Up, List as Be, Flex as E, Menu as si, Avatar as zp, Notification as Zu, UnstyledButton as Ee, NumberInput as Hp, Divider as Vn, lighten as Yl, Box as Hn, Modal as Nn, Popover as oa, Stack as qp, ActionIcon as rl, SimpleGrid as Gp, RingProgress as Xu, Collapse as Hr, Progress as Qu, Table as Kl, Accordion as Qt, FileButton as Vp, Tooltip as Jl, RadioGroup as Yp, GridCol as fr, PinInput as Kp, Tabs as Xi, Alert as Jp, ColorSchemeScript as Zp, MantineProvider as Xp } from "@mantine/core";
import { useMediaQuery as Ve, useDebouncedValue as Qp } from "@mantine/hooks";
import { Dropzone as qr, MIME_TYPES as it } from "@mantine/dropzone";
import Re from "dayjs";
import { DatePickerInput as e_ } from "@mantine/dates";
import { Carousel as Od } from "@mantine/carousel";
function t_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qi = { exports: {} }, ri = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fd;
function n_() {
  if (Fd) return ri;
  Fd = 1;
  var e = oe, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, d, c) {
    var u, h = {}, p = null, f = null;
    c !== void 0 && (p = "" + c), d.key !== void 0 && (p = "" + d.key), d.ref !== void 0 && (f = d.ref);
    for (u in d) s.call(d, u) && !o.hasOwnProperty(u) && (h[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) h[u] === void 0 && (h[u] = d[u]);
    return { $$typeof: t, type: l, key: p, ref: f, props: h, _owner: r.current };
  }
  return ri.Fragment = n, ri.jsx = a, ri.jsxs = a, ri;
}
var ii = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ad;
function s_() {
  return Ad || (Ad = 1, process.env.NODE_ENV !== "production" && function() {
    var e = oe, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m = Symbol.iterator, g = "@@iterator";
    function v(w) {
      if (w === null || typeof w != "object")
        return null;
      var V = m && w[m] || w[g];
      return typeof V == "function" ? V : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(w) {
      {
        for (var V = arguments.length, te = new Array(V > 1 ? V - 1 : 0), ge = 1; ge < V; ge++)
          te[ge - 1] = arguments[ge];
        y("error", w, te);
      }
    }
    function y(w, V, te) {
      {
        var ge = _.ReactDebugCurrentFrame, Ge = ge.getStackAddendum();
        Ge !== "" && (V += "%s", te = te.concat([Ge]));
        var st = te.map(function(Oe) {
          return String(Oe);
        });
        st.unshift("Warning: " + V), Function.prototype.apply.call(console[w], console, st);
      }
    }
    var P = !1, j = !1, b = !1, N = !1, C = !1, S;
    S = Symbol.for("react.module.reference");
    function F(w) {
      return !!(typeof w == "string" || typeof w == "function" || w === s || w === o || C || w === r || w === c || w === u || N || w === f || P || j || b || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === a || w.$$typeof === l || w.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      w.$$typeof === S || w.getModuleId !== void 0));
    }
    function W(w, V, te) {
      var ge = w.displayName;
      if (ge)
        return ge;
      var Ge = V.displayName || V.name || "";
      return Ge !== "" ? te + "(" + Ge + ")" : te;
    }
    function D(w) {
      return w.displayName || "Context";
    }
    function B(w) {
      if (w == null)
        return null;
      if (typeof w.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof w == "function")
        return w.displayName || w.name || null;
      if (typeof w == "string")
        return w;
      switch (w) {
        case s:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case r:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case l:
            var V = w;
            return D(V) + ".Consumer";
          case a:
            var te = w;
            return D(te._context) + ".Provider";
          case d:
            return W(w, w.render, "ForwardRef");
          case h:
            var ge = w.displayName || null;
            return ge !== null ? ge : B(w.type) || "Memo";
          case p: {
            var Ge = w, st = Ge._payload, Oe = Ge._init;
            try {
              return B(Oe(st));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, G = 0, z, re, X, Q, M, he, le;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function we() {
      {
        if (G === 0) {
          z = console.log, re = console.info, X = console.warn, Q = console.error, M = console.group, he = console.groupCollapsed, le = console.groupEnd;
          var w = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: w,
            log: w,
            warn: w,
            error: w,
            group: w,
            groupCollapsed: w,
            groupEnd: w
          });
        }
        G++;
      }
    }
    function ue() {
      {
        if (G--, G === 0) {
          var w = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, w, {
              value: z
            }),
            info: q({}, w, {
              value: re
            }),
            warn: q({}, w, {
              value: X
            }),
            error: q({}, w, {
              value: Q
            }),
            group: q({}, w, {
              value: M
            }),
            groupCollapsed: q({}, w, {
              value: he
            }),
            groupEnd: q({}, w, {
              value: le
            })
          });
        }
        G < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = _.ReactCurrentDispatcher, Pe;
    function Y(w, V, te) {
      {
        if (Pe === void 0)
          try {
            throw Error();
          } catch (Ge) {
            var ge = Ge.stack.trim().match(/\n( *(at )?)/);
            Pe = ge && ge[1] || "";
          }
        return `
` + Pe + w;
      }
    }
    var ie = !1, ve;
    {
      var Ue = typeof WeakMap == "function" ? WeakMap : Map;
      ve = new Ue();
    }
    function ze(w, V) {
      if (!w || ie)
        return "";
      {
        var te = ve.get(w);
        if (te !== void 0)
          return te;
      }
      var ge;
      ie = !0;
      var Ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var st;
      st = pe.current, pe.current = null, we();
      try {
        if (V) {
          var Oe = function() {
            throw Error();
          };
          if (Object.defineProperty(Oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Oe, []);
            } catch (hn) {
              ge = hn;
            }
            Reflect.construct(w, [], Oe);
          } else {
            try {
              Oe.call();
            } catch (hn) {
              ge = hn;
            }
            w.call(Oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (hn) {
            ge = hn;
          }
          w();
        }
      } catch (hn) {
        if (hn && ge && typeof hn.stack == "string") {
          for (var Ie = hn.stack.split(`
`), nn = ge.stack.split(`
`), Nt = Ie.length - 1, Et = nn.length - 1; Nt >= 1 && Et >= 0 && Ie[Nt] !== nn[Et]; )
            Et--;
          for (; Nt >= 1 && Et >= 0; Nt--, Et--)
            if (Ie[Nt] !== nn[Et]) {
              if (Nt !== 1 || Et !== 1)
                do
                  if (Nt--, Et--, Et < 0 || Ie[Nt] !== nn[Et]) {
                    var En = `
` + Ie[Nt].replace(" at new ", " at ");
                    return w.displayName && En.includes("<anonymous>") && (En = En.replace("<anonymous>", w.displayName)), typeof w == "function" && ve.set(w, En), En;
                  }
                while (Nt >= 1 && Et >= 0);
              break;
            }
        }
      } finally {
        ie = !1, pe.current = st, ue(), Error.prepareStackTrace = Ge;
      }
      var wr = w ? w.displayName || w.name : "", qs = wr ? Y(wr) : "";
      return typeof w == "function" && ve.set(w, qs), qs;
    }
    function He(w, V, te) {
      return ze(w, !1);
    }
    function ft(w) {
      var V = w.prototype;
      return !!(V && V.isReactComponent);
    }
    function et(w, V, te) {
      if (w == null)
        return "";
      if (typeof w == "function")
        return ze(w, ft(w));
      if (typeof w == "string")
        return Y(w);
      switch (w) {
        case c:
          return Y("Suspense");
        case u:
          return Y("SuspenseList");
      }
      if (typeof w == "object")
        switch (w.$$typeof) {
          case d:
            return He(w.render);
          case h:
            return et(w.type, V, te);
          case p: {
            var ge = w, Ge = ge._payload, st = ge._init;
            try {
              return et(st(Ge), V, te);
            } catch {
            }
          }
        }
      return "";
    }
    var Ye = Object.prototype.hasOwnProperty, Mt = {}, Zt = _.ReactDebugCurrentFrame;
    function kt(w) {
      if (w) {
        var V = w._owner, te = et(w.type, w._source, V ? V.type : null);
        Zt.setExtraStackFrame(te);
      } else
        Zt.setExtraStackFrame(null);
    }
    function fe(w, V, te, ge, Ge) {
      {
        var st = Function.call.bind(Ye);
        for (var Oe in w)
          if (st(w, Oe)) {
            var Ie = void 0;
            try {
              if (typeof w[Oe] != "function") {
                var nn = Error((ge || "React class") + ": " + te + " type `" + Oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof w[Oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw nn.name = "Invariant Violation", nn;
              }
              Ie = w[Oe](V, Oe, ge, te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Nt) {
              Ie = Nt;
            }
            Ie && !(Ie instanceof Error) && (kt(Ge), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ge || "React class", te, Oe, typeof Ie), kt(null)), Ie instanceof Error && !(Ie.message in Mt) && (Mt[Ie.message] = !0, kt(Ge), $("Failed %s type: %s", te, Ie.message), kt(null));
          }
      }
    }
    var tt = Array.isArray;
    function pt(w) {
      return tt(w);
    }
    function nt(w) {
      {
        var V = typeof Symbol == "function" && Symbol.toStringTag, te = V && w[Symbol.toStringTag] || w.constructor.name || "Object";
        return te;
      }
    }
    function yt(w) {
      try {
        return Z(w), !1;
      } catch {
        return !0;
      }
    }
    function Z(w) {
      return "" + w;
    }
    function Le(w) {
      if (yt(w))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nt(w)), Z(w);
    }
    var _t = _.ReactCurrentOwner, Dt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tn, $n;
    function Sn(w) {
      if (Ye.call(w, "ref")) {
        var V = Object.getOwnPropertyDescriptor(w, "ref").get;
        if (V && V.isReactWarning)
          return !1;
      }
      return w.ref !== void 0;
    }
    function Yn(w) {
      if (Ye.call(w, "key")) {
        var V = Object.getOwnPropertyDescriptor(w, "key").get;
        if (V && V.isReactWarning)
          return !1;
      }
      return w.key !== void 0;
    }
    function rs(w, V) {
      typeof w.ref == "string" && _t.current;
    }
    function J(w, V) {
      {
        var te = function() {
          tn || (tn = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        te.isReactWarning = !0, Object.defineProperty(w, "key", {
          get: te,
          configurable: !0
        });
      }
    }
    function $e(w, V) {
      {
        var te = function() {
          $n || ($n = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
        };
        te.isReactWarning = !0, Object.defineProperty(w, "ref", {
          get: te,
          configurable: !0
        });
      }
    }
    var je = function(w, V, te, ge, Ge, st, Oe) {
      var Ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: w,
        key: V,
        ref: te,
        props: Oe,
        // Record the component responsible for creating this element.
        _owner: st
      };
      return Ie._store = {}, Object.defineProperty(Ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.defineProperty(Ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ge
      }), Object.freeze && (Object.freeze(Ie.props), Object.freeze(Ie)), Ie;
    };
    function Ne(w, V, te, ge, Ge) {
      {
        var st, Oe = {}, Ie = null, nn = null;
        te !== void 0 && (Le(te), Ie = "" + te), Yn(V) && (Le(V.key), Ie = "" + V.key), Sn(V) && (nn = V.ref, rs(V, Ge));
        for (st in V)
          Ye.call(V, st) && !Dt.hasOwnProperty(st) && (Oe[st] = V[st]);
        if (w && w.defaultProps) {
          var Nt = w.defaultProps;
          for (st in Nt)
            Oe[st] === void 0 && (Oe[st] = Nt[st]);
        }
        if (Ie || nn) {
          var Et = typeof w == "function" ? w.displayName || w.name || "Unknown" : w;
          Ie && J(Oe, Et), nn && $e(Oe, Et);
        }
        return je(w, Ie, nn, Ge, ge, _t.current, Oe);
      }
    }
    var Te = _.ReactCurrentOwner, Kn = _.ReactDebugCurrentFrame;
    function kn(w) {
      if (w) {
        var V = w._owner, te = et(w.type, w._source, V ? V.type : null);
        Kn.setExtraStackFrame(te);
      } else
        Kn.setExtraStackFrame(null);
    }
    var Qr;
    Qr = !1;
    function xr(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }
    function ei() {
      {
        if (Te.current) {
          var w = B(Te.current.type);
          if (w)
            return `

Check the render method of \`` + w + "`.";
        }
        return "";
      }
    }
    function ti(w) {
      return "";
    }
    var yr = {};
    function js(w) {
      {
        var V = ei();
        if (!V) {
          var te = typeof w == "string" ? w : w.displayName || w.name;
          te && (V = `

Check the top-level render call using <` + te + ">.");
        }
        return V;
      }
    }
    function Pd(w, V) {
      {
        if (!w._store || w._store.validated || w.key != null)
          return;
        w._store.validated = !0;
        var te = js(V);
        if (yr[te])
          return;
        yr[te] = !0;
        var ge = "";
        w && w._owner && w._owner !== Te.current && (ge = " It was passed a child from " + B(w._owner.type) + "."), kn(w), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', te, ge), kn(null);
      }
    }
    function Td(w, V) {
      {
        if (typeof w != "object")
          return;
        if (pt(w))
          for (var te = 0; te < w.length; te++) {
            var ge = w[te];
            xr(ge) && Pd(ge, V);
          }
        else if (xr(w))
          w._store && (w._store.validated = !0);
        else if (w) {
          var Ge = v(w);
          if (typeof Ge == "function" && Ge !== w.entries)
            for (var st = Ge.call(w), Oe; !(Oe = st.next()).done; )
              xr(Oe.value) && Pd(Oe.value, V);
        }
      }
    }
    function kp(w) {
      {
        var V = w.type;
        if (V == null || typeof V == "string")
          return;
        var te;
        if (typeof V == "function")
          te = V.propTypes;
        else if (typeof V == "object" && (V.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        V.$$typeof === h))
          te = V.propTypes;
        else
          return;
        if (te) {
          var ge = B(V);
          fe(te, w.props, "prop", ge, w);
        } else if (V.PropTypes !== void 0 && !Qr) {
          Qr = !0;
          var Ge = B(V);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ge || "Unknown");
        }
        typeof V.getDefaultProps == "function" && !V.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ep(w) {
      {
        for (var V = Object.keys(w.props), te = 0; te < V.length; te++) {
          var ge = V[te];
          if (ge !== "children" && ge !== "key") {
            kn(w), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ge), kn(null);
            break;
          }
        }
        w.ref !== null && (kn(w), $("Invalid attribute `ref` supplied to `React.Fragment`."), kn(null));
      }
    }
    var Rd = {};
    function Ld(w, V, te, ge, Ge, st) {
      {
        var Oe = F(w);
        if (!Oe) {
          var Ie = "";
          (w === void 0 || typeof w == "object" && w !== null && Object.keys(w).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var nn = ti();
          nn ? Ie += nn : Ie += ei();
          var Nt;
          w === null ? Nt = "null" : pt(w) ? Nt = "array" : w !== void 0 && w.$$typeof === t ? (Nt = "<" + (B(w.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : Nt = typeof w, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Nt, Ie);
        }
        var Et = Ne(w, V, te, Ge, st);
        if (Et == null)
          return Et;
        if (Oe) {
          var En = V.children;
          if (En !== void 0)
            if (ge)
              if (pt(En)) {
                for (var wr = 0; wr < En.length; wr++)
                  Td(En[wr], w);
                Object.freeze && Object.freeze(En);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Td(En, w);
        }
        if (Ye.call(V, "key")) {
          var qs = B(w), hn = Object.keys(V).filter(function(Op) {
            return Op !== "key";
          }), ia = hn.length > 0 ? "{key: someKey, " + hn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Rd[qs + ia]) {
            var Lp = hn.length > 0 ? "{" + hn.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ia, qs, Lp, qs), Rd[qs + ia] = !0;
          }
        }
        return w === s ? Ep(Et) : kp(Et), Et;
      }
    }
    function Ip(w, V, te) {
      return Ld(w, V, te, !0);
    }
    function Pp(w, V, te) {
      return Ld(w, V, te, !1);
    }
    var Tp = Pp, Rp = Ip;
    ii.Fragment = s, ii.jsx = Tp, ii.jsxs = Rp;
  }()), ii;
}
var Md;
function r_() {
  return Md || (Md = 1, process.env.NODE_ENV === "production" ? Qi.exports = n_() : Qi.exports = s_()), Qi.exports;
}
var i = r_();
const aa = {}, U = ({
  name: e,
  width: t,
  height: n,
  color: s,
  fill: r,
  className: o,
  ariaHidden: a,
  role: l,
  ariaLabel: d,
  size: c,
  strokeWidth: u,
  ...h
}) => {
  const [p, f] = O(null);
  return ne(() => {
    if (typeof window > "u") return;
    const m = `/assets/${e}.svg`;
    aa[m] || (aa[m] = fetch(m, { method: "GET" }).then((g) => {
      if (!g.ok)
        throw new Error(`Failed to fetch SVG: ${g.statusText}`);
      return g.text();
    }).catch((g) => {
      throw console.error("Error fetching SVG:", g), g;
    })), aa[m].then((g) => {
      const $ = new DOMParser().parseFromString(g, "image/svg+xml").querySelector("svg");
      if (!$) {
        console.error("Invalid SVG file:", m);
        return;
      }
      c ? ($.setAttribute("width", c.toString()), $.setAttribute("height", c.toString())) : (t && $.setAttribute("width", t.toString()), n && $.setAttribute("height", n.toString())), s && $.setAttribute("color", s), r && $.setAttribute("fill", r), u && $.setAttribute("stroke-width", (u == null ? void 0 : u.toString()) || ""), o && $.setAttribute("class", o), a !== void 0 && $.setAttribute("aria-hidden", a.toString()), l && $.setAttribute("role", l), d && $.setAttribute("aria-label", d), f(
        oe.createElement("svg", {
          dangerouslySetInnerHTML: { __html: $.innerHTML },
          ...Object.fromEntries([...$.attributes].map((y) => [y.name, y.value])),
          ...h
        })
      );
    }).catch((g) => {
      console.error("Error processing SVG:", g);
    });
  }, [e, t, n, s, r, c, u, a, l, d, o]), p || /* @__PURE__ */ i.jsx("div", { className: "icon-placeholder", "aria-hidden": !0 });
}, gn = {
  black: "#000000",
  white: "#FFFFFF",
  midnightBlue: "#1E3C78",
  azure: "#243D74",
  honey: "#FFAF0F",
  mainRed: "#F05A37",
  ghostBlue: "#F5FAFF",
  tomato: "#F05437",
  tomatoHover: "#FF7D64",
  lightGreyTP: "#0000001A",
  berry: "#2D4B91",
  dimGrey: "#5C6972",
  blueGrey: "#1E3C7827",
  cerulean: "#32B4F0",
  jet: "#333333",
  nonPhotoBlue: "#9EDBF6",
  cadet: "#5A6973",
  aliceBlue: "#EBF5FF",
  blueGreyBorder: "#A7B1C7",
  greySpan: "#B4B4B4",
  softGray: "#DEDEDE",
  arsenic: "#41434C",
  solitude: "#EDEEF0",
  alabaster: "#FAFAFA",
  brightGreen: "#00B812",
  secondaryGray: "#7A8287",
  aluminium: "#8D8D8D",
  deepSkyBlue: "#8CDDF9",
  transparent: "transparent",
  green: "#008000",
  brightGrey: "#41434C",
  concord: "#7C7C7C",
  shuttelGrey: "#5A6973"
}, i_ = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  currencyDisplay: "symbol",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
}), Je = (e = 0) => "US" + i_.format(e), ee = ({
  children: e,
  order: t = 1,
  variant: n,
  fontWeight: s,
  fontSize: r,
  className: o,
  style: a,
  id: l,
  ...d
}) => {
  const { requiredAsterisk: c = !1 } = d || {};
  let u;
  const h = Ve("(max-width: 767px)");
  switch (n) {
    case "white":
      u = "#fff";
      break;
    case "yellow":
      u = "#FFAF0F";
      break;
    case "blue":
      u = "#1E3C78";
      break;
    case "black":
      u = "#333333";
      break;
    case "cerulean":
      u = gn.cerulean;
      break;
    default:
      u = void 0;
      break;
  }
  switch (s) {
    case "200":
      s = "200";
      break;
    case "400":
      s = "400";
      break;
    case "700":
      s = "700";
      break;
    case "initial":
      s = void 0;
      break;
    default:
      s = "400";
      break;
  }
  return /* @__PURE__ */ i.jsxs(
    ys,
    {
      order: t,
      className: o,
      style: { color: u, fontWeight: s, fontSize: r, ...a },
      lts: h ? 0.5 : 0,
      ...d,
      children: [
        e,
        " ",
        c && /* @__PURE__ */ i.jsx("span", { className: "requiredFeild", children: "*" })
      ]
    }
  );
}, o_ = "_track_wfs5q_1", a_ = "_thumb_wfs5q_5", l_ = "_bar_wfs5q_12", d_ = "_mark_wfs5q_16", c_ = "_markLabel_wfs5q_20", u_ = "_cardRoot_wfs5q_25", h_ = "_sliderOuter_wfs5q_38", Gs = {
  track: o_,
  thumb: a_,
  bar: l_,
  mark: d_,
  markLabel: c_,
  cardRoot: u_,
  sliderOuter: h_
}, WT = ({
  defaultValue: e,
  label: t = "",
  className: n,
  id: s,
  id1: r,
  updatedValue: o,
  maxVal: a,
  step: l,
  marks: d,
  hideSlider: c = !1
}) => {
  const [u, h] = O(e), p = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(Hs, { className: Gs.sliderOuter, "data-testid": r, children: /* @__PURE__ */ i.jsx(cn, { shadow: "lg", p: "lg", radius: "sm", px: 50, classNames: { root: Gs.cardRoot }, children: /* @__PURE__ */ i.jsx(T, { style: { textAlign: "center" }, children: /* @__PURE__ */ i.jsxs(T.Col, { children: [
    /* @__PURE__ */ i.jsx(ee, { order: p ? 4 : 3, variant: "blue", fontWeight: "400", children: "You're approved for up to:" }),
    /* @__PURE__ */ i.jsx(ee, { order: 2, variant: "blue", fontWeight: "700", children: Je(d[1].value) }),
    /* @__PURE__ */ i.jsx($t, { h: 40 }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    !c && /* @__PURE__ */ i.jsx(
      Yu,
      {
        classNames: {
          bar: Gs.bar,
          track: Gs.track,
          thumb: Gs.thumb,
          mark: Gs.mark,
          markLabel: Gs.markLabel
        },
        id: s,
        defaultValue: e,
        name: s,
        label: null,
        value: u,
        onChange: h,
        min: d[0].value,
        max: d[1].value,
        step: l,
        marks: d,
        size: "xl",
        radius: "xl"
      }
    ),
    !c && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx($t, { h: 40 }),
      /* @__PURE__ */ i.jsx(ee, { order: p ? 4 : 3, variant: "blue", fontWeight: "400", children: "Your request:" }),
      /* @__PURE__ */ i.jsx($t, { h: 5 }),
      /* @__PURE__ */ i.jsx(ee, { order: 2, variant: "blue", fontWeight: "700", children: Je(u) })
    ] })
  ] }) }) }) }) });
}, f_ = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:22|44|7[27]|87|9[69])[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-689]|8[1-69]|9[1-578])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Zl(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(f_), e.apply(this, n);
}
function il(e) {
  "@babel/helpers - typeof";
  return il = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, il(e);
}
function p_(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function __(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function m_(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ai(e, t);
}
function g_(e) {
  var t = th();
  return function() {
    var s = Mi(e), r;
    if (t) {
      var o = Mi(this).constructor;
      r = Reflect.construct(s, arguments, o);
    } else
      r = s.apply(this, arguments);
    return v_(this, r);
  };
}
function v_(e, t) {
  if (t && (il(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return eh(e);
}
function eh(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ol(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ol = function(s) {
    if (s === null || !$_(s)) return s;
    if (typeof s != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(s)) return t.get(s);
      t.set(s, r);
    }
    function r() {
      return $o(s, arguments, Mi(this).constructor);
    }
    return r.prototype = Object.create(s.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), Ai(r, s);
  }, ol(e);
}
function $o(e, t, n) {
  return th() ? $o = Reflect.construct : $o = function(r, o, a) {
    var l = [null];
    l.push.apply(l, o);
    var d = Function.bind.apply(r, l), c = new d();
    return a && Ai(c, a.prototype), c;
  }, $o.apply(null, arguments);
}
function th() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $_(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Ai(e, t) {
  return Ai = Object.setPrototypeOf || function(s, r) {
    return s.__proto__ = r, s;
  }, Ai(e, t);
}
function Mi(e) {
  return Mi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mi(e);
}
var ms = /* @__PURE__ */ function(e) {
  m_(n, e);
  var t = g_(n);
  function n(s) {
    var r;
    return __(this, n), r = t.call(this, s), Object.setPrototypeOf(eh(r), n.prototype), r.name = r.constructor.name, r;
  }
  return p_(n);
}(/* @__PURE__ */ ol(Error)), Xl = 2, b_ = 17, x_ = 3, Gn = "0-9０-９٠-٩۰-۹", y_ = "-‐-―−ー－", w_ = "／/", C_ = "．.", j_ = "  ­​⁠　", N_ = "()（）［］\\[\\]", S_ = "~⁓∼～", ko = "".concat(y_).concat(w_).concat(C_).concat(j_).concat(N_).concat(S_), Ql = "+＋";
function Dd(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), s = t[0].split("."), r = 0; r < 3; r++) {
    var o = Number(n[r]), a = Number(s[r]);
    if (o > a) return 1;
    if (a > o) return -1;
    if (!isNaN(o) && isNaN(a)) return 1;
    if (isNaN(o) && !isNaN(a)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var k_ = {}.constructor;
function bo(e) {
  return e != null && e.constructor === k_;
}
function al(e) {
  "@babel/helpers - typeof";
  return al = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, al(e);
}
function Zo(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E_(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function Xo(e, t, n) {
  return t && E_(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var I_ = "1.2.0", P_ = "1.7.35", Bd = " ext. ", T_ = /^\d+$/, un = /* @__PURE__ */ function() {
  function e(t) {
    Zo(this, e), F_(t), this.metadata = t, nh.call(this, t);
  }
  return Xo(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var s = this.countryCallingCodes()[n];
        if (s && s.length === 1 && s[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, s) {
      if (n && T_.test(n) && (s = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new Wd(this.getCountryMetadata(n), this);
      } else if (s) {
        if (!this.hasCallingCode(s))
          throw new Error("Unknown calling code: ".concat(s));
        this.numberingPlan = new Wd(this.getNumberingPlanMetadata(s), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var s = this.countryCallingCodes()[n];
      if (s)
        return s.length === 1 && s[0].length === 3 ? void 0 : s;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var s = this.getCountryCodesForCallingCode(n);
      if (s)
        return s[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var s = this.getCountryCodeForCallingCode(n);
      if (s)
        return this.getCountryMetadata(s);
      if (this.nonGeographic()) {
        var r = this.nonGeographic()[n];
        if (r)
          return r;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Wd = /* @__PURE__ */ function() {
  function e(t, n) {
    Zo(this, e), this.globalMetadataObject = n, this.metadata = t, nh.call(this, n.metadata);
  }
  return Xo(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, s = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return s.map(function(r) {
        return new R_(r, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Ud(this.types(), n))
        return new O_(Ud(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Bd : this.metadata[13] || Bd;
    }
  }]), e;
}(), R_ = /* @__PURE__ */ function() {
  function e(t, n) {
    Zo(this, e), this._format = t, this.metadata = n;
  }
  return Xo(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !L_.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), L_ = /^\(?\$1\)?$/, O_ = /* @__PURE__ */ function() {
  function e(t, n) {
    Zo(this, e), this.type = t, this.metadata = n;
  }
  return Xo(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Ud(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function F_(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!bo(e) || !bo(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(bo(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + A_(e) + ": " + e, "."));
}
var A_ = function(t) {
  return al(t);
};
function ed(e, t) {
  if (t = new un(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function M_(e, t) {
  return t.countries.hasOwnProperty(e);
}
function nh(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Dd(t, I_) === -1 ? this.v2 = !0 : Dd(t, P_) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var D_ = ";ext=", Cr = function(t) {
  return "([".concat(Gn, "]{1,").concat(t, "})");
};
function sh(e) {
  var t = "20", n = "15", s = "9", r = "6", o = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", l = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", h = "[  \\t]*", p = "(?:,{2}|;)", f = D_ + Cr(t), m = o + d + a + Cr(t) + l, g = o + c + a + Cr(s) + l, v = u + Cr(r) + "#", _ = h + p + a + Cr(n) + l, $ = h + "(?:,)+" + a + Cr(s) + l;
  return f + "|" + m + "|" + g + "|" + v + "|" + _ + "|" + $;
}
var B_ = "[" + Gn + "]{" + Xl + "}", W_ = "[" + Ql + "]{0,1}(?:[" + ko + "]*[" + Gn + "]){3,}[" + ko + Gn + "]*", U_ = new RegExp("^[" + Ql + "]{0,1}(?:[" + ko + "]*[" + Gn + "]){1,2}$", "i"), z_ = W_ + // Phone number extensions
"(?:" + sh() + ")?", H_ = new RegExp(
  // Either a short two-digit-only phone number
  "^" + B_ + "$|^" + z_ + "$",
  "i"
);
function q_(e) {
  return e.length >= Xl && H_.test(e);
}
function G_(e) {
  return U_.test(e);
}
var zd = new RegExp("(?:" + sh() + ")$", "i");
function V_(e) {
  var t = e.search(zd);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), s = e.match(zd), r = 1; r < s.length; ) {
    if (s[r])
      return {
        number: n,
        ext: s[r]
      };
    r++;
  }
}
var Y_ = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function K_(e) {
  return Y_[e];
}
function J_(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Z_(e)) || t) {
    n && (e = n);
    var s = 0;
    return function() {
      return s >= e.length ? { done: !0 } : { done: !1, value: e[s++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z_(e, t) {
  if (e) {
    if (typeof e == "string") return Hd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Hd(e, t);
  }
}
function Hd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
function qd(e) {
  for (var t = "", n = J_(e.split("")), s; !(s = n()).done; ) {
    var r = s.value;
    t += X_(r, t) || "";
  }
  return t;
}
function X_(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : K_(e);
}
function td(e, t) {
  return Q_(e, void 0, t);
}
function Q_(e, t, n) {
  var s = n.type(t), r = s && s.possibleLengths() || n.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  var o = e.length, a = r[0];
  return a === o ? "IS_POSSIBLE" : a > o ? "TOO_SHORT" : r[r.length - 1] < o ? "TOO_LONG" : r.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function em(e, t, n) {
  if (t === void 0 && (t = {}), n = new un(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return rh(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function rh(e, t) {
  switch (td(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Cs(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function tm(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = nm(e)) || t) {
    n && (e = n);
    var s = 0;
    return function() {
      return s >= e.length ? { done: !0 } : { done: !1, value: e[s++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nm(e, t) {
  if (e) {
    if (typeof e == "string") return Gd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gd(e, t);
  }
}
function Gd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
var sm = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function nd(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new un(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var s = t.v2 ? e.nationalNumber : e.phone;
    if (Cs(s, n.nationalNumberPattern())) {
      if (la(s, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || la(s, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = tm(sm), o; !(o = r()).done; ) {
        var a = o.value;
        if (la(s, a, n))
          return a;
      }
    }
  }
}
function la(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Cs(e, t.pattern());
}
function rm(e, t, n) {
  if (t = t || {}, n = new un(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return nd(e, t, n.metadata) !== void 0;
  var s = t.v2 ? e.nationalNumber : e.phone;
  return Cs(s, n.nationalNumberPattern());
}
function im(e, t, n) {
  var s = new un(n), r = s.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(o) {
    return om(t, o, n);
  }) : [];
}
function om(e, t, n) {
  var s = new un(n);
  return s.selectNumberingPlan(t), s.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function am(e) {
  return e.replace(new RegExp("[".concat(ko, "]+"), "g"), " ").trim();
}
var lm = /(\$\d)/;
function dm(e, t, n) {
  var s = n.useInternationalFormat, r = n.withNationalPrefix, o = e.replace(new RegExp(t.pattern()), s ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && t.nationalPrefixFormattingRule() ? t.format().replace(lm, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return s ? am(o) : o;
}
var cm = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function um(e, t, n) {
  var s = new un(n);
  if (s.selectNumberingPlan(e, t), s.defaultIDDPrefix())
    return s.defaultIDDPrefix();
  if (cm.test(s.IDDPrefix()))
    return s.IDDPrefix();
}
function hm(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function fm(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = pm(e)) || t) {
    n && (e = n);
    var s = 0;
    return function() {
      return s >= e.length ? { done: !0 } : { done: !1, value: e[s++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pm(e, t) {
  if (e) {
    if (typeof e == "string") return Vd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Vd(e, t);
  }
}
function Vd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
function Yd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function Kd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yd(Object(n), !0).forEach(function(s) {
      _m(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yd(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function _m(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Jd = {
  formatExtension: function(t, n, s) {
    return "".concat(t).concat(s.ext()).concat(n);
  }
};
function mm(e, t, n, s) {
  if (n ? n = Kd(Kd({}, Jd), n) : n = Jd, s = new un(s), e.country && e.country !== "001") {
    if (!s.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    s.country(e.country);
  } else if (e.countryCallingCode)
    s.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var r = s.countryCallingCode(), o = n.v2 ? e.nationalNumber : e.phone, a;
  switch (t) {
    case "NATIONAL":
      return o ? (a = Eo(o, e.carrierCode, "NATIONAL", s, n), da(a, e.ext, s, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (a = Eo(o, null, "INTERNATIONAL", s, n), a = "+".concat(r, " ").concat(a), da(a, e.ext, s, n.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(o);
    case "RFC3966":
      return hm({
        number: "+".concat(r).concat(o),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var l = vm(o, e.carrierCode, r, n.fromCountry, s);
      return da(l, e.ext, s, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Eo(e, t, n, s, r) {
  var o = gm(s.formats(), e);
  return o ? dm(e, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: t,
    metadata: s
  }) : e;
}
function gm(e, t) {
  for (var n = fm(e), s; !(s = n()).done; ) {
    var r = s.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var o = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(o) !== 0)
        continue;
    }
    if (Cs(t, r.pattern()))
      return r;
  }
}
function da(e, t, n, s) {
  return t ? s(e, t, n) : e;
}
function vm(e, t, n, s, r) {
  var o = ed(s, r.metadata);
  if (o === n) {
    var a = Eo(e, t, "NATIONAL", r);
    return n === "1" ? n + " " + a : a;
  }
  var l = um(s, void 0, r.metadata);
  if (l)
    return "".concat(l, " ").concat(n, " ").concat(Eo(e, null, "INTERNATIONAL", r));
}
function Zd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function Xd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zd(Object(n), !0).forEach(function(s) {
      $m(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zd(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function $m(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function bm(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function ym(e, t, n) {
  return xm(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var wm = /* @__PURE__ */ function() {
  function e(t, n, s) {
    if (bm(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!s)
      throw new TypeError("`metadata` not passed");
    var r = jm(t, s), o = r.country, a = r.countryCallingCode;
    this.country = o, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return s;
    };
  }
  return ym(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : im(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return em(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return rm(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new un(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return nd(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, s) {
      return mm(this, n, s ? Xd(Xd({}, s), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), Cm = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function jm(e, t) {
  var n, s, r = new un(t);
  return Cm(e) ? (n = e, r.selectNumberingPlan(n), s = r.countryCallingCode()) : s = e, {
    country: n,
    countryCallingCode: s
  };
}
var Nm = new RegExp("([" + Gn + "])");
function Sm(e, t, n, s) {
  if (t) {
    var r = new un(s);
    r.selectNumberingPlan(t, n);
    var o = new RegExp(r.IDDPrefix());
    if (e.search(o) === 0) {
      e = e.slice(e.match(o)[0].length);
      var a = e.match(Nm);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function km(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), s = n.exec(e);
    if (s) {
      var r, o, a = s.length - 1, l = a > 0 && s[a];
      if (t.nationalPrefixTransformRule() && l)
        r = e.replace(n, t.nationalPrefixTransformRule()), a > 1 && (o = s[1]);
      else {
        var d = s[0];
        r = e.slice(d.length), l && (o = s[1]);
      }
      var c;
      if (l) {
        var u = e.indexOf(s[1]), h = e.slice(0, u);
        h === t.numberingPlan.nationalPrefix() && (c = t.numberingPlan.nationalPrefix());
      } else
        c = s[0];
      return {
        nationalNumber: r,
        nationalPrefix: c,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function ll(e, t) {
  var n = km(e, t), s = n.carrierCode, r = n.nationalNumber;
  if (r !== e) {
    if (!Em(e, r, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !Im(r, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: s
  };
}
function Em(e, t, n) {
  return !(Cs(e, n.nationalNumberPattern()) && !Cs(t, n.nationalNumberPattern()));
}
function Im(e, t) {
  switch (td(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Pm(e, t, n, s) {
  var r = t ? ed(t, s) : n;
  if (e.indexOf(r) === 0) {
    s = new un(s), s.selectNumberingPlan(t, n);
    var o = e.slice(r.length), a = ll(o, s), l = a.nationalNumber, d = ll(e, s), c = d.nationalNumber;
    if (!Cs(c, s.nationalNumberPattern()) && Cs(l, s.nationalNumberPattern()) || td(c, s) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: o
      };
  }
  return {
    number: e
  };
}
function Tm(e, t, n, s) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var o = Sm(e, t, n, s);
    if (o && o !== e)
      r = !0, e = "+" + o;
    else {
      if (t || n) {
        var a = Pm(e, t, n, s), l = a.countryCallingCode, d = a.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  s = new un(s);
  for (var c = 2; c - 1 <= x_ && c <= e.length; ) {
    var u = e.slice(1, c);
    if (s.hasCallingCode(u))
      return s.selectNumberingPlan(u), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function Rm(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Lm(e)) || t) {
    n && (e = n);
    var s = 0;
    return function() {
      return s >= e.length ? { done: !0 } : { done: !1, value: e[s++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lm(e, t) {
  if (e) {
    if (typeof e == "string") return Qd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Qd(e, t);
  }
}
function Qd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
function Om(e, t) {
  var n = t.countries, s = t.defaultCountry, r = t.metadata;
  r = new un(r);
  for (var o = [], a = Rm(n), l; !(l = a()).done; ) {
    var d = l.value;
    if (r.country(d), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return d;
    } else if (nd({
      phone: e,
      country: d
    }, void 0, r.metadata))
      if (s) {
        if (d === s)
          return d;
        o.push(d);
      } else
        return d;
  }
  if (o.length > 0)
    return o[0];
}
function Fm(e, t) {
  var n = t.nationalNumber, s = t.defaultCountry, r = t.metadata, o = r.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : Om(n, {
      countries: o,
      defaultCountry: s,
      metadata: r.metadata
    });
}
var ih = "+", Am = "[\\-\\.\\(\\)]?", ec = "([" + Gn + "]|" + Am + ")", Mm = "^\\" + ih + ec + "*[" + Gn + "]" + ec + "*$", Dm = new RegExp(Mm, "g"), dl = Gn, Bm = "[" + dl + "]+((\\-)*[" + dl + "])*", Wm = "a-zA-Z", Um = "[" + Wm + "]+((\\-)*[" + dl + "])*", zm = "^(" + Bm + "\\.)*" + Um + "\\.?$", Hm = new RegExp(zm, "g"), tc = "tel:", cl = ";phone-context=", qm = ";isub=";
function Gm(e) {
  var t = e.indexOf(cl);
  if (t < 0)
    return null;
  var n = t + cl.length;
  if (n >= e.length)
    return "";
  var s = e.indexOf(";", n);
  return s >= 0 ? e.substring(n, s) : e.substring(n);
}
function Vm(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Dm.test(e) || Hm.test(e);
}
function Ym(e, t) {
  var n = t.extractFormattedPhoneNumber, s = Gm(e);
  if (!Vm(s))
    throw new ms("NOT_A_NUMBER");
  var r;
  if (s === null)
    r = n(e) || "";
  else {
    r = "", s.charAt(0) === ih && (r += s);
    var o = e.indexOf(tc), a;
    o >= 0 ? a = o + tc.length : a = 0;
    var l = e.indexOf(cl);
    r += e.substring(a, l);
  }
  var d = r.indexOf(qm);
  if (d > 0 && (r = r.substring(0, d)), r !== "")
    return r;
}
var Km = 250, Jm = new RegExp("[" + Ql + Gn + "]"), Zm = new RegExp("[^" + Gn + "#]+$");
function Xm(e, t, n) {
  if (t = t || {}, n = new un(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new ms("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var s = e1(e, t.v2, t.extract), r = s.number, o = s.ext, a = s.error;
  if (!r) {
    if (t.v2)
      throw a === "TOO_SHORT" ? new ms("TOO_SHORT") : new ms("NOT_A_NUMBER");
    return {};
  }
  var l = n1(r, t.defaultCountry, t.defaultCallingCode, n), d = l.country, c = l.nationalNumber, u = l.countryCallingCode, h = l.countryCallingCodeSource, p = l.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new ms("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < Xl) {
    if (t.v2)
      throw new ms("TOO_SHORT");
    return {};
  }
  if (c.length > b_) {
    if (t.v2)
      throw new ms("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var f = new wm(u, c, n.metadata);
    return d && (f.country = d), p && (f.carrierCode = p), o && (f.ext = o), f.__countryCallingCodeSource = h, f;
  }
  var m = (t.extended ? n.hasSelectedNumberingPlan() : d) ? Cs(c, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: u,
    carrierCode: p,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && n.possibleLengths() && rh(c, n)),
    phone: c,
    ext: o
  } : m ? t1(d, c, o) : {};
}
function Qm(e, t, n) {
  if (e) {
    if (e.length > Km) {
      if (n)
        throw new ms("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var s = e.search(Jm);
    if (!(s < 0))
      return e.slice(s).replace(Zm, "");
  }
}
function e1(e, t, n) {
  var s = Ym(e, {
    extractFormattedPhoneNumber: function(a) {
      return Qm(a, n, t);
    }
  });
  if (!s)
    return {};
  if (!q_(s))
    return G_(s) ? {
      error: "TOO_SHORT"
    } : {};
  var r = V_(s);
  return r.ext ? r : {
    number: s
  };
}
function t1(e, t, n) {
  var s = {
    country: e,
    phone: t
  };
  return n && (s.ext = n), s;
}
function n1(e, t, n, s) {
  var r = Tm(qd(e), t, n, s.metadata), o = r.countryCallingCodeSource, a = r.countryCallingCode, l = r.number, d;
  if (a)
    s.selectNumberingPlan(a);
  else if (l && (t || n))
    s.selectNumberingPlan(t, n), t && (d = t), a = n || ed(t, s.metadata);
  else return {};
  if (!l)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: a
    };
  var c = ll(qd(l), s), u = c.nationalNumber, h = c.carrierCode, p = Fm(a, {
    nationalNumber: u,
    defaultCountry: t,
    metadata: s
  });
  return p && (d = p, p === "001" || s.country(d)), {
    country: d,
    countryCallingCode: a,
    countryCallingCodeSource: o,
    nationalNumber: u,
    carrierCode: h
  };
}
function nc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function sc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nc(Object(n), !0).forEach(function(s) {
      s1(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function s1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function r1(e, t, n) {
  return Xm(e, sc(sc({}, t), {}, {
    v2: !0
  }), n);
}
function rc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function i1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rc(Object(n), !0).forEach(function(s) {
      o1(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function o1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function a1(e, t) {
  return u1(e) || c1(e, t) || d1(e, t) || l1();
}
function l1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function d1(e, t) {
  if (e) {
    if (typeof e == "string") return ic(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ic(e, t);
  }
}
function ic(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
function c1(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var s = [], r = !0, o = !1, a, l;
    try {
      for (n = n.call(e); !(r = (a = n.next()).done) && (s.push(a.value), !(t && s.length === t)); r = !0)
        ;
    } catch (d) {
      o = !0, l = d;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (o) throw l;
      }
    }
    return s;
  }
}
function u1(e) {
  if (Array.isArray(e)) return e;
}
function sd(e) {
  var t = Array.prototype.slice.call(e), n = a1(t, 4), s = n[0], r = n[1], o = n[2], a = n[3], l, d, c;
  if (typeof s == "string")
    l = s;
  else throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    a ? (d = o, c = a) : (d = void 0, c = o), r && (d = i1({
      defaultCountry: r
    }, d));
  else if (bo(r))
    o ? (d = r, c = o) : c = r;
  else throw new Error("Invalid second argument: ".concat(r));
  return {
    text: l,
    options: d,
    metadata: c
  };
}
function oc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function ac(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oc(Object(n), !0).forEach(function(s) {
      h1(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function h1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rd(e, t, n) {
  t && t.defaultCountry && !M_(t.defaultCountry, n) && (t = ac(ac({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return r1(e, t, n);
  } catch (s) {
    if (!(s instanceof ms)) throw s;
  }
}
function f1() {
  var e = sd(arguments), t = e.text, n = e.options, s = e.metadata;
  return rd(t, n, s);
}
function lc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function dc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lc(Object(n), !0).forEach(function(s) {
      p1(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function p1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _1() {
  var e = sd(arguments), t = e.text, n = e.options, s = e.metadata;
  n = dc(dc({}, n), {}, {
    extract: !1
  });
  var r = rd(t, n, s);
  return r && r.isValid() || !1;
}
function cc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function uc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cc(Object(n), !0).forEach(function(s) {
      m1(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
function m1(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function g1() {
  var e = sd(arguments), t = e.text, n = e.options, s = e.metadata;
  n = uc(uc({}, n), {}, {
    extract: !1
  });
  var r = rd(t, n, s);
  return r && r.isPossible() || !1;
}
function v1() {
  return Zl(f1, arguments);
}
function ul() {
  return Zl(_1, arguments);
}
function $1() {
  return Zl(g1, arguments);
}
const b1 = "_label_9eqa0_1", x1 = "_arrow_9eqa0_8", y1 = "_root_9eqa0_22", w1 = "_input_9eqa0_32", C1 = "_countryCode_9eqa0_49", j1 = "_autoCompleteDropdown_9eqa0_60", N1 = "_option_9eqa0_85", Vs = {
  label: b1,
  arrow: x1,
  root: y1,
  input: w1,
  countryCode: C1,
  autoCompleteDropdown: j1,
  option: N1
}, S1 = oe.forwardRef(
  ({ value: e, emoji: t, code: n, ...s }, r) => /* @__PURE__ */ i.jsx("div", { ref: r, ...s, children: e })
);
S1.displayName = "PhoneNumberCode";
const UT = ({
  id: e,
  label: t,
  countryCodes: n = [],
  onChange: s,
  error: r,
  validity: o,
  defaultValue: a,
  status: l = !0,
  IncomingselectedCountryData: d
}) => {
  const [c, u] = O(
    a === void 0 ? "" : a.toString().split("-")[0]
  ), h = Ve("(max-width: 767px)"), [p, f] = O(a === void 0 ? "" : a == null ? void 0 : a.split("-")[1]), m = dn(null), [g, v] = O(""), [_, $] = O(!1), [y, P] = O(""), [j, b] = O("");
  let N = Fi(() => {
    var D;
    try {
      if (c) {
        const B = c == null ? void 0 : c.split(" - "), q = B && B[0], G = (D = n.find((z) => z.emoji === q)) == null ? void 0 : D.key;
        return G || (!(r != null && r.fieldErrors[e]) && B[0].length === 0 ? "" : (r != null && r.fieldErrors[e] && B[0].length === 0, "Invalid"));
      }
    } catch {
    }
  }, [n, c, p]);
  const [C, S] = O();
  ne(() => {
    var D;
    try {
      if (c) {
        const B = c == null ? void 0 : c.split(" - "), q = B && B[0], G = (D = n.find((z) => {
          if (z.emoji === q)
            return S(z), z;
        })) == null ? void 0 : D.code;
        b("+" + G + "-" + p);
      }
    } catch {
    }
  }, [c, p]), ne(() => {
    s && s(`${c}-${p}`, C);
  }, [p, c, s]), ne(() => {
    var D;
    if (c) {
      const B = n.filter((q) => {
        var G;
        if (((G = JSON.parse(d)) == null ? void 0 : G.key) === (q == null ? void 0 : q.key) && q.code === c.split("+")[1])
          return q;
      });
      u((D = B[0]) == null ? void 0 : D.value);
    }
  }, []), ne(() => {
    v("");
  }, [c]), ne(() => {
    r != null && r.fieldErrors[e] && N === "Invalid" ? v("Required") : v(""), (r && l === !1 || a) && $(!0);
  }, [r]);
  const F = () => {
    var D, B;
    return p.length > 0 && N !== "Invalid" && !ul(p, N) || p.length === 0 ? "Please enter a valid phone number" : (D = r == null ? void 0 : r.fieldErrors) != null && D.referenceMobile && ((B = r == null ? void 0 : r.fieldErrors) == null ? void 0 : B.referenceMobile[0]) === "Your reference cannot have the same phone number as you, please enter a valid phone number" ? "Your reference cannot have the same phone number as you, please enter a valid phone number" : null;
  }, W = _ ? F() : null;
  return ne(() => {
    var D;
    P((D = F()) == null ? void 0 : D.toString());
  }, [F]), /* @__PURE__ */ i.jsx(Ku.Wrapper, { label: t, classNames: Vs, id: "input-wrapper", children: /* @__PURE__ */ i.jsxs(T, { gutter: 0, children: [
    /* @__PURE__ */ i.jsxs(T.Col, { span: 3, children: [
      /* @__PURE__ */ i.jsx(
        "input",
        {
          type: "hidden",
          name: e,
          id: e + "hidden",
          "data-testid": e + "hidden",
          value: j
        }
      ),
      /* @__PURE__ */ i.jsx(
        Ju,
        {
          id: `${e}-autocomplete`,
          className: Vs.countryCode,
          classNames: {
            input: Vs.input,
            dropdown: Vs.autoCompleteDropdown,
            option: Vs.option
          },
          data: n,
          withScrollArea: !1,
          filter: ({ options: D, search: B }) => n.filter((q) => q.name.toLowerCase().includes(B.toLowerCase().trim()) || q.code.includes(
            B.substring(0, 1) === "+" ? B.substring(1).trim() : B.trim()
          )),
          value: c,
          onChange: u,
          onDropdownClose: () => {
            var D;
            return (D = m.current) == null ? void 0 : D.focus();
          },
          placeholder: h ? "Code" : "Country Code",
          rightSection: /* @__PURE__ */ i.jsx("i", { className: Vs.arrow }),
          rightSectionWidth: 10,
          error: g || N === "Invalid" ? "Please select a valid country code from the dropdown" : null,
          limit: 200
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs(T.Col, { span: 9, pl: 30, children: [
      /* @__PURE__ */ i.jsx(
        Ko,
        {
          id: e,
          classNames: Vs,
          value: p,
          onChange: (D) => {
            const B = D.currentTarget.value;
            B.length <= 40 && f(B);
          },
          ref: m,
          readOnly: c === "",
          type: "number",
          placeholder: "Mobile phone number",
          error: W
        }
      ),
      /* @__PURE__ */ i.jsx("input", { type: "hidden", name: o, id: o, value: y })
    ] })
  ] }) });
}, k1 = "_infoCard_1bg51_1", E1 = "_editName_1bg51_8", I1 = "_text_1bg51_15", P1 = "_previewImage_1bg51_19", T1 = "_root_1bg51_31", R1 = "_crossIcon_1bg51_35", L1 = "_imageContainer_1bg51_49", O1 = "_error_1bg51_55", mt = {
  infoCard: k1,
  editName: E1,
  text: I1,
  previewImage: P1,
  root: T1,
  crossIcon: R1,
  imageContainer: L1,
  error: O1
}, F1 = () => /* @__PURE__ */ i.jsx(ss, { justify: "center", gap: "xl", style: { minHeight: 220, pointerEvents: "none" }, children: /* @__PURE__ */ i.jsxs("div", { children: [
  /* @__PURE__ */ i.jsx(Ce, { size: "xl", inline: !0, children: "Drag images here or click to select files" }),
  /* @__PURE__ */ i.jsx(Ce, { size: "sm", color: "dimmed", inline: !0, mt: 7, children: "Attach as many files as you like, each file should not exceed 5mb" })
] }) }), A1 = () => /* @__PURE__ */ i.jsx(ss, { justify: "center", gap: "xl", style: { minHeight: 220, pointerEvents: "none" }, children: /* @__PURE__ */ i.jsxs("div", { children: [
  /* @__PURE__ */ i.jsx(Ce, { size: "xl", inline: !0, children: "Drag images here or click to select files" }),
  /* @__PURE__ */ i.jsx(Ce, { size: "sm", color: "dimmed", inline: !0, mt: 7, children: "Attach as many files as you like, each file should not exceed 5mb" })
] }) }), zT = ({
  id: e,
  firstDocId: t,
  secDocId: n,
  error: s,
  showBacksideUploadButton: r
}) => {
  let o = dn(), a = dn();
  const [l, d] = O("upload front side"), [c, u] = O("upload back side"), [h, p] = O([]), [f, m] = O([]), [g, v] = O(!1), [_, $] = O(!1), y = (N) => {
    o.current(), p([]);
  }, P = (N) => {
    a.current(), m([]);
  }, j = () => o ? o.current() : null, b = () => a ? a.current() : null;
  return ne(() => {
    h.length === 1 ? (h.map((N, C) => {
      const S = URL.createObjectURL(N);
      return /* @__PURE__ */ i.jsxs(T.Col, { span: { xs: 12, md: 12 }, className: mt.imageContainer, children: [
        /* @__PURE__ */ i.jsx("p", { className: mt.crossIcon, onClick: () => y(), children: "X" }),
        N.type === "application/pdf" ? /* @__PURE__ */ i.jsx("iframe", { src: S, className: mt.previewImage }) : /* @__PURE__ */ i.jsx(
          yi,
          {
            src: S,
            style: { float: "left", image: mt.previewImage }
          },
          C
        )
      ] }, N.name);
    }), v(!0), d("")) : (d("Upload front side"), v(!1));
  }, [h]), ne(() => {
    f.length === 1 ? (u(""), f.map((N, C) => {
      const S = URL.createObjectURL(N);
      return /* @__PURE__ */ i.jsxs(T.Col, { span: { xs: 12, md: 12 }, className: mt.imageContainer, children: [
        /* @__PURE__ */ i.jsx("p", { className: mt.crossIcon, onClick: () => P(), children: "X" }),
        N.type === "application/pdf" ? /* @__PURE__ */ i.jsx("iframe", { src: S, className: mt.previewImage }) : /* @__PURE__ */ i.jsx(
          yi,
          {
            src: S,
            style: { float: "left", image: mt.previewImage }
          },
          C
        )
      ] }, N.name);
    }), $(!0)) : (u("Upload back side"), $(!1));
  }, [f]), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(
      qr,
      {
        openRef: o,
        onDrop: (N) => {
          p([...h, N[0]]);
        },
        className: mt.root,
        multiple: !1,
        name: t,
        useFsAccessApi: !1,
        accept: [it.png, it.jpeg, it.svg, it.gif, it.pdf],
        children: F1()
      }
    ),
    /* @__PURE__ */ i.jsx(
      qr,
      {
        openRef: a,
        onDrop: (N) => {
          m([...f, N[0]]);
        },
        classNames: { root: mt.root },
        name: n,
        useFsAccessApi: !1,
        accept: [it.png, it.jpeg, it.svg, it.gif, it.pdf],
        children: A1()
      }
    ),
    /* @__PURE__ */ i.jsx(Hs, { px: 0, pb: 15, children: /* @__PURE__ */ i.jsxs(cn, { className: mt.infoCard, shadow: "sm", p: "lg", radius: "sm", children: [
      /* @__PURE__ */ i.jsxs(T, { children: [
        /* @__PURE__ */ i.jsxs(T.Col, { span: { md: 6 }, children: [
          (h == null ? void 0 : h.length) > 0 ? h.map((N, C) => {
            const S = URL.createObjectURL(N);
            return /* @__PURE__ */ i.jsxs(
              T.Col,
              {
                span: { xs: 12, md: 12 },
                className: mt.imageContainer,
                children: [
                  /* @__PURE__ */ i.jsx("p", { className: mt.crossIcon, onClick: () => y(), children: "X" }),
                  N.type === "application/pdf" ? /* @__PURE__ */ i.jsx("iframe", { src: S, className: mt.previewImage }) : /* @__PURE__ */ i.jsx(
                    yi,
                    {
                      src: S,
                      classNames: { root: mt.previewImage },
                      style: { float: "left", image: mt.previewImage }
                    },
                    C
                  )
                ]
              },
              N.name
            );
          }) : null,
          /* @__PURE__ */ i.jsx(on, { className: mt.editName, children: /* @__PURE__ */ i.jsx("span", { onClick: j, children: l }) })
        ] }),
        r && /* @__PURE__ */ i.jsxs(T.Col, { span: { md: 6 }, children: [
          (f == null ? void 0 : f.length) > 0 ? f.map((N, C) => {
            const S = URL.createObjectURL(N);
            return /* @__PURE__ */ i.jsxs(
              T.Col,
              {
                span: { xs: 12, md: 12 },
                className: mt.imageContainer,
                children: [
                  /* @__PURE__ */ i.jsx("p", { className: mt.crossIcon, onClick: () => P(), children: "X" }),
                  N.type === "application/pdf" ? /* @__PURE__ */ i.jsx("iframe", { src: S, className: mt.previewImage }) : /* @__PURE__ */ i.jsx(
                    yi,
                    {
                      src: S,
                      style: { float: "left", image: mt.previewImage }
                    },
                    C
                  )
                ]
              },
              N.name
            );
          }) : null,
          /* @__PURE__ */ i.jsx(on, { className: mt.editName, children: /* @__PURE__ */ i.jsx("span", { onClick: b, children: c }) })
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: mt.error, children: s == null ? void 0 : s.fieldErrors[t] }),
      /* @__PURE__ */ i.jsx("div", { className: mt.error, style: { paddingTop: "8px" }, children: s == null ? void 0 : s.fieldErrors[n] })
    ] }) })
  ] });
}, M1 = "_root_1rg1f_1", D1 = "_label_1rg1f_42", B1 = "_loader_1rg1f_47", W1 = "_text_1rg1f_55", U1 = "_inner_1rg1f_59", hl = {
  root: M1,
  label: D1,
  loader: B1,
  text: W1,
  inner: U1
}, z1 = ({ children: e }) => /* @__PURE__ */ i.jsxs("div", { className: hl.loader, children: [
  /* @__PURE__ */ i.jsx(ts, { color: "white", size: "xs" }),
  /* @__PURE__ */ i.jsx("span", { className: hl.text, children: e })
] }), qe = ({
  children: e,
  onClick: t,
  variant: n,
  type: s = "button",
  id: r = "default",
  leftIcon: o,
  size: a,
  uppercase: l,
  fullWidth: d,
  className: c,
  disabled: u,
  style: h,
  value: p,
  loading: f,
  pageData: m,
  oppId: g,
  component: v,
  href: _,
  classNames: $,
  ...y
}) => /* @__PURE__ */ i.jsx(
  Jt,
  {
    classNames: $ || hl,
    className: c,
    onClick: t,
    type: s,
    id: r,
    "data-testid": r,
    name: r,
    leftSection: o,
    size: a,
    tt: l ? "uppercase" : "none",
    variant: n,
    "data-variant": n,
    fullWidth: d,
    styles: {
      label: {
        fontFamily: "Montserrat"
      }
    },
    disabled: u,
    style: h,
    value: p,
    loading: f,
    loaderProps: { children: /* @__PURE__ */ i.jsx(z1, { children: e }) },
    ...y,
    children: e
  }
);
function oh(e) {
  var t, n, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = oh(e[t])) && (s && (s += " "), s += n);
  else for (t in e) e[t] && (s && (s += " "), s += t);
  return s;
}
function R() {
  for (var e, t, n = 0, s = ""; n < arguments.length; ) (e = arguments[n++]) && (t = oh(e)) && (s && (s += " "), s += t);
  return s;
}
const H1 = "_root_1uaxm_1", q1 = "_rootRB_1uaxm_16", G1 = "_rootRB_1uaxm_16", V1 = "_title_1uaxm_32", Y1 = "_description_1uaxm_39", K1 = "_horizontalAlign_1uaxm_47", J1 = "_control_1uaxm_52", eo = {
  root: H1,
  rootRB: q1,
  rootRb: G1,
  title: V1,
  description: Y1,
  horizontalAlign: K1,
  control: J1
}, HT = ({ id: e, children: t, className: n, RB: s, headerText: r = "Tip" }) => /* @__PURE__ */ i.jsxs(
  Jo,
  {
    px: "md",
    py: "md",
    shadow: "xs",
    radius: "md",
    className: R(s ? eo.rootRB : eo.root, n),
    id: e,
    children: [
      /* @__PURE__ */ i.jsxs(ss, { children: [
        /* @__PURE__ */ i.jsx(U, { name: "tip" }),
        /* @__PURE__ */ i.jsx(Ce, { fw: "700", color: "dimmed", className: eo.title, children: r })
      ] }),
      /* @__PURE__ */ i.jsx(Ce, { size: "sm", color: "dimmed", className: eo.description, children: t })
    ]
  }
), Z1 = "_icon_x87pw_1", X1 = "_root_x87pw_6", Q1 = "_input_x87pw_24", eg = "_error_x87pw_49", tg = "_label_x87pw_54", ng = "_edit_x87pw_62", sg = "_cross_x87pw_84", rg = "_incase_x87pw_104", ig = "_dollar_x87pw_121", og = "_secondaryRoot_x87pw_136", ag = "_secondaryInput_x87pw_154", lg = "_secondaryLabel_x87pw_179", dg = "_secondaryWrapper_x87pw_187", cg = "_secondaryDollar_x87pw_191", ug = "_secondaryError_x87pw_196", hg = "_tertiaryInput_x87pw_201", fg = "_tertiaryLabelBold_x87pw_224", pg = "_outlineRoot_x87pw_238", _g = "_outlineLabel_x87pw_258", mg = "_outlineInput_x87pw_266", gg = "_top10_x87pw_283", vg = "_combinedOfferRoot_x87pw_288", $g = "_combinedOfferLabel_x87pw_304", bg = "_combinedOfferInput_x87pw_311", xg = "_combinedOfferError_x87pw_346", yg = "_toggleSecret_x87pw_351", Ae = {
  icon: Z1,
  root: X1,
  input: Q1,
  error: eg,
  label: tg,
  edit: ng,
  cross: sg,
  incase: rg,
  dollar: ig,
  secondaryRoot: og,
  secondaryInput: ag,
  secondaryLabel: lg,
  secondaryWrapper: dg,
  secondaryDollar: cg,
  secondaryError: ug,
  tertiaryInput: hg,
  delete: "_delete_x87pw_219",
  tertiaryLabelBold: fg,
  outlineRoot: pg,
  outlineLabel: _g,
  outlineInput: mg,
  top10: gg,
  combinedOfferRoot: vg,
  combinedOfferLabel: $g,
  combinedOfferInput: bg,
  combinedOfferError: xg,
  toggleSecret: yg
}, wg = {
  combinedOffer: {
    root: Ae.combinedOfferRoot,
    label: Ae.combinedOfferLabel,
    input: Ae.combinedOfferInput,
    error: Ae.combinedOfferError,
    section: Ae.combinedOfferSection,
    wrapper: Ae.combinedOfferWrapper
  },
  primary: {
    root: Ae.root,
    input: Ae.input,
    label: Ae.label,
    wrapper: Ae.wrapper,
    dollar: Ae.dollar,
    error: Ae.error
  },
  secondary: {
    root: Ae.secondaryRoot,
    input: Ae.secondaryInput,
    label: Ae.secondaryLabel,
    wrapper: Ae.secondaryWrapper,
    error: Ae.secondaryError
  },
  tertiary: {
    input: Ae.tertiaryInput,
    label: Ae.tertiaryLabel,
    error: Ae.secondaryError
  },
  tertiaryBold: {
    input: Ae.tertiaryInput,
    label: Ae.tertiaryLabelBold,
    error: Ae.secondaryError
  },
  outline: {
    root: Ae.outlineRoot,
    label: Ae.outlineLabel,
    input: Ae.outlineInput,
    error: Ae.secondaryError
  }
}, Cg = ({ label: e, optional: t }) => /* @__PURE__ */ i.jsxs("label", { children: [
  e,
  " ",
  t && /* @__PURE__ */ i.jsx("span", { children: "(Optional)" })
] }), Di = ({
  showDollar: e,
  id: t,
  defaultValue: n,
  placeholder: s,
  label: r,
  className: o,
  error: a,
  type: l,
  maxLength: d = 200,
  // value,
  keyPress: c,
  keyUp: u,
  showEdit: h,
  redirectOnEdit: p,
  readOnly: f,
  sideButtonName: m = "Edit",
  updatedValue: g = (re) => {
  },
  ssn: v = !1,
  maskValue: _,
  style: $,
  step: y = "any",
  onPaste: P,
  hidden: j,
  rightSection: b,
  round: N = !1,
  ref: C,
  autoComplete: S,
  withAsterisk: F = !1,
  variant: W = "primary",
  optional: D = !1,
  noRound: B = !1,
  deleteable: q = !1,
  secureToggle: G = !1,
  ...z
}) => {
  var fe, tt, pt;
  const re = dn(null), [X, Q] = oe.useState(n), [M, he] = oe.useState(h), [le, ce] = oe.useState(p), [we, ue] = oe.useState(!1), [pe, Pe] = oe.useState(f), [Y, ie] = oe.useState(!1), [ve] = oe.useState(S || "off"), [Ue, ze] = oe.useState(!0);
  ne(() => {
    Q(n), Y || Pe(f);
  }, [n, f]);
  const He = (nt) => {
    let yt = nt.currentTarget.value;
    l !== "number" && l !== "tel" && (yt = yt.replace(/<[^>]*>/g, "")), v && (yt = yt.replace(/\D/g, ""));
    const Z = z != null && z.onlyTextAllowed ? /\d/.test(yt) : !1;
    yt.length <= d && !Z && (Q(yt), g(yt));
  }, ft = () => {
    ie(!0), Pe(!1), he(!1), ue(!0), setTimeout(() => {
      var nt;
      (nt = re == null ? void 0 : re.current) == null || nt.focus();
    }, 20);
  }, et = () => {
    l === "number" ? Q(0) : (Q(""), g("")), he(!0), ue(!1);
  }, Ye = () => {
    B || l === "number" && Q(N ? Math.round(Number(X)) : X ? Math.ceil(Number(X) * 100) / 100 : "");
  }, Mt = Fi(() => {
    var nt, yt, Z;
    if (b) return b;
    if (G)
      return /* @__PURE__ */ i.jsx(
        "span",
        {
          onClick: () => ze((Le) => !Le),
          className: R(Ae.toggleSecret, (nt = z == null ? void 0 : z.customClass) == null ? void 0 : nt.rightIconClass),
          role: "button",
          "aria-label": Ue ? "Show value" : "Hide value",
          children: Ue ? /* @__PURE__ */ i.jsx("img", { src: "/images/eye-closed.png", alt: "eye-closed" }) : /* @__PURE__ */ i.jsx("img", { src: "/images/eye-open.png", alt: "eye-open" })
        }
      );
    if (q && !pe && X)
      return /* @__PURE__ */ i.jsx("span", { onClick: et, className: Ae.delete, children: /* @__PURE__ */ i.jsx(U, { name: "xBox" }) });
    if (M && pe)
      return /* @__PURE__ */ i.jsx(
        "span",
        {
          id: t + "edit",
          onClick: ft,
          className: R(Ae.top10, (yt = z == null ? void 0 : z.customClass) == null ? void 0 : yt.rightIconClass),
          children: m
        }
      );
    if (we)
      return /* @__PURE__ */ i.jsx(
        "span",
        {
          className: R(Ae.top10, (Z = z == null ? void 0 : z.customClass) == null ? void 0 : Z.rightCrossIconClass),
          id: t + "cross",
          onClick: et,
          children: "X"
        }
      );
  }, [b, q, pe, X, M, Ue]), Zt = G ? Ue ? "password" : "text" : l, kt = (nt, yt = {}) => ["root", "label", "input", "error", "section", "wrapper", "dollar"].reduce((Le, _t) => {
    var Dt;
    return Le[_t] = R((Dt = wg[nt]) == null ? void 0 : Dt[_t], yt == null ? void 0 : yt[_t]), Le;
  }, {});
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(
      Ko,
      {
        classNames: kt(W, z == null ? void 0 : z.customClass),
        className: o,
        id: t,
        "data-testid": t,
        name: t,
        value: _ || X,
        onChange: He,
        label: /* @__PURE__ */ i.jsx(Cg, { label: r, optional: D }),
        placeholder: s,
        error: (fe = z == null ? void 0 : z.customError) != null && fe.length ? z == null ? void 0 : z.customError : (pt = ((tt = a == null ? void 0 : a.fieldErrors) == null ? void 0 : tt[t]) || []) == null ? void 0 : pt.join(", "),
        ref: C || re,
        onKeyPress: c,
        onKeyUp: u,
        readOnly: pe && f,
        type: Zt,
        autoComplete: ve,
        style: $,
        onPaste: P,
        step: y,
        hidden: j,
        rightSection: Mt,
        onWheel: (nt) => {
          re && re.current && re.current.blur && re.current.blur(), nt.preventDefault();
        },
        onBlur: Ye,
        leftSection: e && /* @__PURE__ */ i.jsx(
          "span",
          {
            className: W === "primary" ? Ae.dollar : R(Ae.secondaryDollar, z == null ? void 0 : z.leftIconClass),
            children: "US$"
          }
        ),
        role: "presentation",
        withAsterisk: F,
        ...z
      }
    ),
    (le == null ? void 0 : le.active) && /* @__PURE__ */ i.jsx("span", { className: Ae.edit, id: t + "redirection", onClick: le.click, children: le.label })
  ] });
}, jg = "_icon_abzj6_1", Ng = "_root_abzj6_6", Sg = "_input_abzj6_17", kg = "_innerInput_abzj6_33", Eg = "_rightSection_abzj6_42", Ig = "_label_abzj6_46", Pg = "_error_abzj6_53", Tg = {
  icon: jg,
  root: Ng,
  input: Sg,
  innerInput: kg,
  rightSection: Eg,
  label: Ig,
  error: Pg
}, ca = ({
  id: e,
  defaultValue: t,
  placeholder: n,
  label: s,
  className: r,
  error: o,
  type: a,
  maxLength: l = 200,
  keyPress: d,
  keyUp: c,
  readOnly: u,
  updatedValue: h = (g) => {
  },
  onPaste: p,
  hidden: f,
  autoComplete: m
}) => {
  const g = dn(null), [v, _] = oe.useState(t), [$, y] = oe.useState(u), [P] = oe.useState(m || "off");
  ne(() => {
    _(t), y(u);
  }, [t, u]);
  const j = (b) => {
    try {
      b.currentTarget.value.length <= l && (_(b.currentTarget.value), h(b.currentTarget.value));
    } catch {
    }
  };
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(
    Dp,
    {
      classNames: Tg,
      className: r,
      id: e,
      "data-testid": e,
      name: e,
      value: v,
      onChange: j,
      label: s,
      placeholder: n,
      error: ((o == null ? void 0 : o.fieldErrors[e]) || []).join(", "),
      ref: g,
      onKeyPress: d,
      onKeyUp: c,
      readOnly: $ && u,
      type: a,
      autoComplete: P,
      onPaste: p,
      hidden: f
    }
  ) });
}, Rg = "_root_apisn_1", Lg = "_icon_apisn_11", Og = "_label_apisn_15", Fg = "_secondaryInput_apisn_26", jr = {
  root: Rg,
  icon: Lg,
  label: Og,
  secondaryInput: Fg
}, qT = ({
  label: e,
  id: t,
  size: n,
  onChange: s,
  className: r,
  updatedValue: o,
  error: a,
  check: l = !1,
  disable: d = !1,
  labelClassName: c,
  bodyClassName: u,
  variant: h = "primary"
}) => {
  const [p, f] = O(l), [m, g] = O(d);
  ne(() => {
    f(l);
  }, [l]), ne(() => {
    g(d);
  }, [d]);
  const v = (_) => {
    var y;
    const $ = (y = _ == null ? void 0 : _.currentTarget) == null ? void 0 : y.checked;
    f($), o == null || o($);
  };
  return /* @__PURE__ */ i.jsx(
    $r,
    {
      checked: p,
      "data-testid": t,
      id: t,
      name: t,
      onChange: v,
      size: n,
      label: e,
      className: r,
      classNames: {
        root: jr.root,
        input: h === "secondary" ? jr.secondaryInput : jr.input,
        icon: jr.icon,
        label: R(jr.label, c),
        body: R(jr.body, u)
      },
      disabled: m,
      error: (a == null ? void 0 : a.fieldErrors[t]) || ""
    }
  );
}, Ag = "_header_1tp1d_1", Mg = "_logo_1tp1d_11", hc = {
  header: Ag,
  logo: Mg
}, GT = () => /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsx(mr, { header: { height: 70 }, children: /* @__PURE__ */ i.jsx(mr.Header, { className: hc.header, children: /* @__PURE__ */ i.jsx("div", { className: hc.logo, children: /* @__PURE__ */ i.jsx(U, { name: "logo" }) }) }) }) }), ts = ({
  size: e,
  id: t,
  color: n = "yellow",
  className: s,
  type: r = "oval",
  customLoaderRootStyle: o
}) => /* @__PURE__ */ i.jsx("div", { "data-testid": t, children: /* @__PURE__ */ i.jsx(
  Bp,
  {
    size: e,
    color: n,
    className: s,
    type: r,
    classNames: { root: o }
  }
) }), Dg = "_root_1r7lf_1", Bg = "_text_1r7lf_11", Wg = "_icon_1r7lf_17", Ug = "_leftIcon_1r7lf_18", zg = "_input_1r7lf_24", Hg = "_optionButton_1r7lf_42", qg = "_mantine-Button-inner_1r7lf_69", Gg = "_mantine-Button-label_1r7lf_74", Vg = "_error_1r7lf_84", Yg = "_label_1r7lf_89", Kg = "_optionContainer_1r7lf_103", Jg = "_sticky_1r7lf_109", Zg = "_edit_1r7lf_116", Xg = "_cross_1r7lf_117", Qg = "_showTick_1r7lf_155", e0 = "_outerWrap_1r7lf_161", t0 = "_inner_1r7lf_165", n0 = "_errorMessage_1r7lf_169", s0 = "_optionWrapper_1r7lf_176", r0 = "_addonLink_1r7lf_188", bn = {
  root: Dg,
  text: Bg,
  icon: Wg,
  leftIcon: Ug,
  input: zg,
  optionButton: Hg,
  "mantine-Button-inner": "_mantine-Button-inner_1r7lf_69",
  mantineButtonInner: qg,
  "mantine-Button-label": "_mantine-Button-label_1r7lf_74",
  mantineButtonLabel: Gg,
  error: Vg,
  label: Yg,
  optionContainer: Kg,
  sticky: Jg,
  edit: Zg,
  cross: Xg,
  showTick: Qg,
  outerWrap: e0,
  inner: t0,
  errorMessage: n0,
  optionWrapper: s0,
  addonLink: r0
}, i0 = ({
  id: e,
  defaultValue: t,
  getOptions: n,
  suggestedDropDownList: s = [],
  placeholder: r,
  label: o,
  textValue: a,
  selectedValue: l,
  error: d,
  loader: c,
  moreOption: u,
  className: h,
  keyPress: p,
  readOnly: f,
  showEdit: m,
  sideButtonName: g = "Edit",
  alternateValue: v,
  tickMarkAlignTopValue: _,
  tickMarkAlignRightValue: $,
  addonOption: y,
  isDefaultOpen: P = !1,
  isNumberAllowed: j = !1
}) => {
  const [b, N] = oe.useState(""), [C, S] = oe.useState("contents"), [F, W] = oe.useState([]), [D, B] = oe.useState(m || !1), [q, G] = oe.useState(!1), [z, re] = oe.useState(f || !1), X = dn(null), [Q, M] = oe.useState(""), [he, le] = oe.useState(!1), ce = (Y) => {
    var ve, Ue, ze, He;
    const ie = j ? (Ue = (ve = Y == null ? void 0 : Y.currentTarget) == null ? void 0 : ve.value) == null ? void 0 : Ue.replace(/[^a-zA-Z0-9\s]/g, "") : (He = (ze = Y == null ? void 0 : Y.currentTarget) == null ? void 0 : ze.value) == null ? void 0 : He.replace(/[^a-zA-Z\s]/g, "");
    if (ie.length <= 255) {
      N(ie), a && a(ie), S("contents"), M(""), le(!1);
      let ft = F.filter(
        (et) => et.name.toLowerCase() === ie.toLowerCase()
      );
      ft.length > 0 && (l && l(ft[0]), S("none"), N(ft[0].name), le(!0));
    }
  };
  oe.useEffect(() => {
    typeof t == "object" ? (N(t.name), ue(t)) : (t === void 0 && (t = ""), N(t), M(t)), n(b).then((Y) => W(Y));
  }, [t]);
  const we = (Y) => {
    n(Y).then((ie) => W(ie));
  };
  oe.useEffect(() => {
    b === "" && (le(!1), W([]), we(b)), (b || P) && n(b).then((Y) => {
      W(Y);
    });
  }, [b]), oe.useEffect(() => {
    ((o == null ? void 0 : o.toLowerCase()) === "state" || (o == null ? void 0 : o.toLowerCase()) === "province") && N(t);
  }, [c]);
  const ue = (Y) => {
    N(Y.name), S("none"), a && a(Y.name), l && l(Y), M(Y.name), le(!0);
  }, pe = () => {
    re(!1), B(!1), G(!0), setTimeout(() => {
      var Y;
      (Y = X == null ? void 0 : X.current) == null || Y.focus();
    }, 20);
  }, Pe = () => {
    N(""), G(!1);
  };
  return oe.useEffect(() => {
    var ie, ve;
    M("");
    let Y = F.filter(
      (Ue) => Ue.name.toLowerCase() === b.toLowerCase()
    );
    M((ie = Y[0]) != null && ie.name ? (ve = Y[0]) == null ? void 0 : ve.name : ""), Y.length === 1 && (le(!0), S("none"));
  }, [F]), ne(() => {
    s != null && s.length && W(s || []);
  }, [s]), /* @__PURE__ */ i.jsxs("div", { children: [
    /* @__PURE__ */ i.jsxs("div", { className: bn.outerWrap, children: [
      /* @__PURE__ */ i.jsx(
        Gl,
        {
          autosize: !0,
          classNames: bn,
          className: h,
          id: e,
          "data-testid": e,
          name: e,
          value: b,
          onChange: ce,
          label: o,
          placeholder: r,
          error: he ? "" : ((d == null ? void 0 : d.fieldErrors[e]) || []).join(", "),
          rightSection: !he && c && /* @__PURE__ */ i.jsx(ts, { size: "sm" }),
          onKeyDown: p,
          autoComplete: "new-password",
          readOnly: f && z,
          ref: X,
          onPaste: (Y) => Y.preventDefault(),
          role: "presentation"
        }
      ),
      he && /* @__PURE__ */ i.jsx(
        "div",
        {
          className: bn.showTick,
          style: { top: _, right: $ },
          children: /* @__PURE__ */ i.jsx(U, { name: "greenTick", size: "20" })
        }
      )
    ] }),
    D && f && /* @__PURE__ */ i.jsx("span", { className: bn.edit, id: e, "data-testid": e, onClick: pe, children: g }),
    q && /* @__PURE__ */ i.jsx("span", { className: bn.cross, id: e, "data-testid": e, onClick: Pe, children: "X" }),
    !he && Object.keys(F).length > 0 ? /* @__PURE__ */ i.jsx(
      "div",
      {
        style: {
          maxHeight: "355px",
          overflowY: Object.keys(F).length > 2 ? "scroll" : "hidden",
          overflowX: "hidden",
          marginTop: d ? "25px" : "10px"
        },
        className: "optionGrid",
        children: /* @__PURE__ */ i.jsxs(
          T,
          {
            py: 0,
            grow: !0,
            classNames: { inner: bn.inner },
            style: { display: C, height: (F == null ? void 0 : F.length) > 2 ? "350px" : "175px" },
            children: [
              F.map((Y, ie) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx(T.Col, { px: 0, span: 12, className: bn.optionWrapper, children: /* @__PURE__ */ i.jsx(
                  qe,
                  {
                    component: "a",
                    href: "#",
                    variant: "outline",
                    leftIcon: Y.icon,
                    className: bn.optionButton,
                    onClick: () => ue(Y),
                    classNames: { label: bn.label },
                    children: Y.name
                  }
                ) }, ie),
                y && ie === (F == null ? void 0 : F.length) - 1 && /* @__PURE__ */ i.jsx(T.Col, { px: 0, py: 0, span: 12, className: bn.sticky, children: /* @__PURE__ */ i.jsx("a", { className: bn.addonLink, onClick: y.click, children: y == null ? void 0 : y.label }) })
              ] })),
              F.length > 0 && !y && (u == null ? void 0 : u.active) && /* @__PURE__ */ i.jsx(T.Col, { px: 0, span: 12, className: bn.sticky, children: /* @__PURE__ */ i.jsx(
                qe,
                {
                  variant: "outline",
                  className: bn.optionButton,
                  onClick: u.click,
                  children: u == null ? void 0 : u.label
                }
              ) })
            ]
          }
        )
      }
    ) : null,
    /* @__PURE__ */ i.jsx("input", { type: "hidden", name: v, value: Q })
  ] });
}, I = ({ children: e, ...t }) => /* @__PURE__ */ i.jsx(Ce, { ...t, children: e }), o0 = "_infoCard_10sxe_1", a0 = "_editName_10sxe_8", l0 = "_text_10sxe_36", d0 = "_debtType_10sxe_40", oi = {
  infoCard: o0,
  editName: a0,
  delete: "_delete_10sxe_22",
  text: l0,
  debtType: d0
}, VT = ({
  link: e,
  amount: t,
  debtType: n,
  remove: s,
  redirectOnEdit: r
}) => {
  const [o, a] = oe.useState(r), l = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(Hs, { px: 0, pb: 15, children: /* @__PURE__ */ i.jsx(cn, { className: oi.infoCard, shadow: "sm", p: "lg", radius: "sm", children: /* @__PURE__ */ i.jsxs(T, { justify: "space-around", align: "center", children: [
    /* @__PURE__ */ i.jsxs(T.Col, { span: 8, children: [
      /* @__PURE__ */ i.jsx(
        ee,
        {
          fontWeight: "400",
          variant: "blue",
          order: l ? 4 : 3,
          className: oi.debtType,
          children: n
        }
      ),
      /* @__PURE__ */ i.jsxs(I, { children: [
        "$ ",
        t,
        " ",
        o != null && o.active ? o.text : "annual income"
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs(T.Col, { className: "alignRight", span: 4, children: [
      o != null && o.active ? /* @__PURE__ */ i.jsx("span", { className: oi.editName, onClick: o.click, children: o.label }) : /* @__PURE__ */ i.jsx(on, { className: oi.editName, href: e, children: "Edit" }),
      s && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("span", { className: oi.delete, onClick: s, children: "Delete" })
      ] })
    ] })
  ] }) }) }) });
}, c0 = "_root_l4rmr_1", u0 = "_input_l4rmr_10", h0 = "_error_l4rmr_26", f0 = {
  root: c0,
  input: u0,
  error: h0
}, YT = ({
  data: e,
  placeholder: t,
  label: n,
  id: s,
  defaultValue: r,
  error: o
}) => {
  const [a, l] = O(r), d = (c) => {
    l(c);
  };
  return /* @__PURE__ */ i.jsx(
    Vl,
    {
      classNames: f0,
      "data-testid": s,
      id: s,
      name: s,
      value: a,
      onChange: d,
      error: ((o == null ? void 0 : o.fieldErrors[s]) || []).join(", "),
      data: e,
      placeholder: t,
      label: n
    }
  );
}, p0 = "_radioGroup_199ug_1", _0 = "_radio_199ug_1", m0 = "_radioSelected_199ug_71", g0 = "_body_199ug_118", v0 = "_labelWrapper_199ug_123", $0 = "_inner_199ug_128", b0 = "_errorMessage_199ug_132", ot = {
  radioGroup: p0,
  radio: _0,
  radioSelected: m0,
  body: g0,
  labelWrapper: v0,
  inner: $0,
  errorMessage: b0
}, x0 = oe.forwardRef(
  ({
    description: e,
    id: t = "default",
    label: n,
    defaultValue: s,
    getOptions: r = () => [],
    error: o,
    items: a,
    showMore: l = !1,
    buttonName: d = "Show more",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updatedValue: c = () => {
    },
    mouseClick: u,
    className: h,
    actAsCheckbox: p = !1,
    radioCustomClass: f = {}
  }, m) => {
    const [g, v] = O([]), [_, $] = O(s), [y, P] = O(!1), j = Ve("(max-width: 767px)"), b = (C) => {
      $(C), c(C), C === "Show more" && P(!0), C === "Show less" && P(!1);
    };
    ne(() => {
      v(r());
    }, []), ne(() => {
      $(s);
    }, [s]);
    const N = p ? b : () => !1;
    return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(
      vt.Group,
      {
        className: R(ot.radioGroup, h),
        classNames: { error: ot.errorMessage },
        value: _,
        label: n,
        description: e,
        id: t,
        name: t,
        "data-testid": t,
        onChange: b,
        onMouseDown: u,
        error: ((o == null ? void 0 : o.fieldErrors[t]) || []).join(", "),
        mb: j ? 15 : 30,
        ref: m,
        children: [
          l ? g == null ? void 0 : g.slice(0, a).map((C) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: ot.labelWrapper,
                body: ot.body,
                root: _ === C.id ? ot.radioSelected : ot.radio,
                inner: ot.inner
              },
              value: C.id,
              label: C.name,
              onClick: N
            },
            C.id
          )) : g.map((C) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: ot.labelWrapper,
                body: ot.body,
                root: _ === C.id ? R(ot.radioSelected, f) : R(ot.radio, f),
                inner: ot.inner
              },
              value: C.id,
              label: C.name,
              onClick: N
            },
            C.id
          )),
          !y && l && g.length > 4 ? /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: ot.labelWrapper,
                body: ot.body,
                root: ot.radio,
                inner: ot.inner
              },
              value: d,
              label: d,
              onClick: N
            },
            ""
          ) : null,
          y && (g == null ? void 0 : g.slice(a).map((C) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: ot.labelWrapper,
                body: ot.body,
                root: _ === C.id ? ot.radioSelected : ot.radio,
                inner: ot.inner
              },
              value: C.id,
              label: C.name,
              onClick: N
            },
            C.id
          ))),
          y && l && g.length > 4 ? /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: ot.labelWrapper,
                body: ot.body,
                inner: ot.inner
              },
              className: ot.radio,
              value: "Show less",
              label: "Show less",
              onClick: N
            },
            ""
          ) : null
        ]
      }
    ) });
  }
);
x0.displayName = "SingleSelect";
const y0 = "_radioGroup_1nlnz_1", w0 = "_radio_1nlnz_1", C0 = "_radioSelected_1nlnz_63", j0 = "_body_1nlnz_108", N0 = "_labelWrapper_1nlnz_113", S0 = "_inner_1nlnz_118", k0 = "_errorMessage_1nlnz_122", at = {
  radioGroup: y0,
  radio: w0,
  radioSelected: C0,
  body: j0,
  labelWrapper: N0,
  inner: S0,
  errorMessage: k0
}, E0 = oe.forwardRef(
  ({
    description: e,
    id: t = "default",
    label: n,
    defaultValue: s,
    getOptions: r = () => [],
    error: o,
    items: a,
    showMore: l = !1,
    buttonName: d = "Show more",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updatedValue: c = () => {
    },
    mouseClick: u,
    className: h,
    actAsCheckbox: p = !1
  }, f) => {
    const [m, g] = O([]), [v, _] = O(s), [$, y] = O(!1), P = (b) => {
      _(b), c(b), b === "Show more" && y(!0), b === "Show less" && y(!1);
    };
    ne(() => {
      g(r());
    }, []), ne(() => {
      _(s);
    }, [s]);
    const j = p ? P : () => !1;
    return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(
      vt.Group,
      {
        className: R(at.radioGroup, h),
        classNames: { error: at.errorMessage },
        value: v,
        label: n,
        description: e,
        id: t,
        name: t,
        "data-testid": t,
        onChange: P,
        onMouseDown: u,
        error: ((o == null ? void 0 : o.fieldErrors[t]) || []).join(", "),
        mb: 30,
        ref: f,
        children: [
          l ? m == null ? void 0 : m.slice(0, a).map((b) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: at.labelWrapper,
                body: at.body,
                root: v === b.id ? at.radioSelected : at.radio,
                inner: at.inner
              },
              value: b.id,
              label: b.name,
              onClick: j
            },
            b.id
          )) : m.map((b) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: at.labelWrapper,
                body: at.body,
                root: v === b.id ? at.radioSelected : at.radio,
                inner: at.inner
              },
              value: b.id,
              label: b.name,
              onClick: j
            },
            b.id
          )),
          !$ && l && m.length > 4 ? /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: at.labelWrapper,
                body: at.body,
                root: at.radio,
                inner: at.inner
              },
              value: d,
              label: d,
              onClick: j
            },
            ""
          ) : null,
          $ && (m == null ? void 0 : m.slice(a).map((b) => /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: at.labelWrapper,
                body: at.body,
                root: v === b.id ? at.radioSelected : at.radio,
                inner: at.inner
              },
              value: b.id,
              label: b.name,
              onClick: j
            },
            b.id
          ))),
          $ && l && m.length > 4 ? /* @__PURE__ */ i.jsx(
            vt,
            {
              style: () => ({
                svg: {
                  opacity: "0!important",
                  position: "fixed",
                  width: "0"
                }
              }),
              classNames: {
                labelWrapper: at.labelWrapper,
                body: at.body,
                inner: at.inner
              },
              className: at.radio,
              value: "Show less",
              label: "Show less",
              onClick: j
            },
            ""
          ) : null
        ]
      }
    ) });
  }
);
E0.displayName = "SingleSelect";
const I0 = "_wrapper_1v6as_2", P0 = {
  wrapper: I0
}, KT = ({ children: e }) => {
  const [t, n] = O(!1), s = Wp();
  return /* @__PURE__ */ i.jsxs(
    mr,
    {
      navbar: { breakpoint: "sm", width: { sm: 300, lg: 400 } },
      header: { height: 70 },
      children: [
        /* @__PURE__ */ i.jsx(mr.Navbar, { px: "md", py: "md", hidden: !t, children: /* @__PURE__ */ i.jsx(Ce, { children: "Application navbar" }) }),
        /* @__PURE__ */ i.jsx(mr.Header, { px: "md", py: "md", children: /* @__PURE__ */ i.jsxs("div", { style: { display: "flex", alignItems: "center", height: "100%" }, children: [
          /* @__PURE__ */ i.jsx("div", { className: P0.wrapper, children: /* @__PURE__ */ i.jsx(
            Up,
            {
              opened: t,
              onClick: () => n((r) => !r),
              size: "sm",
              color: s.colors.gray[6],
              mr: "xl"
            }
          ) }),
          /* @__PURE__ */ i.jsx(Ce, { children: "MPOWERFinancing" })
        ] }) }),
        /* @__PURE__ */ i.jsx(Ce, { children: e })
      ]
    }
  );
}, T0 = "_outerContainer_lbudm_1", R0 = "_container_lbudm_10", L0 = "_joinCommunity_lbudm_22", O0 = "_underline_lbudm_32", F0 = "_iconsCounnity_lbudm_50", A0 = "_list_lbudm_57", M0 = "_listitem_lbudm_73", D0 = "_text_lbudm_78", B0 = "_discordIcon_lbudm_88", xn = {
  outerContainer: T0,
  container: R0,
  joinCommunity: L0,
  underline: O0,
  iconsCounnity: F0,
  list: A0,
  listitem: M0,
  text: D0,
  discordIcon: B0
}, ah = "footer", W0 = () => /* @__PURE__ */ i.jsx("div", { className: xn.outerContainer, children: /* @__PURE__ */ i.jsx(Hs, { fluid: !0, p: 10, className: xn.container, id: ah, children: /* @__PURE__ */ i.jsxs(T, { align: "center", justify: "center", children: [
  /* @__PURE__ */ i.jsx(T.Col, { span: { xl: 6, lg: 6, md: 6, sm: 12, xs: 12, base: 12 }, children: /* @__PURE__ */ i.jsxs(T, { m: 0, p: 8, className: xn.joinCommunity, align: "center", justify: "flex-end", children: [
    /* @__PURE__ */ i.jsx(ys, { className: xn.text, order: 6, children: "Join our community" }),
    /* @__PURE__ */ i.jsx("div", { className: xn.underline })
  ] }) }),
  /* @__PURE__ */ i.jsx(T.Col, { span: { xl: 6, lg: 6, md: 6, sm: 12, xs: 12, base: 12 }, children: /* @__PURE__ */ i.jsx(
    T,
    {
      className: xn.iconsCounnity,
      m: 0,
      pt: 18,
      p: 8,
      align: "center",
      justify: "flex-start",
      children: /* @__PURE__ */ i.jsxs(Be, { className: xn.list, children: [
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.listitem, children: /* @__PURE__ */ i.jsx(on, { href: "https://www.facebook.com/MPOWERFinancing/", target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "facebook" }) }) }),
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.listitem, children: /* @__PURE__ */ i.jsx(on, { href: "https://www.linkedin.com/company/mpower-financing", target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "linkedin" }) }) }),
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.listitem, children: /* @__PURE__ */ i.jsx(on, { href: "https://twitter.com/MPOWERfinancing", target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "twitter" }) }) }),
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.listitem, children: /* @__PURE__ */ i.jsx(on, { href: "https://www.instagram.com/mpowerfinancing/", target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "instagram" }) }) }),
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.listitem, children: /* @__PURE__ */ i.jsx(
          on,
          {
            href: "https://www.youtube.com/channel/UCOb54nB9C8Ro8_ZbmyPJlng",
            target: "_blank",
            children: /* @__PURE__ */ i.jsx(U, { name: "youtube" })
          }
        ) }),
        /* @__PURE__ */ i.jsx(Be.Item, { className: xn.discordIcon, children: /* @__PURE__ */ i.jsx(on, { href: "https://discord.com/invite/mYQQttqSYK", target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "discord" }) }) })
      ] })
    }
  ) })
] }) }) }), ua = {
  REDIRECT_URL: "https://www.mpowerfinancing.com/"
}, fc = {
  canada: "Canada"
}, U0 = "We calculated this amount based on the yearly cost of attendance and the semesters you have left to complete your education.", ha = [
  {
    feature: "isFutureDate",
    flagMap: {
      parent: ["compLightSegIneligible"],
      child: ["isDateGreaterThanToday"]
    },
    restrictedModule: ["education"]
  },
  {
    feature: "lightSpeedFeature",
    flagMap: {
      parent: ["compLightSegIneligible"],
      child: ["lightSegIneligible"]
    },
    restrictedModule: ["education", "employment"]
  },
  {
    feature: "skipEmploymentTillOffer",
    flagMap: {
      child: ["childSkipEmploymentTillOffer"]
    },
    restrictedModule: ["employment"]
  }
], Ys = {
  received: {
    value: "I have received my visa and will upload it",
    label: "I have received my visa and will upload it."
  },
  scheduled: {
    value: "I have an appointment scheduled",
    label: "I have an appointment scheduled."
  },
  rejected: {
    value: "My Visa was rejected. I may need to defer my start date",
    label: "My Visa was rejected. I may need to defer my start date."
  },
  scheduleAppointment: {
    value: "I need to schedule a visa appointment",
    label: "I need to schedule a visa appointment."
  }
}, z0 = {
  received: {
    value: "I have received my study permit and will upload it",
    label: "I have received my study permit and will upload it."
  },
  scheduled: {
    value: "I need to apply for my study permit",
    label: "I need to apply for my study permit."
  },
  rejected: {
    value: "I have applied for my study permit but have not heard back as yet",
    label: "I have applied for my study permit but have not heard back as yet."
  },
  scheduleAppointment: {
    value: "My study permit got rejected the first time but I am re-applying",
    label: "My study permit got rejected the first time but I am re-applying."
  }
}, fa = ["id-verification"], to = {
  borrower: "BORROWER",
  borrowerUSGrad: "BORROWER-US-GRAD",
  borrowerInSchoolUSSchool: "BORROWER-IN-SCHOOL-US",
  borrowerInSchoolCanSchool: "BORROWER-IN-SCHOOL-CAN",
  borrowerRefi: "BORROWER-REFI",
  borrowerInSchool: "BORROWER-IN-SCHOOL",
  preBorrower: "PRE-BORROWER",
  preBorrowerRefi: "PRE-BORROWER-REFI",
  preBorrowerInSchool: "PRE-BORROWER-IN-SCHOOL",
  tas: "TAS"
}, H0 = [
  {
    value: "🇨🇦 - +1",
    label: "🇨🇦 - +1",
    key: "CA",
    code: "1",
    emoji: "🇨🇦",
    name: "Canada",
    codeWithPlus: "+1",
    codeWithZero: "01",
    codeWithZeroWithPlus: "+01",
    valueWithName: "🇨🇦 - Canada (+1)"
  },
  {
    value: "🇺🇸 - +1",
    label: "🇺🇸 - +1",
    key: "US",
    code: "1",
    emoji: "🇺🇸",
    name: "United States",
    codeWithPlus: "+1",
    codeWithZero: "01",
    codeWithZeroWithPlus: "+01",
    valueWithName: "🇺🇸 - United States (+1)"
  }
], pa = "primary", q0 = {
  career: [
    {
      id: 1,
      titleImage: "/images/marketplace/marketplace-career-1-min.webp",
      title: "Boost your job and internship search in the U.S.",
      description: "Free access for MPOWER students - resume builder, F-1/OPT/H-1B roles, internships and expert-backed career tools",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms.",
      logo: "/images/marketplace/froghire.webp",
      buttonClickNavigation: "https://docs.google.com/forms/d/e/1FAIpQLSfpL1Mk1xtgHmr8UPabNhI6tBKpUCJ-Pj_WOEeG0E1fCpwh5A/viewform",
      partnerName: "Froghire"
    },
    {
      id: 2,
      titleImage: "/images/marketplace/marketplace-visa-1-min.webp",
      title: "Ace your U.S. student visa with CatalystGEM",
      description: "Free F-1 visa essentials course + optional mock interviews for extra prep.",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/catalystgem.webp",
      buttonClickNavigation: "https://apply.catalystgem.com/f1visa-admin-mpower",
      partnerName: "CatalystGEM"
    }
  ],
  credit: [
    {
      id: 1,
      titleImage: "/images/marketplace/marketplace-cc-1-min.webp",
      title: "Get A Prequalified U.S. Credit Card For Free",
      description: "Prequalified exclusively for MPOWER students - build credit, earn rewards,and open a U.S. bank account.",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/zolve.webp",
      buttonClickNavigation: "https://zolve.com/?utm_channel=partners&utm_source=loan_providers&utm_medium=website_landing_page&utm_campaign=ST_US_CC_acuisition_fall25_20-05-25&utm_term=NA&utm_content=NA&utm_affiliate=MPOWER&referral_code=MPOWER",
      partnerName: "Zolve"
    },
    {
      id: 2,
      titleImage: "/images/marketplace/marketplace-cc-3-min.webp",
      title: "Start Your Financial Journey in Canada",
      description: "Earn cash back dollars. Redeem them to help pay down your account balance with $0 annual fee",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/td.webp",
      buttonClickNavigation: "https://www.mpowerfinancing.com/international-student-canada-banking",
      partnerName: "TDBankCanada"
    }
  ],
  others: [
    {
      id: 1,
      titleImage: "/images/marketplace/marketplace-other-1-min.webp",
      title: "Stay connected in Canada with PhoneBox ESIM",
      description: "No credit history, contracts or activation fees - just instant, flexible connectivity.",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/esim.webp",
      buttonClickNavigation: "https://gophonebox.com/activation/?bn=4047&i_rep=173",
      partnerName: "PhoneBox"
    },
    {
      id: 2,
      titleImage: "/images/marketplace/marketplace-other-2-min.webp",
      title: "Get your U.S. phone number before you fly",
      description: "Plans start at just US$15/month - with no contracts or U.S. bank account needed.",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/campussim.webp",
      buttonClickNavigation: "https://www.campussims.com/mpower-x-campussims/",
      partnerName: "Campussims"
    },
    {
      id: 3,
      titleImage: "/images/marketplace/marketplace-other-3-min.webp",
      title: "Get your U.S. taxes done right with Sprintax",
      description: "Expert tax help for international students - even if you earned no income.",
      buttonText: "EXPLORE",
      lockMessage: "Unlock after accepting loan terms",
      logo: "/images/marketplace/sprintax.webp",
      buttonClickNavigation: "https://taxprep.sprintax.com/?utm_ref=mpower-financing&utm_content=prmc",
      partnerName: "Sprintax"
    }
  ]
}, id = {
  VERIFICATION: "verification",
  REFERENCE_EMAIL_CONFIRMATION: "ref-email-confirmation",
  CONSENT: "consent-preference",
  VERIFICATION_WHATSAPP: "wp-verification"
};
var lh = /* @__PURE__ */ ((e) => (e.IN_SCHOOL = "in_school", e.REFI = "refi", e))(lh || {});
const od = "/images/cardbg.png", G0 = {
  "nova-cashflow": "* We use our trusted partner, Nova Credit, to securely verify your identity and financial details. This direct connection is the fastest way to confirm your information, prevent delays, and move your application forward. It is a secure, read-only process."
}, V0 = "phc_4Qdr1dwJVzr6YeHePQRlx9ZMavX3kHUsurdNY8sHSMs", Y0 = "https://us.i.posthog.com", K0 = "https://www.mpowerfinancing.com/privacy-policy", pc = "__MPOWER_KEY__", J0 = "__MPOWER_VALUE__";
class dh {
  constructor(t) {
    this.inMemoryStorage = {}, this.storageAvailable = null, this.storageType = t;
  }
  isStorageAvailable() {
    if (this.storageAvailable === null)
      try {
        window[this.storageType].setItem(pc, J0), window[this.storageType].removeItem(pc), this.storageAvailable = !0;
      } catch {
        this.storageAvailable = !1;
      }
    return this.storageAvailable;
  }
  getItem(t) {
    if (this.isStorageAvailable())
      try {
        const n = window[this.storageType].getItem(t);
        return n ? JSON.parse(n) : null;
      } catch {
        return null;
      }
    return this.inMemoryStorage[t] ?? null;
  }
  setItem(t, n) {
    if (this.isStorageAvailable())
      try {
        window[this.storageType].setItem(t, JSON.stringify(n));
      } catch {
      }
    else
      this.inMemoryStorage[t] = n;
  }
  removeItem(t) {
    if (this.isStorageAvailable())
      try {
        window[this.storageType].removeItem(t);
      } catch {
      }
    else
      delete this.inMemoryStorage[t];
  }
  clear() {
    if (this.isStorageAvailable())
      try {
        window[this.storageType].clear();
      } catch {
      }
    this.inMemoryStorage = {};
  }
  resetStorageCheck() {
    this.storageAvailable = null;
  }
}
const _n = new dh("localStorage"), JT = new dh("sessionStorage"), ZT = (e) => {
  if (e != null && e.length)
    for (const t of e)
      _n.removeItem(t);
}, Z0 = {
  MODAL: 1300,
  APP_NAVIGATION: 1200,
  DASHBOARD_HEADER: 1100,
  FOOTER: 100,
  FOOTER_BUTTONS: 105
}, _a = [
  { pathName: "DASHBOARD", route: "dashboard" },
  { pathName: "MYLOANS", route: "my-loans" }
], X0 = "_mainHeader_bo74s_1", Q0 = "_header_bo74s_7", e2 = "_logo_bo74s_31", t2 = "_menuSection_bo74s_40", n2 = "_logoutBtn_bo74s_50", s2 = "_yellowSpotIcon_bo74s_61", r2 = "_mobileViewScreen_bo74s_72", i2 = "_bigYellowSpotWithLetter_bo74s_82", o2 = "_dropdown_bo74s_100", a2 = "_showLogout_bo74s_105", l2 = "_notificationDot_bo74s_109", d2 = "_notificationDotNav_bo74s_118", yn = {
  mainHeader: X0,
  header: Q0,
  logo: e2,
  menuSection: t2,
  logoutBtn: n2,
  yellowSpotIcon: s2,
  mobileViewScreen: r2,
  bigYellowSpotWithLetter: i2,
  dropdown: o2,
  showLogout: a2,
  notificationDot: l2,
  notificationDotNav: d2
}, c2 = ({
  updatedValue: e = (l) => l,
  showUser: t,
  firstName: n,
  lastName: s,
  data: r,
  pathName: o,
  pageError: a
}) => {
  var $, y, P, j;
  const { userRole: l = "", userLoginType: d = "", showNotificationCookie: c = {} } = r || {}, u = l === to.tas || l === to.preBorrower || l === to.preBorrowerInSchool || l === to.preBorrowerRefi, [h, p] = O(!0), [f, m] = O(
    u && !h || !u
  );
  ne(() => {
    var C, S;
    const b = (S = (C = window == null ? void 0 : window.location) == null ? void 0 : C.pathname) == null ? void 0 : S.includes("/eligibility"), N = u && !b || !u;
    p(b), m(N);
  }, [o]);
  const g = (b) => {
    e(b);
  }, v = () => {
    if (!f && t) return !1;
    t ? g("dashboard") : window.location.href = ua == null ? void 0 : ua.REDIRECT_URL;
  }, _ = (() => {
    try {
      return JSON.parse(a);
    } catch {
      return a;
    }
  })();
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(mr, { header: { height: 71 }, className: yn.mainHeader, children: /* @__PURE__ */ i.jsxs(mr.Header, { className: yn.header, children: [
    /* @__PURE__ */ i.jsx(E, { className: yn.logo, onClick: v, children: /* @__PURE__ */ i.jsx(U, { name: "logo" }) }),
    /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx("nav", { children: /* @__PURE__ */ i.jsxs("ul", { className: yn.menuSection, children: [
      /* @__PURE__ */ i.jsx("li", { className: R(yn.logoutBtn, t && yn.showLogout) }),
      t && /* @__PURE__ */ i.jsx("li", { className: yn.yellowSpotIcon, children: /* @__PURE__ */ i.jsx(T, { className: yn.mobileViewScreen, children: /* @__PURE__ */ i.jsx(T.Col, { children: /* @__PURE__ */ i.jsxs(si, { children: [
        /* @__PURE__ */ i.jsx(si.Target, { children: /* @__PURE__ */ i.jsxs(
          zp,
          {
            className: yn.bigYellowSpotWithLetter,
            component: "button",
            alt: "User Name",
            "aria-label": "Toggle menu",
            children: [
              (y = ($ = n == null ? void 0 : n.charAt(0)) == null ? void 0 : $.toString()) == null ? void 0 : y.toUpperCase(),
              (j = (P = s == null ? void 0 : s.charAt(0)) == null ? void 0 : P.toString()) == null ? void 0 : j.toUpperCase()
            ]
          }
        ) }),
        (_ == null ? void 0 : _.showNotification) && /* @__PURE__ */ i.jsx(
          "span",
          {
            className: R(yn.notificationDot, yn.notificationDotNav)
          }
        ),
        /* @__PURE__ */ i.jsxs(si.Dropdown, { className: yn.dropdown, children: [
          f && /* @__PURE__ */ i.jsxs(
            si.Item,
            {
              color: gn.white,
              onClick: () => g("dashboard/myProfile"),
              children: [
                "My Profile",
                " ",
                (_ == null ? void 0 : _.showNotification) && /* @__PURE__ */ i.jsx("span", { className: yn.notificationDot })
              ]
            }
          ),
          /* @__PURE__ */ i.jsx(
            si.Item,
            {
              color: gn.white,
              onClick: () => g("logout"),
              children: "Logout"
            }
          )
        ] })
      ] }) }) }) })
    ] }) }) })
  ] }) }) });
}, u2 = "_infoMessage_d2uy5_1", h2 = "_infoContainer_d2uy5_6", f2 = "_infoCross_d2uy5_30", ma = {
  infoMessage: u2,
  infoContainer: h2,
  infoCross: f2
}, p2 = () => {
  const { appIssue: e, setAppIssue: t } = fh(), n = () => {
    t({
      status: !1,
      info: ""
    }), clearTimeout(void 0);
  };
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: (e == null ? void 0 : e.status) && /* @__PURE__ */ i.jsxs(Hs, { size: "lg", className: ma.infoContainer, children: [
    /* @__PURE__ */ i.jsx("div", { className: ma.infoMessage, children: e == null ? void 0 : e.info }),
    /* @__PURE__ */ i.jsx("div", { className: ma.infoCross, onClick: n, children: "X" })
  ] }) });
}, ch = ({
  children: e,
  title: t,
  className: n,
  onClose: s,
  color: r = "red"
}) => /* @__PURE__ */ i.jsx(
  Zu,
  {
    title: t,
    color: r,
    className: n,
    onClose: s,
    style: { width: "50%", marginTop: "50px", textAlign: "left" },
    children: e
  }
), _2 = "_container_1qwp9_1", m2 = "_contentContainer_1qwp9_7", g2 = "_mt_1qwp9_12", v2 = "_notification_1qwp9_17", $2 = "_cookieContainer_1qwp9_25", b2 = "_cookieText_1qwp9_37", x2 = "_cookieTextLink_1qwp9_43", y2 = "_cookieButton_1qwp9_49", Ns = {
  container: _2,
  contentContainer: m2,
  mt: g2,
  notification: v2,
  cookieContainer: $2,
  cookieText: b2,
  cookieTextLink: x2,
  cookieButton: y2
}, uh = {
  MESSAGE: "Please enter the data and try again",
  TITLE: "We encountered an issue"
}, hh = Vu(void 0), fh = () => {
  const e = Yi(hh);
  return e || !1;
}, XT = ({
  updatedValue: e = (u) => u,
  data: t,
  children: n,
  showUser: s,
  firstName: r,
  lastName: o,
  pathname: a,
  pageError: l = "",
  showCookieDisclaimer: d = !1,
  onCookieDisclaimerAccept: c
}) => {
  let u = !1;
  _a == null || _a.forEach(($, y) => {
    const { route: P = "" } = $ || {};
    a != null && a.includes(P) && (u = !0);
  });
  const h = ($) => {
    e($);
  }, p = a == null ? void 0 : a.includes("id-verification"), [f, m] = O({ status: !1, info: "" }), [g, v] = O(!1), _ = {
    appIssue: f,
    setAppIssue: ($) => m((y) => ({ ...y, ...$ }))
  };
  return ne(() => {
    typeof window < "u" && ((_n == null ? void 0 : _n.getItem("reload")) === "true" ? (v(!0), _n == null || _n.setItem("reload", "false")) : v(!1));
    const $ = (() => {
      try {
        return JSON.parse(l);
      } catch {
        return l;
      }
    })();
    return !($ != null && $.showNotification) && l ? m({ status: !0, info: l }) : m({ status: !1, info: "" });
  }, [l, a]), /* @__PURE__ */ i.jsx(hh.Provider, { value: _, children: /* @__PURE__ */ i.jsxs(E, { className: Ns.container, children: [
    /* @__PURE__ */ i.jsx(
      c2,
      {
        firstName: r,
        lastName: o,
        updatedValue: ($) => h($),
        showUser: s,
        data: t,
        pathName: a,
        pageError: l
      }
    ),
    g && /* @__PURE__ */ i.jsx(
      ch,
      {
        title: uh.TITLE,
        className: Ns.notification,
        onClose: () => v(!1),
        color: "yellow",
        children: "Please enter the data and try again"
      }
    ),
    /* @__PURE__ */ i.jsxs("div", { className: R(p && Ns.mt, Ns.contentContainer), children: [
      /* @__PURE__ */ i.jsx(p2, {}),
      n,
      !u && /* @__PURE__ */ i.jsx($t, { h: 75, mt: "md" })
    ] }),
    u && /* @__PURE__ */ i.jsx(W0, {}),
    d && /* @__PURE__ */ i.jsxs(E, { className: Ns.cookieContainer, children: [
      /* @__PURE__ */ i.jsxs("div", { className: Ns.cookieText, children: [
        "This website uses cookies to ensure you get the best experience on our website.",
        " ",
        /* @__PURE__ */ i.jsx(
          "a",
          {
            className: Ns.cookieTextLink,
            href: K0,
            target: "_blank",
            rel: "noreferrer",
            children: /* @__PURE__ */ i.jsx("b", { children: "Learn more" })
          }
        )
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: Ns.cookieButton, children: /* @__PURE__ */ i.jsx(Jt, { onClick: c, children: "Got It" }) })
    ] })
  ] }) });
}, w2 = "_notification_rgjvw_1", C2 = {
  notification: w2
}, QT = ({
  children: e,
  pathname: t,
  pageError: n = ""
}) => {
  const [s, r] = O(!1);
  return ne(() => {
    typeof window < "u" && ((_n == null ? void 0 : _n.getItem("reload")) === "true" ? (r(!0), _n == null || _n.setItem("reload", "false")) : r(!1));
  }, [n, t]), /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    s && /* @__PURE__ */ i.jsx(
      ch,
      {
        title: uh.TITLE,
        className: C2.notification,
        onClose: () => r(!1),
        color: "yellow",
        children: "Please enter the data and try again"
      }
    ),
    e
  ] }) });
}, j2 = "_label_1dymm_1", N2 = "_radio_1dymm_11", S2 = "_radioSelected_1dymm_44", k2 = "_svgIcon_1dymm_76", E2 = "_itemText_1dymm_92", I2 = "_labelWrapper_1dymm_97", P2 = "_inner_1dymm_101", T2 = "_root_1dymm_105", R2 = "_inputLabel_1dymm_109", L2 = "_group_1dymm_116", O2 = "_mantine-Group-root_1dymm_125", F2 = "_rootData_1dymm_130", A2 = "_radioLabel_1dymm_141", M2 = "_error_1dymm_145", In = {
  label: j2,
  radio: N2,
  radioSelected: S2,
  svgIcon: k2,
  itemText: E2,
  labelWrapper: I2,
  inner: P2,
  root: T2,
  inputLabel: R2,
  group: L2,
  "mantine-Group-root": "_mantine-Group-root_1dymm_125",
  mantineGroupRoot: O2,
  rootData: F2,
  radioLabel: A2,
  error: M2
}, eR = ({
  description: e,
  id: t,
  label: n,
  defaultValue: s,
  ref: r,
  error: o,
  mouseClick: a,
  options: l,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updatedValue: d = () => {
  },
  customRootClass: c
}) => {
  const [u, h] = O(s), p = (f) => {
    var g;
    const m = typeof f == "string" ? f : (g = f == null ? void 0 : f.target) == null ? void 0 : g.id;
    h(m), d(m);
  };
  return ne(() => {
    h(s);
  }, [s]), /* @__PURE__ */ i.jsx(
    vt.Group,
    {
      value: u,
      onChange: p,
      onMouseDown: a,
      label: n,
      description: e,
      id: t,
      "data-testid": t,
      name: t,
      required: !0,
      error: ((o == null ? void 0 : o.fieldErrors[t]) || []).join(", "),
      className: In.group,
      withAsterisk: !1,
      classNames: {
        label: In.inputLabel,
        root: c || In.root,
        error: In.error
      },
      children: l.map((f) => {
        const m = f.icon ? f.icon : "";
        return /* @__PURE__ */ i.jsx(
          vt,
          {
            id: f.id,
            onClick: p,
            "data-testid": f.id,
            className: u === f.id ? In.radioSelected : In.radio,
            classNames: {
              labelWrapper: In.labelWrapper,
              inner: In.inner,
              root: In.rootData,
              label: In.radioLabel
              //root: classes.radioRoot,
            },
            value: f.id,
            label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
              /* @__PURE__ */ i.jsx("span", { className: In.svgIcon, children: m ? /* @__PURE__ */ i.jsx(m, {}) : "" }),
              /* @__PURE__ */ i.jsx(
                "span",
                {
                  dangerouslySetInnerHTML: { __html: f.name },
                  className: In.itemText
                }
              )
            ] }),
            ref: r
          },
          f.id
        );
      })
    }
  );
}, D2 = "_root_9gf5a_1", B2 = "_wrapper_9gf5a_5", W2 = "_input_9gf5a_15", U2 = "_label_9gf5a_32", z2 = "_edit_9gf5a_39", H2 = "_editUp_9gf5a_40", q2 = "_enableClick_9gf5a_70", G2 = "_rightSelection_9gf5a_74", V2 = "_disabledRightSelection_9gf5a_86", Y2 = "_transparent_9gf5a_90", Nr = {
  root: D2,
  wrapper: B2,
  input: W2,
  label: U2,
  edit: z2,
  editUp: H2,
  enableClick: q2,
  rightSelection: G2,
  disabledRightSelection: V2,
  transparent: Y2
}, K2 = ({
  placeholder: e = "Pick date",
  defaultValue: t,
  label: n = "",
  className: s,
  id: r,
  updatedValue: o,
  inputFormat: a,
  error: l,
  maxDate: d,
  initialMonth: c,
  initialLevel: u,
  readOnly: h,
  showEdit: p,
  sideButtonName: f = "Edit",
  required: m = !1
}) => {
  const [g, v] = O(t), [_, $] = O(!1), [y, P] = O(!1), [j, b] = oe.useState(p), [N, C] = oe.useState(h), [S, F] = O(!1), W = dn(null), D = (q) => {
    F(!0);
    const G = Re(q).format(a), z = Re(t).format(a);
    v(G || z), typeof o < "u" && o(G || z);
  }, B = () => {
    var q, G;
    (q = W == null ? void 0 : W.current) == null || q.focus(), C(!1), $(!0), b(!1), P(!0), (G = W == null ? void 0 : W.current) == null || G.focus();
  };
  return /* @__PURE__ */ i.jsxs("div", { style: { borderBottom: " 5px black" }, children: [
    /* @__PURE__ */ i.jsx(
      e_,
      {
        variant: "unstyled",
        classNames: { wrapper: Nr.wrapper, input: Nr.input, label: Nr.label },
        className: _ ? Nr.enableClick : s,
        "aria-controls": "",
        placeholder: e,
        label: n,
        id: r,
        name: r,
        "data-testid": r,
        value: typeof g < "u" ? new Date(g) : void 0,
        onChange: D,
        required: m,
        valueFormat: a,
        error: S ? "" : ((l == null ? void 0 : l.fieldErrors[r || 0]) || []).join(", "),
        maxDate: d,
        disabled: h && N,
        defaultDate: c
      }
    ),
    j && /* @__PURE__ */ i.jsx(
      "span",
      {
        className: l ? Nr.edit : Nr.editUp,
        id: r,
        "data-testid": r,
        onClick: B,
        children: f
      }
    )
  ] });
}, tR = oe.memo(K2), J2 = "_radio_xxzms_1", Z2 = "_text_xxzms_27", X2 = "_inner_xxzms_31", Q2 = "_dollarIcon_xxzms_37", ev = "_radioSelected_xxzms_51", tv = "_infoIcon_xxzms_76", nv = "_amount_xxzms_99", sv = "_header_xxzms_104", Ks = {
  radio: J2,
  text: Z2,
  inner: X2,
  dollarIcon: Q2,
  radioSelected: ev,
  infoIcon: tv,
  amount: nv,
  header: sv
}, nR = ({
  id: e,
  value: t,
  title: n = "My financial plan",
  totalCost: s = "$0",
  additional: r,
  styles: o,
  infoClick: a,
  showInfoButton: l = !0
}) => {
  const d = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(Hs, { px: 0, style: { paddingBottom: d ? "5px" : "50px" }, children: /* @__PURE__ */ i.jsx(
    cn,
    {
      shadow: "sm",
      p: "lg",
      radius: "sm",
      style: { background: "#F5FAFF 0% 0% no-repeat padding-box" },
      children: /* @__PURE__ */ i.jsxs(T, { align: "center", children: [
        /* @__PURE__ */ i.jsxs(T.Col, { span: { sm: 12, md: o != null && o.active ? 12 : 6 }, children: [
          o && o.active ? /* @__PURE__ */ i.jsx(
            ee,
            {
              order: o.order,
              variant: "blue",
              fontWeight: "700",
              className: Ks.header,
              children: n
            }
          ) : /* @__PURE__ */ i.jsx(
            ee,
            {
              order: d ? 3 : 2,
              variant: "blue",
              fontWeight: "700",
              className: Ks.header,
              children: n
            }
          ),
          /* @__PURE__ */ i.jsx($t, { h: 10 }),
          /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "blue", fontWeight: "400", children: "Total cost to complete program" }),
          /* @__PURE__ */ i.jsxs(
            ee,
            {
              className: Ks.amount,
              order: d ? 4 : 2,
              variant: "blue",
              fontWeight: "700",
              children: [
                "US",
                s,
                l && /* @__PURE__ */ i.jsx(Ee, { role: "button", "aria-label": "COA Details", onClick: a, children: /* @__PURE__ */ i.jsx(U, { name: "infoCircle", className: Ks.infoIcon }) })
              ]
            }
          ),
          (r == null ? void 0 : r.active) && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx($t, { h: 20 }),
            /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "blue", fontWeight: "400", children: "Additional funding resources:" }),
            /* @__PURE__ */ i.jsx(I, { size: "xs", children: "This is the total amount you entered in the previous section." }),
            /* @__PURE__ */ i.jsxs(
              ee,
              {
                className: Ks.amount,
                order: d ? 4 : 2,
                variant: "blue",
                fontWeight: "700",
                children: [
                  "US",
                  r.cost
                ]
              }
            ),
            /* @__PURE__ */ i.jsx(
              on,
              {
                href: r.path,
                style: { display: "block", color: "#000", textDecoration: "underline" },
                children: "Add another funding source"
              }
            )
          ] }),
          (o == null ? void 0 : o.active) && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx($t, { h: "xl" }),
            /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "blue", fontWeight: "400", children: "Funding gap:" }),
            /* @__PURE__ */ i.jsxs(
              ee,
              {
                className: Ks.amount,
                order: d ? 4 : 2,
                variant: "blue",
                fontWeight: "700",
                children: [
                  "US",
                  o.fundGap
                ]
              }
            )
          ] })
        ] }),
        !(o != null && o.active) && /* @__PURE__ */ i.jsx(T.Col, { span: { sm: 12, md: 6 }, className: Ks.dollarIcon, children: /* @__PURE__ */ i.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "350",
            height: "350",
            viewBox: "0 0 44.814 44.919",
            style: { opacity: "0.5" },
            children: /* @__PURE__ */ i.jsxs("g", { id: "Group_545", "data-name": "Group 545", transform: "translate(13307 -18553)", children: [
              /* @__PURE__ */ i.jsx(
                "path",
                {
                  id: "Path_717",
                  "data-name": "Path 717",
                  d: "M47.215,39.745l1.35-7a4.16,4.16,0,0,1,1.254,1.5.982.982,0,0,0,1.785-.821A5.663,5.663,0,0,0,49,30.723l.435-2.317a.956.956,0,1,0-1.882-.339l-.386,1.978c-.529-.047-.964-.094-1.4-.094A6.049,6.049,0,0,0,39.5,35.742a5.966,5.966,0,0,0,5.4,5.741l-1.4,7.188a3.982,3.982,0,0,1-1.736-1.832.982.982,0,1,0-1.785.821,6.131,6.131,0,0,0,3.135,2.992l-.482,2.51a.942.942,0,0,0,.771,1.11H43.6a1.028,1.028,0,0,0,.964-.771l.482-2.413a3.817,3.817,0,0,0,.771.049,6.049,6.049,0,0,0,6.273-5.791,6.034,6.034,0,0,0-4.871-5.6ZM41.424,35.74a4.119,4.119,0,0,1,4.342-3.86,6.659,6.659,0,0,1,.964.1L45.284,39.55a4.026,4.026,0,0,1-3.86-3.81Zm4.344,13.51a1.033,1.033,0,0,1-.386-.049l1.446-7.573A3.983,3.983,0,0,1,50.11,45.34a4.126,4.126,0,0,1-4.342,3.909Z",
                  transform: "translate(-13330.47 18534.629)",
                  fill: "#ffcb4c"
                }
              ),
              /* @__PURE__ */ i.jsx(
                "path",
                {
                  id: "Elipse_126",
                  "data-name": "Elipse 126",
                  d: "M17.317.63A16.74,16.74,0,1,0,34,17.369,16.733,16.733,0,0,0,17.317.63m0-.63A17.37,17.37,0,1,1,0,17.369,17.343,17.343,0,0,1,17.317,0Z",
                  transform: "translate(-13301.857 18558.145)",
                  fill: "#1e3c78"
                }
              ),
              /* @__PURE__ */ i.jsx(
                "path",
                {
                  id: "Elipse_127",
                  "data-name": "Elipse 127",
                  d: "M22.407.63A21.83,21.83,0,1,0,44.185,22.46,21.828,21.828,0,0,0,22.407.63m0-.63A22.46,22.46,0,1,1,0,22.46,22.433,22.433,0,0,1,22.407,0Z",
                  transform: "translate(-13307 18553)",
                  fill: "#1e3c78"
                }
              )
            ] })
          }
        ) })
      ] })
    }
  ) }) });
}, rv = "_root_o7xj0_1", iv = "_input_o7xj0_12", ov = "_label_o7xj0_20", av = "_error_o7xj0_26", lv = {
  root: rv,
  input: iv,
  label: ov,
  error: av
}, sR = ({
  id: e,
  placeholder: t,
  label: n,
  className: s,
  error: r,
  defaultValue: o,
  updatedValue: a,
  decimalseparator: l,
  step: d,
  decimalScale: c,
  min: u,
  max: h,
  hideControls: p = !1,
  allowLeadingZeros: f = !0,
  disabled: m = !1
}) => {
  const [g, v] = oe.useState(o), _ = ($) => {
    v($), a && a($);
  };
  return ne(() => {
    m && v(0);
  }, [m]), /* @__PURE__ */ i.jsx(
    Hp,
    {
      step: d,
      decimalSeparator: l,
      decimalScale: c,
      fixedDecimalScale: !0,
      min: u,
      max: h,
      classNames: lv,
      id: e,
      "data-testid": e,
      name: e,
      value: typeof g < "u" ? Number(g) === 0 ? "" : Number(g) : void 0,
      onChange: _,
      label: n,
      placeholder: t,
      className: s,
      error: ((r == null ? void 0 : r.fieldErrors[e]) || []).join(", "),
      clampBehavior: "strict",
      hideControls: p,
      allowLeadingZeros: f,
      disabled: m
    }
  );
}, dv = "_applicationTip_1pxzo_1", cv = "_icon_1pxzo_10", uv = "_content_1pxzo_14", ga = {
  applicationTip: dv,
  icon: cv,
  content: uv
}, rR = ({
  iconName: e,
  iconSize: t = 30,
  className: n,
  children: s
}) => /* @__PURE__ */ i.jsxs("div", { className: R(ga.applicationTip, n), "data-testid": "application-tip", children: [
  /* @__PURE__ */ i.jsx(U, { name: e, size: t, className: ga.icon }),
  /* @__PURE__ */ i.jsx("div", { className: ga.content, children: s })
] }), hv = (e) => {
  try {
    const t = JSON.parse(JSON.stringify(e)), n = _n.getItem("progressBarInfo") || {}, s = fv(n);
    return (s == null ? void 0 : s.length) === 0 ? e : pv(t, s);
  } catch {
    return e;
  }
}, fv = (e) => ha == null ? void 0 : ha.filter(
  (t) => {
    var n;
    return ((n = e == null ? void 0 : e.pagerProgressInput) == null ? void 0 : n[t.feature]) === !0;
  }
), _c = (e, t) => t == null ? void 0 : t.some((n) => e[n] === !0), pv = (e, t) => e == null ? void 0 : e.filter((n) => {
  const s = mc(t, "parent");
  if (_c(n, s)) return !1;
  if (n.steps) {
    const r = mc(t, "child");
    n.steps = n.steps.filter(
      (o) => !_c(o, r)
    );
  }
  return !0;
}), mc = (e, t) => e.flatMap((n) => (n == null ? void 0 : n.flagMap[t]) || []), _v = "_item_13obi_1", mv = "_line_13obi_8", gv = "_number_13obi_18", vv = "_label_13obi_35", $v = "_itemTitle_13obi_39", bv = "_accordionItem_13obi_43", xv = "_accordionLine_13obi_50", yv = "_accordionNumber_13obi_55", wv = "_progress_13obi_67", Cv = "_fs16_13obi_72", jv = "_progressText_13obi_76", Nv = "_text_13obi_88", Sv = "_stepModalHeading_13obi_97", kv = "_stepsWrapper_13obi_104", Ev = "_moduleNameWrapper_13obi_111", Iv = "_stepsCountWrapper_13obi_119", Pv = "_moduleName_13obi_111", Tv = "_modalContainer_13obi_131", Rv = "_modalCloseIc_13obi_137", Lv = "_modalContent_13obi_142", Ov = "_customModalHeader_13obi_147", Vt = {
  item: _v,
  line: mv,
  number: gv,
  label: vv,
  itemTitle: $v,
  accordionItem: bv,
  accordionLine: xv,
  accordionNumber: yv,
  progress: wv,
  fs16: Cv,
  progressText: jv,
  text: Nv,
  stepModalHeading: Sv,
  stepsWrapper: kv,
  moduleNameWrapper: Ev,
  stepsCountWrapper: Iv,
  moduleName: Pv,
  modalContainer: Tv,
  modalCloseIc: Rv,
  modalContent: Lv,
  customModalHeader: Ov
}, Ki = Vu({
  steps: [],
  currentLocation: "",
  currentModuleIndex: -1,
  currentPageIndex: -1,
  time: 10,
  id: ""
}), ph = "#DEDEDE", Fv = (e, t) => Yl(t, 0.4), Av = ({ index: e, className: t }) => {
  const { steps: n, currentModuleIndex: s, currentPageIndex: r } = Yi(Ki), o = n[e].steps, a = e <= s ? "#56B3EB" : ph;
  return /* @__PURE__ */ i.jsx(
    ss,
    {
      wrap: "nowrap",
      gap: 0,
      className: t,
      style: { background: Yl(a, 0.4) },
      children: Array.from({ length: o.length }).map((l, d) => /* @__PURE__ */ i.jsx(
        Hn,
        {
          style: (c) => ({
            width: `calc(100% / ${o.length})`,
            height: "100%",
            backgroundColor: e === s ? d <= r ? a : Fv(c, a) : a,
            borderTopRightRadius: e === s && d === r && "15px",
            borderBottomRightRadius: e === s && d === r && "15px"
          })
        },
        `${e}-${d}`
      ))
    }
  );
}, Mv = ({ index: e, stepsLength: t }) => {
  const [n, s] = O(!1), { currentModuleIndex: r, steps: o, currentPageIndex: a } = Yi(Ki), l = e <= r ? "#56B3EB" : ph, d = e === r ? Yl(l, 0.4) : l, c = e + 1, u = Ve("(max-width: 767px)");
  return c > t - 1 ? null : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(Hn, { className: Vt.item, onClick: () => s(!!u), children: [
      /* @__PURE__ */ i.jsx(
        Av,
        {
          index: e,
          className: R(Vt.line, { backgroundColor: l, opacity: 0.4 })
        }
      ),
      /* @__PURE__ */ i.jsx(Hn, { className: Vt.number, style: { backgroundColor: d } })
    ] }),
    n && u && /* @__PURE__ */ i.jsx(
      Nn,
      {
        opened: n,
        onClose: () => s(!1),
        transitionProps: {
          transition: "fade",
          duration: 600,
          timingFunction: "linear"
        },
        centered: !0,
        radius: "lg",
        classNames: {
          close: Vt.modalCloseIc,
          content: Vt.modalContent,
          header: Vt.customModalHeader
        },
        closeButtonProps: {
          icon: /* @__PURE__ */ i.jsx(U, { name: "closePopup" })
        },
        children: /* @__PURE__ */ i.jsx("div", { className: Vt.modalContentWrapper, children: /* @__PURE__ */ i.jsx(
          Dv,
          {
            steps: o,
            currentModuleIndex: r + 1,
            currentPageIndex: a + 1
          }
        ) })
      }
    )
  ] });
};
function Dv({ steps: e, currentModuleIndex: t, currentPageIndex: n }) {
  try {
    const s = (o) => t > o + 1 ? "completedModule" : t === o + 1 ? "inProgressModule" : "pendingModule", r = (o, a) => {
      var c, u;
      if (fa != null && fa.includes(o == null ? void 0 : o.moduleName)) return /* @__PURE__ */ i.jsx(i.Fragment, {});
      const l = a + 1 === t, d = a + 1 < t ? (c = o == null ? void 0 : o.steps) == null ? void 0 : c.length : l ? n : 0;
      return /* @__PURE__ */ i.jsx(E, { justify: "space-between", align: "center", className: Vt.stepsWrapper, children: /* @__PURE__ */ i.jsxs(
        E,
        {
          justify: "flex-start",
          align: "center",
          className: Vt.moduleNameWrapper,
          direction: "row",
          children: [
            /* @__PURE__ */ i.jsx(U, { name: s(a) }),
            /* @__PURE__ */ i.jsxs(Ce, { tt: "capitalize", fw: 600, classNames: { root: Vt.moduleName }, children: [
              o == null ? void 0 : o.moduleName,
              " ",
              /* @__PURE__ */ i.jsxs("span", { className: Vt.stepsCountWrapper, children: [
                d,
                "/",
                (u = o == null ? void 0 : o.steps) == null ? void 0 : u.length
              ] })
            ] })
          ]
        }
      ) }, a);
    };
    return /* @__PURE__ */ i.jsxs("div", { className: Vt.modalContainer, children: [
      /* @__PURE__ */ i.jsxs(E, { align: "center", justify: "center", direction: "column", children: [
        /* @__PURE__ */ i.jsx(U, { name: "navInfoIcon" }),
        /* @__PURE__ */ i.jsx(Ce, { size: "lg", ta: "center", className: Vt.stepModalHeading, children: "Next steps" })
      ] }),
      /* @__PURE__ */ i.jsx(Vn, { my: "md" }),
      /* @__PURE__ */ i.jsx(E, { justify: "center", align: "center", direction: "column", children: e == null ? void 0 : e.map(r) })
    ] });
  } catch {
    return /* @__PURE__ */ i.jsx(i.Fragment, {});
  }
}
const Bv = () => {
  const { steps: e } = Yi(Ki);
  return /* @__PURE__ */ i.jsx(ss, { wrap: "nowrap", gap: 0, className: Vt.stepperHeader, children: e.map((t, n) => /* @__PURE__ */ i.jsx(Mv, { index: n, stepsLength: e == null ? void 0 : e.length }, n)) });
}, Wv = (e) => {
  var a, l, d;
  const { filteredSteps: t } = e || {}, { steps: n, currentModuleIndex: s, currentPageIndex: r, time: o } = Yi(Ki);
  return /* @__PURE__ */ i.jsxs(E, { className: Vt.progressText, children: [
    /* @__PURE__ */ i.jsxs(Ce, { c: "#243D74", fw: 700, className: Vt.text, children: [
      (a = t == null ? void 0 : t[s]) == null ? void 0 : a.accordionName,
      " ",
      `${r + 1} / ${(d = (l = t == null ? void 0 : t[s]) == null ? void 0 : l.steps) == null ? void 0 : d.length}`
    ] }),
    /* @__PURE__ */ i.jsx(Vn, { orientation: "vertical" }),
    /* @__PURE__ */ i.jsx(Ce, { c: "#243D74", className: Vt.text, children: `Great! ${(o / 60).toFixed(
      0
    )} mins to an offer` })
  ] });
}, Uv = ({
  currentLocation: e,
  steps: t,
  total_time: n = 23 * 60,
  id: s = "stepper",
  isNewUser: r = !1
}) => {
  var g, v;
  const { appIssue: o } = fh(), [a, l] = O(t);
  ne(() => {
    const _ = hv(t) || t;
    l(_);
  }, [o]);
  const [d, c, u] = e.split("/"), h = a.findIndex(
    (_) => _.moduleName === c
  ), p = (v = (g = a[h]) == null ? void 0 : g.steps) == null ? void 0 : v.findIndex(
    (_) => {
      var $;
      return (($ = _ == null ? void 0 : _.name) == null ? void 0 : $.toLowerCase()) === ((u == null ? void 0 : u.toLowerCase()) || "");
    }
  ), f = t.reduce((_, $) => (_.push(
    ...$.steps.flatMap((y) => y.name ? `/${$.moduleName}/${y.name}` : `/${$.moduleName}`)
  ), _), []), m = n * (f.length - f.findIndex((_) => _ === e)) / f.length;
  return /* @__PURE__ */ i.jsxs(
    Ki.Provider,
    {
      value: {
        currentLocation: e,
        steps: a,
        currentModuleIndex: h,
        currentPageIndex: p,
        time: m,
        id: s,
        isNewUser: r
      },
      children: [
        /* @__PURE__ */ i.jsx(Bv, {}),
        /* @__PURE__ */ i.jsx(Wv, { filteredSteps: a }),
        /* @__PURE__ */ i.jsx($t, { h: 5 }),
        /* @__PURE__ */ i.jsx(Vn, { orientation: "horizontal" })
      ]
    }
  );
}, iR = Fp(Uv), zv = "_actionBtn_18y1v_1", Hv = "_wrapper_18y1v_14", qv = "_dropdown_18y1v_24", Gv = "_root_18y1v_29", Vv = "_label_18y1v_50", Yv = "_stack_18y1v_58", Kv = "_cross_18y1v_67", Jv = "_errorcross_18y1v_68", Zv = "_disableStyle_18y1v_93", Xv = "_enableStyle_18y1v_101", Qv = "_datePickerButton_18y1v_105", On = {
  actionBtn: zv,
  wrapper: Hv,
  dropdown: qv,
  default: "_default_18y1v_28",
  root: Gv,
  label: Vv,
  stack: Yv,
  cross: Kv,
  errorcross: Jv,
  disableStyle: Zv,
  enableStyle: Xv,
  datePickerButton: Qv
}, e$ = ({ name: e, left: t, right: n, title: s }) => /* @__PURE__ */ i.jsxs(ss, { justify: "center", gap: "xl", children: [
  /* @__PURE__ */ i.jsx(rl, { onClick: t, className: On.actionBtn, children: /* @__PURE__ */ i.jsx(U, { name: "chevron_Left", className: On.left }) }),
  /* @__PURE__ */ i.jsx(Jt, { variant: "subtle", onClick: s, children: e }),
  /* @__PURE__ */ i.jsx(rl, { onClick: n, className: On.actionBtn, children: /* @__PURE__ */ i.jsx(U, { name: "chevron_Right", className: On.right }) })
] }), t$ = ({
  close: e,
  buttons: t,
  onSelect: n,
  level: s,
  disabledBefore: r,
  disabledAfter: o
}) => {
  const a = (c) => {
    const u = Re(c).startOf("month").toDate();
    return r && u < r || o && u > o;
  }, l = (c) => {
    const u = Re(c).startOf("year").toDate();
    return r && u < r || o && u > o;
  }, d = (c) => {
    (s === "months" && !a(c.value) || s === "years" && !l(c.value)) && (n(c.value), s === "months" && e());
  };
  return /* @__PURE__ */ i.jsx(Gp, { spacing: 0, cols: 3, children: t.map((c, u) => /* @__PURE__ */ i.jsx(
    Jt,
    {
      variant: "subtle",
      className: On.datePickerButton,
      onClick: () => d(c),
      disabled: s === "months" ? a(c.value) : l(c.value),
      children: c.label
    },
    u
  )) });
}, n$ = (e) => ({
  open: !1,
  value: e,
  level: "months"
}), ji = {
  months: {
    left: 1,
    right: 1,
    nextLevel: "years",
    prevLevel: "months",
    getTitle: (e = /* @__PURE__ */ new Date()) => e.getFullYear().toString(),
    getButtons: (e = /* @__PURE__ */ new Date()) => [
      { value: Re(e).set("month", 0).toDate(), label: "Jan" },
      { value: Re(e).set("month", 1).toDate(), label: "Feb" },
      { value: Re(e).set("month", 2).toDate(), label: "Mar" },
      { value: Re(e).set("month", 3).toDate(), label: "Apr" },
      { value: Re(e).set("month", 4).toDate(), label: "May" },
      { value: Re(e).set("month", 5).toDate(), label: "Jun" },
      { value: Re(e).set("month", 6).toDate(), label: "Jul" },
      { value: Re(e).set("month", 7).toDate(), label: "Aug" },
      { value: Re(e).set("month", 8).toDate(), label: "Sep" },
      { value: Re(e).set("month", 9).toDate(), label: "Oct" },
      { value: Re(e).set("month", 10).toDate(), label: "Nov" },
      { value: Re(e).set("month", 11).toDate(), label: "Dec" }
    ]
  },
  years: {
    left: 10,
    right: 10,
    nextLevel: "years",
    prevLevel: "months",
    getTitle: (e = /* @__PURE__ */ new Date()) => {
      const t = Math.floor(e.getFullYear() / 10) * 10 - 2, n = Math.floor(e.getFullYear() / 10) * 10 + 10;
      return `${t + 1} - ${n}`;
    },
    getButtons: (e = /* @__PURE__ */ new Date()) => {
      const n = Math.floor(e.getFullYear() / 10) * 10 - 2;
      return Array.from({ length: 12 }, (s, r) => {
        const o = n + r + 1;
        return {
          value: Re(e).set("year", o).toDate(),
          label: `${o}`
        };
      });
    }
  }
}, s$ = (e, t) => {
  switch (t.type) {
    case "close":
      return { ...e, open: !1, level: "months" };
    case "open":
      return { ...e, open: !0 };
    case "left": {
      const n = Re(e.value).add(-ji[e.level].left, "year").toDate();
      return { ...e, value: n, case: "left" };
    }
    case "right": {
      const n = Re(e.value).add(+ji[e.level].left, "y");
      return { ...e, value: n.toDate(), case: "right" };
    }
    case "title":
      return { ...e, level: ji[e.level].nextLevel };
    case "select": {
      const n = t.payload.value;
      return e.level === "months" ? { ...e, value: n, case: "" } : { ...e, value: n, level: "months", case: "" };
    }
    case "empty":
      return { ...e, value: t.type ? void 0 : /* @__PURE__ */ new Date() };
    default:
      throw new Error();
  }
}, r$ = (e) => Fi(() => {
  if (e != null)
    return typeof e == "string" ? new Date(e) : e;
}, [e]), i$ = oe.forwardRef(
  ({
    id: e,
    defaultValue: t,
    error: n,
    placeholder: s,
    updatedValue: r,
    label: o,
    format: a,
    fieldValue: l,
    disabled: d = !1,
    position: c,
    formattedValue: u,
    showCompressedError: h = !1,
    disabledBefore: p,
    disabledAfter: f
  }, m) => {
    const g = r$(t), [v, _] = Ap(s$, g, n$), $ = ["left", "right"], y = v.value && !$.includes(v == null ? void 0 : v.case) ? Re(v.value).format(a) : "", P = (C) => {
      l(C), _({ type: "select", payload: { value: C } }), typeof r < "u" && r(C || t);
    }, j = (n == null ? void 0 : n.fieldErrors[e || 0]) || [], b = h ? j == null ? void 0 : j[0] : j == null ? void 0 : j.join(", "), N = () => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("label", { className: On.label, children: o }),
      /* @__PURE__ */ i.jsx(
        Ko,
        {
          name: e,
          id: e,
          styles: {
            wrapper: { width: "100%" },
            error: { display: "inline-block !important" }
          },
          onFocus: () => _({ type: "open" }),
          value: y || u,
          error: b,
          readOnly: !0,
          placeholder: s,
          className: d ? On.disableStyle : On.enableStyle,
          ref: m
        }
      )
    ] });
    return /* @__PURE__ */ i.jsxs(oa, { position: c, opened: v.open, onClose: () => _({ type: "close" }), children: [
      /* @__PURE__ */ i.jsx(oa.Target, { children: /* @__PURE__ */ i.jsx(T, { children: /* @__PURE__ */ i.jsx(
        T.Col,
        {
          span: { base: 12 },
          className: R(y === "" ? On.default : On.root, On.wrapper),
          children: /* @__PURE__ */ i.jsx(N, {})
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(oa.Dropdown, { id: "month-picker", "aria-controls": "", children: /* @__PURE__ */ i.jsxs(qp, { className: On.stack, children: [
        /* @__PURE__ */ i.jsx(
          e$,
          {
            name: ji[v.level].getTitle(v.value),
            left: () => _({ type: "left" }),
            right: () => _({ type: "right" }),
            title: () => _({ type: "title" })
          }
        ),
        /* @__PURE__ */ i.jsx(
          t$,
          {
            close: () => _({ type: "close" }),
            onSelect: (C) => P(C),
            level: v.level,
            buttons: ji[v.level].getButtons(v.value),
            disabledBefore: p,
            disabledAfter: f
          }
        )
      ] }) })
    ] });
  }
), oR = oe.memo(i$), o$ = "_root_1pmpp_1", a$ = "_singleCheckbox_1pmpp_15", l$ = "_singleCheckboxRB_1pmpp_37", d$ = "_singleCheckboxRB_1pmpp_37", c$ = "_body_1pmpp_57", u$ = "_labelWrapper_1pmpp_63", h$ = "_label_1pmpp_63", f$ = "_inner_1pmpp_80", p$ = "_icon_1pmpp_84", Js = {
  root: o$,
  singleCheckbox: a$,
  singleCheckboxRB: l$,
  singleCheckboxRb: d$,
  body: c$,
  labelWrapper: u$,
  label: h$,
  inner: f$,
  icon: p$
}, aR = ({
  id: e,
  size: t,
  getOptions: n = () => [],
  defaultValue: s,
  error: r,
  RB: o,
  setStandardisedValue: a,
  setLanguageValue: l
}) => {
  const [d, c] = O([]), [u, h] = O(s || []);
  ne(() => {
    c(n());
  }, []);
  const p = (f) => {
    h((m) => {
      let g = [...m];
      const v = m.indexOf(f.target.value);
      return f.target.checked ? f.target.value === "haventTaken" || f.target.value === "waived" ? (g = [f.target.value], e === "standardizedTest" ? a == null || a(g) : e === "languageTest" && (l == null || l(g))) : (v === -1 ? g.push(f.target.value) : (g.push(f.target.value), e === "standardizedTest" ? a == null || a(g) : e === "languageTest" && (l == null || l(g))), g = g.filter((_) => !["haventTaken", "waived"].includes(_))) : v > -1 && g.splice(v, 1), g;
    });
  };
  return /* @__PURE__ */ i.jsx(
    $r.Group,
    {
      value: u,
      classNames: Js,
      "data-testid": e,
      id: e,
      size: t,
      error: ((r == null ? void 0 : r.fieldErrors[e]) || []).join(", "),
      children: d.map((f, m) => /* @__PURE__ */ i.jsx(
        $r,
        {
          onClick: p,
          value: f.id,
          label: f.label,
          name: e,
          classNames: {
            label: Js.label,
            labelWrapper: Js.labelWrapper,
            body: Js.body,
            icon: Js.icon
          },
          className: o ? Js.singleCheckboxRB : Js.singleCheckbox
        },
        m
      ))
    }
  );
}, k = "u" > typeof window ? window : void 0, en = "u" > typeof globalThis ? globalThis : k, At = en == null ? void 0 : en.navigator, A = en == null ? void 0 : en.document, ut = en == null ? void 0 : en.location, Bi = en == null ? void 0 : en.fetch, ad = en != null && en.XMLHttpRequest && "withCredentials" in new en.XMLHttpRequest() ? en.XMLHttpRequest : void 0, gc = en == null ? void 0 : en.AbortController, _$ = en == null ? void 0 : en.CompressionStream, rn = At == null ? void 0 : At.userAgent;
function _h() {
  return !(!k || k.navigator.onLine === !1);
}
const ai = typeof globalThis < "u" ? globalThis : k;
ai && typeof self > "u" && (ai.self = ai), ai && typeof File > "u" && (ai.File = function() {
});
const se = k ?? {}, vc = "0.8.2", xs = { DEBUG: !1, LIB_VERSION: vc, LIB_NAME: "browser-common", JS_SDK_VERSION: vc };
var Qn = function(e) {
  return e.AnonymousId = "anonymous_id", e.DistinctId = "distinct_id", e.Props = "props", e.EnablePersonProcessing = "enable_person_processing", e.PersonMode = "person_mode", e.FeatureFlagDetails = "feature_flag_details", e.FeatureFlags = "feature_flags", e.FeatureFlagPayloads = "feature_flag_payloads", e.BootstrapFeatureFlagDetails = "bootstrap_feature_flag_details", e.BootstrapFeatureFlags = "bootstrap_feature_flags", e.BootstrapFeatureFlagPayloads = "bootstrap_feature_flag_payloads", e.OverrideFeatureFlags = "override_feature_flags", e.Queue = "queue", e.AiQueue = "ai_queue", e.AiCaptureQueue = "ai_capture_queue", e.LogsQueue = "logs_queue", e.OptedOut = "opted_out", e.SessionId = "session_id", e.SessionStartTimestamp = "session_start_timestamp", e.SessionLastTimestamp = "session_timestamp", e.PersonProperties = "person_properties", e.GroupProperties = "group_properties", e.InstalledAppBuild = "installed_app_build", e.InstalledAppVersion = "installed_app_version", e.SessionReplay = "session_replay", e.PushRegistered = "push_registered", e.SessionReplayEventTriggerActivatedSession = "session_replay_event_trigger_activated_session", e.SurveyLastSeenDate = "survey_last_seen_date", e.SurveysSeen = "surveys_seen", e.Surveys = "surveys", e.RemoteConfig = "remote_config", e.FlagsEndpointWasHit = "flags_endpoint_was_hit", e.DeviceId = "device_id", e;
}({}), fl = function(e) {
  return e.GZipJS = "gzip-js", e.Base64 = "base64", e;
}({});
const m$ = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"], g$ = ["token"];
function de(e, t) {
  return e.indexOf(t) !== -1;
}
const Qo = function(e) {
  return e.trim();
}, pl = function(e) {
  return e.replace(/^\$/, "");
};
function mh(e) {
  var t;
  const n = [];
  return (t = JSON.stringify(e, function(s, r) {
    if (typeof r == "bigint") return r.toString();
    if (typeof r != "function" && typeof r != "symbol") {
      if (r instanceof Error) return { name: r.name, message: r.message, stack: r.stack };
      if (r && typeof r == "object") {
        for (; n.length > 0 && n[n.length - 1] !== this; ) n.pop();
        if (n.includes(r)) return "[Circular]";
        n.push(r);
      }
      return r;
    }
  })) !== null && t !== void 0 ? t : "null";
}
const gh = Object.prototype, ld = gh.hasOwnProperty, ea = gh.toString, ae = Array.isArray || function(e) {
  return ea.call(e) === "[object Array]";
}, Yt = (e) => typeof e == "function", xe = (e) => e === Object(e) && !ae(e), mn = (e) => {
  if (xe(e)) {
    for (const t in e) if (ld.call(e, t)) return !1;
    return !0;
  }
  return !1;
}, L = (e) => e === void 0, ye = (e) => ea.call(e) == "[object String]", Ni = (e) => ye(e) && e.trim().length === 0, gt = (e) => e === null, _e = (e) => L(e) || gt(e), bt = (e) => ea.call(e) == "[object Number]" && e == e, ps = (e) => bt(e) && e > 0, ln = (e) => ea.call(e) === "[object Boolean]", v$ = (e) => de(m$, e), $$ = (e) => de(g$, e);
function vh(e) {
  return e === null || typeof e != "object";
}
function Io(e, t) {
  return {}.toString.call(e) === `[object ${t}]`;
}
function Ji(e) {
  switch ({}.toString.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object DOMError]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return $h(e, Error);
  }
}
function dd(e) {
  return "u" > typeof Event && $h(e, Event);
}
function $h(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
const b$ = [!0, "true", 1, "1", "yes"], va = (e) => de(b$, e), x$ = [!1, "false", 0, "0", "no"];
function $c(e, t, n, s, r, o, a) {
  try {
    var l = e[o](a), d = l.value;
  } catch (c) {
    return void n(c);
  }
  l.done ? t(d) : Promise.resolve(d).then(s, r);
}
function Qe(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(s, r) {
      var o = e.apply(t, n);
      function a(d) {
        $c(o, s, r, a, l, "next", d);
      }
      function l(d) {
        $c(o, s, r, a, l, "throw", d);
      }
      a(void 0);
    });
  };
}
const y$ = ["amazonbot", "amazonproductbot", "app.hypefactors.com", "applebot", "archive.org_bot", "awariobot", "backlinksextendedbot", "baiduspider", "bingbot", "bingpreview", "chrome-lighthouse", "dataforseobot", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "http://yandex.com/bots", "hubspot", "ia_archiver", "leikibot", "linkedinbot", "meta-externalagent", "mj12bot", "msnbot", "nessus", "petalbot", "pinterestbot", "prerender", "rogerbot", "screaming frog", "sebot-wa", "sitebulb", "slackbot", "slurp", "trendictionbot", "turnitin", "twitterbot", "vercel-screenshot", "vercelbot", "yahoo! slurp", "yandexbot", "zoombot", "bot.htm", "bot.php", "(bot;", "bot/", "crawler", "ahrefsbot", "ahrefssiteaudit", "semrushbot", "siteauditbot", "splitsignalbot", "gptbot", "oai-searchbot", "chatgpt-user", "perplexitybot", "better uptime bot", "sentryuptimebot", "uptimerobot", "headlesschrome", "cypress", "google-hoteladsverifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleother", "google-cloudvertexbot", "googleweblight", "mediapartners-google", "storebot-google", "google-inspectiontool", "bytespider"], bc = function(e, t = []) {
  if (!e) return !1;
  const n = e.toLowerCase();
  return y$.concat(t).some((s) => {
    const r = s.toLowerCase();
    return n.indexOf(r) !== -1;
  });
};
function es(e, t, n, s, r) {
  return t > n && (s.warn("min cannot be greater than max."), t = n), bt(e) ? e > n ? (s.warn(" cannot be  greater than max: " + n + ". Using max value instead."), n) : t > e ? (s.warn(" cannot be less than min: " + t + ". Using min value instead."), t) : e : (s.warn(" must be a number. using max or fallback. max: " + n + ", fallback: " + r), es(r ?? n, t, n, s));
}
var w$ = class {
  constructor(e) {
    this.C = {}, this.I = e.I, this.R = es(e.bucketSize, 0, 100, e.$), this.A = es(e.refillRate, 0, this.R, e.$), this.O = es(e.refillInterval, 0, 864e5, e.$);
  }
  F(e, t) {
    const n = Math.floor((t - e.lastAccess) / this.O);
    n > 0 && (e.tokens = Math.min(e.tokens + n * this.A, this.R), e.lastAccess = e.lastAccess + n * this.O);
  }
  consumeRateLimit(e) {
    var t;
    const n = Date.now(), s = String(e);
    let r = this.C[s];
    return r ? this.F(r, n) : (r = { tokens: this.R, lastAccess: n }, this.C[s] = r), r.tokens === 0 || (r.tokens--, r.tokens === 0 && ((t = this.I) === null || t === void 0 || t.call(this, e)), r.tokens === 0);
  }
  stop() {
    this.C = {};
  }
};
const Gr = "Mobile", Wi = "Android", Po = "Tablet", bh = "Android Tablet", xh = "iPad", yh = "Apple Watch", xo = "Safari", ta = "BlackBerry", wh = "Samsung Internet", yo = "Chrome", Ch = "Chrome iOS", jh = "Internet Explorer", Nh = "Internet Explorer Mobile", Sh = "Opera", kh = "Microsoft Edge", wo = "Firefox", Eh = "Firefox iOS", To = "Nintendo", Ro = "PlayStation", na = "Xbox", Ih = "Android Mobile", Ph = "Mobile Safari", $a = "Windows", Th = "Windows Phone", xc = "Nokia", _l = "Ouya", C$ = "Generic " + Gr.toLowerCase(), Rh = "Generic " + Po.toLowerCase(), ml = "Konqueror", Lh = "Oculus Browser", Oh = "Vivaldi", Fh = "Yandex", Ah = "Whale", Mh = "DuckDuckGo", Dh = "Pale Moon", Bh = "Waterfox", gl = "Brave", Wh = "Claude", Uh = "Codex", zh = "ChatGPT", Hh = "Google Search App", ba = new RegExp("Version/(\\d+(\\.\\d+)?)"), xa = new RegExp("(Claude|Codex|ChatGPT)\\/(\\d+(\\.\\d+)?)"), j$ = new RegExp(na, "i"), N$ = new RegExp("PlayStation \\w+", "i"), S$ = new RegExp("Nintendo \\w+", "i"), cd = new RegExp("BlackBerry|PlayBook|BB10", "i"), k$ = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, qh = function(e, t, n, s) {
  return t = t || "", function(o) {
    return o != null && o.brave ? gl : null;
  }(n) || (s != null && s.detectGoogleSearchApp && de(e, "GSA/") ? Hh : de(e, " OPR/") && de(e, "Mini") ? "Opera Mini" : de(e, " OPR/") ? Sh : cd.test(e) ? ta : de(e, "IEMobile") || de(e, "WPDesktop") ? Nh : de(e, "OculusBrowser") ? Lh : de(e, "SamsungBrowser") ? wh : de(e, "Edge") || de(e, "Edg/") ? kh : de(e, "Vivaldi/") ? Oh : de(e, "YaBrowser/") ? Fh : de(e, "Whale/") ? Ah : de(e, "DuckDuckGo/") || de(e, "Ddg/") ? Mh : de(e, "Claude/") ? Wh : de(e, "Codex/") ? Uh : de(e, "ChatGPT/") ? zh : de(e, "FBIOS") ? "Facebook Mobile" : de(e, "UCWEB") || de(e, "UCBrowser") ? "UC Browser" : de(e, "CriOS") ? Ch : de(e, "CrMo") || de(e, yo) ? yo : de(e, Wi) && de(e, xo) ? Ih : de(e, "FxiOS") ? Eh : de(e.toLowerCase(), ml.toLowerCase()) ? ml : de(e, "Brave/") ? gl : ((o, a) => a && de(a, "Apple") || function(l) {
    return de(l, xo) && !de(l, yo) && !de(l, Wi);
  }(o))(e, t) ? de(e, Gr) ? Ph : xo : de(e, "PaleMoon/") ? Dh : de(e, "Waterfox/") ? Bh : de(e, wo) ? wo : de(e, "MSIE") || de(e, "Trident/") ? jh : de(e, "Gecko") ? wo : "");
}, E$ = { [Nh]: [new RegExp("rv:(\\d+(\\.\\d+)?)")], [kh]: [new RegExp("Edge?\\/(\\d+(\\.\\d+)?)")], [yo]: [new RegExp("(Chrome|CrMo)\\/(\\d+(\\.\\d+)?)")], [Ch]: [new RegExp("CriOS\\/(\\d+(\\.\\d+)?)")], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/(\\d+(\\.\\d+)?)")], [xo]: [ba], [Ph]: [ba], [Sh]: [new RegExp("(Opera|OPR)\\/(\\d+(\\.\\d+)?)")], [wo]: [new RegExp("Firefox\\/(\\d+(\\.\\d+)?)")], [Eh]: [new RegExp("FxiOS\\/(\\d+(\\.\\d+)?)")], [ml]: [new RegExp("Konqueror[:/]?(\\d+(\\.\\d+)?)", "i")], [ta]: [new RegExp("BlackBerry (\\d+(\\.\\d+)?)"), ba], [Ih]: [new RegExp("android\\s(\\d+(\\.\\d+)?)", "i")], [wh]: [new RegExp("SamsungBrowser\\/(\\d+(\\.\\d+)?)")], [Lh]: [new RegExp("OculusBrowser\\/(\\d+(\\.\\d+)?)")], [Oh]: [new RegExp("Vivaldi\\/(\\d+(\\.\\d+)?)")], [Fh]: [new RegExp("YaBrowser\\/(\\d+(\\.\\d+)?)")], [Ah]: [new RegExp("Whale\\/(\\d+(\\.\\d+)?)")], [gl]: [new RegExp("Brave\\/(\\d+(\\.\\d+)?)")], [Wh]: [xa], [Uh]: [xa], [zh]: [xa], [Mh]: [new RegExp("(DuckDuckGo|Ddg)\\/(\\d+(\\.\\d+)?)")], [Dh]: [new RegExp("PaleMoon\\/(\\d+(\\.\\d+)?)")], [Bh]: [new RegExp("Waterfox\\/(\\d+(\\.\\d+)?)")], [Hh]: [new RegExp("GSA\\/(\\d+(\\.\\d+)?)")], [jh]: [new RegExp("(rv:|MSIE )(\\d+(\\.\\d+)?)")], Mozilla: [new RegExp("rv:(\\d+(\\.\\d+)?)")] }, I$ = function(e, t, n, s) {
  const r = qh(e, t, n, s), o = E$[r];
  if (L(o)) return null;
  for (let a = 0; o.length > a; a++) {
    const l = e.match(o[a]);
    if (l) return parseFloat(l[l.length - 2]);
  }
  return null;
}, yc = [[new RegExp("Xbox; Xbox (.*?)[);]", "i"), (e) => [na, e && e[1] || ""]], [new RegExp(To, "i"), [To, ""]], [new RegExp(Ro, "i"), [Ro, ""]], [cd, [ta, ""]], [new RegExp($a, "i"), (e, t) => {
  if (/Phone/.test(t) || /WPDesktop/.test(t)) return [Th, ""];
  if (new RegExp(Gr).test(t) && !/IEMobile\b/.test(t)) return ["Windows Mobile", ""];
  const n = /Windows NT ([0-9.]+)/i.exec(t);
  if (n && n[1]) {
    let s = k$[n[1]] || "";
    return /arm/i.test(t) && (s = "RT"), [$a, s];
  }
  return [$a, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (e) => e && e[3] ? ["iOS", [e[3], e[4], e[5] || "0"].join(".")] : ["iOS", ""]], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (e) => {
  let t = "";
  return e && e.length >= 3 && (t = L(e[2]) ? e[3] : e[2]), ["watchOS", t];
}], [new RegExp("(Android (\\d+)\\.(\\d+)\\.?(\\d+)?|Android)", "i"), (e) => e && e[2] ? [Wi, [e[2], e[3], e[4] || "0"].join(".")] : [Wi, ""]], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (e) => {
  const t = ["Mac OS X", ""];
  return e && e[1] && (t[1] = [e[1], e[2], e[3] || "0"].join(".")), t;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, ["Chrome OS", ""]], [/Linux|debian/i, ["Linux", ""]]], Gh = function(e) {
  for (let t = 0; yc.length > t; t++) {
    const [n, s] = yc[t], r = n.exec(e), o = r && (Yt(s) ? s(r, e) : s);
    if (o) return o;
  }
  return ["", ""];
}, Vh = function(e) {
  return S$.test(e) ? To : N$.test(e) ? Ro : j$.test(e) ? na : new RegExp(_l, "i").test(e) ? _l : new RegExp("(Windows Phone|WPDesktop)", "i").test(e) ? Th : /iPad/.test(e) ? xh : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? yh : cd.test(e) ? ta : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp(xc, "i").test(e) ? xc : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? new RegExp(Gr).test(e) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) || /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? Wi : bh : new RegExp("(pda|Mobile)", "i").test(e) ? C$ : new RegExp(Po, "i").test(e) && !new RegExp("Tablet pc", "i").test(e) ? Rh : "";
}, P$ = function(e, t) {
  var n;
  const s = Vh(e);
  return s === xh || s === bh || s === "Kobo" || s === "Kindle Fire" || s === Rh ? Po : s === To || s === na || s === Ro || s === _l ? "Console" : s === yh ? "Wearable" : s ? Gr : (t == null ? void 0 : t.userAgentDataPlatform) === "Android" && ((n = t == null ? void 0 : t.maxTouchPoints) !== null && n !== void 0 ? n : 0) > 0 ? 600 > Math.min((r = t == null ? void 0 : t.screenWidth) !== null && r !== void 0 ? r : 0, (o = t == null ? void 0 : t.screenHeight) !== null && o !== void 0 ? o : 0) / ((a = t == null ? void 0 : t.devicePixelRatio) !== null && a !== void 0 ? a : 1) ? Gr : Po : "Desktop";
  var r, o, a;
}, ya = /\bFBAV\/(\d+(?:\.\d+)*)/i, wc = [[/\bInstagram(?:[ /](\d+(?:\.\d+)*))?\b/i, "Instagram"], [/\bBarcelona[ /](\d+(?:\.\d+)*)?/i, "Threads"], [/\b(?:MessengerForiOS|(?:FBAN|FB_IAB)\/Orca-Android)\b/i, "Messenger", ya], [/\bFBAN\/EMA\b/i, "Facebook Lite", ya], [/\b(?:FBIOS|(?:FBAN|FB_IAB)\/(?:FB4A|FBIOS))\b/i, "Facebook", ya], [/\bLinkedInApp(?:\]?\/(\d+(?:\.\d+)*))?\b/i, "LinkedIn"], [/\bTwitter(?:Android| for (?:iPhone|iPad|Android))(?:\/(\d+(?:\.\d+)*))?\b/i, "Twitter"], [/\b(?:musical_ly|trill)(?:[_/](\d+\.\d+(?:\.\d+)*))?(?=\b|_)/i, "TikTok", /\bapp_version\/(\d+(?:\.\d+)*)/i], [/\b(?:MicroMessenger|WeChat)\/(\d+(?:\.\d+)*)?/i, "WeChat"], [/\bLine\/(\d+(?:\.\d+)*)?/i, "Line"], [/\bGSA\/(\d+(?:\.\d+)*)?/i, "Google"], [/\[Pinterest\/(?:iOS|Android)\b|\bPinterest(?: for (?:Android(?: Tablet)?|iOS))?\/(\d+(?:\.\d+)*)/i, "Pinterest"], [/\b(?:WA4A|WAiOS)\/(\d+(?:\.\d+)*)?/i, "WhatsApp"], [/\bSnapchat[ /](\d+(?:\.\d+)*)?/i, "Snapchat"], [/\bBing(?:Web|Sapphire)\/(\d+(?:\.\d+)*)?/i, "Bing"], [/\bNAVER\(inapp; search;/i, "Naver", /\bNAVER\(inapp; search;[^;)]*; (\d+(?:\.\d+)*)/i], [/\bKAKAOTALK[ /](\d+\.\d+(?:\.\d+)*)?/i, "KakaoTalk"]], vl = "[Truncated]", sa = "[Unserializable]";
function Ur(e) {
  let t = "";
  for (let n = 0; e.length > n; n++) {
    const s = e.charCodeAt(n);
    if (55296 > s || s > 56319) t += 56320 > s || s > 57343 ? e[n] : "�";
    else {
      const r = e.charCodeAt(n + 1);
      56320 > r || r > 57343 ? t += "�" : (t += e[n] + e[n + 1], n++);
    }
  }
  return t;
}
const T$ = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function Cc(e, t) {
  return typeof (n = e) == "string" && T$.test(n) ? e : t();
  var n;
}
function Yh(e, t) {
  const n = new Error(t);
  try {
    Object.defineProperty(n, "name", { value: e, writable: !0, enumerable: !0, configurable: !0 });
  } catch {
  }
  return n;
}
function zs(e) {
  return e && e.split("#")[0];
}
function ud(e, t) {
  const n = setTimeout(e, t);
  return n != null && n.unref && (n == null || n.unref()), n;
}
function jc(e, t, n) {
  return Kh.apply(this, arguments);
}
function Kh() {
  return (Kh = Qe(function* (e, t, n) {
    let s;
    try {
      return yield Promise.race([e, new Promise((r, o) => {
        s = ud(() => {
          try {
            n == null || n(), r();
          } catch (a) {
            o(a);
          }
        }, t);
      })]);
    } finally {
      clearTimeout(s);
    }
  })).apply(this, arguments);
}
let no, Nc, wa;
function R$(e) {
  const t = globalThis._posthogChunkIds;
  if (!t) return;
  const n = Object.keys(t);
  return wa && n.length === Nc || (Nc = n.length, wa = n.reduce((s, r) => {
    no || (no = {});
    const o = no[r];
    if (o) s[o[0]] = o[1];
    else {
      const a = e(r);
      for (let l = a.length - 1; l >= 0; l--) {
        const d = a[l], c = d == null ? void 0 : d.filename, u = t[r];
        if (c && u) {
          s[c] = u, no[r] = [c, u];
          break;
        }
      }
    }
    return s;
  }, {})), wa;
}
function Si(e) {
  return Si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Si(e);
}
function L$(e, t, n) {
  return (t = function(s) {
    var r = function(o) {
      if (Si(o) != "object" || !o) return o;
      var a = o[Symbol.toPrimitive];
      if (a !== void 0) {
        var l = a.call(o, "string");
        if (Si(l) != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(o);
    }(s);
    return Si(r) == "symbol" ? r : r + "";
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Sc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, s);
  }
  return n;
}
function x(e) {
  for (var t = 1; arguments.length > t; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sc(Object(n), !0).forEach(function(s) {
      L$(e, s, n[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sc(Object(n)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(n, s));
    });
  }
  return e;
}
var O$ = class {
  constructor(e, t, n = []) {
    this.coercers = e, this.stackParser = t, this.modifiers = n;
  }
  buildFromUnknown(e, t = {}) {
    const n = t && t.mechanism || { handled: !0, type: "generic" }, s = this.buildCoercingContext(n, t, 0).apply(e), r = this.buildParsingContext(t), o = this.parseStacktrace(s, r);
    return { $exception_list: this.convertToExceptionList(o, n), $exception_level: "error" };
  }
  modifyFrames(e) {
    var t = this;
    return Qe(function* () {
      for (const n of e) n.stacktrace && n.stacktrace.frames && ae(n.stacktrace.frames) && (n.stacktrace.frames = yield t.applyModifiers(n.stacktrace.frames));
      return e;
    })();
  }
  coerceFallback(e) {
    var t;
    return { type: "Error", value: "Unknown error", stack: (t = e.syntheticException) === null || t === void 0 ? void 0 : t.stack, synthetic: !0 };
  }
  parseStacktrace(e, t) {
    let n, s;
    return e.cause != null && (n = this.parseStacktrace(e.cause, t)), e.stack != "" && e.stack != null && (s = this.applyChunkIds(this.stackParser(e.stack, e.synthetic ? t.skipFirstLines : 0), t.chunkIdMap)), x(x({}, e), {}, { cause: n, stack: s });
  }
  applyChunkIds(e, t) {
    return e.map((n) => (n.filename && t && (n.chunk_id = t[n.filename]), n));
  }
  applyCoercers(e, t) {
    for (const n of this.coercers) if (n.match(e)) return n.coerce(e, t);
    return this.coerceFallback(t);
  }
  applyModifiers(e) {
    var t = this;
    return Qe(function* () {
      let n = e;
      for (const s of t.modifiers) n = yield s(n);
      return n;
    })();
  }
  convertToExceptionList(e, t) {
    var n, s, r;
    const o = { type: e.type, value: e.value, mechanism: { type: (n = t.type) !== null && n !== void 0 ? n : "generic", handled: (s = t.handled) === null || s === void 0 || s, synthetic: (r = e.synthetic) !== null && r !== void 0 && r } };
    e.stack && (o.stacktrace = { type: "raw", frames: e.stack });
    const a = [o];
    return e.cause != null && a.push(...this.convertToExceptionList(e.cause, x(x({}, t), {}, { handled: !0 }))), a;
  }
  buildParsingContext(e) {
    var t;
    return { chunkIdMap: R$(this.stackParser), skipFirstLines: (t = e.skipFirstLines) !== null && t !== void 0 ? t : 1 };
  }
  buildCoercingContext(e, t, n = 0) {
    const s = (r, o) => {
      if (4 >= o) {
        const a = this.buildCoercingContext(e, t, o);
        return this.applyCoercers(r, a);
      }
    };
    return x(x({}, t), {}, { syntheticException: n == 0 ? t.syntheticException : void 0, mechanism: e, apply: (r) => s(r, n), next: (r) => s(r, n + 1) });
  }
};
function $l(e, t, n, s, r) {
  const o = { platform: e, filename: t, function: n === "<anonymous>" ? "?" : n, in_app: !!t && !t.startsWith("webkit-masked-url://") && t !== "<anonymous>" };
  return L(s) || (o.lineno = s), L(r) || (o.colno = r), o;
}
const Jh = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, s = e.indexOf("safari-web-extension") !== -1;
  return n || s ? [e.indexOf("@") !== -1 ? e.split("@")[0] : "?", n ? `safari-extension:${t}` : `safari-web-extension:${t}`] : [e, t];
}, F$ = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, A$ = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, M$ = /\((\S*)(?::(\d+))(?::(\d+))\)/, D$ = (e, t) => {
  const n = F$.exec(e);
  if (n) {
    const [, r, o, a] = n;
    return $l(t, r, "?", +o, +a);
  }
  const s = A$.exec(e);
  if (s) {
    if (s[2] && s[2].indexOf("eval") === 0) {
      const a = M$.exec(s[2]);
      a && (s[2] = a[1], s[3] = a[2], s[4] = a[3]);
    }
    const [r, o] = Jh(s[1] || "?", s[2]);
    return $l(t, o, r, s[3] ? +s[3] : void 0, s[4] ? +s[4] : void 0);
  }
}, B$ = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, W$ = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, U$ = (e, t) => {
  const n = B$.exec(e);
  if (n) {
    if (n[3] && n[3].indexOf(" > eval") > -1) {
      const o = W$.exec(n[3]);
      o && (n[1] = n[1] || "eval", n[3] = o[1], n[4] = o[2], n[5] = "");
    }
    let s = n[3], r = n[1] || "?";
    return [r, s] = Jh(r, s), $l(t, s, r, n[4] ? +n[4] : void 0, n[5] ? +n[5] : void 0);
  }
}, kc = /\(error: (.*)\)/;
function hd(e, t) {
  return e.filename === t.filename && e.function === t.function && e.module === t.module && e.lineno === t.lineno && e.colno === t.colno;
}
function z$(e) {
  for (let t = 1; 10 >= t; t++) {
    const n = e.length - 2 * t;
    if (0 > n) break;
    let s = !0;
    for (let r = 0; t > r; r++) if (!hd(e[n + r], e[n + t + r])) {
      s = !1;
      break;
    }
    if (s) {
      for (let r = 0; t > r; r++) e[n + r] = e[n + t + r];
      return e.length = n + t, { start: n, length: t };
    }
  }
}
function H$(e, t) {
  const n = t.start + t.length, s = Xh(e, t);
  s && e.splice(n + s === e.length ? n : t.start, s);
}
function Zh(e, t) {
  let n = t.start;
  for (; n > 0 && hd(e[n - 1], e[n - 1 + t.length]); ) n--;
  return t.start - n;
}
function Xh(e, t) {
  const n = t.start + t.length;
  let s = n;
  for (; e.length > s && hd(e[s], e[s - t.length]); ) s++;
  return s - n;
}
function q$(e, t) {
  const n = t[0];
  let s = e.length - (n ? Zh(e, n) : 0);
  for (const r of t) s -= Xh(e, r);
  return s;
}
function G$(e, t, n) {
  for (let s = 0; e.length > s; s++) {
    const r = e[(t + s) % e.length], o = e[(n + s) % e.length];
    if (r !== o) return o > r;
  }
  return !1;
}
var V$ = class {
  match(e) {
    return this.isDOMException(e) || this.isDOMError(e);
  }
  coerce(e, t) {
    const n = ye(e.stack);
    return { type: this.getType(e), value: this.getValue(e), stack: n ? e.stack : void 0, cause: e.cause ? t.next(e.cause) : void 0, synthetic: !1 };
  }
  getType(e) {
    return this.isDOMError(e) ? "DOMError" : "DOMException";
  }
  getValue(e) {
    const t = e.name || (this.isDOMError(e) ? "DOMError" : "DOMException");
    return e.message ? `${t}: ${e.message}` : t;
  }
  isDOMException(e) {
    return Io(e, "DOMException");
  }
  isDOMError(e) {
    return Io(e, "DOMError");
  }
}, Y$ = class {
  match(e) {
    return Ji(e);
  }
  coerce(e, t) {
    var n;
    const s = this.getStack(e), r = s === void 0;
    return { type: this.getType(e), value: this.getMessage(e, t), stack: s ?? ((n = t.syntheticException) === null || n === void 0 ? void 0 : n.stack), cause: e.cause ? t.next(e.cause) : void 0, synthetic: r };
  }
  getType(e) {
    return e.name || e.constructor.name;
  }
  getMessage(e, t) {
    const n = e.message;
    return String(n.error && typeof n.error.message == "string" ? n.error.message : n);
  }
  getStack(e) {
    return e.stacktrace || e.stack || void 0;
  }
}, K$ = class {
  match(e) {
    return !!Io(e, "ErrorEvent") && (e.error != null || this.sr(e));
  }
  coerce(e, t) {
    var n;
    if (e.error != null) return t.apply(e.error);
    const s = t.apply(e.message);
    return x(x({}, s), {}, { stack: (n = this.ar(e)) !== null && n !== void 0 ? n : s.stack, synthetic: !0 });
  }
  sr(e) {
    return ye(e.message) && e.message.length > 0;
  }
  ar(e) {
    var t, n;
    const s = e, r = (t = s.lineno) !== null && t !== void 0 ? t : 0, o = (n = s.colno) !== null && n !== void 0 ? n : 0;
    if (ye(s.filename) && s.filename.length !== 0 && r !== 0) return `Error
    at ${s.filename}:${r}:${o}`;
  }
};
const J$ = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
var Z$ = class {
  match(e) {
    return typeof e == "string";
  }
  coerce(e, t) {
    var n;
    const [s, r] = this.getInfos(e);
    return { type: s ?? "Error", value: r ?? e, stack: (n = t.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
  getInfos(e) {
    let t = "Error", n = e;
    const s = e.match(J$);
    return s && (t = s[1], n = s[2]), [t, n];
  }
};
const X$ = ["fatal", "error", "warning", "log", "info", "debug"];
function Qh(e, t = 40) {
  const n = Object.keys(e);
  if (n.sort(), !n.length) return "[object has no keys]";
  for (let s = n.length; s > 0; s--) {
    const r = n.slice(0, s).join(", ");
    if (t >= r.length) return s === n.length ? r : r.length > t ? `${r.slice(0, t)}...` : r;
  }
  return "";
}
var Q$ = class {
  match(e) {
    return typeof e == "object" && e !== null;
  }
  coerce(e, t) {
    var n, s;
    const r = this.getErrorPropertyFromObject(e);
    return r ? t.apply(r) : { type: this.getType(e), value: this.getValue(e), stack: (n = this.getStack(e)) !== null && n !== void 0 ? n : (s = t.syntheticException) === null || s === void 0 ? void 0 : s.stack, level: this.isSeverityLevel(e.level) ? e.level : "error", synthetic: !0 };
  }
  getType(e) {
    if (dd(e)) return e.constructor.name;
    const t = "name" in e ? e.name : void 0;
    return ye(t) && !Ni(t) ? t : "Error";
  }
  getValue(e) {
    if ("name" in e && typeof e.name == "string") {
      let n = `'${e.name}' captured as exception`;
      return "message" in e && typeof e.message == "string" && (n += ` with message: '${e.message}'`), n;
    }
    if ("message" in e && typeof e.message == "string") return e.message;
    const t = this.getObjectClassName(e);
    return `${t && t !== "Object" ? `'${t}'` : "Object"} captured as exception with keys: ${Qh(e)}`;
  }
  isSeverityLevel(e) {
    return ye(e) && !Ni(e) && X$.indexOf(e) >= 0;
  }
  getStack(e) {
    try {
      return ye(e.stacktrace) && e.stacktrace.length > 0 ? e.stacktrace : ye(e.stack) && e.stack.length > 0 ? e.stack : void 0;
    } catch {
      return;
    }
  }
  getErrorPropertyFromObject(e) {
    for (const t in e) if ({}.hasOwnProperty.call(e, t)) {
      const n = e[t];
      if (Ji(n)) return n;
    }
  }
  getObjectClassName(e) {
    try {
      const t = Object.getPrototypeOf(e);
      return t ? t.constructor.name : void 0;
    } catch {
      return;
    }
  }
}, eb = class {
  match(e) {
    return dd(e);
  }
  coerce(e, t) {
    var n;
    const s = e.constructor.name;
    return { type: s, value: `${s} captured as exception with keys: ${Qh(e)}`, stack: (n = t.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
}, tb = class {
  match(e) {
    return vh(e);
  }
  coerce(e, t) {
    var n;
    return { type: "Error", value: `Primitive value captured as exception: ${String(e)}`, stack: (n = t.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
}, nb = class {
  match(e) {
    return Io(e, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(e);
  }
  isCustomEventWrappingRejection(e) {
    if (!dd(e)) return !1;
    try {
      const t = e.detail;
      return t != null && typeof t == "object" && "reason" in t;
    } catch {
      return !1;
    }
  }
  coerce(e, t) {
    var n;
    const s = this.getUnhandledRejectionReason(e);
    return vh(s) ? { type: "UnhandledRejection", value: `Non-Error promise rejection captured with value: ${String(s)}`, stack: (n = t.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 } : t.apply(s);
  }
  getUnhandledRejectionReason(e) {
    try {
      if ("reason" in e) return e.reason;
      if ("detail" in e && e.detail != null && typeof e.detail == "object" && "reason" in e.detail) return e.detail.reason;
    } catch {
    }
    return e;
  }
};
const Lo = "$message", Oo = "$timestamp", sb = /* @__PURE__ */ new Set([Lo, Oo]), Ca = { enabled: !0, max_bytes: 32768 };
function Fo(e) {
  var t;
  return e ? { enabled: (t = e.enabled) !== null && t !== void 0 ? t : Ca.enabled, max_bytes: ib(e.max_bytes, Ca.max_bytes) } : x({}, Ca);
}
var rb = class {
  constructor(e) {
    this.ts = [], this.es = 0, this.Sr = Fo(e);
  }
  setConfig(e) {
    this.Sr = Fo(e), this.ns();
  }
  add(e) {
    const t = function(s) {
      let r;
      try {
        r = mh(s);
      } catch {
        return;
      }
      try {
        const o = JSON.parse(r);
        if (!xe(o)) return;
        const a = o, l = a[Lo], d = a[Oo];
        return !ye(l) || l.trim().length === 0 || !ye(d) && !bt(d) ? void 0 : { step: a, json: r };
      } catch {
        return;
      }
    }(e);
    if (!t) return;
    const n = function(s) {
      if ("u" > typeof TextEncoder) return new TextEncoder().encode(s).length;
      const r = encodeURIComponent(s);
      let o = 0;
      for (let a = 0; r.length > a; a++) r[a] === "%" ? (o += 1, a += 2) : o += 1;
      return o;
    }(t.json);
    n > this.Sr.max_bytes || (this.ts.push({ step: t.step, bytes: n }), this.es += n, this.ns());
  }
  getAttachable() {
    return this.ts.map((e) => e.step);
  }
  clear() {
    this.ts = [], this.es = 0;
  }
  size() {
    return this.ts.length;
  }
  ns() {
    for (; this.es > this.Sr.max_bytes && this.ts.length > 0; ) {
      const e = this.ts.shift();
      e && (this.es -= e.bytes);
    }
  }
};
function ib(e, t) {
  if (!bt(e) || e === 1 / 0 || e === -1 / 0) return t;
  const n = Math.floor(e);
  return 0 > n ? t : n;
}
const Ec = (e) => {
  if (typeof e != "string") return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
};
function Ic(e) {
  return typeof e == "string" || e;
}
function Pc(e) {
  return typeof e == "string" ? e : void 0;
}
const ob = ["$feature_flag", "$feature_flag_response", "$feature_flag_has_experiment", "$feature_flag_id", "$feature_flag_version", "$feature_flag_reason", "$feature_flag_request_id", "$feature_flag_evaluated_at", "$feature_flag_error", "locally_evaluated", "$groups", "$process_person_profile", "$geoip_disable", "$current_url", "$pathname", "$referring_domain", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid", "gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx", "$session_id", "$window_id", "$lib", "$lib_version", "$device_id", "$is_server"], ef = "NativeGzipValidationError", bl = (e) => e.length >= 2 && e[0] === 31 && e[1] === 139, Tc = (e, t) => e === fl.GZipJS || t === fl.GZipJS || t === "gzip", Rc = (e) => !(!e || typeof e != "object") && ("name" in e ? String(e.name) : "") === "NotReadableError";
let li;
const so = (e) => {
  throw Yh(ef, `Native gzip produced invalid output: ${e}`);
}, ab = (Lc = Qe(function* (e, t) {
  18 > e.size && so("too-short");
  const n = new Uint8Array(yield e.slice(0, 10).arrayBuffer());
  bl(n) && n[2] === 8 || so("invalid-header");
  const s = new DataView(yield e.slice(e.size - 8).arrayBuffer());
  s.getUint32(0, !0) !== ((o) => {
    const a = (() => {
      if (li) return li;
      li = [];
      for (let d = 0; 256 > d; d++) {
        let c = d;
        for (let u = 0; 8 > u; u++) c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
        li[d] = c >>> 0;
      }
      return li;
    })();
    let l = 4294967295;
    for (let d = 0; o.length > d; d++) l = a[255 & (l ^ o[d])] ^ l >>> 8;
    return (4294967295 ^ l) >>> 0;
  })(t) && so("invalid-crc");
  const r = t.length >>> 0;
  s.getUint32(4, !0) !== r && so("invalid-size");
}), function(e, t) {
  return Lc.apply(this, arguments);
});
var Lc;
function xl() {
  return xl = Qe(function* (e, t = !0, n) {
    try {
      const r = new TextEncoder().encode(e), o = new globalThis.CompressionStream("gzip"), a = o.writable.getWriter(), l = a.write(r).then(() => a.close()).catch((s = Qe(function* (u) {
        try {
          yield a.abort(u);
        } catch {
        }
        throw u;
      }), function(u) {
        return s.apply(this, arguments);
      })), d = new Response(o.readable).blob(), [c] = yield Promise.all([d, l]);
      return yield ab(c, r), c;
    } catch (r) {
      if (n != null && n.rethrow) throw r;
      return t && console.error("Failed to gzip compress data", r), null;
    }
    var s;
  }), xl.apply(this, arguments);
}
function tf(e, t) {
  if (e == null) return {};
  var n, s, r = function(a, l) {
    if (a == null) return {};
    var d = {};
    for (var c in a) if ({}.hasOwnProperty.call(a, c)) {
      if (l.includes(c)) continue;
      d[c] = a[c];
    }
    return d;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (s = 0; o.length > s; s++) t.includes(n = o[s]) || {}.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
const lb = {}.propertyIsEnumerable;
function Ao(e, t) {
  try {
    return nf(e, t, { ancestors: /* @__PURE__ */ new WeakSet(), remainingNodes: 1e4 }, 0);
  } catch {
    return [];
  }
}
function fd(e, t, n, s) {
  if (0 >= n.remainingNodes) return { stringValue: vl };
  if (n.remainingNodes--, ln(e)) return { boolValue: e };
  if (typeof e == "bigint") return function(r, o) {
    const a = r.toString(), l = BigInt("9223372036854775808");
    return r >= l || -l > r ? (o == null || o.debug(`Attribute ${a} is outside the int64 range; encoding it as a string`), { stringValue: a }) : { intValue: a };
  }(e, t);
  if (typeof e == "number") {
    if (!Number.isFinite(e)) return { stringValue: String(e) };
    if (Number.isInteger(e)) {
      if (Number.isSafeInteger(e)) return { intValue: String(e) };
      if (typeof BigInt > "u") return { stringValue: String(e) };
      const r = BigInt(e).toString();
      return e >= 9223372036854776e3 || -9223372036854776e3 > e ? (t == null || t.debug(`Attribute ${r} is outside the int64 range; encoding it as a string`), { stringValue: r }) : { intValue: r };
    }
    return { doubleValue: e };
  }
  if (typeof e == "string") return { stringValue: Ur(e) };
  if (typeof e == "function") return { stringValue: "[Function]" };
  if (typeof e == "symbol") return { stringValue: String(e) };
  if (typeof e == "object" && e !== null) {
    if (n.ancestors.has(e)) return { stringValue: "[Circular]" };
    if (s >= 20) return { stringValue: vl };
    if (e instanceof Date) {
      const r = e.getTime(), o = Number.isFinite(r) ? e.toISOString() : String(e);
      return { stringValue: typeof o == "string" ? Ur(o) : String(o) };
    }
    n.ancestors.add(e);
    try {
      try {
        const r = e.toJSON;
        if (typeof r == "function") return fd(r.call(e), t, n, s + 1);
      } catch {
      }
      return ae(e) ? { arrayValue: { values: db(e, t, n, s + 1) } } : { kvlistValue: { values: nf(e, t, n, s + 1) } };
    } finally {
      n.ancestors.delete(e);
    }
  }
  return { stringValue: Ur(String(e)) };
}
function db(e, t, n, s) {
  const r = [], o = Math.min(e.length, 1e3);
  let a = 0;
  for (; o > a && n.remainingNodes > 0; a++) try {
    const l = a in e ? e[a] : void 0;
    if (_e(l)) continue;
    r.push(fd(l, t, n, s));
  } catch {
    r.push({ stringValue: sa });
  }
  return e.length > a && r.push({ stringValue: vl }), r;
}
function nf(e, t, n, s) {
  const r = [];
  for (const o in e) if (lb.call(e, o)) {
    if (!o) {
      t == null || t.debug("Dropping an attribute with an empty key");
      continue;
    }
    if (r.length >= 1e3 || 0 >= n.remainingNodes) {
      t == null || t.debug("Attributes truncated: the value exceeds the OTLP encoder budget");
      break;
    }
    try {
      const a = e[o];
      if (gt(a) || L(a)) continue;
      r.push({ key: Ur(o), value: fd(a, t, n, s) });
    } catch {
      r.push({ key: Ur(o), value: { stringValue: sa } });
    }
  }
  return r;
}
function sf(e, t, n) {
  return x(x(x(x({}, e.resourceAttributes), {}, { "service.name": e.serviceName || "unknown_service" }, e.environment && { "deployment.environment": e.environment }), e.serviceVersion && { "service.version": e.serviceVersion }), {}, { "telemetry.sdk.name": t, "telemetry.sdk.version": n });
}
const Oc = { darwin: "macOS", win32: "Windows", linux: "Linux", android: "Android", freebsd: "FreeBSD", openbsd: "OpenBSD", sunos: "SunOS", aix: "AIX", "Mac OS X": "macOS" }, rf = { trace: { text: "TRACE", number: 1 }, debug: { text: "DEBUG", number: 5 }, info: { text: "INFO", number: 9 }, warn: { text: "WARN", number: 13 }, error: { text: "ERROR", number: 17 }, fatal: { text: "FATAL", number: 21 } }, cb = rf.info;
function ub(e) {
  try {
    return Ur(String(e));
  } catch {
    return sa;
  }
}
function hb(e, t, n, s) {
  const r = e.level || "info", { text: o, number: a } = rf[r] || cb, l = function(p = Date.now()) {
    return String(p) + "000000";
  }(bt(s) ? s : void 0), d = {};
  t.distinctId && (d.posthogDistinctId = t.distinctId), t.sessionId && (d.sessionId = t.sessionId), t.windowId && (d["window.id"] = t.windowId), _e(t.sessionStartTimestamp) || (d.sessionStartTimestamp = String(t.sessionStartTimestamp)), _e(t.lastActivityTimestamp) || (d.lastActivityTimestamp = String(t.lastActivityTimestamp)), t.currentUrl && (d["url.full"] = t.currentUrl), t.screenName && (d["screen.name"] = t.screenName), t.appState && (d["app.state"] = t.appState), t.activeFeatureFlags && t.activeFeatureFlags.length > 0 && (d.feature_flags = t.activeFeatureFlags);
  const c = x({}, d), u = e.attributes;
  if (u) {
    let p = [];
    try {
      p = Object.keys(u);
    } catch {
      p = [];
    }
    for (const f of p) {
      let m;
      try {
        m = u[f];
      } catch {
        m = sa;
      }
      Object.defineProperty(c, f, { value: m, enumerable: !0, writable: !0, configurable: !0 });
    }
  }
  const h = { timeUnixNano: l, observedTimeUnixNano: l, severityNumber: a, severityText: o, body: { stringValue: ub(e.body) }, attributes: Ao(c, n) };
  return e.trace_id && (h.traceId = e.trace_id), e.span_id && (h.spanId = e.span_id), L(e.trace_flags) || (h.flags = e.trace_flags), h;
}
function of(e, t, n) {
  return sf(e, t, n);
}
function af(e, t, n, s) {
  return { resourceLogs: [{ resource: { attributes: Ao(t) }, scopeLogs: [{ scope: { name: n, version: s }, logRecords: e }] }] };
}
var fb = class {
  constructor(e, t, n, s, r, o = () => Promise.resolve(), a) {
    var l;
    this._instance = e, this.Sr = t, this.$ = n, this.ss = s, this.rs = r, this.ls = o, this.us = a, this.hs = null, this.cs = 0, this.ds = 0, this.vs = 0, this.fs = 0, this.ps = 0, this.gs = !1, this.ys = t.maxBufferSize, this.bs = Math.max((l = t.maxQueueSize) !== null && l !== void 0 ? l : t.maxBufferSize, t.maxBufferSize), this._s = t.flushIntervalMs, this.ws = t.maxBatchRecordsPerPost, this.ks = t.rateCapWindowMs, this.Ss = t.maxLogsPerInterval;
  }
  clearQueue() {
    this.ds++, this._instance.setPersistedProperty(Qn.LogsQueue, []);
  }
  reset() {
    this.xs(), this.fs = 0, this.ps = 0, this.gs = !1, this.vs = 0, this.ws = this.Sr.maxBatchRecordsPerPost;
  }
  onReconnect() {
    this.vs = 0, this.Cs();
  }
  captureLog(e, t) {
    var n;
    if (this._instance.isDisabled || this._instance.optedOut || !(e != null && e.body)) return;
    const s = this.$s(e);
    if (s === null) return;
    if (!s.body) return void this.$.info("Log was rejected in beforeSend function");
    if (!this.Ts()) return;
    const r = { record: hb(s, (n = t == null ? void 0 : t.context) !== null && n !== void 0 ? n : this.ss(), this.$, t == null ? void 0 : t.occurredAtMs) };
    this.rs(() => this.Is(r));
  }
  $s(e) {
    const t = this.Sr.beforeSend;
    if (!t) return e;
    const n = ae(t) ? t : [t];
    let s = e;
    for (const r of n) try {
      const o = r(s);
      if (!o) return this.$.info("Log was rejected in beforeSend function"), null;
      s = o;
    } catch (o) {
      return this.$.error("Error in beforeSend function for log:", o), null;
    }
    return s;
  }
  Ts() {
    if (this.Ss === void 0) return !0;
    const e = Date.now(), t = e - this.fs;
    return this.ks > t && t >= 0 || (this.fs = e, this.ps = 0, this.gs = !1), this.Ss > this.ps ? (this.ps++, !0) : (this.gs || (this.$.warn(`captureLog dropping logs: exceeded ${this.Ss} logs per ${this.ks}ms`), this.gs = !0), !1);
  }
  flush() {
    var e = this;
    return Qe(function* () {
      if (!e._instance.isDisabled) return e.hs || (e.hs = e.Ms().finally(() => {
        e.hs = null;
      })), e.hs;
    })();
  }
  Ms() {
    var e = this;
    return Qe(function* () {
      var t;
      e.xs();
      let n = (t = e._instance.getPersistedProperty(Qn.LogsQueue)) !== null && t !== void 0 ? t : [];
      if (n.length === 0) return;
      const s = n.length;
      let r = 0;
      for (; n.length > 0 && s > r; ) {
        var o, a;
        const l = e.ds;
        e.cs = 0;
        const d = Math.min(n.length, e.ws), c = n.slice(0, d), u = af(c.map((p) => p.record), e.Es(), (o = e.us) !== null && o !== void 0 ? o : e._instance.getLibraryId(), e._instance.getLibraryVersion()), h = yield e._instance.Ps(u);
        if (e.ds !== l) return;
        if (h.kind === "too-large" && c.length > 1) e.ws = Math.max(1, Math.floor(c.length / 2)), e.$.warn(`Received 413 when sending logs batch of size ${c.length}, reducing batch size to ${e.ws}`);
        else if (h.kind === "retry-later" || (h.kind === "too-large" ? e.$.warn("Dropping a single log record after 413 with batch size 1 — the record is larger than the server cap and cannot be split further.") : h.kind === "ok" && e.Sr.maxBatchRecordsPerPost > e.ws && (e.ws = Math.min(e.Sr.maxBatchRecordsPerPost, e.ws + 1)), yield e.Rs(c.length), n = (a = e._instance.getPersistedProperty(Qn.LogsQueue)) !== null && a !== void 0 ? a : [], r += c.length, h.kind === "fatal")) throw h.error;
      }
    })();
  }
  Rs(e) {
    var t = this;
    return Qe(function* () {
      var n;
      const s = Math.max(0, e - t.cs), r = (n = t._instance.getPersistedProperty(Qn.LogsQueue)) !== null && n !== void 0 ? n : [];
      t._instance.setPersistedProperty(Qn.LogsQueue, r.slice(s)), yield t.ls();
    })();
  }
  Es() {
    return of(this.Sr, this._instance.getLibraryId(), this._instance.getLibraryVersion());
  }
  Is(e) {
    var t;
    if (this._instance.optedOut) return;
    const n = (t = this._instance.getPersistedProperty(Qn.LogsQueue)) !== null && t !== void 0 ? t : [];
    this.bs > n.length || (n.shift(), this.cs++, this.$.info("Logs queue is full, dropping oldest record.")), n.push(e), this._instance.setPersistedProperty(Qn.LogsQueue, n), this.ys > n.length ? this.As() : this.Cs();
  }
  As(e = this._s) {
    this.Fs || (this.Fs = ud(() => {
      this.Fs = void 0, this.Cs();
    }, e));
  }
  Os() {
    const e = Math.min(Math.max(0, this.vs - 1), 6);
    return this._s * Math.pow(2, e);
  }
  Ds() {
    const e = this._instance.getPersistedProperty(Qn.LogsQueue);
    return !!e && e.length > 0;
  }
  shutdown(e) {
    var t = this;
    return Qe(function* () {
      t.xs();
      const n = t.flush().catch(() => {
      });
      e !== void 0 ? yield jc(n, e) : yield n;
    })();
  }
  flushWithTimeout(e) {
    var t = this;
    return Qe(function* () {
      const n = t.flush();
      yield jc(n, e, () => {
        n.catch(() => {
        });
      });
    })();
  }
  Cs() {
    this.flush().then(() => {
      this.vs = 0;
    }, (e) => {
      this.vs++, this.$.error("PostHog logs flush failed:", e);
    }).finally(() => {
      !this._instance.isDisabled && this.Ds() && this.As(this.Os());
    });
  }
  xs() {
    this.Fs && (clearTimeout(this.Fs), this.Fs = void 0);
  }
};
const ja = [0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4];
function Fc(e) {
  return String(e) + "000000";
}
function Ac(e, t, n, s) {
  let r = "";
  return s && (r = Object.keys(s).sort().map((o) => `${JSON.stringify(o)}:${JSON.stringify(s[o])}`).join(",")), `${e}\0${t}\0${n ?? ""}\0${r}`;
}
var pb = class {
  constructor(e, t, n) {
    this._instance = e, this.Sr = t, this.$ = n, this.Ls = /* @__PURE__ */ new Map(), this.hs = null, this.Ns = !1, this.qs = /* @__PURE__ */ new Map(), this.js = /* @__PURE__ */ new Set(), this.Bs = 0;
  }
  count(e, t = 1, n) {
    this.Hs({ name: e, type: "count", value: t, unit: n == null ? void 0 : n.unit, attributes: n == null ? void 0 : n.attributes });
  }
  gauge(e, t, n) {
    this.Hs({ name: e, type: "gauge", value: t, unit: n == null ? void 0 : n.unit, attributes: n == null ? void 0 : n.attributes });
  }
  histogram(e, t, n) {
    this.Hs({ name: e, type: "histogram", value: t, unit: n == null ? void 0 : n.unit, attributes: n == null ? void 0 : n.attributes });
  }
  flush() {
    var e = this;
    const t = this.hs, n = function() {
      var s = Qe(function* () {
        t && (yield t.catch(() => {
        })), yield e.zs();
      });
      return function() {
        return s.apply(this, arguments);
      };
    }()().finally(() => {
      this.hs === n && (this.hs = null);
    });
    return this.hs = n, n;
  }
  drainWindow() {
    if (this.Ls.size === 0) return null;
    const e = this.Ls;
    return this.Ls = /* @__PURE__ */ new Map(), this.Ns = !1, this.qs = /* @__PURE__ */ new Map(), this.js = /* @__PURE__ */ new Set(), this.Us(e);
  }
  reset() {
    this.Bs++, this.xs(), this.Ls = /* @__PURE__ */ new Map(), this.hs = null, this.Ns = !1, this.qs = /* @__PURE__ */ new Map(), this.js = /* @__PURE__ */ new Set();
  }
  Hs(e) {
    if (this._instance.isDisabled || this._instance.optedOut) return;
    const t = this.$s(e);
    if (t === null) return;
    if (!t.name || typeof t.name != "string") return void this.$.warn("Dropping metric with empty name");
    if (typeof t.value != "number" || !Number.isFinite(t.value)) return void this.$.warn(`Dropping metric '${t.name}': value must be a finite number`);
    if (t.type === "count" && 0 > t.value) return void this.$.warn(`Dropping count '${t.name}': counters are monotonic, value must be >= 0`);
    let n, s;
    try {
      n = t.attributes ? x({}, t.attributes) : void 0, s = Ac(t.type, t.name, t.unit, n);
    } catch (a) {
      return void this.$.warn(`Dropping metric '${t.name}': attributes could not be serialized`, a);
    }
    let r = this.Ls.get(s);
    if (!r) {
      if (!this.Ws()) return;
      r = { name: t.name, type: t.type, unit: t.unit, attributes: n, windowStartMs: Date.now() }, this.Ls.set(s, r);
    }
    const o = this.qs.get(t.name);
    o === void 0 ? this.qs.set(t.name, t.type) : o === t.type || this.js.has(t.name) || (this.js.add(t.name), this.$.warn(`Metric name '${t.name}' is already used as a ${o}; recording it as a ${t.type} too will blend both series in charts. Use a distinct name.`)), this.Vs(r, t.value), this.As();
  }
  Ws() {
    return this.Sr.maxSeriesPerFlush > this.Ls.size || (this.Ns || (this.Ns = !0, this.$.warn(`Metric series cap reached (${this.Sr.maxSeriesPerFlush} per flush window); dropping new series until the next flush. Reduce attribute cardinality.`)), !1);
  }
  Vs(e, t) {
    switch (e.type) {
      case "count":
        var n;
        e.total = ((n = e.total) !== null && n !== void 0 ? n : 0) + t;
        break;
      case "gauge":
        e.last = t;
        break;
      case "histogram": {
        e.hist || (e.hist = { count: 0, sum: 0, min: t, max: t, bucketCounts: new Array(ja.length + 1).fill(0) });
        const s = e.hist;
        s.count += 1, s.sum += t, s.min = Math.min(s.min, t), s.max = Math.max(s.max, t), s.bucketCounts[function(r, o) {
          for (let a = 0; o.length > a; a++) if (o[a] >= r) return a;
          return o.length;
        }(t, ja)] += 1;
        break;
      }
    }
  }
  $s(e) {
    const t = this.Sr.beforeSend;
    if (!t) return e;
    const n = ae(t) ? t : [t];
    let s = e;
    for (const r of n) try {
      const o = r(s);
      if (!o) return this.$.info("Metric was rejected in beforeSend function"), null;
      s = o;
    } catch (o) {
      return this.$.error("Error in beforeSend function for metric:", o), null;
    }
    return s;
  }
  As() {
    this.Fs || (this.Fs = ud(() => {
      this.Fs = void 0, this.flush().catch((e) => {
        this.$.error("Metrics flush failed:", e);
      });
    }, this.Sr.flushIntervalMs));
  }
  xs() {
    this.Fs && (clearTimeout(this.Fs), this.Fs = void 0);
  }
  zs() {
    var e = this;
    return Qe(function* () {
      if (e.Ls.size === 0) return;
      const t = e.Ls;
      e.Ls = /* @__PURE__ */ new Map(), e.Ns = !1, e.qs = /* @__PURE__ */ new Map(), e.js = /* @__PURE__ */ new Set();
      const n = e.Bs, s = yield e._instance.Gs(e.Us(t));
      if (n === e.Bs) switch (s.kind) {
        case "ok":
          return;
        case "retry-later":
          return e.Zs(t), void e.As();
        case "too-large":
          return void e.$.warn("Metrics batch exceeded the server size limit and was dropped");
        case "fatal":
          return void e.$.error("Failed to send metrics batch:", s.error);
      }
    })();
  }
  Us(e) {
    return t = this.Qs(e), n = function(o, a, l) {
      return sf(o, a, l);
    }(this.Sr, this._instance.getLibraryId(), this._instance.getLibraryVersion()), s = this._instance.getLibraryId(), r = this._instance.getLibraryVersion(), { resourceMetrics: [{ resource: { attributes: Ao(n) }, scopeMetrics: [{ scope: { name: s, version: r }, metrics: t }] }] };
    var t, n, s, r;
  }
  Qs(e) {
    const t = Fc(Date.now()), n = /* @__PURE__ */ new Map();
    for (const a of e.values()) {
      var s;
      const l = Ac(a.type, a.name, a.unit, void 0);
      let d = n.get(l);
      d || (d = x({ name: a.name }, a.unit && { unit: a.unit }), a.type === "count" ? d.sum = { aggregationTemporality: 1, isMonotonic: !0, dataPoints: [] } : a.type === "gauge" ? d.gauge = { dataPoints: [] } : d.histogram = { aggregationTemporality: 1, dataPoints: [] }, n.set(l, d));
      const c = Ao((s = a.attributes) !== null && s !== void 0 ? s : {}, this.$), u = Fc(a.windowStartMs);
      if (a.type === "count") {
        var r;
        const h = { attributes: c, startTimeUnixNano: u, timeUnixNano: t, asDouble: (r = a.total) !== null && r !== void 0 ? r : 0 };
        d.sum.dataPoints.push(h);
      } else if (a.type === "gauge") {
        var o;
        const h = { attributes: c, timeUnixNano: t, asDouble: (o = a.last) !== null && o !== void 0 ? o : 0 };
        d.gauge.dataPoints.push(h);
      } else a.hist && d.histogram.dataPoints.push({ attributes: c, startTimeUnixNano: u, timeUnixNano: t, count: a.hist.count, sum: a.hist.sum, min: a.hist.min, max: a.hist.max, bucketCounts: a.hist.bucketCounts, explicitBounds: ja });
    }
    return Array.from(n.values());
  }
  Zs(e) {
    for (const [s, r] of e) {
      const o = this.Ls.get(s);
      if (o) switch (o.windowStartMs = Math.min(o.windowStartMs, r.windowStartMs), o.type) {
        case "count":
          var t, n;
          o.total = ((t = o.total) !== null && t !== void 0 ? t : 0) + ((n = r.total) !== null && n !== void 0 ? n : 0);
          break;
        case "gauge":
          break;
        case "histogram":
          if (r.hist) if (o.hist) {
            o.hist.count += r.hist.count, o.hist.sum += r.hist.sum, o.hist.min = Math.min(o.hist.min, r.hist.min), o.hist.max = Math.max(o.hist.max, r.hist.max);
            for (let a = 0; o.hist.bucketCounts.length > a; a++) o.hist.bucketCounts[a] += r.hist.bucketCounts[a];
          } else o.hist = r.hist;
      }
      else this.Ws() && this.Ls.set(s, r);
    }
  }
};
const lf = (e, { debugEnabled: t } = {}) => {
  const n = { N(s, ...r) {
    k && (xs.DEBUG || k.POSTHOG_DEBUG || t) && !L(k.console) && k.console && ("__rrweb_original__" in k.console[s] ? k.console[s].__rrweb_original__ : k.console[s])(e, ...r);
  }, debug(...s) {
    n.N("debug", ...s);
  }, info(...s) {
    n.N("log", ...s);
  }, warn(...s) {
    n.N("warn", ...s);
  }, error(...s) {
    n.N("error", ...s);
  }, critical(...s) {
    console.error(e, ...s);
  }, uninitializedWarning(s) {
    n.error(`You must initialize PostHog before calling ${s}`);
  }, createLogger: (s, r) => lf(`${e} ${s}`, r) };
  return n;
}, H = lf("[PostHog.js]"), xt = H.createLogger, _b = xt("[ExternalScriptsLoader]"), Mo = (e) => {
  const t = A == null ? void 0 : A.querySelectorAll("script");
  if (t) {
    for (let n = 0; t.length > n; n++) if (t[n].src === e || t[n].getAttribute("src") === e) return t[n];
  }
}, cr = (e, t, n) => {
  if (e.config.disable_external_dependency_loading) return _b.warn(`${t} was requested but loading of external scripts is disabled.`), n("Loading of external scripts is disabled");
  const s = Mo(t);
  if (s) {
    if (s.__posthog_loading_callback_fired) return n();
    const o = s.__posthog_loading_error;
    return o ? n(o) : (s.addEventListener("load", (a) => {
      s.__posthog_loading_callback_fired = !0, n(void 0, a);
    }), void s.addEventListener("error", (a) => {
      s.__posthog_loading_error = a, n(a);
    }));
  }
  const r = () => {
    if (!A) return n("document not found");
    if (Mo(t)) return cr(e, t, n);
    let o = A.createElement("script");
    if (o.type = "text/javascript", o.crossOrigin = "anonymous", o.src = t, o.onload = (l) => {
      o.__posthog_loading_callback_fired = !0, n(void 0, l);
    }, o.onerror = (l) => {
      o.__posthog_loading_error = l, n(l);
    }, e.config.prepare_external_dependency_script && (o = e.config.prepare_external_dependency_script(o)), !o) return n("prepare_external_dependency_script returned null");
    if (e.config.external_scripts_inject_target === "head") A.head.appendChild(o);
    else {
      const l = A.querySelectorAll("body > script");
      var a;
      l.length > 0 ? (a = l[0].parentNode) === null || a === void 0 || a.insertBefore(o, l[0]) : A.body.appendChild(o);
    }
  };
  A != null && A.body ? r() : A == null || A.addEventListener("DOMContentLoaded", r);
}, Na = {}, Mc = (e, t) => {
  let n = `/static/${t}.js?v=${e.version}`;
  return t === "toolbar" && (n = `${n}&t=${Math.floor(Date.now() / 3e5) * 3e5}`), e.requestRouter.endpointFor("assets", n);
};
se.__PosthogExtensions__ = se.__PosthogExtensions__ || {}, se.__PosthogExtensions__.loadExternalDependency = (e, t, n) => {
  if (t === "remote-config") {
    const r = e.requestRouter.endpointFor("assets", `/array/${e.config.token}/config.js`);
    return void cr(e, r, n);
  }
  const s = e.config.strict_script_versioning;
  if (s) {
    const r = e.requestRouter.endpointFor("assets", `/static/${e.version}/${t}.js`), o = Na[r];
    if (s === "fallback" && o) {
      if (Mo(o)) return void cr(e, o, n);
      delete Na[r];
    }
    return void cr(e, r, s === "fallback" ? (a, l) => {
      if (a) if (typeof a == "string") n(a);
      else {
        var d;
        const c = Mc(e, t);
        Na[r] = c;
        const u = Mo(r);
        u == null || (d = u.parentNode) === null || d === void 0 || d.removeChild(u), cr(e, c, n);
      }
      else n(void 0, l);
    } : n);
  }
  cr(e, Mc(e, t), n);
}, se.__PosthogExtensions__.loadSiteApp = (e, t, n) => {
  const s = e.requestRouter.endpointFor("api", t);
  cr(e, s, n);
}, xs.DEBUG = !1, xs.LIB_VERSION = "1.429.2", xs.LIB_NAME = "web";
var Ot = xs;
const mb = "$people_distinct_id", Bn = "distinct_id", pd = "$device_id", Sa = "$device_model", Do = "__alias", gb = "__cmpns", ro = "$fbc", Un = "$fbc_persistence", yl = "__timers", df = "$autocapture_disabled_server_side", wl = "$heatmaps_enabled_server_side", Cl = "$exception_capture_enabled_server_side", cf = "$error_tracking_suppression_rules", jl = "$error_tracking_capture_extension_exceptions", Nl = "$web_vitals_enabled_server_side", _d = "$dead_clicks_enabled_server_side", md = "$product_tours_enabled_server_side", uf = "$logs_capture_enabled_server_side", hf = "$web_vitals_allowed_metrics", ki = "$session_recording_remote_config", vb = "$session_recording_enabled_server_side", $b = "$replay_sample_rate", bb = "$replay_override_sampling", xb = "$replay_override_linked_flag", yb = "$replay_override_url_trigger", wb = "$replay_override_event_trigger", Dr = "$sesid", ff = "$session_is_sampled", Cb = "$session_past_minimum_duration", jb = "$session_recording_url_trigger_activated_session", Nb = "$session_recording_event_trigger_activated_session", Sb = "$debug_first_full_snapshot_timestamp", kb = "$sess_rec_flush_size", zn = "$enabled_feature_flags", vs = "$active_feature_flags", Sl = "$early_access_features", gr = "$feature_flag_details", Ms = "$feature_flag_payloads", vr = "$feature_flag_request_id", Ei = "$minimal_flag_called_events", Xn = "$override_feature_flags", ur = "$override_feature_flag_payloads", Ds = "$stored_person_properties", Bs = "$stored_group_properties", pf = "$groups", kl = "$surveys", Bo = "$surveys_loaded_at", _f = "$surveys_activated", mf = "$surveys_activated_session", gf = "$surveys_activated_timestamps", El = "ph_product_tours", Eb = "$product_tours_activated", Ib = "$product_tours_activated_session", Pb = "$conversations_widget_session_id", Tb = "$conversations_ticket_id", Rb = "$conversations_widget_state", Lb = "$conversations_user_traits", Ws = "$flag_call_reported", wi = "$flag_call_reported_session_id", Ui = "$feature_flag_errors", Us = "$feature_flag_evaluated_at", an = "$user_state", Il = "$client_session_props", Ob = "$capture_rate_limit", vf = "$initial_campaign_params", $f = "$initial_referrer_info", Br = "$initial_person_info", gd = "$epp", ka = "$posthog_cookieless", bf = "$cookieless_mode", xf = "$sdk_debug_extensions_init_method", yf = "$sdk_debug_extensions_init_time_ms", wf = "$sdk_debug_recording_script_not_loaded", Fb = "$sdk_debug_replay_event_trigger_status", Ab = "$sdk_debug_replay_linked_flag_trigger_status", Mb = "$sdk_debug_replay_matched_recording_trigger_groups", Db = "$sdk_debug_replay_pending_trigger_conditions", Bb = "$sdk_debug_replay_remote_trigger_matching_config", Wb = "$sdk_debug_replay_trigger_groups_count", Ub = "$sdk_debug_replay_url_trigger_status", zb = "$session_recording_start_reason", vd = "PostHog loadExternalDependency extension not found.", $s = "anonymous", Co = "identified", Cf = "identified_only", zi = "visibilitychange", Wo = "beforeunload", $d = "$pageview", Dc = "$pageleave", Pl = "$identify", Bc = "$groupidentify";
function io(e, t) {
  ae(e) && e.forEach(t);
}
function Me(e, t) {
  if (!_e(e)) if (ae(e)) e.forEach(t);
  else if (((n) => n instanceof FormData)(e)) e.forEach((n, s) => t(n, s));
  else for (const n in e) ld.call(e, n) && t(e[n], n);
}
const Xe = function(e, ...t) {
  for (const n of t) for (const s in n) n[s] !== void 0 && (e[s] = n[s]);
  return e;
};
function jo(e) {
  const t = Object.keys(e);
  let n = t.length;
  const s = new Array(n);
  for (; n--; ) s[n] = [t[n], e[t[n]]];
  return s;
}
const Wc = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Hb = function(e) {
  return function(...t) {
    try {
      return e.apply(this, t);
    } catch (n) {
      H.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), H.critical(n);
    }
  };
}, bd = function(e) {
  const t = {};
  return Me(e, function(n, s) {
    (ye(n) && n.length > 0 || bt(n)) && (t[s] = n);
  }), t;
};
function jf(e) {
  const t = x({}, e);
  for (const n of ["name", "message", "stack", "cause", "errors"]) try {
    n in e && (t[n] = e[n]);
  } catch {
  }
  return t;
}
const qb = ["herokuapp.com", "vercel.app", "netlify.app"];
function Gb(e) {
  const t = e == null ? void 0 : e.hostname;
  if (!ye(t)) return !1;
  const n = t.split(".").slice(-2).join(".");
  for (const s of qb) if (n === s) return !1;
  return !0;
}
function We(e, t, n, s) {
  const { capture: r = !1, passive: o = !0 } = s ?? {};
  e == null || e.addEventListener(t, n, { capture: r, passive: o });
}
function Tl(e) {
  return e.name === "ph_toolbar_internal";
}
const Rl = (e) => {
  if (A) {
    try {
      const t = e + "=", n = A.cookie.split(";").filter((s) => s.length);
      for (let s = 0; n.length > s; s++) {
        let r = n[s];
        for (; r.charAt(0) == " "; ) r = r.substring(1, r.length);
        if (r.indexOf(t) === 0) return decodeURIComponent(r.substring(t.length, r.length));
      }
    } catch {
    }
    return null;
  }
};
Math.trunc || (Math.trunc = function(e) {
  return 0 > e ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
  return bt(e) && isFinite(e) && Math.floor(e) === e;
});
var Vb = class Ll {
  constructor(t) {
    if (this.bytes = t, t.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(t, n, s, r) {
    if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(s) || !Number.isInteger(r) || 0 > t || 0 > n || 0 > s || 0 > r || t > 281474976710655 || n > 4095 || s > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
    const o = new Uint8Array(16);
    return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / 256, o[5] = t, o[6] = 112 | n >>> 8, o[7] = n, o[8] = 128 | s >>> 24, o[9] = s >>> 16, o[10] = s >>> 8, o[11] = s, o[12] = r >>> 24, o[13] = r >>> 16, o[14] = r >>> 8, o[15] = r, new Ll(o);
  }
  toString() {
    let t = "";
    for (let n = 0; this.bytes.length > n; n++) t = t + (this.bytes[n] >>> 4).toString(16) + (15 & this.bytes[n]).toString(16), n !== 3 && n !== 5 && n !== 7 && n !== 9 || (t += "-");
    if (t.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return t;
  }
  clone() {
    return new Ll(this.bytes.slice(0));
  }
  equals(t) {
    return this.compareTo(t) === 0;
  }
  compareTo(t) {
    for (let n = 0; 16 > n; n++) {
      const s = this.bytes[n] - t.bytes[n];
      if (s !== 0) return Math.sign(s);
    }
    return 0;
  }
}, Yb = class {
  generate() {
    const e = this.generateOrAbort();
    if (!L(e)) return e;
    {
      this.Ct = 0;
      const t = this.generateOrAbort();
      if (L(t)) throw new Error("Could not generate UUID after timestamp reset");
      return t;
    }
  }
  generateOrAbort() {
    const e = (() => {
      const t = Date.now();
      return bt(t) && isFinite(t) ? Math.min(Math.max(Math.floor(t), 0), 281474976710655) : 0;
    })();
    if (e > this.Ct) this.Ct = e, this.Mt();
    else {
      if (this.Ct >= e + 1e4) return;
      this.It++, this.It > 4398046511103 && (this.Ct++, this.Mt());
    }
    return Vb.fromFieldsV7(this.Ct, Math.trunc(this.It / Math.pow(2, 30)), this.It & Math.pow(2, 30) - 1, this.Tt.nextUint32());
  }
  Mt() {
    this.It = 1024 * this.Tt.nextUint32() + (1023 & this.Tt.nextUint32());
  }
  constructor() {
    this.Ct = 0, this.It = 0, this.Tt = new Kb();
  }
};
let Nf = (e) => {
  if ("u" > typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (let t = 0; e.length > t; t++) e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return e;
};
k && !L(k.crypto) && crypto.getRandomValues && (Nf = (e) => crypto.getRandomValues(e));
var Kb = class {
  nextUint32() {
    return this.Rt.length > this.$t || (Nf(this.Rt), this.$t = 0), this.Rt[this.$t++];
  }
  constructor() {
    this.Rt = new Uint32Array(8), this.$t = 1 / 0;
  }
};
let Uc;
const qn = () => Jb().toString(), Jb = () => (Uc || (Uc = new Yb())).generate();
let di = "";
const Zb = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
let Sr = null;
const dt = { Et() {
  if (!gt(Sr)) return Sr;
  if (Sr = !1, A) try {
    const e = `__ph_cookie_support_${qn()}`;
    dt.At(e, "xyz"), Sr = Rl(e) === '"xyz"', dt.Lt(e);
  } catch {
    Sr = !1;
  }
  return Sr;
}, Pt(e) {
  H.error("cookieStore error: " + e);
}, Ot: Rl, Dt(e) {
  let t;
  try {
    t = JSON.parse(dt.Ot(e)) || {};
  } catch {
  }
  return t;
}, At(e, t, n, s, r) {
  if (!A) return !1;
  try {
    let o = "", a = "";
    const l = function(c, u) {
      if (u) {
        let h = function(p, f = A) {
          if (di) return di;
          if (!f || ["localhost", "127.0.0.1"].includes(p)) return "";
          const m = p.split(".");
          let g = Math.min(m.length, 8);
          const v = "dmn_chk_" + qn();
          for (; !di && g--; ) {
            const _ = m.slice(g).join("."), $ = v + "=1;domain=." + _ + ";path=/";
            f.cookie = $ + ";max-age=3", f.cookie.includes(v) && (f.cookie = $ + ";max-age=0", di = _);
          }
          return di;
        }(c);
        if (!h) {
          const p = ((f) => {
            const m = f.match(Zb);
            return m ? m[0] : "";
          })(c);
          p !== h && H.info("Warning: cookie subdomain discovery mismatch", p, h), h = p;
        }
        return h ? "; domain=." + h : "";
      }
      return "";
    }(A.location.hostname, s);
    if (n) {
      const c = /* @__PURE__ */ new Date();
      c.setTime(c.getTime() + 864e5 * n), o = "; expires=" + c.toUTCString();
    }
    r && (a = "; secure");
    const d = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + l + a;
    return d.length > 3686.4 && H.warn("cookieStore warning: large cookie, len=" + d.length), A.cookie = d, !0;
  } catch {
    return !1;
  }
}, Lt(e, t) {
  if (A != null && A.cookie) try {
    dt.At(e, "", -1, t);
  } catch {
    return;
  }
} };
let Ea = null;
const ke = { Et() {
  if (!gt(Ea)) return Ea;
  let e = !0;
  if (L(k)) e = !1;
  else try {
    const t = "__mplssupport__";
    ke.At(t, "xyz"), ke.Ot(t) !== '"xyz"' && (e = !1), ke.Lt(t);
  } catch {
    e = !1;
  }
  return e || H.error("localStorage unsupported; falling back to cookie store"), Ea = e, e;
}, Pt(e) {
  H.error("localStorage error: " + e);
}, Ot(e) {
  try {
    return k == null ? void 0 : k.localStorage.getItem(e);
  } catch (t) {
    ke.Pt(t);
  }
  return null;
}, Dt(e) {
  try {
    return JSON.parse(ke.Ot(e)) || {};
  } catch {
  }
  return null;
}, At(e, t) {
  try {
    return k == null || k.localStorage.setItem(e, JSON.stringify(t)), !0;
  } catch (n) {
    ke.Pt(n);
  }
  return !1;
}, Lt(e) {
  try {
    k == null || k.localStorage.removeItem(e);
  } catch (t) {
    ke.Pt(t);
  }
} }, Ia = [Ds, vs, zn, gr, Ms, vr, Us, Ui, Ws], hr = [pd, Bn, Dr, ff, gd, Br, Un, an], Uo = (e) => e + "_cpm", Xb = ["__proto__", "constructor", "prototype"], Pa = (e) => {
  if (!xe(e)) return {};
  const t = {};
  return Object.keys(e).forEach((n) => {
    Xb.indexOf(n) === -1 && (t[n] = e[n]);
  }), t;
}, Ta = (e, t = []) => {
  const n = {};
  return [...hr, ...t].forEach((s) => {
    const r = e[s];
    L(r) || gt(r) || r === "" || (n[s] = r);
  }), n;
}, Sf = (e) => {
  let t = 5381, n = 2166136261;
  for (let s = 0; e.length > s; s++) {
    const r = e.charCodeAt(s);
    t = 33 * t ^ r, n = Math.imul(n ^ r, 16777619);
  }
  return e.length.toString(36) + "." + (t >>> 0).toString(36) + "." + (n >>> 0).toString(36);
}, zc = (e, t) => ({ p: t, f: Sf(JSON.stringify(e)) }), Hc = (e, t) => {
  if (!t) return { properties: [], isValid: !1 };
  try {
    const n = dt.Dt(Uo(e)), s = (n == null ? void 0 : n.f) === Sf(t) && ae(n.p);
    return { properties: s ? n.p : [], isValid: s };
  } catch {
    return { properties: [], isValid: !1 };
  }
}, Ra = (e, t) => t + "|" + (dt.Ot(Uo(e)) || ""), kr = {}, Ol = { Et: () => !0, Pt(e) {
  H.error("memoryStorage error: " + e);
}, Ot: (e) => e in kr ? kr[e] : null, Dt: (e) => e in kr ? kr[e] : null, At: (e, t) => (kr[e] = t, !0), Lt(e) {
  delete kr[e];
} };
let Zs = null;
const Ze = { Et() {
  if (!gt(Zs)) return Zs;
  if (Zs = !0, L(k)) Zs = !1;
  else try {
    const e = "__support__";
    Ze.At(e, "xyz"), Ze.Ot(e) !== '"xyz"' && (Zs = !1), Ze.Lt(e);
  } catch {
    Zs = !1;
  }
  return Zs;
}, Pt(e) {
  H.error("sessionStorage error: ", e);
}, Ot(e) {
  try {
    return k == null ? void 0 : k.sessionStorage.getItem(e);
  } catch (t) {
    Ze.Pt(t);
  }
  return null;
}, Dt(e) {
  try {
    return JSON.parse(Ze.Ot(e)) || null;
  } catch {
  }
  return null;
}, At(e, t) {
  try {
    return k == null || k.sessionStorage.setItem(e, JSON.stringify(t)), !0;
  } catch (n) {
    Ze.Pt(n);
  }
  return !1;
}, Lt(e) {
  try {
    k == null || k.sessionStorage.removeItem(e);
  } catch (t) {
    Ze.Pt(t);
  }
} };
var Qb = class {
  constructor(e) {
    this._instance = e;
  }
  get Sr() {
    return this._instance.config;
  }
  get consent() {
    return this.xo() ? 0 : this.Co;
  }
  isOptedOut() {
    return this.Sr.cookieless_mode === "always" || this.isRejected() || this.consent === -1 && this.Sr.cookieless_mode === "on_reject";
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  isExplicitlyOptedOut() {
    return this.consent === 0;
  }
  isRejected() {
    return this.consent === 0 || this.consent === -1 && this.Sr.opt_out_capturing_by_default;
  }
  optInOut(e) {
    this.$o.At(this.To, e ? 1 : 0, this.Sr.cookie_expiration, this.Sr.cross_subdomain_cookie, this.Sr.secure_cookie);
  }
  reset() {
    this.$o.Lt(this.To, this.Sr.cross_subdomain_cookie);
  }
  get To() {
    const { token: e, opt_out_capturing_cookie_prefix: t, consent_persistence_name: n } = this._instance.config;
    return n || (t ? t + e : "__ph_opt_in_out_" + e);
  }
  get Co() {
    const e = this.$o.Ot(this.To);
    return va(e) ? 1 : de(x$, e) ? 0 : -1;
  }
  get $o() {
    const e = this.Sr.opt_out_capturing_persistence_type, t = e === "localStorage" ? ke : dt, n = t.Et() ? t : Ol;
    if (!this.Io || this.Io !== n) {
      this.Io = n;
      const s = e === "localStorage" ? dt : ke;
      s.Ot(this.To) && (this.Io.Ot(this.To) || this.optInOut(va(s.Ot(this.To))), s.Lt(this.To, this.Sr.cross_subdomain_cookie));
    }
    return this.Io;
  }
  xo() {
    return !!this.Sr.respect_dnt && [At == null ? void 0 : At.doNotTrack, At == null ? void 0 : At.msDoNotTrack, se.doNotTrack, At == null ? void 0 : At.globalPrivacyControl].some((e) => va(e));
  }
};
function kf(e, t) {
  var n;
  const s = e == null || (n = e.config) === null || n === void 0 ? void 0 : n.get_current_url;
  if (!Yt(s)) return t;
  try {
    const r = s(t);
    return ye(r) && r ? r : t;
  } catch (r) {
    return H.error("Error in get_current_url, falling back to window.location.href", r), t;
  }
}
function qc(e) {
  var t;
  return e instanceof Element && (e.id === "__POSTHOG_TOOLBAR__" || !!(!((t = e.closest) === null || t === void 0) && t.call(e, ".toolbar-global-fade-container")));
}
function ns(e) {
  return !!e && e.nodeType === 1;
}
function Kt(e, t) {
  return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function Ef(e) {
  return !!e && e.nodeType === 3;
}
function xd(e) {
  return !!e && e.nodeType === 11 && ns(e.host);
}
function yd(e) {
  return e ? Qo(e).split(/\s+/) : [];
}
function Gc(e, t) {
  const n = function(s) {
    var r;
    const o = k == null || (r = k.location) === null || r === void 0 ? void 0 : r.href;
    return L(o) ? void 0 : kf(s, o);
  }(t);
  return !!(n && e && e.some((s) => n.match(s)));
}
function Vr(e) {
  let t = "";
  switch (typeof e.className) {
    case "string":
      t = e.className;
      break;
    case "object":
      t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
      break;
    default:
      t = "";
  }
  return yd(t);
}
function If(e) {
  return _e(e) ? null : Qo(e).split(/(\s+)/).filter((t) => Pi(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function Hi(e) {
  let t = "";
  return zr(e) && !qi(e) && e.childNodes && e.childNodes.length && Me(e.childNodes, function(n) {
    var s;
    Ef(n) && n.textContent && (t += (s = If(n.textContent)) !== null && s !== void 0 ? s : "");
  }), Qo(t);
}
function Ii(e) {
  var t;
  return L(e.target) ? e.srcElement || null : !((t = e.target) === null || t === void 0) && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
}
const wd = ["a", "button", "form", "input", "select", "textarea", "label"];
function Fl(e, t) {
  const n = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
  try {
    return !!n && n.call(e, t);
  } catch {
    return !1;
  }
}
function Al(e, t) {
  if (L(t)) return !0;
  for (const n of e) if (t.some((s) => Fl(n, s))) return !0;
  return !1;
}
function Pf(e) {
  const t = e.parentNode;
  return !(!t || !ns(t)) && t;
}
const La = [".ph-no-autocapture", "[data-ph-no-autocapture]"], Tf = ["next", "previous", "prev", ">", "<"], ex = [...Tf, "+", "-", "−", "–"], Vc = (e, t) => /[a-z0-9]/i.test(t) ? e.includes(t) : e === t, Yc = [".ph-no-rageclick", ".ph-no-capture"], tx = ["", "text", "search", "email", "password", "url", "tel", "number"];
function Rf(e, t) {
  if (!k || Cd(e)) return !1;
  let n, s, r;
  var o, a;
  if (ln(t) ? (n = !!t && Yc, s = void 0, r = !1) : (n = (o = t == null ? void 0 : t.css_selector_ignorelist) !== null && o !== void 0 ? o : Yc, s = t == null ? void 0 : t.content_ignorelist, r = (a = t == null ? void 0 : t.ignore_text_selection) !== null && a !== void 0 && a), n === !1 || r && function(d) {
    return !(!d || !ns(d)) && (!!Kt(d, "textarea") || (Kt(d, "input") ? de(tx, (d.getAttribute("type") || "").toLowerCase()) : function(c) {
      var u;
      if (c.isContentEditable) return !0;
      const h = (u = c.getAttribute) === null || u === void 0 ? void 0 : u.call(c, "contenteditable");
      return h === "true" || h === "";
    }(d)));
  }(e)) return !1;
  const { targetElementList: l } = Lf(e, !1);
  return !function(d, c) {
    if (d === !1 || L(d)) return !1;
    let u;
    if (d === !0) u = Tf;
    else {
      if (!ae(d)) return !1;
      if (d.length > 10) return H.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
      u = d.map((h) => h.toLowerCase());
    }
    return c.some(({ safeText: h, ariaLabel: p }) => u.some((f) => Vc(h, f) || Vc(p, f)));
  }(s, l.map((d) => {
    var c;
    return { safeText: Hi(d).toLowerCase(), ariaLabel: ((c = d.getAttribute("aria-label")) === null || c === void 0 ? void 0 : c.toLowerCase().trim()) || "" };
  })) && !Al(l, n);
}
const Cd = (e) => !e || Kt(e, "html") || !ns(e), Lf = (e, t) => {
  if (!k || Cd(e)) return { parentIsUsefulElement: !1, targetElementList: [] };
  let n = !1;
  const s = [e];
  let r = e;
  for (; r.parentNode && !Kt(r, "body"); ) {
    if (xd(r.parentNode)) {
      s.push(r.parentNode.host), r = r.parentNode.host;
      continue;
    }
    const o = Pf(r);
    if (!o) break;
    if (t || wd.indexOf(o.tagName.toLowerCase()) > -1) n = !0;
    else try {
      const a = k.getComputedStyle(o);
      a && a.getPropertyValue("cursor") === "pointer" && (n = !0);
    } catch {
    }
    s.push(o), r = o;
  }
  return { parentIsUsefulElement: n, targetElementList: s };
};
function zr(e) {
  const t = /* @__PURE__ */ new Set();
  let n = 0;
  for (let o = e; o.parentNode && !Kt(o, "body"); o = o.parentNode) {
    if (n++ >= 1e3 || t.has(o)) return !1;
    t.add(o);
    const a = Vr(o);
    if (de(a, "ph-sensitive") || de(a, "ph-no-capture")) return !1;
  }
  if (de(Vr(e), "ph-include")) return !0;
  const s = e.type || "";
  if (ye(s)) switch (s.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  const r = e.name || e.id || "";
  return !ye(r) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(r.replace(/[^a-zA-Z0-9]/g, ""));
}
function qi(e) {
  return !!(Kt(e, "input") && !["button", "checkbox", "submit", "reset"].includes(e.type) || Kt(e, "select") || Kt(e, "textarea") || e.getAttribute("contenteditable") === "true");
}
const Kc = new RegExp("^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$"), Jc = /(^|[^0-9A-Za-z_])([0-9][0-9 -]*[0-9])(?=$|[^0-9A-Za-z_])/g, nx = [16, 15, 14, 13], sx = new RegExp("^(\\d{3}-?\\d{2}-?\\d{4})$"), Zc = new RegExp("(^|[^0-9])((?!000|666)[0-9]{3}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4})(?=$|([^0-9]))", "g"), Xc = /[0-9A-Za-z_]/;
function rx(e) {
  let t = 0, n = !1;
  for (let s = e.length - 1; s >= 0; s--) {
    let r = e.charCodeAt(s) - 48;
    n && (r *= 2, r > 9 && (r -= 9)), t += r, n = !n;
  }
  return t % 10 == 0;
}
function Pi(e, t = !0) {
  return !(_e(e) || ye(e) && (e = Qo(e), (t ? Kc.test((e || "").replace(/[- ]/g, "")) : function(n) {
    let s;
    for (Jc.lastIndex = 0; s = Jc.exec(n); ) {
      const r = s[2];
      if (!r) continue;
      const o = r.replace(/[- ]/g, "");
      for (let a = 0; o.length > a; a++) for (const l of nx) {
        const d = a + l;
        if (o.length >= d) {
          const c = o.slice(a, d);
          if (Kc.test(c) && rx(c)) return !0;
        }
      }
    }
    return !1;
  }(e)) || (t ? sx.test(e) : function(n) {
    let s;
    for (Zc.lastIndex = 0; s = Zc.exec(n); ) {
      const r = s[1], o = s[3];
      if (!(r && o && Xc.test(r) && Xc.test(o))) return !0;
    }
    return !1;
  }(e))));
}
function Qc(e) {
  let t = Hi(e);
  return t = `${t} ${Of(e)}`.trim(), Pi(t) ? t : "";
}
function Of(e) {
  let t = "";
  return e && e.childNodes && e.childNodes.length && Me(e.childNodes, function(n) {
    var s;
    if (n && ((s = n.tagName) === null || s === void 0 ? void 0 : s.toLowerCase()) === "span") try {
      const r = Hi(n);
      t = `${t} ${r}`.trim(), n.childNodes && n.childNodes.length && (t = `${t} ${Of(n)}`.trim());
    } catch (r) {
      H.error("[AutoCapture]", r);
    }
  }), t;
}
function eu(e) {
  return e.replace(/"|\\"/g, '\\"');
}
function ix(e) {
  const t = e.attr__class;
  if (t) return ae(t) ? t : yd(t);
}
const oo = xt("[Dead Clicks]"), ox = () => !0, ax = (e) => {
  var t;
  const n = !!(!((t = e.instance.persistence) === null || t === void 0) && t.get_property(_d)), s = e.instance.config.capture_dead_clicks;
  return ln(s) ? s : !!xe(s) || n;
};
var tu = class {
  get lazyLoadedDeadClicksAutocapture() {
    return this.Mo;
  }
  constructor(e, t, n) {
    this.instance = e, this.isEnabled = t, this.onCapture = n, this.startIfEnabledOrStop();
  }
  onRemoteConfig(e) {
    if (!e.ok) return;
    const t = e.config;
    "captureDeadClicks" in t && (this.instance.persistence && this.instance.persistence.register({ [_d]: t.captureDeadClicks }), this.startIfEnabledOrStop());
  }
  startIfEnabledOrStop() {
    this.isEnabled(this) ? this.Eo(() => {
      this.Po();
    }) : this.stop();
  }
  Eo(e) {
    var t, n, s;
    !((t = se.__PosthogExtensions__) === null || t === void 0) && t.initDeadClicksAutocapture ? e() : (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this.instance, "dead-clicks-autocapture", (r) => {
      r ? oo.error("failed to load script", r) : e();
    });
  }
  Po() {
    var e;
    if (A) {
      if (!this.Mo && (!((e = se.__PosthogExtensions__) === null || e === void 0) && e.initDeadClicksAutocapture)) {
        const t = xe(this.instance.config.capture_dead_clicks) ? x({}, this.instance.config.capture_dead_clicks) : {};
        t.__onCapture = this.onCapture, this.onCapture && (t.capture_dead_swipes = !1), this.Mo = se.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, t), this.Mo.start(A), oo.info("starting...");
      }
    } else oo.error("`document` not found. Cannot start.");
  }
  stop() {
    this.Mo && (this.Mo.stop(), this.Mo = void 0, oo.info("stopping..."));
  }
};
const ci = xt("[SegmentIntegration]");
function nu(e, t, n = !0) {
  const s = e.config.segment;
  if (!s) return t();
  const { analytics: r, filterProperties: o } = ((l) => Yt(l.register))(a = s) ? { analytics: a } : a;
  var a;
  (function(l, d, c, u) {
    const h = (f) => {
      const m = () => f.anonymousId() || qn();
      l.config.get_device_id = m, u && f.id() && (l.register({ distinct_id: f.id(), $device_id: m() }), l.persistence.set_property(an, Co)), c(u ? void 0 : f.anonymousId() || void 0);
    }, p = d.user();
    "then" in p && Yt(p.then) ? p.then(h) : h(p);
  })(e, r, (l) => {
    r.register(((d, c, { filterProperties: u } = {}) => {
      typeof Promise < "u" && Promise.resolve || ci.warn("This browser does not have Promise support, and can not use the segment integration");
      const h = (p, f) => {
        if (!f) return p;
        const m = !!c && p.event.anonymousId === c && !p.event.userId;
        m || p.event.userId || p.event.anonymousId === d.get_distinct_id() || (ci.info("No userId set, resetting PostHog"), d.reset()), m || (c = void 0), p.event.userId && p.event.userId !== d.get_distinct_id() && (ci.info("UserId set, identifying with PostHog"), d.identify(p.event.userId));
        let g = d.calculateEventProperties(f, p.event.properties);
        if (!_e(u)) {
          const v = p.event.properties || {}, _ = {};
          for (const y of Object.keys(g)) ld.call(v, y) || (_[y] = g[y]);
          const $ = ((y, P) => {
            const j = ae(y) ? y : [y];
            let b = x({}, P);
            for (const N of j) try {
              if (b = N(b), _e(b)) return null;
            } catch (C) {
              return ci.error("Error in Segment filterProperties:", C), null;
            }
            return b;
          })(u, _);
          if (_e($)) return p;
          g = $;
        }
        return p.event.properties = Object.assign({}, g, p.event.properties), p;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded() {
        return !0;
      }, load() {
        return Promise.resolve();
      }, track(p) {
        return h(p, p.event.event);
      }, page(p) {
        return h(p, $d);
      }, identify(p) {
        return h(p, Pl);
      }, screen(p) {
        return h(p, "$screen");
      } };
    })(e, l, { filterProperties: o })).then(() => {
      t();
    }, (d) => {
      ci.error("Failed to register the Segment integration", d), t();
    });
  }, n);
}
const Ff = "posthog-js";
function Af(e, { organization: t, projectId: n, prefix: s, severityAllowList: r = ["error"], sendExceptionsToPostHog: o = !0 } = {}) {
  return (a) => {
    var l, d, c, u, h;
    if (r !== "*" && !r.includes(a.level) || !e.__loaded) return a;
    a.tags || (a.tags = {});
    const p = e.requestRouter.endpointFor("ui", `/project/${e.config.token}/person/${e.get_distinct_id()}`);
    a.tags["PostHog Person URL"] = p, e.sessionRecordingStarted() && (a.tags["PostHog Recording URL"] = e.get_session_replay_url({ withTimestamp: !0 }));
    const f = ((l = a.exception) === null || l === void 0 ? void 0 : l.values) || [], m = f.map((_) => x(x({}, _), {}, { stacktrace: _.stacktrace ? x(x({}, _.stacktrace), {}, { type: "raw", frames: (_.stacktrace.frames || []).map(($) => x(x({}, $), {}, { platform: "web:javascript" })) }) : void 0 })), g = { $exception_message: ((d = f[0]) === null || d === void 0 ? void 0 : d.value) || a.message, $exception_type: (c = f[0]) === null || c === void 0 ? void 0 : c.type, $exception_level: a.level, $exception_list: m, $sentry_event_id: a.event_id, $sentry_exception: a.exception, $sentry_exception_message: ((u = f[0]) === null || u === void 0 ? void 0 : u.value) || a.message, $sentry_exception_type: (h = f[0]) === null || h === void 0 ? void 0 : h.type, $sentry_tags: a.tags };
    var v;
    return t && n && (g.$sentry_url = (s || "https://sentry.io/organizations/") + t + "/issues/?project=" + n + "&query=" + a.event_id), o && ((v = e.exceptions) === null || v === void 0 || v.sendExceptionEvent(g)), a;
  };
}
var lx = class {
  constructor(e, t, n, s, r, o) {
    this.name = Ff, this.setupOnce = function(a) {
      a(Af(e, { organization: t, projectId: n, prefix: s, severityAllowList: r, sendExceptionsToPostHog: o == null || o }));
    };
  }
}, su = class {
  constructor(e) {
    this.Ro = (t, n, s) => {
      s && (s.noSessionId || s.activityTimeout || s.sessionPastMaximumLength || s.crossTabAdoption) && (H.info("[PageViewManager] Session rotated, clearing pageview state", { sessionId: t, changeReason: s }), this.Ao = void 0, this._instance.scrollManager.resetContext());
    }, this._instance = e, this.Fo();
  }
  Fo() {
    var e;
    this.Oo = (e = this._instance.sessionManager) === null || e === void 0 ? void 0 : e.onSessionId(this.Ro);
  }
  destroy() {
    var e;
    (e = this.Oo) === null || e === void 0 || e.call(this), this.Oo = void 0;
  }
  doPageView(e, t) {
    var n;
    const s = this.Do(e, t);
    return this.Ao = { pathname: (n = k == null ? void 0 : k.location.pathname) !== null && n !== void 0 ? n : "", pageViewId: t, timestamp: e }, this._instance.scrollManager.resetContext(), s;
  }
  doPageLeave(e) {
    var t;
    return this.Do(e, (t = this.Ao) === null || t === void 0 ? void 0 : t.pageViewId);
  }
  doEvent() {
    var e;
    return { $pageview_id: (e = this.Ao) === null || e === void 0 ? void 0 : e.pageViewId };
  }
  Do(e, t) {
    const n = this.Ao;
    if (!n) return { $pageview_id: t };
    let s = { $pageview_id: t, $prev_pageview_id: n.pageViewId };
    const r = this._instance.scrollManager.getContext();
    if (r && !this._instance.config.disable_scroll_properties) {
      let { maxScrollHeight: o, lastScrollY: a, maxScrollY: l, maxContentHeight: d, lastContentY: c, maxContentY: u } = r;
      if (!(L(o) || L(a) || L(l) || L(d) || L(c) || L(u))) {
        o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), d = Math.ceil(d), c = Math.ceil(c), u = Math.ceil(u);
        const h = o > 1 ? es(a / o, 0, 1, H) : 1, p = o > 1 ? es(l / o, 0, 1, H) : 1, f = d > 1 ? es(c / d, 0, 1, H) : 1, m = d > 1 ? es(u / d, 0, 1, H) : 1;
        s = Xe(s, { $prev_pageview_last_scroll: a, $prev_pageview_last_scroll_percentage: h, $prev_pageview_max_scroll: l, $prev_pageview_max_scroll_percentage: p, $prev_pageview_last_content: c, $prev_pageview_last_content_percentage: f, $prev_pageview_max_content: u, $prev_pageview_max_content_percentage: m });
      }
    }
    return n.pathname && (s.$prev_pageview_pathname = n.pathname), n.timestamp && (s.$prev_pageview_duration = (e.getTime() - n.timestamp.getTime()) / 1e3), s;
  }
};
const ui = ["flags", "surveys"], dx = { [mb]: { exposure: "hidden" }, [Do]: { exposure: "hidden" }, [gb]: { exposure: "hidden" }, [yl]: { exposure: "hidden" }, [Un]: { exposure: "hidden" }, [df]: { exposure: "event" }, [wl]: { exposure: "hidden" }, [uf]: { exposure: "hidden" }, [Cl]: { exposure: "event" }, [cf]: { exposure: "hidden" }, [jl]: { exposure: "event" }, [Nl]: { exposure: "event" }, [_d]: { exposure: "event" }, [md]: { exposure: "hidden" }, [hf]: { exposure: "event" }, [ki]: { exposure: "hidden" }, [vb]: { exposure: "hidden" }, [Dr]: { exposure: "hidden" }, [ff]: { exposure: "event" }, [$b]: { exposure: "event", shouldSkipFromEventProperties: (e) => gt(e) }, [Cb]: { exposure: "event" }, [jb]: { exposure: "event" }, [Nb]: { exposure: "event" }, [Sb]: { exposure: "event" }, [kb]: { exposure: "hidden" }, [zn]: { exposure: "hidden", storageGroup: "flags" }, [vs]: { exposure: "hidden", storageGroup: "flags" }, [Sl]: { exposure: "hidden" }, [gr]: { exposure: "hidden", storageGroup: "flags" }, [Ms]: { exposure: "hidden", storageGroup: "flags" }, [vr]: { exposure: "hidden", storageGroup: "flags", volatile: !0 }, [Ei]: { exposure: "hidden", storageGroup: "flags" }, [Xn]: { exposure: "hidden" }, [ur]: { exposure: "hidden" }, [Ds]: { exposure: "hidden" }, [Bs]: { exposure: "hidden" }, [kl]: { exposure: "hidden", storageGroup: "surveys" }, [Bo]: { exposure: "hidden", storageGroup: "surveys", volatile: !0 }, [_f]: { exposure: "event" }, [mf]: { exposure: "hidden" }, [gf]: { exposure: "hidden" }, [El]: { exposure: "hidden" }, [Eb]: { exposure: "hidden" }, [Ib]: { exposure: "hidden" }, [Pb]: { exposure: "event" }, [Tb]: { exposure: "event" }, [Rb]: { exposure: "event" }, [Lb]: { exposure: "event" }, [Ws]: { exposure: "hidden" }, [wi]: { exposure: "hidden" }, [pf]: { exposure: "event" }, [Ui]: { exposure: "hidden" }, [Us]: { exposure: "hidden", storageGroup: "flags", volatile: !0 }, [an]: { exposure: "hidden" }, [Il]: { exposure: "hidden" }, [Ob]: { exposure: "hidden" }, [vf]: { exposure: "hidden" }, [$f]: { exposure: "hidden" }, [Br]: { exposure: "hidden" }, [gd]: { exposure: "hidden" }, [bb]: { exposure: "event" }, [xb]: { exposure: "event" }, [yb]: { exposure: "event" }, [wb]: { exposure: "event" }, [xf]: { exposure: "event" }, [yf]: { exposure: "event" }, [wf]: { exposure: "event" }, [Fb]: { exposure: "event" }, [Ab]: { exposure: "event" }, [Mb]: { exposure: "event" }, [Db]: { exposure: "event" }, [Bb]: { exposure: "event" }, [Wb]: { exposure: "event" }, [Ub]: { exposure: "event" }, [zb]: { exposure: "event" } }, cx = [["$posthog_sr_group_event_trigger_", { exposure: "hidden" }], ["$posthog_sr_group_url_trigger_", { exposure: "hidden" }], ["$posthog_sr_group_sampling_", { exposure: "hidden" }]], Bt = (e) => {
  const t = dx[e];
  if (t) return t;
  for (const [n, s] of cx) if (e.indexOf(n) === 0) return s;
}, Wr = (e, t) => {
  try {
    let n;
    return JSON.stringify(e, (s, r) => {
      var o;
      return Ji(r) ? ((o = n) !== null && o !== void 0 || (n = /* @__PURE__ */ new WeakMap()), n.has(r) || n.set(r, jf(r)), n.get(r)) : typeof r == "bigint" ? r.toString() : r;
    }, t);
  } catch {
    return mh(e);
  }
}, Yr = (e) => {
  const t = A == null ? void 0 : A.createElement("a");
  return L(t) ? null : (t.href = e, t);
}, Kr = function(e, t) {
  const n = ((e.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&");
  let s;
  for (let r = 0; n.length > r; r++) {
    const o = n[r].split("=");
    if (o[0] === t) {
      s = o;
      break;
    }
  }
  if (!ae(s) || 2 > s.length) return "";
  {
    let r = s[1];
    try {
      r = decodeURIComponent(r);
    } catch {
      H.error("Skipping decoding for malformed query param: " + r);
    }
    return r.replace(/\+/g, " ");
  }
}, Gi = function(e, t, n) {
  if (!e || !t || !t.length) return e;
  const s = e.split("#"), r = s[1], o = (s[0] || "").split("?"), a = o[1], l = o[0], d = (a || "").split("&"), c = [];
  for (let h = 0; d.length > h; h++) {
    const p = d[h].split("=");
    ae(p) && (t.includes(p[0]) ? c.push(p[0] + "=" + n) : c.push(d[h]));
  }
  let u = l;
  return a != null && (u += "?" + c.join("&")), r != null && (u += "#" + r), u;
}, zo = function(e, t) {
  const n = e.match(new RegExp(t + "=([^&]*)"));
  return n ? n[1] : null;
}, Mf = (e, t) => e >= t && _h(), Df = (e, t, n, s) => {
  if (e === 0) {
    if (_h()) {
      const r = t + 1;
      return r === n && s(), r;
    }
    return t;
  }
  return 0;
}, Jr = ["gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx"], ux = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid", ...Jr], Vi = "<masked>", hx = ["li_fat_id"];
function Bf(e, t, n) {
  if (!A) return {};
  const s = t ? [...Jr, ...n || []] : [], r = Wf(Gi(A.URL, s, Vi), e), o = function() {
    const a = {};
    return Me(hx, function(l) {
      const d = Rl(l);
      a[l] = d || null;
    }), a;
  }();
  return Xe(o, r);
}
function Wf(e, t) {
  const n = ux.concat(t || []), s = {};
  return Me(n, function(r) {
    const o = Kr(e, r);
    s[r] = o || null;
  }), s;
}
function Uf(e) {
  const t = function(r) {
    return r ? r.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : r.search("https?://(.*)bing.com") === 0 ? "bing" : r.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : r.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  }(e), n = t != "yahoo" ? "q" : "p", s = {};
  if (!gt(t)) {
    s.$search_engine = t;
    const r = A ? Kr(A.referrer, n) : "";
    r.length && (s.ph_keyword = r);
  }
  return s;
}
function zf() {
  return navigator.language || navigator.userLanguage;
}
function fx() {
  const e = zf();
  return typeof e == "string" ? e.split("-")[0] : void 0;
}
const Ho = "$direct";
function Hf() {
  return (A == null ? void 0 : A.referrer) || Ho;
}
function qf(e, t, n = !1) {
  const s = e ? [...Jr, ...t || []] : [], r = n ? zs(ut == null ? void 0 : ut.href) : ut == null ? void 0 : ut.href, o = r == null ? void 0 : r.substring(0, 1e3);
  return { r: Hf().substring(0, 1e3), u: o ? Gi(o, s, Vi) : void 0 };
}
function Gf(e, t = !1) {
  var n;
  const { r: s, u: r } = e, o = t ? zs(r) : r, a = { $referrer: s, $referring_domain: s == null ? void 0 : s == Ho ? Ho : (n = Yr(s)) === null || n === void 0 ? void 0 : n.host };
  if (o) {
    a.$current_url = o;
    const l = Yr(o);
    a.$host = l == null ? void 0 : l.host, a.$pathname = l == null ? void 0 : l.pathname;
    const d = Wf(o);
    Xe(a, d);
  }
  if (s) {
    const l = Uf(s);
    Xe(a, l);
  }
  return a;
}
function Vf() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}
function px() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch {
    return;
  }
}
const _x = { flags: Us, surveys: Bo }, mx = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"], ao = (e) => `${e}_cookie_identity_change_pending`, lo = (e) => {
  let t = "", n = 0;
  for (const s of e) {
    const r = encodeURIComponent(JSON.stringify(s).slice(1, -1)).length;
    if (n + r > 1e3) break;
    t += s, n += r;
  }
  return t;
}, It = "main", _s = [zn, vs, gr, Ms, vr, Us, Ei, Ds], Oa = (e) => _s.indexOf(e) !== -1, Ss = (e, t) => {
  try {
    return JSON.stringify(e) === JSON.stringify(t);
  } catch {
    return e === t;
  }
}, Er = (e) => {
  if (!e) return {};
  const t = JSON.parse(e);
  return xe(t) ? t : {};
}, ru = (e, t) => {
  Me(e, (n, s) => {
    const r = Bt(s);
    r && r.exposure !== "event" || {}.hasOwnProperty.call(t, s) || delete e[s];
  });
};
var Fa = class {
  constructor(e, t, n = !0) {
    if (this.Lo = {}, this.No = !1, this.qo = !1, this.jo = !1, this.Bo = !1, this.Ho = !1, this.zo = /* @__PURE__ */ new Map(), this.Uo = !1, this.Wo = !1, this.Vo = !1, this.Go = !1, this.Zo = /* @__PURE__ */ new Set(), this.Sr = e, this.Qo = n, this.props = {}, this.Jo = void 0, this.Ko = ((s) => {
      let r = "";
      return s.token && (r = s.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), s.persistence_name ? "ph_" + s.persistence_name : "ph_" + r + "_posthog";
    })(e), this.$o = this.Yo(e), this.jo = this.Xo(e), this.load(), this.tl(), e.debug && H.info("Persistence loaded", e.persistence, x({}, this.props)), this.update_config(e, e, t), this.save(), k) {
      const s = () => this.flush();
      We(k, "beforeunload", s, { capture: !1 }), We(k, "pagehide", s, { capture: !1 }), this.el = (r) => {
        if (this.No && (!r.storageArea || r.storageArea === (k == null ? void 0 : k.localStorage)) && r.key) if (r.key !== this.Ko) {
          if (this.jo) {
            const o = ui.find((a) => r.key === this.il(a));
            o && this.nl(r.key, o);
          }
        } else this.nl(r.key, It);
      }, We(k, "storage", this.el);
    }
  }
  markCrossTabFeatureFlagChanges(e) {
    Object.entries(e).forEach(([t, n]) => {
      const s = this.zo.get(t);
      if (!Oa(t) || s === !0) return;
      if (n === !0) return void this.sl(t, !0);
      const r = new Set(s || []);
      n.forEach((o) => r.add(o)), r.size && this.sl(t, r);
    });
  }
  onCrossTabFeatureFlagChange(e) {
    return this.Zo.add(e), () => this.Zo.delete(e);
  }
  destroy() {
    this.el && k && (k.removeEventListener("storage", this.el), this.el = void 0), this.Zo.clear();
  }
  nl(e, t, n = !0) {
    if (this.pi) return !1;
    let s, r;
    try {
      if (r = ke.Ot(e), gt(r)) {
        const l = this.rl(t);
        return l.storageValue = null, t !== It && (l.persisted = !1), !1;
      }
      s = Er(r);
    } catch {
      return !1;
    }
    const o = t === It ? s : ke.Dt(this.Ko);
    if (o && this.ol(o)) return !1;
    const a = this.ll(s, t, n);
    return t === It && this.jo && !Ss(this.al().main, s) || this.ul(s, t, !0, r), a;
  }
  ol(e) {
    const t = this.props[Bn], n = e[Bn];
    return !L(t) && !L(n) && t !== n;
  }
  ul(e, t, n, s) {
    const r = this.rl(t);
    r.storageValue = s, t !== It && (r.persisted = n);
    try {
      r.fingerprint = this.hl(e, t);
    } catch {
      r.fingerprint = void 0;
    }
  }
  ll(e, t, n) {
    let s = !1;
    return _s.forEach((r) => {
      var o;
      const a = (o = Bt(r)) === null || o === void 0 ? void 0 : o.storageGroup;
      if (t === It && this.jo && a || t !== It && a !== t) return;
      const l = r in e, d = this.cl(r, l ? e[r] : void 0), c = this.zo.has(r) ? r in this.props : l;
      c === r in this.props && Ss(d, this.props[r]) || (c ? this.dl(r, d, !1) : this.vl(r, !1), s = !0);
    }), s && n && this.Zo.forEach((r) => r()), s;
  }
  fl() {
    if (!this.No) return !1;
    try {
      this.Vo = !1;
      const e = ke.Ot(this.Ko), t = this.rl(It);
      let n, s = !1, r = !1;
      if (e !== t.storageValue) if (gt(e)) t.storageValue = null;
      else {
        if (n = Er(e), this.Vo = !this.Wo && this.ol(n), this.Vo) return !1;
        r = this.ll(n, It, !1), !this.jo || Ss(this.al().main, n) ? this.ul(n, It, !0, e) : t.storageValue = e, s = !0;
      }
      return this.jo && ui.forEach((o) => {
        const a = ke.Ot(this.il(o)), l = this.rl(o), d = n || {}, c = s && _s.some((h) => {
          var p;
          return ((p = Bt(h)) === null || p === void 0 ? void 0 : p.storageGroup) === o && h in d;
        });
        if (a === l.storageValue && !c) return;
        if (gt(a)) return l.storageValue = null, l.persisted = !1, void (c && (r = this.ll(d, o, !1) || r));
        const u = Er(a);
        r = this.ll(u, o, !1) || r, this.ul(u, o, !0, a);
      }), r;
    } catch {
      return !1;
    }
  }
  sl(e, t) {
    this.zo.set(e, t);
    const n = Bt(e);
    n != null && n.volatile || (this.rl((this.jo ? n == null ? void 0 : n.storageGroup : void 0) || It).fingerprint = void 0, this.pl(e));
  }
  gl() {
    _s.forEach((e) => this.zo.set(e, !0));
  }
  tl() {
    if (this.No) try {
      const e = ke.Ot(this.Ko), t = Er(e);
      this.rl(It).storageValue = e, _s.forEach((n) => {
        var s;
        const r = this.jo ? (s = Bt(n)) === null || s === void 0 ? void 0 : s.storageGroup : void 0, o = r ? ke.Ot(this.il(r)) : null;
        if (r) {
          const l = this.rl(r);
          l.storageValue = o, l.persisted = !gt(o);
        }
        const a = r && !gt(o) ? Er(o) : t;
        n in this.props ? this.ml(n, a[n], this.props[n]) : n in a && this.sl(n, !0);
      });
    } catch {
    }
  }
  cl(e, t) {
    const n = this.zo.get(e);
    if (!n) return t;
    if (n === !0) return this.props[e];
    if (e === "$active_feature_flags") {
      const o = new Set(ae(t) ? t : []), a = new Set(ae(this.props[e]) ? this.props[e] : []);
      return n.forEach((l) => a.has(l) ? o.add(l) : o.delete(l)), Array.from(o);
    }
    const s = xe(t) ? x({}, t) : {}, r = xe(this.props[e]) ? this.props[e] : {};
    return n.forEach((o) => {
      o in r ? s[o] = r[o] : delete s[o];
    }), s;
  }
  ml(e, t, n) {
    if (!Oa(e)) return;
    const s = this.zo.get(e);
    if (s === !0) return;
    let r = t;
    if (this.No) try {
      var o;
      const l = this.jo ? (o = Bt(e)) === null || o === void 0 ? void 0 : o.storageGroup : void 0, d = l ? this.il(l) : this.Ko;
      r = Er(ke.Ot(d))[e];
    } catch {
    }
    const a = new Set(s || []);
    if (e === "$active_feature_flags") {
      if (!L(t) && !ae(t) || !L(r) && !ae(r) || !ae(n)) return void this.sl(e, !0);
      const l = new Set(t || []), d = new Set(r || []), c = new Set(n);
      (/* @__PURE__ */ new Set([...l, ...c])).forEach((u) => {
        l.has(u) !== c.has(u) && a.add(u);
      }), a.forEach((u) => {
        d.has(u) === c.has(u) && a.delete(u);
      });
    } else {
      if (!xe(n)) return void (Ss(r, n) ? this.zo.delete(e) : this.sl(e, !0));
      {
        if (!L(t) && !xe(t) || L(t) && mn(n) && L(r)) return void this.sl(e, !0);
        const l = xe(t) ? t : {}, d = xe(r) ? r : {};
        (/* @__PURE__ */ new Set([...Object.keys(l), ...Object.keys(n)])).forEach((c) => {
          c in l == c in n && Ss(l[c], n[c]) || a.add(c);
        }), a.forEach((c) => {
          c in d == c in n && Ss(d[c], n[c]) && a.delete(c);
        });
      }
    }
    a.size ? this.sl(e, a) : this.zo.delete(e);
  }
  yl() {
    var e;
    const t = (e = this.Sr) === null || e === void 0 ? void 0 : e.persistence_save_debounce_ms;
    return bt(t) && t > 0 ? t : 0;
  }
  bl(e) {
    if (this.Sr.cookieWinsOnConflict && this.Sr.persistence.toLowerCase() === "localstorage+cookie") if (e) try {
      const t = Ta(e, this.Sr.cookie_persisted_properties || []), n = zc(t, this.Sr.cookie_persisted_properties || []), s = JSON.stringify(t) + "|" + JSON.stringify(n), r = dt.Ot(this.Ko) || void 0;
      r && Ra(this.Ko, r) === s && (this._l = s, this.wl = r);
    } catch {
    }
    else try {
      const t = dt.Ot(this.Ko) || void 0;
      this._l = t ? Ra(this.Ko, t) : void 0, this.wl = t;
    } catch {
    }
  }
  syncCookieProperties() {
    return this.kl(this.Sr);
  }
  kl(e, t = !1) {
    if (this.pi && !t || this.Ho || !e.cookieWinsOnConflict || e.persistence.toLowerCase() !== "localstorage+cookie") return !1;
    let n;
    try {
      n = dt.Ot(this.Ko) || void 0;
    } catch {
    }
    if (!n || n === this.wl) return !1;
    const s = Ra(this.Ko, n);
    let r;
    try {
      r = Pa(JSON.parse(n));
    } catch {
      return !1;
    }
    if ((dt.Ot(this.Ko) || void 0) !== n) return !1;
    this._l = s, this.wl = n;
    const o = Hc(this.Ko, n), a = [...hr, ...o.properties], l = {};
    if (Object.keys(r).forEach((g) => {
      const v = r[g];
      (L(v) || gt(v) || v === "" || g === "$user_state" && v !== "anonymous" && v !== "identified") && (l[g] = !0, delete r[g]);
    }), mn(r)) return !1;
    const d = "distinct_id" in r || r.$user_state === "anonymous" || r.$user_state === "identified", c = this.props, u = c[Bn], h = c[an], p = Xe({}, c);
    [...hr, ...e.cookie_persisted_properties || []].forEach((g) => {
      if (a.indexOf(g) !== -1 && !(g in r) && !l[g] && (d || g !== "distinct_id" && g !== "$user_state")) {
        const v = p[g];
        (o.isValid || hr.indexOf(g) === -1 || v !== !1 && v !== 0) && delete p[g];
      }
    }), this.props = Xe(p, r), _s.forEach((g) => {
      const v = g in this.props;
      g in c === v && Ss(c[g], this.props[g]) || (v ? this.ml(g, c[g], this.props[g]) : this.sl(g, !0));
    }), !d || "$user_state" in r || "$user_state" in this.props || this.dl(an, $s);
    const f = this.props[Bn], m = this.props[an];
    return !d || f === u && m === h || (this.Wo = !0, this.Bo = !0, Ze.At(ao(this.Ko), !0), this.vl(Ds), this.vl(vs), this.vl(zn), this.vl(gr), this.vl(Ms), this.vl(vr), this.vl(Us), this.vl(Ui), this.vl(Ws), m !== "anonymous" || h !== "identified" && r.$user_state !== "anonymous" && (L(u) || f === u) || (ru(this.props, r), this.vl(Bs)), m === "identified" ? this.props.$user_id = f : delete this.props.$user_id, this.vl(Do)), !0;
  }
  consumeCookieIdentityChange() {
    const e = ao(this.Ko), t = this.Bo || !!Ze.Ot(e);
    return this.Bo = !1, t && Ze.Lt(e), t;
  }
  Sl(e = !1) {
    return !(this.Ho || this.pi && !e || !this.Sr.cookieWinsOnConflict || this.Sr.persistence.toLowerCase() !== "localstorage+cookie" || (this.Ho = !0, 0));
  }
  xl() {
    this.Ho && (L(this.Cl) || (clearTimeout(this.Cl), this.Cl = void 0), delete this.Lo[It], this.$l(!0));
  }
  Tl(e = !0) {
    if (this.Ho) try {
      e ? this.xl() : L(this.Cl) || (clearTimeout(this.Cl), this.Cl = void 0);
    } finally {
      this.Ho = !1;
    }
  }
  isDisabled() {
    return !!this.pi;
  }
  Yo(e) {
    mx.indexOf(e.persistence.toLowerCase()) === -1 && (H.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
    const t = ((a = [], l = !1) => {
      const d = [...hr, ...a];
      return x(x({}, ke), {}, { Dt(c) {
        try {
          let h, p = {};
          try {
            h = dt.Ot(c) || void 0, p = h ? Pa(JSON.parse(h)) : {};
          } catch {
          }
          const f = JSON.parse(ke.Ot(c) || "{}");
          let m;
          if (l) {
            const g = Hc(c, h), v = [...hr, ...g.properties], _ = {};
            Object.keys(p).forEach((y) => {
              const P = p[y];
              gt(P) || P === "" || y === "$user_state" && P !== "anonymous" && P !== "identified" || (_[y] = P);
            });
            const $ = "distinct_id" in _ || _.$user_state === "anonymous" || _.$user_state === "identified";
            if (Object.keys(_).length > 0) {
              var u;
              const y = f[Bn], P = (u = f.$user_state) !== null && u !== void 0 ? u : $s;
              d.forEach((j) => {
                if (v.indexOf(j) !== -1 && !(j in p) && ($ || j !== "distinct_id" && j !== "$user_state")) {
                  const b = f[j];
                  (g.isValid || hr.indexOf(j) === -1 || b !== !1 && b !== 0) && delete f[j];
                }
              }), !$ || "$user_state" in p || "$user_state" in f || (f[an] = $s), !$ || ("distinct_id" in _ ? _[Bn] : f[Bn]) === y && ("$user_state" in _ ? _[an] : f[an]) === P || (Ia.forEach((j) => delete f[j]), _.$user_state === "identified" && "distinct_id" in _ ? f.$user_id = _[Bn] : delete f.$user_id, _.$user_state !== "identified" && (delete f[pf], delete f[Bs]), delete f.__alias);
            }
            m = Xe(f, _);
          } else m = Xe(p, f);
          return ke.At(c, m), m;
        } catch {
        }
        return null;
      }, At(c, u, h, p, f, m) {
        const g = ke.At(c, u, void 0, void 0, m);
        try {
          const v = Ta(u, a);
          if (Object.keys(v).length) {
            if (l) {
              const _ = Uo(c), $ = zc(v, a);
              if (dt.At(_, $, h, p, f, m), dt.Ot(_) !== JSON.stringify($)) {
                dt.Lt(_, p);
                const y = Ta(u);
                return dt.At(c, y, h, p, f, m), g;
              }
            }
            dt.At(c, v, h, p, f, m);
          }
        } catch (v) {
          ke.Pt(v);
        }
        return g;
      }, Lt(c, u) {
        try {
          k == null || k.localStorage.removeItem(c), dt.Lt(c, u), dt.Lt(Uo(c), u);
        } catch (h) {
          ke.Pt(h);
        }
      } });
    })(e.cookie_persisted_properties || [], e.cookieWinsOnConflict);
    let n, s = !1, r = !1;
    const o = e.persistence.toLowerCase();
    return o === "localstorage" && ke.Et() ? (n = ke, r = !0) : o === "localstorage+cookie" && t.Et() ? (n = t, r = !0, s = !0) : o === "sessionstorage" && Ze.Et() ? n = Ze : o === "memory" ? n = Ol : o === "cookie" && dt.Et() ? (n = dt, s = !0) : t.Et() ? (n = t, r = !0, s = !0) : dt.Et() ? (n = dt, s = !0) : n = Ol, this.No = r, this.qo = s, n;
  }
  il(e) {
    return `${this.Ko}__${e}`;
  }
  Xo(e) {
    return this.No && !!e.split_storage;
  }
  properties() {
    const e = {};
    return Me(this.props, (t, n) => {
      const s = Bt(n);
      if (!s || s.exposure === "event") {
        var r;
        if (!(s == null || (r = s.shouldSkipFromEventProperties) === null || r === void 0) && r.call(s, t)) return;
        e[n] = t;
      }
    }), e;
  }
  load(e = !1) {
    if (this.pi && !e) return;
    const t = this.Sr.cookieWinsOnConflict && this.Sr.persistence.toLowerCase() === "localstorage+cookie", n = t ? ke.Dt(this.Ko) : null;
    let s = {};
    if (t) try {
      s = Pa(dt.Dt(this.Ko)), Me(s, (l, d) => {
        (L(l) || gt(l) || l === "") && delete s[d];
      });
    } catch {
    }
    const r = this.$o.Dt(this.Ko);
    if (r && (this.props = Xe({}, r)), this.jo && this.Il(), t && r) {
      var o, a;
      const l = n == null ? void 0 : n[Bn], d = (o = n == null ? void 0 : n.$user_state) !== null && o !== void 0 ? o : $s, c = r[Bn], u = (a = r.$user_state) !== null && a !== void 0 ? a : $s;
      if (c !== l || u !== d) {
        this.Bo = !0, Ze.At(ao(this.Ko), !0);
        const h = Xe({}, this.props);
        Ia.forEach((f) => delete h[f]), u !== "anonymous" || d !== "identified" && s.$user_state !== "anonymous" && (L(l) || c === l) || (ru(h, s), delete h[Bs]), this.props = h;
        const p = /* @__PURE__ */ new Set();
        Ia.forEach((f) => {
          var m;
          const g = (m = Bt(f)) === null || m === void 0 ? void 0 : m.storageGroup;
          g && p.add(g);
        }), p.forEach((f) => {
          const m = {};
          Me(this.props, (g, v) => {
            var _;
            ((_ = Bt(v)) === null || _ === void 0 ? void 0 : _.storageGroup) === f && (m[v] = g);
          }), mn(m) ? (ke.Lt(this.il(f)), this.Lo[f] = {}) : ke.At(this.il(f), m) && (this.Lo[f] = { persisted: !0, fingerprint: this.hl(m, f) });
        });
      }
    }
    Ze.Ot(ao(this.Ko)) && (this.Bo = !0);
  }
  Il() {
    for (const e of ui) {
      const t = ke.Dt(this.il(e));
      if (t && !mn(t)) {
        const n = this.rl(e);
        n.persisted = !0, this.Ml(e) || (n.fingerprint = this.hl(t, e)), this.El(e, t) || Xe(this.props, t);
      }
    }
  }
  Ml(e) {
    return Object.keys(this.props).some((t) => {
      var n;
      return ((n = Bt(t)) === null || n === void 0 ? void 0 : n.storageGroup) === e;
    });
  }
  El(e, t) {
    const n = _x[e];
    if (!n) return !1;
    const s = t[n], r = this.props[n];
    return bt(s) && bt(r) && r > s;
  }
  refreshKey(e) {
    var t;
    if (this.pi || e === "$fbc_persistence" && this.Go) return;
    const n = this.jo ? (t = Bt(e)) === null || t === void 0 ? void 0 : t.storageGroup : void 0, s = n ? ke.Dt(this.il(n)) : this.$o.Dt(this.Ko);
    if (s && e in s) this.dl(e, s[e], !1);
    else {
      if (n) {
        const r = this.$o.Dt(this.Ko);
        if (r && e in r) return void this.dl(e, r[e], !1);
      }
      this.vl(e, !1);
    }
  }
  save() {
    if (this.pi) return;
    const e = this.yl();
    e > 0 ? L(this.Cl) && (this.Cl = setTimeout(() => {
      this.Cl = void 0, this.$l();
    }, e)) : this.$l();
  }
  flush() {
    L(this.Cl) || (clearTimeout(this.Cl), this.Cl = void 0, this.$l());
  }
  $l(e = !1) {
    if (this.pi || this.Ho && !e) return;
    e || (this.syncCookieProperties(), this.Go || this.Sr.cookieWinsOnConflict && this.Sr.persistence.toLowerCase() === "localstorage+cookie" || this.refreshKey(Un));
    const t = !e && !this.Uo;
    t || (this.Vo = !1);
    const n = !!t && this.fl();
    if (this.Vo) return void (this.Sr.debug && H.warn("skipping persistence write because storage belongs to a different distinct ID"));
    if (this.jo) return this.Pl(), void (n && this.Zo.forEach((r) => r()));
    const s = this.Rl(this.$o, this.Ko, this.props, It);
    s === "written" && this.bl(this.props), s !== "failed" && (this.zo.clear(), this.Wo = !1, this.Go = !1), n && this.Zo.forEach((r) => r());
  }
  Pl() {
    const { main: e, groups: t } = this.al(), n = this.Rl(this.$o, this.Ko, e, It);
    n === "written" && this.bl(e), n !== "failed" && (this.Wo = !1, this.Go = !1, _s.forEach((r) => {
      var o;
      !((o = Bt(r)) === null || o === void 0) && o.storageGroup || this.zo.delete(r);
    }));
    for (const r of ui) {
      var s;
      const o = t[r];
      if (mn(o) && !(!((s = this.Lo[r]) === null || s === void 0) && s.persisted)) {
        _s.forEach((l) => {
          var d;
          ((d = Bt(l)) === null || d === void 0 ? void 0 : d.storageGroup) === r && this.zo.delete(l);
        });
        continue;
      }
      const a = this.Rl(ke, this.il(r), o, r);
      a !== "failed" && _s.forEach((l) => {
        const d = Bt(l);
        (d == null ? void 0 : d.storageGroup) !== r || a !== "written" && d.volatile || this.zo.delete(l);
      });
    }
  }
  al() {
    const e = {}, t = { flags: {}, surveys: {} };
    return Me(this.props, (n, s) => {
      var r;
      const o = (r = Bt(s)) === null || r === void 0 ? void 0 : r.storageGroup;
      o ? t[o][s] = n : e[s] = n;
    }), { main: e, groups: t };
  }
  hl(e, t) {
    if (t === It) return JSON.stringify(e) + "|" + this.Al + "|" + this.Fl + "|" + this.Ol;
    const n = {};
    return Me(e, (s, r) => {
      var o;
      n[r] = !((o = Bt(r)) === null || o === void 0) && o.volatile ? "__volatile__" : s;
    }), JSON.stringify(n);
  }
  Rl(e, t, n, s) {
    const r = this.rl(s);
    if (s !== It && !r.dirty && !L(r.fingerprint)) return "skipped";
    let o;
    try {
      if (o = this.hl(n, s), o === r.fingerprint) return r.dirty = !1, "skipped";
    } catch {
      o = void 0;
    }
    return e.At(t, n, this.Al, this.Fl, this.Ol, this.Sr.debug) ? (r.dirty = !1, s !== It && (r.persisted = !0), L(o) || (r.fingerprint = o), this.No && (r.storageValue = ke.Ot(t)), "written") : (this.Sr.debug && H.warn(`failed to persist storage entry "${t}"; will retry on next save`), "failed");
  }
  remove({ keepGroupEntries: e = !1 } = {}) {
    if (this.gl(), L(this.Cl) || (clearTimeout(this.Cl), this.Cl = void 0), this.$o.Lt(this.Ko, !1), this.$o.Lt(this.Ko, !0), !e && this.Qo) for (const t of ui) ke.Lt(this.il(t));
    e ? delete this.Lo[It] : this.Lo = {}, this._l = void 0, this.wl = void 0;
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(e, t, n) {
    if (xe(e)) {
      this.syncCookieProperties(), L(t) && (t = "None"), this.Al = L(n) ? this.Dl : n;
      let s = !1;
      if (Me(e, (r, o) => {
        this.props.hasOwnProperty(o) && this.props[o] !== t || (this.dl(o, r), s = !0);
      }), s) return this.save(), !0;
    }
    return !1;
  }
  register(e, t) {
    if (xe(e)) {
      this.syncCookieProperties(), this.Al = L(t) ? this.Dl : t;
      let n = !1;
      if (Me(e, (s, r) => {
        e.hasOwnProperty(r) && (this.props[r] !== s || xe(s) || ae(s)) && (this.dl(r, s), n = !0);
      }), n) return this.save(), !0;
    }
    return !1;
  }
  unregister(e) {
    this.syncCookieProperties();
    const t = typeof e == "string" ? [e] : e;
    let n = !1;
    for (const s of t) s in this.props && (this.vl(s), n = !0);
    n && this.save();
  }
  update_campaign_params() {
    const e = A == null ? void 0 : A.URL;
    if (e === this.Jo) return;
    const t = Bf(this.Sr.custom_campaign_params, this.Sr.mask_personal_data_properties, this.Sr.custom_personal_data_properties), n = !mn(bd(t));
    return n && this.register(t), this.Jo = e, n ? t : void 0;
  }
  update_search_keyword() {
    this.register(function() {
      const e = A == null ? void 0 : A.referrer;
      return e ? Uf(e) : {};
    }());
  }
  update_referrer_info() {
    var e;
    this.register_once({ $referrer: Hf(), $referring_domain: (A == null ? void 0 : A.referrer) && ((e = Yr(A.referrer)) === null || e === void 0 ? void 0 : e.host) || Ho }, void 0);
  }
  set_initial_person_info() {
    if (this.props.$initial_campaign_params || this.props.$initial_referrer_info) return;
    const e = qf(this.Sr.mask_personal_data_properties, this.Sr.custom_personal_data_properties, this.Sr.disable_capture_url_hashes);
    this.register_once({ [Br]: this.qo ? { r: lo(e.r), u: e.u ? lo(e.u) : void 0 } : e }, void 0);
  }
  get_initial_props() {
    const e = {};
    Me([$f, vf], (n) => {
      const s = this.props[n];
      s && Me(s, function(r, o) {
        e["$initial_" + pl(o)] = r;
      });
    });
    const t = this.props[Br];
    if (t) {
      const n = function(s, r = !1) {
        const o = Gf(s, r), a = {};
        return Me(o, function(l, d) {
          a[`$initial_${pl(d)}`] = l;
        }), a;
      }(t, this.Sr.disable_capture_url_hashes);
      Xe(e, n);
    }
    return e;
  }
  safe_merge(e) {
    return Me(this.props, function(t, n) {
      n in e || (e[n] = t);
    }), e;
  }
  update_config(e, t, n) {
    const s = e.persistence !== t.persistence, r = !((f, m) => {
      if (f.length !== m.length) return !1;
      const g = [...f].sort(), v = [...m].sort();
      return g.every((_, $) => _ === v[$]);
    })(e.cookie_persisted_properties || [], t.cookie_persisted_properties || []), o = s || r, a = e.cookieWinsOnConflict !== t.cookieWinsOnConflict, l = e.disable_persistence || !!n, d = !!this.pi && !l;
    l || this.kl(t, d), this.Sr = e, !l && (s || r || a) && (this._l = void 0, this.wl = void 0, this.kl(x(x({}, e), {}, { cookie_persisted_properties: t.cookie_persisted_properties }), d));
    const c = o || a ? this.Yo(e) : this.$o;
    this.Ll();
    const u = this.Xo(e), h = o || u !== this.jo, p = !l && (h || e.cross_subdomain_cookie !== this.Fl || e.secure_cookie !== this.Ol) && this.Sl(d);
    this.Uo = h;
    try {
      if (this.Dl = this.Al = e.cookie_expiration, this.set_disabled(l), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), h) {
        const f = this.props;
        this.clear(), this.$o = c, this.jo = u, this.props = f, this.save();
      } else a && (this.$o = c, l || (delete this.Lo[It], this.$l()));
    } finally {
      this.Uo = !1, p && this.Tl();
    }
  }
  Ll() {
    const e = this.props[Br];
    if (!this.qo || !xe(e) || typeof e.r != "string") return;
    const t = lo(e.r), n = typeof e.u == "string" ? lo(e.u) : e.u;
    t === e.r && n === e.u || this.dl(Br, x(x({}, e), {}, { r: t, u: n }));
  }
  set_disabled(e) {
    this.pi = e, this.pi ? this.remove() : this.save();
  }
  set_cross_subdomain(e) {
    e !== this.Fl && (this.Fl = e, this.remove({ keepGroupEntries: !0 }), this.save());
  }
  set_secure(e) {
    e !== this.Ol && (this.Ol = e, this.remove({ keepGroupEntries: !0 }), this.save());
  }
  set_event_timer(e, t) {
    const n = this.props.__timers || {};
    n[e] = t, this.dl(yl, n), this.save();
  }
  remove_event_timer(e) {
    const t = this.props.__timers || {}, n = t[e];
    return L(n) || (delete t[e], this.dl(yl, t), this.save()), n;
  }
  get_property(e) {
    return this.props[e];
  }
  set_property(e, t) {
    this.dl(e, t), this.save();
  }
  dl(e, t, n = !0) {
    var s;
    const r = this.props[e];
    this.props[e] = t, n && (e !== "distinct_id" && e !== "$user_state" || r === t || (this.Wo = !0), e !== "$fbc_persistence" || Ss(r, t) || (this.Go = !0), this.ml(e, r, t), !((s = Bt(e)) === null || s === void 0) && s.volatile || this.pl(e));
  }
  vl(e, t = !0) {
    delete this.props[e], t && (Oa(e) && this.sl(e, !0), e === "$fbc_persistence" && (this.Go = !0), this.pl(e));
  }
  pl(e) {
    var t;
    const n = (t = Bt(e)) === null || t === void 0 ? void 0 : t.storageGroup;
    n && (this.rl(n).dirty = !0);
  }
  rl(e) {
    return this.Lo[e] || (this.Lo[e] = {});
  }
};
const jn = { GZipJS: "gzip-js", Base64: "base64" }, hi = { Activation: "events", Cancellation: "cancelEvents" }, Aa = { Popover: "popover", API: "api", Widget: "widget", ExternalSurvey: "external_survey" }, bs = { SHOWN: "survey shown", DISMISSED: "survey dismissed", SENT: "survey sent", ABANDONED: "survey abandoned" }, Ma = { SURVEY_ID: "$survey_id", SURVEY_NAME: "$survey_name", SURVEY_RESPONSE: "$survey_response", SURVEY_ITERATION: "$survey_iteration", SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date", SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed", SURVEY_SUBMISSION_ID: "$survey_submission_id", SURVEY_QUESTIONS: "$survey_questions", SURVEY_COMPLETED: "$survey_completed", PRODUCT_TOUR_ID: "$product_tour_id", SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date", SURVEY_LANGUAGE: "$survey_language" }, Ml = { Popover: "popover", Inline: "inline" };
function co(e) {
  let t = !0;
  return { dispose() {
    if (t) {
      t = !1;
      const n = e();
      n && Yt(n.then) && n.then(void 0, () => {
      });
    }
  } };
}
const gx = { SHOWN: "product tour shown", DISMISSED: "product tour dismissed", COMPLETED: "product tour completed", STEP_SHOWN: "product tour step shown", STEP_COMPLETED: "product tour step completed", BUTTON_CLICKED: "product tour button clicked", STEP_SELECTOR_FAILED: "product tour step selector failed", BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed", BANNER_ACTION_CLICKED: "product tour banner action clicked" }, iu = { TOUR_ID: "$product_tour_id", TOUR_NAME: "$product_tour_name", TOUR_ITERATION: "$product_tour_iteration", TOUR_RENDER_REASON: "$product_tour_render_reason", TOUR_STEP_ID: "$product_tour_step_id", TOUR_STEP_ORDER: "$product_tour_step_order", TOUR_STEP_TYPE: "$product_tour_step_type", TOUR_DISMISS_REASON: "$product_tour_dismiss_reason", TOUR_BUTTON_TEXT: "$product_tour_button_text", TOUR_BUTTON_ACTION: "$product_tour_button_action", TOUR_BUTTON_LINK: "$product_tour_button_link", TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id", TOUR_STEPS_COUNT: "$product_tour_steps_count", TOUR_STEP_SELECTOR: "$product_tour_step_selector", TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found", TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag", TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id", TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes", TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text", TOUR_ERROR: "$product_tour_error", TOUR_MATCHES_COUNT: "$product_tour_matches_count", TOUR_FAILURE_PHASE: "$product_tour_failure_phase", TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element", TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms", TOUR_BANNER_SELECTOR: "$product_tour_banner_selector", TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id", USE_MANUAL_SELECTOR: "$use_manual_selector", INFERENCE_DATA_PRESENT: "$inference_data_present", TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date", TOUR_TYPE: "$product_tour_type" }, ou = xt("[RateLimiter]");
var vx = class {
  constructor(e) {
    this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t) => {
      const n = t.text;
      if (n && n.length) try {
        (JSON.parse(n).quota_limited || []).forEach((s) => {
          ou.info(`${s || "events"} is quota limited.`), this.serverLimits[s] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (s) {
        return void ou.warn(`could not rate limit - continuing. Error: "${s == null ? void 0 : s.message}"`, { text: n });
      }
    }, this.instance = e, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  get captureEventsPerSecond() {
    var e;
    return ((e = this.instance.config.rate_limiting) === null || e === void 0 ? void 0 : e.events_per_second) || 10;
  }
  get captureEventsBurstLimit() {
    var e;
    return Math.max(((e = this.instance.config.rate_limiting) === null || e === void 0 ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
  }
  clientRateLimitContext(e = !1) {
    var t, n, s;
    const { captureEventsBurstLimit: r, captureEventsPerSecond: o } = this, a = (/* @__PURE__ */ new Date()).getTime(), l = (t = (n = this.instance.persistence) === null || n === void 0 ? void 0 : n.get_property("$capture_rate_limit")) !== null && t !== void 0 ? t : { tokens: r, last: a };
    l.tokens += (a - l.last) / 1e3 * o, l.last = a, l.tokens > r && (l.tokens = r);
    const d = 1 > l.tokens;
    if (d || e || (l.tokens = Math.max(0, l.tokens - 1)), d && !e) {
      const c = (bt(l.dropped) ? l.dropped : 0) + 1;
      l.dropped = c, !this.lastEventRateLimited && this.Nl(c) && (l.dropped = 0);
    }
    return this.lastEventRateLimited = d, (s = this.instance.persistence) === null || s === void 0 || s.set_property("$capture_rate_limit", l), { isRateLimited: d, remainingTokens: l.tokens };
  }
  ql(e) {
    const t = this.instance.config.property_denylist;
    return !ae(t) || !t.includes(e);
  }
  jl() {
    var e;
    if (this.ql("$current_url") && this.ql("$pathname") && (ut != null && ut.pathname)) return `${(e = ut.origin) !== null && e !== void 0 ? e : ""}${ut.pathname}`;
  }
  Nl(e) {
    var t, n;
    const { captureEventsBurstLimit: s, captureEventsPerSecond: r } = this, o = this.jl(), a = this.ql("$session_id") ? (t = (n = this.instance).get_session_id) === null || t === void 0 ? void 0 : t.call(n) : void 0, l = [`${e} event(s) dropped since the last warning`, o ? `triggered on ${o}` : void 0, a ? `session ${a}` : void 0].filter(Boolean).join(", ");
    return !!this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: `posthog-js client rate limited: ${l}. Config is set to ${r} events per second and ${s} events burst limit.` }, { skip_client_rate_limiting: !0 });
  }
  isServerRateLimited(e) {
    const t = this.serverLimits[e || "events"] || !1;
    return t !== !1 && (/* @__PURE__ */ new Date()).getTime() < t;
  }
};
const ks = xt("[RemoteConfig]");
var Yf = class {
  constructor(e) {
    this._instance = e;
  }
  get remoteConfig() {
    var e;
    return (e = se._POSTHOG_REMOTE_CONFIG) === null || e === void 0 || (e = e[this._instance.config.token]) === null || e === void 0 ? void 0 : e.config;
  }
  Bl(e) {
    var t, n, s;
    !((t = se.__PosthogExtensions__) === null || t === void 0) && t.loadExternalDependency ? (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this._instance, "remote-config", () => e(this.remoteConfig)) : e();
  }
  Hl(e) {
    this._instance._send_request({ method: "GET", url: this._instance.requestRouter.endpointFor("assets", `/array/${this._instance.config.token}/config`), callback: e });
  }
  load() {
    try {
      if (this.remoteConfig) return ks.info("Using preloaded remote config", this.remoteConfig), void this.zl(this.remoteConfig);
      if (this._instance.Ul()) return void ks.warn("Remote config is disabled. Falling back to local config.");
      this.Bl((e) => {
        if (!e) return ks.info("No config found after loading remote JS config. Falling back to JSON."), void this.Hl((t) => {
          this.zl(t.json, t);
        });
        this.zl(e);
      });
    } catch (e) {
      ks.error("Error loading remote config", e), this.zl();
    }
  }
  zl(e, t) {
    !e && t && (t.statusCode === 0 ? t.error || ks.warn("Failed to fetch remote config from PostHog.") : ks.error("Failed to fetch remote config from PostHog."));
    try {
      this._instance.zl(e ? { ok: !0, config: e } : { ok: !1 });
    } catch (s) {
      ks.error("Error applying remote config", s);
    }
    if ((e == null ? void 0 : e.hasFeatureFlags) !== !1 && !this._instance.config.advanced_disable_feature_flags_on_first_load) try {
      var n;
      (n = this._instance.featureFlags) === null || n === void 0 || n.ensureFlagsLoaded();
    } catch (s) {
      ks.error("Error loading feature flags", s);
    }
  }
}, Fn = Uint8Array, vn = Uint16Array, Zr = Uint32Array, jd = new Fn([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), Nd = new Fn([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), au = new Fn([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Kf = function(e, t) {
  for (var n = new vn(31), s = 0; 31 > s; ++s) n[s] = t += 1 << e[s - 1];
  var r = new Zr(n[30]);
  for (s = 1; 30 > s; ++s) for (var o = n[s]; n[s + 1] > o; ++o) r[o] = o - n[s] << 5 | s;
  return [n, r];
}, Jf = Kf(jd, 2), Dl = Jf[1];
Jf[0][28] = 258, Dl[258] = 28;
for (var lu = Kf(Nd, 0)[1], Zf = new vn(32768), ht = 0; 32768 > ht; ++ht) {
  var Ir = (43690 & ht) >>> 1 | (21845 & ht) << 1;
  Zf[ht] = ((65280 & (Ir = (61680 & (Ir = (52428 & Ir) >>> 2 | (13107 & Ir) << 2)) >>> 4 | (3855 & Ir) << 4)) >>> 8 | (255 & Ir) << 8) >>> 1;
}
var Ti = function(e, t, n) {
  for (var s = e.length, r = 0, o = new vn(t); s > r; ++r) ++o[e[r] - 1];
  var a, l = new vn(t);
  for (r = 0; t > r; ++r) l[r] = l[r - 1] + o[r - 1] << 1;
  for (a = new vn(s), r = 0; s > r; ++r) a[r] = Zf[l[e[r] - 1]++] >>> 15 - e[r];
  return a;
}, br = new Fn(288);
for (ht = 0; 144 > ht; ++ht) br[ht] = 8;
for (ht = 144; 256 > ht; ++ht) br[ht] = 9;
for (ht = 256; 280 > ht; ++ht) br[ht] = 7;
for (ht = 280; 288 > ht; ++ht) br[ht] = 8;
var qo = new Fn(32);
for (ht = 0; 32 > ht; ++ht) qo[ht] = 5;
var $x = Ti(br, 9), bx = Ti(qo, 5), Xf = function(e) {
  return (e / 8 | 0) + (7 & e && 1);
}, Qf = function(e, t, n) {
  (n == null || n > e.length) && (n = e.length);
  var s = new (e instanceof vn ? vn : e instanceof Zr ? Zr : Fn)(n - t);
  return s.set(e.subarray(t, n)), s;
}, is = function(e, t, n) {
  var s = t / 8 | 0;
  e[s] |= n <<= 7 & t, e[s + 1] |= n >>> 8;
}, fi = function(e, t, n) {
  var s = t / 8 | 0;
  e[s] |= n <<= 7 & t, e[s + 1] |= n >>> 8, e[s + 2] |= n >>> 16;
}, Da = function(e, t) {
  for (var n = [], s = 0; e.length > s; ++s) e[s] && n.push({ s, f: e[s] });
  var r = n.length, o = n.slice();
  if (!r) return [new Fn(0), 0];
  if (r == 1) {
    var a = new Fn(n[0].s + 1);
    return a[n[0].s] = 1, [a, 1];
  }
  n.sort(function(j, b) {
    return j.f - b.f;
  }), n.push({ s: -1, f: 25001 });
  var l = n[0], d = n[1], c = 0, u = 1, h = 2;
  for (n[0] = { s: -1, f: l.f + d.f, l, r: d }; u != r - 1; ) l = n[n[h].f > n[c].f ? c++ : h++], d = n[c != u && n[h].f > n[c].f ? c++ : h++], n[u++] = { s: -1, f: l.f + d.f, l, r: d };
  var p = o[0].s;
  for (s = 1; r > s; ++s) o[s].s > p && (p = o[s].s);
  var f = new vn(p + 1), m = Bl(n[u - 1], f, 0);
  if (m > t) {
    s = 0;
    var g = 0, v = m - t, _ = 1 << v;
    for (o.sort(function(j, b) {
      return f[b.s] - f[j.s] || j.f - b.f;
    }); r > s; ++s) {
      var $ = o[s].s;
      if (t >= f[$]) break;
      g += _ - (1 << m - f[$]), f[$] = t;
    }
    for (g >>>= v; g > 0; ) {
      var y = o[s].s;
      t > f[y] ? g -= 1 << t - f[y]++ - 1 : ++s;
    }
    for (; s >= 0 && g; --s) {
      var P = o[s].s;
      f[P] == t && (--f[P], ++g);
    }
    m = t;
  }
  return [new Fn(f), m];
}, Bl = function(e, t, n) {
  return e.s == -1 ? Math.max(Bl(e.l, t, n + 1), Bl(e.r, t, n + 1)) : t[e.s] = n;
}, du = function(e) {
  for (var t = e.length; t && !e[--t]; ) ;
  for (var n = new vn(++t), s = 0, r = e[0], o = 1, a = function(d) {
    n[s++] = d;
  }, l = 1; t >= l; ++l) if (e[l] == r && l != t) ++o;
  else {
    if (!r && o > 2) {
      for (; o > 138; o -= 138) a(32754);
      o > 2 && (a(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
    } else if (o > 3) {
      for (a(r), --o; o > 6; o -= 6) a(8304);
      o > 2 && (a(o - 3 << 5 | 8208), o = 0);
    }
    for (; o--; ) a(r);
    o = 1, r = e[l];
  }
  return [n.subarray(0, s), t];
}, pi = function(e, t) {
  for (var n = 0, s = 0; t.length > s; ++s) n += e[s] * t[s];
  return n;
}, Wl = function(e, t, n) {
  var s = n.length, r = Xf(t + 2);
  e[r] = 255 & s, e[r + 1] = s >>> 8, e[r + 2] = 255 ^ e[r], e[r + 3] = 255 ^ e[r + 1];
  for (var o = 0; s > o; ++o) e[r + o + 4] = n[o];
  return 8 * (r + 4 + s);
}, cu = function(e, t, n, s, r, o, a, l, d, c, u) {
  is(t, u++, n), ++r[256];
  for (var h = Da(r, 15), p = h[0], f = h[1], m = Da(o, 15), g = m[0], v = m[1], _ = du(p), $ = _[0], y = _[1], P = du(g), j = P[0], b = P[1], N = new vn(19), C = 0; $.length > C; ++C) N[31 & $[C]]++;
  for (C = 0; j.length > C; ++C) N[31 & j[C]]++;
  for (var S = Da(N, 7), F = S[0], W = S[1], D = 19; D > 4 && !F[au[D - 1]]; --D) ;
  var B, q, G, z, re = c + 5 << 3, X = pi(r, br) + pi(o, qo) + a, Q = pi(r, p) + pi(o, g) + a + 14 + 3 * D + pi(N, F) + (2 * N[16] + 3 * N[17] + 7 * N[18]);
  if (X >= re && Q >= re) return Wl(t, u, e.subarray(d, d + c));
  if (is(t, u, 1 + (X > Q)), u += 2, X > Q) {
    B = Ti(p, f), q = p, G = Ti(g, v), z = g;
    var M = Ti(F, W);
    for (is(t, u, y - 257), is(t, u + 5, b - 1), is(t, u + 10, D - 4), u += 14, C = 0; D > C; ++C) is(t, u + 3 * C, F[au[C]]);
    u += 3 * D;
    for (var he = [$, j], le = 0; 2 > le; ++le) {
      var ce = he[le];
      for (C = 0; ce.length > C; ++C) is(t, u, M[we = 31 & ce[C]]), u += F[we], we > 15 && (is(t, u, ce[C] >>> 5 & 127), u += ce[C] >>> 12);
    }
  } else B = $x, q = br, G = bx, z = qo;
  for (C = 0; l > C; ++C) if (s[C] > 255) {
    var we;
    fi(t, u, B[257 + (we = s[C] >>> 18 & 31)]), u += q[we + 257], we > 7 && (is(t, u, s[C] >>> 23 & 31), u += jd[we]);
    var ue = 31 & s[C];
    fi(t, u, G[ue]), u += z[ue], ue > 3 && (fi(t, u, s[C] >>> 5 & 8191), u += Nd[ue]);
  } else fi(t, u, B[s[C]]), u += q[s[C]];
  return fi(t, u, B[256]), u + q[256];
}, xx = new Zr([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), yx = function() {
  for (var e = new Zr(256), t = 0; 256 > t; ++t) {
    for (var n = t, s = 9; --s; ) n = (1 & n && 3988292384) ^ n >>> 1;
    e[t] = n;
  }
  return e;
}(), Ba = function(e, t, n) {
  for (; n; ++t) e[t] = n, n >>>= 8;
};
function wx(e, t) {
  t === void 0 && (t = {});
  var n = /* @__PURE__ */ function() {
    var h = 4294967295;
    return { p(p) {
      for (var f = h, m = 0; p.length > m; ++m) f = yx[255 & f ^ p[m]] ^ f >>> 8;
      h = f;
    }, d() {
      return 4294967295 ^ h;
    } };
  }(), s = e.length;
  n.p(e);
  var r, o, a, l, d, c = (l = 10 + ((r = t).filename && r.filename.length + 1 || 0), d = 8, function(h, p, f, m, g, v) {
    var _ = h.length, $ = new Fn(m + _ + 5 * (1 + Math.floor(_ / 7e3)) + g), y = $.subarray(m, $.length - g), P = 0;
    if (!p || 8 > _) for (var j = 0; _ >= j; j += 65535) {
      var b = j + 65535;
      _ > b ? P = Wl(y, P, h.subarray(j, b)) : (y[j] = v, P = Wl(y, P, h.subarray(j, _)));
    }
    else {
      for (var N = xx[p - 1], C = N >>> 13, S = 8191 & N, F = (1 << f) - 1, W = new vn(32768), D = new vn(F + 1), B = Math.ceil(f / 3), q = 2 * B, G = function(nt) {
        return (h[nt] ^ h[nt + 1] << B ^ h[nt + 2] << q) & F;
      }, z = new Zr(25e3), re = new vn(288), X = new vn(32), Q = 0, M = 0, he = (j = 0, 0), le = 0, ce = 0; _ > j; ++j) {
        var we = G(j), ue = 32767 & j, pe = D[we];
        if (W[ue] = pe, D[we] = ue, j >= le) {
          var Pe = _ - j;
          if ((Q > 7e3 || he > 24576) && Pe > 423) {
            P = cu(h, y, 0, z, re, X, M, he, ce, j - ce, P), he = Q = M = 0, ce = j;
            for (var Y = 0; 286 > Y; ++Y) re[Y] = 0;
            for (Y = 0; 30 > Y; ++Y) X[Y] = 0;
          }
          var ie = 2, ve = 0, Ue = S, ze = ue - pe & 32767;
          if (Pe > 2 && we == G(j - ze)) for (var He = Math.min(C, Pe) - 1, ft = Math.min(32767, j), et = Math.min(258, Pe); ft >= ze && --Ue && ue != pe; ) {
            if (h[j + ie] == h[j + ie - ze]) {
              for (var Ye = 0; et > Ye && h[j + Ye] == h[j + Ye - ze]; ++Ye) ;
              if (Ye > ie) {
                if (ie = Ye, ve = ze, Ye > He) break;
                var Mt = Math.min(ze, Ye - 2), Zt = 0;
                for (Y = 0; Mt > Y; ++Y) {
                  var kt = j - ze + Y + 32768 & 32767, fe = kt - W[kt] + 32768 & 32767;
                  fe > Zt && (Zt = fe, pe = kt);
                }
              }
            }
            ze += (ue = pe) - (pe = W[ue]) + 32768 & 32767;
          }
          if (ve) {
            z[he++] = 268435456 | Dl[ie] << 18 | lu[ve];
            var tt = 31 & Dl[ie], pt = 31 & lu[ve];
            M += jd[tt] + Nd[pt], ++re[257 + tt], ++X[pt], le = j + ie, ++Q;
          } else z[he++] = h[j], ++re[h[j]];
        }
      }
      P = cu(h, y, v, z, re, X, M, he, ce, j - ce, P);
    }
    return Qf($, 0, m + Xf(P) + g);
  }(o = e, (a = t).level == null ? 6 : a.level, a.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(o.length)))) : 12 + a.mem, l, d, !0)), u = c.length;
  return function(h, p) {
    var f = p.filename;
    if (h[0] = 31, h[1] = 139, h[2] = 8, h[8] = 2 > p.level ? 4 : p.level == 9 ? 2 : 0, h[9] = 3, p.mtime != 0 && Ba(h, 4, Math.floor(new Date(p.mtime || Date.now()) / 1e3)), f) {
      h[3] = 8;
      for (var m = 0; f.length >= m; ++m) h[m + 10] = f.charCodeAt(m);
    }
  }(c, t), Ba(c, u - 8, n.d()), Ba(c, u - 4, s), c;
}
const Cx = !!ad || !!Bi, ep = "text/plain";
let No = !1;
const tp = (e, t) => {
  const [n, s] = e.split("#"), [r, o] = n.split("?");
  if (!o) return e;
  const a = o.split("&").filter((l) => l.split("=")[0] !== t).join("&");
  return `${r}${a ? `?${a}` : ""}${s ? `#${s}` : ""}`;
}, Zi = (e, t, n = !0) => {
  var s;
  const [r, o] = e.split("?"), a = x({}, t), l = (s = o == null ? void 0 : o.split("&").map((c) => {
    var u;
    const [h, p] = c.split("="), f = n && (u = a[h]) !== null && u !== void 0 ? u : p;
    return delete a[h], `${h}=${f}`;
  })) !== null && s !== void 0 ? s : [], d = function(c, u = "&") {
    let h, p;
    const f = [];
    return Me(c, function(m, g) {
      L(m) || L(g) || g === "undefined" || (h = encodeURIComponent(((v) => v instanceof File)(m) ? m.name : m.toString()), p = encodeURIComponent(g), f[f.length] = p + "=" + h);
    }), f.join(u);
  }(a);
  return d && l.push(d), l.length > 0 ? `${r}?${l.join("&")}` : r;
}, Wa = (e) => {
  if (e.Wl) return e.Wl;
  const { data: t, compression: n } = e;
  if (!t) return;
  if (n === jn.GZipJS) {
    const r = wx(function(o) {
      var a = o.length;
      if (typeof TextEncoder < "u") return new TextEncoder().encode(o);
      for (var l = new Fn(o.length + (o.length >>> 1)), d = 0, c = function(f) {
        l[d++] = f;
      }, u = 0; a > u; ++u) {
        if (d + 5 > l.length) {
          var h = new Fn(d + 8 + (a - u << 1));
          h.set(l), l = h;
        }
        var p = o.charCodeAt(u);
        128 > p ? c(p) : 2048 > p ? (c(192 | p >>> 6), c(128 | 63 & p)) : p > 55295 && 57344 > p ? (c(240 | (p = 65536 + (1047552 & p) | 1023 & o.charCodeAt(++u)) >>> 18), c(128 | p >>> 12 & 63), c(128 | p >>> 6 & 63), c(128 | 63 & p)) : (c(224 | p >>> 12), c(128 | p >>> 6 & 63), c(128 | 63 & p));
      }
      return Qf(l, 0, d);
    }(Wr(t)), { mtime: 0 });
    return { contentType: ep, body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength), estimatedSize: r.byteLength };
  }
  if (n === jn.Base64) {
    const r = function(a) {
      return a && btoa(encodeURIComponent(a).replace(/%([0-9A-F]{2})/g, (l, d) => String.fromCharCode(parseInt(d, 16))));
    }(Wr(t)), o = ((a) => "data=" + encodeURIComponent(typeof a == "string" ? a : Wr(a)))(r);
    return { contentType: "application/x-www-form-urlencoded", body: o, estimatedSize: new Blob([o]).size };
  }
  const s = Wr(t);
  return { contentType: "application/json", body: s, estimatedSize: new Blob([s]).size };
}, np = (e) => {
  const t = () => e.transport === "sendBeacon" ? { url: Zi(e.url, { compression: jn.Base64 }), encodedBody: Wa(x(x({}, e), {}, { compression: jn.Base64, Wl: void 0 })) } : { url: tp(e.url, "compression"), encodedBody: Wa(x(x({}, e), {}, { compression: void 0, Wl: void 0 })) };
  let n;
  try {
    n = Wa(e);
  } catch (r) {
    if (Tc(e.compression, Kr(e.url, "compression"))) return H.error("Failed to gzip request body, sending uncompressed payload", r), t();
    throw r;
  }
  return n && Tc(e.compression, Kr(e.url, "compression")) && !((s = n.body) instanceof ArrayBuffer ? bl(new Uint8Array(s)) : ArrayBuffer.isView(s) && bl(new Uint8Array(s.buffer, s.byteOffset, s.byteLength))) ? (No = !0, t()) : { url: e.url, encodedBody: n };
  var s;
}, sp = (e) => {
  try {
    return np(e);
  } catch (n) {
    var t;
    return H.error(n), void ((t = e.callback) === null || t === void 0 || t.call(e, { statusCode: 0, error: n }));
  }
}, jx = function() {
  var e = Qe(function* (t) {
    const n = yield function(r) {
      return xl.apply(this, arguments);
    }(Wr(t.data), Ot.DEBUG, { rethrow: !0 });
    if (!n) return t;
    const s = yield n.arrayBuffer();
    return x(x({}, t), {}, { Wl: { contentType: ep, body: s, estimatedSize: s.byteLength } });
  });
  return function(t) {
    return e.apply(this, arguments);
  };
}(), Nx = /Failed to fetch|NetworkError|Load failed/i, rp = (e) => (e == null ? void 0 : e.name) === "TypeError" && Nx.test((e == null ? void 0 : e.message) || ""), ip = (e) => {
  const t = sp(e);
  if (!t) return;
  const n = new ad(), { url: s, encodedBody: r } = t;
  n.open(e.method || "GET", s, !0);
  const { contentType: o, body: a } = r ?? {};
  Me(e.headers, function(l, d) {
    n.setRequestHeader(d, l);
  }), o && n.setRequestHeader("Content-Type", o), e.timeout && (n.timeout = e.timeout), n.onreadystatechange = () => {
    if (n.readyState === 4) {
      var l;
      const d = { statusCode: n.status, text: n.responseText };
      if (n.status === 200) try {
        d.json = JSON.parse(n.responseText);
      } catch {
      }
      (l = e.callback) === null || l === void 0 || l.call(e, d);
    }
  }, n.send(a);
}, op = (e) => {
  const t = sp(e);
  if (!t) return;
  const { url: n, encodedBody: s } = t, { contentType: r, body: o, estimatedSize: a } = s ?? {}, l = new Headers();
  Me(e.headers, function(h, p) {
    l.append(p, h);
  }), r && l.append("Content-Type", r);
  let d = null, c = !1;
  if (gc) {
    const h = new gc();
    d = { signal: h.signal, timeout: setTimeout(() => {
      var p;
      c = !0, h.abort(Yh("AbortError", "PostHog request timed out" + ((p = e.timeout) ? ` after ${p}ms` : "")));
    }, e.timeout) };
  }
  const u = (h) => {
    var p;
    c && (h == null ? void 0 : h.name) === "AbortError" || rp(h) ? H.warn(h) : H.error(h), (p = e.callback) === null || p === void 0 || p.call(e, { statusCode: 0, error: h });
  };
  try {
    Bi(n, x({ method: (e == null ? void 0 : e.method) || "GET", headers: l, keepalive: e.method === "POST" && !e.Vl && 52428.8 > (a || 0), body: o, signal: d == null ? void 0 : d.signal }, e.fetchOptions)).then((h) => h.text().then((p) => {
      var f;
      const m = { statusCode: h.status, text: p };
      if (h.status === 200) try {
        m.json = JSON.parse(p);
      } catch (g) {
        H.error(g);
      }
      (f = e.callback) === null || f === void 0 || f.call(e, m);
    })).catch(u).finally(() => d ? clearTimeout(d.timeout) : null);
  } catch (h) {
    d && clearTimeout(d.timeout), u(h);
  }
}, Ul = (e) => {
  try {
    var t;
    const { url: n, encodedBody: s } = np(e), { contentType: r, body: o, estimatedSize: a } = s ?? {};
    if (!o) return;
    const l = o instanceof Blob ? o : new Blob([o], { type: r });
    if (At.sendBeacon(n, l)) return;
    const d = ae(e.data) ? e.data : (t = e.data) === null || t === void 0 ? void 0 : t.batch;
    if (ae(d) && d.length > 1 && (a ?? 0) > 16384) {
      const c = Math.ceil(d.length / 2), u = (h) => ae(e.data) ? h : x(x({}, e.data), {}, { batch: h });
      return Ul(x(x({}, e), {}, { data: u(d.slice(0, c)) })), void Ul(x(x({}, e), {}, { data: u(d.slice(c)) }));
    }
    H.warn(`Beacon of ~${a ?? 0} bytes was rejected by the browser, falling back to ${Bi ? "fetch" : "XHR"}`), Bi ? op(x(x({}, e), {}, { Vl: !0 })) : ip(e);
  } catch (n) {
    H.warn("Beacon send failed", n);
  }
}, uu = (e, t, n, s) => {
  const r = s === "query" ? t === "POST" ? "sent_at" : "_" : void 0;
  return Zi(n === jn.GZipJS ? tp(e, "compression") : e, x(x({}, r ? { [r]: Date.now().toString() } : {}), n === jn.GZipJS ? {} : { compression: n }));
}, Sx = (() => {
  const e = [];
  return Bi && e.push({ transport: "fetch", method: op }), ad && e.push({ transport: "XHR", method: ip }), At != null && At.sendBeacon && e.push({ transport: "sendBeacon", method: Ul }), e;
})();
var kx = class {
  constructor(e, t) {
    this.Gl = !0, this.Zl = [], this.Ql = es((t == null ? void 0 : t.flush_interval_ms) || 3e3, 250, 5e3, H.createLogger("flush interval"), 3e3), this.Jl = e;
  }
  enqueue(e) {
    this.Zl.push(e), this.Kl || this.Yl();
  }
  unload() {
    this.Xl();
    const e = this.Zl.length > 0 ? this.ta() : {}, t = Object.values(e);
    [...t.filter((n) => n.url.indexOf("/e") === 0), ...t.filter((n) => n.url.indexOf("/e") !== 0)].map((n) => {
      this.ea(x(x({}, n), {}, { transport: "sendBeacon" }));
    });
  }
  enable() {
    this.Gl = !1, this.Yl();
  }
  Yl() {
    this.Gl || (this.Kl = setTimeout(() => {
      if (this.Xl(), this.Zl.length > 0) {
        const e = this.ta();
        for (const t in e) {
          const n = e[t], s = (/* @__PURE__ */ new Date()).getTime();
          n.data && ae(n.data) && Me(n.data, (r) => {
            r.offset = Math.abs(r.timestamp - s), delete r.timestamp;
          }), this.ea(n);
        }
      }
    }, this.Ql));
  }
  ea(e) {
    try {
      this.Jl(e);
    } catch (t) {
      H.error(t);
    }
  }
  Xl() {
    clearTimeout(this.Kl), this.Kl = void 0;
  }
  ta() {
    const e = {};
    return Me(this.Zl, (t) => {
      var n;
      const s = t, r = (s ? s.batchKey : null) || s.url;
      L(e[r]) && (e[r] = x(x({}, s), {}, { data: [] })), (n = e[r].data) === null || n === void 0 || n.push(s.data);
    }), this.Zl = [], e;
  }
};
const Ex = ["retriesPerformedSoFar"];
var Ix = class {
  constructor(e) {
    this._instance = e, this.ia = !1, this.na = 3e3, this.Zl = [], this.Zl = [], this.sa = !0, this.resume();
  }
  resume() {
    if (!L(k) && "onLine" in k.navigator) {
      if (this.sa = k.navigator.onLine, this.ra) return;
      this.ra = () => {
        this.sa = !0, this.oa();
      }, this.la = () => {
        this.sa = !1;
      }, We(k, "online", this.ra), We(k, "offline", this.la);
    }
  }
  get length() {
    return this.Zl.length;
  }
  retriableRequest(e) {
    let { retriesPerformedSoFar: t } = e, n = tf(e, Ex);
    ps(t) && (n.url = Zi(n.url, { retry_count: t })), this._instance._send_request(x(x({}, n), {}, { callback: (s) => {
      var r;
      if (s.statusCode !== 200 && (400 > s.statusCode || s.statusCode >= 500)) {
        if ((s.statusCode === 0 ? 3 : 10) > (t ?? 0)) return void this.Is(x({ retriesPerformedSoFar: t }, n));
        s.statusCode === 0 && H.warn(`Request failed before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped retrying after ${t ?? 0} retries.`);
      }
      (r = n.callback) === null || r === void 0 || r.call(n, s);
    } }));
  }
  Is(e) {
    const t = e.retriesPerformedSoFar || 0;
    e.retriesPerformedSoFar = t + 1;
    const n = function(o) {
      const a = 3e3 * Math.pow(2, o), l = a / 2, d = Math.min(18e5, a), c = (Math.random() - 0.5) * (d - l);
      return Math.ceil(d + c);
    }(t), s = Date.now() + n;
    this.Zl.push({ retryAt: s, requestOptions: e });
    let r = `Enqueued failed request for retry in ${n}`;
    navigator.onLine || (r += " (Browser is offline)"), H.warn(r), this.ia || (this.ia = !0, this.aa());
  }
  aa() {
    if (this.ua && clearTimeout(this.ua), this.Zl.length === 0) return this.ia = !1, void (this.ua = void 0);
    this.ua = setTimeout(() => {
      this.sa && this.Zl.length > 0 && this.oa(), this.aa();
    }, this.na);
  }
  oa() {
    const e = Date.now(), t = [], n = this.Zl.filter((s) => e > s.retryAt || (t.push(s), !1));
    if (this.Zl = t, n.length > 0) for (const { requestOptions: s } of n) this.retriableRequest(s);
  }
  unload() {
    this.ua && (clearTimeout(this.ua), this.ua = void 0), this.ia = !1, L(k) || (this.ra && (k.removeEventListener("online", this.ra), this.ra = void 0), this.la && (k.removeEventListener("offline", this.la), this.la = void 0));
    for (const { requestOptions: e } of this.Zl) try {
      this._instance._send_request(x(x({}, e), {}, { transport: "sendBeacon" }));
    } catch (t) {
      H.error(t);
    }
    this.Zl = [];
  }
}, Px = class {
  constructor(e) {
    this._instance = e, this.ha = () => {
      var t, n, s, r;
      this.ca || (this.ca = {});
      const o = this.scrollElement(), a = this.scrollY(), l = o ? Math.max(0, o.scrollHeight - o.clientHeight) : 0, d = a + ((o == null ? void 0 : o.clientHeight) || 0), c = (o == null ? void 0 : o.scrollHeight) || 0;
      this.ca.lastScrollY = Math.ceil(a), this.ca.maxScrollY = Math.max(a, (t = this.ca.maxScrollY) !== null && t !== void 0 ? t : 0), this.ca.maxScrollHeight = Math.max(l, (n = this.ca.maxScrollHeight) !== null && n !== void 0 ? n : 0), this.ca.lastContentY = d, this.ca.maxContentY = Math.max(d, (s = this.ca.maxContentY) !== null && s !== void 0 ? s : 0), this.ca.maxContentHeight = Math.max(c, (r = this.ca.maxContentHeight) !== null && r !== void 0 ? r : 0);
    };
  }
  get da() {
    return this._instance.config.scroll_root_selector;
  }
  getContext() {
    return this.ca;
  }
  resetContext() {
    const e = this.ca;
    return setTimeout(this.ha, 0), e;
  }
  startMeasuringScrollPosition() {
    We(k, "scroll", this.ha, { capture: !0 }), We(k, "scrollend", this.ha, { capture: !0 }), We(k, "resize", this.ha);
  }
  scrollElement() {
    if (this.da) {
      const n = ae(this.da) ? this.da : [this.da];
      for (const s of n) {
        var e;
        const r = k == null || (e = k.document) === null || e === void 0 ? void 0 : e.querySelector(s);
        if (r) return r;
      }
      return;
    }
    var t;
    return k == null || (t = k.document) === null || t === void 0 ? void 0 : t.documentElement;
  }
  va(e) {
    var t, n;
    const s = e === "y" ? "scrollTop" : "scrollLeft";
    if (this.da) {
      const r = this.scrollElement();
      return r && r[s] || 0;
    }
    return k ? e === "y" ? k.scrollY || k.pageYOffset || ((t = k.document) === null || t === void 0 || (t = t.documentElement) === null || t === void 0 ? void 0 : t.scrollTop) || 0 : k.scrollX || k.pageXOffset || ((n = k.document) === null || n === void 0 || (n = n.documentElement) === null || n === void 0 ? void 0 : n.scrollLeft) || 0 : 0;
  }
  scrollY() {
    return this.va("y");
  }
  scrollX() {
    return this.va("x");
  }
};
const Tx = (e) => qf(e == null ? void 0 : e.config.mask_personal_data_properties, e == null ? void 0 : e.config.custom_personal_data_properties, e == null ? void 0 : e.config.disable_capture_url_hashes);
var hu = class {
  constructor(e, t, n, s) {
    this.je = (r) => {
      const o = this.fa();
      if (o && o.sessionId === r) return;
      const a = { sessionId: r, props: this.pa(this._instance) };
      this.ga.register({ [Il]: a });
    }, this._instance = e, this.ma = t, this.ga = n, this.pa = s || Tx, this.ma.onSessionId(this.je);
  }
  fa() {
    return this.ga.props[Il];
  }
  getSetOnceProps() {
    var e;
    const t = (e = this.fa()) === null || e === void 0 ? void 0 : e.props;
    return t ? "r" in t ? Gf(t, this._instance.config.disable_capture_url_hashes) : { $referring_domain: t.referringDomain, $pathname: t.initialPathName, utm_source: t.utm_source, utm_campaign: t.utm_campaign, utm_medium: t.utm_medium, utm_content: t.utm_content, utm_term: t.utm_term } : {};
  }
  getSessionProps() {
    const e = {};
    return Me(bd(this.getSetOnceProps()), (t, n) => {
      n === "$current_url" && (n = "url"), e[`$session_entry_${pl(n)}`] = t;
    }), e;
  }
}, Go = class {
  on(e, t) {
    return this.ya[e] || (this.ya[e] = []), this.ya[e].push(t), () => {
      this.ya[e] = this.ya[e].filter((n) => n !== t);
    };
  }
  emit(e, t) {
    for (const n of this.ya[e] || []) n(t);
    for (const n of this.ya["*"] || []) n(e, t);
  }
  constructor() {
    this.ya = {};
  }
};
const Pr = xt("[SessionId]"), fu = 864e5;
var pu = class {
  on(e, t) {
    return this.ba.on(e, t);
  }
  constructor(e, t, n) {
    var s;
    if (this._a = null, this.wa = null, this.ka = [], this.Sa = void 0, this.xa = !1, this.ba = new Go(), this.Ca = (o, a) => !(!ps(o) || !ps(a)) && Math.abs(o - a) > this.sessionTimeoutMs, !e.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    if (e.config.cookieless_mode === "always") throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
    this.Sr = e.config, this.ga = e.persistence, this.Be = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this.$a = void 0, this._sessionActivityTimestamp = null, this.Ta = t || qn, this.Ia = n || qn;
    const r = this.Sr.persistence_name || this.Sr.token;
    if (this._sessionTimeoutMs = 1e3 * es(this.Sr.session_idle_timeout_seconds || 1800, 60, 36e3, Pr.createLogger("session_idle_timeout_seconds"), 1800), e.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this.Ma(), this.Ea = "ph_" + r + "_window_id", this.Pa = "ph_" + r + "_primary_window_exists", this.Ra()) {
      const o = Ze.Dt(this.Ea), a = Ze.Dt(this.Pa);
      o && !a ? this.Be = o : Ze.Lt(this.Ea), Ze.At(this.Pa, !0);
    }
    !((s = this.Sr.bootstrap) === null || s === void 0) && s.sessionID && this.setBootstrapSessionId(this.Sr.bootstrap.sessionID), this.Aa();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(e) {
    return L(this.ka) && (this.ka = []), this.ka.push(e), this.Xt && e(this.Xt, this.Be), () => {
      this.ka = this.ka.filter((t) => t !== e);
    };
  }
  Ra() {
    return this.Sr.persistence !== "memory" && !this.ga.pi && Ze.Et();
  }
  Fa(e) {
    e !== this.Be && (this.Be = e, this.Ra() && Ze.At(this.Ea, e));
  }
  Oa() {
    return this.Be ? this.Be : this.Ra() ? Ze.Dt(this.Ea) : null;
  }
  Da(e) {
    const t = this._a;
    return !gt(t) && !gt(e) && 5e3 > Math.abs(e - t);
  }
  La(e, t, n) {
    const s = t !== this._sessionActivityTimestamp, r = !(e !== this.Xt || n !== this._sessionStartTimestamp);
    this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this.Xt = e, r && !s || r && this.Da(t) || (this._a = t, this.ga.register({ [Dr]: [t, e, n] }));
  }
  Na() {
    var e;
    const t = (e = this.Sr) === null || e === void 0 ? void 0 : e.persistence_save_debounce_ms;
    return ps(t) && t > 0;
  }
  qa() {
    this.Na() ? this.ga.refreshKey(Dr) : (this.ga.flush(), this.ga.load());
  }
  ja() {
    var e;
    if (gt(this._sessionActivityTimestamp) || this._sessionActivityTimestamp === this._a) return;
    this.qa();
    const [, t, n] = this.Ba();
    t === this.Xt && n === this._sessionStartTimestamp && (this._a = this._sessionActivityTimestamp, this.ga.register({ [Dr]: [this._sessionActivityTimestamp, (e = this.Xt) !== null && e !== void 0 ? e : null, this._sessionStartTimestamp] }), this.ga.flush());
  }
  Ha() {
    const [e] = this.Ba(), t = ps(e) ? e : 0, n = ps(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
    return Math.max(t, n);
  }
  za(e) {
    return this.qa(), this.Ca(e, this.Ha());
  }
  Ba() {
    const e = this.ga.props[Dr];
    return ae(e) && e.length === 2 && e.push(e[0]), e || [0, null, 0];
  }
  resetSessionId() {
    this._a = null, this.$a = void 0, clearTimeout(this.Ua), this.Ua = void 0, this.La(null, null, null);
  }
  setBootstrapSessionId(e, t = !1) {
    const n = ((s, r = (/* @__PURE__ */ new Date()).getTime()) => {
      try {
        const o = ((a) => {
          const l = a.replace(/-/g, "");
          if (l.length !== 32) throw new Error("Not a valid UUID");
          if (l[12] !== "7") throw new Error("Not a UUIDv7");
          return parseInt(l.substring(0, 12), 16);
        })(s);
        return o > r + 6e4 ? void Pr.error("Bootstrap sessionID cannot be in the future") : o;
      } catch (o) {
        return void Pr.error("Invalid sessionID in bootstrap", o);
      }
    })(e);
    return !L(n) && (t ? this.$a = { sessionId: e, sessionStartTimestamp: n } : this.La(e, (/* @__PURE__ */ new Date()).getTime(), n), !0);
  }
  destroy() {
    this.xa = !0, this.ja(), clearTimeout(this.Ua), this.Ua = void 0, this.Sa && k && (k.removeEventListener(Wo, this.Sa, { capture: !1 }), this.Sa = void 0), this.ka = [];
  }
  Aa() {
    this.Sa = () => {
      this.ja(), this.Ra() && Ze.Lt(this.Pa);
    }, We(k, Wo, this.Sa, { capture: !1 });
  }
  checkAndGetSessionAndWindowId(e = !1, t = null, n = !1) {
    if (this.Sr.cookieless_mode === "always") throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
    const s = t || (/* @__PURE__ */ new Date()).getTime(), r = this.Xt;
    if (n) this.wa = s;
    else if (gt(this.wa) || this.wa > s || s - this.wa >= 1e3) {
      var o, a;
      (o = (a = this.ga).syncCookieProperties) === null || o === void 0 || o.call(a), this.wa = s;
    }
    let [, l, d] = this.Ba();
    const c = !L(r) && l !== r, u = this.Ha();
    let h = this.Oa();
    const p = this.$a, f = !!p && (p.sessionStartTimestamp > s + 6e4 || s - p.sessionStartTimestamp > fu), m = p ? f : ps(d) && Math.abs(s - d) > fu;
    let g = !1, v = c;
    const _ = !l || !!p, $ = l;
    let y = !_ && !e && this.Ca(s, u);
    if (y && (y = this.za(s), y || Pr.info("cross-tab refresh kept the session alive", { sessionId: l }), [, l, d] = this.Ba()), _ || y || m) {
      v = !1;
      const N = p && !f;
      l = N ? p.sessionId : this.Ta(), h = this.Ia(), Pr.info("new session ID assigned", { sessionId: l, windowId: h, bootstrapped: !!N, changeReason: { noSessionId: _, activityTimeout: y, sessionPastMaximumLength: m } }), d = N ? p.sessionStartTimestamp : s, this.$a = void 0, g = !0;
    } else h || (h = this.Ia(), g = !0), v = v || l !== $, v && (Pr.info("adopted cross-tab session id", { sessionId: l, windowId: h }), g = !0);
    const P = ps(u) && e && !m ? u : s, j = ps(d) ? d : (/* @__PURE__ */ new Date()).getTime();
    this.Fa(h), this.La(l, P, j), e || this.Ma();
    const b = { noSessionId: _, activityTimeout: y, sessionPastMaximumLength: m, crossTabAdoption: v };
    return g && this.ka.forEach((N) => N(l, h, b)), { sessionId: l, windowId: h, sessionStartTimestamp: j, changeReason: g ? b : void 0, lastActivityTimestamp: u };
  }
  Ma() {
    this.xa || (clearTimeout(this.Ua), this.Ua = setTimeout(() => {
      if (!this.xa) if (this.za((/* @__PURE__ */ new Date()).getTime())) {
        const e = this.Xt;
        this.resetSessionId(), this.ba.emit("forcedIdleReset", { idleSessionId: e });
      } else this.Ma();
    }, 1.1 * this.sessionTimeoutMs));
  }
};
const ap = function(e, t) {
  if (!e) return !1;
  const n = e.userAgent;
  if (n && bc(n, t)) return !0;
  try {
    const s = e == null ? void 0 : e.userAgentData;
    if (s != null && s.brands && s.brands.some((r) => bc(r == null ? void 0 : r.brand, t))) return !0;
  } catch {
  }
  return !!e.webdriver;
};
function lp() {
  return (lp = Qe(function* () {
    const e = At == null ? void 0 : At.userAgentData;
    if (e != null && e.getHighEntropyValues) try {
      const t = yield e.getHighEntropyValues(["model"]), n = t == null ? void 0 : t.model;
      return ye(n) && n.length > 0 ? n : void 0;
    } catch (t) {
      return void H.info("Unable to resolve $device_model from userAgentData.getHighEntropyValues", t);
    }
  })).apply(this, arguments);
}
function Rx(e, t) {
  let n = `$survey_${t}/${e.id}`;
  return e.current_iteration && e.current_iteration > 0 && (n = `$survey_${t}/${e.id}/${e.current_iteration}`), n;
}
function dp(e) {
  var t;
  return !!(!((t = e.conditions) === null || t === void 0 || (t = t.events) === null || t === void 0 || (t = t.values) === null || t === void 0) && t.length);
}
const Vo = (e, t) => {
  if (!((n) => {
    try {
      new RegExp(n);
    } catch {
      return !1;
    }
    return !0;
  })(t)) return !1;
  try {
    return new RegExp(t).test(e);
  } catch {
    return !1;
  }
}, uo = (e) => e.toLowerCase(), cp = { exact: (e, t) => t.some((n) => e.some((s) => n === s)), is_not: (e, t) => t.every((n) => e.every((s) => n !== s)), regex: (e, t) => t.some((n) => e.some((s) => Vo(n, s))), not_regex: (e, t) => t.every((n) => e.every((s) => !Vo(n, s))), icontains: (e, t) => t.map(uo).some((n) => e.map(uo).some((s) => n.includes(s))), not_icontains: (e, t) => t.map(uo).every((n) => e.map(uo).every((s) => !n.includes(s))), gt: (e, t) => t.some((n) => {
  const s = parseFloat(n);
  return !isNaN(s) && e.some((r) => s > parseFloat(r));
}), lt: (e, t) => t.some((n) => {
  const s = parseFloat(n);
  return !isNaN(s) && e.some((r) => s < parseFloat(r));
}) };
function up(e, t) {
  return !e || Object.entries(e).every(([n, s]) => {
    const r = t == null ? void 0 : t[n];
    if (r == null) return !1;
    const o = cp[s.operator];
    return !!o && o(s.values, [String(r)]);
  });
}
function Ua(e, t, n) {
  return Wr({ distinct_id: e, userPropertiesToSet: t, userPropertiesToSetOnce: n });
}
const zl = "custom", _u = "i.posthog.com", Lx = /^\/static\//, Ox = ["/s/", "/e/", "/i/"];
var Fx = class {
  constructor(e) {
    this.Wa = {}, this.instance = e;
  }
  get apiHost() {
    const e = this.instance.config.api_host.trim().replace(/\/$/, "");
    return e === "https://app.posthog.com" ? "https://us.i.posthog.com" : e;
  }
  get flagsApiHost() {
    const e = this.instance.config.flags_api_host;
    return e ? e.trim().replace(/\/$/, "") : this.apiHost;
  }
  get uiHost() {
    var e;
    let t = (e = this.instance.config.ui_host) === null || e === void 0 ? void 0 : e.replace(/\/$/, "");
    return t || (t = this.apiHost.replace(`.${_u}`, ".posthog.com")), t === "https://app.posthog.com" ? "https://us.posthog.com" : t;
  }
  get region() {
    return this.Wa[this.apiHost] || (this.Wa[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : zl), this.Wa[this.apiHost];
  }
  Va(e) {
    if (!Lx.test(e)) return;
    const t = this.instance.config.asset_host;
    return typeof t == "string" && t.trim().replace(/\/$/, "") || void 0;
  }
  Ga(e) {
    const t = Yr(e);
    return t ? t.protocol + "//" + t.host + t.pathname : void 0;
  }
  Za(e, t, n) {
    if (e === "ui") return n;
    let s = n;
    const r = this.instance.config.rewriteRequestPath;
    if (r) {
      var o;
      const a = ((o = Yr(n)) === null || o === void 0 ? void 0 : o.href) || n;
      s = r(new URL(a)).toString();
    }
    if (r && e === "api" && Ox.some((a) => t.indexOf(a) === 0)) {
      const a = this.Ga(s);
      if (a) {
        const l = this.apiHost;
        let d = this.Qa;
        (d == null ? void 0 : d.apiHost) === l && d.rewriteRequestPath === r || (d = { apiHost: l, rewriteRequestPath: r, urls: /* @__PURE__ */ new Set() }, this.Qa = d), d.urls.add(a);
      }
    }
    return s;
  }
  isIngestionEndpoint(e) {
    const t = this.Qa, n = this.Ga(e);
    return (t == null ? void 0 : t.apiHost) === this.apiHost && t.rewriteRequestPath === this.instance.config.rewriteRequestPath && !!n && t.urls.has(n);
  }
  endpointFor(e, t = "") {
    if (t && (t = t[0] === "/" ? t : `/${t}`), e === "ui") return this.Za(e, t, this.uiHost + t);
    if (e === "flags") return this.Za(e, t, this.flagsApiHost + t);
    if (e === "assets") {
      const s = this.Va(t);
      if (s) return this.Za(e, t, `${s}${t}`);
    }
    if (this.region === zl) return this.Za(e, t, this.apiHost + t);
    const n = _u + t;
    switch (e) {
      case "assets":
        return this.Za(e, t, `https://${this.region}-assets.${n}`);
      case "api":
        return this.Za(e, t, `https://${this.region}.${n}`);
    }
  }
};
const De = xt("[Surveys]"), hp = (e) => {
  try {
    const t = ((n) => ((s, r) => `seenSurvey_${function(o) {
      return o.current_iteration && o.current_iteration > 0 ? `${o.id}_${o.current_iteration}` : o.id;
    }(r)}`)(0, n))(e);
    if (localStorage.getItem(t)) return;
    localStorage.setItem(t, "true");
  } catch (t) {
    De.error("Failed to persist survey seen state", t);
  }
}, Ax = [Aa.Popover, Aa.Widget, Aa.API], Mx = { ignoreConditions: !1, ignoreDelay: !1, displayType: Ml.Popover }, Dx = xt("[PostHog ExternalIntegrations]"), Bx = { intercom: "intercom-integration", crispChat: "crisp-chat-integration" };
var Wx = class {
  constructor(e) {
    this._instance = e;
  }
  Eo(e, t) {
    var n, s;
    (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this._instance, e, (r) => {
      if (r) return Dx.error("failed to load script", r);
      t();
    });
  }
  startIfEnabledOrStop() {
    var e;
    for (const [r, o] of Object.entries((e = this._instance.config.integrations) !== null && e !== void 0 ? e : {})) {
      var t, n, s;
      o && !(!((t = se.__PosthogExtensions__) === null || t === void 0 || (t = t.integrations) === null || t === void 0) && t[r]) && this.Eo(Bx[r], () => {
        var a;
        (a = se.__PosthogExtensions__) === null || a === void 0 || (a = a.integrations) === null || a === void 0 || (a = a[r]) === null || a === void 0 || a.start(this._instance);
      }), !o && (!((n = se.__PosthogExtensions__) === null || n === void 0 || (n = n.integrations) === null || n === void 0) && n[r]) && ((s = se.__PosthogExtensions__) === null || s === void 0 || (s = s.integrations) === null || s === void 0 || (s = s[r]) === null || s === void 0 || s.stop());
    }
  }
}, Ux = class {
  constructor(e, t) {
    this.$ = e, this.lo = t, this.Ja = /* @__PURE__ */ new Map(), this.fo = !1;
  }
  add(e) {
    var t = this;
    return Qe(function* () {
      if (t.fo) throw new Error("Cannot add an extension to a disposed ExtensionRuntime");
      if (t.Ja.has(e.name)) throw new Error(`Browser extension "${e.name}" is already registered`);
      t.Ja.set(e.name, e);
      try {
        const n = e.setup(t.lo);
        n && (yield n);
      } catch (n) {
        const s = t.Ja.get(e.name) === e;
        s && t.Ja.delete(e.name), t.$.error(`Failed to set up browser extension "${e.name}"`, n), s && t.Ka(e);
      }
    })();
  }
  getExtension(e) {
    return this.Ja.get(e);
  }
  dispose() {
    if (this.fo) return;
    this.fo = !0;
    const e = Array.from(this.Ja.values()).reverse();
    this.Ja.clear();
    for (const t of e) this.Ka(t);
  }
  Ka(e) {
    try {
      var t;
      const n = (t = e.dispose) === null || t === void 0 ? void 0 : t.call(e);
      n && Yt(n.then) && n.then(void 0, (s) => {
        this.$.error(`Failed to dispose browser extension "${e.name}"`, s);
      });
    } catch (n) {
      this.$.error(`Failed to dispose browser extension "${e.name}"`, n);
    }
  }
}, zx = class {
  constructor(e) {
    this._instance = e;
  }
  initialize() {
  }
  get(e) {
    const t = this._instance.persistence;
    if (typeof e == "string") return t == null ? void 0 : t.get_property(e);
    const n = {};
    for (const s of e) {
      const r = t == null ? void 0 : t.get_property(s);
      L(r) || (n[s] = r);
    }
    return n;
  }
  set(e, t) {
    var n;
    (n = this._instance.persistence) === null || n === void 0 || n.register(typeof e == "string" ? { [e]: t } : e);
  }
  remove(e) {
    var t;
    (t = this._instance.persistence) === null || t === void 0 || t.unregister(e);
  }
};
const mu = "extensionsRemoteConfig";
var Hx = class {
  constructor(e) {
    this.instance = e, this.fo = !1, this.$ = H, this.Ya = e.Xa, this.kv = new zx(e), this.onEvent = (t) => co(this.instance.on("eventCaptured", (n) => {
      try {
        t({ event: n.event, properties: n.properties });
      } catch (s) {
        this.$.error("Browser extension event listener failed", s);
      }
    })), this.onRemoteConfig = (t) => {
      if (this.fo) return co(() => {
      });
      const n = (r) => {
        try {
          t(r);
        } catch (o) {
          this.$.error("Browser extension remote config listener failed", o);
        }
      }, s = this.instance.tu.on(mu, n);
      return this.Ya && n(this.Ya), co(s);
    }, this.eu = new Ux(H.createLogger("[BrowserExtensions]"), this);
  }
  get logger() {
    return this.$;
  }
  get distinctId() {
    return this.instance.get_distinct_id();
  }
  get anonymousId() {
    var e;
    return (e = this.instance.get_property("$device_id")) !== null && e !== void 0 ? e : this.distinctId;
  }
  get deviceId() {
    const e = this.instance.get_property(pd);
    return typeof e == "string" ? e : void 0;
  }
  get library() {
    return { name: Ot.LIB_NAME, version: Ot.LIB_VERSION };
  }
  get initialPersonProperties() {
    var e, t;
    return (e = (t = this.instance.persistence) === null || t === void 0 ? void 0 : t.get_initial_props()) !== null && e !== void 0 ? e : {};
  }
  get groups() {
    return this.instance.getGroups();
  }
  get session() {
    try {
      var e, t, n, s;
      const r = (e = this.instance.sessionManager) === null || e === void 0 ? void 0 : e.checkAndGetSessionAndWindowId(!0);
      return { sessionId: (t = r == null ? void 0 : r.sessionId) !== null && t !== void 0 ? t : "", windowId: (n = r == null ? void 0 : r.windowId) !== null && n !== void 0 ? n : "", sessionStartTimestamp: (s = r == null ? void 0 : r.sessionStartTimestamp) !== null && s !== void 0 ? s : 0 };
    } catch {
      return { sessionId: "", windowId: "", sessionStartTimestamp: 0 };
    }
  }
  get canCapture() {
    return this.instance.is_capturing();
  }
  get projectToken() {
    return this.instance.config.token;
  }
  add(e) {
    return this.eu.add(e);
  }
  getExtension(e) {
    return this.eu.getExtension(e);
  }
  capture(e, t, n) {
    var s = this;
    return Qe(function* () {
      n ? s.instance.capture(e, t, { timestamp: n.timestamp, uuid: n.uuid, $set: n.set, $set_once: n.setOnce }) : s.instance.capture(e, t);
    })();
  }
  registerDynamicEventProperties(e) {
    return co(this.instance.iu(e));
  }
  handleRemoteConfig(e) {
    this.fo || (this.Ya = e, this.instance.tu.emit(mu, e));
  }
  sendRequest(e) {
    var t = this;
    return Qe(function* (n, s = {}) {
      var r;
      const o = t.instance.requestRouter.endpointFor((r = s.target) !== null && r !== void 0 ? r : "api", n), a = { method: s.method, url: s.query ? Zi(o, s.query) : o, data: s.body, headers: s.headers, timeout: s.timeoutMs, fireCallbackOnDrop: !0, transport: s.transport, compression: s.compression, compressionFallback: s.target === "flags" && s.compression === "best-available" ? fl.Base64 : void 0, timestampMode: s.sentAt };
      return s.transport === "sendBeacon" ? (t.instance._send_request(a), { statusCode: 202 }) : new Promise((l) => {
        a.callback = l, t.instance._send_request(a);
      });
    }).apply(this, arguments);
  }
  dispose() {
    this.fo || (this.fo = !0, this.eu.dispose());
  }
};
const Ri = {};
let za = 0;
const Li = () => {
}, gu = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', _i = "Surveys module not available", vu = "sanitize_properties is deprecated. Use before_send instead", fp = "Invalid value for property_denylist config: ", qx = /^[A-Za-z0-9_-]{1,400}$/, Ha = /^fb\.[0-9]+\.[0-9]+\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?$/, Gx = ["token", "distinct_id", bf], Ci = "posthog";
let pp = !Cx && (rn == null ? void 0 : rn.indexOf("MSIE")) === -1 && (rn == null ? void 0 : rn.indexOf("Mozilla")) === -1;
const Vx = (e) => {
  const t = {};
  return e && e !== "unset" && ("2025-11-30" > e || (t.strictMinimumDuration = !0), "2026-05-30" > e || (t.canvasCapture = { resolutionScale: 0.6 }), "2026-06-25" > e || (t.streamNetworkBody = !0), "2026-08-30" > e || (t.captureJsonLd = !0)), t;
}, qa = (e) => {
  var t;
  return x({ api_host: "https://us.i.posthog.com", flags_api_host: null, ui_host: null, asset_host: null, token: "", autocapture: !0, cross_subdomain_cookie: Gb(A == null ? void 0 : A.location), persistence: "localStorage+cookie", persistence_name: "", cookie_persisted_properties: [], loaded: Li, save_campaign_params: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageleave: "if_capture_pageview", defaults: e ?? "unset", __preview_deferred_init_extensions: !1, __preview_external_dependency_versioned_paths: !1, __preview_cookie_wins_on_conflict: !1, debug: ut && ye(ut == null ? void 0 : ut.search) && ut.search.indexOf("__posthog_debug=true") !== -1 || !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, disable_surveys_automatic_display: !1, disable_conversations: !1, disable_product_tours: !1, disableDeviceModel: !1, reuseAnonymousId: !1, disable_external_dependency_loading: !1, strict_script_versioning: "fallback", enable_recording_console_log: void 0, secure_cookie: (k == null || (t = k.location) === null || t === void 0 ? void 0 : t.protocol) === "https:", ip: !1, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", consent_persistence_name: null, opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, request_batching: !0, properties_string_max_length: 65535, mask_all_element_attributes: !1, mask_all_text: !1, mask_personal_data_properties: !1, custom_personal_data_properties: [], advanced_disable_flags: !1, advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_only_evaluate_survey_feature_flags: !1, advanced_feature_flags_dedup_per_session: !1, advanced_enable_surveys: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, surveys_request_timeout_ms: 1e4, on_request_error(n) {
    H.error("Bad HTTP status: " + n.statusCode + " " + n.text);
  }, get_device_id: (n) => n, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: Cf, before_send: void 0, get_current_url: void 0, request_queue_config: { flush_interval_ms: 3e3 }, error_tracking: {}, _onCapture: Li }, ((n) => ({ rageclick: n && n >= "2026-05-30" ? { content_ignorelist: ex, ignore_text_selection: !0 } : !n || "2025-11-30" > n || { content_ignorelist: !0 }, capture_pageview: !n || "2025-05-24" > n || "history_change", session_recording: Vx(n), external_scripts_inject_target: n && n >= "2026-01-30" ? "head" : "body", internal_or_test_user_hostname: n && n >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0, persistence_save_debounce_ms: n && n >= "2026-05-30" ? 250 : 0, split_storage: !(!n || "2026-05-30" > n), detect_google_search_app: !(!n || "2026-05-30" > n), disable_capture_url_hashes: !(!n || "2026-06-25" > n), cookieWinsOnConflict: !(!n || n === "unset" || "2026-08-29" > n) }))(e));
}, Yx = [["process_person", "person_profiles"], ["xhr_headers", "request_headers"], ["cookie_name", "persistence_name"], ["disable_cookie", "disable_persistence"], ["__preview_disable_beacon", "disable_beacon"], ["store_google", "save_campaign_params"], ["verbose", "debug"], ["__preview_cookie_wins_on_conflict", "cookieWinsOnConflict"]], $u = (e) => {
  const t = {};
  for (const [r, o] of Yx) L(e[r]) || (t[o] = e[r]);
  const n = Xe({}, t, e), s = e.__preview_external_dependency_versioned_paths;
  return L(s) || (L(e.strict_script_versioning) && (n.strict_script_versioning = !!s), ye(s) && L(e.asset_host) && (n.asset_host = s)), ae(e.property_blacklist) && (L(e.property_denylist) ? n.property_denylist = e.property_blacklist : ae(e.property_denylist) ? n.property_denylist = [...e.property_blacklist, ...e.property_denylist] : H.error(fp + e.property_denylist)), n;
};
var Kx = class {
  constructor() {
    this.__forceAllowLocalhost = !1;
  }
  get nu() {
    return this.__forceAllowLocalhost;
  }
  set nu(e) {
    H.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
  }
}, Oi = class As {
  su(t) {
    if (!t) return;
    const n = this.Ja.indexOf(t);
    n !== -1 && this.Ja.splice(n, 1);
  }
  ru(t, n) {
    var s;
    return this.su(t), this.Ja.push(n), (s = n.initialize) === null || s === void 0 || s.call(n), n;
  }
  ou() {
    return this.config.cookieless_mode === "always" || this.config.cookieless_mode === "on_reject" && this.consent.isRejected();
  }
  lu() {
    if (this.au || this.config.reuseAnonymousId || this.config.segment || this.ou()) return;
    const t = this.config.persistence === "memory" || this.config.persistence === "sessionStorage";
    if (!t && !this.config.disable_persistence || this.uu) return;
    let n, s, r;
    t ? (n = `persistence is set to '${this.config.persistence}'`, s = this.config.persistence === "memory" ? "on every page load" : "for every new browser tab or window", r = "Either set persistence to 'localStorage+cookie', keep this persistence and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId.") : (n = "persistence is disabled (disable_persistence is true)", s = "on every page load", r = "Either set disable_persistence to false, keep persistence disabled and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId."), this.au = !0, console.warn("[PostHog.js]", `${n} but no bootstrap.distinctID was provided. PostHog will mint a new distinct ID ${s}, so calling identify() merges a new ID onto the person each time. A person can then pass the distinct-ID limit and its events stop appearing on person pages and the session tab. ${r}`);
  }
  hu() {
    if (this.ou() || this.get_distinct_id() !== "$posthog_cookieless") return;
    const t = this.persistence;
    if (!t) return;
    this.cu() || t.load(!0);
    const n = this.get_distinct_id();
    if (!n || n === "$posthog_cookieless") {
      const s = this.config.get_device_id(qn());
      this.register({ distinct_id: s, $device_id: s }), t.set_property(an, $s);
    }
    this.du();
  }
  get decideEndpointWasHit() {
    var t, n;
    return (t = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.hasLoadedFlags) !== null && t !== void 0 && t;
  }
  get flagsEndpointWasHit() {
    var t, n;
    return (t = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.hasLoadedFlags) !== null && t !== void 0 && t;
  }
  constructor() {
    var t;
    this.vu = !1, this.fu = !1, this.webPerformance = new Kx(), this.pu = !1, this.version = Ot.LIB_VERSION, this.gu = /* @__PURE__ */ new Set(), this.mu = "", this.tu = new Go(), this.Ja = [], this.yu = [], this.uu = !1, this.au = !1, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = qa(), this.SentryIntegration = lx, this.sentryIntegration = (s) => function(r, o) {
      const a = Af(r, o);
      return { name: Ff, processEvent: (l) => a(l) };
    }(this, s), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.bu = !1, this._u = null, this.wu = null, this.ku = null, this.scrollManager = new Px(this), this.pageViewManager = new su(this), this.rateLimiter = new vx(this), this.requestRouter = new Fx(this), this.consent = new Qb(this), this.externalIntegrations = new Wx(this);
    const n = (t = As.__defaultExtensionClasses) !== null && t !== void 0 ? t : {};
    this.featureFlags = n.featureFlags && new n.featureFlags(this), this.toolbar = n.toolbar && new n.toolbar(this), this.surveys = n.surveys && new n.surveys(this), this.conversations = n.conversations && new n.conversations(this), this.logs = n.logs && new n.logs(this), this.metrics = n.metrics && new n.metrics(this), this.experiments = n.experiments && new n.experiments(this), this.exceptions = n.exceptions && new n.exceptions(this), this.people = { set: (s, r, o) => {
      const a = ye(s) ? { [s]: r } : s;
      this.setPersonProperties(a), o == null || o({});
    }, set_once: (s, r, o) => {
      const a = ye(s) ? { [s]: r } : s;
      this.setPersonProperties(void 0, a), o == null || o({});
    } }, this.on("eventCaptured", (s) => H.info(`send "${s == null ? void 0 : s.event}"`, s));
  }
  init(t, n, s) {
    if (s && s !== Ci) {
      var r;
      const o = (r = Ri[s]) !== null && r !== void 0 ? r : new As();
      return o._init(t, n, s), Ri[s] = o, Ri[Ci][s] = o, o;
    }
    return this._init(t, n, s);
  }
  _init(t, n = {}, s) {
    var r, o, a;
    const l = ye(t) ? t.trim() : "";
    if (!l) return H.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    var d;
    if (this.__loaded) return l !== ((d = this.config) === null || d === void 0 ? void 0 : d.token) ? console.warn("[PostHog.js]", `You have already initialized PostHog with a different project token! Re-initializing is a no-op, so events will keep going to the project this instance was initialized with. To capture into a second project, load PostHog once, then initialize a named instance after the SDK has loaded, e.g. posthog.init('${l}', { ... }, 'project2')`) : console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = qa(n.defaults), n.debug = this.Su(n.debug), this.xu = n, this.Cu = [], n.person_profiles ? this.wu = n.person_profiles : n.process_person && (this.wu = n.process_person);
    const c = qa(n.defaults), u = $u(n), h = Xe({}, c, u, { name: s, token: l });
    xe(c.rageclick) && xe(u.rageclick) && (h.rageclick = Xe({}, c.rageclick, u.rageclick)), xe(c.session_recording) && xe(u.session_recording) && (h.session_recording = Xe({}, c.session_recording, u.session_recording)), this.set_config(h), this.config.on_xhr_error && H.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = n.disable_compression ? void 0 : jn.GZipJS;
    const p = this.cu();
    if (this.persistence = new Fa(this.config, p), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Fa(x(x({}, this.config), {}, { persistence: "sessionStorage" }), p, !1), this.mu = "ph_" + (this.config.persistence_name || this.config.token) + "_session_registered_properties", this.config.persistence !== "memory" && !p && Ze.Et()) {
      const _ = Ze.Dt(this.mu);
      ae(_) && _.forEach(($) => {
        ye($) && this.gu.add($);
      });
    } else Ze.Lt(this.mu);
    const f = x({}, this.persistence.props), m = x({}, this.sessionPersistence.props);
    this.register({ $initialization_time: (/* @__PURE__ */ new Date()).toISOString() }), this.$u = new kx((_) => this.Tu(_), this.config.request_queue_config), this.Iu = new Ix(this), this.__request_queue = [];
    const g = this.ou();
    g || (this.sessionManager = new pu(this), this.sessionPropsManager = new hu(this, this.sessionManager, this.persistence), this.sessionManager.onSessionId((_, $, y) => {
      (y != null && y.activityTimeout || y != null && y.sessionPastMaximumLength || y != null && y.crossTabAdoption) && this.Mu();
    })), this.Eu(), this.config.__preview_deferred_init_extensions ? (H.info("Deferring extension initialization to improve startup performance"), setTimeout(() => {
      this.Pu(g);
    }, 0)) : (H.info("Initializing extensions synchronously"), this.Pu(g)), Ot.DEBUG = Ot.DEBUG || this.config.debug, Ot.DEBUG && H.info("Starting in debug mode", { this: this, config: n, thisC: x({}, this.config), p: f, s: m }), this.config.identity_distinct_id && !(!((r = n.bootstrap) === null || r === void 0) && r.distinctID) && (n.bootstrap = x(x({}, n.bootstrap), {}, { distinctID: this.config.identity_distinct_id, isIdentifiedID: !0 }));
    const v = (o = n.bootstrap) === null || o === void 0 ? void 0 : o.distinctID;
    if (this.uu = !!v && !Ni(v), ((a = n.bootstrap) === null || a === void 0 ? void 0 : a.distinctID) !== void 0) {
      const _ = n.bootstrap.distinctID, $ = this.get_distinct_id(), y = this.persistence.get_property(an);
      if (n.bootstrap.isIdentifiedID && $ != null && $ !== _ && y === "anonymous") this.identify(_);
      else if (n.bootstrap.isIdentifiedID && $ != null && $ !== _ && y === "identified") H.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
      else {
        const P = this.config.get_device_id(qn()), j = n.bootstrap.isIdentifiedID ? P : _;
        this.persistence.set_property(an, n.bootstrap.isIdentifiedID ? Co : $s), this.register({ distinct_id: _, $device_id: j });
      }
    }
    if (g) this.register_once({ distinct_id: ka, $device_id: null }, "");
    else if (!this.get_distinct_id()) {
      const _ = this.config.get_device_id(qn());
      this.register_once({ distinct_id: _, $device_id: _ }, ""), this.persistence.set_property(an, $s);
    }
    return We(k, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), { passive: !1 }), We(k, "pageshow", () => {
      var _;
      this.vu = !1, this.fu || (_ = this.Iu) === null || _ === void 0 || _.resume();
    }), n.segment ? nu(this, () => this.Ru()) : this.Ru(), Yt(this.config._onCapture) && this.config._onCapture !== Li && (H.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (_) => this.config._onCapture(_.event, _))), this.config.ip && H.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this.config.disableDeviceModel || function() {
      return lp.apply(this, arguments);
    }().then((_) => {
      _ && this.register({ [Sa]: _ });
    }).catch(Li), this;
  }
  Au(t) {
    const n = t;
    return ye(n.name) && Yt(n.setup);
  }
  Fu(t, n) {
    this.Au(t) ? n.push(() => {
      this.Ou().add(t).catch(() => {
        var s;
        return (s = t.dispose) === null || s === void 0 ? void 0 : s.call(t);
      }).catch((s) => {
        H.error(`Failed to dispose browser extension "${t.name}"`, s);
      });
    }) : this.Ja.push(t);
  }
  Eu() {
    var t, n, s;
    const r = (t = (n = this.config.__extensionClasses) === null || n === void 0 ? void 0 : n.featureFlags) !== null && t !== void 0 ? t : (s = As.__defaultExtensionClasses) === null || s === void 0 ? void 0 : s.featureFlags;
    var o, a, l;
    r && (this.featureFlags && this.featureFlags instanceof r || ((o = this.Du) === null || o === void 0 || o.call(this), this.Du = void 0, this.featureFlags = new r(this)), Yt(this.featureFlags.onReloading) && Yt(this.featureFlags.setup) ? this.Du || (this.Du = this.featureFlags.onReloading(() => {
      this.tu.emit("featureFlagsReloading", !0);
    }), this.Ou().add(this.featureFlags)) : (a = (l = this.featureFlags).initialize) === null || a === void 0 || a.call(l));
  }
  Pu(t) {
    const n = performance.now(), s = x(x({}, As.__defaultExtensionClasses), this.config.__extensionClasses), r = [];
    var o, a, l, d, c, u, h;
    s.exceptions && this.Ja.push(this.exceptions = (o = this.exceptions) !== null && o !== void 0 ? o : new s.exceptions(this)), s.historyAutocapture && this.Ja.push(this.historyAutocapture = new s.historyAutocapture(this)), s.tracingHeaders && this.Ja.push(this.tracingHeaders = new s.tracingHeaders(this)), s.siteApps && this.Ja.push(this.siteApps = new s.siteApps(this)), s.sessionRecording && !t && this.Ja.push(this.sessionRecording = new s.sessionRecording(this)), this.config.disable_scroll_properties || r.push(() => {
      this.scrollManager.startMeasuringScrollPosition();
    }), s.autocapture && this.Fu(this.autocapture = new s.autocapture(this), r), s.surveys && this.Fu(this.surveys = (a = this.surveys) !== null && a !== void 0 ? a : new s.surveys(this), r), s.logs && this.Fu(this.logs = (l = this.logs) !== null && l !== void 0 ? l : new s.logs(this), r), s.metrics && this.Ja.push(this.metrics = (d = this.metrics) !== null && d !== void 0 ? d : new s.metrics(this)), s.conversations && this.Ja.push(this.conversations = (c = this.conversations) !== null && c !== void 0 ? c : new s.conversations(this)), s.productTours && this.Ja.push(this.productTours = new s.productTours(this)), s.heatmaps && this.Ja.push(this.heatmaps = new s.heatmaps(this)), s.webVitalsAutocapture && this.Ja.push(this.webVitalsAutocapture = new s.webVitalsAutocapture(this)), s.exceptionObserver && this.Ja.push(this.exceptionObserver = new s.exceptionObserver(this)), s.deadClicksAutocapture && this.Ja.push(this.deadClicksAutocapture = new s.deadClicksAutocapture(this, ax)), s.toolbar && this.Ja.push(this.toolbar = (u = this.toolbar) !== null && u !== void 0 ? u : new s.toolbar(this)), s.experiments && this.Ja.push(this.experiments = (h = this.experiments) !== null && h !== void 0 ? h : new s.experiments(this)), this.Ja.forEach((p) => {
      p.initialize && r.push(() => {
        var f;
        (f = p.initialize) === null || f === void 0 || f.call(p);
      });
    }), r.push(() => {
      if (this.Lu) {
        const p = this.Lu;
        this.Lu = void 0, this.Ja.forEach((f) => {
          var m;
          return (m = f.onRemoteConfig) === null || m === void 0 ? void 0 : m.call(f, p);
        });
      }
    }), this.Nu(r, n);
  }
  Nu(t, n) {
    for (; t.length > 0; ) {
      if (this.config.__preview_deferred_init_extensions && performance.now() - n >= 30 && t.length > 0) return void setTimeout(() => {
        this.Nu(t, n);
      }, 0);
      const r = t.shift();
      if (r) try {
        r();
      } catch (o) {
        H.error("Error initializing extension:", o);
      }
    }
    const s = Math.round(performance.now() - n);
    this.register_for_session({ [xf]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous", [yf]: s }), this.config.__preview_deferred_init_extensions && H.info(`PostHog extensions initialized (${s}ms)`);
  }
  zl(t) {
    var n;
    if (!A || !A.body) return H.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.zl(t);
    }, 500);
    if (this.config.__preview_deferred_init_extensions && (this.Lu = t), this.Xa = t, this.compression = void 0, t.ok) {
      var s;
      const r = t.config;
      r.supportedCompression && !this.config.disable_compression && (this.compression = de(r.supportedCompression, jn.GZipJS) ? jn.GZipJS : de(r.supportedCompression, jn.Base64) ? jn.Base64 : void 0), !((s = r.analytics) === null || s === void 0) && s.endpoint && (this.analyticsDefaultEndpoint = r.analytics.endpoint);
    }
    this.set_config({ person_profiles: this.wu ? this.wu : Cf }), (n = this.qu) === null || n === void 0 || n.handleRemoteConfig(t), this.Ja.forEach((r) => {
      var o;
      return (o = r.onRemoteConfig) === null || o === void 0 ? void 0 : o.call(r, t);
    });
  }
  Ru() {
    try {
      this.config.loaded(this);
    } catch (t) {
      H.critical("`loaded` function failed", t);
    }
    if (this.ju(), this.config.internal_or_test_user_hostname && (ut == null ? void 0 : ut.hostname)) {
      const t = ut.hostname, n = this.config.internal_or_test_user_hostname;
      (typeof n == "string" ? t === n : n.test(t)) && this.setInternalOrTestUser();
    }
    this.config.capture_pageview && setTimeout(() => {
      (this.consent.isOptedIn() || this.ou()) && this.Bu();
    }, 1), this.Hu = new Yf(this), this.Hu.load();
  }
  ju() {
    var t;
    this.is_capturing() && this.config.request_batching && ((t = this.$u) === null || t === void 0 || t.enable());
  }
  _dom_loaded() {
    this.is_capturing() && io(this.__request_queue, (t) => this.Tu(t)), this.__request_queue = [], this.ju();
  }
  _handle_unload() {
    var t, n, s, r, o, a;
    this.vu = !0, (t = this.surveys) === null || t === void 0 || (n = t.handlePageUnload) === null || n === void 0 || n.call(t), (s = this.metrics) === null || s === void 0 || s.flush("sendBeacon"), this.config.request_batching ? (this.zu() && this.capture(Dc), (r = this.logs) === null || r === void 0 || r.flushLogs("sendBeacon"), (o = this.$u) === null || o === void 0 || o.unload(), (a = this.Iu) === null || a === void 0 || a.unload()) : this.zu() && this.capture(Dc, null, { transport: "sendBeacon" });
  }
  _send_request(t) {
    var n, s, r;
    this.__loaded ? pp ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) ? t.fireCallbackOnDrop && ((s = t.callback) === null || s === void 0 || s.call(t, { statusCode: 429 })) : (t.transport = t.transport || this.config.api_transport, t.headers = x(x({}, this.config.request_headers), t.headers), t.compression = t.compression === "best-available" ? (n = this.compression) !== null && n !== void 0 ? n : t.compressionFallback : t.compression, (L(this.config.disable_beacon) ? this.config.__preview_disable_beacon : this.config.disable_beacon) && (t.disableTransport = ["sendBeacon"]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((o) => {
      var a, l, d;
      const c = x({}, o);
      c.timeout = c.timeout || 6e4;
      const u = (a = c.transport) !== null && a !== void 0 ? a : "fetch";
      u === "sendBeacon" && L(c.compression) && c.data && (c.compression = jn.Base64), c.method === "POST" && c.data && (c.timestampMode === "capture-body" ? c.data = ((m) => {
        var g, v;
        const _ = (ae(m) ? m : [m]).map((y) => x(x({}, y), y.timestamp instanceof Date && !isNaN(y.timestamp.getTime()) ? { timestamp: y.timestamp.toISOString() } : {})), $ = _[0];
        return { api_key: (g = $ == null || (v = $.properties) === null || v === void 0 ? void 0 : v.token) !== null && g !== void 0 ? g : $ == null ? void 0 : $.token, batch: _, sent_at: (/* @__PURE__ */ new Date()).toISOString() };
      })(c.data) : c.timestampMode === "body" && (c.data = ((m, g = (/* @__PURE__ */ new Date()).toISOString()) => ae(m) ? m.map((v) => x(x({}, v), {}, { sent_at: g })) : x(x({}, m), {}, { sent_at: g }))(c.data))), c.url = uu(c.url, c.method, c.compression, c.timestampMode);
      const h = Sx.filter((m) => !c.disableTransport || !m.transport || !c.disableTransport.includes(m.transport)), p = (l = (d = function(m, g) {
        for (let v = 0; m.length > v; v++) if (g(m[v])) return m[v];
      }(h, (m) => m.transport === u)) === null || d === void 0 ? void 0 : d.method) !== null && l !== void 0 ? l : h[0].method;
      if (!p) throw new Error("No available transport method");
      const f = (m) => {
        try {
          p(m);
        } catch (v) {
          var g;
          rp(v) ? H.warn(v) : H.error(v), (g = c.callback) === null || g === void 0 || g.call(c, { statusCode: 0, error: v });
        }
      };
      u !== "sendBeacon" && c.data && c.compression === jn.GZipJS && _$ && typeof Promise < "u" && !No ? jx(c).then((m) => {
        f(m);
      }).catch((m) => {
        if (Rc(m)) return No = !0, void f(x(x({}, c), {}, { compression: void 0, url: uu(o.url, o.method, void 0, o.timestampMode) }));
        ((g) => {
          if (!g || typeof g != "object") return !1;
          const v = "name" in g ? String(g.name) : "";
          return Rc(g) || v === ef;
        })(m) && (No = !0), f(c);
      }) : p(c);
    })(x(x({}, t), {}, { callback: (o) => {
      var a, l, d;
      this.rateLimiter.checkForLimiting(o), 400 > o.statusCode || (l = (d = this.config).on_request_error) === null || l === void 0 || l.call(d, o), (a = t.callback) === null || a === void 0 || a.call(t, o);
    } }))) : t.fireCallbackOnDrop && ((r = t.callback) === null || r === void 0 || r.call(t, { statusCode: 0 }));
  }
  Tu(t) {
    this.Iu ? this.Iu.retriableRequest(t) : this._send_request(t);
  }
  _execute_array(t) {
    za++;
    try {
      let n;
      const s = [], r = [], o = [];
      io(t, (l) => {
        if (l) if (n = l[0], ae(n)) o.push(l);
        else if (Yt(l)) try {
          l.call(this);
        } catch (d) {
          H.error("Error executing queued PostHog call", l, d);
        }
        else ae(l) && n === "alias" ? s.push(l) : ae(l) && n.indexOf("capture") !== -1 && Yt(this[n]) ? o.push(l) : r.push(l);
      });
      const a = function(l, d) {
        io(l, function(c) {
          try {
            if (ae(c[0])) {
              let u = d;
              Me(c, function(h) {
                u = u[h[0]].apply(u, h.slice(1));
              });
            } else d[c[0]].apply(d, c.slice(1));
          } catch (u) {
            H.error("Error executing queued PostHog call", c, u);
          }
        });
      };
      a(s, this), a(r, this), a(o, this);
    } finally {
      za--;
    }
  }
  push(t) {
    if (za > 0 && ae(t) && ye(t[0])) {
      const n = As.prototype[t[0]];
      return void (Yt(n) && n.apply(this, t.slice(1)));
    }
    this._execute_array([t]);
  }
  Uu() {
    var t;
    const n = (t = this.persistence) === null || t === void 0 ? void 0 : t.get_property(Un);
    return ye(n) && Ha.test(n) ? { value: n, delivered: !1 } : xe(n) && ye(n.value) && Ha.test(n.value) ? { value: n.value, delivered: n.delivered === !0 } : void 0;
  }
  Wu(t, n, s, r) {
    if (!this.persistence) return;
    this.persistence.refreshKey(Un);
    const o = this.Uu();
    if (!r) {
      if (s) return ye(n) && Ha.test(n) ? (n !== (o == null ? void 0 : o.value) && this.persistence.register({ [Un]: { value: n, delivered: !1 } }), { value: n, pending: n !== (o == null ? void 0 : o.value) || !o.delivered }) : void this.persistence.unregister(Un);
      if (ye(t) && qx.test(t)) {
        if ((o == null ? void 0 : o.value.split(".")[3]) === t) return { value: o.value, pending: !o.delivered };
        const a = `fb.1.${Date.now()}.${t}`;
        return this.persistence.register({ [Un]: { value: a, delivered: !1 } }), { value: a, pending: !0 };
      }
      return o ? { value: o.value, pending: !o.delivered } : void 0;
    }
    this.persistence.unregister(Un);
  }
  Vu(t) {
    if (!this.persistence) return;
    this.persistence.refreshKey(Un);
    const n = this.Uu();
    (n == null ? void 0 : n.value) !== t || n.delivered || this.persistence.register({ [Un]: { value: t, delivered: !0 } });
  }
  capture(t, n, s) {
    var r, o, a, l, d;
    if (!(this.__loaded && this.persistence && this.sessionPersistence && this.$u)) return void H.uninitializedWarning("posthog.capture");
    if (!this.is_capturing()) return;
    if (L(t) || !ye(t)) return void H.error("No event name provided to posthog.capture");
    this.hu();
    const c = !this.config.opt_out_useragent_filter && this._is_bot();
    if (c && !this.config.__preview_capture_bot_pageviews) return;
    const u = s != null && s.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
    if (u != null && u.isRateLimited) return void H.critical("This capture call is ignored due to client rate limiting.");
    let h;
    n != null && n.$current_url && !ye(n == null ? void 0 : n.$current_url) && (H.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), n == null || delete n.$current_url), t !== "$exception" || s != null && s.Gu || H.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && (h = this.sessionPersistence.update_campaign_params()), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
    const p = /* @__PURE__ */ new Date(), f = (s == null ? void 0 : s.timestamp) || p, m = Cc(s == null ? void 0 : s.uuid, qn);
    let g = { uuid: m, event: t, properties: this.calculateEventProperties(t, n || {}, f, m) };
    t === "$pageview" && this.config.__preview_capture_bot_pageviews && c && (g.event = "$bot_pageview", g.properties.$browser_type = "bot"), u && (g.properties.$lib_rate_limit_remaining_tokens = u.remainingTokens);
    const v = t === "$feature_flag_called" && g.properties.$feature_flag_has_experiment === !1 && this.get_property("$minimal_flag_called_events") === !0;
    s != null && s.$set && !v && (g.$set = s == null ? void 0 : s.$set);
    const _ = xe(n == null ? void 0 : n.$set) ? n.$set : void 0, $ = !!(s != null && s.$set) && "$fbc" in s.$set, y = $ || !!_ && "$fbc" in _, P = $ ? s == null || (r = s.$set) === null || r === void 0 ? void 0 : r[ro] : _ == null ? void 0 : _[ro], j = ae(n == null ? void 0 : n.$unset) ? n.$unset : [], b = (s == null ? void 0 : s.$unset) || [], N = j.indexOf("$fbc") !== -1 || b.indexOf("$fbc") !== -1, C = this.Wu(h == null ? void 0 : h.fbclid, P, y, N);
    C && g.properties.$process_person_profile === !0 && C.pending && !y && !v && (g.$set = x({ [ro]: C.value }, g.$set));
    const S = s == null ? void 0 : s.$unset;
    S && (g.$unset = S);
    const F = v ? void 0 : this.Zu(s == null ? void 0 : s.$set_once, t !== Bc, t === Pl);
    if (F && (g.$set_once = F), s != null && s._noTruncate || (W = this.config.properties_string_max_length, g = function(X, Q) {
      const M = /* @__PURE__ */ new Set();
      return function he(le, ce) {
        if (le !== Object(le)) return Q ? Q(le) : le;
        if (M.has(le)) return;
        let we;
        if (M.add(le), ae(le)) we = [], io(le, (ue) => {
          we.push(he(ue));
        });
        else {
          const ue = {};
          Me(Ji(le) ? jf(le) : le, (pe, Pe) => {
            M.has(pe) || (ue[Pe] = he(pe));
          }), we = ue;
        }
        return we;
      }(X);
    }(g, (X) => ye(X) ? X.slice(0, W) : X)), g.timestamp = f, L(s == null ? void 0 : s.timestamp) || (g.properties.$event_time_override_provided = !0, g.properties.$event_time_override_system_time = p), v && (g.properties = ((X, Q = []) => {
      const M = {}, he = (le) => {
        X[le] !== void 0 && (M[le] = X[le]);
      };
      return ob.forEach(he), Q.forEach(he), M;
    })(g.properties, Gx)), t === bs.DISMISSED || t === bs.SENT) {
      const X = n == null ? void 0 : n[Ma.SURVEY_ID], Q = n == null ? void 0 : n[Ma.SURVEY_ITERATION];
      hp({ id: X, current_iteration: Q }), g.$set = x(x({}, g.$set), {}, { [Rx({ id: X, current_iteration: Q }, t === bs.SENT ? "responded" : "dismissed")]: !0 });
    } else t === bs.SHOWN && (g.$set = x(x({}, g.$set), {}, { [Ma.SURVEY_LAST_SEEN_DATE]: (/* @__PURE__ */ new Date()).toISOString() }));
    var W;
    if (t === gx.SHOWN) {
      const X = n == null ? void 0 : n[iu.TOUR_TYPE];
      X && (g.$set = x(x({}, g.$set), {}, { [`${iu.TOUR_LAST_SEEN_DATE}/${X}`]: (/* @__PURE__ */ new Date()).toISOString() }));
    }
    const D = x(x({}, g.properties.$set), g.$set);
    if (mn(D) || this.setPersonPropertiesForFlags(D), !_e(this.config.before_send)) {
      const X = this.$s(g);
      if (!X) return;
      g = X, g.uuid = Cc(g.uuid, qn);
    }
    const B = (o = (a = g.$set) === null || a === void 0 ? void 0 : a.$fbc) !== null && o !== void 0 ? o : xe((l = g.properties) === null || l === void 0 ? void 0 : l.$set) ? g.properties.$set[ro] : void 0, q = C != null && C.pending && B === C.value ? C.value : void 0;
    this.tu.emit("eventCaptured", g);
    const G = (d = s == null ? void 0 : s._url) !== null && d !== void 0 ? d : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), z = x(x({ method: "POST", url: G, data: g, compression: "best-available", timestampMode: (s == null ? void 0 : s._batchKey) === "recordings" || /\/s\/(?:\?|$)/.test(G) ? "body" : "capture-body", batchKey: s == null ? void 0 : s._batchKey }, s != null && s.transport ? { transport: s.transport } : {}), q ? { fireCallbackOnDrop: !0, callback: (X) => {
      X.statusCode >= 200 && 300 > X.statusCode && this.Vu(q);
    } } : {});
    var re;
    return !this.config.request_batching || s && !(s != null && s._batchKey) || s != null && s.send_instantly || q ? (!z.transport && !z.callback && mn((re = this.config.request_headers) !== null && re !== void 0 ? re : {}) && this.vu && (z.transport = "sendBeacon"), this.Tu(z)) : this.$u.enqueue(z), g;
  }
  _addCaptureHook(t) {
    return this.on("eventCaptured", (n) => t(n.event, n));
  }
  getExtension(t) {
    var n;
    return (n = this.qu) === null || n === void 0 ? void 0 : n.getExtension(t);
  }
  Ou() {
    var t;
    return (t = this.qu) !== null && t !== void 0 ? t : this.qu = new Hx(this);
  }
  iu(t) {
    this.yu.push(t);
    let n = !0;
    return () => {
      if (!n) return;
      n = !1;
      const s = this.yu.indexOf(t);
      s !== -1 && this.yu.splice(s, 1);
    };
  }
  Qu(t = !0) {
    var n, s, r;
    return !!(!((n = this.persistence) === null || n === void 0) && n.consumeCookieIdentityChange()) && (this.ku = null, this.persistence.get_property("$user_state") === "anonymous" && ((r = this.sessionPersistence) === null || r === void 0 || r.clear(), this.gu.clear(), this.Ju()), (s = this.featureFlags) === null || s === void 0 || s.reset(), t && this.reloadFeatureFlags(), !0);
  }
  calculateEventProperties(t, n, s, r, o) {
    if (s = s || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return n;
    this.persistence.syncCookieProperties(), this.Qu();
    const a = o ? void 0 : this.persistence.remove_event_timer(t);
    let l = x({}, n);
    if (l.token = this.config.token, l.$config_defaults = this.config.defaults, this.ou() && (l[bf] = !0), t === "$snapshot") {
      const $ = x(x({}, this.persistence.properties()), this.sessionPersistence.properties());
      return l.distinct_id = $.distinct_id, (!ye(l.distinct_id) && !bt(l.distinct_id) || Ni(l.distinct_id)) && H.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), l;
    }
    const d = function($, y, P, j = !1) {
      var b, N, C, S;
      if (!rn) return {};
      const F = $ ? [...Jr, ...y || []] : [], [W, D] = Gh(rn), [B, q] = function(we) {
        for (let ue = 0; wc.length > ue; ue++) {
          const [pe, Pe, Y] = wc[ue], ie = we.match(pe);
          if (ie) {
            const ve = Y && we.match(Y) || ie;
            return [Pe, (ve == null ? void 0 : ve[1]) || ""];
          }
        }
        return ["", ""];
      }(rn), G = function() {
        const we = "u" > typeof navigator ? navigator : void 0;
        return we != null && we.brave ? { brave: !0 } : {};
      }(), z = {};
      L(P) || (z.detectGoogleSearchApp = P);
      const re = {}, X = (b = navigator) === null || b === void 0 || (b = b.userAgentData) === null || b === void 0 ? void 0 : b.platform, Q = (N = navigator) === null || N === void 0 ? void 0 : N.maxTouchPoints, M = k == null || (C = k.screen) === null || C === void 0 ? void 0 : C.width, he = k == null || (S = k.screen) === null || S === void 0 ? void 0 : S.height, le = k == null ? void 0 : k.devicePixelRatio;
      L(X) || (re.userAgentDataPlatform = X), L(Q) || (re.maxTouchPoints = Q), L(M) || (re.screenWidth = M), L(he) || (re.screenHeight = he), L(le) || (re.devicePixelRatio = le);
      const ce = Xe(bd({ $os: W, $os_version: D, $browser: qh(rn, navigator.vendor, G, z), $webview_app: B, $webview_app_version: q, $device: Vh(rn), $device_type: P$(rn, re), $timezone: Vf(), $timezone_offset: px() }), { $current_url: Gi(j ? zs(ut == null ? void 0 : ut.href) : ut == null ? void 0 : ut.href, F, Vi), $host: ut == null ? void 0 : ut.host, $pathname: ut == null ? void 0 : ut.pathname, $raw_user_agent: rn.length > 1e3 ? rn.substring(0, 997) + "..." : rn, $browser_version: I$(rn, navigator.vendor, G, z), $browser_language: zf(), $browser_language_prefix: fx(), $screen_height: k == null ? void 0 : k.screen.height, $screen_width: k == null ? void 0 : k.screen.width, $viewport_height: k == null ? void 0 : k.innerHeight, $viewport_width: k == null ? void 0 : k.innerWidth, $lib: xs.LIB_NAME, $lib_version: xs.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
      return xs.SDK_DIST_CHANNEL && (ce.$sdk_dist_channel = xs.SDK_DIST_CHANNEL), ce;
    }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app, this.config.disable_capture_url_hashes);
    if (this.sessionManager) {
      const { sessionId: $, windowId: y } = this.sessionManager.checkAndGetSessionAndWindowId(o, s.getTime(), !0);
      l.$session_id = $, l.$window_id = y;
    }
    this.sessionPropsManager && Xe(l, this.sessionPropsManager.getSessionProps());
    try {
      var c;
      this.sessionRecording && Xe(l, this.sessionRecording.sdkDebugProperties), l.$sdk_debug_retry_queue_size = (c = this.Iu) === null || c === void 0 ? void 0 : c.length;
    } catch ($) {
      l.$sdk_debug_error_capturing_properties = String($);
    }
    let u;
    if (this.requestRouter.region === zl && (l.$lib_custom_api_host = this.config.api_host), u = t !== "$pageview" || o ? t !== "$pageleave" || o ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(s) : this.pageViewManager.doPageView(s, r), l = Xe(l, u), t === "$pageview" && A && (l.title = A.title), !L(a)) {
      const $ = s.getTime() - a;
      l.$duration = parseFloat(($ / 1e3).toFixed(3));
    }
    rn && this.config.opt_out_useragent_filter && (l.$browser_type = this._is_bot() ? "bot" : "browser");
    const h = this.persistence.properties(), p = this.sessionPersistence.properties(), f = l.$groups, m = h.$groups;
    xe(f) && !mn(f) && (l.$groups = x(x({}, xe(m) ? m : {}), f)), Me(["$referrer", "$referring_domain"], ($) => {
      $ in h && delete p[$];
    });
    const g = {};
    if (this.yu.length > 0) for (const $ of this.yu.slice()) try {
      Xe(g, $());
    } catch (y) {
      H.error("Failed to produce browser extension event properties", y);
    }
    l = Xe({}, d, h, p, x(x({}, g), l)), l.$is_identified = this._isIdentified(), ae(this.config.property_denylist) ? Me(this.config.property_denylist, function($) {
      delete l[$];
    }) : H.error(fp + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    const v = this.config.sanitize_properties;
    v && (H.error(vu), l = v(l, t));
    const _ = this.Ku();
    return l.$process_person_profile = _, _ && !o && this.Yu("_calculate_event_properties"), l;
  }
  Zu(t, n = !0, s = !1) {
    var r;
    if (!this.persistence || !this.Ku() || this.pu && !s) return t;
    const o = this.persistence.get_initial_props(), a = (r = this.sessionPropsManager) === null || r === void 0 ? void 0 : r.getSetOnceProps();
    let l = Xe({}, o, a || {}, t || {});
    const d = this.config.sanitize_properties;
    return d && (H.error(vu), l = d(l, "$set_once")), n && (this.pu = !0), mn(l) ? void 0 : l;
  }
  register(t, n) {
    var s;
    (s = this.persistence) === null || s === void 0 || s.register(t, n);
  }
  register_once(t, n, s) {
    var r;
    (r = this.persistence) === null || r === void 0 || r.register_once(t, n, s);
  }
  register_for_session(t) {
    var n, s;
    (n = this.persistence) === null || n === void 0 || n.syncCookieProperties(), this.Qu(), (s = this.sessionPersistence) === null || s === void 0 || s.register(t), Object.keys(t).forEach((r) => this.gu.add(r)), this.Ju();
  }
  unregister(t) {
    var n;
    (n = this.persistence) === null || n === void 0 || n.unregister(t);
  }
  unregister_for_session(t) {
    var n;
    (n = this.sessionPersistence) === null || n === void 0 || n.unregister(t), this.gu.delete(t), this.Ju();
  }
  Xu(t, n) {
    this.register({ [t]: n });
  }
  Mu() {
    this.gu.forEach((t) => {
      var n;
      (n = this.sessionPersistence) === null || n === void 0 || n.unregister(t);
    }), this.gu.clear(), this.Ju();
  }
  Ju() {
    var t;
    if (!this.mu) return;
    if (this.config.persistence === "memory" || !((t = this.sessionPersistence) === null || t === void 0) && t.pi || !Ze.Et()) return void Ze.Lt(this.mu);
    const n = [];
    this.gu.forEach((s) => n.push(s)), n.length > 0 ? Ze.At(this.mu, n) : Ze.Lt(this.mu);
  }
  getFeatureFlag(t, n) {
    var s;
    return (s = this.featureFlags) === null || s === void 0 ? void 0 : s.getFeatureFlag(t, n);
  }
  getFeatureFlagPayload(t) {
    var n;
    return (n = this.featureFlags) === null || n === void 0 ? void 0 : n.getFeatureFlagPayload(t);
  }
  getFeatureFlagResult(t, n) {
    var s;
    return (s = this.featureFlags) === null || s === void 0 ? void 0 : s.getFeatureFlagResult(t, n);
  }
  getAllFeatureFlags() {
    var t, n;
    return (t = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.getAllFeatureFlags()) !== null && t !== void 0 ? t : [];
  }
  isFeatureEnabled(t, n) {
    var s, r;
    return (s = (r = this.featureFlags) === null || r === void 0 ? void 0 : r.isFeatureEnabled(t, n)) !== null && s !== void 0 ? s : n == null ? void 0 : n.defaultValue;
  }
  reloadFeatureFlags() {
    var t;
    (t = this.featureFlags) === null || t === void 0 || t.reloadFeatureFlags();
  }
  updateFlags(t, n, s) {
    var r;
    (r = this.featureFlags) === null || r === void 0 || r.updateFlags(t, n, s);
  }
  updateEarlyAccessFeatureEnrollment(t, n, s) {
    var r;
    (r = this.featureFlags) === null || r === void 0 || r.updateEarlyAccessFeatureEnrollment(t, n, s);
  }
  getEarlyAccessFeatures(t, n = !1, s) {
    var r;
    return (r = this.featureFlags) === null || r === void 0 ? void 0 : r.getEarlyAccessFeatures(t, n, s);
  }
  on(t, n) {
    return this.tu.on(t, n);
  }
  onFeatureFlags(t) {
    return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, { errorsLoading: !0 }), () => {
    });
  }
  onSurveysLoaded(t) {
    return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], { isLoaded: !1, error: _i }), () => {
    });
  }
  onSessionId(t) {
    var n, s;
    return (n = (s = this.sessionManager) === null || s === void 0 ? void 0 : s.onSessionId(t)) !== null && n !== void 0 ? n : () => {
    };
  }
  getSurveys(t, n = !1) {
    this.surveys ? this.surveys.getSurveys(t, n) : t([], { isLoaded: !1, error: _i });
  }
  getActiveMatchingSurveys(t, n = !1) {
    this.surveys ? this.surveys.getActiveMatchingSurveys(t, n) : t([], { isLoaded: !1, error: _i });
  }
  renderSurvey(t, n) {
    var s;
    (s = this.surveys) === null || s === void 0 || s.renderSurvey(t, n);
  }
  displaySurvey(t, n = Mx) {
    var s;
    (s = this.surveys) === null || s === void 0 || s.displaySurvey(t, n);
  }
  cancelPendingSurvey(t) {
    var n;
    (n = this.surveys) === null || n === void 0 || n.cancelPendingSurvey(t);
  }
  canRenderSurvey(t) {
    var n, s;
    return (n = (s = this.surveys) === null || s === void 0 ? void 0 : s.canRenderSurvey(t)) !== null && n !== void 0 ? n : { visible: !1, disabledReason: _i };
  }
  canRenderSurveyAsync(t, n = !1) {
    var s, r;
    return (s = (r = this.surveys) === null || r === void 0 ? void 0 : r.canRenderSurveyAsync(t, n)) !== null && s !== void 0 ? s : Promise.resolve({ visible: !1, disabledReason: _i });
  }
  th(t) {
    return !t || Ni(t) ? (H.critical("Unique user id has not been set in posthog.identify"), !1) : t === "$posthog_cookieless" ? (H.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.`), !1) : !["distinct_id", "distinctid"].includes(t.toLowerCase()) && !["undefined", "null"].includes(t.toLowerCase()) || (H.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.`), !1);
  }
  identify(t, n, s) {
    if (!this.__loaded || !this.persistence) return H.uninitializedWarning("posthog.identify");
    if (bt(t) && (t = t.toString(), H.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), !this.th(t) || !this.Yu("posthog.identify")) return;
    this.hu();
    const r = this.get_distinct_id(), o = this.persistence.syncCookieProperties() && this.get_distinct_id() !== r, a = this.Qu(!1), l = this.persistence.Sl();
    let d = !1;
    try {
      const u = this.get_distinct_id();
      this.register({ $user_id: t }), this.get_property("$device_id") || this.register_once({ $had_persisted_distinct_id: !0, $device_id: u }, ""), t !== u && t !== this.get_property("__alias") && (this.unregister(Do), this.register({ distinct_id: t }));
      const h = (this.persistence.get_property("$user_state") || "anonymous") === $s, p = t !== u, f = !p && h;
      if (p && h) {
        var c;
        const m = this.config.reuseAnonymousId ? { distinct_id: t } : { distinct_id: t, $anon_distinct_id: u };
        this.persistence.set_property(an, Co), this.setPersonPropertiesForFlags({ $set: n || {}, $set_once: s || {} }, !1), this.config.cookieWinsOnConflict && this.persistence.xl(), this.capture(Pl, m, { $set: n || {}, $set_once: s || {} }), this.ku = Ua(t, n, s), (c = this.featureFlags) === null || c === void 0 || c.setAnonymousDistinctId(this.config.reuseAnonymousId ? void 0 : u);
      } else if (f) {
        this.persistence.set_property(an, Co);
        const m = n || {}, g = s || {};
        this.setPersonPropertiesForFlags({ $set: m, $set_once: g }, !1), this.config.cookieWinsOnConflict && this.persistence.xl(), this.capture("$set", { $set: m, $set_once: g }), this.ku = Ua(t, n, s);
      } else (n || s) && this.setPersonProperties(n, s);
      p || o || a ? (this.reloadFeatureFlags(), this.featureFlags ? this.featureFlags.resetFlagCallReported() : this.unregister(Ws)) : f && (n || s) && this.reloadFeatureFlags(), d = !0;
    } finally {
      l && this.persistence.Tl(d);
    }
  }
  setPersonProperties(t, n) {
    if (!t && !n || !this.Yu("posthog.setPersonProperties")) return;
    const s = Ua(this.get_distinct_id(), t, n);
    this.ku !== s ? (this.setPersonPropertiesForFlags({ $set: t || {}, $set_once: n || {} }, !0), this.capture("$set", { $set: t || {}, $set_once: n || {} }), this.ku = s) : H.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
  }
  unsetPersonProperties(t) {
    var n;
    const s = (ae(t) ? t : [t]).filter((r) => ye(r) && r.length > 0);
    s.length !== 0 && this.Yu("posthog.unsetPersonProperties") && ((n = this.featureFlags) === null || n === void 0 || n.unsetPersonPropertiesForFlags(s, !0), this.capture("$set", { $unset: s }), this.ku = null);
  }
  group(t, n, s) {
    var r;
    if (!t || !n) return void H.error("posthog.group requires a group type and group key");
    (r = this.persistence) === null || r === void 0 || r.syncCookieProperties(), this.Qu();
    const o = this.getGroups(), a = o[t] !== n;
    if (a && this.resetGroupPropertiesForFlags(t), this.register({ $groups: x(x({}, o), {}, { [t]: n }) }), (a || s) && this.Ku()) {
      const l = { $group_type: t, $group_key: n };
      s && (l.$group_set = s), this.capture(Bc, l);
    }
    s && this.setGroupPropertiesForFlags({ [t]: s }), a && !s && this.reloadFeatureFlags();
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(t, n = !0) {
    var s;
    (s = this.featureFlags) === null || s === void 0 || s.setPersonPropertiesForFlags(t, n);
  }
  resetPersonPropertiesForFlags(t = !0) {
    var n;
    (n = this.featureFlags) === null || n === void 0 || n.resetPersonPropertiesForFlags(t);
  }
  setGroupPropertiesForFlags(t, n = !0) {
    var s;
    this.Yu("posthog.setGroupPropertiesForFlags") && ((s = this.featureFlags) === null || s === void 0 || s.setGroupPropertiesForFlags(t, n));
  }
  resetGroupPropertiesForFlags(t) {
    var n;
    (n = this.featureFlags) === null || n === void 0 || n.resetGroupPropertiesForFlags(t);
  }
  reset(t) {
    const n = ln(t) ? t : t == null ? void 0 : t.resetDeviceID, s = ln(t) || t == null ? void 0 : t.bootstrap;
    this.eh(n, !1, s);
  }
  eh(t, n = !1, s) {
    var r, o, a, l, d, c;
    if (H.info("reset"), !this.__loaded) return H.uninitializedWarning("posthog.reset");
    const u = s == null ? void 0 : s.sessionID;
    this.config.bootstrap = s || ((r = this.xu) === null || r === void 0 ? void 0 : r.bootstrap) || {}, (o = this.featureFlags) === null || o === void 0 || (a = o.updateConfig) === null || a === void 0 || a.call(o, this.config, this.Ul());
    const h = this.get_property(pd), p = this.get_property(Sa), f = this.get_property(ki);
    (l = this.sessionRecording) === null || l === void 0 || l.flushBeforeIdentityReset();
    const m = this.is_capturing();
    this.consent.reset(), n || !m || this.is_capturing() || console.warn("[PostHog.js]", "reset() cleared the stored consent, and capturing is now off because of `opt_out_capturing_by_default`. Call opt_in_capturing() again, and prefer calling reset() before opting in rather than after.");
    const g = (d = this.persistence) === null || d === void 0 || (c = d.Sl) === null || c === void 0 ? void 0 : c.call(d);
    let v = !1;
    try {
      var _, $, y, P, j, b, N, C, S, F, W, D, B;
      if ((_ = this.persistence) === null || _ === void 0 || _.clear(), ($ = this.sessionPersistence) === null || $ === void 0 || $.clear(), this.gu.clear(), this.Ju(), L(f) || (F = this.persistence) === null || F === void 0 || F.register({ $session_recording_remote_config: f }), (y = this.surveys) === null || y === void 0 || y.reset(), (P = this.featureFlags) === null || P === void 0 || P.reset(), (j = this.conversations) === null || j === void 0 || j.reset(), (b = this.logs) === null || b === void 0 || b.reset(), (N = this.metrics) === null || N === void 0 || N.reset(), (C = this.persistence) === null || C === void 0 || C.set_property("$user_state", "anonymous"), (S = this.sessionManager) === null || S === void 0 || S.resetSessionId(), this.ku = null, this.config.cookieless_mode === "always") this.register_once({ distinct_id: ka, $device_id: null }, "");
      else {
        const z = this.config.get_device_id(qn());
        this.register_once({ distinct_id: z, $device_id: t ? z : h }, ""), t || L(p) || this.register({ [Sa]: p });
      }
      if (this.register({ $last_posthog_reset: (/* @__PURE__ */ new Date()).toISOString() }, 1), s && (s.distinctID === void 0 || this.ou() || ((B = this.persistence) === null || B === void 0 || B.set_property("$user_state", s.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: s.distinctID })), (W = this.featureFlags) === null || W === void 0 || W.initialize(), !L(u) && !(!((D = this.sessionManager) === null || D === void 0) && D.setBootstrapSessionId(u, !0)))) {
        const z = x({}, s);
        delete z.sessionID, this.config.bootstrap = z;
      }
      delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, v = !0;
    } finally {
      var q, G;
      g && ((q = this.persistence) === null || q === void 0 || (G = q.Tl) === null || G === void 0 || G.call(q, v));
    }
    this.reloadFeatureFlags();
  }
  shutdown(t) {
    var n = this;
    return Qe(function* () {
      var s, r, o, a, l, d, c;
      if (n.__loaded) {
        n.fu = !0, n.Ou().dispose(), (s = n.sessionRecording) === null || s === void 0 || s.dispose(), (r = n.logs) === null || r === void 0 || r.flushLogs("sendBeacon"), (o = n.metrics) === null || o === void 0 || o.flush("sendBeacon"), (a = n.$u) === null || a === void 0 || a.unload(), (l = n.Iu) === null || l === void 0 || l.unload();
        try {
          var u;
          (u = n.featureFlags) === null || u === void 0 || u.destroy();
        } catch (h) {
          H.error("Error while destroying feature flags", h);
        }
        (d = n.persistence) === null || d === void 0 || d.destroy(), (c = n.sessionPersistence) === null || c === void 0 || c.destroy();
      } else H.uninitializedWarning("posthog.shutdown");
    })();
  }
  setIdentity(t, n) {
    var s;
    delete this.config.identity_claims, this.config.identity_distinct_id = t, this.config.identity_hash = n, this.alias(t), (s = this.conversations) === null || s === void 0 || s.ih();
  }
  clearIdentity() {
    var t;
    delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, (t = this.conversations) === null || t === void 0 || t.nh();
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var t, n;
    return (t = (n = this.sessionManager) === null || n === void 0 ? void 0 : n.checkAndGetSessionAndWindowId(!0).sessionId) !== null && t !== void 0 ? t : "";
  }
  get_session_replay_url(t) {
    if (!this.sessionManager) return "";
    const { sessionId: n, sessionStartTimestamp: s } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
    let r = this.requestRouter.endpointFor("ui", `/project/${this.config.token}/replay/${n}`);
    if (t != null && t.withTimestamp && s) {
      var o;
      const a = (o = t.timestampLookBack) !== null && o !== void 0 ? o : 10;
      if (!s) return r;
      r += `?t=${Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - s) / 1e3) - a, 0)}`;
    }
    return r;
  }
  alias(t, n) {
    return t === this.get_property("$people_distinct_id") ? (H.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Yu("posthog.alias") ? (L(n) && (n = this.get_distinct_id()), t !== n ? (this.Xu(Do, t), this.capture("$create_alias", { alias: t, distinct_id: n })) : (H.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
  }
  set_config(t) {
    const n = x({}, this.config);
    if (xe(t)) {
      var s, r, o, a, l, d, c, u, h, p, f, m, g;
      Xe(this.config, $u(t));
      const _ = this.cu();
      (s = this.persistence) === null || s === void 0 || s.update_config(this.config, n, _), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Fa(x(x({}, this.config), {}, { persistence: "sessionStorage" }), _, !1);
      const $ = this.Su(this.config.debug);
      var v;
      ln($) && (this.config.debug = $), ln(this.config.debug) && (this.config.debug ? (Ot.DEBUG = !0, ke.Et() && ke.At("ph_debug", !0), H.info("set_config", { config: t, oldConfig: n, newConfig: x({}, this.config) })) : (Ot.DEBUG = !1, ke.Et() && ke.Lt("ph_debug"))), (r = this.featureFlags) === null || r === void 0 || (o = r.updateConfig) === null || o === void 0 || o.call(r, this.config, this.Ul()), (a = this.exceptionObserver) === null || a === void 0 || a.onConfigChange(), (l = this.exceptions) === null || l === void 0 || l.onConfigChange(), (d = this.sessionRecording) === null || d === void 0 || d.startIfEnabledOrStop(), (c = this.tracingHeaders) === null || c === void 0 || c.startIfEnabledOrStop(), (u = this.autocapture) === null || u === void 0 || u.startIfEnabled(), (h = this.heatmaps) === null || h === void 0 || h.startIfEnabled(), ("capture_pageview" in t || "disable_capture_url_hashes" in t) && ((v = this.historyAutocapture) === null || v === void 0 || v.startIfEnabledOrStop()), (p = this.exceptionObserver) === null || p === void 0 || p.startIfEnabledOrStop(), (f = this.deadClicksAutocapture) === null || f === void 0 || f.startIfEnabledOrStop(), (m = this.surveys) === null || m === void 0 || m.loadIfEnabled(), this.du(), (g = this.externalIntegrations) === null || g === void 0 || g.startIfEnabledOrStop(), !n.segment && this.config.segment && this.persistence && nu(this, Li, !1);
    }
  }
  _overrideSDKInfo(t, n) {
    Ot.LIB_NAME = t, Ot.LIB_VERSION = n;
  }
  startSessionRecording(t) {
    const n = t === !0, s = { sampling: n || !!(t != null && t.sampling), linked_flag: n || !!(t != null && t.linked_flag), url_trigger: n || !!(t != null && t.url_trigger), event_trigger: n || !!(t != null && t.event_trigger) };
    var r, o, a, l, d;
    Object.values(s).some(Boolean) && ((r = this.sessionManager) === null || r === void 0 || r.checkAndGetSessionAndWindowId(), s.sampling && ((o = this.sessionRecording) === null || o === void 0 || o.overrideSampling()), s.linked_flag && ((a = this.sessionRecording) === null || a === void 0 || a.overrideLinkedFlag()), s.url_trigger && ((l = this.sessionRecording) === null || l === void 0 || l.overrideTrigger("url")), s.event_trigger && ((d = this.sessionRecording) === null || d === void 0 || d.overrideTrigger("event"))), this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var t;
    return !!(!((t = this.sessionRecording) === null || t === void 0) && t.started);
  }
  captureException(t, n) {
    try {
      if (!this.exceptions) return;
      const s = this.exceptions.buildProperties(t, { handled: !0, syntheticException: new Error("PostHog syntheticException") });
      return this.exceptions.sendExceptionEvent(x(x({}, s), n));
    } catch {
      return;
    }
  }
  addExceptionStep(t, n) {
    var s;
    (s = this.exceptions) === null || s === void 0 || s.addExceptionStep(t, n);
  }
  captureLog(t) {
    var n;
    (n = this.logs) === null || n === void 0 || n.captureLog(t);
  }
  get logger() {
    var t, n;
    return (t = (n = this.logs) === null || n === void 0 ? void 0 : n.logger) !== null && t !== void 0 ? t : As.sh;
  }
  startExceptionAutocapture(t) {
    this.set_config({ capture_exceptions: t == null || t });
  }
  stopExceptionAutocapture() {
    this.set_config({ capture_exceptions: !1 });
  }
  loadToolbar(t) {
    var n, s;
    return (n = (s = this.toolbar) === null || s === void 0 ? void 0 : s.loadToolbar(t)) !== null && n !== void 0 && n;
  }
  get_property(t) {
    var n;
    return (n = this.persistence) === null || n === void 0 ? void 0 : n.props[t];
  }
  getSessionProperty(t) {
    var n;
    return (n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.props[t];
  }
  toString() {
    var t;
    let n = (t = this.config.name) !== null && t !== void 0 ? t : Ci;
    return n !== Ci && (n = "posthog." + n), n;
  }
  _isIdentified() {
    var t, n;
    return ((t = this.persistence) === null || t === void 0 ? void 0 : t.get_property("$user_state")) === "identified" || ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.get_property("$user_state")) === "identified";
  }
  Ku() {
    var t, n;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && mn(this.getGroups()) && !(!((t = this.persistence) === null || t === void 0 || (t = t.props) === null || t === void 0) && t.__alias) && !(!((n = this.persistence) === null || n === void 0 || (n = n.props) === null || n === void 0) && n.$epp));
  }
  zu() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && !!this.config.capture_pageview;
  }
  createPersonProfile() {
    this.Ku() || this.Yu("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  setInternalOrTestUser() {
    this.Yu("posthog.setInternalOrTestUser") && this.setPersonProperties({ $internal_or_test_user: !0 });
  }
  Yu(t) {
    return this.config.person_profiles === "never" ? (H.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.lu(), this.Xu(gd, !0), !0);
  }
  cu() {
    if (this.config.cookieless_mode === "always") return !0;
    const t = this.consent.isOptedOut();
    return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && this.config.cookieless_mode !== "on_reject");
  }
  du() {
    var t, n;
    const s = this.cu();
    var r, o, a;
    return this.is_capturing() || (r = this.logs) === null || r === void 0 || r.rh(), ((t = this.persistence) === null || t === void 0 ? void 0 : t.pi) !== s && ((o = this.persistence) === null || o === void 0 || o.set_disabled(s)), ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.pi) !== s && ((a = this.sessionPersistence) === null || a === void 0 || a.set_disabled(s)), s && (this.gu.clear(), this.Ju()), s;
  }
  opt_in_capturing(t) {
    var n;
    if (this.config.cookieless_mode !== "always") {
      if (this.ou()) {
        var s, r, o, a, l, d;
        (s = this.sessionRecording) === null || s === void 0 || s.dispose({ discardBufferedEvents: !0 }), this.eh(!0, !0), (r = this.sessionManager) === null || r === void 0 || r.destroy(), (o = this.pageViewManager) === null || o === void 0 || o.destroy(), this.sessionManager = new pu(this), this.pageViewManager = new su(this), this.persistence && (this.sessionPropsManager = new hu(this, this.sessionManager, this.persistence));
        const f = (a = (l = this.config.__extensionClasses) === null || l === void 0 ? void 0 : l.sessionRecording) !== null && a !== void 0 ? a : (d = As.__defaultExtensionClasses) === null || d === void 0 ? void 0 : d.sessionRecording;
        var c, u;
        f && (this.sessionRecording = this.ru(this.sessionRecording, new f(this)), this.Xa && ((c = this.sessionRecording) === null || c === void 0 || (u = c.onRemoteConfig) === null || u === void 0 || u.call(c, this.Xa)));
      }
      var h, p;
      this.consent.optInOut(!0), this.du(), this.ju(), (n = this.sessionRecording) === null || n === void 0 || n.startIfEnabledOrStop(), this.config.cookieless_mode == "on_reject" && ((h = this.surveys) === null || h === void 0 || h.loadIfEnabled()), (L(t == null ? void 0 : t.captureEventName) || t != null && t.captureEventName) && this.capture((p = t == null ? void 0 : t.captureEventName) !== null && p !== void 0 ? p : "$opt_in", t == null ? void 0 : t.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this.Bu();
    } else H.warn(gu);
  }
  opt_out_capturing() {
    if (this.config.cookieless_mode === "always") return void H.warn(gu);
    const t = this.config.cookieless_mode === "on_reject" ? this.sessionRecording : void 0;
    var n, s;
    t == null || t.dispose({ discardBufferedEvents: !0 }), this.config.cookieless_mode === "on_reject" && this.consent.isOptedIn() && this.eh(!0, !0), this.consent.optInOut(!1), this.du(), this.config.cookieless_mode === "on_reject" && (this.register({ distinct_id: ka, $device_id: null }), this.su(t), this.sessionRecording = void 0, (n = this.sessionManager) === null || n === void 0 || n.destroy(), (s = this.pageViewManager) === null || s === void 0 || s.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.Bu(), this.ju());
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  get_explicit_consent_status() {
    const t = this.consent.consent;
    return t === 1 ? "granted" : t === 0 ? "denied" : "pending";
  }
  is_capturing() {
    return this.config.cookieless_mode === "always" || (this.config.cookieless_mode === "on_reject" ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this.du();
  }
  _is_bot() {
    return At ? ap(At, this.config.custom_blocked_useragents) : void 0;
  }
  Bu() {
    A && (A.visibilityState === "visible" ? this.bu || (this.bu = !0, this.capture($d, { title: A.title }, { send_instantly: !0 }), this._u && (A.removeEventListener(zi, this._u), this._u = null)) : this._u || (this._u = this.Bu.bind(this), We(A, zi, this._u)));
  }
  debug(t) {
    t === !1 ? (k == null || k.console.log("You've disabled debug mode."), this.set_config({ debug: !1 })) : (k == null || k.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({ debug: !0 }));
  }
  Ul() {
    const t = this.xu || {};
    return "advanced_disable_flags" in t ? !!t.advanced_disable_flags : this.config.advanced_disable_flags !== !1 ? !!this.config.advanced_disable_flags : this.config.advanced_disable_decide === !0 ? (H.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : function(n, s, r, o, a) {
      const l = s in n && !_e(n[s]), d = r in n && !_e(n[r]);
      return l ? n[s] : !!d && (a.warn(`Config field '${r}' is deprecated. Please use '${s}' instead. The old field will be removed in a future major version.`), n[r]);
    }(t, "advanced_disable_flags", "advanced_disable_decide", 0, H);
  }
  $s(t) {
    var n;
    if (_e(this.config.before_send)) return t;
    const s = Object.keys((n = t.properties) !== null && n !== void 0 ? n : {}).filter($$), r = ae(this.config.before_send) ? this.config.before_send : [this.config.before_send];
    let o = t;
    for (const a of r) try {
      if (o = a(o), _e(o)) {
        const l = `Event '${t.event}' was rejected in beforeSend function`;
        return v$(t.event) ? H.warn(`${l}. This can cause unexpected behavior.`) : H.info(l), null;
      }
      o.properties && !mn(o.properties) || H.warn(`Event '${t.event}' has no properties after beforeSend function, this is likely an error.`);
    } catch (l) {
      return H.error(`Error in beforeSend function for event '${t.event}':`, l), null;
    }
    for (const a of s) if (o.properties && _e(o.properties[a])) return H.warn(`Event '${t.event}' had its '${a}' property removed in a beforeSend function. This property is required for ingestion, so the event will be dropped.`), null;
    return o;
  }
  getPageViewId() {
    var t;
    return (t = this.pageViewManager.Ao) === null || t === void 0 ? void 0 : t.pageViewId;
  }
  captureTraceFeedback(t, n) {
    this.capture("$ai_feedback", { $ai_trace_id: String(t), $ai_feedback_text: n });
  }
  captureTraceMetric(t, n, s) {
    this.capture("$ai_metric", { $ai_trace_id: String(t), $ai_metric_name: n, $ai_metric_value: String(s) });
  }
  Su(t) {
    const n = ln(t) && !t, s = ke.Et() && ke.Ot("ph_debug") === "true";
    return !n && (!!s || t);
  }
};
Oi.__defaultExtensionClasses = {}, Oi.sh = /* @__PURE__ */ (() => {
  const e = () => {
  };
  return { trace: e, debug: e, info: e, warn: e, error: e, fatal: e };
})(), function(e, t) {
  for (let n = 0; t.length > n; n++) e.prototype[t[n]] = Hb(e.prototype[t[n]]);
}(Oi, ["identify"]);
var _p = class {
  constructor(e) {
    this.disabled = e === !1;
    const t = xe(e) ? e : {};
    this.thresholdPx = t.threshold_px || 30, this.timeoutMs = t.timeout_ms || 1e3, this.clickCount = t.click_count || 3, this.clicks = [];
  }
  isRageClick(e, t, n) {
    if (this.disabled) return !1;
    const s = this.clicks[this.clicks.length - 1];
    if (s && Math.abs(e - s.x) + Math.abs(t - s.y) < this.thresholdPx && this.timeoutMs > n - s.timestamp) {
      if (this.clicks.push({ x: e, y: t, timestamp: n }), this.clicks.length === this.clickCount) return !0;
    } else this.clicks = [{ x: e, y: t, timestamp: n }];
    return !1;
  }
};
const Ga = "$copy_autocapture", ho = xt("[AutoCapture]");
function Va(e, t) {
  return t.length > e ? t.slice(0, e) + "..." : t;
}
function Jx(e) {
  if (e.previousElementSibling) return e.previousElementSibling;
  let t = e;
  do
    t = t.previousSibling;
  while (t && !ns(t));
  return t;
}
function Zx(e, { e: t, maskAllElementAttributes: n, maskAllText: s, elementAttributeIgnoreList: r, elementsChainAsString: o, disableCaptureUrlHashes: a }) {
  var l, d;
  if (!ns(e)) return { props: {} };
  const c = [e], u = /* @__PURE__ */ new Set([e]);
  let h = e;
  for (; h.parentNode && !Kt(h, "body") && 1e3 > c.length; ) {
    if (xd(h.parentNode)) {
      const b = h.parentNode.host;
      if (u.has(b)) break;
      u.add(b), c.push(b), h = b;
      continue;
    }
    if (!ns(h.parentNode) || u.has(h.parentNode)) break;
    u.add(h.parentNode), c.push(h.parentNode), h = h.parentNode;
  }
  const p = t.type === "click" && e.namespaceURI === "http://www.w3.org/2000/svg" ? c.findIndex((b) => Kt(b, "button") || Kt(b, "a")) : -1;
  p > 0 && (s = s || c.slice(0, p + 1).some((b) => !zr(b) || qi(b)));
  const f = [], m = {};
  let g, v = !1, _ = !1;
  if (Me(c, (b) => {
    const N = zr(b);
    if (Kt(b, "a")) {
      const C = b.getAttribute("href");
      v = !!(N && C && Pi(C)) && (a ? zs(C) : C);
    }
    de(Vr(b), "ph-no-capture") && (_ = !0), f.push(function(C, S, F, W, D = !1) {
      const B = C.tagName.toLowerCase(), q = { tag_name: B };
      wd.indexOf(B) > -1 && !F && (q.$el_text = B.toLowerCase() === "a" || B.toLowerCase() === "button" ? Va(1024, Qc(C)) : Va(1024, Hi(C)));
      const G = Vr(C);
      G.length > 0 && (q.classes = G.filter(function(Q) {
        return Q !== "";
      })), Me(C.attributes, function(Q) {
        var M;
        if ((!qi(C) || ["name", "id", "class", "aria-label"].indexOf(Q.name) !== -1) && !(W != null && W.includes(Q.name)) && !S && Pi(Q.value) && (!ye(M = Q.name) || M.substring(0, 10) !== "_ngcontent" && M.substring(0, 7) !== "_nghost")) {
          let he = Q.value;
          Q.name === "class" && (he = yd(he).join(" ")), q["attr__" + Q.name] = Va(1024, Q.name === "href" && D ? zs(he) : he);
        }
      });
      let z = 1, re = 1, X = C;
      for (; X = Jx(X); ) z++, X.tagName === C.tagName && re++;
      return q.nth_child = z, q.nth_of_type = re, q;
    }(b, n, s, r, a)), Me(function(C) {
      if (!zr(C)) return {};
      const S = {};
      return Me(C.attributes, function(F) {
        if (F.name && F.name.indexOf("data-ph-capture-attribute") === 0) {
          const W = F.name.replace("data-ph-capture-attribute-", ""), D = F.value;
          W && D && Pi(D) && (S[W] = D);
        }
      }), S;
    }(b), (C, S) => {
      ({}).hasOwnProperty.call(m, S) || (m[S] = C);
    });
  }), _) return { props: {}, explicitNoCapture: _ };
  if (p > 0 && (e = c[p], f.splice(0, p)), s || (f[0].$el_text = Kt(e, "a") || Kt(e, "button") ? Qc(e) : Hi(e)), v) {
    var $, y;
    f[0].attr__href = v;
    const b = ($ = Yr(v)) === null || $ === void 0 ? void 0 : $.host, N = k == null || (y = k.location) === null || y === void 0 ? void 0 : y.host;
    b && N && b !== N && (g = v);
  }
  return { props: Xe((j = t.type, { $event_type: j, $ce_version: 1 }), o ? {} : { $elements: f }, { $elements_chain: (P = f, ae(P) ? function(b) {
    return b.map((N) => {
      var C, S;
      let F = "";
      if (N.tag_name && (F += N.tag_name), N.attr_class) {
        N.attr_class.sort();
        for (const B of N.attr_class) F += `.${B.replace(/"/g, "")}`;
      }
      const W = x(x(x(x({}, N.text ? { text: N.text } : {}), {}, { "nth-child": (C = N.nth_child) !== null && C !== void 0 ? C : 0, "nth-of-type": (S = N.nth_of_type) !== null && S !== void 0 ? S : 0 }, N.href ? { href: N.href } : {}), N.attr_id ? { attr_id: N.attr_id } : {}), N.attributes), D = {};
      return jo(W).sort(([B], [q]) => function(G, z) {
        return z > G ? -1 : G > z ? 1 : 0;
      }(B, q)).forEach(([B, q]) => D[eu(B.toString())] = eu(q.toString())), F += ":", F += jo(D).map(([B, q]) => `${B}="${q}"`).join(""), F;
    }).join(";");
  }(function(b) {
    return b.map((N) => {
      var C, S;
      const F = { text: (C = N.$el_text) === null || C === void 0 ? void 0 : C.slice(0, 400), tag_name: N.tag_name, href: (S = N.attr__href) === null || S === void 0 ? void 0 : S.slice(0, 2048), attr_class: ix(N), attr_id: N.attr__id, nth_child: N.nth_child, nth_of_type: N.nth_of_type, attributes: {} };
      return jo(N).filter(([W]) => W.indexOf("attr__") === 0).forEach(([W, D]) => F.attributes[W] = D), F;
    });
  }(P)) : "") }, !((l = f[0]) === null || l === void 0) && l.$el_text ? { $el_text: (d = f[0]) === null || d === void 0 ? void 0 : d.$el_text } : {}, g && t.type === "click" ? { $external_click_url: g } : {}, m), target: e };
  var P, j;
}
var Xx = class {
  Js() {
    this.Ks = void 0, clearTimeout(this.Ys), this.Ys = void 0;
  }
  Xs(e) {
    var t;
    if (!zr(e)) return !0;
    const n = (t = this.so().css_selector_ignorelist) !== null && t !== void 0 ? t : La, s = /* @__PURE__ */ new Set();
    let r = e;
    for (; r; ) {
      if (s.size >= 1e3 || s.has(r)) return !0;
      s.add(r);
      const o = r, a = Vr(o);
      if (de(a, "ph-no-capture") || de(a, "ph-sensitive") || qi(o) || n.some((d) => Fl(o, d))) return !0;
      const l = r.parentNode;
      r = xd(l) ? l.host : l && ns(l) ? l : null;
    }
    return !1;
  }
  oo(e) {
    if (!this.isEnabled || e.type === "pointercancel") return void this.Js();
    if (e.type === "pointerdown") {
      this.Js();
      const s = Ii(e);
      var t;
      return void (e.isPrimary && e.button === 0 && !e.ctrlKey && s && ns(s) && (this.Ks = { target: s, excluded: this.Xs(s), id: e.pointerId, x: e.clientX, y: e.clientY, released: !1, distinctId: (t = this.lo) === null || t === void 0 ? void 0 : t.distinctId }));
    }
    const n = this.Ks;
    n && (e.pointerId !== n.id || Math.abs(e.clientX - n.x) > 5 || Math.abs(e.clientY - n.y) > 5 ? this.Js() : e.type === "pointerup" && (n.released = !0, this.Ys = setTimeout(() => this.Js(), 0)));
  }
  ao(e) {
    var t;
    const n = this.Ks;
    this.Js();
    const s = Ii(e);
    if (n != null && n.released && n.target.isConnected && n.distinctId === ((t = this.lo) === null || t === void 0 ? void 0 : t.distinctId) && e.pointerId === n.id && (e.detail > 0 || e.pointerType === "touch" || e.pointerType === "pen") && e.button === 0 && 5 >= Math.abs(e.clientX - n.x) && 5 >= Math.abs(e.clientY - n.y) && s && (Kt(s, "html") || Kt(s, "body"))) {
      var r;
      if (n.excluded) return null;
      const o = (r = this.so().css_selector_ignorelist) !== null && r !== void 0 ? r : La;
      return [s, A == null ? void 0 : A.documentElement, A == null ? void 0 : A.body].some((a) => {
        if (!a) return !1;
        const l = Vr(a);
        return de(l, "ph-no-capture") || de(l, "ph-sensitive") || !zr(a) || qi(a) || o.some((d) => Fl(a, d));
      }) ? null : n.target;
    }
  }
  constructor(e) {
    this.uo = e, this.name = "autocapture", this.ho = !1, this.co = null, this.do = !1, this.vo = !1, this.Sr = { enabled: !1, rageclick: !1, maskAllElementAttributes: !1, maskAllText: !1, disableCaptureUrlHashes: !1, remoteRequestsDisabled: !1 }, this.fo = !1, this.uo.refresh(this.Sr), this.rageclicks = new _p(this.Sr.rageclick), this.po = null;
  }
  setup(e) {
    this.mo(), this.lo = e;
    const t = e.onRemoteConfig(this.onRemoteConfig.bind(this));
    this.fo ? t.dispose() : (this.yo = t, this.startIfEnabled());
  }
  dispose() {
    var e;
    this.fo || (this.fo = !0, this.lo = void 0, (e = this.yo) === null || e === void 0 || e.dispose(), this.yo = void 0, this.bo());
  }
  so() {
    return this.uo.refresh(this.Sr), this.Sr;
  }
  mo() {
    var e, t;
    return this.so(), this.Sr.url_allowlist = (e = this.Sr.url_allowlist) === null || e === void 0 ? void 0 : e.map((n) => new RegExp(n)), this.Sr.url_ignorelist = (t = this.Sr.url_ignorelist) === null || t === void 0 ? void 0 : t.map((n) => new RegExp(n)), this.Sr;
  }
  _o() {
    if (!this.isBrowserSupported()) return void ho.info("Disabling Automatic Event Collection because this browser is not supported");
    if (!k || !A) return;
    const e = this.wo = (t) => {
      t = t || (k == null ? void 0 : k.event);
      try {
        if (t.type === "blur") return void this.Js();
        if (t.type.indexOf("pointer") === 0) return void this.oo(t);
        const n = t.type === "click" ? this.ao(t) : void 0;
        if (gt(n)) return;
        this.ko(t, "$autocapture", n);
      } catch (n) {
        ho.error("Failed to capture event", n);
      }
    };
    if (We(k, "blur", e), We(A, "submit", e, { capture: !0 }), We(A, "change", e, { capture: !0 }), We(A, "click", e, { capture: !0 }), Me(["pointerdown", "pointermove", "pointerup", "pointercancel"], (t) => {
      We(A, t, e, { capture: !0 });
    }), this.so().capture_copied_text) {
      const t = this.So = (n) => {
        n = n || (k == null ? void 0 : k.event);
        try {
          this.ko(n, Ga);
        } catch (s) {
          ho.error("Failed to capture clipboard event", s);
        }
      };
      We(A, "copy", t, { capture: !0 }), We(A, "cut", t, { capture: !0 }), We(A, "paste", t, { capture: !0 });
    }
  }
  bo() {
    this.Js(), this.wo && (k == null || k.removeEventListener("blur", this.wo), Me(["pointerdown", "pointermove", "pointerup", "pointercancel"], (e) => {
      A == null || A.removeEventListener(e, this.wo, !0);
    }), A == null || A.removeEventListener("submit", this.wo, !0), A == null || A.removeEventListener("change", this.wo, !0), A == null || A.removeEventListener("click", this.wo, !0), this.wo = void 0), this.So && (A == null || A.removeEventListener("copy", this.So, !0), A == null || A.removeEventListener("cut", this.So, !0), A == null || A.removeEventListener("paste", this.So, !0), this.So = void 0), this.ho = !1;
  }
  startIfEnabled() {
    this.isEnabled || this.Js(), !this.fo && this.lo && this.isEnabled && !this.ho && (this._o(), this.ho = !0);
  }
  onRemoteConfig(e) {
    if (this.fo) return;
    if (this.do = !0, !e.ok) return void this.startIfEnabled();
    const t = e.config;
    t.elementsChainAsString && (this.vo = t.elementsChainAsString);
    const n = t.autocapture_opt_out;
    var s;
    ln(n) && ((s = this.lo) === null || s === void 0 || s.kv.set("$autocapture_disabled_server_side", n), this.co = n), this.startIfEnabled();
  }
  setElementSelectors(e) {
    this.po = e;
  }
  getElementSelectors(e, t) {
    var n;
    const s = [];
    return (n = this.po) === null || n === void 0 || n.forEach((r) => {
      const o = A == null ? void 0 : A.querySelectorAll(r);
      o == null || o.forEach((a) => {
        e !== a && t !== a || de(s, r) || s.push(r);
      });
    }), s;
  }
  get isEnabled() {
    var e, t;
    if (this.fo) return !1;
    const n = (e = this.lo) === null || e === void 0 ? void 0 : e.kv.get(df), s = this.co, r = this.so();
    if (!r.remoteRequestsDisabled && !this.do) return !1;
    const o = r.remoteRequestsDisabled && !this.do;
    if (gt(s) && !ln(n) && !o) return !1;
    const a = (t = this.co) !== null && t !== void 0 ? t : !!n;
    return !!r.enabled && !a;
  }
  ko(e, t = "$autocapture", n) {
    if (!this.isEnabled) return void this.Js();
    let s = n || Ii(e);
    Ef(s) && (s = s.parentNode || null);
    const r = this.mo();
    var o;
    t === "$autocapture" && e.type === "click" && e instanceof MouseEvent && r.rageclick && (!((o = this.rageclicks) === null || o === void 0) && o.isRageClick(e.clientX, e.clientY, e.timeStamp || (/* @__PURE__ */ new Date()).getTime())) && Rf(s, r.rageclick) && this.ko(e, "$rageclick", n);
    const a = t === Ga, l = a ? x(x({}, r), {}, { dom_event_allowlist: void 0 }) : r;
    if (s && function(h, p, f, m, g, v) {
      var _;
      if (!k || Cd(h) || f != null && f.url_allowlist && !Gc(f.url_allowlist, v) || f != null && f.url_ignorelist && Gc(f.url_ignorelist, v)) return !1;
      if (f != null && f.dom_event_allowlist) {
        const j = f.dom_event_allowlist;
        if (j && !j.some((b) => p.type === b)) return !1;
      }
      const { parentIsUsefulElement: $, targetElementList: y } = Lf(h, m);
      if (!function(j, b) {
        const N = b == null ? void 0 : b.element_allowlist;
        if (L(N)) return !0;
        for (const C of j) if (N.some((S) => C.tagName.toLowerCase() === S)) return !0;
        return !1;
      }(y, f) || !Al(y, f == null ? void 0 : f.css_selector_allowlist) || Al(y, (_ = f == null ? void 0 : f.css_selector_ignorelist) !== null && _ !== void 0 ? _ : La)) return !1;
      try {
        const j = k.getComputedStyle(h);
        if (j && j.getPropertyValue("cursor") === "pointer" && p.type === "click") return !0;
      } catch {
      }
      const P = h.tagName.toLowerCase();
      switch (P) {
        case "html":
          return !1;
        case "form":
          return (g || ["submit"]).indexOf(p.type) >= 0;
        case "input":
        case "select":
        case "textarea":
          return (g || ["change", "click"]).indexOf(p.type) >= 0;
        default:
          return $ ? (g || ["click"]).indexOf(p.type) >= 0 : (g || ["click"]).indexOf(p.type) >= 0 && (wd.indexOf(P) > -1 || h.getAttribute("contenteditable") === "true");
      }
    }(s, e, l, a, a ? ["copy", "cut", "paste"] : void 0, { config: { get_current_url: r.getCurrentUrl } })) {
      var d;
      const { props: h, explicitNoCapture: p, target: f } = Zx(s, { e, maskAllElementAttributes: r.maskAllElementAttributes, maskAllText: r.maskAllText, elementAttributeIgnoreList: r.element_attribute_ignorelist, elementsChainAsString: this.vo, disableCaptureUrlHashes: r.disableCaptureUrlHashes });
      if (p) return !1;
      const m = this.getElementSelectors(s, f);
      if (m && m.length > 0 && (h.$element_selectors = m), t === Ga) {
        const g = e.type || "clipboard";
        if (g !== "paste") {
          var c, u;
          const v = k == null || (c = k.getSelection()) === null || c === void 0 ? void 0 : c.toString(), _ = If(v);
          if (!_) return !1;
          h.$selected_content = _, h.$clipboard_text_length = (u = v == null ? void 0 : v.length) !== null && u !== void 0 ? u : 0;
        }
        h.$copy_type = g;
      }
      return (d = this.lo) === null || d === void 0 || d.capture(t, h).catch((g) => ho.error("Failed to capture event", g)), !0;
    }
  }
  isBrowserSupported() {
    return Yt(A == null ? void 0 : A.querySelectorAll);
  }
}, Qx = class {
  constructor(e) {
    this._instance = e;
  }
  refresh(e) {
    const t = this._instance.config, n = xe(t.autocapture) ? t.autocapture : void 0;
    e.enabled = !!t.autocapture, e.rageclick = t.rageclick, e.maskAllElementAttributes = t.mask_all_element_attributes, e.maskAllText = t.mask_all_text, e.disableCaptureUrlHashes = t.disable_capture_url_hashes, e.getCurrentUrl = t.get_current_url, e.remoteRequestsDisabled = this._instance.Ul(), e.url_allowlist = n == null ? void 0 : n.url_allowlist, e.url_ignorelist = n == null ? void 0 : n.url_ignorelist, e.dom_event_allowlist = n == null ? void 0 : n.dom_event_allowlist, e.element_allowlist = n == null ? void 0 : n.element_allowlist, e.css_selector_allowlist = n == null ? void 0 : n.css_selector_allowlist, e.css_selector_ignorelist = n == null ? void 0 : n.css_selector_ignorelist, e.element_attribute_ignorelist = n == null ? void 0 : n.element_attribute_ignorelist, e.capture_copied_text = n == null ? void 0 : n.capture_copied_text;
  }
};
const mi = xt("[ExceptionAutocapture]"), bu = () => {
}, xu = (e) => {
  var t;
  if (Yt(e)) return (t = e.__posthog_layer__) !== null && t !== void 0 ? t : e.__rrweb_layer__;
};
function mp(e, t, n) {
  try {
    if (!(t in e)) return bu;
    const s = { next: e[t] }, r = n(function(...o) {
      return s.next.apply(this, o);
    });
    return Yt(r) && (r.prototype = r.prototype || {}, Object.defineProperties(r, { __posthog_wrapped__: { enumerable: !1, value: !0 }, __posthog_layer__: { enumerable: !1, value: s } })), e[t] = r, () => {
      if (e[t] === r) return void (e[t] = s.next);
      let o = e[t], a = xu(o);
      for (; a; ) {
        if (a.next === r) return void (a.next = s.next);
        o = a.next, a = xu(o);
      }
    };
  } catch {
    return bu;
  }
}
const ey = xt("[TracingHeaders]"), Xs = xt("[Web Vitals]"), yu = 9e5, wu = ["CLS", "FCP", "INP", "LCP"], ty = ["INP", "LCP"], ny = ["interactionTarget", "interactionType", "inputDelay", "processingDuration", "presentationDelay", "loadState", "target", "url", "timeToFirstByte", "resourceLoadDelay", "resourceLoadDuration", "elementRenderDelay", "largestShiftTarget", "largestShiftTime", "largestShiftValue", "firstByteToFCP"], Ya = "disabled", Cu = "lazy_loading", os = xt("[SessionRecording]"), sy = xt("[Heatmaps]");
function Ka(e) {
  return xe(e) && "clientX" in e && "clientY" in e && bt(e.clientX) && bt(e.clientY);
}
const fo = xt("[Product Tours]"), Ja = (e) => {
  var t;
  return !e.config.disable_product_tours && !!(!((t = e.persistence) === null || t === void 0) && t.get_property(md));
}, ry = ["$set_once", "$set"], Jn = xt("[SiteApps]"), ju = "Error while initializing PostHog app with config id ", gp = (e, t) => e != null && e.then ? e.then(t) : t(e), Tr = "SDK is not enabled or survey functionality is not yet loaded", Nu = "Disabled. Not loading surveys.";
var iy = class {
  constructor(e, t) {
    this.uo = e, this.oh = t, this.name = "surveys", this._surveyEventReceiver = null, this._surveyManager = null, this.ah = !1, this.uh = [], this.hh = null, this.dh = null, this.fo = !1, this.fh = /* @__PURE__ */ new Set(), this.onRemoteConfig = (n) => {
      if (this.fo || this.Sr.disableSurveys) return;
      if (!n.ok) return De.warn("Remote config unavailable. Not loading surveys.");
      const s = n.config.surveys;
      if (_e(s)) return De.warn("Flags not loaded yet. Not loading surveys.");
      this.ph = ln(s) ? s : s.length > 0, De.info(`flags response received, isSurveysEnabled: ${this.ph}`), this.loadIfEnabled();
    };
  }
  setup(e) {
    if (!this.fo) return this.gh = e, gp(e.kv.initialize(), () => {
      if (this.gh !== e || this.fo) return;
      this.gh = void 0, this.lo = e;
      const t = e.onRemoteConfig(this.onRemoteConfig);
      this.fo ? t.dispose() : (this.yo = t, this.loadIfEnabled());
    });
  }
  dispose() {
    var e, t, n, s;
    this.fo || (this.fo = !0, this.gh = void 0, this.lo = void 0, (e = this.yo) === null || e === void 0 || e.dispose(), this.yo = void 0, (t = this._surveyEventReceiver) === null || t === void 0 || t.dispose(), this._surveyEventReceiver = null, (n = this._surveyManager) === null || n === void 0 || (s = n.dispose) === null || s === void 0 || s.call(n), this._surveyManager = null, this.uh = [], this.hh = null, this.fh.forEach((r) => clearTimeout(r)), this.fh.clear());
  }
  get Sr() {
    return this.uo.get();
  }
  initialize() {
    this.loadIfEnabled();
  }
  reset() {
    try {
      var e;
      (e = this._surveyEventReceiver) === null || e === void 0 || e.reset(), localStorage.removeItem("lastSeenSurveyDate");
      const t = [];
      for (let n = 0; n < localStorage.length; n++) {
        const s = localStorage.key(n);
        (s != null && s.startsWith("seenSurvey_") || s != null && s.startsWith("inProgressSurvey_")) && t.push(s);
      }
      t.forEach((n) => localStorage.removeItem(n));
    } catch {
    }
  }
  loadIfEnabled() {
    if (this.fo || !this.lo) return;
    const e = this.Sr;
    if (this._surveyManager) return;
    if (this.ah) return void De.info("Already initializing surveys, skipping...");
    if (e.disableSurveys) return void De.info(Nu);
    if (e.cookielessMode && this.uo.isOptedOut()) return void De.info("Not loading surveys in cookieless mode without consent.");
    const t = this.uo.getExtensions();
    if (!t) return void De.error("PostHog Extensions not found.");
    if (L(this.ph) && !e.advancedEnableSurveys) return;
    const n = this.ph || e.advancedEnableSurveys;
    this.ah = !0;
    try {
      const s = t.generateSurveys;
      if (s) return this.mh(s, n), void (this.ah = !1);
      const r = t.loadExternalDependency;
      if (!r) return this.yh(vd), void (this.ah = !1);
      r((o) => {
        try {
          if (this.fo) return;
          const a = this.uo.getExtensions();
          o || !(a != null && a.generateSurveys) ? this.yh("Could not load surveys script", o) : this.mh(a.generateSurveys, n);
        } finally {
          this.ah = !1;
        }
      });
    } catch (s) {
      throw this.ah = !1, this.yh("Error initializing surveys", s), s;
    }
  }
  mh(e, t) {
    this.fo || (this._surveyManager = e(t), this._surveyEventReceiver = this.uo.createEventReceiver(), De.info("Surveys loaded successfully"), this.bh({ isLoaded: !0 }));
  }
  yh(e, t) {
    De.error(e, t), this.bh({ isLoaded: !1, error: e });
  }
  onSurveysLoaded(e) {
    return this.uh.push(e), this._surveyManager && this.bh({ isLoaded: !0 }), () => {
      this.uh = this.uh.filter((t) => t !== e);
    };
  }
  getSurveys(e, t = !1) {
    var n;
    const s = (n = this.lo) !== null && n !== void 0 ? n : this.oh;
    if (!s || this.fo) return;
    if (this.Sr.disableSurveys) return De.info(Nu), e([]);
    const r = s.kv.get(kl);
    if (r && !t) return e(r, { isLoaded: !0 }), void (this._h() && this.getSurveys(() => {
    }, !0));
    if (this.hh) return void this.hh.then(({ surveys: l, context: d }) => {
      this.fo || e(l, d);
    }).catch((l) => De.error("Error in survey callback", l));
    const o = this.wh("/api/surveys/", { method: "GET", query: { token: s.projectToken }, sentAt: "query", timeoutMs: this.Sr.requestTimeoutMs }).then((l) => {
      try {
        return this.kh(s, l);
      } catch (d) {
        return De.error("Error processing surveys response", d), this.kh(s, { statusCode: 0, error: d });
      }
    }, (l) => this.kh(s, { statusCode: 0, error: l }));
    this.hh = o;
    const a = () => {
      this.hh === o && (this.hh = null);
    };
    o.then((l) => {
      a(), this.fo || e(l.surveys, l.context);
    }, a).catch((l) => De.error("Error in survey callback", l));
  }
  wh(e, t) {
    const n = this.lo;
    return n ? n.sendRequest(e, t) : new Promise((s) => s({ statusCode: 0, error: new Error(Tr) }));
  }
  kh(e, t) {
    if (this.fo) return { surveys: [], context: { isLoaded: !1, error: Tr } };
    const n = t.statusCode;
    if (n !== 200 || !t.json) {
      const a = `Surveys API could not be loaded, status: ${n}`;
      return n !== 0 ? De.error(a) : t.error || De.warn(a), this.dh = Date.now(), { surveys: [], context: { isLoaded: !1, error: a } };
    }
    this.dh = null;
    const s = t.json.surveys || [], r = s.filter((a) => function(l) {
      return !(!l.start_date || l.end_date);
    }(a) && (dp(a) || function(l) {
      var d;
      return !!(!((d = l.conditions) === null || d === void 0 || (d = d.actions) === null || d === void 0 || (d = d.values) === null || d === void 0) && d.length);
    }(a)));
    var o;
    return r.length > 0 && ((o = this._surveyEventReceiver) === null || o === void 0 || o.register(r)), e.kv.set({ [kl]: s, [Bo]: Date.now() }), { surveys: s, context: { isLoaded: !0 } };
  }
  _h() {
    return this.Sh() && !this.hh && !this.xh();
  }
  Sh() {
    var e, t;
    const n = (e = (t = this.lo) !== null && t !== void 0 ? t : this.oh) === null || e === void 0 ? void 0 : e.kv.get(Bo);
    return bt(n) && Date.now() - n > 3e5;
  }
  xh() {
    return bt(this.dh) && 3e5 > Date.now() - this.dh;
  }
  markSurveyAsSeen(e, t) {
    var n;
    const s = { id: e, current_iteration: (n = t == null ? void 0 : t.iteration) !== null && n !== void 0 ? n : null };
    hp(s);
    try {
      localStorage.setItem("lastSeenSurveyDate", (/* @__PURE__ */ new Date()).toISOString());
    } catch {
    }
  }
  bh(e) {
    for (const t of this.uh) try {
      if (!e.isLoaded) return t([], e);
      this.getSurveys(t);
    } catch (n) {
      De.error("Error in survey callback", n);
    }
  }
  getActiveMatchingSurveys(e, t = !1) {
    if (!_e(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(e, t);
    De.warn("init was not called");
  }
  Ch(e) {
    let t = null;
    return this.getSurveys((n) => {
      var s;
      t = (s = n.find((r) => r.id === e)) !== null && s !== void 0 ? s : null;
    }), t;
  }
  $h(e) {
    if (_e(this._surveyManager)) return { eligible: !1, reason: Tr };
    const t = typeof e == "string" ? this.Ch(e) : e;
    return t ? this._surveyManager.checkSurveyEligibility(t) : { eligible: !1, reason: "Survey not found" };
  }
  Th(e) {
    if (!this.uo.isCapturing()) return { eligible: !1, reason: "PostHog is not capturing, so a survey response cannot be recorded" };
    if (_e(this._surveyManager)) return { eligible: !1, reason: Tr };
    const t = typeof e == "string" ? this.Ch(e) : e;
    return t ? this._surveyManager.checkSurveyRenderability(t) : { eligible: !1, reason: "Survey not found" };
  }
  canRenderSurvey(e) {
    if (_e(this._surveyManager)) return De.warn("init was not called"), { visible: !1, disabledReason: Tr };
    const t = this.Th(e);
    return { visible: t.eligible, disabledReason: t.reason };
  }
  canRenderSurveyAsync(e, t) {
    return _e(this._surveyManager) ? (De.warn("init was not called"), Promise.resolve({ visible: !1, disabledReason: Tr })) : new Promise((n) => {
      this.getSurveys((s) => {
        var r;
        const o = (r = s.find((a) => a.id === e)) !== null && r !== void 0 ? r : null;
        if (o) {
          const a = this.Th(o);
          n({ visible: a.eligible, disabledReason: a.reason });
        } else n({ visible: !1, disabledReason: "Survey not found" });
      }, t);
    });
  }
  renderSurvey(e, t, n) {
    var s;
    if (!this.uo.isCapturing()) return;
    if (_e(this._surveyManager)) return void De.warn("init was not called");
    const r = typeof e == "string" ? this.Ch(e) : e;
    if (!(r != null && r.id)) return void De.warn("Survey not found");
    if (!Ax.includes(r.type)) return void De.warn(`Surveys of type ${r.type} cannot be rendered in the app`);
    const o = A == null ? void 0 : A.querySelector(t);
    if (o) {
      if (!((s = r.appearance) === null || s === void 0) && s.surveyPopupDelaySeconds) {
        De.info(`Rendering survey ${r.id} with delay of ${r.appearance.surveyPopupDelaySeconds} seconds`);
        const a = setTimeout(() => {
          var l, d;
          this.fh.delete(a), !this.fo && this.uo.isCapturing() && (De.info(`Rendering survey ${r.id} with delay of ${(l = r.appearance) === null || l === void 0 ? void 0 : l.surveyPopupDelaySeconds} seconds`), (d = this._surveyManager) === null || d === void 0 || d.renderSurvey(r, o, n), De.info(`Survey ${r.id} rendered`));
        }, 1e3 * r.appearance.surveyPopupDelaySeconds);
        return void this.fh.add(a);
      }
      this._surveyManager.renderSurvey(r, o, n);
    } else De.warn("Survey element not found");
  }
  displaySurvey(e, t) {
    var n;
    if (!this.uo.isCapturing()) return;
    if (_e(this._surveyManager)) return void De.warn("init was not called");
    const s = this.Ch(e);
    if (!s) return void De.warn("Survey not found");
    let r = s;
    if (!((n = s.appearance) === null || n === void 0) && n.surveyPopupDelaySeconds && t.ignoreDelay && (r = x(x({}, s), {}, { appearance: x(x({}, s.appearance), {}, { surveyPopupDelaySeconds: 0 }) })), t.displayType !== Ml.Popover && t.initialResponses && De.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), t.ignoreConditions === !1) {
      const o = this.$h(s);
      if (!o.eligible) return void De.warn("Survey is not eligible to be displayed: ", o.reason);
    }
    t.displayType !== Ml.Inline ? this._surveyManager.handlePopoverSurvey(r, t) : this.renderSurvey(r, t.selector, t.properties);
  }
  cancelPendingSurvey(e) {
    _e(this._surveyManager) ? De.warn("init was not called") : this._surveyManager.cancelSurvey(e);
  }
  handlePageUnload() {
    var e, t;
    (e = this._surveyManager) === null || e === void 0 || (t = e.handlePageUnload) === null || t === void 0 || t.call(e);
  }
};
function Rr(e, t, n) {
  if (_e(e)) return !1;
  switch (n) {
    case "exact":
      return e === t;
    case "contains": {
      const s = t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
      return new RegExp(s, "i").test(e);
    }
    case "regex":
      try {
        return new RegExp(t).test(e);
      } catch {
        return !1;
      }
    default:
      return !1;
  }
}
var oy = class {
  constructor(e) {
    this._instance = e, this.Ih = /* @__PURE__ */ new Set(), this.Mh = /* @__PURE__ */ new Set(), this.Eh = new Go(), this.Ph = (t, n) => this.Rh(t, n) && this.Ah(t, n) && this.Fh(t, n) && this.Oh(t, n), this.Rh = (t, n) => !(n != null && n.event) || (t == null ? void 0 : t.event) === (n == null ? void 0 : n.event);
  }
  init() {
    var e, t;
    L((e = this._instance) === null || e === void 0 ? void 0 : e._addCaptureHook) || (this.Dh = (t = this._instance) === null || t === void 0 ? void 0 : t._addCaptureHook((n, s) => {
      this.on(n, s);
    }));
  }
  dispose() {
    var e;
    (e = this.Dh) === null || e === void 0 || e.call(this), this.Dh = void 0, this.Eh = new Go();
  }
  register(e) {
    var t, n;
    if (!L((t = this._instance) === null || t === void 0 ? void 0 : t._addCaptureHook) && (e.forEach((s) => {
      var r;
      this.Ih.add(s), (r = s.steps) === null || r === void 0 || r.forEach((o) => {
        this.Mh.add((o == null ? void 0 : o.event) || "");
      });
    }), (n = this._instance) === null || n === void 0 ? void 0 : n.autocapture)) {
      const s = /* @__PURE__ */ new Set();
      this.Ih.forEach((r) => {
        var o;
        (o = r.steps) === null || o === void 0 || o.forEach((a) => {
          a != null && a.selector && s.add(a.selector);
        });
      }), this._instance.autocapture.setElementSelectors(s);
    }
  }
  replace(e) {
    this.Ih.clear(), this.Mh.clear(), this.register(e);
  }
  on(e, t) {
    t != null && e.length != 0 && (this.Mh.has(e) || this.Mh.has(t.event)) && this.Ih.forEach((n) => {
      this.Lh(t, n) && this.Eh.emit("actionCaptured", n.name);
    });
  }
  Nh(e) {
    this.onAction("actionCaptured", (t) => e(t));
  }
  Lh(e, t) {
    if ((t == null ? void 0 : t.steps) == null) return !1;
    for (const n of t.steps) if (this.Ph(e, n)) return !0;
    return !1;
  }
  onAction(e, t) {
    return this.Eh.on(e, t);
  }
  Ah(e, t) {
    if (t != null && t.url) {
      var n;
      const s = e == null || (n = e.properties) === null || n === void 0 ? void 0 : n.$current_url;
      if (!s || typeof s != "string" || !Rr(s, t.url, t.url_matching || "contains")) return !1;
    }
    return !0;
  }
  Fh(e, t) {
    return !!this.qh(e, t) && !!this.jh(e, t) && !!this.Bh(e, t);
  }
  qh(e, t) {
    var n;
    if (!(t != null && t.href)) return !0;
    const s = this.Hh(e);
    if (s.length > 0) return s.some((o) => Rr(o.href, t.href, t.href_matching || "exact"));
    const r = (e == null || (n = e.properties) === null || n === void 0 ? void 0 : n.$elements_chain) || "";
    return !!r && Rr(function(o) {
      const a = o.match(/(?::|")href="(.*?)"/);
      return a ? a[1] : "";
    }(r), t.href, t.href_matching || "exact");
  }
  jh(e, t) {
    var n;
    if (!(t != null && t.text)) return !0;
    const s = this.Hh(e);
    if (s.length > 0) return s.some((d) => Rr(d.text, t.text, t.text_matching || "exact") || Rr(d.$el_text, t.text, t.text_matching || "exact"));
    const r = (e == null || (n = e.properties) === null || n === void 0 ? void 0 : n.$elements_chain) || "";
    return !!r && (o = function(d) {
      const c = [], u = /(?::|")text="(.*?)"/g;
      let h;
      for (; !_e(h = u.exec(d)); ) c.includes(h[1]) || c.push(h[1]);
      return c;
    }(r), a = t.text, l = t.text_matching || "exact", o.some((d) => Rr(d, a, l)));
    var o, a, l;
  }
  Bh(e, t) {
    var n, s;
    if (!(t != null && t.selector)) return !0;
    const r = e == null || (n = e.properties) === null || n === void 0 ? void 0 : n.$element_selectors;
    if (r != null && r.includes(t.selector)) return !0;
    const o = (e == null || (s = e.properties) === null || s === void 0 ? void 0 : s.$elements_chain) || "";
    if (t.selector_regex && o) try {
      return new RegExp(t.selector_regex).test(o);
    } catch {
      return !1;
    }
    return !1;
  }
  Hh(e) {
    var t;
    return (e == null || (t = e.properties) === null || t === void 0 ? void 0 : t.$elements) == null ? [] : e == null ? void 0 : e.properties.$elements;
  }
  Oh(e, t) {
    return !(t != null && t.properties) || t.properties.length === 0 || up(t.properties.reduce((n, s) => {
      const r = ae(s.value) ? s.value.map(String) : s.value != null ? [String(s.value)] : [];
      return n[s.key] = { values: r, operator: s.operator || "exact" }, n;
    }, {}), e == null ? void 0 : e.properties);
  }
}, ay = class {
  constructor(e) {
    var t, n;
    this.zh = [], this._instance = e, this.Uh = /* @__PURE__ */ new Map(), this.Wh = /* @__PURE__ */ new Map(), this.Vh = /* @__PURE__ */ new Map(), this.Gh = (t = this._instance) === null || t === void 0 || (n = t.onSessionId) === null || n === void 0 ? void 0 : n.call(t, (s) => this.Zh(s));
  }
  Qh(e) {
    return !1;
  }
  Jh() {
    return null;
  }
  Kh(e) {
  }
  Yh() {
  }
  Xh(e, t) {
    return !!e && up(e.propertyFilters, t == null ? void 0 : t.properties);
  }
  tc(e, t) {
    const n = /* @__PURE__ */ new Map();
    return e.forEach((s) => {
      var r;
      (r = s.conditions) === null || r === void 0 || (r = r[t]) === null || r === void 0 || (r = r.values) === null || r === void 0 || r.forEach((o) => {
        if (o != null && o.name) {
          const a = n.get(o.name) || [];
          a.push(s.id), n.set(o.name, a);
        }
      });
    }), n;
  }
  ec(e, t, n) {
    const s = (n === hi.Activation ? this.Uh : this.Wh).get(e);
    let r = [];
    return this.nc((o) => {
      r = o.filter((a) => s == null ? void 0 : s.includes(a.id));
    }), r.filter((o) => {
      var a;
      const l = (a = o.conditions) === null || a === void 0 || (a = a[n]) === null || a === void 0 || (a = a.values) === null || a === void 0 ? void 0 : a.find((d) => d.name === e);
      return this.Xh(l, t);
    });
  }
  register(e) {
    this.sc(e, !1);
  }
  replace(e) {
    this.sc(e, !0);
  }
  sc(e, t) {
    var n;
    L((n = this._instance) === null || n === void 0 ? void 0 : n._addCaptureHook) || (this.rc(e, t), this.oc(e, t));
  }
  oc(e, t) {
    const n = e.filter((o) => {
      var a;
      return (a = o.conditions) === null || a === void 0 || (a = a.actions) === null || a === void 0 || (a = a.values) === null || a === void 0 ? void 0 : a.length;
    });
    var s;
    if (t && this.Vh.clear(), n.length === 0) return void (t && ((s = this.lc) === null || s === void 0 || s.replace([])));
    this.lc || (this.lc = new oy(this._instance), this.lc.init(), this.lc.Nh((o) => this.onAction(o)));
    const r = [];
    n.forEach((o) => {
      var a;
      (a = o.conditions) === null || a === void 0 || (a = a.actions) === null || a === void 0 || a.values.forEach((l) => {
        if (r.push(l), l.name) {
          var d;
          const c = (d = this.Vh.get(l.name)) !== null && d !== void 0 ? d : [];
          c.includes(o.id) || c.push(o.id), this.Vh.set(l.name, c);
        }
      });
    }), t ? this.lc.replace(r) : this.lc.register(r);
  }
  ac(e, t) {
    t.forEach((n, s) => {
      var r;
      const o = (r = e.get(s)) !== null && r !== void 0 ? r : [];
      n.forEach((a) => {
        o.includes(a) || o.push(a);
      }), e.set(s, o);
    });
  }
  rc(e, t) {
    var n, s;
    const r = e.filter((d) => {
      var c, u;
      return ((c = d.conditions) === null || c === void 0 ? void 0 : c.events) && ((u = d.conditions) === null || u === void 0 || (u = u.events) === null || u === void 0 || (u = u.values) === null || u === void 0 ? void 0 : u.length) > 0;
    }), o = e.filter((d) => {
      var c, u;
      return ((c = d.conditions) === null || c === void 0 ? void 0 : c.cancelEvents) && ((u = d.conditions) === null || u === void 0 || (u = u.cancelEvents) === null || u === void 0 || (u = u.values) === null || u === void 0 ? void 0 : u.length) > 0;
    }), a = this.tc(e, hi.Activation), l = this.tc(e, hi.Cancellation);
    t ? (this.Uh = a, this.Wh = l) : (this.ac(this.Uh, a), this.ac(this.Wh, l)), (r.length !== 0 || o.length !== 0) && ((n = this.Dh) !== null && n !== void 0 || (this.Dh = (s = this._instance) === null || s === void 0 ? void 0 : s._addCaptureHook((d, c) => {
      this.onEvent(d, c);
    })));
  }
  onEvent(e, t) {
    var n, s;
    const r = this.uc(), o = (t == null || (n = t.properties) === null || n === void 0 ? void 0 : n.$survey_id) || (t == null || (s = t.properties) === null || s === void 0 ? void 0 : s.$product_tour_id);
    if (o && this.getActivatedIds().includes(o)) {
      const l = this.hc(e, o);
      if (l === "consume") return r.info("event consumed activated item, removing it", { event: e, itemId: o }), void this.cc([o]);
      if (l === "persist") return r.info("shown item promoted to persisted activation", { event: e, itemId: o }), this.dc(o), void this.vc([o]);
    }
    if (this.Wh.has(e)) {
      const l = this.ec(e, t, hi.Cancellation);
      l.length > 0 && (r.info("cancel event matched, cancelling items", { event: e, itemsToCancel: l.map((d) => d.id) }), this.cc(l.map((d) => d.id)), l.forEach((d) => this.fc(d.id)));
    }
    if (!this.Uh.has(e)) return;
    r.info("event name matched", { event: e, eventPayload: t, items: this.Uh.get(e) });
    const a = this.ec(e, t, hi.Activation);
    this.gc(a.map((l) => l.id));
  }
  onAction(e) {
    this.Vh.has(e) && this.gc(this.Vh.get(e) || []);
  }
  gc(e) {
    var t, n;
    if (e.length === 0) return;
    const s = !!(!((t = this._instance) === null || t === void 0 || (n = t.get_session_id) === null || n === void 0) && n.call(t)), r = [];
    for (const o of e) s && this.Qh(o) ? this.dc(o) && this.mc(o) : r.push(o);
    r.length > 0 && (this.zh = [.../* @__PURE__ */ new Set([...this.zh, ...r])]), this.uc().info("updating activated items", { activatedItems: this.getActivatedIds() });
  }
  dc(e) {
    this.zh = this.zh.filter((n) => n !== e);
    const t = this.yc();
    return !t.includes(e) && (this.bc([...t, e]), this._c(), !0);
  }
  cc(e) {
    const t = new Set(e);
    this.zh = this.zh.filter((r) => !t.has(r));
    const n = this.wc(), s = n.filter((r) => !t.has(r));
    s.length !== n.length && (this.bc(s), s.length === 0 && this.kc()), this.vc(e);
  }
  Sc() {
    var e;
    const t = this.Jh();
    if (!t) return {};
    const n = (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.props[t];
    return n && typeof n == "object" ? n : {};
  }
  mc(e) {
    if (!this.Jh()) return;
    const t = this.Sc();
    this.Kh(x(x({}, t), {}, { [e]: Date.now() }));
  }
  vc(e) {
    if (!this.Jh()) return;
    const t = this.Sc(), n = {};
    let s = !1;
    for (const [r, o] of Object.entries(t)) e.includes(r) ? s = !0 : n[r] = o;
    s && (mn(n) ? this.Yh() : this.Kh(n));
  }
  xc() {
    this.Jh() && this.Yh();
  }
  getActivationTimestamp(e) {
    if (!this.yc().includes(e)) return;
    const t = this.Sc()[e];
    return bt(t) ? t : void 0;
  }
  wc() {
    var e;
    const t = this.Cc();
    return ((e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.props[t]) || [];
  }
  yc() {
    var e, t, n;
    const s = this.wc();
    if (s.length === 0) return [];
    const r = (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.props[this.$c()], o = (t = this._instance) === null || t === void 0 || (n = t.get_session_id) === null || n === void 0 ? void 0 : n.call(t);
    return o && r === o ? s : [];
  }
  _c() {
    var e, t;
    const n = (e = this._instance) === null || e === void 0 || (t = e.get_session_id) === null || t === void 0 ? void 0 : t.call(e);
    n && this.Tc(n);
  }
  kc() {
    this.Ic();
  }
  Zh(e) {
    var t;
    const n = (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.props[this.$c()];
    if (n && n !== e) {
      const s = this.wc(), r = this.Sc();
      s.length > 0 && (this.bc([]), s.filter((o) => bt(r[o])).forEach((o) => this.fc(o))), this.kc(), this.xc();
    }
  }
  getActivatedIds() {
    return [.../* @__PURE__ */ new Set([...this.yc(), ...this.zh])].filter((e) => !this.Mc(e));
  }
  dispose() {
    var e, t, n;
    (e = this.Gh) === null || e === void 0 || e.call(this), this.Gh = void 0, (t = this.Dh) === null || t === void 0 || t.call(this), this.Dh = void 0, (n = this.lc) === null || n === void 0 || n.dispose(), this.lc = void 0;
  }
  reset() {
    this.zh = [], this.wc().length > 0 && this.bc([]), this.kc(), this.xc();
  }
  getEventToItemsMap() {
    return this.Uh;
  }
  Ec() {
    return this.lc;
  }
}, ly = class extends ay {
  constructor(e) {
    super(e);
  }
  Cc() {
    return _f;
  }
  $c() {
    return mf;
  }
  Jh() {
    return gf;
  }
  Kh(e) {
    var t;
    (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || t.register({ $surveys_activated_timestamps: e });
  }
  Yh() {
    var e;
    (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || e.unregister("$surveys_activated_timestamps");
  }
  Qh(e) {
    var t;
    let n;
    this.nc((r) => {
      n = r.find((o) => o.id === e);
    });
    const s = n == null || (t = n.appearance) === null || t === void 0 ? void 0 : t.surveyPopupDelaySeconds;
    return bt(s) && s > 0;
  }
  Pc() {
    return bs.SHOWN;
  }
  nc(e) {
    var t;
    (t = this._instance) === null || t === void 0 || t.getSurveys(e);
  }
  fc(e) {
    var t;
    (t = this._instance) === null || t === void 0 || t.cancelPendingSurvey(e);
  }
  uc() {
    return De;
  }
  bc(e) {
    var t;
    (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || t.register({ $surveys_activated: e });
  }
  Tc(e) {
    var t;
    (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || t.register({ $surveys_activated_session: e });
  }
  Ic() {
    var e;
    (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || e.unregister("$surveys_activated_session");
  }
  Mc() {
    return !1;
  }
  hc(e, t) {
    let n;
    return this.nc((s) => {
      n = s.find((r) => r.id === t);
    }), !n || function(s) {
      var r;
      return dp(s) && !!(!((r = s.conditions) === null || r === void 0 || (r = r.events) === null || r === void 0) && r.repeatedActivation) || s.schedule === "always";
    }(n) ? e === bs.SHOWN ? "consume" : "ignore" : e === bs.SHOWN ? "persist" : e === bs.DISMISSED || e === bs.SENT ? "consume" : "ignore";
  }
  getSurveys() {
    return this.getActivatedIds();
  }
  getEventToSurveys() {
    return this.getEventToItemsMap();
  }
}, dy = class {
  constructor(e) {
    this._instance = e;
  }
  initialize() {
  }
  get(e) {
    if (typeof e == "string") return this._instance.get_property(e);
    const t = {};
    for (const n of e) {
      const s = this._instance.get_property(n);
      L(s) || (t[n] = s);
    }
    return t;
  }
  set(e, t) {
    this._instance.register(typeof e == "string" ? { [e]: t } : e);
  }
  remove(e) {
    typeof e != "string" ? e.forEach((t) => this._instance.unregister(t)) : this._instance.unregister(e);
  }
}, cy = class {
  constructor(e) {
    this._instance = e;
  }
  get() {
    const e = this._instance.config;
    return { disableSurveys: e.disable_surveys, cookielessMode: !!e.cookieless_mode, advancedEnableSurveys: e.advanced_enable_surveys, requestTimeoutMs: e.surveys_request_timeout_ms };
  }
  isOptedOut() {
    return this._instance.consent.isOptedOut();
  }
  isCapturing() {
    return this._instance.is_capturing();
  }
  getExtensions() {
    const e = se == null ? void 0 : se.__PosthogExtensions__;
    if (!e) return;
    const { generateSurveys: t, loadExternalDependency: n } = e;
    return { generateSurveys: t ? (s) => t(this._instance, s) : void 0, loadExternalDependency: n ? (s) => n(this._instance, "surveys", s) : void 0 };
  }
  createEventReceiver() {
    return new ly(this._instance);
  }
};
const uy = k != null && k.location ? zo(k.location.hash, "__posthog") || zo(location.hash, "state") : null, Su = "_postHogToolbarParams", ku = xt("[Toolbar]"), Eu = xt("[FeatureFlags]");
var hy = class {
  constructor(e, t = !1) {
    this.Rc = !1, this.update(e, t);
  }
  update(e, t) {
    this.Ac = ((n, s) => {
      var r, o, a, l, d;
      return { bootstrap: { featureFlags: (r = n.bootstrap) === null || r === void 0 ? void 0 : r.featureFlags, featureFlagPayloads: (o = n.bootstrap) === null || o === void 0 ? void 0 : o.featureFlagPayloads }, remoteRequestsDisabled: s, featureFlagsDisabled: !!n.advanced_disable_feature_flags, onlyEvaluateSurveyFeatureFlags: !!n.advanced_only_evaluate_survey_feature_flags, deduplicateCallsPerSession: !!n.advanced_feature_flags_dedup_per_session, cacheTtlMs: n.feature_flag_cache_ttl_ms, refreshIntervalMs: (a = n.remote_config_refresh_interval_ms) !== null && a !== void 0 ? a : 3e5, requestTimeoutMs: n.feature_flag_request_timeout_ms, compression: n.disable_compression ? void 0 : "best-available", evaluationContexts: (l = (d = n.evaluation_contexts) !== null && d !== void 0 ? d : n.evaluation_environments) !== null && l !== void 0 ? l : [], flagKeys: ae(n.flag_keys) ? n.flag_keys : void 0 };
    })(e, t), !e.evaluation_environments || e.evaluation_contexts || this.Rc || (Eu.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Rc = !0), L(e.flag_keys) || ae(e.flag_keys) || Eu.error("Invalid flag_keys found:", e.flag_keys, "Expected array of non-empty strings");
  }
  get() {
    return this.Ac;
  }
};
const Iu = xt("[FeatureFlags]"), Qs = xt("[FeatureFlags]", { debugEnabled: !0 }), Za = `" failed. Feature flags didn't load in time.`, Pu = "connection_error", Tu = (e) => {
  const t = {};
  for (let n = 0; e.length > n; n++) t[e[n]] = !0;
  return t;
}, Ru = (e) => {
  const t = {};
  for (const [n, s] of jo(e || {})) s && (t[n] = s);
  return t;
}, Lu = (e) => Ji(e) && (e.name === "RangeError" && e.message.indexOf("Maximum call stack size exceeded") === 0 || e.name === "InternalError" && e.message === "too much recursion"), An = xt("[Error tracking]"), Hl = "webkit-masked-url:", fy = [{ value: "isolatedAPI.contexts.topHostname", exact: !1 }, { value: "No response from target", exact: !0 }], py = ["chrome-extension://", "moz-extension://", "safari-extension:", "safari-web-extension:", Hl], _y = ["__firefox__", "__gCrWeb"], Ou = "Refusing to render web experiment since the viewer is a likely bot", my = { icontains: (e, t) => t.toLowerCase().indexOf(e.toLowerCase()) > -1, not_icontains: (e, t) => t.toLowerCase().indexOf(e.toLowerCase()) === -1, regex: (e, t) => Vo(t, e), not_regex: (e, t) => !Vo(t, e), exact: (e, t) => t === e, is_not: (e, t) => t !== e }, Pn = xt("[Conversations]"), er = "Conversations not available yet.";
function Fu(e, t) {
  var n, s, r, o, a, l, d;
  const c = (n = e == null ? void 0 : e.flushIntervalMs) !== null && n !== void 0 ? n : 3e3, u = (s = e == null ? void 0 : e.maxBufferSize) !== null && s !== void 0 ? s : 100, h = t != null && t.consoleCapture ? void 0 : (r = e == null ? void 0 : e.maxLogsPerInterval) !== null && r !== void 0 ? r : 1e3, p = L(h) ? Math.max(u, 2048) : Math.max(u, h), f = x(x({}, function() {
    let m = "", g = "";
    try {
      const v = At == null ? void 0 : At.userAgent;
      v && ([m, g] = Gh(v));
    } catch {
    }
    return function(v, _) {
      const $ = function(y) {
        if (y) return {}.hasOwnProperty.call(Oc, y) ? Oc[y] : y;
      }(v);
      return x(x({}, $ ? { "os.name": $ } : {}), _ ? { "os.version": _ } : {});
    }(m, g);
  }()), e == null ? void 0 : e.resourceAttributes);
  return { serviceName: (o = (a = f == null ? void 0 : f["service.name"]) !== null && a !== void 0 ? a : e == null ? void 0 : e.serviceName) !== null && o !== void 0 ? o : t == null ? void 0 : t.serviceNameDefault, serviceVersion: (l = f == null ? void 0 : f["service.version"]) !== null && l !== void 0 ? l : e == null ? void 0 : e.serviceVersion, environment: (d = f == null ? void 0 : f["deployment.environment"]) !== null && d !== void 0 ? d : e == null ? void 0 : e.environment, resourceAttributes: f, beforeSend: e == null ? void 0 : e.beforeSend, flushIntervalMs: c, maxBufferSize: u, maxQueueSize: p, maxBatchRecordsPerPost: 100, rateCapWindowMs: c, maxLogsPerInterval: h, backgroundFlushBudgetMs: 0, terminationFlushBudgetMs: 0 };
}
const gy = ["debug", "log", "warn", "error", "info"], vy = (e) => {
  for (; e != null && e.__rrweb_original__; ) e = e.__rrweb_original__;
  return e;
}, Au = "console", vp = "__posthogHandledLogsRequestError", Xa = (e, t) => {
  const n = e instanceof Error ? e : new Error(t);
  return n[vp] = !0, n;
}, Mu = (e) => !!e && typeof e == "object" && e[vp] === !0, ra = { featureFlags: class {
  constructor(e) {
    this.name = "featureFlags", this.Fc = !1, this.featureFlagEventHandlers = [], this.$ = Iu, this.Oc = {}, this.Dc = {}, this.Lc = [], this.Nc = !1, this.qc = !1, this.jc = 0, this.Bc = !1, this.Hc = !1, this.zc = !1, this.Uc = !1, this.Wc = 0, this.sn = () => {
      const t = this.Vc();
      this.Wc = 0, t && this.reloadFeatureFlags();
    }, this.Gc = () => {
      var t;
      const n = this.Zc;
      L(n) || this.Sr.remoteRequestsDisabled || !A || A.visibilityState === "hidden" || Date.now() - ((t = this.Qc) !== null && t !== void 0 ? t : 0) < n || (this.reloadFeatureFlags(), this.Jc());
    }, this.an = () => {
      (A == null ? void 0 : A.visibilityState) === "visible" && this.Gc();
    }, "get" in e ? this.uo = e : (this._instance = e, this.Kc = new hy(e.config, e.Ul()), this.uo = this.Kc);
  }
  updateConfig(e, t) {
    var n;
    (n = this.Kc) === null || n === void 0 || n.update(e, t), this.lo && this.Yc();
  }
  setup(e) {
    return this.gh = e, this.$ = e.logger.createLogger("[FeatureFlags]"), gp(e.kv.initialize(), () => {
      this.gh === e && (this.gh = void 0, this.lo = e, this.Xc(e));
    });
  }
  Xc(e) {
    var t;
    if (this.lo === e) return k && We(k, "online", this.sn), this.Yc(), this.td = e.registerDynamicEventProperties(() => this.ed() ? this.Oc : this.Dc), this.nd = (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.onCrossTabFeatureFlagChange(() => {
      this.sd(), this.rd(), this.od();
    }), this.rd(), this.initialize();
  }
  Yc() {
    const e = this.Sr.refreshIntervalMs, t = !this.Sr.remoteRequestsDisabled && A && !L(e) && e > 0 ? e : void 0;
    t !== this.Zc && (this.ld(), L(t) || (this.Zc = t, this.Jc(), A != null && A.addEventListener && We(A, zi, this.an)));
  }
  Jc() {
    L(this.Zc) || (L(this.ad) || clearInterval(this.ad), this.Qc = Date.now(), this.ad = setInterval(this.Gc, this.Zc));
  }
  ld() {
    var e;
    L(this.ad) || (clearInterval(this.ad), this.ad = void 0, A == null || (e = A.removeEventListener) === null || e === void 0 || e.call(A, "visibilitychange", this.an)), this.Zc = void 0, this.Qc = void 0;
  }
  destroy() {
    this.ud();
  }
  dispose() {
    this.ud();
  }
  ud() {
    var e, t;
    this.ld(), this.jc++, this.Hc = !1, this.gh = void 0, this.lo && (this.hd(), (e = this.td) === null || e === void 0 || e.dispose(), this.td = void 0, (t = this.nd) === null || t === void 0 || t.call(this), this.nd = void 0, this.Lc = [], k == null || k.removeEventListener("online", this.sn), this.lo = void 0);
  }
  get Sr() {
    return this.uo.get();
  }
  dd(e) {
    var t;
    return this.vd && e in this.vd ? this.vd[e] : (t = this.lo) === null || t === void 0 ? void 0 : t.kv.get(e);
  }
  sd() {
    return !!this.vd && (this.vd = void 0, !0);
  }
  fd() {
    var e;
    return !L((e = this.lo) === null || e === void 0 ? void 0 : e.kv.get("$enabled_feature_flags")) && this.sd();
  }
  At(e) {
    this.pd(() => {
      var t;
      return (t = this.lo) === null || t === void 0 ? void 0 : t.kv.set(e);
    });
  }
  gd(e, t, n) {
    var s;
    if (!(!((s = this._instance) === null || s === void 0) && s.persistence) || !e.$enabled_feature_flags) return;
    const r = this.dd("$enabled_feature_flags") || {}, o = e.$enabled_feature_flags || {}, a = t.flags || t.featureFlags, l = t.flags ? Object.entries(t.flags).filter(([, _]) => !(_ != null && _.failed)).map(([_]) => _) : [], d = !!t.errorsWhileComputingFlags && !!t.flags, c = d ? l : n && !ae(a) ? Object.keys(a || {}) : Array.from(/* @__PURE__ */ new Set([...Object.keys(r), ...Object.keys(o)])), u = this.dd("$feature_flag_payloads") || {}, h = e.$feature_flag_payloads || {}, p = d || n ? c : Array.from(/* @__PURE__ */ new Set([...Object.keys(u), ...Object.keys(h)])), f = !d && !n, m = !!f || c, g = !!f || p, v = { [vs]: m, [zn]: m, [Ms]: g };
    e.$feature_flag_details && (v[gr] = m);
    for (const _ of [vr, Us, Ei]) L(e[_]) || (v[_] = !0);
    this._instance.persistence.markCrossTabFeatureFlagChanges(v);
  }
  Lt(e) {
    this.pd(() => {
      var t;
      return (t = this.lo) === null || t === void 0 ? void 0 : t.kv.remove(e);
    });
  }
  pd(e) {
    try {
      e();
    } catch (t) {
      this.$.error("Failed to update feature flag persistence", t);
    }
  }
  rd() {
    const e = {};
    for (const s of [vs, Ms, vr, Xn]) {
      const r = this.dd(s);
      L(r) || (e[s] = r);
    }
    this.Oc = e;
    const t = x({}, e), n = this.dd(zn);
    if (n) for (const [s, r] of Object.entries(n)) t[`$feature/${s}`] = r;
    this.Dc = t;
  }
  ed() {
    const e = this.Sr.cacheTtlMs;
    if (!e || 0 >= e) return !1;
    const t = this.dd(Us);
    return typeof t != "number" || Date.now() - t > e;
  }
  md() {
    return !!this.ed() && (this.Uc || this.qc || (this.Uc = !0, this.$.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
  }
  yd() {
    const e = this.Sr.evaluationContexts;
    return e != null && e.length ? e.filter((t) => {
      const n = t && typeof t == "string" && t.trim().length > 0;
      return n || this.$.error("Invalid evaluation context found:", t, "Expected non-empty string"), n;
    }) : [];
  }
  bd() {
    const e = this.Sr.flagKeys;
    if (!L(e)) return e.filter((t) => {
      const n = t && typeof t == "string" && t.trim().length > 0;
      return n || this.$.error("Invalid flag key found:", t, "Expected non-empty string"), n;
    });
  }
  initialize() {
    var e, t;
    const n = this.Sr, s = (e = (t = n.bootstrap) === null || t === void 0 ? void 0 : t.featureFlags) !== null && e !== void 0 ? e : {};
    if (Object.keys(s).length) {
      var r, o;
      const a = (r = (o = n.bootstrap) === null || o === void 0 ? void 0 : o.featureFlagPayloads) !== null && r !== void 0 ? r : {}, l = Object.keys(s).filter((c) => !L(s[c])).reduce((c, u) => (c[u] = s[u], c), {}), d = Object.keys(a).filter((c) => l[c]).reduce((c, u) => (c[u] = a[u], c), {});
      return this._d({ featureFlags: l, featureFlagPayloads: d }, void 0, { persist: !1 });
    }
  }
  updateFlags(e, t, n) {
    var s, r;
    const o = n != null && n.merge && (s = this.dd("$enabled_feature_flags")) !== null && s !== void 0 ? s : {}, a = n != null && n.merge && (r = this.dd("$feature_flag_payloads")) !== null && r !== void 0 ? r : {}, l = x(x({}, o), e), d = x(x({}, a), t), c = {};
    for (const [u, h] of Object.entries(l)) c[u] = { key: u, enabled: Ic(h), variant: Pc(h), reason: void 0, metadata: L(d == null ? void 0 : d[u]) ? void 0 : { id: 0, version: void 0, description: void 0, payload: d[u] } };
    this._d({ flags: c });
  }
  get hasLoadedFlags() {
    return this.Nc;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagsWithDetails() {
    const e = this.dd(gr), t = this.dd(Xn), n = this.dd(ur);
    if (!n && !t) return e || {};
    const s = Xe({}, e || {}), r = [.../* @__PURE__ */ new Set([...Object.keys(n || {}), ...Object.keys(t || {})])];
    for (const l of r) {
      var o;
      const d = s[l], c = t == null ? void 0 : t[l], u = L(c) ? (o = d == null ? void 0 : d.enabled) !== null && o !== void 0 && o : !!c, h = L(c) ? d == null ? void 0 : d.variant : typeof c == "string" ? c : void 0, p = n == null ? void 0 : n[l], f = x(x({}, d), {}, { enabled: u, variant: u ? h ?? (d == null ? void 0 : d.variant) : void 0 });
      var a;
      u !== (d == null ? void 0 : d.enabled) && (f.original_enabled = d == null ? void 0 : d.enabled), h !== (d == null ? void 0 : d.variant) && (f.original_variant = d == null ? void 0 : d.variant), p && (f.metadata = x(x({}, d == null ? void 0 : d.metadata), {}, { payload: p, original_payload: d == null || (a = d.metadata) === null || a === void 0 ? void 0 : a.payload })), s[l] = f;
    }
    return this.Fc || (this.$.warn(" Overriding feature flag details!", { flagDetails: e, overriddenPayloads: n, finalDetails: s }), this.Fc = !0), s;
  }
  getAllFeatureFlags() {
    const e = this.getFlagVariants(), t = this.getFlagPayloads();
    return Object.keys(e).map((n) => {
      const s = e[n];
      return { key: n, enabled: Ic(s), variant: Pc(s), payload: Ec(t[n]) };
    });
  }
  getFlagVariants() {
    const e = this.dd(zn), t = this.dd(Xn);
    if (!t) return e || {};
    const n = Xe({}, e || {}), s = Object.keys(t);
    for (let r = 0; s.length > r; r++) n[s[r]] = t[s[r]];
    return this.Fc || (this.$.warn(" Overriding feature flags!", { enabledFlags: e, overriddenFlags: t, finalFlags: n }), this.Fc = !0), n;
  }
  getFlagPayloads() {
    const e = this.dd(Ms), t = this.dd(ur);
    if (!t) return e || {};
    const n = Xe({}, e || {}), s = Object.keys(t);
    for (let r = 0; s.length > r; r++) n[s[r]] = t[s[r]];
    return this.Fc || (this.$.warn(" Overriding feature flag payloads!", { flagPayloads: e, overriddenPayloads: t, finalPayloads: n }), this.Fc = !0), n;
  }
  reloadFeatureFlags() {
    this.Bc || this.Sr.featureFlagsDisabled || this.Vc() || (this.qc && (this.Hc = !0), this.wd || (this.Lc.slice().forEach((e) => {
      try {
        e();
      } catch (t) {
        this.$.error("Error while running feature flags reloading callback", t);
      }
    }), this.wd = setTimeout(() => {
      this.kd();
    }, 5)));
  }
  hd() {
    clearTimeout(this.wd), this.wd = void 0;
  }
  onReloading(e) {
    return this.Lc.push(e), () => {
      this.Lc = this.Lc.filter((t) => t !== e);
    };
  }
  ensureFlagsLoaded() {
    this.Nc || this.qc || this.wd || this.reloadFeatureFlags();
  }
  setAnonymousDistinctId(e) {
    this.$anon_distinct_id = e;
  }
  setReloadingPaused(e) {
    this.Bc = e;
  }
  resetFlagCallReported() {
    this.Lt(Ws);
  }
  kd(e) {
    this.hd();
    const t = this.lo;
    if (!t || this.Sr.remoteRequestsDisabled || this.Vc()) return;
    if (this.qc) return void (this.Hc = !0);
    const n = { token: t.projectToken, distinct_id: t.distinctId, groups: t.groups, $anon_distinct_id: this.$anon_distinct_id, person_properties: x(x(x({}, t.initialPersonProperties), this.dd("$stored_person_properties") || {}), {}, { $lib: t.library.name, $lib_version: t.library.version }), group_properties: this.dd(Bs), timezone: Vf() };
    L(t.deviceId) || (n.$device_id = t.deviceId), (e != null && e.disableFlags || this.Sr.featureFlagsDisabled) && (n.disable_flags = !0);
    const s = this.yd();
    s.length && (n.evaluation_contexts = s);
    const r = this.bd();
    L(r) || (n.flag_keys = r);
    const o = this.Sr.onlyEvaluateSurveyFeatureFlags, a = "/flags/?v=2" + (o ? "&only_evaluate_survey_feature_flags=true" : ""), l = this.jc;
    this.qc = !0;
    const d = () => {
      this.Hc && (this.Hc = !1, this.kd());
    }, c = (h) => {
      var p, f;
      const m = (p = h.json) !== null && p !== void 0 ? p : {}, g = h.statusCode !== 200;
      if (this.qc = !1, l !== this.jc) return void d();
      if (this.Sd(h.statusCode), g || this.Hc || (this.$anon_distinct_id = void 0), n.disable_flags && !this.Hc) return;
      this.zc = !g;
      const v = [];
      h.error ? v.push(h.error instanceof Error && h.error.name === "AbortError" ? "timeout" : h.error instanceof Error ? Pu : "unknown_error") : h.statusCode !== 200 && v.push(`api_error_${h.statusCode}`), m.errorsWhileComputingFlags && v.push("errors_while_computing_flags");
      const _ = !!(!((f = m.quotaLimited) === null || f === void 0) && f.includes("feature_flags"));
      _ && v.push("quota_limited"), this.At({ [Ui]: v }), _ ? this.$.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : n.disable_flags || this._d(m, g, { partialResponse: o }), d();
    }, u = (h) => {
      this.qc = !1, l === this.jc && (this.At({ [Ui]: [Pu] }), this.$.error("Feature flag request failed", h), this.fd() && this.od(!0)), d();
    };
    try {
      t.sendRequest(a, { target: "flags", method: "POST", body: n, compression: this.Sr.compression, sentAt: "body", timeoutMs: this.Sr.requestTimeoutMs }).then(c).catch(u);
    } catch (h) {
      u(h);
    }
  }
  Vc() {
    return Mf(this.Wc, 3);
  }
  Sd(e) {
    this.Wc = Df(e, this.Wc, 3, () => this.$.warn("Feature flag requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped refreshing feature flags; will try again when connectivity changes."));
  }
  getFeatureFlag(e, t = {}) {
    var n;
    if (t.fresh && !this.zc) return;
    if (!(this.Nc || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlag for key "' + e + Za);
    if (this.md()) return;
    const s = this.getFeatureFlagResult(e, t);
    return (n = s == null ? void 0 : s.variant) !== null && n !== void 0 ? n : s == null ? void 0 : s.enabled;
  }
  getFeatureFlagDetails(e) {
    return this.getFlagsWithDetails()[e];
  }
  getFeatureFlagPayload(e) {
    const t = this.getFeatureFlagResult(e, { send_event: !1 });
    return t == null ? void 0 : t.payload;
  }
  getFeatureFlagResult(e, t = {}) {
    if (t.fresh && !this.zc) return;
    if (!(this.Nc || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlagResult for key "' + e + Za);
    if (this.md()) return;
    const n = this.getFlagVariants(), s = e in n, r = n[e], o = this.getFlagPayloads()[e], a = String(r), l = this.dd("$feature_flag_request_id") || void 0, d = this.dd("$feature_flag_evaluated_at") || void 0;
    let c, u = this.dd("$flag_call_reported") || {};
    if (this.Sr.deduplicateCallsPerSession) {
      var h;
      const S = (h = this.lo) === null || h === void 0 ? void 0 : h.session.sessionId, F = this.dd(wi);
      S && S !== F && (u = {}, c = S);
    }
    if (t.send_event || !("send_event" in t)) if (e in u && u[e].includes(a)) c && this.At({ [Ws]: u, [wi]: c });
    else {
      var p, f, m, g, v, _, $, y, P, j, b, N;
      ae(u[e]) ? u[e].push(a) : u[e] = [a], this.At(x({ [Ws]: u }, c ? { [wi]: c } : {}));
      const S = this.getFeatureFlagDetails(e), F = [...(p = this.dd("$feature_flag_errors")) !== null && p !== void 0 ? p : []];
      L(r) && F.push("flag_missing");
      const W = { $feature_flag: e, $feature_flag_response: r, $feature_flag_payload: o ?? null, $feature_flag_request_id: l, $feature_flag_evaluated_at: d, $feature_flag_bootstrapped_response: (f = (m = this.Sr.bootstrap) === null || m === void 0 || (m = m.featureFlags) === null || m === void 0 ? void 0 : m[e]) !== null && f !== void 0 ? f : null, $feature_flag_bootstrapped_payload: (g = (v = this.Sr.bootstrap) === null || v === void 0 || (v = v.featureFlagPayloads) === null || v === void 0 ? void 0 : v[e]) !== null && g !== void 0 ? g : null, $used_bootstrap_value: !this.zc };
      L(S == null || (_ = S.metadata) === null || _ === void 0 ? void 0 : _.has_experiment) || (W.$feature_flag_has_experiment = S.metadata.has_experiment), L(S == null || ($ = S.metadata) === null || $ === void 0 ? void 0 : $.version) || (W.$feature_flag_version = S.metadata.version);
      const D = (y = S == null || (P = S.reason) === null || P === void 0 ? void 0 : P.description) !== null && y !== void 0 ? y : S == null || (j = S.reason) === null || j === void 0 ? void 0 : j.code;
      var C;
      D && (W.$feature_flag_reason = D), !(S == null || (b = S.metadata) === null || b === void 0) && b.id && (W.$feature_flag_id = S.metadata.id), L(S == null ? void 0 : S.original_variant) && L(S == null ? void 0 : S.original_enabled) || (W.$feature_flag_original_response = L(S.original_variant) ? S.original_enabled : S.original_variant), !(S == null || (N = S.metadata) === null || N === void 0) && N.original_payload && (W.$feature_flag_original_payload = S == null || (C = S.metadata) === null || C === void 0 ? void 0 : C.original_payload), F.length && (W.$feature_flag_error = F.join(",")), this.xd(W);
    }
    else c && this.At({ [Ws]: u, [wi]: c });
    return s ? { key: e, enabled: !!r, variant: typeof r == "string" ? r : void 0, payload: Ec(o) } : void 0;
  }
  xd(e) {
    try {
      var t;
      (t = this.lo) === null || t === void 0 || t.capture("$feature_flag_called", e).catch((n) => {
        this.$.error("Failed to capture feature flag call", n);
      });
    } catch (n) {
      this.$.error("Failed to capture feature flag call", n);
    }
  }
  getRemoteConfigPayload(e, t) {
    this.Cd(e, t);
  }
  Cd(e, t) {
    var n = this;
    return Qe(function* () {
      const s = n.lo;
      if (!s) return;
      const r = { distinct_id: s.distinctId, token: s.projectToken, person_properties: { $lib: s.library.name, $lib_version: s.library.version } }, o = n.yd();
      o.length && (r.evaluation_contexts = o);
      const a = n.bd();
      let l;
      L(a) || (r.flag_keys = a);
      try {
        var d;
        const c = (d = (yield s.sendRequest("/flags/?v=2", { target: "flags", method: "POST", body: r, compression: n.Sr.compression, sentAt: "body", timeoutMs: n.Sr.requestTimeoutMs })).json) === null || d === void 0 ? void 0 : d.featureFlagPayloads;
        l = (c == null ? void 0 : c[e]) || void 0;
      } catch (c) {
        return void n.$.error("Remote config feature flag request failed", c);
      }
      try {
        t(l);
      } catch (c) {
        n.$.error("Remote config feature flag callback failed", c);
      }
    })();
  }
  isFeatureEnabled(e, t = {}) {
    if (t.fresh && !this.zc) return t.defaultValue;
    if (!(this.Nc || this.getFlags() && this.getFlags().length > 0)) return this.$.warn('isFeatureEnabled for key "' + e + Za), t.defaultValue;
    const n = this.getFeatureFlag(e, t);
    return L(n) ? t.defaultValue : !!n;
  }
  addFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers.push(e);
  }
  removeFeatureFlagsHandler(e) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((t) => t !== e);
  }
  receivedFeatureFlags(e, t, n) {
    this._d(e, t, n);
  }
  _d(e, t, n) {
    if (!this.lo) return;
    this.Nc = !0;
    const s = ((r, o = {}, a = {}, l = {}, d, c = Iu) => {
      const u = ((y, P) => {
        const j = y.flags;
        if (j) {
          const b = Object.fromEntries(Object.keys(j).map((C) => {
            var S;
            return [C, (S = j[C].variant) !== null && S !== void 0 ? S : j[C].enabled];
          })), N = Object.fromEntries(Object.keys(j).filter((C) => j[C].enabled).filter((C) => {
            var S;
            return !L((S = j[C].metadata) === null || S === void 0 ? void 0 : S.payload);
          }).map((C) => {
            var S;
            return [C, (S = j[C].metadata) === null || S === void 0 ? void 0 : S.payload];
          }));
          return x(x({}, y), {}, { featureFlags: b, featureFlagPayloads: N });
        }
        return y.featureFlags && P.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), y;
      })(r, c), h = u.flags, p = u.featureFlags, f = u.featureFlagPayloads;
      if (!p) return;
      const m = r.requestId, g = r.evaluatedAt;
      if (ae(p)) {
        c.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
        const y = {};
        if (p) for (let P = 0; p.length > P; P++) y[p[P]] = !0;
        return { [vs]: p, [zn]: y, [Ei]: !1 };
      }
      let v = p, _ = f, $ = h;
      if (d != null && d.partialResponse) {
        const y = Object.keys(v), P = _ || {};
        v = x(x({}, o), v), _ = x(x({}, a), P), y.forEach((j) => {
          j in P || _ == null || delete _[j];
        }), $ = x(x({}, l), $);
      } else if (r.errorsWhileComputingFlags) if (h) {
        const y = new Set(Object.keys(h).filter((j) => {
          var b;
          return !(!((b = h[j]) === null || b === void 0) && b.failed);
        }));
        v = x(x({}, o), Object.fromEntries(Object.entries(v).filter(([j]) => y.has(j))));
        const P = Object.fromEntries(Object.entries(_ || {}).filter(([j]) => y.has(j)));
        _ = x(x({}, a), P), y.forEach((j) => {
          j in P || _ == null || delete _[j];
        }), $ = x(x({}, l), Object.fromEntries(Object.entries($ || {}).filter(([j]) => y.has(j))));
      } else v = x(x({}, o), v), _ = x(x({}, a), _), $ = x(x({}, l), $);
      return x(x({ [vs]: Object.keys(Ru(v)), [zn]: v || {}, [Ms]: _ || {}, [gr]: $ || {}, [Ei]: r.minimalFlagCalledEvents === !0 }, m ? { [vr]: m } : {}), g ? { [Us]: g } : {});
    })(e, this.getFlagVariants(), this.getFlagPayloads(), this.getFlagsWithDetails(), n, this.$);
    if (s) if ((n == null ? void 0 : n.persist) === !1) {
      const r = !L(this.lo.kv.get(zn));
      this.vd = s, r || this.At(s);
    } else this.sd(), this.gd(s, e, !!(n != null && n.partialResponse)), this.At(s);
    else t && this.fd();
    t || (this.Uc = !1), this.od(t);
  }
  override(e, t = !1) {
    this.$.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({ flags: e, suppressWarning: t });
  }
  overrideFeatureFlags(e) {
    this.$d(e);
  }
  $d(e) {
    if (this.lo) {
      if (e === !1) return this.Lt([Xn, ur]), this.od(), void Qs.info("All overrides cleared");
      if (ae(e)) return this.At({ [Xn]: Tu(e) }), this.od(), void Qs.info("Flag overrides set", { flags: e });
      if (e && typeof e == "object" && ("flags" in e || "payloads" in e)) {
        var t;
        const n = e;
        this.Fc = !!((t = n.suppressWarning) !== null && t !== void 0 && t);
        const s = {}, r = n.flags, o = n.payloads;
        return r && (s[Xn] = ae(r) ? Tu(r) : r), o && (s[ur] = o), Object.keys(s).length && this.At(s), r === !1 && o === !1 ? this.Lt([Xn, ur]) : r === !1 ? this.Lt(Xn) : o === !1 && this.Lt(ur), this.od(), r === !1 ? Qs.info("Flag overrides cleared") : r && Qs.info("Flag overrides set", { flags: r }), void (o === !1 ? Qs.info("Payload overrides cleared") : o && Qs.info("Payload overrides set", { payloads: o }));
      }
      if (e && typeof e == "object") return this.At({ [Xn]: e }), this.od(), void Qs.info("Flag overrides set", { flags: e });
      this.$.warn("Invalid overrideOptions provided to overrideFeatureFlags", { overrideOptions: e });
    } else this.$.warn("posthog.featureFlags.overrideFeatureFlags called before feature flags were ready");
  }
  onFeatureFlags(e) {
    if (this.addFeatureFlagsHandler(e), this.Nc) {
      const { flags: t, flagVariants: n } = this.Td();
      try {
        e(t, n);
      } catch (s) {
        this.$.error("Error while running feature flags callback", s);
      }
    }
    return () => this.removeFeatureFlagsHandler(e);
  }
  updateEarlyAccessFeatureEnrollment(e, t, n) {
    var s;
    const r = (this.dd("$early_access_features") || []).find((c) => c.flagKey === e), o = { [`$feature_enrollment/${e}`]: t }, a = { $feature_flag: e, $feature_enrollment: t, $set: o };
    r && (a.$early_access_feature_name = r.name), n && (a.$feature_enrollment_stage = n);
    const l = x(x({}, this.getFlagVariants()), {}, { [e]: t });
    (s = this._instance) === null || s === void 0 || (s = s.persistence) === null || s === void 0 || s.markCrossTabFeatureFlagChanges({ $active_feature_flags: [e], $enabled_feature_flags: [e], $stored_person_properties: Object.keys(o) }), this.At({ [vs]: Object.keys(Ru(l)), [zn]: l, [Ds]: x(x({}, this.dd("$stored_person_properties") || {}), o) }), this.od();
    try {
      var d;
      (d = this.lo) === null || d === void 0 || d.capture("$feature_enrollment_update", a).catch((c) => {
        this.$.error("Failed to capture early access feature enrollment", c);
      });
    } catch (c) {
      this.$.error("Failed to capture early access feature enrollment", c);
    }
  }
  getEarlyAccessFeatures(e, t = !1, n) {
    const s = this.dd(Sl);
    !s || t ? this.Id(e, n) : e(s);
  }
  Id(e, t) {
    var n = this;
    return Qe(function* () {
      const s = n.lo;
      if (!s) return;
      const r = t ? `&${t.map((a) => `stage=${a}`).join("&")}` : "";
      let o;
      try {
        const a = yield s.sendRequest(`/api/early_access_features/?token=${s.projectToken}${r}`, { target: "api", method: "GET", sentAt: "query" });
        if (!a.json) return;
        o = a.json.earlyAccessFeatures, n.At({ [Sl]: o });
      } catch (a) {
        return void n.$.error("Early access feature request failed", a);
      }
      try {
        e(o);
      } catch (a) {
        n.$.error("Early access feature callback failed", a);
      }
    })();
  }
  Td() {
    const e = this.getFlags(), t = this.getFlagVariants();
    return { flags: e.filter((n) => t[n]), flagVariants: Object.keys(t).filter((n) => t[n]).reduce((n, s) => (n[s] = t[s], n), {}) };
  }
  od(e) {
    this.rd();
    const { flags: t, flagVariants: n } = this.Td();
    this.featureFlagEventHandlers.forEach((s) => {
      try {
        s(t, n, { errorsLoading: e });
      } catch (r) {
        this.$.error("Error while running feature flags callback", r);
      }
    });
  }
  setPersonPropertiesForFlags(e, t = !0) {
    this.Md(e, t);
  }
  Md(e, t = !0) {
    const n = this.dd("$stored_person_properties") || {}, s = (e == null ? void 0 : e.$set) || (e != null && e.$set_once ? {} : e), r = e == null ? void 0 : e.$set_once, o = {};
    if (r) for (const a in r) ({}).hasOwnProperty.call(r, a) && (a in n || (o[a] = r[a]));
    this.At({ [Ds]: x(x(x({}, n), o), s) }), t && this.reloadFeatureFlags();
  }
  unsetPersonPropertiesForFlags(e, t = !0) {
    const n = x({}, this.dd("$stored_person_properties") || {});
    e.forEach((s) => {
      delete n[s];
    }), this.At({ [Ds]: n }), t && this.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags(e = !0) {
    this.Lt(Ds), e && this.reloadFeatureFlags();
  }
  setGroupPropertiesForFlags(e, t = !0) {
    const n = this.dd("$stored_group_properties") || {}, s = x({}, n);
    for (const r of Object.keys(e)) s[r] = x(x({}, n[r]), e[r]);
    this.At({ [Bs]: s }), t && this.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(e) {
    if (e) {
      const t = this.dd("$stored_group_properties") || {};
      this.At({ [Bs]: x(x({}, t), {}, { [e]: {} }) });
    } else this.Lt(Bs);
  }
  reset() {
    this.jc++, this.Hc = !1, this.Oc = {}, this.Dc = {}, this.vd = void 0, this.Nc = !1, this.Bc = !1, this.zc = !1, this.$anon_distinct_id = void 0, this.hd(), this.Fc = !1, this.Wc = 0;
  }
} }, $y = { sessionRecording: class {
  get Sr() {
    return this._instance.config;
  }
  get ga() {
    return this._instance.persistence;
  }
  get started() {
    var e;
    return !!(!((e = this.Ed) === null || e === void 0) && e.isStarted);
  }
  get status() {
    var e, t;
    return this.Pd === "awaiting_config" || this.Pd === "missing_config" ? this.Pd : (e = (t = this.Ed) === null || t === void 0 ? void 0 : t.status) !== null && e !== void 0 ? e : this.Pd;
  }
  constructor(e) {
    if (this._instance = e, this._forceAllowLocalhostNetworkCapture = !1, this.Pd = Ya, this.Rd = void 0, this.Ad = !1, this.Ke = (() => {
      var t, n;
      if (!(A != null && A.visibilityState) || A.visibilityState === "visible") return !0;
      const s = k == null || (t = k.performance) === null || t === void 0 || (n = t.getEntriesByType) === null || n === void 0 ? void 0 : n.call(t, "visibility-state");
      return !(s != null && s.length) || s.some((r) => r.name === "visible");
    })(), this.an = () => {
      var t, n;
      (A == null ? void 0 : A.visibilityState) === "visible" && (this.Ke = !0, (t = this.Ed) === null || t === void 0 || (n = t.setDocumentWasEverVisible) === null || n === void 0 || n.call(t, !0));
    }, !this._instance.sessionManager) throw os.error("started without valid sessionManager"), new Error("[SessionRecording] started without valid sessionManager. This is a bug.");
    if (this.Sr.cookieless_mode === "always") throw new Error('[SessionRecording] cannot be used with cookieless_mode="always"');
    A != null && A.addEventListener && We(A, "visibilitychange", this.an);
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  dispose({ discardBufferedEvents: e = !1 } = {}) {
    var t;
    this.Ad = !0, A == null || (t = A.removeEventListener) === null || t === void 0 || t.call(A, "visibilitychange", this.an), e ? this.Fd(!0) : this.stopRecording();
  }
  get Od() {
    var e;
    const t = !!(!((e = this._instance.get_property("$session_recording_remote_config")) === null || e === void 0) && e.enabled), n = !this.Sr.disable_session_recording, s = this.Sr.disable_session_recording || this._instance.consent.isOptedOut();
    return k && t && n && !s;
  }
  startIfEnabledOrStop(e) {
    var t;
    if (this.Ad || this.Od && (!((t = this.Ed) === null || t === void 0) && t.isStarted)) return;
    const n = !L(Object.assign) && !L(Array.from);
    this.Od && n ? (this.Dd(e), os.info("starting")) : (this.Pd = Ya, this.stopRecording());
  }
  Dd(e) {
    var t, n;
    if (this.Od) if (this.Pd !== "awaiting_config" && this.Pd !== "missing_config" && (this.Pd = Cu), (se == null || (t = se.__PosthogExtensions__) === null || t === void 0 || (t = t.rrweb) === null || t === void 0 ? void 0 : t.record) && ((n = se.__PosthogExtensions__) === null || n === void 0 ? void 0 : n.initSessionRecording)) this.Ld(e);
    else {
      var s, r;
      const o = this._instance.sessionManager;
      (s = se.__PosthogExtensions__) === null || s === void 0 || (r = s.loadExternalDependency) === null || r === void 0 || r.call(s, this._instance, this.Nd, (a) => {
        if (!this.Ad && this.Od && this._instance.sessionManager === o) return a ? (this._instance.register_for_session({ $sdk_debug_recording_script_not_loaded: !0 }), os.error("could not load recorder", a)) : void this.Ld(e);
        this.Pd = "disabled";
      });
    }
  }
  stopRecording() {
    var e, t;
    (e = this.Rd) === null || e === void 0 || e.call(this), this.Rd = void 0, (t = this.Ed) === null || t === void 0 || t.stop();
  }
  Fd(e = !1) {
    var t, n;
    (t = this.Rd) === null || t === void 0 || t.call(this), this.Rd = void 0, (n = this.Ed) === null || n === void 0 || n.discard({ discardProducerEvents: e });
  }
  qd() {
    var e, t;
    (e = this.ga) === null || e === void 0 || e.unregister("$session_is_sampled"), (t = this.ga) === null || t === void 0 || t.unregister("$replay_sample_rate");
  }
  jd(e, t) {
    if (_e(e)) return null;
    const n = bt(e) ? e : parseFloat(e);
    return typeof (s = n) != "number" || !Number.isFinite(s) || 0 > s || s > 1 ? (os.warn(`${t} must be between 0 and 1. Ignoring invalid value:`, e), null) : n;
    var s;
  }
  Bd(e) {
    if (this.ga) {
      var t, n;
      const s = this.ga, r = () => {
        var o;
        const a = e.sessionRecording === !1 ? void 0 : e.sessionRecording, l = this.jd((o = this.Sr.session_recording) === null || o === void 0 ? void 0 : o.sampleRate, "session_recording.sampleRate"), d = this.jd(a == null ? void 0 : a.sampleRate, "remote config sampleRate"), c = l ?? d;
        _e(c) && this.qd();
        const u = a == null ? void 0 : a.minimumDurationMilliseconds;
        s.register({ [ki]: x(x({ cache_timestamp: Date.now(), enabled: !!a }, a), {}, { networkPayloadCapture: x({ capturePerformance: e.capturePerformance }, a == null ? void 0 : a.networkPayloadCapture), canvasRecording: { enabled: a == null ? void 0 : a.recordCanvas, fps: a == null ? void 0 : a.canvasFps, quality: a == null ? void 0 : a.canvasQuality }, sampleRate: c, minimumDurationMilliseconds: L(u) ? null : u, endpoint: a == null ? void 0 : a.endpoint, triggerMatchType: a == null ? void 0 : a.triggerMatchType, masking: a == null ? void 0 : a.masking, urlTriggers: a == null ? void 0 : a.urlTriggers, version: a == null ? void 0 : a.version, triggerGroups: a == null ? void 0 : a.triggerGroups }) });
      };
      r(), (t = this.Rd) === null || t === void 0 || t.call(this), this.Rd = (n = this._instance.sessionManager) === null || n === void 0 ? void 0 : n.onSessionId(r);
    }
  }
  onRemoteConfig(e) {
    const t = e.ok ? e.config : void 0;
    return t && "sessionRecording" in t ? t.sessionRecording === !1 ? (this.Bd(t), void this.Fd()) : (this.Bd(t), void this.startIfEnabledOrStop()) : (this.Pd === "awaiting_config" && (this.Pd = "missing_config", os.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
  }
  log(e, t = "log") {
    var n;
    !((n = this.Ed) === null || n === void 0) && n.log ? this.Ed.log(e, t) : os.warn("log called before recorder was ready");
  }
  get Nd() {
    var e, t;
    const n = (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.get_property(ki);
    return (n == null || (t = n.scriptConfig) === null || t === void 0 ? void 0 : t.script) || "lazy-recorder";
  }
  Hd() {
    const e = this._instance.get_property(ki);
    if (!e) return !1;
    let t;
    try {
      t = typeof e == "object" ? e : JSON.parse(e);
    } catch (n) {
      return os.warn("persisted remote config for session recording is invalid and will be ignored", n), !1;
    }
    return !_e(t.cache_timestamp) && 36e5 >= Date.now() - t.cache_timestamp;
  }
  Ld(e) {
    var t, n, s;
    if (!this.Ad && this.Od && this._instance.sessionManager) {
      if (!(!((t = se.__PosthogExtensions__) === null || t === void 0) && t.initSessionRecording)) return os.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({ [wf]: !0 });
      var r;
      if (this.Ed || (this.Ed = (r = se.__PosthogExtensions__) === null || r === void 0 ? void 0 : r.initSessionRecording(this._instance, this.Ke), this.Ed._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.Hd())
        return this.Pd === "missing_config" || this.Pd === "awaiting_config" ? void 0 : (this.Pd = "awaiting_config", os.info("persisted remote config is stale, requesting fresh config before starting"), void new Yf(this._instance).load());
      this.Pd = Cu, (n = (s = this.Ed).setDocumentWasEverVisible) === null || n === void 0 || n.call(s, this.Ke), this.Ed.start(e);
    } else this.Pd = Ya;
  }
  onRRwebEmit(e) {
    var t, n;
    (t = this.Ed) === null || t === void 0 || (n = t.onRRwebEmit) === null || n === void 0 || n.call(t, e);
  }
  overrideLinkedFlag() {
    var e, t;
    this.Ed || (t = this.ga) === null || t === void 0 || t.register({ $replay_override_linked_flag: !0 }), (e = this.Ed) === null || e === void 0 || e.overrideLinkedFlag();
  }
  overrideSampling() {
    var e, t;
    this.Ed || (t = this.ga) === null || t === void 0 || t.register({ $replay_override_sampling: !0 }), (e = this.Ed) === null || e === void 0 || e.overrideSampling();
  }
  overrideTrigger(e) {
    var t, n;
    this.Ed || (n = this.ga) === null || n === void 0 || n.register({ [e === "url" ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0 }), (t = this.Ed) === null || t === void 0 || t.overrideTrigger(e);
  }
  get sdkDebugProperties() {
    var e;
    return ((e = this.Ed) === null || e === void 0 ? void 0 : e.sdkDebugProperties) || { $recording_status: this.status };
  }
  tryAddCustomEvent(e, t) {
    var n;
    return !!(!((n = this.Ed) === null || n === void 0) && n.tryAddCustomEvent(e, t));
  }
  flushBeforeIdentityReset() {
    var e, t;
    (e = this.Ed) === null || e === void 0 || (t = e.flushBeforeIdentityReset) === null || t === void 0 || t.call(e);
  }
} }, by = { autocapture: class extends Xx {
  constructor(e) {
    super(new Qx(e)), this.instance = e;
  }
}, historyAutocapture: class {
  constructor(e) {
    this._instance = e, this.zd = this.Ud();
  }
  initialize() {
    this.startIfEnabled();
  }
  get isEnabled() {
    const e = this.Wd();
    return !!(e.path || e.search || this.Vd(e));
  }
  startIfEnabled() {
    this.isEnabled && (H.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
  }
  startIfEnabledOrStop() {
    this.stop(), this.zd = this.Ud(), this.startIfEnabled();
  }
  stop() {
    this.Gd && this.Gd(), this.Gd = void 0, this.Zd && this.Zd(), this.Zd = void 0, H.info("History API monitoring stopped");
  }
  monitorHistoryChanges() {
    k && k.history && (this.Qd("pushState"), this.Qd("replaceState"), this.Jd(), this.Vd() && this.Kd());
  }
  Qd(e) {
    var t;
    if (!k || !((t = k.history[e]) === null || t === void 0) && t.__posthog_wrapped__) return;
    const n = this;
    mp(k.history, e, (s) => function(r, o, a) {
      s.call(this, r, o, a), n.Yd(e);
    });
  }
  Ud() {
    const e = k == null ? void 0 : k.location;
    if (e != null && e.pathname) return { pathname: e.pathname, search: e.search, hash: e.hash };
  }
  Wd() {
    const e = this._instance.config.capture_pageview;
    return e === "history_change" ? { path: !0 } : xe(e) ? e : {};
  }
  Vd(e = this.Wd()) {
    return !!e.hash && !this._instance.config.disable_capture_url_hashes;
  }
  Xd(e) {
    const t = this.Wd(), n = this.zd;
    return !(!n || !(t.path && e.pathname !== n.pathname || t.search && e.search !== n.search || this.Vd(t) && e.hash !== n.hash));
  }
  Yd(e) {
    try {
      const t = this.Ud();
      if (!t) return;
      this.Xd(t) && this._instance.capture($d, { navigation_type: e }), this.zd = t;
    } catch (t) {
      H.error(`Error capturing ${e} pageview`, t);
    }
  }
  Jd() {
    if (this.Gd) return;
    const e = () => {
      this.Yd("popstate");
    };
    We(k, "popstate", e), this.Gd = () => {
      k && k.removeEventListener("popstate", e);
    };
  }
  Kd() {
    if (this.Zd) return;
    const e = () => {
      this.Yd("hashchange");
    };
    We(k, "hashchange", e), this.Zd = () => {
      k && k.removeEventListener("hashchange", e);
    };
  }
}, heatmaps: class {
  get Sr() {
    return this.instance.config;
  }
  constructor(e) {
    var t;
    this.tv = !1, this.ho = !1, this.ev = null, this.instance = e, this.tv = !!(!((t = this.instance.persistence) === null || t === void 0) && t.props[wl]), this.rageclicks = new _p(e.config.rageclick);
  }
  initialize() {
    this.startIfEnabled();
  }
  get flushIntervalMilliseconds() {
    let e = 5e3;
    return xe(this.Sr.capture_heatmaps) && this.Sr.capture_heatmaps.flush_interval_milliseconds && (e = this.Sr.capture_heatmaps.flush_interval_milliseconds), e;
  }
  get isEnabled() {
    return _e(this.Sr.capture_heatmaps) ? _e(this.Sr.enable_heatmaps) ? this.tv : this.Sr.enable_heatmaps : this.Sr.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this.ho) return;
      sy.info("starting..."), this.iv(), this.an();
    } else {
      var e;
      clearInterval((e = this.ev) !== null && e !== void 0 ? e : void 0), this.nv(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(e) {
    if (!e.ok) return;
    const t = e.config;
    if (!("heatmaps" in t)) return;
    const n = !!t.heatmaps;
    this.instance.persistence && this.instance.persistence.register({ [wl]: n }), this.tv = n, this.startIfEnabled();
  }
  getAndClearBuffer() {
    const e = this.Rt;
    return this.Rt = void 0, e;
  }
  sv(e) {
    Ka(e.originalEvent) && this._r(e.originalEvent, "deadclick");
  }
  an() {
    this.ev && clearInterval(this.ev), this.ev = (A == null ? void 0 : A.visibilityState) === "visible" ? setInterval(this.oa.bind(this), this.flushIntervalMilliseconds) : null;
  }
  iv() {
    k && A && (this.rv = this.oa.bind(this), We(k, Wo, this.rv), this.ov = (e) => this._r(e || (k == null ? void 0 : k.event)), We(A, "click", this.ov, { capture: !0 }), this.lv = (e) => this.av(e || (k == null ? void 0 : k.event)), We(A, "mousemove", this.lv, { capture: !0 }), this.uv = new tu(this.instance, ox, this.sv.bind(this)), this.uv.startIfEnabledOrStop(), this.hv = this.an.bind(this), We(A, zi, this.hv), this.ho = !0);
  }
  nv() {
    var e;
    k && A && (this.rv && k.removeEventListener(Wo, this.rv), this.ov && A.removeEventListener("click", this.ov, { capture: !0 }), this.lv && A.removeEventListener("mousemove", this.lv, { capture: !0 }), this.hv && A.removeEventListener(zi, this.hv), clearTimeout(this.dv), (e = this.uv) === null || e === void 0 || e.stop(), this.ho = !1);
  }
  vv(e, t) {
    const n = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), o = function(a, l, d) {
      let c = a;
      for (; c && ns(c) && !Kt(c, "body"); ) {
        if (c === d) return !1;
        let f;
        try {
          var u, h, p;
          f = (u = (h = (p = c.ownerDocument) === null || p === void 0 ? void 0 : p.defaultView) !== null && h !== void 0 ? h : k) === null || u === void 0 ? void 0 : u.getComputedStyle(c).position;
        } catch {
          return !1;
        }
        if (de(l, f)) return !0;
        c = Pf(c);
      }
      return !1;
    }(Ii(e), ["fixed", "sticky"], r);
    return { x: e.clientX + (o ? 0 : s), y: e.clientY + (o ? 0 : n), target_fixed: o, type: t };
  }
  _r(e, t = "click") {
    var n;
    if (qc(e.target) || !Ka(e)) return;
    const s = this.vv(e, t);
    !((n = this.rageclicks) === null || n === void 0) && n.isRageClick(e.clientX, e.clientY, (/* @__PURE__ */ new Date()).getTime()) && Rf(Ii(e), this.instance.config.rageclick) && this.Hs(x(x({}, s), {}, { type: "rageclick" })), this.Hs(s);
  }
  av(e) {
    !qc(e.target) && Ka(e) && (clearTimeout(this.dv), this.dv = setTimeout(() => {
      this.Hs(this.vv(e, "mousemove"));
    }, 500));
  }
  Hs(e) {
    if (!k) return;
    const t = this.Sr.disable_capture_url_hashes ? zs(k.location.href) : k.location.href, n = this.Sr.custom_personal_data_properties, s = this.Sr.mask_personal_data_properties ? [...Jr, ...n || []] : [], r = Gi(t, s, Vi);
    this.Rt = this.Rt || {}, this.Rt[r] || (this.Rt[r] = []), this.Rt[r].push(e);
  }
  oa() {
    this.Rt && !mn(this.Rt) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}, deadClicksAutocapture: tu, webVitalsAutocapture: class {
  constructor(e) {
    var t;
    this._instance = e, this.tv = !1, this.ho = !1, this.Rt = { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 }, this.fv = () => {
      clearTimeout(this.pv), this.pv = void 0, this.Rt.metrics.length !== 0 && (this._instance.capture("$web_vitals", x({ $current_url: this.Rt.url }, this.Rt.metrics.reduce((n, s) => x(x({}, n), {}, { [`$web_vitals_${s.name}_event`]: x({}, s), [`$web_vitals_${s.name}_value`]: s.value }), {}))), this.Rt = { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }, this.gv = (n) => {
      var s;
      if (this.Rt = this.Rt || { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 }, _e(n == null ? void 0 : n.name) || _e(n == null ? void 0 : n.value)) return void Xs.error("Invalid metric received", n);
      const r = typeof n.navigationURL == "string" ? n.navigationURL : void 0, o = this.mv(r);
      if (L(o)) return;
      const a = bt(n.navigationId) || typeof n.navigationId == "string" ? `navigation:${n.navigationId}` : `url:${o}`;
      if (this.yv && n.value >= this.yv) return void Xs.error("Ignoring metric with value >= " + this.yv, n);
      this.Rt.navigationKey !== a && (this.fv(), this.pv = setTimeout(this.fv, this.flushToCaptureTimeoutMs)), L(this.Rt.navigationKey) && (this.Rt.navigationKey = a, this.Rt.url = o), this.Rt.firstMetricTimestamp = L(this.Rt.firstMetricTimestamp) ? Date.now() : this.Rt.firstMetricTimestamp;
      const l = (s = this._instance.sessionManager) === null || s === void 0 ? void 0 : s.checkAndGetSessionAndWindowId(!0), d = x(x(x({}, n), r ? { navigationURL: o } : {}), {}, { $current_url: o, timestamp: Date.now() });
      if (delete d.entries, xe(n.attribution) && this.attributionMetrics.indexOf(n.name) > -1) {
        const c = {};
        for (const u of ny) {
          const h = u === "url" && typeof n.attribution[u] == "string" ? this.mv(n.attribution[u]) : n.attribution[u];
          L(h) || (c[u] = h);
        }
        d.attribution = c;
      } else delete d.attribution;
      L(l) || (d.$session_id = l.sessionId, d.$window_id = l.windowId), this.Rt.metrics.push(d), this.Rt.metrics.length === this.allowedMetrics.length && this.fv();
    }, this.bv = () => {
      if (this.ho) return;
      let n, s, r, o, a = !1;
      const l = se.__PosthogExtensions__, d = l == null ? void 0 : l.postHogWebVitalsCallbacksByFlavor, c = (d == null ? void 0 : d[this._v]) || (this._v === "web-vitals" && L(d) ? l == null ? void 0 : l.postHogWebVitalsCallbacks : void 0);
      if (!L(c)) {
        const p = c.withoutAttribution, f = this.attributionMetrics;
        a = !L(p), n = f.indexOf("LCP") > -1 ? c.onLCP : (p == null ? void 0 : p.onLCP) || c.onLCP, s = f.indexOf("CLS") > -1 ? c.onCLS : (p == null ? void 0 : p.onCLS) || c.onCLS, r = f.indexOf("FCP") > -1 ? c.onFCP : (p == null ? void 0 : p.onFCP) || c.onFCP, o = f.indexOf("INP") > -1 ? c.onINP : (p == null ? void 0 : p.onINP) || c.onINP;
      }
      if (!(n && s && r && o)) return void Xs.error("web vitals callbacks not loaded - not starting");
      const u = { reportSoftNavs: this.useSoftNavs }, h = a && this.attributionMetrics.indexOf("INP") > -1 ? x(x({}, u), {}, { includeProcessedEventEntries: !1 }) : u;
      this.allowedMetrics.indexOf("LCP") > -1 && n(this.gv.bind(this), u), this.allowedMetrics.indexOf("CLS") > -1 && s(this.gv.bind(this), u), this.allowedMetrics.indexOf("FCP") > -1 && r(this.gv.bind(this), u), this.allowedMetrics.indexOf("INP") > -1 && o(this.gv.bind(this), h), this.ho = !0;
    }, this.tv = !!(!((t = this._instance.persistence) === null || t === void 0) && t.props[Nl]), this.startIfEnabled();
  }
  get wv() {
    return this._instance.config.capture_performance;
  }
  get allowedMetrics() {
    var e, t;
    const n = xe(this.wv) ? (e = this.wv) === null || e === void 0 ? void 0 : e.web_vitals_allowed_metrics : void 0;
    return _e(n) ? ((t = this._instance.persistence) === null || t === void 0 ? void 0 : t.props.$web_vitals_allowed_metrics) || wu : n;
  }
  get flushToCaptureTimeoutMs() {
    return (xe(this.wv) ? this.wv.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get attributionMetrics() {
    const e = xe(this.wv) ? this.wv.web_vitals_attribution : void 0;
    return ln(e) ? e ? wu : [] : ae(e) ? e : ty;
  }
  get useAttribution() {
    return this.attributionMetrics.length > 0;
  }
  get useSoftNavs() {
    const e = xe(this.wv) ? this.wv.__preview_web_vitals_soft_navs : void 0;
    return e != null && e;
  }
  get yv() {
    const e = xe(this.wv) && bt(this.wv.__web_vitals_max_value) ? this.wv.__web_vitals_max_value : yu;
    return e > 0 && 6e4 >= e ? yu : e;
  }
  get isEnabled() {
    const e = ut == null ? void 0 : ut.protocol;
    if (e !== "http:" && e !== "https:") return Xs.info("Web Vitals are disabled on non-http/https protocols"), !1;
    const t = xe(this.wv) ? this.wv.web_vitals : ln(this.wv) ? this.wv : void 0;
    return ln(t) ? t : this.tv;
  }
  startIfEnabled() {
    this.isEnabled && !this.ho && (Xs.info("enabled, starting..."), this.Eo(this.bv));
  }
  onRemoteConfig(e) {
    if (!e.ok) return;
    const t = e.config;
    if (!("capturePerformance" in t)) return;
    const n = xe(t.capturePerformance) && !!t.capturePerformance.web_vitals, s = xe(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
    this._instance.persistence && (this._instance.persistence.register({ [Nl]: n }), this._instance.persistence.register({ [hf]: s })), this.tv = n, this.startIfEnabled();
  }
  get _v() {
    return this.useSoftNavs ? this.useAttribution ? "web-vitals-with-attribution-soft-navs" : "web-vitals-soft-navs" : this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
  }
  Eo(e) {
    var t;
    const n = se.__PosthogExtensions__, s = this._v, r = n == null ? void 0 : n.postHogWebVitalsCallbacksByFlavor;
    r != null && r[s] || s === "web-vitals" && L(r) && (n != null && n.postHogWebVitalsCallbacks) ? e() : n == null || (t = n.loadExternalDependency) === null || t === void 0 || t.call(n, this._instance, s, (o) => {
      o ? Xs.error("failed to load script", o) : e();
    });
  }
  mv(e) {
    const t = e || (k == null ? void 0 : k.location.href);
    if (!t) return void Xs.error("Could not determine current URL");
    const n = this._instance.config.disable_capture_url_hashes ? zs(t) : t, s = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [...Jr, ...s || []] : [];
    return Gi(n, r, Vi);
  }
} }, xy = { exceptionObserver: class {
  constructor(e) {
    var t;
    this.bv = () => {
      var n;
      if (!k || !this.isEnabled || !(!((n = se.__PosthogExtensions__) === null || n === void 0) && n.errorWrappingFunctions)) return;
      const s = se.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = se.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, o = se.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
      try {
        !this.Sv && this.Sr.capture_unhandled_errors && (this.Sv = s(this.captureException.bind(this))), !this.xv && this.Sr.capture_unhandled_rejections && (this.xv = r(this.captureException.bind(this))), !this.Cv && this.Sr.capture_console_errors && (this.Cv = o(this.captureException.bind(this)));
      } catch (a) {
        mi.error("failed to start", a), this.$v();
      }
    }, this._instance = e, this.Tv = !!(!((t = this._instance.persistence) === null || t === void 0) && t.props[Cl]), this.wt = new w$(x(x({}, function(n = {}) {
      var s, r, o, a;
      return { refillRate: (s = (r = n.exceptionRateLimiterRefillRate) !== null && r !== void 0 ? r : n.__exceptionRateLimiterRefillRate) !== null && s !== void 0 ? s : 1, bucketSize: (o = (a = n.exceptionRateLimiterBucketSize) !== null && a !== void 0 ? a : n.__exceptionRateLimiterBucketSize) !== null && o !== void 0 ? o : 10 };
    }(this._instance.config.error_tracking)), {}, { refillInterval: 1e4, $: mi })), this.Sr = this.Iv(), this.startIfEnabledOrStop();
  }
  Iv() {
    const e = this._instance.config.capture_exceptions;
    let t = { capture_unhandled_errors: !1, capture_unhandled_rejections: !1, capture_console_errors: !1 };
    return xe(e) ? t = x(x({}, t), e) : (L(e) ? this.Tv : e) && (t = x(x({}, t), {}, { capture_unhandled_errors: !0, capture_unhandled_rejections: !0 })), t;
  }
  get isEnabled() {
    return this.Sr.capture_console_errors || this.Sr.capture_unhandled_errors || this.Sr.capture_unhandled_rejections;
  }
  startIfEnabledOrStop() {
    this.isEnabled ? (mi.info("enabled"), this.$v(), this.Eo(this.bv)) : this.$v();
  }
  Eo(e) {
    var t, n, s;
    !((t = se.__PosthogExtensions__) === null || t === void 0) && t.errorWrappingFunctions ? e() : (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this._instance, "exception-autocapture", (r) => {
      if (r) return mi.error("failed to load script", r);
      e();
    });
  }
  $v() {
    var e, t, n;
    (e = this.Sv) === null || e === void 0 || e.call(this), this.Sv = void 0, (t = this.xv) === null || t === void 0 || t.call(this), this.xv = void 0, (n = this.Cv) === null || n === void 0 || n.call(this), this.Cv = void 0;
  }
  onRemoteConfig(e) {
    if (!e.ok) return;
    const t = e.config;
    "autocaptureExceptions" in t && (this.Tv = !!t.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({ [Cl]: this.Tv }), this.Sr = this.Iv(), this.startIfEnabledOrStop());
  }
  onConfigChange() {
    this.Sr = this.Iv();
  }
  captureException(e) {
    try {
      var t, n, s;
      const r = (t = e == null || (n = e.$exception_list) === null || n === void 0 || (n = n[0]) === null || n === void 0 ? void 0 : n.type) !== null && t !== void 0 ? t : "Exception";
      if (this.wt.consumeRateLimit(r)) return void mi.info("Skipping exception capture because of client rate limiting.", { exception: r });
      (s = this._instance.exceptions) === null || s === void 0 || s.sendExceptionEvent(e);
    } catch {
    }
  }
}, exceptions: class {
  constructor(e) {
    var t, n;
    this.Mv = [], this.Ev = new O$([new V$(), new nb(), new K$(), new Y$(), new eb(), new Q$(), new Z$(), new tb()], /* @__PURE__ */ function(s, ...r) {
      return (o, a = 0) => {
        const l = [], d = o.split(`
`), c = Math.min(d.length, a + 1e3), u = [];
        for (let f = a; c > f; f++) {
          const m = d[f];
          if (m.length > 1024) continue;
          const g = kc.test(m) ? m.replace(kc, "$1") : m;
          if (!g.match(/\S*Error: /)) {
            for (const v of r) {
              const _ = v(g, s);
              if (_) {
                l.push(_);
                const $ = z$(l);
                if ($) {
                  for (let y = u.length - 1; y >= 0; y--) {
                    const P = u[y];
                    if ($.start >= P.start + P.length) break;
                    u.pop();
                  }
                  u.push($);
                }
                break;
              }
            }
            if (q$(l, u) >= 50) break;
          }
        }
        const h = [...u].sort((f, m) => m.start - f.start), p = h[h.length - 1];
        if (p) {
          const f = Zh(l, p);
          l.splice(p.start - f, f);
          for (const m of h) m.start -= f;
        }
        for (const f of h) H$(l, f);
        return u.some((f) => f.start === 0 && l.length === f.length) && function(f) {
          const m = f.map((v) => `${v.function}|${v.filename}|${v.lineno}|${v.colno}|${v.module}`);
          let g = 0;
          for (let v = 1; m.length > v; v++) G$(m, v, g) && (g = v);
          f.push(...f.splice(0, g));
        }(l), function(f) {
          if (!f.length) return [];
          const m = Array.from(f);
          return m.reverse(), m.slice(0, 50).map((g) => {
            return x(x({}, g), {}, { filename: g.filename || (v = m, v[v.length - 1] || {}).filename, function: g.function || "?" });
            var v;
          });
        }(l);
      };
    }("web:javascript", D$, U$)), this._instance = e, this.Mv = (t = (n = this._instance.persistence) === null || n === void 0 ? void 0 : n.get_property("$error_tracking_suppression_rules")) !== null && t !== void 0 ? t : [], this.Pv = Fo(this.Rv()), this.Av = new rb(this.Pv);
  }
  onConfigChange() {
    this.Pv = Fo(this.Rv()), this.Av.setConfig(this.Pv);
  }
  onRemoteConfig(e) {
    var t, n, s;
    if (!e.ok) return;
    const r = e.config;
    if (!("errorTracking" in r)) return;
    const o = (t = (n = r.errorTracking) === null || n === void 0 ? void 0 : n.suppressionRules) !== null && t !== void 0 ? t : [], a = (s = r.errorTracking) === null || s === void 0 ? void 0 : s.captureExtensionExceptions;
    this.Mv = o, this._instance.persistence && this._instance.persistence.register({ [cf]: this.Mv, [jl]: a });
  }
  get Fv() {
    var e;
    const t = !!this._instance.get_property(jl), n = this._instance.config.error_tracking.captureExtensionExceptions;
    return (e = n ?? t) !== null && e !== void 0 && e;
  }
  buildProperties(e, t) {
    return this.Ev.buildFromUnknown(e, { syntheticException: t == null ? void 0 : t.syntheticException, mechanism: { handled: t == null ? void 0 : t.handled } });
  }
  addExceptionStep(e, t) {
    if (this.Pv.enabled) try {
      if (!ye(e) || e.trim().length === 0) return void An.warn("Ignoring exception step because message must be a non-empty string");
      const { sanitizedProperties: n, droppedKeys: s } = function(r) {
        if (!r) return { sanitizedProperties: {}, droppedKeys: [] };
        const o = [];
        return { sanitizedProperties: Object.keys(r).reduce((a, l) => sb.has(l) ? (o.push(l), a) : (a[l] = r[l], a), {}), droppedKeys: o };
      }(this.Ov(t));
      s.length > 0 && An.warn("Ignoring reserved exception step fields", { droppedKeys: s }), this.Av.add(x({ [Lo]: e, [Oo]: (/* @__PURE__ */ new Date()).toISOString() }, n));
    } catch (n) {
      An.error("Failed to add exception step. Ignoring breadcrumb.", n);
    }
  }
  sendExceptionEvent(e) {
    try {
      const t = e.$exception_list;
      if (this.Dv(t)) {
        if (this.Lv(t)) return this.Nv("Exception dropped: matched a suppression rule"), void An.info("Skipping exception capture because a suppression rule matched");
        if (!this.Fv && this.qv(t)) return this.Nv("Exception dropped: thrown by a browser extension"), void An.info("Skipping exception capture because it was thrown by an extension");
        if (!this.Fv && this.jv(t)) return this.Nv("Exception dropped: thrown by an injected browser script"), void An.info("Skipping exception capture because it was thrown by an injected browser script");
        if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.Bv(t)) return this.Nv("Exception dropped: thrown by the PostHog SDK"), void An.info("Skipping exception capture because it was thrown by the PostHog SDK");
      }
      const n = this.Pv.enabled && _e(e.$exception_steps) ? this.Hv(e) : e, s = function() {
        const r = globalThis._posthogReleaseId;
        return typeof r == "string" && r.length > 0 ? r : void 0;
      }();
      s && (n.$release_id = s);
      try {
        const r = this._instance.capture("$exception", n, { _noTruncate: !0, _batchKey: "exceptionEvent", Gu: !0 });
        return r && this.Av.clear(), r;
      } catch (r) {
        return Lu(r) || An.error("Failed to capture exception event. Dropping this exception.", r), void this.Av.clear();
      }
    } catch (t) {
      return void (Lu(t) || An.error("Failed to process exception event. Ignoring this exception.", t));
    }
  }
  Hv(e) {
    try {
      const t = this.Av.getAttachable();
      return t.length === 0 ? e : x(x({}, e), {}, { $exception_steps: t });
    } catch (t) {
      return An.error("Failed to read buffered exception steps. Capturing exception without steps.", t), e;
    }
  }
  Nv(e) {
    this.Pv.enabled && this.Av.add({ [Lo]: e, [Oo]: (/* @__PURE__ */ new Date()).toISOString() });
  }
  Ov(e) {
    return xe(e) ? x({}, e) : {};
  }
  Rv() {
    var e, t;
    return (e = (t = this._instance.config.error_tracking) === null || t === void 0 ? void 0 : t.exception_steps) !== null && e !== void 0 ? e : {};
  }
  Lv(e) {
    if (e.length === 0) return !1;
    try {
      const t = e.reduce((n, { type: s, value: r }) => (ye(s) && s.length > 0 && n.$exception_types.push(s), ye(r) && r.length > 0 && n.$exception_values.push(r), n), { $exception_types: [], $exception_values: [] });
      return this.Mv.some((n) => {
        const s = n.values.map((r) => {
          const o = cp[r.operator], a = t[r.key];
          if (!o || !a) return !1;
          const l = ae(r.value) ? r.value : [r.value];
          return l.length > 0 && o(l, a);
        });
        return n.type === "OR" ? s.some(Boolean) : s.every(Boolean);
      });
    } catch (t) {
      return An.warn("Failed to evaluate suppression rules. Capturing the exception.", t), !1;
    }
  }
  qv(e) {
    const t = e.flatMap((s) => {
      var r, o;
      return (r = (o = s.stacktrace) === null || o === void 0 ? void 0 : o.frames) !== null && r !== void 0 ? r : [];
    }), n = t.filter(({ filename: s }) => !!s && py.some((r) => s.startsWith(r)));
    return n.length !== 0 && (!n.every(({ filename: s }) => !!s && s.startsWith(Hl)) || e.some(({ type: s, value: r }) => s === "NoResponse" || ye(r) && fy.some(({ value: o, exact: a }) => a ? r === o : r.includes(o))) && !t.some(({ in_app: s, filename: r }) => s && !(r != null && r.startsWith(Hl))));
  }
  jv(e) {
    return e.some(({ value: t }) => ye(t) && _y.some((n) => t.includes(n)));
  }
  Bv(e) {
    if (e.length > 0) {
      var t, n, s, r;
      const o = (t = (n = e[0].stacktrace) === null || n === void 0 ? void 0 : n.frames) !== null && t !== void 0 ? t : [], a = o[o.length - 1];
      return (s = a == null || (r = a.filename) === null || r === void 0 ? void 0 : r.includes("posthog.com/static")) !== null && s !== void 0 && s;
    }
    return !1;
  }
  Dv(e) {
    return !_e(e) && ae(e);
  }
} }, yy = x({ productTours: class {
  get ga() {
    return this._instance.persistence;
  }
  constructor(e) {
    this.zv = null, this.Uv = null, this._instance = e;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    if (!e.ok) return;
    const t = e.config;
    if ("productTours" in t) {
      var n, s;
      if (this.ga && this.ga.register({ [md]: !!t.productTours }), !Ja(this._instance)) return !this.zv && _e((n = this.ga) === null || n === void 0 ? void 0 : n.props.ph_product_tours) || fo.info("product tours disabled; stopping and clearing cached tours"), (s = this.zv) === null || s === void 0 || s.stop(), this.zv = null, void this.clearCache();
      this.loadIfEnabled();
    }
  }
  loadIfEnabled() {
    !this.zv && Ja(this._instance) && this.Eo(() => this.Wv());
  }
  Eo(e) {
    var t, n, s;
    !((t = se.__PosthogExtensions__) === null || t === void 0) && t.generateProductTours ? e() : (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this._instance, "product-tours", (r) => {
      r ? fo.error("Could not load product tours script", r) : e();
    });
  }
  Wv() {
    var e;
    !this.zv && (!((e = se.__PosthogExtensions__) === null || e === void 0) && e.generateProductTours) && (this.zv = se.__PosthogExtensions__.generateProductTours(this._instance, !0));
  }
  getProductTours(e, t = !1) {
    if (ae(this.Uv) && !t) return void e(this.Uv, { isLoaded: !0 });
    const n = this.ga;
    if (n) {
      const s = n.props[El];
      if (ae(s) && !t) return this.Uv = s, void e(s, { isLoaded: !0 });
    }
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", `/api/product_tours/?token=${this._instance.config.token}`), method: "GET", timestampMode: "query", callback: (s) => {
      if (!Ja(this._instance)) return void e([], { isLoaded: !0 });
      const r = s.statusCode;
      if (r !== 200 || !s.json) {
        const a = `Product Tours API could not be loaded, status: ${r}`;
        return r === 0 ? s.error || fo.warn(a) : fo.error(a), void e([], { isLoaded: !1, error: a });
      }
      const o = ae(s.json.product_tours) ? s.json.product_tours : [];
      this.Uv = o, n && n.register({ [El]: o }), e(o, { isLoaded: !0 });
    } });
  }
  getActiveProductTours(e) {
    _e(this.zv) ? e([], { isLoaded: !1, error: "Product tours not loaded" }) : this.zv.getActiveProductTours(e);
  }
  showProductTour(e) {
    var t;
    (t = this.zv) === null || t === void 0 || t.showTourById(e);
  }
  previewTour(e) {
    this.zv ? this.zv.previewTour(e) : this.Eo(() => {
      var t;
      this.Wv(), (t = this.zv) === null || t === void 0 || t.previewTour(e);
    });
  }
  dismissProductTour() {
    var e;
    (e = this.zv) === null || e === void 0 || e.dismissTour("user_clicked_skip");
  }
  nextStep() {
    var e;
    (e = this.zv) === null || e === void 0 || e.nextStep();
  }
  previousStep() {
    var e;
    (e = this.zv) === null || e === void 0 || e.previousStep();
  }
  clearCache() {
    var e;
    this.Uv = null, (e = this.ga) === null || e === void 0 || e.unregister("ph_product_tours");
  }
  resetTour(e) {
    var t;
    (t = this.zv) === null || t === void 0 || t.resetTour(e);
  }
  resetAllTours() {
    var e;
    (e = this.zv) === null || e === void 0 || e.resetAllTours();
  }
  cancelPendingTour(e) {
    var t;
    (t = this.zv) === null || t === void 0 || t.cancelPendingTour(e);
  }
} }, ra), wy = { siteApps: class {
  constructor(e) {
    this._instance = e, this.Vv = 0, this.Gv = [], this.apps = {};
  }
  get isEnabled() {
    return !!this._instance.config.opt_in_site_apps;
  }
  Zv(e, t) {
    if (!t) return;
    const n = this.globalsForEvent(t);
    this.Gv.push(n), this.Gv.length > 1e3 && (this.Gv = this.Gv.slice(10));
  }
  get siteAppLoaders() {
    var e;
    return (e = se._POSTHOG_REMOTE_CONFIG) === null || e === void 0 || (e = e[this._instance.config.token]) === null || e === void 0 ? void 0 : e.siteApps;
  }
  initialize() {
    if (this.isEnabled) {
      const e = this._instance._addCaptureHook(this.Zv.bind(this));
      this.Qv = () => {
        e(), this.Gv = [], this.Qv = void 0;
      };
    }
  }
  globalsForEvent(e) {
    var t, n, s, r, o, a, l;
    if (!e) throw new Error("Event payload is required");
    const d = {}, c = this._instance.get_property("$groups") || [], u = this._instance.get_property("$stored_group_properties") || {};
    for (const [f, m] of Object.entries(u)) d[f] = { id: c[f], type: f, properties: m };
    const { $set_once: h, $set: p } = e;
    return { event: x(x({}, tf(e, ry)), {}, { properties: x(x(x({}, e.properties), p ? { $set: x(x({}, (t = (n = e.properties) === null || n === void 0 ? void 0 : n.$set) !== null && t !== void 0 ? t : {}), p) } : {}), h ? { $set_once: x(x({}, (s = (r = e.properties) === null || r === void 0 ? void 0 : r.$set_once) !== null && s !== void 0 ? s : {}), h) } : {}), elements_chain: (o = (a = e.properties) === null || a === void 0 ? void 0 : a.$elements_chain) !== null && o !== void 0 ? o : "", distinct_id: (l = e.properties) === null || l === void 0 ? void 0 : l.distinct_id }), person: { properties: this._instance.get_property("$stored_person_properties") }, groups: d };
  }
  Jv(e) {
    var t;
    const n = (t = e.tagName) === null || t === void 0 ? void 0 : t.toLowerCase();
    return n === "style" && this._instance.config.prepare_external_dependency_stylesheet ? this._instance.config.prepare_external_dependency_stylesheet(e) || (Jn.error("prepare_external_dependency_stylesheet returned null"), null) : n === "script" && this._instance.config.prepare_external_dependency_script ? this._instance.config.prepare_external_dependency_script(e) || (Jn.error("prepare_external_dependency_script returned null"), null) : e;
  }
  Kv() {
    var e, t, n, s, r, o, a, l;
    if (!this._instance.config.prepare_external_dependency_stylesheet && !this._instance.config.prepare_external_dependency_script) return () => {
    };
    const d = A == null ? void 0 : A.defaultView, c = d == null || (e = d.Node) === null || e === void 0 ? void 0 : e.prototype;
    if (!d || !c) return () => {
    };
    if (this.Vv++, this.Yv) return this.Xv();
    const u = [], h = this, p = /* @__PURE__ */ new WeakSet(), f = (v, _, $) => {
      if (!(v != null && v[_])) return;
      const y = v[_];
      v[_] = $(y), u.push(() => {
        v[_] = y;
      });
    }, m = (v) => {
      if (p.has(v)) return v;
      const _ = h.Jv(v);
      return _ && p.add(_), _;
    }, g = (v) => v.map((_) => typeof _ == "string" ? _ : m(_)).filter((_) => !gt(_));
    return f(c, "appendChild", (v) => function(_) {
      const $ = m(_);
      return $ ? v.call(this, $) : _;
    }), f(c, "insertBefore", (v) => function(_, $) {
      const y = m(_);
      return y ? v.call(this, y, $) : _;
    }), f(c, "replaceChild", (v) => function(_, $) {
      const y = m(_);
      return y ? v.call(this, y, $) : $;
    }), [(t = d.Element) === null || t === void 0 ? void 0 : t.prototype, (n = d.Document) === null || n === void 0 ? void 0 : n.prototype, (s = d.DocumentFragment) === null || s === void 0 ? void 0 : s.prototype].forEach((v) => {
      f(v, "append", (_) => function(...$) {
        return _.apply(this, g($));
      }), f(v, "prepend", (_) => function(...$) {
        return _.apply(this, g($));
      });
    }), [(r = d.Element) === null || r === void 0 ? void 0 : r.prototype, (o = d.CharacterData) === null || o === void 0 ? void 0 : o.prototype, (a = d.DocumentType) === null || a === void 0 ? void 0 : a.prototype].forEach((v) => {
      f(v, "before", (_) => function(...$) {
        return _.apply(this, g($));
      }), f(v, "after", (_) => function(...$) {
        return _.apply(this, g($));
      }), f(v, "replaceWith", (_) => function(...$) {
        const y = g($);
        return $.length && !y.length ? void 0 : _.apply(this, y);
      });
    }), f((l = d.Element) === null || l === void 0 ? void 0 : l.prototype, "insertAdjacentElement", (v) => function(_, $) {
      const y = m($);
      return y ? v.call(this, _, y) : null;
    }), this.Yv = () => {
      u.forEach((v) => v()), this.Yv = void 0;
    }, this.Xv();
  }
  Xv() {
    let e = !1;
    return () => {
      var t;
      e || (e = !0, this.Vv--, this.Vv === 0 && ((t = this.Yv) === null || t === void 0 || t.call(this)));
    };
  }
  tf(e, t = !0) {
    const n = this.Kv();
    try {
      const s = e(n);
      return t && n(), s;
    } catch (s) {
      throw n(), s;
    }
  }
  setupSiteApp(e) {
    const t = this.apps[e.id], n = () => {
      var o;
      !t.errored && this.Gv.length && (Jn.info(`Processing ${this.Gv.length} events for site app with id ${e.id}`), this.Gv.forEach((a) => this.tf(() => {
        var l;
        return (l = t.processEvent) === null || l === void 0 ? void 0 : l.call(t, a);
      })), t.processedBuffer = !0), Object.values(this.apps).every((a) => a.processedBuffer || a.errored) && ((o = this.Qv) === null || o === void 0 || o.call(this));
    };
    let s = !1;
    const r = (o) => {
      t.errored = !o, t.loaded = !0, Jn.info(`Site app with id ${e.id} ${o ? "loaded" : "errored"}`), s && n();
    };
    try {
      const { processEvent: o } = this.tf((a) => e.init({ posthog: this._instance, callback(l) {
        a(), r(l);
      } }), !1);
      o && (t.processEvent = o), s = !0;
    } catch (o) {
      Jn.error(ju + e.id, o), r(!1);
    }
    if (s && t.loaded) try {
      n();
    } catch (o) {
      Jn.error(`Error while processing buffered events PostHog app with config id ${e.id}`, o), t.errored = !0;
    }
  }
  ef() {
    const e = this.siteAppLoaders || [];
    for (const t of e) this.apps[t.id] = { id: t.id, loaded: !1, errored: !1, processedBuffer: !1 };
    for (const t of e) this.setupSiteApp(t);
  }
  if(e) {
    if (Object.keys(this.apps).length === 0) return;
    const t = this.globalsForEvent(e);
    for (const n of Object.values(this.apps)) try {
      this.tf(() => {
        var s;
        return (s = n.processEvent) === null || s === void 0 ? void 0 : s.call(n, t);
      });
    } catch (s) {
      Jn.error(`Error while processing event ${e.event} for site app ${n.id}`, s);
    }
  }
  onRemoteConfig(e) {
    var t, n, s;
    if (!((t = this.siteAppLoaders) === null || t === void 0) && t.length) return this.isEnabled ? (this.ef(), void this._instance.on("eventCaptured", (l) => this.if(l))) : void Jn.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
    if ((n = this.Qv) === null || n === void 0 || n.call(this), !e.ok) return;
    const r = e.config;
    if (!((s = r.siteApps) === null || s === void 0) && s.length) if (this.isEnabled) for (const { id: l, url: d } of r.siteApps) {
      var o, a;
      se[`__$$ph_site_app_${l}`] = this._instance, (o = se.__PosthogExtensions__) === null || o === void 0 || (a = o.loadSiteApp) === null || a === void 0 || a.call(o, this._instance, d, (c) => {
        if (c) return Jn.error(ju + l, c);
      });
    }
    else Jn.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
} }, Cy = { tracingHeaders: class {
  constructor(e) {
    this._instance = e, this.nf = void 0, this.sf = void 0, this.rf = void 0, this.bv = () => {
      const t = this.lf();
      var n, s;
      t ? (L(this.nf) && (this.nf = (n = se.__PosthogExtensions__) === null || n === void 0 || (n = n.tracingHeadersPatchFns) === null || n === void 0 ? void 0 : n._patchXHR(t, () => this._instance.get_distinct_id(), this._instance.sessionManager)), L(this.sf) && (this.sf = (s = se.__PosthogExtensions__) === null || s === void 0 || (s = s.tracingHeadersPatchFns) === null || s === void 0 ? void 0 : s._patchFetch(t, () => this._instance.get_distinct_id(), this._instance.sessionManager))) : this.$v();
    };
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  Eo(e) {
    var t, n, s;
    !((t = se.__PosthogExtensions__) === null || t === void 0) && t.tracingHeadersPatchFns ? e() : (n = se.__PosthogExtensions__) === null || n === void 0 || (s = n.loadExternalDependency) === null || s === void 0 || s.call(n, this._instance, "tracing-headers", (r) => {
      if (r) return ey.error("failed to load script", r);
      e();
    });
  }
  af() {
    var e, t;
    return (e = (t = this._instance.config.tracing_headers) !== null && t !== void 0 ? t : this._instance.config.addTracingHeaders) !== null && e !== void 0 ? e : this._instance.config.__add_tracing_headers;
  }
  lf() {
    const e = this.af();
    return ae(e) ? (ae(this.rf) ? this.rf.splice(0, this.rf.length, ...e) : this.rf = [...e], e.length > 0 ? this.rf : void 0) : (ae(this.rf) && this.rf.splice(0), this.rf = e || void 0, this.rf);
  }
  $v() {
    var e, t;
    (e = this.nf) === null || e === void 0 || e.call(this), (t = this.sf) === null || t === void 0 || t.call(this), this.nf = void 0, this.sf = void 0;
  }
  startIfEnabledOrStop() {
    this.lf() ? this.Eo(this.bv) : this.$v();
  }
} }, jy = x({ surveys: class extends iy {
  constructor(e) {
    var t;
    super(new cy(e), (t = e, { get projectToken() {
      return t.config.token;
    }, kv: new dy(t) })), this._instance = e;
  }
  wh(e, t) {
    const n = t.query ? Zi(e, t.query) : e;
    return new Promise((s) => {
      var r;
      this._instance._send_request({ method: t.method, url: this._instance.requestRouter.endpointFor((r = t.target) !== null && r !== void 0 ? r : "api", n), data: t.body, headers: t.headers, timeout: t.timeoutMs, fireCallbackOnDrop: !0, transport: t.transport, compression: t.compression, timestampMode: t.sentAt, callback: s });
    });
  }
} }, ra), Ny = { toolbar: class {
  constructor(e) {
    this.instance = e;
  }
  uf(e) {
    se.ph_toolbar_state = e;
  }
  hf() {
    var e;
    return (e = se.ph_toolbar_state) !== null && e !== void 0 ? e : 0;
  }
  initialize() {
    return this.maybeLoadToolbar();
  }
  maybeLoadToolbar(e = void 0, t = void 0, n = void 0) {
    var s, r;
    if (Tl(this.instance.config) || !k || !A) return !1;
    e = (s = e) !== null && s !== void 0 ? s : k.location, n = (r = n) !== null && r !== void 0 ? r : k.history;
    try {
      if (!t) {
        try {
          k.localStorage.setItem("test", "test"), k.localStorage.removeItem("test");
        } catch {
          return !1;
        }
        t = k == null ? void 0 : k.localStorage;
      }
      const o = uy || zo(e.hash, "__posthog") || zo(e.hash, "state");
      let a;
      const l = o ? Wc(() => JSON.parse(atob(decodeURIComponent(o)))) || Wc(() => JSON.parse(decodeURIComponent(o))) : null;
      return l && l.action === "ph_authorize" ? (a = l, a.source = "url", a && Object.keys(a).length > 0 && (l.desiredHash ? e.hash = l.desiredHash : n ? n.replaceState(n.state, "", e.pathname + e.search) : e.hash = "")) : (a = JSON.parse(t.getItem(Su) || "{}"), a.source = "localstorage", delete a.userIntent), !(!a.token || this.instance.config.token !== a.token || (this.loadToolbar(a), 0));
    } catch {
      return !1;
    }
  }
  cf(e) {
    const t = se.ph_load_toolbar || se.ph_load_editor;
    !_e(t) && Yt(t) ? t(e, this.instance) : ku.warn("No toolbar load function found");
  }
  loadToolbar(e) {
    const t = !!(A != null && A.getElementById("__POSTHOG_TOOLBAR__"));
    if (!k || t) return !1;
    const n = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, s = x(x({ token: this.instance.config.token }, e), {}, { apiURL: this.instance.requestRouter.endpointFor("ui") }, n ? { instrument: !1 } : {});
    if (k.localStorage.setItem(Su, JSON.stringify(x(x({}, s), {}, { source: void 0 }))), this.hf() === 2) this.cf(s);
    else if (this.hf() === 0) {
      var r, o;
      this.uf(1), (r = se.__PosthogExtensions__) === null || r === void 0 || (o = r.loadExternalDependency) === null || o === void 0 || o.call(r, this.instance, "toolbar", (a) => {
        if (a) return ku.error("[Toolbar] Failed to load", a), void this.uf(0);
        this.uf(2), this.cf(s);
      }), We(k, "turbolinks:load", () => {
        this.uf(0), this.loadToolbar(s);
      });
    }
    return !0;
  }
  df(e) {
    return this.loadToolbar(e);
  }
  maybeLoadEditor(e = void 0, t = void 0, n = void 0) {
    return this.maybeLoadToolbar(e, t, n);
  }
} }, Sy = x({ experiments: class sn {
  get Sr() {
    return this._instance.config;
  }
  constructor(t) {
    this._instance = t, this.getWebExperimentsAndEvaluateDisplayLogic = (n = !1) => {
      this.getWebExperiments((s) => {
        sn.vf("retrieved web experiments from the server"), this.ff = /* @__PURE__ */ new Map(), s.forEach((r) => {
          if (r.feature_flag_key) {
            var o;
            this.ff && (sn.vf("setting flag key ", r.feature_flag_key, " to web experiment ", r), (o = this.ff) === null || o === void 0 || o.set(r.feature_flag_key, r));
            const a = this._instance.getFeatureFlag(r.feature_flag_key);
            ye(a) && r.variants[a] && this.pf(r.name, a, r.variants[a].transforms);
          } else if (r.variants) for (const a in r.variants) {
            const l = r.variants[a];
            sn.gf(l, this._instance) && this.pf(r.name, a, l.transforms);
          }
        });
      }, n);
    }, this._instance.onFeatureFlags((n) => {
      this.onFeatureFlags(n);
    });
  }
  initialize() {
  }
  onFeatureFlags(t) {
    if (this._is_bot()) sn.vf(Ou);
    else if (!this.Sr.disable_web_experiments) {
      if (_e(this.ff)) return this.ff = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      sn.vf("applying feature flags", t), t.forEach((n) => {
        var s;
        if (this.ff && (!((s = this.ff) === null || s === void 0) && s.has(n))) {
          var r;
          const o = this._instance.getFeatureFlag(n), a = (r = this.ff) === null || r === void 0 ? void 0 : r.get(n);
          o && (a != null && a.variants[o]) && this.pf(a.name, o, a.variants[o].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    const t = sn.getWindowLocation();
    if (t != null && t.search) {
      const n = Kr(t == null ? void 0 : t.search, "__experiment_id"), s = Kr(t == null ? void 0 : t.search, "__experiment_variant");
      n && s && (sn.vf(`previewing web experiments ${n} && ${s}`), this.getWebExperiments((r) => {
        this.mf(parseInt(n), s, r);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this.Sr.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(t, n, s) {
    if (this.Sr.disable_web_experiments && !s) return t([]);
    const r = this._instance.get_property("$web_experiments");
    if (r && !n) return t(r);
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", `/api/web_experiments/?token=${this.Sr.token}`), method: "GET", timestampMode: "query", callback: (o) => t(o.statusCode === 200 && o.json && o.json.experiments || []) });
  }
  mf(t, n, s) {
    const r = s.filter((o) => o.id === t);
    r && r.length > 0 && (sn.vf(`Previewing web experiment [${r[0].name}] with variant [${n}]`), this.pf(r[0].name, n, r[0].variants[n].transforms));
  }
  static gf(t, n) {
    return !_e(t.conditions) && sn.yf(t, n) && sn.bf(t);
  }
  static yf(t, n) {
    var s;
    if (_e(t.conditions) || _e((s = t.conditions) === null || s === void 0 ? void 0 : s.url)) return !0;
    const r = sn.getWindowLocation();
    if (r) {
      var o, a, l;
      const d = kf(n, r.href);
      return !(!((o = t.conditions) === null || o === void 0) && o.url) || my[(a = (l = t.conditions) === null || l === void 0 ? void 0 : l.urlMatchType) !== null && a !== void 0 ? a : "icontains"](t.conditions.url, d);
    }
    return !1;
  }
  static getWindowLocation() {
    return k == null ? void 0 : k.location;
  }
  static bf(t) {
    var n;
    if (_e(t.conditions) || _e((n = t.conditions) === null || n === void 0 ? void 0 : n.utm)) return !0;
    const s = Bf();
    if (s.utm_source) {
      var r, o, a, l, d, c, u, h;
      const p = !(!((r = t.conditions) === null || r === void 0 || (r = r.utm) === null || r === void 0) && r.utm_campaign) || ((o = t.conditions) === null || o === void 0 || (o = o.utm) === null || o === void 0 ? void 0 : o.utm_campaign) == s.utm_campaign, f = !(!((a = t.conditions) === null || a === void 0 || (a = a.utm) === null || a === void 0) && a.utm_source) || ((l = t.conditions) === null || l === void 0 || (l = l.utm) === null || l === void 0 ? void 0 : l.utm_source) == s.utm_source, m = !(!((d = t.conditions) === null || d === void 0 || (d = d.utm) === null || d === void 0) && d.utm_medium) || ((c = t.conditions) === null || c === void 0 || (c = c.utm) === null || c === void 0 ? void 0 : c.utm_medium) == s.utm_medium, g = !(!((u = t.conditions) === null || u === void 0 || (u = u.utm) === null || u === void 0) && u.utm_term) || ((h = t.conditions) === null || h === void 0 || (h = h.utm) === null || h === void 0 ? void 0 : h.utm_term) == s.utm_term;
      return p && m && g && f;
    }
    return !1;
  }
  static vf(t, ...n) {
    H.info(`[WebExperiments] ${t}`, n);
  }
  pf(t, n, s) {
    this._is_bot() ? sn.vf(Ou) : n !== "control" ? s.forEach((r) => {
      if (r.selector) {
        var o;
        sn.vf(`applying transform of variant ${n} for experiment ${t} `, r);
        const a = (o = document) === null || o === void 0 ? void 0 : o.querySelectorAll(r.selector);
        a == null || a.forEach((l) => {
          const d = l;
          r.html && (d.innerHTML = r.html), r.css && d.setAttribute("style", r.css);
        });
      }
    }) : sn.vf("Control variants leave the page unmodified.");
  }
  _is_bot() {
    return At && this._instance ? ap(At, this.Sr.custom_blocked_useragents) : void 0;
  }
} }, ra), ky = { conversations: class {
  constructor(e) {
    this._instance = e, this._f = void 0, this._conversationsManager = null, this.wf = !1, this.ne = null, this.kf = !1;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(e) {
    if (this._instance.config.disable_conversations || (this.Sf = e.ok, !e.ok)) return;
    const t = e.config.conversations;
    _e(t) || (ln(t) ? this._f = t : (this._f = t.enabled, this.ne = t), this.loadIfEnabled());
  }
  reset() {
    var e;
    (e = this._conversationsManager) === null || e === void 0 || e.reset(), this._conversationsManager = null, this._f = void 0, this.ne = null, this.Sf = void 0, this.kf = !1;
  }
  loadIfEnabled() {
    if (this._conversationsManager || this.wf || this._instance.config.disable_conversations || Tl(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) return;
    const e = se == null ? void 0 : se.__PosthogExtensions__;
    if (e && !L(this._f) && this._f) if (this.ne && this.ne.token) {
      this.wf = !0;
      try {
        const t = e.initConversations;
        if (t) return this.xf(t), void (this.wf = !1);
        const n = e.loadExternalDependency;
        if (!n) return void this.Cf(vd);
        n(this._instance, "conversations", (s) => {
          s || !e.initConversations ? this.Cf("Could not load conversations script", s) : this.xf(e.initConversations), this.wf = !1;
        });
      } catch (t) {
        this.Cf("Error initializing conversations", t), this.wf = !1;
      }
    } else Pn.error("Conversations enabled but missing token in remote config.");
  }
  xf(e) {
    if (this.ne) try {
      this._conversationsManager = e(this.ne, this._instance), this.kf = !1, Pn.info("Conversations loaded successfully");
    } catch (t) {
      this.Cf("Error completing conversations initialization", t);
    }
    else Pn.error("Cannot complete initialization: remote config is null");
  }
  Cf(e, t) {
    Pn.error(e, t), this._conversationsManager = null, this.wf = !1, this.kf = !0;
  }
  show() {
    this._conversationsManager ? this._conversationsManager.show() : Pn.warn("Conversations not loaded yet.");
  }
  hide() {
    this._conversationsManager && this._conversationsManager.hide();
  }
  isAvailable() {
    return this._f === !0 && !gt(this._conversationsManager);
  }
  getUnavailableReason() {
    return this.isAvailable() ? null : this._instance.config.disable_conversations ? "disabled_by_config" : Tl(this._instance.config) ? "disabled_for_toolbar" : this._instance.config.cookieless_mode && this._instance.consent.isOptedOut() ? "consent_opted_out" : this.Sf === !1 ? "remote_config_failed" : L(this._f) ? this.Sf ? "disabled_in_project" : "remote_config_pending" : this._f ? _e(this.ne) || !this.ne.token ? "missing_token" : se != null && se.__PosthogExtensions__ ? this.wf ? "initializing" : this.kf ? "load_failed" : "not_loaded" : "extensions_unavailable" : "disabled_in_project";
  }
  isVisible() {
    var e, t;
    return (e = (t = this._conversationsManager) === null || t === void 0 ? void 0 : t.isVisible()) !== null && e !== void 0 && e;
  }
  sendMessage(e, t, n) {
    var s = this;
    return Qe(function* () {
      return s._conversationsManager ? s._conversationsManager.sendMessage(e, t, n) : (Pn.warn(er), null);
    })();
  }
  getMessages(e, t) {
    var n = this;
    return Qe(function* () {
      return n._conversationsManager ? n._conversationsManager.getMessages(e, t) : (Pn.warn(er), null);
    })();
  }
  markAsRead(e) {
    var t = this;
    return Qe(function* () {
      return t._conversationsManager ? t._conversationsManager.markAsRead(e) : (Pn.warn(er), null);
    })();
  }
  getTickets(e) {
    var t = this;
    return Qe(function* () {
      return t._conversationsManager ? t._conversationsManager.getTickets(e) : (Pn.warn(er), null);
    })();
  }
  requestRestoreLink(e) {
    var t = this;
    return Qe(function* () {
      return t._conversationsManager ? t._conversationsManager.requestRestoreLink(e) : (Pn.warn(er), null);
    })();
  }
  restoreFromToken(e) {
    var t = this;
    return Qe(function* () {
      return t._conversationsManager ? t._conversationsManager.restoreFromToken(e) : (Pn.warn(er), null);
    })();
  }
  restoreFromUrlToken() {
    var e = this;
    return Qe(function* () {
      return e._conversationsManager ? e._conversationsManager.restoreFromUrlToken() : (Pn.warn(er), null);
    })();
  }
  getCurrentTicketId() {
    var e, t;
    return (e = (t = this._conversationsManager) === null || t === void 0 ? void 0 : t.getCurrentTicketId()) !== null && e !== void 0 ? e : null;
  }
  getWidgetSessionId() {
    var e, t;
    return (e = (t = this._conversationsManager) === null || t === void 0 ? void 0 : t.getWidgetSessionId()) !== null && e !== void 0 ? e : null;
  }
  ih() {
    var e;
    (e = this._conversationsManager) === null || e === void 0 || e.setIdentity();
  }
  nh() {
    var e;
    (e = this._conversationsManager) === null || e === void 0 || e.clearIdentity();
  }
} }, Ey = { logs: class {
  constructor(e) {
    var t;
    this._instance = e, this.name = "logs", this.$f = !1, this.Tf = !1, this.If = !1, this.$ = xt("[logs]"), this.Mf = x(x({}, this.$), {}, { error: (...n) => {
      n.some(Mu) || this.$.error(...n);
    } }), this.Zl = [], this.Ef = [], this.Wc = 0, this.fo = !1, this.Pf = [], this.Rf = [], this.Af = !1, this.Ff = !1, this.Of = () => {
      var n, s;
      this.fo || (this.Wc = 0, (n = this.Df) === null || n === void 0 || n.onReconnect(), (s = this.Lf) === null || s === void 0 || s.onReconnect());
    }, this._instance && (!((t = this._instance.config.logs) === null || t === void 0) && t.captureConsoleLogs) && (this.$f = !0), k && We(k, "online", this.Of);
  }
  Nf(e, t, n, s) {
    var r;
    const o = Fu((r = this._instance) === null || r === void 0 || (r = r.config) === null || r === void 0 ? void 0 : r.logs, n);
    return [new fb(this.qf(e, t), o, this.Mf, () => this.jf(), (a) => a(), void 0, s), o];
  }
  Bf() {
    var e;
    const t = (e = this._instance) === null || e === void 0 || (e = e.config) === null || e === void 0 ? void 0 : e.logs;
    var n;
    return this.Df && this.Hf === t || ((n = this.Df) === null || n === void 0 || n.reset(), this.Hf = t, [this.Df, this.zf] = this.Nf(() => this.Zl, (s) => {
      this.Zl = s;
    })), this.Df;
  }
  Uf() {
    var e;
    const t = (e = this._instance) === null || e === void 0 || (e = e.config) === null || e === void 0 ? void 0 : e.logs;
    var n;
    return this.Lf && this.Wf === t || ((n = this.Lf) === null || n === void 0 || n.reset(), this.Wf = t, [this.Lf, this.Vf] = this.Nf(() => this.Ef, (s) => {
      this.Ef = s;
    }, { serviceNameDefault: "posthog-browser-logs", consoleCapture: !0 }, Au)), this.Lf;
  }
  setup(e) {
    var t;
    if (this.fo) return;
    this.lo = e, !((t = this._instance) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.logs) === null || t === void 0) && t.captureConsoleLogs && (this.$f = !0), (this.$f || this.Gf() && this.Zf()) && this.Qf();
    let n = !1;
    const s = e.onRemoteConfig((r) => {
      var o;
      n = r.ok && ((o = r.config.logs) === null || o === void 0 ? void 0 : o.captureConsoleLogs) === !0, this.onRemoteConfig(r);
    });
    this.fo ? s.dispose() : (this.yo = s, n || this.loadIfEnabled());
  }
  dispose() {
    var e, t, n, s;
    this.fo || (this.fo = !0, this.Jf(), (e = this.yo) === null || e === void 0 || e.dispose(), this.yo = void 0, this.lo = void 0, this.If = !1, k == null || k.removeEventListener("online", this.Of), (t = this.Kf) === null || t === void 0 || t.call(this), this.Kf = void 0, (n = this.Df) === null || n === void 0 || n.reset(), (s = this.Lf) === null || s === void 0 || s.reset());
  }
  onRemoteConfig(e) {
    var t, n;
    if (this.fo) return;
    const s = e.ok ? (t = e.config.logs) === null || t === void 0 ? void 0 : t.captureConsoleLogs : void 0;
    _e(s) ? this.Yf() : ((n = this._instance) === null || n === void 0 || (n = n.persistence) === null || n === void 0 || n.register({ $logs_capture_enabled_server_side: !!s }), s ? (this.$f = !0, this.Tf || this.Qf(), this.loadIfEnabled()) : this.Yf());
  }
  reset() {
    var e, t, n, s;
    this.Jf(), (e = this.Df) === null || e === void 0 || e.clearQueue(), this.Zl = [], (t = this.Df) === null || t === void 0 || t.reset(), (n = this.Lf) === null || n === void 0 || n.clearQueue(), this.Ef = [], (s = this.Lf) === null || s === void 0 || s.reset(), this.Wc = 0;
  }
  captureLog(e) {
    this.fo || this.Bf().captureLog(e);
  }
  captureConsoleLog(e) {
    this.fo || this.Uf().captureLog(e);
  }
  captureBufferedConsoleLog(e, t, n) {
    this.fo || this.Uf().captureLog(e, { context: t, occurredAtMs: n });
  }
  Zf() {
    var e;
    return !!(!((e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || (e = e.props) === null || e === void 0) && e[uf]);
  }
  Gf() {
    var e, t, n;
    return !(!((e = this._instance) === null || e === void 0 || (t = e.Ul) === null || t === void 0) && t.call(e)) || !!(!((n = se._POSTHOG_REMOTE_CONFIG) === null || n === void 0 || (n = n[this._instance.config.token]) === null || n === void 0) && n.config);
  }
  rh() {
    var e;
    this.Jf(), (e = this.Lf) === null || e === void 0 || e.clearQueue(), this.Ef = [];
  }
  Yf() {
    this.$f || this.Jf();
  }
  Qf() {
    var e;
    if (this.Af || !(se != null && se.console)) return;
    const t = Fu((e = this._instance) === null || e === void 0 || (e = e.config) === null || e === void 0 ? void 0 : e.logs).maxBufferSize;
    for (const n of gy) {
      let s;
      try {
        s = vy(se.console[n]);
      } catch {
        continue;
      }
      s && this.Rf.push(mp(se.console, n, (r) => {
        const o = (...a) => {
          try {
            this.Xf(n, a, t);
          } catch {
          }
          return r.apply(se.console, a);
        };
        return o.__rrweb_original__ = s, o;
      }));
    }
    this.Af = !0, this.tp = setTimeout(() => {
      this.Jf();
    }, 3e4);
  }
  Xf(e, t, n) {
    var s;
    if (this.Af && !this.Ff && t.length !== 0) if (!((s = this._instance) === null || s === void 0) && s.is_capturing()) {
      if (n > this.Pf.length) {
        this.Ff = !0;
        try {
          this.Pf.push({ level: e, args: t, occurredAtMs: Date.now(), context: this.jf() });
        } finally {
          this.Ff = !1;
        }
      }
    } else this.Jf();
  }
  Jf() {
    if (this.Pf = [], this.Af) {
      this.Af = !1, this.tp && (clearTimeout(this.tp), this.tp = void 0);
      for (const e of this.Rf) e();
      this.Rf = [];
    }
  }
  ep() {
    const e = this.Pf;
    return this.Jf(), e;
  }
  get logger() {
    return this.np || (this.np = { trace: (e, t) => this.captureLog({ body: e, level: "trace", attributes: t }), debug: (e, t) => this.captureLog({ body: e, level: "debug", attributes: t }), info: (e, t) => this.captureLog({ body: e, level: "info", attributes: t }), warn: (e, t) => this.captureLog({ body: e, level: "warn", attributes: t }), error: (e, t) => this.captureLog({ body: e, level: "error", attributes: t }), fatal: (e, t) => this.captureLog({ body: e, level: "fatal", attributes: t }) }), this.np;
  }
  flushLogs(e) {
    e ? this.sp(e) : (this.Df && this.Df.flush().catch((t) => this.rp(t)), this.Lf && this.Lf.flush().catch((t) => this.rp(t)));
  }
  rp(e) {
    Mu(e) || this.$.error("PostHog logs flush failed:", e);
  }
  loadIfEnabled() {
    if (this.fo || !this.$f || this.Tf || this.If) return;
    const e = se == null ? void 0 : se.__PosthogExtensions__;
    if (!e) return this.$.error("PostHog Extensions not found."), void this.Jf();
    const t = e.loadExternalDependency;
    if (!t) return this.$.error(vd), void this.Jf();
    this.If = !0;
    try {
      t(this._instance, "logs", (n) => {
        if (this.If = !1, this.fo || !this.$f) return;
        const s = e.logs;
        if (n || !(s != null && s.initializeLogs)) this.$.error("Could not load logs script", n), this.Jf();
        else {
          var r;
          const l = this.ep();
          var o, a;
          this.Kf = s.initializeLogs((r = this.lo) !== null && r !== void 0 ? r : this._instance), this.Tf = !0, l.length > 0 && ((o = s.replayConsoleBuffer) === null || o === void 0 || o.call(s, (a = this.lo) !== null && a !== void 0 ? a : this._instance, l));
        }
      });
    } catch (n) {
      throw this.If = !1, n;
    }
  }
  qf(e, t) {
    const n = this._instance;
    return { get isDisabled() {
      return !1;
    }, get optedOut() {
      return !n.is_capturing();
    }, getPersistedProperty: (s) => s === Qn.LogsQueue ? e() : void 0, setPersistedProperty(s, r) {
      var o;
      s === Qn.LogsQueue && t((o = r) !== null && o !== void 0 ? o : []);
    }, Ps: (s) => this.Ps(s), getLibraryId: () => Ot.LIB_NAME, getLibraryVersion: () => Ot.LIB_VERSION };
  }
  Ps(e) {
    return new Promise((t) => {
      if (Mf(this.Wc, 3)) return void t({ kind: "fatal", error: Xa(void 0, "logs endpoint is unreachable, dropping batch") });
      let n = !1;
      const s = (o) => {
        n || (n = !0, clearTimeout(r), t(o));
      }, r = setTimeout(() => {
        this.$.warn("Logs request timed out before receiving a response"), s({ kind: "retry-later", error: Xa(void 0, "logs request timed out") });
      }, 9e4);
      this._instance._send_request({ method: "POST", url: this.op(), data: e, compression: "best-available", batchKey: "logs", fireCallbackOnDrop: !0, callback: (o) => {
        const a = o.statusCode;
        if (this.lp(a), a >= 200 && 300 > a) s({ kind: "ok" });
        else if (a === 413) s({ kind: "too-large" });
        else if (a !== 0 && a !== 408 && a !== 429 && 500 > a) s({ kind: "fatal", error: new Error(`logs request failed with status ${a}`) });
        else {
          var l;
          a === 0 ? (o.error || this.$.warn("Logs request failed before receiving an HTTP response"), s({ kind: "retry-later", error: Xa(o.error, "logs request failed before receiving an HTTP response") })) : s({ kind: "retry-later", error: (l = o.error) !== null && l !== void 0 ? l : new Error(`logs request failed with status ${a}`) });
        }
      } });
    });
  }
  lp(e) {
    (e !== 0 || this._instance.__loaded) && (this.Wc = Df(e, this.Wc, 3, () => this.$.warn("Log requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped sending logs; will try again when connectivity changes.")));
  }
  sp(e) {
    this.Zl.length > 0 && this.ap(e, this.Zl, this.zf, Ot.LIB_NAME, (t) => {
      this.Zl = t;
    }), this.Ef.length > 0 && this.ap(e, this.Ef, this.Vf, Au, (t) => {
      this.Ef = t;
    });
  }
  ap(e, t, n, s, r) {
    if (t.length === 0) return;
    const o = t.map((l) => l.record);
    r([]);
    const a = af(o, of(n, Ot.LIB_NAME, Ot.LIB_VERSION), s, Ot.LIB_VERSION);
    this._instance._send_request({ method: "POST", url: this.op(), data: a, compression: "best-available", batchKey: "logs", transport: e });
  }
  op() {
    return this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
  }
  jf() {
    var e;
    const t = {};
    if (t.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
      const { sessionId: n, windowId: s, sessionStartTimestamp: r, lastActivityTimestamp: o } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
      t.sessionId = n, t.windowId = s, _e(r) || (t.sessionStartTimestamp = r), _e(o) || (t.lastActivityTimestamp = o);
    }
    if (!(se == null || (e = se.location) === null || e === void 0) && e.href && (t.currentUrl = this._instance.config.disable_capture_url_hashes ? zs(se.location.href) : se.location.href), this._instance.featureFlags) {
      const n = this._instance.featureFlags.getFlags();
      n && n.length > 0 && (t.activeFeatureFlags = n);
    }
    return t;
  }
} }, Iy = { metrics: class {
  constructor(e) {
    this._instance = e, this.$ = xt("[metrics]");
  }
  initialize() {
  }
  Bf() {
    var e;
    const t = (e = this._instance) === null || e === void 0 || (e = e.config) === null || e === void 0 ? void 0 : e.metrics;
    var n;
    return this.Df && this.Hf === t || ((n = this.Df) === null || n === void 0 || n.reset(), this.Hf = t, this.Df = new pb(this.qf(), function(s) {
      var r, o, a, l, d;
      const c = s == null ? void 0 : s.resourceAttributes;
      return { serviceName: (r = c == null ? void 0 : c["service.name"]) !== null && r !== void 0 ? r : s == null ? void 0 : s.serviceName, serviceVersion: (o = c == null ? void 0 : c["service.version"]) !== null && o !== void 0 ? o : s == null ? void 0 : s.serviceVersion, environment: (a = c == null ? void 0 : c["deployment.environment"]) !== null && a !== void 0 ? a : s == null ? void 0 : s.environment, resourceAttributes: c, beforeSend: s == null ? void 0 : s.beforeSend, flushIntervalMs: (l = s == null ? void 0 : s.flushIntervalMs) !== null && l !== void 0 ? l : 1e4, maxSeriesPerFlush: (d = s == null ? void 0 : s.maxSeriesPerFlush) !== null && d !== void 0 ? d : 1e3 };
    }(t), this.$)), this.Df;
  }
  count(e, t = 1, n) {
    this.Bf().count(e, t, n);
  }
  gauge(e, t, n) {
    this.Bf().gauge(e, t, n);
  }
  histogram(e, t, n) {
    this.Bf().histogram(e, t, n);
  }
  flush(e) {
    if (!this.Df) return Promise.resolve();
    if (e) {
      const t = this.Df.drainWindow();
      return t && this.Gs(t, e), Promise.resolve();
    }
    return this.Df.flush().catch((t) => this.$.error("PostHog metrics flush failed:", t));
  }
  reset() {
    var e;
    (e = this.Df) === null || e === void 0 || e.reset();
  }
  qf() {
    const e = this._instance, t = this;
    return { get isDisabled() {
      return !1;
    }, get optedOut() {
      return !e.is_capturing();
    }, Gs: (n) => t.Gs(n), getLibraryId: () => Ot.LIB_NAME, getLibraryVersion: () => Ot.LIB_VERSION };
  }
  Gs(e, t) {
    return new Promise((n) => {
      let s = !1;
      const r = (a) => {
        s || (s = !0, clearTimeout(o), n(a));
      }, o = setTimeout(() => r({ kind: "retry-later", error: new Error("metrics request timed out") }), 9e4);
      this._instance._send_request(x(x({ method: "POST", url: this.up(), data: e, compression: "best-available", batchKey: "metrics" }, t && { transport: t }), {}, { fireCallbackOnDrop: !0, callback(a) {
        const l = a.statusCode;
        if (l >= 200 && 300 > l) r({ kind: "ok" });
        else if (l === 413) r({ kind: "too-large" });
        else if (l !== 0 && l !== 408 && l !== 429 && 500 > l) r({ kind: "fatal", error: new Error(`metrics request failed with status ${l}`) });
        else {
          var d;
          r({ kind: "retry-later", error: (d = a.error) !== null && d !== void 0 ? d : new Error(`metrics request failed with status ${l}`) });
        }
      } }));
    });
  }
  up() {
    return this._instance.requestRouter.endpointFor("api", "/i/v1/metrics") + "?token=" + encodeURIComponent(this._instance.config.token);
  }
} };
Oi.__defaultExtensionClasses = x({}, x(x(x(x(x(x(x(x(x(x(x(x(x({}, ra), $y), by), xy), yy), wy), jy), Cy), Ny), Sy), ky), Ey), Iy));
const Py = function() {
  Ot.SDK_DIST_CHANNEL = "npm";
  const e = Ri[Ci] = new Oi();
  return function() {
    function t() {
      t.done || (t.done = !0, pp = !1, Me(Ri, function(n) {
        n._dom_loaded();
      }));
    }
    A != null && A.addEventListener ? A.readyState === "complete" ? t() : We(A, "DOMContentLoaded", t, { capture: !1 }) : k && H.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
  }(), e;
}();
var pr = Py;
let po;
const Ty = new Uint8Array(16);
function Ry() {
  if (!po && (po = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !po))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return po(Ty);
}
const Gt = [];
for (let e = 0; e < 256; ++e)
  Gt.push((e + 256).toString(16).slice(1));
function Ly(e, t = 0) {
  return Gt[e[t + 0]] + Gt[e[t + 1]] + Gt[e[t + 2]] + Gt[e[t + 3]] + "-" + Gt[e[t + 4]] + Gt[e[t + 5]] + "-" + Gt[e[t + 6]] + Gt[e[t + 7]] + "-" + Gt[e[t + 8]] + Gt[e[t + 9]] + "-" + Gt[e[t + 10]] + Gt[e[t + 11]] + Gt[e[t + 12]] + Gt[e[t + 13]] + Gt[e[t + 14]] + Gt[e[t + 15]];
}
const Oy = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Du = {
  randomUUID: Oy
};
function Fy(e, t, n) {
  if (Du.randomUUID && !e)
    return Du.randomUUID();
  e = e || {};
  const s = e.random || (e.rng || Ry)();
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, Ly(s);
}
const Bu = (e) => {
  var s;
  const t = `${e}=`, n = (s = document == null ? void 0 : document.cookie) == null ? void 0 : s.split(";");
  for (let r = 0; r < n.length; r++) {
    let o = n[r];
    for (; o.charAt(0) === " "; ) o = o.substring(1);
    if (o.indexOf(t) === 0)
      try {
        return JSON.parse(decodeURIComponent(o.substring(t.length, o.length)));
      } catch {
        return null;
      }
  }
  return null;
}, Ay = "_button_1q8pr_2", My = "_root_1q8pr_15", Dy = "_rootShowButton_1q8pr_28", By = "_filledButtonSpan_1q8pr_33", Wy = "_buttonLeft_1q8pr_46", Uy = "_buttonRight_1q8pr_80", zy = "_buttonRightShow_1q8pr_101", Hy = "_showDesktop_1q8pr_120", qy = "_showDesktopButton_1q8pr_125", Gy = "_showButtonInMobile_1q8pr_129", Vy = "_loaderIcon_1q8pr_138", Yy = "_inner_1q8pr_155", Ky = "_divForMargin_1q8pr_159", Jy = "_hide_1q8pr_163", Zy = "_buttonRoot_1q8pr_167", Xy = "_backButton_1q8pr_188", Qy = "_buttonGridCol_1q8pr_205", e3 = "_goBackText_1q8pr_209", Ft = {
  button: Ay,
  root: My,
  rootShowButton: Dy,
  filledButtonSpan: By,
  buttonLeft: Wy,
  buttonRight: Uy,
  buttonRightShow: zy,
  showDesktop: Hy,
  showDesktopButton: qy,
  showButtonInMobile: Gy,
  loaderIcon: Vy,
  inner: Yy,
  divForMargin: Ky,
  hide: Jy,
  buttonRoot: Zy,
  backButton: Xy,
  buttonGridCol: Qy,
  goBackText: e3
}, t3 = "_hide_1uj7p_1", n3 = "_button_1uj7p_5", s3 = "_root_1uj7p_17", r3 = "_rootShowButton_1uj7p_36", i3 = "_filledButtonSpan_1uj7p_41", o3 = "_buttonLeft_1uj7p_51", a3 = "_buttonRight_1uj7p_74", l3 = "_buttonRightShow_1uj7p_96", d3 = "_showDesktop_1uj7p_115", c3 = "_showDesktopButton_1uj7p_120", u3 = "_showButtonInMobile_1uj7p_124", h3 = "_loaderIcon_1uj7p_133", f3 = "_inner_1uj7p_150", Wt = {
  hide: t3,
  button: n3,
  root: s3,
  rootShowButton: r3,
  filledButtonSpan: i3,
  buttonLeft: o3,
  buttonRight: a3,
  buttonRightShow: l3,
  showDesktop: d3,
  showDesktopButton: c3,
  showButtonInMobile: u3,
  loaderIcon: h3,
  inner: f3
}, p3 = ({
  showOutlineButton: e,
  backButtonId: t,
  outlineButtonOnClick: n,
  uppercase: s,
  outlineButtonText: r,
  showFilledButton: o,
  showButton: a,
  filledButtonText: l,
  disabled: d,
  id: c,
  loading: u,
  pageData: h,
  oppId: p,
  showGutter: f = !0,
  manageLayerOfData: m,
  showLoader: g
}) => {
  const v = a ? Wt.showDesktopButton : Wt.showDesktop, _ = a ? Wt.rootShowButton : Wt.root, $ = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsxs(
    T,
    {
      className: _,
      classNames: { root: Wt.root, inner: Wt.inner },
      id: "vwo-next-button-new-version",
      children: [
        f && /* @__PURE__ */ i.jsx(T.Col, { span: { sm: 0, md: 3 }, className: v }),
        /* @__PURE__ */ i.jsxs(T.Col, { span: { sm: 12, md: 9 }, children: [
          e && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "outline",
              id: t,
              className: R(Wt.button, Wt.buttonLeft),
              onClick: n,
              uppercase: s,
              children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx("span", { className: v, children: r }),
                /* @__PURE__ */ i.jsx(
                  "span",
                  {
                    className: a ? Wt.showButtonInMobile : Wt.filledButtonSpan,
                    children: /* @__PURE__ */ i.jsx(U, { name: "backwardArrowIcon" })
                  }
                )
              ] })
            }
          ),
          o && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "filled",
              onClick: m,
              type: "submit",
              uppercase: s,
              className: a ? R(Wt.button, Wt.buttonRightShow) : R(Wt.button, Wt.buttonRight),
              id: c,
              disabled: d,
              value: "create",
              loading: !$ && u,
              pageData: h,
              oppId: p,
              children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx("span", { className: v, children: l }),
                /* @__PURE__ */ i.jsx(
                  "span",
                  {
                    className: a ? Wt.showButtonInMobile : Wt.filledButtonSpan,
                    children: /* @__PURE__ */ i.jsx(U, { name: "forwardArrowIcon" })
                  }
                )
              ] })
            }
          ),
          g && /* @__PURE__ */ i.jsx("span", { className: Wt.loaderIcon, children: /* @__PURE__ */ i.jsx(ts, { size: "lg" }) })
        ] })
      ]
    }
  ) });
}, _3 = {
  secondary: {
    root: Ft.buttonRoot
  }
};
function m3() {
  return ne(() => {
    const t = (localStorage == null ? void 0 : localStorage.getItem("ph_custom_session_id")) ?? Fy();
    pr == null || pr.init(V0, {
      api_host: Y0,
      person_profiles: "identified_only",
      loaded: (n) => {
        n == null || n.register_for_session({ custom_session_id: t }), n == null || n.capture("$session_started");
      }
    });
  }, []), null;
}
const g3 = (e, t) => {
  try {
    typeof window < "u" && (pr != null && pr.__loaded) && pr.capture(e, t);
  } catch {
  }
}, lR = ({
  outlineButtonOnClick: e,
  filledButtonOnClick: t,
  manageDataLayer: n,
  showOutlineButton: s,
  showFilledButton: r,
  outlineButtonText: o = "BACK",
  filledButtonText: a,
  showGutter: l = !0,
  uppercase: d = !0,
  id: c,
  backButtonId: u = "back",
  disabled: h = !1,
  loading: p,
  pageData: f,
  oppId: m,
  timeout: g,
  showButton: v,
  customVariant: _ = "secondary",
  footerBack: $ = !1,
  handleClientSide: y = !1
}) => {
  const [P, j] = O(!1), b = Ve("(min-width: 768px)");
  function N() {
    j(!0), setTimeout(() => {
      t && t();
    }, 3e3);
  }
  const C = (W) => {
    const D = Bu("sfmc"), B = Bu("currentUserEmail"), q = D != null && D.sfmcActivityId ? { ...D } : null, G = window.dataLayer || [];
    G == null || G.push({
      testVersion: JSON.stringify({
        sfmcKey: D == null ? void 0 : D.sfmcActivityId
      }),
      sfmcVersion: JSON.stringify({ sfmc_details: "sfmc test", ...q || {} }),
      ...B && {
        event: "userProvidedData",
        leadsUserData: {
          emailID: B
        }
      },
      ...m && {
        oppId: m,
        moduleName: f == null ? void 0 : f.pageName,
        stepNumber: f == null ? void 0 : f.stepNumber
      }
    }), g3("Next CTA Clicked", {
      source: "Footer",
      ...B && {
        emailID: B
      },
      ...m && {
        oppId: m
      },
      pageData: JSON.stringify(f),
      moduleName: f == null ? void 0 : f.pageName,
      stepNumber: f == null ? void 0 : f.stepNumber
    }), g ? N() : t == null || t();
  }, S = v ? Ft.rootShowButton : Ft.root, F = v ? Ft.showDesktopButton : Ft.showDesktop;
  return ne(() => {
    const W = window.document.getElementById(ah), D = "with-mobile-footer-buttons";
    if (b) {
      W == null || W.classList.remove(D);
      return;
    }
    return W == null || W.classList.add(D), () => {
      W == null || W.classList.remove(D);
    };
  }, [b]), /* @__PURE__ */ i.jsxs(oe.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(
      T,
      {
        className: S,
        classNames: { root: Ft.root, inner: Ft.inner, col: Ft.buttonGridCol },
        id: "vwo-next-button-new-version",
        children: [
          l && /* @__PURE__ */ i.jsx(T.Col, { span: { sm: 0, md: 3 }, className: F }),
          /* @__PURE__ */ i.jsxs(T.Col, { span: { sm: 12, md: 9 }, children: [
            s && !(_ === "secondary" && $ && !b) && /* @__PURE__ */ i.jsx(
              qe,
              {
                variant: "outline",
                id: u,
                className: R(Ft.button, Ft.buttonLeft),
                onClick: e,
                children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                  /* @__PURE__ */ i.jsx("span", { className: F, children: o }),
                  /* @__PURE__ */ i.jsxs(
                    "span",
                    {
                      className: v ? Ft.showButtonInMobile : Ft.filledButtonSpan,
                      children: [
                        /* @__PURE__ */ i.jsx(U, { name: "leftArrow" }),
                        " Back"
                      ]
                    }
                  )
                ] })
              }
            ),
            r && /* @__PURE__ */ i.jsx(
              qe,
              {
                variant: "filled",
                onClick: C,
                type: y ? "button" : "submit",
                uppercase: d,
                className: v ? R(Ft.button, Ft.buttonRightShow) : R(Ft.button, Ft.buttonRight),
                classNames: _3[_] || null,
                id: c,
                disabled: h,
                value: "create",
                loading: p,
                pageData: f,
                oppId: m,
                children: a || ""
              }
            ),
            $ && /* @__PURE__ */ i.jsx(
              qe,
              {
                variant: "outline",
                onClick: e,
                classNames: { root: Ft.backButton },
                id: u,
                children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                  /* @__PURE__ */ i.jsx(U, { name: "leftArrow", color: "#949494" }),
                  " ",
                  /* @__PURE__ */ i.jsx("span", { className: Ft.goBackText, children: "Back" })
                ] })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ i.jsx("div", { id: "vwo-next-button-old-version", className: Ft.hide, children: /* @__PURE__ */ i.jsx(
      p3,
      {
        showOutlineButton: s,
        backButtonId: u,
        outlineButtonOnClick: e,
        uppercase: d,
        outlineButtonText: o,
        showFilledButton: r,
        showButton: v,
        filledButtonText: a,
        disabled: h,
        id: c,
        loading: p,
        pageData: f,
        oppId: m,
        manageLayerOfData: C
      }
    ) }),
    /* @__PURE__ */ i.jsx(m3, {})
  ] });
}, v3 = "_divStyle_1ajec_1", $3 = "_group_1ajec_13", b3 = "_btn_1ajec_22", x3 = "_btn_Child_1ajec_54", y3 = "_btn_Child_1ajec_54", w3 = "_oneWave_1ajec_87", C3 = "_womenGroup_1ajec_101", gi = {
  divStyle: v3,
  group: $3,
  btn: b3,
  btn_Child: x3,
  btnChild: y3,
  oneWave: w3,
  womenGroup: C3
}, dR = () => /* @__PURE__ */ i.jsxs(T, { className: gi.divStyle, children: [
  /* @__PURE__ */ i.jsx(T.Col, { className: gi.oneWave, span: 12, children: /* @__PURE__ */ i.jsx(U, { name: "colorWave" }) }),
  /* @__PURE__ */ i.jsx(T.Col, { className: gi.womenGroup, span: 5, children: /* @__PURE__ */ i.jsx(U, { name: "womenGroup" }) }),
  /* @__PURE__ */ i.jsx(T.Col, { className: gi.btn, span: 12, children: /* @__PURE__ */ i.jsx(Jt, { className: gi.btn_Child, children: "START A NEW APPLICATION" }) })
] }), j3 = "_rootContainer_terz2_1", N3 = "_seconfRootContainer_terz2_19", S3 = "_innerContainer_terz2_37", k3 = "_verifyDOC_terz2_46", E3 = "_verifyDOC_terz2_46", I3 = "_universityText_terz2_60", P3 = "_tableContainer_terz2_71", T3 = "_universityIcon_terz2_80", R3 = "_CardFlexCol2_terz2_85", L3 = "_CardFlexCol2_terz2_85", O3 = "_CardFlexRow_1_terz2_94", F3 = "_CardFlexRow_1_terz2_94", A3 = "_CardText_terz2_101", M3 = "_CardText_terz2_101", D3 = "_CardText_1_terz2_109", B3 = "_CardText_1_terz2_109", W3 = "_btn_terz2_116", U3 = "_btn_Child_terz2_123", z3 = "_btn_Child_terz2_123", Pt = {
  rootContainer: j3,
  seconfRootContainer: N3,
  innerContainer: S3,
  verifyDOC: k3,
  verifyDoc: E3,
  universityText: I3,
  tableContainer: P3,
  universityIcon: T3,
  CardFlexCol2: R3,
  cardFlexCol2: L3,
  CardFlexRow_1: O3,
  cardFlexRow1: F3,
  CardText: A3,
  cardText: M3,
  CardText_1: D3,
  cardText1: B3,
  btn: W3,
  btn_Child: U3,
  btnChild: z3
}, cR = ({
  universityCardData: e = [],
  addCard: t,
  onComplete: n
}) => {
  const [s, r] = O([]), [o, a] = O(!1);
  return ne(() => {
    r(e);
  }, []), ne(() => {
    a(t);
  }, [t]), /* @__PURE__ */ i.jsx(i.Fragment, { children: o ? /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(T, { className: Pt.seconfRootContainer, children: /* @__PURE__ */ i.jsxs(T.Col, { children: [
    /* @__PURE__ */ i.jsx(U, { name: "addButton" }),
    /* @__PURE__ */ i.jsx(ys, { order: 6, children: "Add a new Card" })
  ] }) }) }) : /* @__PURE__ */ i.jsx(i.Fragment, { children: s.map((l) => /* @__PURE__ */ i.jsxs(T, { className: Pt.rootContainer, children: [
    /* @__PURE__ */ i.jsx(T.Col, { className: Pt.innerContainer, children: /* @__PURE__ */ i.jsx(ys, { order: 6, className: Pt.verifyDOC, children: l.title }) }),
    /* @__PURE__ */ i.jsx(T.Col, { className: Pt.innerContainer, children: /* @__PURE__ */ i.jsx(ys, { order: 4, className: Pt.universityText, children: l.content }) }),
    /* @__PURE__ */ i.jsxs(T, { className: Pt.tableContainer, children: [
      /* @__PURE__ */ i.jsx(T.Col, { className: Pt.universityIcon, span: 3, children: /* @__PURE__ */ i.jsx(U, { name: "university" }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 9, children: /* @__PURE__ */ i.jsxs(T, { className: Pt.CardFlexCol2, children: [
        /* @__PURE__ */ i.jsxs(T.Col, { className: Pt.CardFlexRow_1, children: [
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText, children: "App ID:" }),
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText_1, children: l.appId })
        ] }),
        /* @__PURE__ */ i.jsxs(T.Col, { className: Pt.CardFlexRow_1, children: [
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText, children: "Academic period:" }),
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText_1, children: l.year })
        ] }),
        /* @__PURE__ */ i.jsxs(T.Col, { className: Pt.CardFlexRow_1, children: [
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText, children: "Loan amount:" }),
          /* @__PURE__ */ i.jsx("div", { className: Pt.CardText_1, children: l.loanAmount })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ i.jsx(T, { className: Pt.btn, children: /* @__PURE__ */ i.jsx(Jt, { className: Pt.btn_Child, onClick: n, children: "COMPLETE NOW" }) })
  ] }, l.id)) }) });
}, H3 = "_wrapper_1gahp_2", q3 = "_imgStyle_1gahp_8", Wu = {
  wrapper: H3,
  imgStyle: q3
}, uR = () => /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx("div", { className: Wu.wrapper, children: /* @__PURE__ */ i.jsx(T, { className: Wu.imgStyle, children: /* @__PURE__ */ i.jsx(U, { name: "lightBlueWaveMobile" }) }) }) }), G3 = "_root_quqbd_1", V3 = {
  root: G3
}, hR = ({ btn: e }) => /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(T, { className: V3.root, align: "center", justify: "space-between", children: [
  /* @__PURE__ */ i.jsx(T.Col, { span: { md: 6, lg: 4, xs: 6, base: 12 }, children: /* @__PURE__ */ i.jsx(T, { pl: 20, pt: 2, align: "center", justify: "flex-start", children: /* @__PURE__ */ i.jsx(ys, { order: 4, ta: "center", children: "Heading" }) }) }),
  /* @__PURE__ */ i.jsx(T.Col, { span: { md: 6, lg: 4, xs: 6, base: 12 }, children: /* @__PURE__ */ i.jsx(T, { pr: 20, pt: 2, align: "center", justify: "flex-end", children: /* @__PURE__ */ i.jsxs(Jt, { variant: "filled", children: [
    "COMPLETE NOW",
    e
  ] }) }) })
] }) });
function Y3(e) {
  return (t) => {
    if (typeof t == "number")
      return `${t / 16}${e}`;
    if (typeof t == "string") {
      const n = t.replace("px", "");
      if (!Number.isNaN(Number(n)))
        return `${Number(n) / 16}${e}`;
    }
    return t;
  };
}
const ws = Y3("rem"), K3 = "_container_13wc5_1", J3 = "_title_13wc5_13", Z3 = "_divider_13wc5_24", X3 = "_description_13wc5_35", Q3 = "_list_13wc5_48", e4 = "_listItem_13wc5_63", t4 = "_listItemIcon_13wc5_79", n4 = "_listItemCompletedIcon_13wc5_96", s4 = "_listItemText_13wc5_100", Zn = {
  container: K3,
  title: J3,
  divider: Z3,
  description: X3,
  list: Q3,
  listItem: e4,
  listItemIcon: t4,
  listItemCompletedIcon: n4,
  listItemText: s4
}, r4 = (e) => {
  const { opened: t, onClose: n, actionProgress: s } = e, r = Ve("(min-width: 768px)"), { name: o, fullName: a, description: l, color: d, progress: c, steps: u } = s, h = c > 99;
  return /* @__PURE__ */ i.jsx(
    Nn,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 150,
        zIndex: 1e7
      },
      radius: "lg",
      opened: t,
      onClose: n,
      size: ws(r ? 838 : 359),
      centered: !0,
      children: /* @__PURE__ */ i.jsxs(E, { className: Zn.container, children: [
        /* @__PURE__ */ i.jsx(
          ee,
          {
            fontWeight: "700",
            order: 3,
            className: Zn.title,
            style: { color: h ? d : gn.softGray },
            children: a ?? o
          }
        ),
        /* @__PURE__ */ i.jsx(Vn, { w: "100%", color: gn.softGray, className: Zn.divider }),
        /* @__PURE__ */ i.jsx(I, { className: Zn.description, children: l }),
        /* @__PURE__ */ i.jsx(Be, { className: Zn.list, children: u.map((p) => /* @__PURE__ */ i.jsxs(Be.Item, { className: Zn.listItem, children: [
          p.done ? /* @__PURE__ */ i.jsx(
            U,
            {
              name: "progressCompleted",
              ariaLabel: "Completed icon",
              className: R(Zn.listItemIcon, Zn.listItemCompletedIcon)
            }
          ) : /* @__PURE__ */ i.jsx(
            U,
            {
              name: "progressNotStarted",
              ariaLabel: "Not started icon",
              className: Zn.listItemIcon
            }
          ),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Zn.listItemText, children: p.name })
        ] }, p.id)) })
      ] })
    }
  );
}, i4 = "_container_10imp_1", o4 = "_inner_10imp_14", a4 = "_modalBody_10imp_18", l4 = "_stepProgressContainer_10imp_27", d4 = "_toggleButton_10imp_35", c4 = "_name_10imp_50", u4 = "_description_10imp_60", h4 = "_ringProgress_10imp_72", f4 = "_list_10imp_76", gs = {
  container: i4,
  inner: o4,
  modalBody: a4,
  stepProgressContainer: l4,
  toggleButton: d4,
  name: c4,
  description: u4,
  ringProgress: h4,
  list: f4
}, p4 = (e) => {
  const { opened: t, onClose: n, actionsProgresses: s } = e, r = Ve("(min-width: 768px)");
  return /* @__PURE__ */ i.jsx(
    Nn,
    {
      style: { display: "flex", alignItems: "center", justifyContent: "center", marginTop: 100 },
      classNames: { body: gs.modalBody, inner: gs.inner },
      radius: "lg",
      opened: t,
      onClose: n,
      size: ws(r ? 1e3 : 420),
      centered: !0,
      children: /* @__PURE__ */ i.jsx(E, { role: "list", className: gs.container, children: s.map((o) => /* @__PURE__ */ Mp(_4, { ...o, key: o.name })) })
    }
  );
}, _4 = (e) => {
  const { color: t, backgroundColor: n, progress: s, name: r, fullName: o, description: a, steps: l } = e, d = Ve("(min-width: 768px)"), [c, u] = O(!1), h = () => u((m) => !m), p = s === 0, f = Xr();
  return /* @__PURE__ */ i.jsxs(
    E,
    {
      role: "listItem",
      className: gs.stepProgressContainer,
      style: { borderBottomWidth: ws(0.5), borderBottomColor: t, borderBottomStyle: "solid" },
      children: [
        /* @__PURE__ */ i.jsxs(E, { direction: "row", align: "center", children: [
          /* @__PURE__ */ i.jsxs(
            Ee,
            {
              role: "switch",
              "aria-expanded": c,
              "aria-controls": f,
              "aria-label": "Toggle",
              onClick: h,
              className: gs.toggleButton,
              style: { "--svg-color": t },
              children: [
                /* @__PURE__ */ i.jsx(U, { name: "chevronRight" }),
                /* @__PURE__ */ i.jsx(ee, { order: 4, fontWeight: "400", className: gs.name, style: { color: t }, children: o ?? r })
              ]
            }
          ),
          /* @__PURE__ */ i.jsx(
            Xu,
            {
              className: gs.ringProgress,
              thickness: d ? 4.76 : 3.46,
              size: d ? 50 : 36,
              sections: [{ color: t, value: s }],
              rootColor: p ? "" : n
            }
          )
        ] }),
        /* @__PURE__ */ i.jsxs(Hr, { id: f, in: c, children: [
          /* @__PURE__ */ i.jsx(I, { className: gs.description, children: a }),
          /* @__PURE__ */ i.jsx(Be, { className: gs.list, children: l.map((m) => /* @__PURE__ */ i.jsx(Be.Item, { children: m.name }, m.id)) })
        ] })
      ]
    }
  );
}, m4 = "_container_4x44f_1", g4 = "_progressModalButton_4x44f_19", v4 = "_actionProgressContainer_4x44f_34", $4 = "_iconContainer_4x44f_39", b4 = "_notStartedIcon_4x44f_46", x4 = "_activeIcon_4x44f_64", y4 = "_completeIcon_4x44f_87", w4 = "_nameButton_4x44f_106", C4 = "_alertIcon_4x44f_132", j4 = "_yellowBatch_4x44f_149", Wn = {
  container: m4,
  progressModalButton: g4,
  actionProgressContainer: v4,
  iconContainer: $4,
  notStartedIcon: b4,
  activeIcon: x4,
  completeIcon: y4,
  nameButton: w4,
  alertIcon: C4,
  yellowBatch: j4
}, N4 = (e) => {
  const { actionsProgresses: t } = e, [n, s] = O(!1), r = () => s((a) => !a), o = t.find((a) => a.progress < 100);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(E, { className: Wn.container, children: [
      /* @__PURE__ */ i.jsx(E, { direction: "row", w: "100%", children: t.map((a) => /* @__PURE__ */ i.jsx(
        S4,
        {
          actionProgress: a,
          active: (o == null ? void 0 : o.name) === a.name
        },
        a.name
      )) }),
      /* @__PURE__ */ i.jsx(
        rl,
        {
          className: Wn.progressModalButton,
          "aria-label": "Open progress modal",
          onClick: r,
          children: /* @__PURE__ */ i.jsx(U, { name: "popUp" })
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(
      p4,
      {
        opened: n,
        onClose: () => s(!1),
        actionsProgresses: t
      }
    )
  ] });
}, S4 = (e) => {
  const { actionProgress: t, active: n } = e, { progress: s, name: r, backgroundColor: o, color: a, alertIcon: l, badgeType: d } = t, c = Ve("(min-width: 768px)"), [u, h] = O(!1), p = () => h((v) => !v), f = s === 0, m = s > 0 && s < 100, g = s > 99;
  return /* @__PURE__ */ i.jsxs(E, { className: Wn.actionProgressContainer, children: [
    /* @__PURE__ */ i.jsxs(E, { direction: "row", w: "100%", align: "center", children: [
      /* @__PURE__ */ i.jsx(
        Qu,
        {
          value: s,
          color: a,
          w: "100%",
          size: c ? 6 : 4,
          style: { backgroundColor: m ? o : gn.softGray }
        }
      ),
      /* @__PURE__ */ i.jsx("div", { className: Wn.yellowBatch, children: d === "yellow" && /* @__PURE__ */ i.jsx(U, { name: "yellowBatch" }) }),
      /* @__PURE__ */ i.jsx("div", { className: Wn.yellowBatch, children: d === "green" && /* @__PURE__ */ i.jsx(U, { name: "greenBatch" }) }),
      /* @__PURE__ */ i.jsxs(E, { className: Wn.iconContainer, children: [
        f && /* @__PURE__ */ i.jsx(E, { className: Wn.notStartedIcon, "aria-label": "Not started icon", children: /* @__PURE__ */ i.jsx(U, { name: "stepperProgressNotStarted" }) }),
        m && /* @__PURE__ */ i.jsx(
          E,
          {
            className: Wn.activeIcon,
            "aria-label": "Active icon",
            style: { "--svg-color": a },
            children: /* @__PURE__ */ i.jsx(U, { name: "stepperProgressActive" })
          }
        ),
        g && /* @__PURE__ */ i.jsx(
          E,
          {
            className: Wn.completeIcon,
            "aria-label": "Completed icon",
            style: { "--svg-color": a },
            children: /* @__PURE__ */ i.jsx(U, { name: "stepperProgressCompleted" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ i.jsx(
      Ee,
      {
        "aria-label": `View progress of ${r}`,
        className: Wn.nameButton,
        "data-active": n,
        onClick: p,
        children: r
      }
    ),
    (l == null ? void 0 : l.showAlert) && /* @__PURE__ */ i.jsx(
      Ee,
      {
        "aria-label": "Upload documents",
        className: Wn.alertIcon,
        style: { right: c ? l.cssRight.desktop : l.cssRight.mobile },
        children: /* @__PURE__ */ i.jsx(U, { name: "kickbackAlert" })
      }
    ),
    /* @__PURE__ */ i.jsx(
      r4,
      {
        opened: u,
        onClose: () => h(!1),
        actionProgress: t
      }
    )
  ] });
}, k4 = "_card_gen4n_1", E4 = "_cardContentContainer_gen4n_15", I4 = "_workingOnText_gen4n_27", P4 = "_currentActionTitle_gen4n_39", T4 = "_list_gen4n_49", R4 = "_listItem_gen4n_63", L4 = "_listItemName_gen4n_91", O4 = "_listItemValue_gen4n_101", F4 = "_applicationDetailsButton_gen4n_111", Ct = {
  card: k4,
  cardContentContainer: E4,
  workingOnText: I4,
  currentActionTitle: P4,
  list: T4,
  listItem: R4,
  listItemName: L4,
  listItemValue: O4,
  applicationDetailsButton: F4
}, fR = (e) => {
  const {
    actionsProgresses: t,
    onApplicationDetails: n,
    appId: s,
    AYPeriod: r,
    loanAmount: o,
    university: a,
    workingOn: l,
    appStartDateRefi: d,
    applicationDetailsButtonLabel: c,
    className: u,
    workingOnColor: h
  } = e, p = Ve("(min-width: 768px)"), f = t.find(
    (m) => m.progress < 100
  );
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(cn, { className: R(Ct.card, u), children: [
    /* @__PURE__ */ i.jsxs(E, { className: Ct.cardContentContainer, children: [
      /* @__PURE__ */ i.jsxs(E, { direction: "row", align: "flex-end", gap: ws(p ? 24 : 20), children: [
        /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
          /* @__PURE__ */ i.jsx(I, { transform: "uppercase", weight: "400", className: Ct.workingOnText, children: "You're working on" }),
          /* @__PURE__ */ i.jsx(
            ee,
            {
              fontWeight: "700",
              className: Ct.currentActionTitle,
              style: { color: h || (f == null ? void 0 : f.color) },
              order: 3,
              children: l
            }
          )
        ] }),
        p && /* @__PURE__ */ i.jsx(
          Ee,
          {
            onClick: n,
            className: Ct.applicationDetailsButton,
            children: c
          }
        )
      ] }),
      /* @__PURE__ */ i.jsx(Vn, {}),
      /* @__PURE__ */ i.jsxs(Be, { className: Ct.list, children: [
        a && /* @__PURE__ */ i.jsxs(Be.Item, { className: Ct.listItem, children: [
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemName, children: "School:" }),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemValue, children: a })
        ] }),
        s && /* @__PURE__ */ i.jsxs(Be.Item, { className: Ct.listItem, children: [
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemName, children: "App ID:" }),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemValue, children: s })
        ] }),
        r && /* @__PURE__ */ i.jsxs(Be.Item, { className: Ct.listItem, children: [
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemName, children: "AY Period:" }),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemValue, children: r })
        ] }),
        d && /* @__PURE__ */ i.jsxs(Be.Item, { className: Ct.listItem, children: [
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemName, children: "App start date:" }),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemValue, children: Re(d).format("MM/DD/YYYY") })
        ] }),
        o && /* @__PURE__ */ i.jsxs(Be.Item, { className: Ct.listItem, children: [
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemName, children: "Loan Amount:" }),
          /* @__PURE__ */ i.jsx(I, { span: !0, className: Ct.listItemValue, children: Je(o) })
        ] })
      ] }),
      !p && /* @__PURE__ */ i.jsx(
        Ee,
        {
          onClick: n,
          className: Ct.applicationDetailsButton,
          children: c
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(N4, { actionsProgresses: t })
  ] }) });
}, A4 = "_card_1vszw_1", M4 = "_title_1vszw_23", D4 = "_text_1vszw_30", Qa = {
  card: A4,
  title: M4,
  text: D4
}, B4 = (e) => {
  const { title: t, text: n, className: s } = e;
  return /* @__PURE__ */ i.jsxs(cn, { className: R(Qa.card, s), children: [
    /* @__PURE__ */ i.jsx(ee, { fontWeight: "700", order: 4, className: Qa.title, children: t }),
    /* @__PURE__ */ i.jsx(I, { component: "p", className: Qa.text, children: n })
  ] });
}, W4 = "_container_17o16_1", U4 = "_button_17o16_13", Uu = {
  container: W4,
  button: U4
}, Sd = (e) => {
  const { children: t, name: n, collapseClassName: s } = e, r = Xr(), [o, a] = O(!1), l = () => a((d) => !d);
  return /* @__PURE__ */ i.jsxs(E, { className: Uu.container, children: [
    /* @__PURE__ */ i.jsxs(
      Ee,
      {
        role: "switch",
        "aria-expanded": o,
        "aria-controls": r,
        "aria-label": "Toggle",
        onClick: l,
        className: Uu.button,
        children: [
          /* @__PURE__ */ i.jsx(U, { name: "chevronRight" }),
          n
        ]
      }
    ),
    /* @__PURE__ */ i.jsx(Hr, { id: r, in: o, className: s, children: t })
  ] });
}, z4 = "_table_icdxw_1", H4 = {
  table: z4
}, pR = (e) => {
  const { disbursementSchedules: t } = e;
  return /* @__PURE__ */ i.jsx(Sd, { name: "Disbursement schedule", children: /* @__PURE__ */ i.jsxs(Kl, { className: H4.table, children: [
    /* @__PURE__ */ i.jsxs("colgroup", { children: [
      /* @__PURE__ */ i.jsx("col", { span: 1 }),
      /* @__PURE__ */ i.jsx("col", { span: 1 }),
      /* @__PURE__ */ i.jsx("col", { span: 1 })
    ] }),
    /* @__PURE__ */ i.jsx("thead", { children: /* @__PURE__ */ i.jsxs("tr", { children: [
      /* @__PURE__ */ i.jsx("th", {}),
      /* @__PURE__ */ i.jsx("th", { children: "Amount" }),
      /* @__PURE__ */ i.jsx("th", { children: "Disbursement Day" })
    ] }) }),
    /* @__PURE__ */ i.jsx("tbody", { children: t.map((n) => /* @__PURE__ */ i.jsxs("tr", { children: [
      /* @__PURE__ */ i.jsx(
        "td",
        {
          "aria-label": n.disbursement_status_code === "D" ? "Paid out" : "Not paid out",
          children: n.disbursement_status_code === "D" ? /* @__PURE__ */ i.jsx(U, { name: "paidOut" }) : /* @__PURE__ */ i.jsx(U, { name: "notPaidOut" })
        }
      ),
      /* @__PURE__ */ i.jsx("td", { children: Je(n.net_disbursement_amount) }),
      /* @__PURE__ */ i.jsx("td", { children: n != null && n.projected_disbursement_date ? Re(n == null ? void 0 : n.projected_disbursement_date).format("MMMM D YYYY") : "--" })
    ] }, n.disbursement_id)) })
  ] }) });
}, q4 = "_list_yx6qs_1", G4 = "_listItem_yx6qs_7", V4 = "_listItemText_yx6qs_14", Y4 = "_collapse_yx6qs_26", _o = {
  list: q4,
  listItem: G4,
  listItemText: V4,
  collapse: Y4
}, _R = (e) => {
  const { loanDocuments: t } = e;
  return /* @__PURE__ */ i.jsx(Sd, { name: "Loan documents", collapseClassName: _o.collapse, children: /* @__PURE__ */ i.jsx(E, { role: "list", className: _o.list, children: t == null ? void 0 : t.map((n) => (n == null ? void 0 : n.link) && /* @__PURE__ */ i.jsxs(E, { className: _o.listItem, role: "listItem", children: [
    /* @__PURE__ */ i.jsx(I, { span: !0, weight: "400", className: _o.listItemText, children: n == null ? void 0 : n.displayName }),
    /* @__PURE__ */ i.jsx(on, { href: n == null ? void 0 : n.link, target: "_blank", children: /* @__PURE__ */ i.jsx(U, { name: "view" }) })
  ] })) }) });
}, K4 = "_title_1v5ix_1", J4 = "_description_1v5ix_11", Z4 = "_list_1v5ix_23", X4 = "_listItem_1v5ix_30", Q4 = "_listItemName_1v5ix_35", ew = "_listItemProgress_1v5ix_47", tw = "_collapse_1v5ix_59", tr = {
  title: K4,
  description: J4,
  list: Z4,
  listItem: X4,
  listItemName: Q4,
  listItemProgress: ew,
  collapse: tw
}, mR = (e) => {
  const { applicationDetails: t } = e;
  return /* @__PURE__ */ i.jsx(Sd, { name: "Application details", collapseClassName: tr.collapse, children: /* @__PURE__ */ i.jsxs(E, { direction: "column", gap: ws(30), children: [
    /* @__PURE__ */ i.jsxs(E, { direction: "column", gap: ws(6), children: [
      /* @__PURE__ */ i.jsx(ee, { className: tr.title, variant: "yellow", fontWeight: "700", order: 4, children: "Application data" }),
      /* @__PURE__ */ i.jsx(I, { component: "p", className: tr.description, children: "View the status of your loan application." })
    ] }),
    /* @__PURE__ */ i.jsx(Be, { className: tr.list, children: t.map((n) => /* @__PURE__ */ i.jsxs(Be.Item, { className: tr.listItem, children: [
      /* @__PURE__ */ i.jsx(I, { span: !0, className: tr.listItemName, children: n.name }),
      /* @__PURE__ */ i.jsxs(I, { span: !0, className: tr.listItemProgress, children: [
        n.progress,
        "%"
      ] })
    ] }, n.id)) })
  ] }) });
}, nw = "_container_zx1ih_1", sw = "_headerContainer_zx1ih_10", rw = "_title_zx1ih_17", iw = "_toggleButton_zx1ih_29", ow = "_activitiesList_zx1ih_49", aw = "_activityItem_zx1ih_53", lw = "_activityName_zx1ih_83", dw = "_activityStatus_zx1ih_99", cw = "_activityStatusInProgress_zx1ih_119", uw = "_activityStatusRejected_zx1ih_127", hw = "_activityStatusComplete_zx1ih_135", fw = "_activityStatusVerified_zx1ih_136", pw = "_documents_zx1ih_145", _w = "_documentsIcon_zx1ih_170", mw = "_viewMoreContainer_zx1ih_176", gw = "_inner_zx1ih_186", Ut = {
  container: nw,
  headerContainer: sw,
  title: rw,
  toggleButton: iw,
  activitiesList: ow,
  activityItem: aw,
  activityName: lw,
  activityStatus: dw,
  activityStatusInProgress: cw,
  activityStatusRejected: uw,
  activityStatusComplete: hw,
  activityStatusVerified: fw,
  documents: pw,
  documentsIcon: _w,
  viewMoreContainer: mw,
  inner: gw
}, vw = {
  "In Progress": "In review",
  Rejected: "Mismatch",
  Complete: "Complete",
  Verified: "Verified"
}, el = 3, gR = ({
  recentActivities: e = [],
  className: t = ""
}) => {
  const n = Xr(), [s, r] = O(!1), [o, a] = O(el), l = () => r((h) => !h), d = () => {
    a(e == null ? void 0 : e.length);
  }, c = () => {
    a(el), l();
  };
  ne(() => {
    a(el);
  }, [e]);
  const u = (h = []) => h.length ? /* @__PURE__ */ i.jsxs(I, { component: "p", className: Ut.documents, children: [
    /* @__PURE__ */ i.jsx(U, { name: "popUp", className: Ut.documentsIcon }),
    h.map((p) => /* @__PURE__ */ i.jsx(on, { href: p.href, children: p.name }, p.href))
  ] }) : null;
  return !e || !e.length ? null : /* @__PURE__ */ i.jsxs(E, { className: R(Ut.container, t), "data-testid": "activity-list", children: [
    /* @__PURE__ */ i.jsxs(E, { className: Ut.headerContainer, children: [
      /* @__PURE__ */ i.jsx(ee, { order: 3, fontWeight: "700", className: Ut.title, children: "Recent activity" }),
      /* @__PURE__ */ i.jsxs(
        Ee,
        {
          role: "switch",
          "aria-expanded": s,
          "aria-controls": n,
          "aria-label": "Toggle",
          onClick: s ? c : l,
          className: Ut.toggleButton,
          children: [
            /* @__PURE__ */ i.jsx(I, { span: !0, children: s ? "Collapse" : "Expand" }),
            /* @__PURE__ */ i.jsx(I, { span: !0, "aria-hidden": !0, children: s ? " -" : " +" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs(Hr, { id: n, in: s, children: [
      /* @__PURE__ */ i.jsx(E, { role: "list", className: Ut.activitiesList, children: e.filter((h) => h && Object.keys(h).length > 0).slice(0, o).map((h) => {
        const p = R(
          Ut.activityStatus,
          h.status === "In Progress" && Ut.activityStatusInProgress,
          h.status === "Rejected" && Ut.activityStatusRejected,
          h.status === "Complete" && Ut.activityStatusComplete,
          h.status === "Verified" && Ut.activityStatusVerified
        );
        return /* @__PURE__ */ i.jsxs(
          T,
          {
            role: "listitem",
            className: Ut.activityItem,
            classNames: { inner: Ut.inner },
            children: [
              /* @__PURE__ */ i.jsx(I, { span: !0, className: Ut.activityName, children: h.label }),
              u(h.documents),
              /* @__PURE__ */ i.jsx(I, { span: !0, className: p, children: vw[h.status] })
            ]
          },
          h.action
        );
      }) }),
      o < (e == null ? void 0 : e.length) && /* @__PURE__ */ i.jsx("div", { className: Ut.viewMoreContainer, children: /* @__PURE__ */ i.jsx(Ee, { onClick: d, className: Ut.toggleButton, children: /* @__PURE__ */ i.jsx(I, { span: !0, children: "View More" }) }) })
    ] })
  ] });
}, $w = "_container_1eqlc_1", bw = "_title_1eqlc_18", xw = "_infoText_1eqlc_34", yw = "_action_1eqlc_51", ww = "_spacing50_1eqlc_68", Cw = "_inner_1eqlc_72", jw = "_root_1eqlc_77", Nw = "_buttonWrapper_1eqlc_81", nr = {
  container: $w,
  title: bw,
  infoText: xw,
  action: yw,
  spacing50: ww,
  inner: Cw,
  root: jw,
  buttonWrapper: Nw
}, Sw = (e) => {
  const { name: t, actionName: n, onAction: s, infoText: r } = e;
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    r && /* @__PURE__ */ i.jsx("div", { className: nr.infoText, dangerouslySetInnerHTML: { __html: r } }),
    t && /* @__PURE__ */ i.jsx(E, { className: nr.container, role: "", children: /* @__PURE__ */ i.jsxs(T, { classNames: { inner: nr.inner, root: nr.root }, children: [
      /* @__PURE__ */ i.jsx(T.Col, { span: { base: n ? 6 : 12, xs: n ? 8 : 12 }, children: /* @__PURE__ */ i.jsx(ee, { order: 4, fontWeight: "700", className: nr.title, children: t }) }),
      n && s && /* @__PURE__ */ i.jsx(T.Col, { span: { base: 6, xs: 4 }, p: 0, children: /* @__PURE__ */ i.jsx(E, { className: nr.buttonWrapper, children: /* @__PURE__ */ i.jsx(Jt, { className: nr.action, onClick: s, children: n }) }) })
    ] }) })
  ] });
}, kw = "_errorMessage_8us48_1", Ew = "_confirmText_8us48_5", Iw = "_error_8us48_1", Pw = "_dobInputStyle_8us48_18", Tw = "_dobInputOptionsStyle_8us48_32", Rw = "_mantine-ScrollArea-root_8us48_45", Lw = "_dobInputSelectionStyle_8us48_58", Ow = "_dobInputLabels_8us48_62", Fw = "_wrapper_8us48_66", Aw = "_option_8us48_71", as = {
  errorMessage: kw,
  confirmText: Ew,
  error: Iw,
  dobInputStyle: Pw,
  dobInputOptionsStyle: Tw,
  "mantine-ScrollArea-root": "_mantine-ScrollArea-root_8us48_45",
  mantineScrollAreaRoot: Rw,
  dobInputSelectionStyle: Lw,
  dobInputLabels: Ow,
  wrapper: Fw,
  option: Aw
};
var So = { exports: {} }, Mw = So.exports, zu;
function Dw() {
  return zu || (zu = 1, function(e, t) {
    (function(n, s) {
      e.exports = s();
    })(Mw, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, s = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, o = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, l = {}, d = function(g) {
        return (g = +g) + (g > 68 ? 1900 : 2e3);
      }, c = function(g) {
        return function(v) {
          this[g] = +v;
        };
      }, u = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
        (this.zone || (this.zone = {})).offset = function(v) {
          if (!v || v === "Z") return 0;
          var _ = v.match(/([+-]|\d\d)/g), $ = 60 * _[1] + (+_[2] || 0);
          return $ === 0 ? 0 : _[0] === "+" ? -$ : $;
        }(g);
      }], h = function(g) {
        var v = l[g];
        return v && (v.indexOf ? v : v.s.concat(v.f));
      }, p = function(g, v) {
        var _, $ = l.meridiem;
        if ($) {
          for (var y = 1; y <= 24; y += 1) if (g.indexOf($(y, 0, v)) > -1) {
            _ = y > 12;
            break;
          }
        } else _ = g === (v ? "pm" : "PM");
        return _;
      }, f = { A: [a, function(g) {
        this.afternoon = p(g, !1);
      }], a: [a, function(g) {
        this.afternoon = p(g, !0);
      }], S: [/\d/, function(g) {
        this.milliseconds = 100 * +g;
      }], SS: [r, function(g) {
        this.milliseconds = 10 * +g;
      }], SSS: [/\d{3}/, function(g) {
        this.milliseconds = +g;
      }], s: [o, c("seconds")], ss: [o, c("seconds")], m: [o, c("minutes")], mm: [o, c("minutes")], H: [o, c("hours")], h: [o, c("hours")], HH: [o, c("hours")], hh: [o, c("hours")], D: [o, c("day")], DD: [r, c("day")], Do: [a, function(g) {
        var v = l.ordinal, _ = g.match(/\d+/);
        if (this.day = _[0], v) for (var $ = 1; $ <= 31; $ += 1) v($).replace(/\[|\]/g, "") === g && (this.day = $);
      }], M: [o, c("month")], MM: [r, c("month")], MMM: [a, function(g) {
        var v = h("months"), _ = (h("monthsShort") || v.map(function($) {
          return $.slice(0, 3);
        })).indexOf(g) + 1;
        if (_ < 1) throw new Error();
        this.month = _ % 12 || _;
      }], MMMM: [a, function(g) {
        var v = h("months").indexOf(g) + 1;
        if (v < 1) throw new Error();
        this.month = v % 12 || v;
      }], Y: [/[+-]?\d+/, c("year")], YY: [r, function(g) {
        this.year = d(g);
      }], YYYY: [/\d{4}/, c("year")], Z: u, ZZ: u };
      function m(g) {
        var v, _;
        v = g, _ = l && l.formats;
        for (var $ = (g = v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(S, F, W) {
          var D = W && W.toUpperCase();
          return F || _[W] || n[W] || _[D].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(B, q, G) {
            return q || G.slice(1);
          });
        })).match(s), y = $.length, P = 0; P < y; P += 1) {
          var j = $[P], b = f[j], N = b && b[0], C = b && b[1];
          $[P] = C ? { regex: N, parser: C } : j.replace(/^\[|\]$/g, "");
        }
        return function(S) {
          for (var F = {}, W = 0, D = 0; W < y; W += 1) {
            var B = $[W];
            if (typeof B == "string") D += B.length;
            else {
              var q = B.regex, G = B.parser, z = S.slice(D), re = q.exec(z)[0];
              G.call(F, re), S = S.replace(re, "");
            }
          }
          return function(X) {
            var Q = X.afternoon;
            if (Q !== void 0) {
              var M = X.hours;
              Q ? M < 12 && (X.hours += 12) : M === 12 && (X.hours = 0), delete X.afternoon;
            }
          }(F), F;
        };
      }
      return function(g, v, _) {
        _.p.customParseFormat = !0, g && g.parseTwoDigitYear && (d = g.parseTwoDigitYear);
        var $ = v.prototype, y = $.parse;
        $.parse = function(P) {
          var j = P.date, b = P.utc, N = P.args;
          this.$u = b;
          var C = N[1];
          if (typeof C == "string") {
            var S = N[2] === !0, F = N[3] === !0, W = S || F, D = N[2];
            F && (D = N[2]), l = this.$locale(), !S && D && (l = _.Ls[D]), this.$d = function(z, re, X) {
              try {
                if (["x", "X"].indexOf(re) > -1) return new Date((re === "X" ? 1e3 : 1) * z);
                var Q = m(re)(z), M = Q.year, he = Q.month, le = Q.day, ce = Q.hours, we = Q.minutes, ue = Q.seconds, pe = Q.milliseconds, Pe = Q.zone, Y = /* @__PURE__ */ new Date(), ie = le || (M || he ? 1 : Y.getDate()), ve = M || Y.getFullYear(), Ue = 0;
                M && !he || (Ue = he > 0 ? he - 1 : Y.getMonth());
                var ze = ce || 0, He = we || 0, ft = ue || 0, et = pe || 0;
                return Pe ? new Date(Date.UTC(ve, Ue, ie, ze, He, ft, et + 60 * Pe.offset * 1e3)) : X ? new Date(Date.UTC(ve, Ue, ie, ze, He, ft, et)) : new Date(ve, Ue, ie, ze, He, ft, et);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(j, C, b), this.init(), D && D !== !0 && (this.$L = this.locale(D).$L), W && j != this.format(C) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
          } else if (C instanceof Array) for (var B = C.length, q = 1; q <= B; q += 1) {
            N[1] = C[q - 1];
            var G = _.apply(this, N);
            if (G.isValid()) {
              this.$d = G.$d, this.$L = G.$L, this.init();
              break;
            }
            q === B && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else y.call(this, P);
        };
      };
    });
  }(So)), So.exports;
}
var Bw = Dw();
const Ww = /* @__PURE__ */ t_(Bw), kd = (e, t) => Number(e) && t[Number(e) - 1] ? t[Number(e) - 1] : !1, Yo = (e, t, n) => {
  const s = [], r = n ? t : e, o = n ? e : t, a = n ? -1 : 1;
  for (let l = r; n ? l >= o : l <= o; l += a)
    s.push(JSON.stringify(l));
  return s;
}, $p = (e) => !isNaN(new Date(e).getTime()), Uw = (e, t) => {
  if (!$p(e) || e === null || e === void 0 || (typeof e != "string" && (e = e == null ? void 0 : e.toString()), (e == null ? void 0 : e.trim()) === ""))
    return null;
  if (e) {
    const n = new Date(e), s = n == null ? void 0 : n.getFullYear(), r = Number(String(n == null ? void 0 : n.getMonth()).padStart(2, "0")) + 1, o = String(n == null ? void 0 : n.getDate()).padStart(2, "0"), a = `${r}/${o}/${s}`;
    if (Re(e).isValid()) {
      const l = new Date(a);
      return Re(l).format("YYYY-MM-DD");
    } else {
      Re.extend(Ww);
      const l = new Date(a);
      return Re(l).format("YYYY-MM-DD");
    }
  } else
    return null;
}, zw = (e, t, n = !0) => {
  var o;
  const s = t || ((o = /* @__PURE__ */ new Date()) == null ? void 0 : o.getFullYear()) + 1;
  return Yo(e, s, n);
}, Hw = (e, t) => {
  const { day: n, year: s, month: r } = e || {};
  if (n && s && r) {
    const o = kd(r, t) || r, a = t.indexOf(o) + 1, l = a > 9 ? a.toString() : `0${a}`, d = `${s}-${l}-${n}`;
    return new Date(d);
  }
  return null;
}, qw = (e, t) => {
  var n;
  return (n = new Date(e, t, 0)) == null ? void 0 : n.getDate();
}, Gw = (e, t, n) => {
  const { day: s, year: r, month: o } = e || {}, a = kd(o, n) || o, l = t.includes(r) && n.includes(a);
  if (r && a && l) {
    const d = r ?? (/* @__PURE__ */ new Date()).getFullYear(), c = n.indexOf(a) + 1 || (/* @__PURE__ */ new Date()).getMonth(), u = qw(d, c);
    let h = Yo(1, u, !1);
    const p = (/* @__PURE__ */ new Date()).getFullYear() - 18, f = n[(/* @__PURE__ */ new Date()).getMonth()], m = (/* @__PURE__ */ new Date()).getDate();
    return p.toString() === r && f.toString() === a && (h = Yo(1, m, !1)), h;
  }
  return !1;
}, Hu = (e) => {
  var o;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(e)) return null;
  const [t, n, s] = (o = e == null ? void 0 : e.split("-")) == null ? void 0 : o.map(Number);
  return new Date(t, n - 1, s);
}, Vw = ({ ...e }) => {
  var Ye, Mt, Zt, kt, fe, tt, pt, nt, yt;
  const {
    monthsName: t,
    selectedDate: n,
    customCallbackFn: s,
    incomingDetails: r = {},
    label: o,
    errors: a,
    currentYear: l,
    id: d,
    startYear: c = 1924,
    customClass: u,
    isDesending: h = !0,
    disabled: p = !1
  } = e || {}, { visaInterviewDate: f = "" } = r || {}, m = r && $p(Hu(f)) ? Hu(f) : !1, [g, v] = O(), [_, $] = O({
    day: m ? (Ye = m == null ? void 0 : m.getDate()) == null ? void 0 : Ye.toString() : "",
    year: m ? (Mt = m == null ? void 0 : m.getFullYear()) == null ? void 0 : Mt.toString() : "",
    month: m ? t[m == null ? void 0 : m.getMonth()] : ""
  }), [y, P] = O(a);
  ne(() => {
    P(a);
  }, [a]);
  const j = t, [b, N] = O(j), C = kd(_ == null ? void 0 : _.month, t) || (_ == null ? void 0 : _.month), S = (j == null ? void 0 : j.indexOf(C)) + 1, F = S > 9 ? S : "0" + S, W = (Zt = String(_ == null ? void 0 : _.day)) == null ? void 0 : Zt.padStart(2, "0"), D = `${_ == null ? void 0 : _.year}-${F}-${W}`, [B, q] = O(Yo(1, 31, !1)), [G, z] = O([]), [re, X] = O(""), Q = (Z, Le, _t) => {
    Z != null && Z.month && (Z != null && Z.day) && !(_t != null && _t.includes(Z == null ? void 0 : Z.day)) && Le((Dt) => ({
      ...Dt,
      day: ""
    }));
  };
  ne(() => {
    const Z = s == null ? void 0 : s(_, re);
    P(Z), (() => {
      var Yn, rs;
      const _t = zw(c, l, h), Dt = Gw(_, G, j), tn = Hw(_, j);
      N(j), _t && z(_t), Dt && q(Dt), tn && v(Uw(tn));
      const $n = (/* @__PURE__ */ new Date()).getMonth() + 1, Sn = (/* @__PURE__ */ new Date()).getFullYear();
      if (((Yn = _ == null ? void 0 : _.year) == null ? void 0 : Yn.toString()) === Sn.toString()) {
        const J = (j == null ? void 0 : j.slice(0, $n)) || j;
        N(J);
      }
      if (c.toString() === Sn.toString() && ((rs = _ == null ? void 0 : _.year) == null ? void 0 : rs.toString()) === Sn.toString()) {
        const J = (j == null ? void 0 : j.slice($n, j == null ? void 0 : j.length)) || j;
        N(J);
      }
      Q(_, $, Dt || B);
    })();
  }, [_ == null ? void 0 : _.day, _ == null ? void 0 : _.year, _ == null ? void 0 : _.month]);
  const M = (Z) => {
    const Le = document.getElementById(Z);
    return document.activeElement === Le;
  }, he = ni((Z, Le) => {
    $((_t) => ({
      ..._t,
      [Z]: Le
    }));
  }, []), le = ni(
    (Z, Le, _t) => {
      if (M(Z))
        return he(_t, Le);
    },
    [he]
  ), ce = (Z) => /^\d+$/.test(Z), we = (Z) => /^[a-zA-Z0-9]+$/.test(Z), ue = (Z) => {
    (!(Z != null && Z.length) || ce(Z) && (Z == null ? void 0 : Z.length) < 3 && (B == null ? void 0 : B.includes(Z))) && le("dobDayField", Z, "day");
  }, pe = ni(
    (Z) => {
      var Dt;
      const Le = ((Dt = Z == null ? void 0 : Z.charAt(0)) == null ? void 0 : Dt.toUpperCase()) + (Z == null ? void 0 : Z.slice(1));
      (!(Z != null && Z.length) || we(Z)) && le("dobMonthField", Le, "month");
    },
    [le]
  ), Pe = ni(
    (Z) => {
      (!(Z != null && Z.length) || ce(Z)) && (Z == null ? void 0 : Z.length) < 5 && le("dobYearField", Z, "year");
    },
    [le]
  ), Y = (Z, Le = "") => {
    const _t = Le.toLowerCase().trim().split(" ");
    return Z.filter((Dt) => {
      const tn = Dt.label.toLowerCase().trim().split(" ");
      return _t.every(
        (Sn) => tn.some((Yn) => Yn.includes(Sn))
      );
    });
  }, ie = ({ options: Z = [], search: Le = "" }) => Y(Z, _ == null ? void 0 : _.month), ve = ({ options: Z = [], search: Le = "" }) => Y(Z, _ == null ? void 0 : _.day), Ue = ({ options: Z = [], search: Le = "" }) => Y(Z, _ == null ? void 0 : _.year), ze = {
    dobYearField: {
      data: G,
      searchValue: _ == null ? void 0 : _.year,
      onSearchChange: Pe,
      error: (fe = (kt = y == null ? void 0 : y.fieldErrors) == null ? void 0 : kt.dobYearField) == null ? void 0 : fe[0],
      filter: (G == null ? void 0 : G.length) && Ue
    },
    dobMonthField: {
      data: b,
      searchValue: _ == null ? void 0 : _.month,
      onSearchChange: pe,
      error: (pt = (tt = y == null ? void 0 : y.fieldErrors) == null ? void 0 : tt.dobMonthField) == null ? void 0 : pt[0],
      filter: (j == null ? void 0 : j.length) && ie
    },
    dobDayField: {
      data: B,
      searchValue: _ == null ? void 0 : _.day,
      onSearchChange: ue,
      error: (yt = (nt = y == null ? void 0 : y.fieldErrors) == null ? void 0 : nt.dobDayField) == null ? void 0 : yt[0],
      filter: (B == null ? void 0 : B.length) && ve
    }
  }, He = [
    {
      label: "Year",
      id: "dobYearField",
      name: "dobYearField",
      placeholder: "Type year",
      nothingFoundMessage: "Provide valid year"
    },
    {
      label: "Month",
      id: "dobMonthField",
      name: "dobMonthField",
      placeholder: "Type month",
      nothingFoundMessage: "Provide valid month"
    },
    {
      label: "Day",
      id: "dobDayField",
      name: "dobDayField",
      placeholder: "Type day",
      nothingFoundMessage: "Provide valid day"
    }
  ], ft = He == null ? void 0 : He.map((Z) => ({
    ...Z,
    ...ze[Z == null ? void 0 : Z.id]
  })), et = ni(
    ({
      label: Z = "",
      id: Le = "",
      name: _t = "",
      placeholder: Dt = "",
      data: tn = [],
      searchValue: $n = "",
      onSearchChange: Sn = () => !1,
      error: Yn = "",
      filter: rs = null
    }) => /* @__PURE__ */ i.jsxs(T.Col, { span: 4, children: [
      /* @__PURE__ */ i.jsx(
        Vl,
        {
          label: Z,
          id: Le,
          name: _t,
          placeholder: Dt,
          data: tn,
          searchable: !0,
          searchValue: $n,
          value: $n,
          onChange: Sn,
          onSearchChange: Sn,
          error: Yn,
          withScrollArea: !1,
          styles: { dropdown: { maxHeight: 200, overflowY: "auto" } },
          comboboxProps: { transitionProps: { transition: "pop", duration: 200 } },
          disabled: p,
          classNames: {
            input: as.dobInputStyle,
            dropdown: as.dobInputOptionsStyle,
            section: as.dobInputSelectionStyle,
            label: R(as.dobInputLabels, u == null ? void 0 : u.label),
            wrapper: as.wrapper,
            option: R(as.option, u == null ? void 0 : u.option)
          },
          checkIconPosition: "right",
          filter: rs,
          allowDeselect: !1
        }
      ),
      /* @__PURE__ */ i.jsx("input", { type: "hidden", id: Le, name: Le, value: $n })
    ] }, Le),
    []
  );
  return /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
    /* @__PURE__ */ i.jsx(Ce, { size: "md", fw: 700, children: o }),
    /* @__PURE__ */ i.jsxs(T, { children: [
      ft.map(et),
      /* @__PURE__ */ i.jsx(
        "input",
        {
          type: "hidden",
          id: d || "dateOfBirth",
          name: d || "dateOfBirth",
          value: D
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(Ce, { size: "xs", fw: 400, c: "red", classNames: { root: as == null ? void 0 : as.errorMessage }, children: re })
  ] });
}, Yw = "_block_1djt1_1", Kw = "_control_1djt1_10", Jw = "_accordion_1djt1_14", Zw = "_header_1djt1_21", Xw = "_radioblock_1djt1_35", Qw = "_radioboxWrap_1djt1_47", e9 = "_headerFlex_1djt1_60", t9 = "_uploadButton_1djt1_73", n9 = "_buttonFlex_1djt1_77", s9 = "_controlClass_1djt1_82", r9 = "_content_1djt1_87", i9 = "_chevron_1djt1_91", o9 = "_headerMobile_1djt1_95", a9 = "_alert_1djt1_109", l9 = "_alertIcon_1djt1_113", d9 = "_action_1djt1_117", c9 = "_accordionItem_1djt1_121", u9 = "_confirmationNumber_1djt1_125", h9 = "_consulateDetailWrap_1djt1_130", f9 = "_consulateLabel_1djt1_136", p9 = "_fieldColumn_1djt1_152", _9 = "_consulateLocation_1djt1_168", rt = {
  block: Yw,
  control: Kw,
  accordion: Jw,
  header: Zw,
  radioblock: Xw,
  radioboxWrap: Qw,
  headerFlex: e9,
  uploadButton: t9,
  buttonFlex: n9,
  controlClass: s9,
  content: r9,
  chevron: i9,
  headerMobile: o9,
  alert: a9,
  alertIcon: l9,
  action: d9,
  accordionItem: c9,
  confirmationNumber: u9,
  consulateDetailWrap: h9,
  consulateLabel: f9,
  fieldColumn: p9,
  consulateLocation: _9
}, m9 = ({
  selctedVisaStatus: e,
  isSubmitting: t,
  applicationCountry: n,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  visaStatusSubmit: s = (u, h) => {
  },
  monthsName: r,
  selectedDate: o,
  visaInterviewDetails: a,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getUserSearchedConsulate: l = (u, h) => {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getVisaInterviewDate: d = (u, h) => {
  },
  incomingConsulateData: c
}) => {
  var pe, Pe;
  const [u, h] = O(e || ""), [p, f] = O(!0), [m, g] = O({
    day: "",
    year: "",
    month: ""
  }), [v, _] = O(""), [$, y] = O({ fieldErrors: {} }), [P, j] = O({ fieldErrors: {} }), [b, N] = O(
    !!e
  ), [C, S] = O({
    consulateNumber: (a == null ? void 0 : a.ds160_info) || "",
    consulateLocation: (a == null ? void 0 : a.consulate_location) || ""
  }), F = u === ((pe = Ys == null ? void 0 : Ys.scheduled) == null ? void 0 : pe.value), [W, D] = O(a == null ? void 0 : a.consulate_location), [B, q] = O(!1), [G] = Qp(W, 500), z = () => {
    const Y = r.map((He) => He.toLowerCase()).includes(m.month.toLowerCase()), ie = (/* @__PURE__ */ new Date()).getFullYear(), Ue = Array.from({ length: 11 }, (He, ft) => ie - 5 + ft).map((He) => He.toString()).includes(m.year), ze = !m.day && !m.month && !m.year || m.day && m.month && m.year && Y && Ue;
    return (u == null ? void 0 : u.length) && ze && !v.length;
  };
  ne(() => {
    const Y = F ? X(u) : !0;
    z() && Y ? (f(!1), N(!1)) : (f(!0), N(!0));
  }, [m, u, v, r, C, W]);
  const re = (Y, ie) => {
    g(Y), _(ie), d(Y);
  }, X = (Y) => {
    var He, ft;
    const ie = Y === ((He = Ys == null ? void 0 : Ys.scheduled) == null ? void 0 : He.value) || F, ve = (c == null ? void 0 : c.some((et) => (et == null ? void 0 : et.id) === W)) ?? !1, Ue = ((ft = C == null ? void 0 : C.consulateNumber) == null ? void 0 : ft.length) === 10 && ve || !C.consulateNumber && !ve;
    return ie && Ue;
  }, Q = (Y) => {
    Y !== e && z() && (!F || X(Y)) ? (f(!1), N(!1)) : (f(!0), N(!0)), h(Y);
  }, M = () => {
    s(u, JSON.stringify(C));
  }, he = (Y) => {
    const ie = /^[a-zA-Z0-9]*$/, ve = Y.target.value, Ue = { fieldErrors: {} };
    ie.test(ve) && (S((ze) => ({
      ...ze,
      consulateNumber: ve || ""
    })), ve.length > 0 && ve.length !== 10 && (Ue.fieldErrors.confirmationNumber = ["Enter 10 characters"])), y(Ue);
  };
  ne(() => {
    (c != null && c.length || c == null) && q(!1);
  }, [c]);
  const [le, ce] = O([]);
  ne(() => {
    if (X(u), W != null && W.length) {
      S((ie) => ({
        ...ie,
        consulateLocation: W
      }));
      const Y = le.find(
        (ie) => ie.name.toLowerCase() === W.trim().toLowerCase()
      );
      j(Y ? { fieldErrors: {} } : { fieldErrors: { consulateLocation: ["Select option from dropdown"] } });
    } else
      j({ fieldErrors: {} });
  }, [(Pe = JSON.stringify(C)) == null ? void 0 : Pe.length, W, le]), ne(() => {
    ce(we(c || []));
  }, [c]), ne(() => {
    (async () => {
      if (!G) {
        S((ie) => ({
          ...ie,
          consulateLocation: ""
        }));
        return;
      }
      try {
        q(!0), l(G, W);
      } catch {
        return q(!1), !1;
      }
    })();
  }, [G]);
  const we = (Y) => Y.filter((ie) => ie.id).map((ie) => ({
    id: ie.id || "",
    name: ie.name
  })), ue = n === "United States" ? Ys : z0;
  return /* @__PURE__ */ i.jsx(
    Qt,
    {
      variant: "contained",
      defaultValue: e ? "" : "accordion",
      classNames: { root: rt.accordion, item: rt.accordionItem },
      chevron: /* @__PURE__ */ i.jsx(U, { name: "downArrowLoan", className: rt.chevron }),
      children: /* @__PURE__ */ i.jsxs(Qt.Item, { value: "accordion", className: rt.block, children: [
        /* @__PURE__ */ i.jsx(
          Qt.Control,
          {
            className: rt.control,
            classNames: {
              control: rt.controlClass
            },
            children: /* @__PURE__ */ i.jsxs(E, { className: rt.headerFlex, children: [
              /* @__PURE__ */ i.jsx(I, { className: rt.header, children: "Please let us know how your visa application is progressing" }),
              b ? /* @__PURE__ */ i.jsxs(Jt, { className: rt.alert, children: [
                /* @__PURE__ */ i.jsx(U, { name: "alertCircle", className: rt.alertIcon }),
                "VISA STATUS"
              ] }) : /* @__PURE__ */ i.jsxs(Jt, { children: [
                /* @__PURE__ */ i.jsx(U, { name: "greenNotFilledCheck" }),
                "  VISA STATUS"
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ i.jsxs(Qt.Panel, { classNames: { content: rt.content }, children: [
          /* @__PURE__ */ i.jsx(I, { className: rt.headerMobile, children: "Please let us know how your visa application is progressing" }),
          /* @__PURE__ */ i.jsx(
            Vw,
            {
              monthsName: r,
              selectedDate: o,
              customCallbackFn: re,
              label: "Visa interview date",
              currentYear: (/* @__PURE__ */ new Date()).getFullYear() + 5,
              incomingDetails: { visaInterviewDate: a == null ? void 0 : a.visaInterviewDate }
            }
          ),
          /* @__PURE__ */ i.jsxs(
            vt.Group,
            {
              defaultValue: e,
              value: u,
              onChange: (Y) => Q(Y),
              name: "visaStatus",
              classNames: { root: rt.radioboxWrap },
              children: [
                /* @__PURE__ */ i.jsx(
                  vt,
                  {
                    value: ue.received.value,
                    label: ue.received.label,
                    color: gn.berry,
                    className: rt.radioblock
                  }
                ),
                /* @__PURE__ */ i.jsx(
                  vt,
                  {
                    value: ue.scheduled.value,
                    label: ue.scheduled.label,
                    color: gn.berry,
                    className: rt.radioblock
                  }
                ),
                /* @__PURE__ */ i.jsx(
                  vt,
                  {
                    value: ue.rejected.value,
                    label: ue.rejected.label,
                    color: gn.berry,
                    className: rt.radioblock
                  }
                ),
                /* @__PURE__ */ i.jsx(
                  vt,
                  {
                    value: ue.scheduleAppointment.value,
                    label: ue.scheduleAppointment.label,
                    color: gn.berry,
                    className: rt.radioblock
                  }
                )
              ]
            },
            e
          ),
          F && /* @__PURE__ */ i.jsxs(
            T,
            {
              className: rt.consulateDetailWrap,
              gutter: { base: 5, xs: "md", md: "xl", xl: 50 },
              children: [
                /* @__PURE__ */ i.jsxs(T.Col, { span: { base: 12, md: 6, lg: 6 }, className: rt.fieldColumn, children: [
                  /* @__PURE__ */ i.jsx(I, { className: rt.consulateLabel, children: "DS-160 Confirmation Number" }),
                  /* @__PURE__ */ i.jsx(
                    Di,
                    {
                      id: "confirmationNumber",
                      placeholder: "Enter 10 digit confirmation number",
                      type: "text",
                      error: $,
                      maxLength: 10,
                      onChange: he,
                      className: rt.confirmationNumber,
                      defaultValue: C == null ? void 0 : C.consulateNumber
                    }
                  )
                ] }),
                /* @__PURE__ */ i.jsxs(T.Col, { span: { base: 12, md: 6, lg: 6 }, className: rt.fieldColumn, children: [
                  /* @__PURE__ */ i.jsx(I, { className: rt.consulateLabel, children: "Consulate Location" }),
                  /* @__PURE__ */ i.jsx(
                    i0,
                    {
                      id: "consulateLocation",
                      suggestedDropDownList: le,
                      defaultValue: C == null ? void 0 : C.consulateLocation,
                      error: P,
                      placeholder: "Type consulate location",
                      selectedValue: (Y) => D(Y),
                      getOptions: async (Y) => (D(Y), Y.trim() ? le.filter(
                        (ve) => ve.name.toLowerCase().includes(Y.toLowerCase())
                      ) : []),
                      loader: B,
                      className: rt.consulateLocation,
                      tickMarkAlignTopValue: "25%",
                      tickMarkAlignRightValue: "5%"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ i.jsx(E, { className: rt.buttonFlex, children: /* @__PURE__ */ i.jsx(
            qe,
            {
              disabled: p || t,
              className: rt.action,
              onClick: M,
              loading: t,
              children: "UPDATE"
            }
          ) })
        ] })
      ] })
    },
    e
  );
}, g9 = "_container_1u3gr_1", v9 = "_header_1u3gr_13", $9 = "_title_1u3gr_25", b9 = "_description_1u3gr_35", x9 = "_list_1u3gr_46", y9 = "_loanIcon_1u3gr_53", w9 = "_tipsContainer_1u3gr_61", C9 = "_tip_1u3gr_61", j9 = "_action_1u3gr_94", N9 = "_fyHeader_1u3gr_112", S9 = "_fyTextDetails_1u3gr_124", k9 = "_enrolmentMessage_1u3gr_130", E9 = "_enrollmentBlock_1u3gr_150", I9 = "_radioboxWrap_1u3gr_165", P9 = "_radioblock_1u3gr_178", T9 = "_loader_1u3gr_184", R9 = "_loaderX_1u3gr_203", L9 = "_helperText_1u3gr_208", Tt = {
  container: g9,
  header: v9,
  title: $9,
  description: b9,
  list: x9,
  loanIcon: y9,
  tipsContainer: w9,
  tip: C9,
  action: j9,
  fyHeader: N9,
  fyTextDetails: S9,
  enrolmentMessage: k9,
  enrollmentBlock: E9,
  radioboxWrap: I9,
  radioblock: P9,
  loader: T9,
  loaderX: R9,
  helperText: L9
}, vR = (e) => {
  const {
    tasks: t,
    className: n,
    description: s,
    showDefault: r,
    applyRbClick: o,
    showRBBlock: a,
    certAmount: l,
    atilAmount: d,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    enrolmentPaymentSubmit: c = (N) => {
    },
    enrolmentData: u = {
      showenrolledPaymentBlock: !1,
      enrolledRadioVal: ""
    },
    isSubmitting: h = !1,
    visaStatus: p,
    monthsName: f,
    selectedDate: m,
    visaInterviewDetails: g,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getUserSearchedConsulate: v = (N, C) => {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getVisaInterviewDate: _ = (N) => {
    },
    steps: $ = [],
    incomingConsulateData: y
  } = e, [P, j] = O(u.enrolledRadioVal), b = (N) => {
    j(N), c(N);
  };
  return /* @__PURE__ */ i.jsxs("section", { className: R(Tt.container, n), children: [
    /* @__PURE__ */ i.jsxs("header", { className: Tt.header, children: [
      /* @__PURE__ */ i.jsx(ee, { className: Tt.title, fontWeight: "700", variant: "yellow", order: 3, children: "My next action" }),
      r && /* @__PURE__ */ i.jsx(I, { className: Tt.description, children: "Please note that the status/tasks you currently see may not be the latest. It may take up to 72 hours for the actual status to be reflected. Do not worry, we are working diligently to update your information as soon as possible." }),
      s && /* @__PURE__ */ i.jsx(I, { className: Tt.description, children: s })
    ] }),
    (u == null ? void 0 : u.showenrolledPaymentBlock) && /* @__PURE__ */ i.jsxs(E, { className: Tt.enrollmentBlock, children: [
      h && /* @__PURE__ */ i.jsxs("div", { className: Tt.loader, children: [
        " ",
        /* @__PURE__ */ i.jsx(ts, { size: "xl", className: Tt.loaderX })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { className: Tt.enrolmentMessage, children: [
        /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "blue", fontWeight: "400", children: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("span", { children: "Remember" }),
          " - Your enrollment is confirmed upon payment of the enrollment deposit to your university. Have you made this payment?",
          /* @__PURE__ */ i.jsx("br", {})
        ] }) }),
        /* @__PURE__ */ i.jsx($t, { h: 10 }),
        /* @__PURE__ */ i.jsx(ee, { order: 5, variant: "black", fontWeight: "400", children: (u == null ? void 0 : u.showReconfirmText) && " Please reconfirm your enrollment status" })
      ] }),
      /* @__PURE__ */ i.jsxs(
        vt.Group,
        {
          value: P,
          onChange: (N) => b(N),
          name: "enrollmentStatus",
          classNames: { root: Tt.radioboxWrap },
          defaultChecked: P,
          children: [
            /* @__PURE__ */ i.jsx(
              vt,
              {
                value: "yes",
                label: "Yes, I have paid.",
                color: gn.berry,
                className: Tt.radioblock
              }
            ),
            /* @__PURE__ */ i.jsx(
              vt,
              {
                value: "no",
                label: "No, I haven't paid.",
                color: gn.berry,
                className: Tt.radioblock
              }
            )
          ]
        },
        P
      )
    ] }),
    a && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsxs(ee, { fontWeight: "400", variant: "blue", order: 4, className: Tt.fyHeader, children: [
        "Congratulations! MPOWER Financing has approved you for a total of",
        " ",
        Je(d),
        ".",
        " ",
        /* @__PURE__ */ i.jsxs("span", { children: [
          "For Spring 2024, your school has certified ",
          Je(l)
        ] })
      ] }),
      /* @__PURE__ */ i.jsx(E, { className: Tt.tipsContainer, children: /* @__PURE__ */ i.jsxs(E, { role: "tooltip", className: Tt.tip, children: [
        /* @__PURE__ */ i.jsx(U, { name: "moneyHandDollar", className: Tt.loanIcon, ariaHidden: !0 }),
        /* @__PURE__ */ i.jsx(ee, { order: 3, variant: "blue", className: Tt.fyTextDetails, children: "APPLY to complete your fall funding request for the remaining balance." }),
        /* @__PURE__ */ i.jsx(Jt, { className: Tt.action, onClick: o, children: "APPLY" })
      ] }) })
    ] }),
    /* @__PURE__ */ i.jsx(E, { role: "list", className: Tt.list, children: t.map((N) => /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(
      Sw,
      {
        name: N.name,
        actionName: N.actionName,
        onAction: N.onAction,
        infoText: N == null ? void 0 : N.infoText
      }
    ) })) }),
    $ && ($ == null ? void 0 : $.length) > 0 && /* @__PURE__ */ i.jsx(E, { children: $ == null ? void 0 : $.map((N) => {
      const C = G0[N];
      return C ? /* @__PURE__ */ i.jsx(I, { size: "sm", className: Tt.helperText, children: C }, N) : null;
    }) }),
    (p == null ? void 0 : p.showVisaStatus) && /* @__PURE__ */ i.jsx(
      m9,
      {
        selctedVisaStatus: p == null ? void 0 : p.selectedVisaStatus,
        visaStatusSubmit: p.visaStatusSubmit,
        isSubmitting: h,
        applicationCountry: p.applicationCountry,
        monthsName: f,
        selectedDate: m,
        visaInterviewDetails: g,
        getUserSearchedConsulate: v,
        incomingConsulateData: y,
        getVisaInterviewDate: _
      },
      p == null ? void 0 : p.selectedVisaStatus
    )
  ] });
}, O9 = "_container_1tp8n_1", F9 = "_title_1tp8n_12", A9 = "_list_1tp8n_22", M9 = "_listItem_1tp8n_52", D9 = "_loanTermCard_1tp8n_56", vi = {
  container: O9,
  title: F9,
  list: A9,
  listItem: M9,
  loanTermCard: D9
}, $R = (e) => {
  const { loanTerms: t, title: n, className: s } = e;
  return /* @__PURE__ */ i.jsxs("section", { className: R(vi.container, s), children: [
    n && /* @__PURE__ */ i.jsx(ee, { order: 3, fontWeight: "700", className: vi.title, variant: "yellow", children: n }),
    /* @__PURE__ */ i.jsx(E, { role: "list", className: vi.list, children: t.map((r) => /* @__PURE__ */ i.jsx(E, { role: "listItem", className: vi.listItem, children: /* @__PURE__ */ i.jsx(
      B4,
      {
        title: r.title,
        text: r.text,
        className: vi.loanTermCard
      }
    ) }, r.key)) })
  ] });
}, B9 = "_svgContainer_1t48i_1", W9 = {
  svgContainer: B9
}, bR = (e) => {
  const { children: t } = e;
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(Hs, { className: W9.svgContainer, children: t }) });
}, bp = {
  png: it.png,
  gif: it.gif,
  jpeg: it.jpeg,
  jpg: it.jpeg,
  pdf: it.pdf,
  doc: it.doc,
  docx: it.docx
}, xp = (e) => {
  var t;
  try {
    const n = typeof e == "string" ? new URL(e) : e, s = n == null ? void 0 : n.pathname, r = (t = s == null ? void 0 : s.split(".")) == null ? void 0 : t.pop();
    return U9(r) ? bp[r] : null;
  } catch {
    console.warn("something went wrong *getFileMimeTypeFromURL*");
  }
}, U9 = (e) => !!bp[e], yp = (e) => {
  var s;
  const t = typeof e == "string" ? new URL(e) : e, n = t == null ? void 0 : t.pathname;
  return (s = n == null ? void 0 : n.split("/")) == null ? void 0 : s.pop();
}, z9 = "_container_13z8w_1", H9 = "_dropzone_13z8w_14", q9 = "_previewContainer_13z8w_23", G9 = "_placeholder_13z8w_30", V9 = "_placeholderPDF_13z8w_41", Y9 = "_placeholderPDF_13z8w_41", K9 = "_iframe_13z8w_58", J9 = "_image_13z8w_65", Z9 = "_error_13z8w_70", X9 = "_previewLink_13z8w_77", _r = {
  container: z9,
  dropzone: H9,
  previewContainer: q9,
  placeholder: G9,
  placeholderPDF: V9,
  placeholderPdf: Y9,
  iframe: K9,
  image: J9,
  error: Z9,
  previewLink: X9
}, Q9 = (e) => {
  const { type: t, name: n, className: s, file: r, onDrop: o, label: a, openRef: l, disabled: d, accept: c, maxSize: u } = e, h = Xr();
  ne(() => {
    const f = document.getElementById(h), m = new DataTransfer();
    r instanceof File && (m.items.add(r), f && (f.files = m == null ? void 0 : m.files));
  }, [r]);
  const p = (f) => {
    o(f == null ? void 0 : f[0]);
  };
  return /* @__PURE__ */ i.jsxs(E, { className: R(_r.container, s), children: [
    r ? /* @__PURE__ */ i.jsx(e8, { file: r, label: a }) : /* @__PURE__ */ i.jsx(
      qr,
      {
        disabled: d,
        openRef: l,
        "aria-label": `Upload ${a}`,
        onDrop: p,
        className: _r.dropzone,
        accept: c,
        multiple: !1,
        maxSize: u,
        onReject: (f) => {
          var g;
          const m = f[0];
          alert(((g = m.errors[0]) == null ? void 0 : g.message) ?? "Something went wrong");
        },
        children: /* @__PURE__ */ i.jsxs(qr.Idle, { children: [
          t === "id" && /* @__PURE__ */ i.jsx(U, { name: "idVerificationPlaceholder", className: _r.placeholder }),
          t === "document" && /* @__PURE__ */ i.jsx(U, { name: "documentPlaceholder", className: _r.placeholder })
        ] })
      }
    ),
    /* @__PURE__ */ i.jsx("input", { name: r instanceof File ? n : void 0, type: "file", id: h, hidden: !0 })
  ] });
}, e8 = (e) => {
  const { label: t, file: n } = e, s = n instanceof File, r = s ? URL.createObjectURL(n) : n.toString(), o = () => {
    URL.revokeObjectURL(r);
  }, a = s ? n.type : xp(r), l = s ? n.name : yp(r);
  return [it.docx, it.doc].some(
    (c) => c === a
  ) ? /* @__PURE__ */ i.jsx(on, { className: _r.previewLink, href: r, children: l }) : a === it.pdf ? /* @__PURE__ */ i.jsx(
    "iframe",
    {
      "aria-label": t,
      src: r,
      onLoad: o,
      loading: "lazy",
      className: _r.iframe
    }
  ) : /* @__PURE__ */ i.jsx(
    "img",
    {
      "aria-label": t,
      alt: t,
      src: r,
      onLoad: o,
      loading: "lazy",
      className: _r.image
    }
  );
}, t8 = "_list_1mgo9_1", n8 = "_listItem_1mgo9_12", s8 = "_listItemActionsContainer_1mgo9_23", r8 = "_previewContainer_1mgo9_37", i8 = "_clickableOverlay_1mgo9_55", o8 = "_previewImage_1mgo9_73", a8 = "_previewIframe_1mgo9_78", l8 = "_addDocumentButton_1mgo9_83", d8 = "_addDocumentButtonIcon_1mgo9_95", c8 = "_addDocumentButtonText_1mgo9_109", u8 = "_previewLink_1mgo9_116", h8 = "_modalContent_1mgo9_137", f8 = "_modalBody_1mgo9_142", p8 = "_modalInner_1mgo9_146", _8 = "_maximizedContent_1mgo9_150", m8 = "_maximizedIframe_1mgo9_162", g8 = "_maximizedImage_1mgo9_171", v8 = "_previewIframeDisabled_1mgo9_178", $8 = "_clickableOverlayAbsolute_1mgo9_182", b8 = "_maximizeIcon_1mgo9_192", x8 = "_previewContainerClickable_1mgo9_209", y8 = "_blobConvertingMessage_1mgo9_214", w8 = "_blobConvertingTitle_1mgo9_224", C8 = "_blobConvertingSubtitle_1mgo9_229", j8 = "_maximizedIframeFull_1mgo9_234", N8 = "_deleteButton_1mgo9_240", be = {
  list: t8,
  listItem: n8,
  listItemActionsContainer: s8,
  previewContainer: r8,
  clickableOverlay: i8,
  previewImage: o8,
  previewIframe: a8,
  addDocumentButton: l8,
  addDocumentButtonIcon: d8,
  addDocumentButtonText: c8,
  previewLink: u8,
  modalContent: h8,
  modalBody: f8,
  modalInner: p8,
  maximizedContent: _8,
  maximizedIframe: m8,
  maximizedImage: g8,
  previewIframeDisabled: v8,
  clickableOverlayAbsolute: $8,
  maximizeIcon: b8,
  previewContainerClickable: x8,
  blobConvertingMessage: y8,
  blobConvertingTitle: w8,
  blobConvertingSubtitle: C8,
  maximizedIframeFull: j8,
  deleteButton: N8
}, xR = (e) => {
  const {
    uploadedFiles: t,
    filesToUpload: n,
    className: s,
    disabled: r,
    canUpload: o = !0,
    canDelete: a = !0,
    onFilesToUpload: l,
    onDeleteFileToUpload: d,
    onDeleteUploadedFile: c,
    mimeTypes: u = [],
    canDeleteUploadedFiles: h = !1
  } = e, p = dn(null), [f, m] = O(0), g = Xr();
  ne(() => {
    if (!p.current || !o) return;
    const _ = new DataTransfer();
    n.forEach(($) => {
      var y, P;
      return (P = (y = _.items).add) == null ? void 0 : P.call(y, $);
    }), p.current.files = _ == null ? void 0 : _.files;
  }, [n, o]);
  const v = (_) => {
    l(_), p != null && p.current && (p.current.value = ""), m(($) => $ + 1);
  };
  return /* @__PURE__ */ i.jsx(E, { className: R(be.container, s), children: /* @__PURE__ */ i.jsxs(E, { role: "list", className: be.list, children: [
    o && /* @__PURE__ */ i.jsx(E, { role: "listItem", className: be.listItem, children: /* @__PURE__ */ i.jsx(
      Vp,
      {
        disabled: r,
        name: n.length > 0 ? "upload" : void 0,
        multiple: !0,
        onChange: v,
        accept: u == null ? void 0 : u.join(","),
        inputProps: {
          id: g
        },
        children: (_) => /* @__PURE__ */ i.jsxs(Ee, { ..._, className: be.addDocumentButton, children: [
          /* @__PURE__ */ i.jsx(
            E,
            {
              ref: p,
              className: be.addDocumentButtonIcon,
              "aria-hidden": !0,
              children: "+"
            }
          ),
          /* @__PURE__ */ i.jsx(I, { className: be.addDocumentButtonText, children: "Add document" })
        ] })
      },
      f
    ) }),
    t.map((_, $) => /* @__PURE__ */ i.jsx(
      k8,
      {
        index: $,
        url: _.url,
        fileName: _.fileName,
        fileMimeType: _.fileMimeType,
        disabled: r,
        deleteMetadata: _.deleteMetadata,
        canDelete: a,
        onDelete: c,
        originalURL: _.originalURL,
        actualSignedURL: _.actualSignedURL
      },
      _.url
    )),
    n.map((_) => /* @__PURE__ */ i.jsx(
      S8,
      {
        file: _,
        onDelete: () => d(_),
        canDelete: a || h,
        disabled: r
      },
      _.path + _.name + _.type
    ))
  ] }) });
}, S8 = (e) => {
  const { onDelete: t, disabled: n, file: s, canDelete: r = !0 } = e, o = URL.createObjectURL(s), a = () => {
    URL.revokeObjectURL(o);
  };
  return /* @__PURE__ */ i.jsxs(E, { role: "listItem", className: be.listItem, children: [
    /* @__PURE__ */ i.jsx(wp, { src: o, onLoad: a, fileMimeType: s.type, fileName: s.name }),
    r && /* @__PURE__ */ i.jsx(E, { className: be.listItemActionsContainer, children: /* @__PURE__ */ i.jsx(
      Ee,
      {
        disabled: n,
        "aria-label": `Delete ${s.name}`,
        onClick: t,
        className: be.deleteButton,
        children: /* @__PURE__ */ i.jsx(U, { name: "trashCan" })
      }
    ) })
  ] });
}, k8 = (e) => {
  const {
    deleteMetadata: t,
    disabled: n,
    url: s,
    fileName: r,
    fileMimeType: o,
    index: a,
    canDelete: l = !0,
    onDelete: d,
    originalURL: c,
    actualSignedURL: u
  } = e, [h, p] = O(!1), f = () => {
    p(!0), d == null || d(s);
  };
  return h && t ? /* @__PURE__ */ i.jsx("input", { hidden: !0, name: `delete-${a}`, value: JSON.stringify(t) }) : h ? null : /* @__PURE__ */ i.jsxs(E, { role: "listItem", className: be.listItem, children: [
    /* @__PURE__ */ i.jsx(
      wp,
      {
        src: s,
        fileMimeType: o,
        fileName: r,
        originalURL: c,
        actualSignedURL: u
      }
    ),
    l && /* @__PURE__ */ i.jsx(E, { className: be.listItemActionsContainer, children: /* @__PURE__ */ i.jsx(
      Ee,
      {
        disabled: n,
        "aria-label": `Delete ${r}`,
        onClick: f,
        className: be.deleteButton,
        children: /* @__PURE__ */ i.jsx(U, { name: "trashCan" })
      }
    ) })
  ] });
}, wp = (e) => {
  const { src: t, fileMimeType: n, fileName: s, onLoad: r, originalURL: o, actualSignedURL: a } = e, [l, d] = O(!1), [c, u] = O(!1), [h, p] = O(!1), f = dn(null), m = t == null ? void 0 : t.startsWith("blob:"), [g, v] = O(null);
  ne(() => {
    m && fetch(t).then(($) => $ == null ? void 0 : $.blob()).then(($) => {
      const y = new FileReader();
      y.onload = () => {
        v(y == null ? void 0 : y.result);
      }, y == null || y.readAsDataURL($);
    }).catch(($) => !1);
  }, [t, m]);
  const _ = [it.docx, it.doc].some(
    ($) => $ === n
  );
  return ne(() => () => {
    f != null && f.current && clearTimeout(f == null ? void 0 : f.current);
  }, []), _ ? /* @__PURE__ */ i.jsx(on, { className: be.previewLink, href: t, children: s }) : n === it.pdf ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: `${be.previewContainer} ${be.previewContainerClickable}`,
        title: "Click to maximize document view",
        role: "button",
        tabIndex: 0,
        onKeyDown: ($) => {
          (($ == null ? void 0 : $.key) === "Enter" || ($ == null ? void 0 : $.key) === " ") && ($ == null || $.preventDefault(), d(!0), u(!1), p(!1));
        },
        children: [
          /* @__PURE__ */ i.jsx(
            "iframe",
            {
              loading: "lazy",
              "aria-label": s,
              src: a || t,
              onLoad: r,
              className: `${be.previewIframe} ${be.previewIframeDisabled}`
            }
          ),
          /* @__PURE__ */ i.jsx(
            "div",
            {
              className: `${be.clickableOverlay} ${be.clickableOverlayAbsolute}`,
              onClick: () => {
                d(!0), u(!1), p(!1), f != null && f.current && clearTimeout(f == null ? void 0 : f.current), f.current = setTimeout(() => {
                  p(!0), u(!1);
                }, 1e4);
              },
              title: "Click to maximize document view"
            }
          ),
          /* @__PURE__ */ i.jsx("div", { className: be.maximizeIcon, children: "⛶" })
        ]
      }
    ),
    /* @__PURE__ */ i.jsx(
      Nn,
      {
        opened: l,
        onClose: () => d(!1),
        title: s,
        size: "xl",
        centered: !0,
        classNames: {
          content: be.modalContent,
          body: be.modalBody,
          inner: be.modalInner
        },
        children: /* @__PURE__ */ i.jsxs("div", { className: be.maximizedContent, children: [
          m && !g && /* @__PURE__ */ i.jsxs("div", { className: be.blobConvertingMessage, children: [
            /* @__PURE__ */ i.jsx("div", { className: be.blobConvertingTitle, children: "Converting blob URL for preview..." }),
            /* @__PURE__ */ i.jsx("div", { className: be.blobConvertingSubtitle, children: "Please wait while we prepare the PDF for viewing" })
          ] }),
          m && g && /* @__PURE__ */ i.jsx(
            "iframe",
            {
              src: g,
              className: `${be.maximizedIframe} ${be.maximizedIframeFull}`,
              title: s,
              allowFullScreen: !0
            }
          ),
          a && /* @__PURE__ */ i.jsx(
            "iframe",
            {
              src: a,
              className: `${be.maximizedIframe} ${be.maximizedIframeFull}`,
              title: s,
              allowFullScreen: !0
            }
          )
        ] })
      }
    )
  ] }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: `${be.previewContainer} ${be.previewContainerClickable}`,
        title: "Click to maximize image view",
        role: "button",
        tabIndex: 0,
        onKeyDown: ($) => {
          (($ == null ? void 0 : $.key) === "Enter" || ($ == null ? void 0 : $.key) === " ") && ($ == null || $.preventDefault(), d(!0), u(!1), p(!1));
        },
        children: [
          /* @__PURE__ */ i.jsx(
            "img",
            {
              loading: "lazy",
              className: be.previewImage,
              src: a || t,
              alt: s
            }
          ),
          /* @__PURE__ */ i.jsx(
            "div",
            {
              className: `${be.clickableOverlay} ${be.clickableOverlayAbsolute}`,
              onClick: () => {
                d(!0), u(!1), p(!1);
              },
              title: "Click to maximize image view"
            }
          ),
          /* @__PURE__ */ i.jsx("div", { className: be.maximizeIcon, children: "⛶" })
        ]
      }
    ),
    /* @__PURE__ */ i.jsxs(
      Nn,
      {
        opened: l,
        onClose: () => d(!1),
        title: s,
        size: "xl",
        centered: !0,
        classNames: {
          content: be.modalContent,
          body: be.modalBody,
          inner: be.modalInner
        },
        children: [
          /* @__PURE__ */ i.jsx("div", { className: be.maximizedContent, children: /* @__PURE__ */ i.jsx("img", { src: a || t, className: be.maximizedImage, alt: s }) }),
          /* @__PURE__ */ i.jsx(ss, { justify: "flex-end", mt: "md", children: /* @__PURE__ */ i.jsx(Jt, { variant: "outline", onClick: () => d(!1), children: "Close" }) })
        ]
      }
    )
  ] });
}, E8 = "_card_l43ep_1", I8 = "_cardClickable_l43ep_36", P8 = "_cardFunding_l43ep_41", T8 = "_contentContainer_l43ep_46", R8 = "_name_l43ep_58", L8 = "_statusLabel_l43ep_76", O8 = "_statusLabelCompleted_l43ep_101", F8 = "_statusLabelDenied_l43ep_106", A8 = "_list_l43ep_111", M8 = "_keyPair_l43ep_141", D8 = "_valuePair_l43ep_146", B8 = "_icon_l43ep_151", W8 = "_iconMoneyHand_l43ep_157", U8 = "_iconRoadToFlag_l43ep_170", z8 = "_actionsContainer_l43ep_183", H8 = "_needMoneyButton_l43ep_194", q8 = "_completeButton_l43ep_211", G8 = "_infoIcon_l43ep_233", V8 = "_titleWrap_l43ep_239", jt = {
  card: E8,
  cardClickable: I8,
  cardFunding: P8,
  contentContainer: T8,
  name: R8,
  statusLabel: L8,
  statusLabelCompleted: O8,
  statusLabelDenied: F8,
  list: A8,
  keyPair: M8,
  valuePair: D8,
  icon: B8,
  iconMoneyHand: W8,
  iconRoadToFlag: U8,
  actionsContainer: z8,
  needMoneyButton: H8,
  completeButton: q8,
  infoIcon: G8,
  titleWrap: V8
}, yR = ({ children: e, ...t }) => {
  const {
    statusLabel: n,
    statusState: s,
    name: r,
    appId: o,
    academicPeriod: a,
    loanAmount: l,
    className: d,
    onNeedMoreMoney: c,
    funding: u,
    onComplete: h,
    completeButtonLabel: p,
    actionsVisible: f = !0,
    repeatBorrower: m,
    appStartDate: g,
    borderColor: v,
    iconStatus: _
  } = t, $ = Ve("(min-width: 768px)"), y = (S) => (F) => {
    F.preventDefault(), F.stopPropagation(), S == null || S();
  }, P = () => {
    if ($) {
      if (p && h) {
        h();
        return;
      }
      m && c && c();
    }
  }, j = !!$ && (!!p && !!h || !!m && !!c), b = g ? Re(g).format("MM/DD/YYYY") : "", N = (S) => S || "--", C = (S) => {
    switch (S) {
      case "kickback":
        return /* @__PURE__ */ i.jsx(U, { name: "kickbackAlert" });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ i.jsxs(
    cn,
    {
      className: R(
        jt.card,
        u && jt.cardFunding,
        j && jt.cardClickable,
        d
      ),
      style: { border: `2px solid ${v}`, backgroundImage: `url(${od})` },
      onClick: P,
      role: j ? "button" : void 0,
      tabIndex: j ? 0 : void 0,
      onKeyDown: j ? (S) => {
        (S.key === "Enter" || S.key === " ") && (S.preventDefault(), P());
      } : void 0,
      children: [
        _ && /* @__PURE__ */ i.jsx("div", { className: jt.infoIcon, children: C(_) }),
        /* @__PURE__ */ i.jsx(
          ee,
          {
            className: R(
              jt.statusLabel,
              s === "completed" && jt.statusLabelCompleted,
              s === "denied" && jt.statusLabelDenied
            ),
            order: 4,
            fontWeight: "initial",
            children: N(n)
          }
        ),
        /* @__PURE__ */ i.jsxs(E, { className: jt.contentContainer, children: [
          /* @__PURE__ */ i.jsx(Jl, { label: r, className: jt.titleWrap, children: /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(ee, { className: jt.name, order: 3, fontWeight: "700", children: N(r) }) }) }),
          /* @__PURE__ */ i.jsxs(Be, { className: jt.list, children: [
            /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsxs(I, { span: !0, className: jt.keyPair, children: [
                "App ID:",
                " "
              ] }),
              /* @__PURE__ */ i.jsx(I, { span: !0, className: jt.valuePair, children: N(o) })
            ] }),
            g && /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsx(I, { span: !0, className: jt.keyPair, children: "App start date:" }),
              /* @__PURE__ */ i.jsx(I, { span: !0, className: jt.valuePair, children: N(b) })
            ] }),
            a && /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsxs(I, { span: !0, className: jt.keyPair, children: [
                "Academic period:",
                " "
              ] }),
              /* @__PURE__ */ i.jsx(I, { span: !0, className: jt.valuePair, children: N(a) })
            ] }),
            /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsxs(I, { span: !0, className: jt.keyPair, children: [
                "Loan amount:",
                " "
              ] }),
              /* @__PURE__ */ i.jsx(I, { span: !0, className: jt.valuePair, children: N(l) })
            ] })
          ] })
        ] }),
        f && /* @__PURE__ */ i.jsxs(E, { className: jt.actionsContainer, children: [
          m && /* @__PURE__ */ i.jsx(
            Ee,
            {
              className: jt.needMoneyButton,
              onClick: y(c),
              children: "Need more money?"
            }
          ),
          p && /* @__PURE__ */ i.jsx(
            qe,
            {
              className: jt.completeButton,
              onClick: y(h),
              uppercase: !0,
              children: p
            }
          )
        ] })
      ]
    }
  );
}, Y8 = "_card_1on63_1", K8 = "_button_1on63_27", J8 = "_icon_1on63_40", Z8 = "_text_1on63_62", mo = {
  card: Y8,
  button: K8,
  icon: J8,
  text: Z8
}, wR = (e) => {
  const { onClick: t, className: n } = e;
  return /* @__PURE__ */ i.jsx(
    cn,
    {
      className: R(mo.card, n),
      style: { backgroundImage: `url(${od})` },
      children: /* @__PURE__ */ i.jsxs(Ee, { className: mo.button, onClick: t, children: [
        /* @__PURE__ */ i.jsx(E, { className: mo.icon, "aria-hidden": "true", children: "+" }),
        /* @__PURE__ */ i.jsx(I, { className: mo.text, span: !0, children: "Add another application" })
      ] })
    }
  );
};
var Ed = /* @__PURE__ */ ((e) => (e.IN_SCHOOL = "in_school", e.US_GRAD = "us_grad", e.REFI = "refi", e))(Ed || {});
const X8 = [
  "in_school",
  "us_grad"
  /* US_GRAD */
], ql = (e) => e ? X8.includes(e) : !1, ls = {
  secureFund: {
    title: "You secure your funds and can cancel anytime before the funds go to your school."
  },
  noVisaYet: {
    title: "No visa yet? You can still sign! ",
    details: "If your visa circumstances change, you're not committed to the loan."
  }
}, Q8 = "_container_60tqb_1", e6 = "_table_60tqb_5", t6 = "_fundingRow_60tqb_49", n6 = "_nameText_60tqb_56", s6 = "_statusLabel_60tqb_64", r6 = "_statusLabelCompleted_60tqb_79", i6 = "_statusLabelDenied_60tqb_85", o6 = "_actionButton_60tqb_91", ds = {
  container: Q8,
  table: e6,
  fundingRow: t6,
  nameText: n6,
  statusLabel: s6,
  statusLabelCompleted: r6,
  statusLabelDenied: i6,
  actionButton: o6
}, CR = (e) => {
  const {
    applications: t,
    onAddApplication: n,
    addApplicationVisible: s,
    className: r,
    actionsVisible: o = !0
  } = e, a = t.some(
    (d) => ql(d.opportunityType) && d.academicPeriod
  ), l = t.some(
    (d) => ql(d.opportunityType) && d.name
  );
  return /* @__PURE__ */ i.jsx(E, { className: R(ds.container, r), children: /* @__PURE__ */ i.jsxs(Kl, { className: ds.table, ta: "left", children: [
    /* @__PURE__ */ i.jsx("thead", { children: /* @__PURE__ */ i.jsxs("tr", { children: [
      /* @__PURE__ */ i.jsx("th", { children: "Status" }),
      a && /* @__PURE__ */ i.jsx("th", { children: "Academic period" }),
      /* @__PURE__ */ i.jsx("th", { children: "App ID" }),
      l && /* @__PURE__ */ i.jsx("th", { children: "School Name" }),
      /* @__PURE__ */ i.jsx("th", { children: "Loan Amount" }),
      o && /* @__PURE__ */ i.jsx("th", { children: "Actions" })
    ] }) }),
    /* @__PURE__ */ i.jsxs("tbody", { children: [
      t.map((d) => /* @__PURE__ */ i.jsxs("tr", { className: R(d.funding && ds.fundingRow), children: [
        /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(
          I,
          {
            span: !0,
            className: R(
              ds.statusLabel,
              d.statusState === "completed" && ds.statusLabelCompleted,
              d.statusState === "denied" && ds.statusLabelDenied
            ),
            children: d.statusLabel
          }
        ) }),
        a && /* @__PURE__ */ i.jsx("td", { "aria-label": d.academicPeriod ? void 0 : "No value", children: d.academicPeriod || "-" }),
        /* @__PURE__ */ i.jsx("td", { "aria-label": d.appId ? void 0 : "No value", children: d.appId }),
        l && /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(Jl, { label: d.name, children: /* @__PURE__ */ i.jsx("span", { className: ds.nameText, children: d.name }) }) }),
        /* @__PURE__ */ i.jsx("td", { "aria-label": d.loanAmount ? void 0 : "No value", children: d.loanAmount || "-" }),
        o && (d.onComplete && d.completeButtonLabel ? /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(
          qe,
          {
            variant: "filled",
            className: ds.actionButton,
            onClick: d.onComplete,
            uppercase: !0,
            children: d.completeButtonLabel
          }
        ) }) : /* @__PURE__ */ i.jsx("td", { "aria-label": "No action" }))
      ] }, d.id)),
      o && s && /* @__PURE__ */ i.jsxs("tr", { children: [
        /* @__PURE__ */ i.jsx("td", { "aria-label": "No value" }),
        a && /* @__PURE__ */ i.jsx("td", { "aria-label": "No value" }),
        /* @__PURE__ */ i.jsx("td", { "aria-label": "No value" }),
        l && /* @__PURE__ */ i.jsx("td", { "aria-label": "No value" }),
        /* @__PURE__ */ i.jsx("td", { "aria-label": "No value" }),
        /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(
          qe,
          {
            variant: "filled",
            className: ds.actionButton,
            onClick: n,
            uppercase: !0,
            children: "Add application"
          }
        ) })
      ] })
    ] })
  ] }) });
}, a6 = "_container_jg49o_1", l6 = "_stepCircle_jg49o_22", d6 = "_completed_jg49o_34", c6 = "_active_jg49o_38", u6 = "_stepBarWrapper_jg49o_45", h6 = "_stepBarBg_jg49o_50", f6 = "_hasFill_jg49o_53", p6 = "_stepBarFill_jg49o_62", _6 = "_stepItem_jg49o_71", m6 = "_stepLabel_jg49o_78", g6 = "_activeLabel_jg49o_94", Mn = {
  container: a6,
  stepCircle: l6,
  completed: d6,
  active: c6,
  stepBarWrapper: u6,
  stepBarBg: h6,
  hasFill: f6,
  stepBarFill: p6,
  stepItem: _6,
  stepLabel: m6,
  activeLabel: g6
}, jR = (e) => {
  const { steps: t, completedStep: n, className: s, progressPercent: r } = e;
  return /* @__PURE__ */ i.jsx(E, { role: "list", "aria-label": "Progress", className: R(Mn.container, s), children: t.map((o, a) => {
    const l = a < n, d = a === n, c = d;
    return /* @__PURE__ */ i.jsxs(oe.Fragment, { children: [
      a < t.length && /* @__PURE__ */ i.jsxs("div", { className: R(Mn.stepBarWrapper, { [Mn.hasFill]: c }), children: [
        /* @__PURE__ */ i.jsx("div", { className: Mn.stepBarBg }),
        /* @__PURE__ */ i.jsx(
          "div",
          {
            className: Mn.stepBarFill,
            style: {
              width: l ? "100%" : d ? `${r}%` : "0%"
            }
          }
        )
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: Mn.stepItem, children: [
        /* @__PURE__ */ i.jsx(
          E,
          {
            className: R(Mn.stepCircle, {
              [Mn.completed]: l,
              [Mn.active]: d
            }),
            children: a + 1
          }
        ),
        /* @__PURE__ */ i.jsx(
          I,
          {
            className: R(Mn.stepLabel, {
              [Mn.activeLabel]: d
            }),
            children: o.label
          }
        )
      ] })
    ] }, a);
  }) });
}, v6 = "_wrapper_6tof5_1", $6 = "_container_6tof5_9", b6 = "_tipsContainer_6tof5_14", x6 = "_tip_6tof5_14", y6 = "_loanIcon_6tof5_55", w6 = "_sliderContainer_6tof5_62", C6 = "_sliderRoot_6tof5_67", j6 = "_sliderInnerContainer_6tof5_71", N6 = "_sliderCornerIcon_6tof5_82", S6 = "_sliderCornerIconLeft_6tof5_97", k6 = "_sliderCornerIconRight_6tof5_106", E6 = "_sliderMinMaxValues_6tof5_115", I6 = "_sliderTrack_6tof5_138", P6 = "_sliderThumb_6tof5_149", T6 = "_sliderBar_6tof5_154", R6 = "_currentAmountRequest_6tof5_165", zt = {
  wrapper: v6,
  container: $6,
  tipsContainer: b6,
  tip: x6,
  loanIcon: y6,
  sliderContainer: w6,
  sliderRoot: C6,
  sliderInnerContainer: j6,
  sliderCornerIcon: N6,
  sliderCornerIconLeft: S6,
  sliderCornerIconRight: k6,
  sliderMinMaxValues: E6,
  sliderTrack: I6,
  sliderThumb: P6,
  sliderBar: T6,
  currentAmountRequest: R6
}, NR = (e) => {
  const { className: t, min: n, max: s, value: r, totalBorrowedTillNow: o, onChange: a, name: l, step: d } = e;
  return /* @__PURE__ */ i.jsx(E, { className: R(zt.wrapper, t), children: /* @__PURE__ */ i.jsxs(E, { className: zt.container, children: [
    /* @__PURE__ */ i.jsx(E, { className: zt.tipsContainer, children: /* @__PURE__ */ i.jsxs(E, { role: "tooltip", className: zt.tip, children: [
      /* @__PURE__ */ i.jsx(U, { name: "loan", className: zt.loanIcon, ariaHidden: !0 }),
      /* @__PURE__ */ i.jsxs(I, { component: "p", children: [
        "Total amount borrowed till now:",
        " ",
        /* @__PURE__ */ i.jsx("strong", { children: Je(o) })
      ] })
    ] }) }),
    /* @__PURE__ */ i.jsxs(E, { className: zt.sliderContainer, children: [
      /* @__PURE__ */ i.jsxs(E, { className: zt.sliderMinMaxValues, children: [
        /* @__PURE__ */ i.jsxs(I, { component: "p", children: [
          "Min amount ",
          /* @__PURE__ */ i.jsx("strong", { children: Je(n) })
        ] }),
        /* @__PURE__ */ i.jsxs(I, { component: "p", children: [
          "Max amount ",
          /* @__PURE__ */ i.jsx("strong", { children: Je(s) })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { className: zt.sliderInnerContainer, children: [
        /* @__PURE__ */ i.jsx(
          U,
          {
            name: "cornerSlider",
            ariaHidden: !0,
            className: R(zt.sliderCornerIcon, zt.sliderCornerIconLeft)
          }
        ),
        /* @__PURE__ */ i.jsx(
          Yu,
          {
            name: l,
            min: n,
            max: s,
            thumbLabel: "Additional funding",
            classNames: {
              root: zt.sliderRoot,
              track: zt.sliderTrack,
              thumb: zt.sliderThumb,
              bar: zt.sliderBar
            },
            onChange: a,
            value: r,
            step: d,
            thumbSize: 28
          }
        ),
        /* @__PURE__ */ i.jsx(
          U,
          {
            name: "cornerSlider",
            ariaHidden: !0,
            className: R(zt.sliderCornerIcon, zt.sliderCornerIconRight)
          }
        )
      ] }),
      /* @__PURE__ */ i.jsx(E, { role: "live", className: zt.currentAmountRequest, children: /* @__PURE__ */ i.jsxs(I, { component: "p", children: [
        "Your additional amount request: ",
        /* @__PURE__ */ i.jsx("strong", { children: Je(r) })
      ] }) })
    ] })
  ] }) });
}, L6 = "_container_s2um3_1", O6 = "_title_s2um3_14", F6 = "_description_s2um3_25", A6 = "_uploadSingleDocument_s2um3_36", M6 = "_actionsContainer_s2um3_40", D6 = "_deleteButton_s2um3_49", B6 = "_uploadDocumentButton_s2um3_66", W6 = "_error_s2um3_77", Es = {
  container: L6,
  title: O6,
  description: F6,
  uploadSingleDocument: A6,
  actionsContainer: M6,
  deleteButton: D6,
  uploadDocumentButton: B6,
  error: W6
}, SR = (e) => {
  const {
    title: t,
    description: n,
    name: s,
    type: r,
    className: o,
    error: a,
    file: l,
    setFileWithPath: d,
    disabled: c,
    accept: u,
    maxSize: h,
    s3FileDeleted: p
  } = e, f = dn(null), m = () => {
    d(null), p == null || p();
  }, g = () => {
    var v;
    (v = f.current) == null || v.call(f);
  };
  return /* @__PURE__ */ i.jsxs(E, { className: R(Es.container, o), children: [
    /* @__PURE__ */ i.jsx(ee, { order: 4, className: Es.title, children: t }),
    /* @__PURE__ */ i.jsx(I, { className: Es.description, children: n }),
    /* @__PURE__ */ i.jsx(
      Q9,
      {
        openRef: f,
        className: Es.uploadSingleDocument,
        type: r,
        label: t,
        name: s,
        file: l,
        onDrop: d,
        disabled: c,
        accept: u,
        maxSize: h
      }
    ),
    /* @__PURE__ */ i.jsxs(E, { className: Es.actionsContainer, children: [
      l && /* @__PURE__ */ i.jsxs(
        Ee,
        {
          disabled: c,
          className: Es.deleteButton,
          onClick: m,
          children: [
            /* @__PURE__ */ i.jsx(U, { name: "trashCan", ariaHidden: !0 }),
            /* @__PURE__ */ i.jsx("span", { children: "Delete" })
          ]
        }
      ),
      !l && /* @__PURE__ */ i.jsx(
        qe,
        {
          disabled: c,
          type: "button",
          variant: "filled",
          className: Es.uploadDocumentButton,
          onClick: g,
          uppercase: !0,
          children: l ? "Clear" : "Select file"
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: Es.error, style: { paddingTop: "8px" }, children: a == null ? void 0 : a.fieldErrors[s] })
  ] });
}, U6 = "_icon_5iiu8_1", z6 = "_root_5iiu8_6", H6 = "_input_5iiu8_17", q6 = "_label_5iiu8_36", G6 = "_error_5iiu8_42", Is = {
  icon: U6,
  root: z6,
  input: H6,
  label: q6,
  error: G6
}, kR = ({
  id: e,
  defaultValue: t,
  placeholder: n,
  label: s,
  className: r,
  error: o,
  type: a,
  maxLength: l = 200,
  // value,
  keyPress: d,
  keyUp: c,
  showEdit: u,
  redirectOnEdit: h,
  readOnly: p,
  sideButtonName: f = "Edit",
  updatedValue: m = (N) => N,
  ssn: g = !1,
  maskValue: v,
  style: _,
  step: $,
  onPaste: y,
  hidden: P,
  autoComplete: j,
  customClass: b
}) => {
  const N = dn(null), [C, S] = oe.useState(t), [F, W] = oe.useState(p), [D] = oe.useState(j || "off");
  ne(() => {
    S(t), W(p);
  }, [t, p]);
  const B = (q) => {
    q.currentTarget.value.length <= l && (S(q.currentTarget.value), m(q.currentTarget.value));
  };
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(
    Gl,
    {
      autosize: !0,
      classNames: {
        wrapper: R(Is.wrapper, b == null ? void 0 : b.root),
        input: R(Is.input, b == null ? void 0 : b.input),
        section: R(Is.section, b == null ? void 0 : b.section),
        root: R(Is.root, b == null ? void 0 : b.root),
        label: R(Is.label, b == null ? void 0 : b.label),
        required: R(Is.required, b == null ? void 0 : b.required),
        description: R(Is.description, b == null ? void 0 : b.description),
        error: R(Is.error, b == null ? void 0 : b.error)
      },
      className: r,
      id: e,
      "data-testid": e,
      name: e,
      value: v || C,
      onChange: B,
      label: s,
      placeholder: n,
      error: ((o == null ? void 0 : o.fieldErrors[e]) || []).join(", "),
      ref: N,
      onKeyPress: d,
      onKeyUp: c,
      readOnly: F && p,
      autoComplete: D,
      style: _,
      onPaste: y,
      hidden: P,
      role: "presentation",
      maxRows: 3
    }
  ) });
}, V6 = "_root_1xph0_1", Y6 = "_showDesktop_1xph0_13", K6 = "_button_1xph0_18", J6 = "_filledButton_1xph0_28", $i = {
  root: V6,
  showDesktop: Y6,
  button: K6,
  filledButton: J6
}, ER = ({
  outlineButtonOnClick: e,
  filledButtonOnClick: t,
  manageDataLayer: n,
  showOutlineButton: s,
  showFilledButton: r,
  outlineButtonText: o = "GO BACK",
  filledButtonText: a,
  showGutter: l = !0,
  uppercase: d = !0,
  id: c,
  backButtonId: u = "back",
  disabled: h = !1,
  loading: p,
  pageData: f,
  oppId: m,
  timeout: g
}) => {
  function v() {
    setTimeout(() => {
      t && t();
    }, 3e3);
  }
  const _ = ($) => {
    const y = window.dataLayer || [];
    m && y.push({
      oppId: m,
      moduleName: f == null ? void 0 : f.pageName,
      stepNumber: f == null ? void 0 : f.stepNumber
    }), g ? v() : t && t();
  };
  return /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsxs(T, { className: $i.root, children: [
    l && /* @__PURE__ */ i.jsx(T.Col, { span: { md: 3, sm: 0 }, className: $i.showDesktop }),
    /* @__PURE__ */ i.jsxs(T.Col, { span: { sm: 12, md: 9 }, children: [
      s && /* @__PURE__ */ i.jsx(
        qe,
        {
          variant: "outline",
          id: u,
          onClick: e,
          className: $i.button,
          children: o
        }
      ),
      r && /* @__PURE__ */ i.jsx(
        qe,
        {
          variant: "filled",
          onClick: _,
          type: "submit",
          uppercase: d,
          id: c,
          disabled: h,
          value: "create",
          loading: p,
          pageData: f,
          oppId: m,
          className: R($i.button, $i.filledButton),
          children: /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx("span", { children: a }) })
        }
      )
    ] })
  ] }) });
}, Lr = () => {
  const e = dn(null);
  return [e, () => {
    e.current && e.current.focus();
  }];
}, Z6 = "_wrapper_176f2_2", X6 = "_wrapper2_176f2_8", Q6 = "_gridCol_176f2_13", e5 = "_box_176f2_27", t5 = "_boxError_176f2_59", n5 = "_span_176f2_76", s5 = "_spanLength_176f2_87", r5 = "_spanError_176f2_99", i5 = "_error_176f2_111", o5 = "_text_176f2_126", a5 = "_codeGrid_176f2_144", l5 = "_firstCodeCol_176f2_164", d5 = "_secondCodeCol_176f2_170", c5 = "_errorClass_176f2_190", Ke = {
  wrapper: Z6,
  wrapper2: X6,
  gridCol: Q6,
  box: e5,
  boxError: t5,
  span: n5,
  spanLength: s5,
  spanError: r5,
  error: i5,
  text: o5,
  codeGrid: a5,
  firstCodeCol: l5,
  secondCodeCol: d5,
  errorClass: c5
}, IR = ({ id: e, name: t, error: n, showError: s }) => {
  const [r, o] = O(""), [a, l] = O(""), [d, c] = O(""), [u, h] = O(""), [p, f] = O(""), [m, g] = O(""), [v, _] = O(""), [$, y] = O(!1), [P, j] = O(!1), [b, N] = Lr(), [C, S] = Lr(), [F, W] = Lr(), [D, B] = Lr(), [q, G] = Lr(), [z, re] = Lr();
  ne(() => {
    N();
  }, []), ne(() => {
    _(r + a + d + u + p + m);
  }, [r, a, d, u, p, m]), ne(() => {
    s && (n == null ? void 0 : n.fieldErrors[e][0]) === "Please enter the code" && j(!0);
  }, [v, n, s]);
  const X = $ ? Ke.spanLength : Ke.span, Q = P ? Ke.spanError : X;
  return /* @__PURE__ */ i.jsxs(Hs, { style: { width: "100%" }, children: [
    /* @__PURE__ */ i.jsxs(T, { className: Ke.text, children: [
      /* @__PURE__ */ i.jsx(T.Col, { span: 4, style: { textAlign: "right", paddingRight: "0" }, children: /* @__PURE__ */ i.jsx(ee, { order: 1, variant: "blue", children: "Please" }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 8, children: /* @__PURE__ */ i.jsx(ee, { order: 1, variant: "yellow", children: "enter the code " }) })
    ] }),
    /* @__PURE__ */ i.jsx($t, { h: 40 }),
    /* @__PURE__ */ i.jsx("div", { className: Ke.wrapper, children: /* @__PURE__ */ i.jsx(T, { children: /* @__PURE__ */ i.jsx(T.Col, { span: 12, children: /* @__PURE__ */ i.jsx(ee, { order: 5, variant: "blue", fontWeight: "700", children: "Code:" }) }) }) }),
    /* @__PURE__ */ i.jsxs(T, { gutter: 1, className: Ke.codeGrid, children: [
      /* @__PURE__ */ i.jsx(T.Col, { span: { xs: 0, base: 2 }, className: Ke.firstCodeCol }),
      /* @__PURE__ */ i.jsx(T.Col, { span: { xs: 1, base: 1 }, className: Ke.secondCodeCol, children: /* @__PURE__ */ i.jsx("div", { className: Ke.wrapper2, children: /* @__PURE__ */ i.jsx(ee, { order: 5, variant: "blue", fontWeight: "700", children: "Code:" }) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: r,
          maxLength: 1,
          className: Q,
          ref: b,
          onChange: (M) => {
            o(M.target.value.toUpperCase()), y(!0), M.target.value.length >= 1 && S();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: a,
          ref: C,
          maxLength: 1,
          className: Q,
          onChange: (M) => {
            l(M.target.value.toUpperCase()), M.target.value.length >= 1 && W();
          },
          onKeyDown: (M) => {
            M.key === "Backspace" && a.length === 0 && N();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: d,
          ref: F,
          maxLength: 1,
          className: Q,
          onChange: (M) => {
            c(M.target.value.toUpperCase()), M.target.value.length >= 1 && B();
          },
          onKeyDown: (M) => {
            M.key === "Backspace" && d.length === 0 && S();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: u,
          ref: D,
          maxLength: 1,
          className: Q,
          onChange: (M) => {
            h(M.target.value.toUpperCase()), M.target.value.length >= 1 && G();
          },
          onKeyDown: (M) => {
            M.key === "Backspace" && u.length === 0 && W();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: p,
          ref: q,
          maxLength: 1,
          className: Q,
          onChange: (M) => {
            f(M.target.value.toUpperCase()), M.target.value.length >= 1 && re();
          },
          onKeyDown: (M) => {
            M.key === "Backspace" && p.length === 0 && B();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 1, className: Ke.gridCol, children: /* @__PURE__ */ i.jsx(Hn, { className: P ? Ke.boxError : Ke.box, children: /* @__PURE__ */ i.jsx(
        "input",
        {
          value: m,
          ref: z,
          maxLength: 1,
          className: Q,
          onChange: (M) => {
            g(M.target.value.toUpperCase()), M.target.value.length >= 1 && N();
          },
          onKeyDown: (M) => {
            M.key === "Backspace" && m.length === 0 && G();
          }
        }
      ) }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: 3 })
    ] }),
    /* @__PURE__ */ i.jsx("input", { type: "hidden", name: t, id: e, value: v }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    P && /* @__PURE__ */ i.jsxs(T, { justify: "center", children: [
      /* @__PURE__ */ i.jsx(T.Col, { span: { xs: 0, base: 2, sm: 1, md: 2 } }),
      /* @__PURE__ */ i.jsx(T.Col, { span: { xs: 12, base: 8, sm: 10, md: 8 }, pl: 1, className: Ke.error, children: /* @__PURE__ */ i.jsx(ee, { variant: "black", order: 6, className: Ke.errorClass, children: "X    Please enter the code provided on the support letter" }) }),
      /* @__PURE__ */ i.jsx(T.Col, { span: { xs: 0, base: 2, sm: 1, md: 2 } })
    ] })
  ] });
}, u5 = "_container_jfkvm_1", h5 = "_table_jfkvm_5", f5 = "_fundingRow_jfkvm_49", p5 = "_nameText_jfkvm_56", _5 = "_statusLabel_jfkvm_64", m5 = "_statusLabelFutureDue_jfkvm_79", g5 = "_statusLabelDue_jfkvm_85", v5 = "_actionButton_jfkvm_91", sr = {
  container: u5,
  table: h5,
  fundingRow: f5,
  nameText: p5,
  statusLabel: _5,
  statusLabelFutureDue: m5,
  statusLabelDue: g5,
  actionButton: v5
}, PR = (e) => {
  const { loans: t, className: n, actionsVisible: s = !0 } = e, r = t.some(
    (a) => ql(a == null ? void 0 : a.opportunityType) && a.name
  ), o = !!t.find((a) => a.opportunityType === Ed.REFI && a.name);
  return /* @__PURE__ */ i.jsx(E, { className: R(sr.container, n), children: /* @__PURE__ */ i.jsxs(Kl, { className: sr.table, children: [
    /* @__PURE__ */ i.jsx("thead", { children: /* @__PURE__ */ i.jsxs("tr", { children: [
      /* @__PURE__ */ i.jsx("th", { children: "Loan ID" }),
      r && /* @__PURE__ */ i.jsx("th", { children: "School Name" }),
      /* @__PURE__ */ i.jsx("th", { children: "Status" }),
      o && /* @__PURE__ */ i.jsx("th", { children: "Principal balance" }),
      o && /* @__PURE__ */ i.jsx("th", { children: "Current due" }),
      s && /* @__PURE__ */ i.jsx("th", { children: "Actions" })
    ] }) }),
    /* @__PURE__ */ i.jsx("tbody", { children: t.map((a) => /* @__PURE__ */ i.jsxs("tr", { className: R(sr.fundingRow), children: [
      /* @__PURE__ */ i.jsx("td", { "aria-label": a.loanID ? void 0 : "No value", children: a.loanID ? a.loanID : "--" }),
      r && /* @__PURE__ */ i.jsx("td", { "aria-label": a.name ? void 0 : "No value", children: a.name }),
      /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(
        I,
        {
          span: !0,
          className: R(
            sr.statusLabel,
            a.statusState === "futureDue" && sr.statusLabelFutureDue,
            a.statusState === "due" && sr.statusLabelDue
          ),
          children: a.statusLabel
        }
      ) }),
      o && /* @__PURE__ */ i.jsx("td", { children: a != null && a.currentPrincipalBalance ? Je(a == null ? void 0 : a.currentPrincipalBalance) : "-" }),
      o && /* @__PURE__ */ i.jsx("td", { children: a != null && a.currentlyDue ? Je(a == null ? void 0 : a.currentlyDue) : "-" }),
      s && (a.onComplete && a.completeButtonLabel ? /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx(
        qe,
        {
          variant: "filled",
          className: sr.actionButton,
          onClick: a.onComplete,
          children: a.completeButtonLabel
        }
      ) }) : /* @__PURE__ */ i.jsx("td", { "aria-label": "No action" }))
    ] }, a.loanID)) })
  ] }) });
}, $5 = "_tableHeader_h99wi_1", b5 = "_tableGrid_h99wi_8", x5 = "_switchFlex_h99wi_13", y5 = "_switchFlexPaid_h99wi_33", w5 = "_switchFlexPending_h99wi_43", C5 = "_tableGridRow_h99wi_53", j5 = "_cancelButton_h99wi_63", N5 = "_outlineButton_h99wi_71", S5 = "_viewMoreOrLess_h99wi_81", k5 = "_hiddenMobile_h99wi_91", E5 = "_hiddenDesktop_h99wi_100", I5 = "_colSpace_h99wi_110", P5 = "_tableItmes_h99wi_117", T5 = "_inner_h99wi_127", R5 = "_actionContainer_h99wi_132", me = {
  tableHeader: $5,
  tableGrid: b5,
  switchFlex: x5,
  switchFlexPaid: y5,
  switchFlexPending: w5,
  tableGridRow: C5,
  cancelButton: j5,
  outlineButton: N5,
  viewMoreOrLess: S5,
  hiddenMobile: k5,
  hiddenDesktop: E5,
  colSpace: I5,
  tableItmes: P5,
  inner: T5,
  actionContainer: R5
}, TR = ({
  disbursements: e,
  className: t,
  showActionCol: n = !0
}) => {
  const [s, r] = O(!1), o = e, a = o == null ? void 0 : o.slice(0, 2), l = o == null ? void 0 : o.slice(2, o == null ? void 0 : o.length), d = (u) => {
    switch (u) {
      case "D":
        return "Disbursed";
      case "A":
        return "Awaiting/Upcoming";
      case "S":
        return "Cancelled";
      case "P":
        return "Partially Cancelled";
      default:
        return "NA";
    }
  }, c = (u, h) => {
    var p, f;
    return u ? (p = Re(u)) == null ? void 0 : p.format("MMMM D YYYY") : h ? (f = Re(h)) == null ? void 0 : f.format("MMMM D YYYY") : "-";
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(
      T,
      {
        className: R(me.tableGridRow, me.hiddenMobile),
        gutter: { xs: "md", md: "xl", xl: 15 },
        justify: "space-between",
        align: "center",
        m: 0,
        p: 24,
        classNames: { inner: me.inner },
        children: [
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 3 }, children: /* @__PURE__ */ i.jsx(I, { className: me.tableHeader, children: "Status" }) }),
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 2 }, children: /* @__PURE__ */ i.jsx(I, { className: me.tableHeader, children: "Amount" }) }),
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 3 }, children: /* @__PURE__ */ i.jsx(I, { className: me.tableHeader, children: "Payment date" }) }),
          n && /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 4 }, children: /* @__PURE__ */ i.jsx(I, { className: me.tableHeader, style: { float: "right" }, children: "Action for Disbursement" }) })
        ]
      }
    ),
    a.map((u) => /* @__PURE__ */ i.jsxs(
      T,
      {
        className: me.tableGridRow,
        gutter: { xs: "md", md: "xl", xl: 15 },
        justify: "space-between",
        align: "center",
        m: 0,
        p: 24,
        classNames: { inner: me.inner },
        children: [
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 3 }, children: /* @__PURE__ */ i.jsxs(T, { className: me.colSpace, p: 0, classNames: { inner: me.inner }, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Status" }),
            /* @__PURE__ */ i.jsxs(
              E,
              {
                className: R(
                  me.switchFlex,
                  u.status === "D" && me.switchFlexPaid,
                  u.status === "S" && me.switchFlexPending,
                  u.status === "P" && me.switchFlexPending
                ),
                justify: "flex-start",
                align: "flex-start",
                direction: "row",
                children: [
                  /* @__PURE__ */ i.jsx("div", {}),
                  /* @__PURE__ */ i.jsx(I, { component: "p", children: d(u.status) })
                ]
              }
            )
          ] }) }),
          /* @__PURE__ */ i.jsxs(T.Col, { span: { lg: 2, xs: 12, sm: 12, md: 2 }, className: me.colSpace, p: 0, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Amount" }),
            /* @__PURE__ */ i.jsxs(I, { className: me.tableItmes, children: [
              " ",
              Je(u == null ? void 0 : u.loanAmount)
            ] })
          ] }),
          /* @__PURE__ */ i.jsxs(T.Col, { span: { lg: 3, xs: 12, sm: 12, md: 3 }, className: me.colSpace, p: 0, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Payment date" }),
            /* @__PURE__ */ i.jsxs(I, { className: me.tableItmes, children: [
              c(u.disbDate, u.projectedDisbDate),
              " "
            ] })
          ] }),
          n && /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 4, xs: 12, sm: 12, md: 3 }, p: 0, children: /* @__PURE__ */ i.jsxs(
            E,
            {
              justify: "flex-end",
              align: "flex-start",
              direction: "row",
              className: me.actionContainer,
              children: [
                u.showHoldButton && /* @__PURE__ */ i.jsx(
                  Jt,
                  {
                    variant: "outline",
                    tt: "uppercase",
                    id: "hold",
                    className: me.outlineButton,
                    onClick: u.onHold,
                    children: "hold payment"
                  }
                ),
                u.showCancelButton && /* @__PURE__ */ i.jsx(Ee, { onClick: u.onCancel, children: /* @__PURE__ */ i.jsx(I, { className: me.cancelButton, children: "Cancel" }) })
              ]
            }
          ) })
        ]
      },
      u.id
    )),
    /* @__PURE__ */ i.jsx(Hr, { in: s, children: l.map((u) => /* @__PURE__ */ i.jsxs(
      T,
      {
        className: me.tableGridRow,
        gutter: { xs: "md", md: "xl", xl: 15 },
        justify: "space-between",
        align: "center",
        m: 0,
        p: 24,
        classNames: { inner: me.inner },
        children: [
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 3 }, children: /* @__PURE__ */ i.jsxs(T, { className: me.colSpace, p: 0, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Status" }),
            /* @__PURE__ */ i.jsxs(
              E,
              {
                className: R(
                  me.switchFlex,
                  u.status === "D" && me.switchFlexPaid,
                  u.status === "S" && me.switchFlexPending,
                  u.status === "P" && me.switchFlexPending
                ),
                justify: "flex-start",
                align: "flex-start",
                direction: "row",
                children: [
                  /* @__PURE__ */ i.jsx("div", {}),
                  /* @__PURE__ */ i.jsx(I, { component: "p", children: d(u.status) })
                ]
              }
            )
          ] }) }),
          /* @__PURE__ */ i.jsxs(T.Col, { span: { lg: 2, xs: 12, sm: 12, md: 2 }, className: me.colSpace, p: 0, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Amount" }),
            /* @__PURE__ */ i.jsxs(I, { className: me.tableItmes, children: [
              " ",
              Je(u == null ? void 0 : u.loanAmount)
            ] })
          ] }),
          /* @__PURE__ */ i.jsxs(T.Col, { span: { lg: 3, xs: 12, sm: 12, md: 3 }, className: me.colSpace, p: 0, children: [
            /* @__PURE__ */ i.jsx(I, { className: R(me.tableHeader, me.hiddenDesktop), children: "Payment date" }),
            /* @__PURE__ */ i.jsxs(I, { className: me.tableItmes, children: [
              c(u.disbDate, u.projectedDisbDate),
              " "
            ] })
          ] }),
          /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 4, xs: 12, sm: 12, md: 4 }, p: 0, children: /* @__PURE__ */ i.jsxs(E, { justify: "flex-end", align: "flex-start", direction: "row", children: [
            u.showHoldButton && /* @__PURE__ */ i.jsx(
              Jt,
              {
                variant: "outline",
                tt: "uppercase",
                id: "hold",
                className: me.outlineButton,
                onClick: u.onHold,
                children: "hold payment"
              }
            ),
            u.showCancelButton && /* @__PURE__ */ i.jsx(Ee, { onClick: u.onCancel, children: /* @__PURE__ */ i.jsx(I, { className: me.cancelButton, children: "Cancel" }) })
          ] }) })
        ]
      },
      u.id
    )) }),
    (l == null ? void 0 : l.length) > 0 && /* @__PURE__ */ i.jsx(T, { justify: "flex-end", m: 0, children: /* @__PURE__ */ i.jsx(T.Col, { offset: 9, span: { lg: 3, sm: 3 }, children: /* @__PURE__ */ i.jsx(
      Ee,
      {
        className: me.viewMoreOrLess,
        onClick: () => r((u) => !u),
        children: s ? "Hidden" : "View more"
      }
    ) }) })
  ] });
}, L5 = "_chartCard_1q9b2_1", O5 = "_chartBoldText_1q9b2_17", F5 = "_chartText_1q9b2_24", A5 = "_chartBottomText_1q9b2_31", M5 = "_root_1q9b2_39", D5 = "_chartData_1q9b2_47", B5 = "_applymoreBtn_1q9b2_52", W5 = "_svg_1q9b2_56", Ps = {
  chartCard: L5,
  chartBoldText: O5,
  chartText: F5,
  chartBottomText: A5,
  root: M5,
  chartData: D5,
  applymoreBtn: B5,
  svg: W5
}, RR = (e) => {
  const { totalLoan: t, usedLoan: n, startNewApplicationClick: s } = e, r = n * 100 / t, o = 100 - r;
  return /* @__PURE__ */ i.jsx(cn, { classNames: { root: Ps.chartCard }, children: /* @__PURE__ */ i.jsxs(T, { align: "center", children: [
    /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 6, sm: 12, xs: 12 }, children: /* @__PURE__ */ i.jsx(
      Xu,
      {
        size: 300,
        thickness: 35,
        classNames: { svg: Ps.svg, root: Ps.svg },
        sections: [
          {
            value: r,
            color: "#32B4F0",
            tooltip: `${Je(n)} Used`
          },
          {
            value: o,
            color: "#8CDDF9",
            tooltip: `${Je(t - n)} Unused`
          }
        ],
        label: /* @__PURE__ */ i.jsxs(E, { direction: "column", style: { textAlign: "center" }, children: [
          /* @__PURE__ */ i.jsxs(I, { className: Ps.chartText, children: [
            "Total amount you",
            /* @__PURE__ */ i.jsx("br", {}),
            " can borrow"
          ] }),
          /* @__PURE__ */ i.jsx(I, { className: Ps.chartBoldText, children: Je(t) })
        ] })
      }
    ) }),
    /* @__PURE__ */ i.jsxs(T.Col, { span: { lg: 6, sm: 12, xs: 12 }, className: Ps.chartData, children: [
      /* @__PURE__ */ i.jsx(ee, { order: 2, fontWeight: "400", variant: "blue", className: "displayInline", children: "Did you" }),
      /* @__PURE__ */ i.jsxs(ee, { order: 2, fontWeight: "700", variant: "yellow", className: "displayInline", children: [
        "need",
        /* @__PURE__ */ i.jsx("br", {}),
        " more money?"
      ] }),
      /* @__PURE__ */ i.jsx($t, { h: 20 }),
      /* @__PURE__ */ i.jsx(
        Jt,
        {
          variant: "filled",
          tt: "uppercase",
          className: Ps.applymoreBtn,
          onClick: s,
          children: "apply for more"
        }
      ),
      /* @__PURE__ */ i.jsx(I, { className: Ps.chartBottomText, children: "# Your approved loans are subjected to academic success, payment on time and other conditions apply." })
    ] })
  ] }) });
}, U5 = "_card_alyc7_1", z5 = "_cardClickable_alyc7_36", H5 = "_cardFunding_alyc7_41", q5 = "_contentContainer_alyc7_46", G5 = "_name_alyc7_52", V5 = "_statusLabel_alyc7_72", Y5 = "_statusLabelFutureDue_alyc7_96", K5 = "_statusLabelDue_alyc7_102", J5 = "_statusLabelDone_alyc7_108", Z5 = "_list_alyc7_114", X5 = "_icon_alyc7_146", Q5 = "_iconMoneyHand_alyc7_152", e7 = "_iconRoadToFlag_alyc7_165", t7 = "_actionsContainer_alyc7_178", n7 = "_needMoneyButton_alyc7_191", s7 = "_completeButton_alyc7_208", r7 = "_infoIcon_alyc7_230", fn = {
  card: U5,
  cardClickable: z5,
  cardFunding: H5,
  contentContainer: q5,
  name: G5,
  statusLabel: V5,
  statusLabelFutureDue: Y5,
  statusLabelDue: K5,
  statusLabelDone: J5,
  list: Z5,
  icon: X5,
  iconMoneyHand: Q5,
  iconRoadToFlag: e7,
  actionsContainer: t7,
  needMoneyButton: n7,
  completeButton: s7,
  infoIcon: r7
}, LR = (e) => {
  const {
    statusLabel: t,
    statusState: n,
    name: s,
    loanID: r,
    amountDue: o,
    loanAmount: a,
    className: l,
    onNeedMoreMoney: d,
    onComplete: c,
    completeButtonLabel: u,
    currentPrincipalBalance: h,
    currentlyDue: p,
    actionsVisible: f = !0,
    repeatBorrower: m,
    borderColor: g,
    iconStatus: v,
    isNoc: _,
    uploadNoc: $,
    isNocUploaded: y = !1,
    opportunityType: P
  } = e, j = Ve("(min-width: 768px)"), b = (F) => (W) => {
    W.preventDefault(), W.stopPropagation(), F == null || F();
  }, N = () => {
    if (j) {
      if (u && c) {
        c();
        return;
      }
      m && d && d();
    }
  }, C = !!j && (!!u && !!c || !!m && !!d), S = (F) => {
    switch (F) {
      case "tuitionBill":
        return /* @__PURE__ */ i.jsx(U, { name: "uploadTutionBillCircle" });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ i.jsxs(
    cn,
    {
      className: R(fn.card, C && fn.cardClickable, l),
      style: { border: `2px solid ${g}`, backgroundImage: `url(${od})` },
      onClick: N,
      role: C ? "button" : void 0,
      tabIndex: C ? 0 : void 0,
      onKeyDown: C ? (F) => {
        (F.key === "Enter" || F.key === " ") && (F.preventDefault(), N());
      } : void 0,
      children: [
        v && /* @__PURE__ */ i.jsx("div", { className: fn.infoIcon, children: S(v) }),
        /* @__PURE__ */ i.jsxs(E, { className: fn.contentContainer, children: [
          /* @__PURE__ */ i.jsx(Jl, { label: s, children: /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(ee, { className: fn.name, order: 3, fontWeight: "700", children: s }) }) }),
          /* @__PURE__ */ i.jsx(
            ee,
            {
              className: R(
                fn.statusLabel,
                n === "futureDue" && fn.statusLabelFutureDue,
                n === "due" && fn.statusLabelDue,
                n === "done" && fn.statusLabelDone
              ),
              order: 4,
              fontWeight: "initial",
              children: t
            }
          ),
          /* @__PURE__ */ i.jsxs(Be, { className: fn.list, children: [
            /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsx(I, { span: !0, children: "Loan ID: " }),
              /* @__PURE__ */ i.jsx(I, { span: !0, children: r || "--" })
            ] }),
            /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsx(I, { span: !0, children: "Principal Balance: " }),
              /* @__PURE__ */ i.jsx(I, { span: !0, children: h ? Je(h) : "--" })
            ] }),
            /* @__PURE__ */ i.jsxs(Be.Item, { children: [
              /* @__PURE__ */ i.jsx(I, { span: !0, children: "Currently due: " }),
              /* @__PURE__ */ i.jsx(I, { span: !0, children: p ? Je(p) : "--" })
            ] })
          ] })
        ] }),
        f && /* @__PURE__ */ i.jsxs(E, { className: fn.actionsContainer, children: [
          m && /* @__PURE__ */ i.jsx(
            Ee,
            {
              className: fn.needMoneyButton,
              onClick: b(d),
              children: "Need more money?"
            }
          ),
          P === lh.REFI && _ && !y && /* @__PURE__ */ i.jsx(
            Ee,
            {
              className: fn.needMoneyButton,
              onClick: b($),
              children: "Upload Noc"
            }
          ),
          /* @__PURE__ */ i.jsx(
            qe,
            {
              className: fn.completeButton,
              onClick: b(c),
              uppercase: !0,
              children: u
            }
          )
        ] })
      ]
    }
  );
}, i7 = "_radio_1ehgo_1", o7 = "_card_1ehgo_11", a7 = "_confirmText_1ehgo_27", l7 = "_singleCheckbox_1ehgo_33", d7 = "_body_1ehgo_48", c7 = "_labelWrapper_1ehgo_54", u7 = "_label_1ehgo_54", h7 = "_cardHeader_1ehgo_63", rr = {
  radio: i7,
  card: o7,
  confirmText: a7,
  singleCheckbox: l7,
  body: d7,
  labelWrapper: c7,
  label: u7,
  cardHeader: h7
}, OR = (e) => {
  const { disbursements: t, id: n, defaultValue: s, error: r } = e, o = t, [a, l] = O(s || []), d = (u) => {
    u.target.checked ? l((h) => [...h, u.target.value]) : l((h) => {
      const p = h.indexOf(u.target.value);
      return p > -1 && h.splice(p, 1), [...h];
    });
  }, c = (u, h) => {
    var p, f;
    return u ? (p = Re(u)) == null ? void 0 : p.format("MMMM D YYYY") : h ? (f = Re(h)) == null ? void 0 : f.format("MMMM D YYYY") : "-";
  };
  return /* @__PURE__ */ i.jsxs(cn, { classNames: { root: rr.card }, children: [
    /* @__PURE__ */ i.jsx(I, { className: rr.cardHeader, children: "Pick the disbursement this is about." }),
    /* @__PURE__ */ i.jsx($t, { h: 15 }),
    /* @__PURE__ */ i.jsx(
      $r.Group,
      {
        value: a,
        "data-testid": n,
        id: n,
        error: ((r == null ? void 0 : r.fieldErrors[n]) || []).join(", "),
        style: { margin: "15px 0" },
        "aria-labelledby": "checkbox-group",
        children: o == null ? void 0 : o.map(
          (u, h) => u.eligibleForAction && /* @__PURE__ */ i.jsx(
            $r,
            {
              onClick: d,
              value: u.id,
              label: /* @__PURE__ */ i.jsxs(I, { className: rr.confirmText, children: [
                Je(u == null ? void 0 : u.loanAmount),
                " Projected Disbursement",
                /* @__PURE__ */ i.jsx("br", {}),
                "Date:",
                " ",
                /* @__PURE__ */ i.jsx(i.Fragment, { children: c(u.disbDate, u.projectedDisbDate) }),
                /* @__PURE__ */ i.jsx("br", {}),
                "Status: ",
                u != null && u.status ? u == null ? void 0 : u.status : "-"
              ] }),
              name: n,
              classNames: {
                label: rr.label,
                labelWrapper: rr.labelWrapper,
                body: rr.body
              },
              className: rr.singleCheckbox
            },
            h
          )
        )
      }
    )
  ] });
}, f7 = "_container_101cz_1", p7 = "_alertCircleIcon_101cz_23", _7 = "_text_101cz_29", m7 = "_welcomeText_101cz_44", g7 = "_sendEmailButton_101cz_55", v7 = "_modal_101cz_64", $7 = "_modalBody_101cz_77", b7 = "_modalTitle_101cz_89", x7 = "_modalText_101cz_102", y7 = "_modalButton_101cz_118", Tn = {
  container: f7,
  alertCircleIcon: p7,
  text: _7,
  welcomeText: m7,
  sendEmailButton: g7,
  modal: v7,
  modalBody: $7,
  modalTitle: b7,
  modalText: x7,
  modalButton: y7
}, FR = (e) => {
  const { confirmed: t, className: n, onCloseEmailConfirmedModal: s, emailConfirmedModalOpen: r } = e, [o, a] = O(!1), [l, d] = O(!1), c = () => {
    a(!0), d(!1);
  };
  return /* @__PURE__ */ i.jsxs(E, { className: R(Tn.container, n), role: "banner", "aria-hidden": t, children: [
    /* @__PURE__ */ i.jsx(I, { className: Tn.text, children: o && /* @__PURE__ */ i.jsx(i.Fragment, { children: "Your confirmation email has been sent!" }) }),
    /* @__PURE__ */ i.jsxs(
      Nn,
      {
        centered: !0,
        size: "100%",
        opened: l,
        withCloseButton: !1,
        onClose: c,
        classNames: { content: Tn.modal, body: Tn.modalBody },
        radius: "lg",
        children: [
          /* @__PURE__ */ i.jsx(ee, { order: 3, className: Tn.modalTitle, children: "Confirmation request" }),
          /* @__PURE__ */ i.jsx(I, { className: Tn.modalText, children: "A confirmation request has been sent to your email." }),
          /* @__PURE__ */ i.jsx(qe, { uppercase: !0, className: Tn.modalButton, onClick: c, children: "Ok" })
        ]
      }
    ),
    /* @__PURE__ */ i.jsxs(
      Nn,
      {
        centered: !0,
        size: "100%",
        opened: r,
        withCloseButton: !1,
        onClose: s,
        classNames: { content: Tn.modal, body: Tn.modalBody },
        radius: "lg",
        children: [
          /* @__PURE__ */ i.jsx(ee, { order: 4, className: Tn.modalTitle, children: "A quick note" }),
          /* @__PURE__ */ i.jsx(I, { className: Tn.modalText, children: "Thank you for verifying your email." }),
          /* @__PURE__ */ i.jsx(qe, { uppercase: !0, className: Tn.modalButton, onClick: s, children: "Continue" })
        ]
      }
    )
  ] });
}, w7 = "_modal_gsmbv_1", C7 = "_modalBody_gsmbv_14", j7 = "_modalClose_gsmbv_26", N7 = "_text_gsmbv_37", S7 = "_buttonsContainer_gsmbv_45", k7 = "_button_gsmbv_45", E7 = "_buttonCancel_gsmbv_85", Ts = {
  modal: w7,
  modalBody: C7,
  modalClose: j7,
  text: N7,
  buttonsContainer: S7,
  button: k7,
  buttonCancel: E7
}, AR = (e) => {
  const { onCancel: t, onConfirm: n, opened: s } = e;
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: "100%",
      opened: s,
      onClose: t,
      classNames: { content: Ts.modal, body: Ts.modalBody, close: Ts.modalClose },
      centered: !0,
      children: [
        /* @__PURE__ */ i.jsx(I, { className: Ts.text, children: "I hereby checked that this payoff statement has all amount transfer details - like account number, IFSC/SWIFT code etc." }),
        /* @__PURE__ */ i.jsxs(E, { className: Ts.buttonsContainer, children: [
          /* @__PURE__ */ i.jsx(qe, { onClick: t, className: R(Ts.button, Ts.buttonCancel), children: "Go back" }),
          /* @__PURE__ */ i.jsx(qe, { onClick: n, className: Ts.button, children: "Upload" })
        ] })
      ]
    }
  );
}, I7 = "_modal_ddgb3_1", P7 = "_modalHeader_ddgb3_12", T7 = "_modalBody_ddgb3_16", R7 = "_contentContainer_ddgb3_25", L7 = "_icon_ddgb3_30", O7 = "_divider_ddgb3_42", F7 = "_title_ddgb3_53", A7 = "_description_ddgb3_71", M7 = "_buttonsContainer_ddgb3_85", D7 = "_button_ddgb3_85", B7 = "_confirmButton_ddgb3_120", wn = {
  modal: I7,
  modalHeader: P7,
  modalBody: T7,
  contentContainer: R7,
  icon: L7,
  divider: O7,
  title: F7,
  description: A7,
  buttonsContainer: M7,
  button: D7,
  confirmButton: B7
}, MR = (e) => {
  const {
    opened: t,
    onCancel: n,
    onConfirm: s,
    headerText: r,
    subHeaderText: o,
    paragraphText: a,
    secButtonText: l = "No",
    primaryButtonText: d = "Yes"
  } = e;
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: "100%",
      radius: "lg",
      classNames: { content: wn.modal, header: wn.modalHeader, body: wn.modalBody },
      opened: t,
      onClose: n,
      centered: !0,
      children: [
        /* @__PURE__ */ i.jsxs(E, { className: wn.contentContainer, children: [
          /* @__PURE__ */ i.jsx(U, { name: "circularRedCross", className: wn.icon }),
          /* @__PURE__ */ i.jsx(Vn, { w: "100%", color: gn.softGray, className: wn.divider }),
          r && /* @__PURE__ */ i.jsxs(ee, { order: 4, className: wn.title, fontWeight: "initial", children: [
            r,
            " ",
            /* @__PURE__ */ i.jsx("br", {}),
            /* @__PURE__ */ i.jsx("strong", { children: o })
          ] }),
          a && /* @__PURE__ */ i.jsx(I, { className: wn.description, component: "p", children: a })
        ] }),
        /* @__PURE__ */ i.jsxs(E, { className: wn.buttonsContainer, children: [
          l && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "outline",
              className: R(wn.button, wn.cancelButton),
              onClick: n,
              children: l
            }
          ),
          d && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "filled",
              className: R(wn.button, wn.confirmButton),
              onClick: s,
              children: d
            }
          )
        ] })
      ]
    }
  );
}, W7 = "_modal_1sx73_1", U7 = "_modalHeader_1sx73_12", z7 = "_modalBody_1sx73_18", H7 = "_contentContainer_1sx73_27", q7 = "_buttonsContainer_1sx73_32", G7 = "_button_1sx73_32", V7 = "_confirmButton_1sx73_69", cs = {
  modal: W7,
  modalHeader: U7,
  modalBody: z7,
  contentContainer: H7,
  buttonsContainer: q7,
  button: G7,
  confirmButton: V7
}, Y7 = (e) => {
  const {
    size: t = "100%",
    children: n,
    opened: s,
    onCancel: r,
    onConfirm: o,
    secButtonText: a,
    primaryButtonText: l,
    loading: d = !1,
    isCustomBodyClassRequire: c = !1,
    primaryButtonDisabled: u = !1,
    type: h = "button",
    customBodyClass: p,
    zIndex: f
  } = e;
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: t,
      classNames: {
        content: cs.modal,
        header: cs.modalHeader,
        body: c ? p : cs.modalBody
      },
      opened: s,
      onClose: r,
      centered: !0,
      radius: "lg",
      zIndex: f,
      children: [
        /* @__PURE__ */ i.jsx(E, { className: cs.contentContainer, children: n }),
        /* @__PURE__ */ i.jsxs(E, { className: cs.buttonsContainer, children: [
          a && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "outline",
              className: R(cs.button, cs.cancelButton),
              onClick: r,
              children: a
            }
          ),
          l && /* @__PURE__ */ i.jsx(
            qe,
            {
              variant: "filled",
              disabled: u,
              className: R(cs.button, cs.confirmButton),
              onClick: o,
              loading: d,
              type: h,
              children: l
            }
          )
        ] })
      ]
    }
  );
}, K7 = "_card_16smo_1", J7 = "_statusLabel_16smo_15", Z7 = "_name_16smo_43", X7 = "_loanDetailsText_16smo_56", Q7 = "_loanDetailsBlock_16smo_70", eC = "_loanDetailsInner_16smo_87", tC = "_right_16smo_99", nC = "_dueBlock_16smo_103", sC = "_dueDetails_16smo_116", rC = "_dueDetailsBorder_16smo_121", iC = "_dueText_16smo_129", oC = "_currentDueText_16smo_135", aC = "_dueHeaderText_16smo_141", lC = "_collapse_16smo_147", dC = "_paymentBox_16smo_152", cC = "_paymentBoxSelected_16smo_167", uC = "_paymentType_16smo_171", hC = "_paymentMethod_16smo_175", fC = "_paymentCountry_16smo_180", pC = "_payNowBtn_16smo_185", _C = "_buttonWrap_16smo_194", mC = "_pricipalBalance_16smo_203", gC = "_balanceAmount_16smo_217", vC = "_viewMoreOrLess_16smo_231", $C = "_dataHeader_16smo_240", bC = "_dataHeaderDetails_16smo_246", xC = "_arrow_16smo_252", yC = "_spin_16smo_1", wC = "_toggleButtonExpanded_16smo_257", CC = "_subHeader_16smo_261", jC = "_iconTextContainer_16smo_267", NC = "_statusLabelRegistered_16smo_276", SC = "_statusLabelUnRegistered_16smo_287", kC = "_viewMoreOrLessBtnWrapper_16smo_298", EC = "_mobileViewWrapper_16smo_303", IC = "_error_16smo_314", PC = "_errorWrap_16smo_318", TC = "_fw400_16smo_324", RC = "_fw700_16smo_328", LC = "_inner_16smo_332", K = {
  card: K7,
  statusLabel: J7,
  name: Z7,
  loanDetailsText: X7,
  loanDetailsBlock: Q7,
  loanDetailsInner: eC,
  right: tC,
  dueBlock: nC,
  dueDetails: sC,
  dueDetailsBorder: rC,
  dueText: iC,
  currentDueText: oC,
  dueHeaderText: aC,
  collapse: lC,
  paymentBox: dC,
  paymentBoxSelected: cC,
  paymentType: uC,
  paymentMethod: hC,
  paymentCountry: fC,
  payNowBtn: pC,
  buttonWrap: _C,
  pricipalBalance: mC,
  balanceAmount: gC,
  viewMoreOrLess: vC,
  dataHeader: $C,
  dataHeaderDetails: bC,
  arrow: xC,
  spin: yC,
  toggleButtonExpanded: wC,
  subHeader: CC,
  iconTextContainer: jC,
  statusLabelRegistered: NC,
  statusLabelUnRegistered: SC,
  viewMoreOrLessBtnWrapper: kC,
  mobileViewWrapper: EC,
  error: IC,
  errorWrap: PC,
  fw400: TC,
  fw700: RC,
  inner: LC
}, DR = (e) => {
  var N, C, S;
  const {
    loanData: t,
    loanStatus: n,
    paymentFailed: s,
    onPaymentClick: r = (F) => F
  } = e, [o, a] = O(!1), [l, d] = O(!1), [c, u] = O(0), [h, p] = O(!0), f = (F) => {
    u(F), p(!1);
  }, m = () => {
    r(c);
  };
  let g = 0, v = !0;
  const _ = (t == null ? void 0 : t.current_principal_balance) > 0 && (t == null ? void 0 : t.loan_number) && (t == null ? void 0 : t.current_due) > 0;
  (N = t == null ? void 0 : t.disbursements) == null || N.map((F) => {
    v && F.disbursement_vendor === "CIBC" && (v = !1), F.disbursement_status_code === "D" && (g = g + F.net_disbursement_amount);
  });
  let $ = "", y = !1, P = null;
  const j = () => t != null && t.final_til_apr ? t == null ? void 0 : t.final_til_apr : t != null && t.atil_rate_apr ? t == null ? void 0 : t.atil_rate_apr : t != null && t.interest_rate_apr ? t == null ? void 0 : t.interest_rate_apr : null, b = j() ? j() + " %" : "-";
  return (t == null ? void 0 : t.opportunity_type) === Ed.REFI ? (y = !0, P = ((C = t == null ? void 0 : t.disbursements[0]) == null ? void 0 : C.disbursement_date) ?? ((S = t == null ? void 0 : t.disbursements[0]) == null ? void 0 : S.projected_disbursement_date), $ = "My refinance loan") : $ = t == null ? void 0 : t.school_name, /* @__PURE__ */ i.jsxs(cn, { classNames: { root: K.card }, children: [
    (t == null ? void 0 : t.due_date) && /* @__PURE__ */ i.jsxs(ee, { className: R(K.statusLabel), order: 5, fontWeight: "700", children: [
      "Due on ",
      Re(t == null ? void 0 : t.due_date).format("MMMM D YYYY")
    ] }),
    /* @__PURE__ */ i.jsx(T, { p: 0, m: 0, classNames: { inner: K.inner }, children: /* @__PURE__ */ i.jsx(ee, { className: K.name, order: 4, fontWeight: "700", children: $ }) }),
    /* @__PURE__ */ i.jsxs(
      T,
      {
        classNames: {
          root: K.loanDetailsBlock,
          inner: R(K.inner, K.loanDetailsInner)
        },
        children: [
          (t == null ? void 0 : t.loan_number) && /* @__PURE__ */ i.jsxs(E, { children: [
            /* @__PURE__ */ i.jsx(
              I,
              {
                component: "p",
                className: R(K.loanDetailsText, K.fw400),
                transform: "uppercase",
                children: "loan id "
              }
            ),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: R(K.loanDetailsText, K.fw700), children: t == null ? void 0 : t.loan_number })
          ] }),
          (t == null ? void 0 : t.loan_status) && /* @__PURE__ */ i.jsxs(E, { children: [
            /* @__PURE__ */ i.jsx(
              I,
              {
                component: "p",
                className: R(K.loanDetailsText, K.fw400),
                transform: "uppercase",
                children: "loan status  "
              }
            ),
            /* @__PURE__ */ i.jsx(
              I,
              {
                component: "p",
                className: R(K.loanDetailsText, K.fw700),
                transform: "uppercase",
                children: n
              }
            )
          ] }),
          g > 0 && /* @__PURE__ */ i.jsxs(E, { children: [
            /* @__PURE__ */ i.jsx(
              I,
              {
                component: "p",
                className: R(K.loanDetailsText, K.fw400),
                transform: "uppercase",
                children: "original loan amount "
              }
            ),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: R(K.loanDetailsText, K.fw700), children: Je(g) })
          ] })
        ]
      }
    ),
    _ && /* @__PURE__ */ i.jsxs(T, { align: "center", p: 0, m: 0, classNames: { inner: K.inner }, children: [
      /* @__PURE__ */ i.jsxs(
        T.Col,
        {
          p: 0,
          span: { md: 8, lg: 8, sm: 8, xs: 12 },
          order: { base: 2, sm: 1, xs: 2, lg: 1, md: 1 },
          children: [
            /* @__PURE__ */ i.jsxs("div", { className: K.dueBlock, children: [
              /* @__PURE__ */ i.jsxs(T, { align: "center", m: 0, justify: "space-between", children: [
                /* @__PURE__ */ i.jsxs(T.Col, { span: "content", mb: 20, p: 10, children: [
                  /* @__PURE__ */ i.jsx(I, { className: R(K.dueHeaderText, K.fw400), children: "Total Payment Due:" }),
                  /* @__PURE__ */ i.jsx(I, { className: R(K.dueHeaderText, K.fw700), children: t != null && t.total_due ? Je(t == null ? void 0 : t.total_due) : Je(0) })
                ] }),
                /* @__PURE__ */ i.jsx(T.Col, { span: "content", onClick: () => a((F) => !F), children: /* @__PURE__ */ i.jsx(
                  Ee,
                  {
                    className: R(K.arrow, o && K.toggleButtonExpanded),
                    children: /* @__PURE__ */ i.jsx(U, { name: "downArrowLoan" })
                  }
                ) })
              ] }),
              /* @__PURE__ */ i.jsx(T, { children: /* @__PURE__ */ i.jsx(Hr, { in: o, className: K.collapse, children: /* @__PURE__ */ i.jsxs(E, { children: [
                /* @__PURE__ */ i.jsx(E, { className: K.dueDetailsBorder }),
                /* @__PURE__ */ i.jsxs(E, { className: K.dueDetails, direction: "column", children: [
                  /* @__PURE__ */ i.jsxs(I, { className: R(K.dueText, K.fw700), children: [
                    "Past due:",
                    " ",
                    t != null && t.past_due ? Je(t == null ? void 0 : t.past_due) : Je(0)
                  ] }),
                  /* @__PURE__ */ i.jsxs(I, { className: R(K.currentDueText, K.fw700), children: [
                    "Current due:",
                    " ",
                    t != null && t.current_due ? Je(t == null ? void 0 : t.current_due) : Je(0)
                  ] })
                ] })
              ] }) }) })
            ] }),
            /* @__PURE__ */ i.jsx(T, { pt: 40, classNames: { inner: K.inner }, children: /* @__PURE__ */ i.jsx(ee, { order: 5, fontWeight: "700", variant: "yellow", children: "What type of bank account are you paying with?" }) }),
            /* @__PURE__ */ i.jsxs(T, { m: 0, children: [
              /* @__PURE__ */ i.jsx(T.Col, { span: "content", children: /* @__PURE__ */ i.jsxs(
                E,
                {
                  className: R(
                    K.paymentBox,
                    c === 1 && K.paymentBoxSelected
                  ),
                  align: "center",
                  onClick: () => f(1),
                  children: [
                    /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(U, { name: "usa" }) }),
                    /* @__PURE__ */ i.jsx(E, { direction: "column", className: K.paymentType, children: /* @__PURE__ */ i.jsx(ee, { className: K.paymentCountry, order: 6, variant: "blue", children: "U.S" }) })
                  ]
                }
              ) }),
              v && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx(T.Col, { span: "content", children: /* @__PURE__ */ i.jsxs(
                  E,
                  {
                    className: R(
                      K.paymentBox,
                      c === 2 && K.paymentBoxSelected
                    ),
                    align: "center",
                    onClick: () => f(2),
                    children: [
                      /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(U, { name: "canada" }) }),
                      /* @__PURE__ */ i.jsxs(E, { direction: "column", className: K.paymentType, children: [
                        /* @__PURE__ */ i.jsx(I, { transform: "uppercase", className: K.paymentMethod, children: "auto payment" }),
                        /* @__PURE__ */ i.jsx(ee, { className: K.paymentCountry, order: 6, variant: "blue", children: "Canada" })
                      ] })
                    ]
                  }
                ) }),
                /* @__PURE__ */ i.jsx(T.Col, { span: "content", children: /* @__PURE__ */ i.jsxs(
                  E,
                  {
                    className: R(
                      K.paymentBox,
                      c === 3 && K.paymentBoxSelected
                    ),
                    align: "center",
                    onClick: () => f(3),
                    children: [
                      /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(U, { name: "otherPaymentIcon" }) }),
                      /* @__PURE__ */ i.jsxs(E, { direction: "column", className: K.paymentType, children: [
                        /* @__PURE__ */ i.jsx(I, { transform: "uppercase", className: K.paymentMethod, children: "One-time payment" }),
                        /* @__PURE__ */ i.jsx(ee, { className: K.paymentCountry, order: 6, variant: "blue", children: "Northstar" })
                      ] })
                    ]
                  }
                ) })
              ] }),
              /* @__PURE__ */ i.jsx(T.Col, { span: "content", children: /* @__PURE__ */ i.jsxs(
                E,
                {
                  className: R(
                    K.paymentBox,
                    c === 4 && K.paymentBoxSelected
                  ),
                  align: "center",
                  onClick: () => f(4),
                  children: [
                    /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(U, { name: "otherPaymentIcon" }) }),
                    /* @__PURE__ */ i.jsxs(E, { direction: "column", className: K.paymentType, children: [
                      /* @__PURE__ */ i.jsx(I, { transform: "uppercase", className: K.paymentMethod, children: "One-time payment" }),
                      /* @__PURE__ */ i.jsx(ee, { className: K.paymentCountry, order: 6, variant: "blue", children: "Flywire" })
                    ] })
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ i.jsx($t, { h: 30 }),
            /* @__PURE__ */ i.jsx(T, { m: 0, className: K.buttonWrap, children: /* @__PURE__ */ i.jsx(
              Jt,
              {
                variant: "filled",
                className: K.payNowBtn,
                onClick: m,
                disabled: !!h,
                children: "PAY NOW"
              }
            ) }),
            s && /* @__PURE__ */ i.jsx(T, { className: K.errorWrap, children: /* @__PURE__ */ i.jsx(I, { component: "p", className: K.error, children: "There is something went wrong. Please try later." }) })
          ]
        }
      ),
      /* @__PURE__ */ i.jsx(
        T.Col,
        {
          span: { md: 4, lg: 4, sm: 4, xs: 12 },
          order: { base: 1, sm: 2, xs: 1, lg: 2, md: 2 },
          p: 0,
          children: g > 0 && /* @__PURE__ */ i.jsxs(
            E,
            {
              className: K.pricipalBalance,
              direction: { base: "row", sm: "column", xs: "row", md: "column", lg: "column" },
              children: [
                /* @__PURE__ */ i.jsxs(ee, { variant: "yellow", order: 4, fontWeight: "700", children: [
                  "Current principal ",
                  /* @__PURE__ */ i.jsx("br", {}),
                  "balance"
                ] }),
                /* @__PURE__ */ i.jsx(I, { className: R(K.balanceAmount, K.fw700), children: (t == null ? void 0 : t.current_principal_balance) > 0 && Je(t == null ? void 0 : t.current_principal_balance) })
              ]
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(Hr, { in: l, children: /* @__PURE__ */ i.jsxs(
      T,
      {
        justify: "space-between",
        align: "flex-start",
        m: 0,
        mt: 30,
        classNames: { inner: R(K.inner, K.mobileViewWrapper) },
        children: [
          /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
            /* @__PURE__ */ i.jsx(I, { className: R(K.fw700, K.dataHeader), children: "Current Interest Rate (APR):" }),
            /* @__PURE__ */ i.jsxs(I, { className: K.dataHeaderDetails, children: [
              t != null && t.current_interest_rate ? (t == null ? void 0 : t.current_interest_rate) + " %" : "-",
              " (",
              b,
              " )"
            ] })
          ] }),
          y ? /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
            /* @__PURE__ */ i.jsx(I, { className: R(K.fw700, K.dataHeader), children: "Disbursement date: " }),
            /* @__PURE__ */ i.jsx(I, { className: K.dataHeaderDetails, children: P && Re(P).format("MMMM D YYYY") })
          ] }) : /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
            /* @__PURE__ */ i.jsx(I, { className: R(K.dataHeader, K.fw700), children: "Anticipated graduation date:" }),
            /* @__PURE__ */ i.jsx(I, { className: K.dataHeaderDetails, children: t != null && t.anticipated_graduation_date ? Re(t == null ? void 0 : t.anticipated_graduation_date).format("MMMM D YYYY") : "-" })
          ] }),
          /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
            /* @__PURE__ */ i.jsx(I, { className: R(K.dataHeader, K.fw700), children: " Servicer: " }),
            /* @__PURE__ */ i.jsxs(I, { className: K.dataHeaderDetails, children: [
              " ",
              t != null && t.servicing_vendor ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                t == null ? void 0 : t.servicing_vendor,
                /* @__PURE__ */ i.jsx(
                  "span",
                  {
                    className: (t == null ? void 0 : t.ach_enabled) === "true" ? K.statusLabelRegistered : K.statusLabelUnRegistered,
                    children: (t == null ? void 0 : t.ach_enabled) === "true" ? "Registered" : "Un-Registered"
                  }
                ),
                /* @__PURE__ */ i.jsxs("div", { children: [
                  "ID: ",
                  (t == null ? void 0 : t.loan_number) || "N/A"
                ] })
              ] }) : "-"
            ] })
          ] }),
          /* @__PURE__ */ i.jsxs(E, { direction: "column", children: [
            /* @__PURE__ */ i.jsx(I, { className: R(K.dataHeader, K.fw700), children: " ACH: " }),
            /* @__PURE__ */ i.jsx(I, { className: K.dataHeaderDetails, children: (t == null ? void 0 : t.ach_active) === !0 ? /* @__PURE__ */ i.jsx("span", { className: K.statusLabelRegistered, children: "Enabled" }) : /* @__PURE__ */ i.jsxs("span", { className: K.iconTextContainer, children: [
              /* @__PURE__ */ i.jsx(U, { name: "wrongTick" }),
              "Not-Enabled"
            ] }) })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ i.jsxs(T, { justify: "flex-end", m: 0, classNames: { inner: K.inner }, children: [
      /* @__PURE__ */ i.jsx(T.Col, { span: { lg: 9, sm: 0 } }),
      /* @__PURE__ */ i.jsx(T.Col, { className: K.viewMoreOrLessBtnWrapper, span: { lg: 3, sm: 5 }, children: /* @__PURE__ */ i.jsx(
        Ee,
        {
          className: K.viewMoreOrLess,
          onClick: () => d((F) => !F),
          children: l ? "Show less" : "View more"
        }
      ) })
    ] })
  ] });
}, OC = "_root_1qiuv_1", FC = "_text_1qiuv_11", AC = "_icon_1qiuv_18", MC = "_leftIcon_1qiuv_19", DC = "_input_1qiuv_25", BC = "_optionButton_1qiuv_46", WC = "_mantine-Button-inner_1qiuv_73", UC = "_mantine-Button-label_1qiuv_78", zC = "_label_1qiuv_88", HC = "_option_1qiuv_46", qC = "_error_1qiuv_110", GC = "_optionContainer_1qiuv_114", VC = "_sticky_1qiuv_120", YC = "_edit_1qiuv_127", KC = "_cross_1qiuv_128", JC = "_showTick_1qiuv_166", ZC = "_outerWrap_1qiuv_172", XC = "_inner_1qiuv_176", QC = "_errorMessage_1qiuv_180", ej = "_addOnOption_1qiuv_189", tj = "_optionWrapper_1qiuv_198", nj = "_dropdownStyle_1qiuv_211", sj = "_rightIconStyle_1qiuv_220", rj = "_rightStyle_1qiuv_226", ij = "_showAdjustedTick_1qiuv_230", oj = "_topArrow_1qiuv_236", wt = {
  root: OC,
  text: FC,
  icon: AC,
  leftIcon: MC,
  input: DC,
  optionButton: BC,
  "mantine-Button-inner": "_mantine-Button-inner_1qiuv_73",
  mantineButtonInner: WC,
  "mantine-Button-label": "_mantine-Button-label_1qiuv_78",
  mantineButtonLabel: UC,
  label: zC,
  option: HC,
  error: qC,
  optionContainer: GC,
  sticky: VC,
  edit: YC,
  cross: KC,
  showTick: JC,
  outerWrap: ZC,
  inner: XC,
  errorMessage: QC,
  addOnOption: ej,
  optionWrapper: tj,
  dropdownStyle: nj,
  rightIconStyle: sj,
  rightStyle: rj,
  showAdjustedTick: ij,
  topArrow: oj
}, BR = oe.forwardRef(
  ({
    id: e,
    defaultValue: t,
    getOptions: n,
    suggestedDropDownList: s = [],
    placeholder: r = "",
    label: o,
    textValue: a,
    selectedValue: l,
    error: d,
    loader: c,
    moreOption: u,
    className: h,
    keyPress: p,
    readOnly: f,
    showEdit: m,
    sideButtonName: g = "Edit",
    alternateValue: v,
    tickMarkAlignTopValue: _,
    addonOption: $,
    isDefaultOpen: y = !1,
    ...P
  }, j) => {
    var Ye, Mt, Zt, kt;
    const { enableToggleDropDown: b = !0, userSelectedValue: N = "" } = P || {}, [C, S] = oe.useState(""), F = Ve("(max-width: 767px)"), [W, D] = oe.useState("contents"), [B, q] = O(b), [G, z] = oe.useState(s), [re, X] = oe.useState(m || !1), [Q, M] = oe.useState(!1), [he, le] = oe.useState(f || !1), ce = dn(null), [we, ue] = oe.useState(""), [pe, Pe] = oe.useState(!1);
    O(!1), ne(() => {
      const fe = ce.current;
      if (!fe || !y) return;
      let tt = 0;
      const pt = setInterval(() => {
        tt <= (r == null ? void 0 : r.length) ? (fe.placeholder = r == null ? void 0 : r.slice(0, tt), tt++) : clearInterval(pt);
      }, 100);
      return () => clearInterval(pt);
    }, [ce == null ? void 0 : ce.current]);
    const Y = (fe) => {
      const tt = fe.currentTarget.value;
      if (tt.length <= 255) {
        S(tt), a && a(tt), D("contents"), ue(""), Pe(!1);
        let pt = G.filter(
          (nt) => nt.name.toLowerCase() === tt.toLowerCase()
        );
        pt.length > 0 && (l && l(pt[0]), D("none"), Pe(!0), q(!1));
      }
    };
    oe.useEffect(() => {
      typeof t == "object" ? (S(t.name), ie(t)) : (t === void 0 && (t = ""), S(t), ue(t)), n(C).then((fe) => {
        fe != null && fe.length && z(fe);
      });
    }, [t]), oe.useEffect(() => {
      n(C).then((fe) => {
        fe != null && fe.length && z(fe);
      });
    }, [C]), oe.useEffect(() => {
      ((o == null ? void 0 : o.toLowerCase()) === "state" || (o == null ? void 0 : o.toLowerCase()) === "province") && S(t);
    }, [c]);
    const ie = (fe) => {
      S(fe.name), D("none"), a && a(fe.name), l && l(fe), ue(fe.name), Pe(!0), q(!1);
    }, ve = () => {
      le(!1), X(!1), M(!0), setTimeout(() => {
        var fe;
        (fe = ce == null ? void 0 : ce.current) == null || fe.focus();
      }, 20);
    }, Ue = () => {
      S(""), M(!1);
    };
    oe.useEffect(() => {
      var tt, pt;
      ue("");
      const fe = G == null ? void 0 : G.filter(
        (nt) => nt.name.toLowerCase() === C.toLowerCase()
      );
      ue((tt = fe == null ? void 0 : fe[0]) != null && tt.name ? (pt = fe == null ? void 0 : fe[0]) == null ? void 0 : pt.name : ""), (fe == null ? void 0 : fe.length) === 1 && (Pe(!0), D("none"));
    }, [G]), ne(() => {
      y && z(s || []);
    }, [s]), ne(() => {
      N && !pe ? q(N === C ? !1 : t || !0) : G != null && G.length && !pe && q(!0);
    }, [N, C]), Ve("(max-width: 500px)");
    const ze = () => {
      q(!B);
    }, He = y ? wt.showAdjustedTick : wt.showTick, ft = y ? "block" : W, et = (G == null ? void 0 : G.length) && B && !(!pe && c);
    return /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsxs("div", { className: wt.outerWrap, children: [
        /* @__PURE__ */ i.jsx(
          Gl,
          {
            autosize: !0,
            classNames: {
              section: y ? wt.rightIconStyle : wt.rightStyle,
              root: wt.root,
              input: wt.input,
              error: wt.error,
              label: wt.label
            },
            className: h,
            id: e,
            "data-testid": e,
            name: e,
            value: C,
            onChange: Y,
            label: o,
            placeholder: r || "",
            error: pe ? "" : (Mt = ((Ye = d == null ? void 0 : d.fieldErrors) == null ? void 0 : Ye[e]) || []) == null ? void 0 : Mt.join(", "),
            rightSection: !pe && c && /* @__PURE__ */ i.jsx(ts, { size: "sm" }),
            onKeyDown: p,
            autoComplete: "off",
            readOnly: f && he,
            ref: j ?? ce,
            onPaste: (fe) => fe.preventDefault(),
            role: "presentation"
          }
        ),
        y && /* @__PURE__ */ i.jsx("div", { className: wt == null ? void 0 : wt.dropdownStyle, onClick: ze, children: et ? /* @__PURE__ */ i.jsx(
          U,
          {
            name: "circledChevronDown",
            size: F ? "18" : "24",
            className: wt.topArrow
          }
        ) : /* @__PURE__ */ i.jsx(U, { name: "circledChevronDown", size: F ? 18 : 24 }) }),
        pe && /* @__PURE__ */ i.jsx("div", { className: He, style: { top: _ }, children: /* @__PURE__ */ i.jsx(U, { name: "greenTick", size: F ? 18 : 24 }) })
      ] }),
      re && f && /* @__PURE__ */ i.jsx("span", { className: wt.edit, id: e, "data-testid": e, onClick: ve, children: g }),
      Q && /* @__PURE__ */ i.jsx("span", { className: wt.cross, id: e, "data-testid": e, onClick: Ue, children: "X" }),
      N && B || B && !pe && ((Zt = Object.keys(G || {})) == null ? void 0 : Zt.length) > 0 ? /* @__PURE__ */ i.jsx(
        "div",
        {
          style: {
            maxHeight: "355px",
            overflowY: ((kt = Object.keys(G)) == null ? void 0 : kt.length) > 2 ? "scroll" : "hidden",
            overflowX: "hidden",
            marginTop: "30px"
          },
          className: "optionGrid",
          children: /* @__PURE__ */ i.jsxs(
            T,
            {
              py: 0,
              grow: !0,
              classNames: { inner: wt.inner },
              style: { display: ft, maxHeight: "auto" },
              children: [
                G.map((fe, tt) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                  /* @__PURE__ */ i.jsx(T.Col, { px: 0, span: 12, className: wt.optionWrapper, children: /* @__PURE__ */ i.jsx(
                    qe,
                    {
                      component: "a",
                      href: "#",
                      variant: "outline",
                      leftIcon: fe.icon,
                      className: wt.optionButton,
                      classNames: { label: wt.option },
                      onClick: () => ie(fe),
                      children: fe.name
                    }
                  ) }, tt),
                  $ && tt === (G == null ? void 0 : G.length) - 1 && /* @__PURE__ */ i.jsx(T.Col, { px: 0, py: 0, span: 12, className: wt.sticky, children: /* @__PURE__ */ i.jsx("span", { className: wt.addOnOption, onClick: $.click, children: $ == null ? void 0 : $.label }) })
                ] })),
                G.length > 0 && !$ && (u == null ? void 0 : u.active) && /* @__PURE__ */ i.jsx(T.Col, { px: 0, span: 12, className: wt.sticky, children: /* @__PURE__ */ i.jsx(
                  qe,
                  {
                    variant: "outline",
                    className: wt.optionButton,
                    onClick: u.click,
                    children: u == null ? void 0 : u.label
                  }
                ) })
              ]
            }
          )
        }
      ) : null,
      /* @__PURE__ */ i.jsx("input", { type: "hidden", name: v, value: we })
    ] });
  }
), aj = "_modal_1cs3q_1", lj = "_modalBody_1cs3q_16", dj = "_modalIcon_1cs3q_29", cj = "_modalDivider_1cs3q_41", uj = "_modalTitle_1cs3q_54", hj = "_modalText_1cs3q_65", Or = {
  modal: aj,
  modalBody: lj,
  modalIcon: dj,
  modalDivider: cj,
  modalTitle: uj,
  modalText: hj
}, WR = (e) => {
  const { open: t, onClose: n, aprInfo: s = !1 } = e;
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: "100%",
      radius: "lg",
      classNames: { content: Or.modal, body: Or.modalBody },
      opened: t,
      onClose: n,
      children: [
        /* @__PURE__ */ i.jsx(U, { name: "infoCircle", className: Or.modalIcon }),
        /* @__PURE__ */ i.jsx(Vn, { className: Or.modalDivider }),
        /* @__PURE__ */ i.jsx(ee, { order: 3, className: Or.modalTitle, fontWeight: "700", children: "Did you know?" }),
        /* @__PURE__ */ i.jsxs(I, { className: Or.modalText, children: [
          "Annual percentage rate (APR) refers to the yearly interest generated by a sum that's charged to borrowers or paid to investors. APR is expressed as a percentage that represents the actual yearly cost of funds over the term of a loan or income earned on an investment.",
          s && " The previous APR shown is representative, while the updated APR % provided here is the exact APR % you will receive for this loan, ensuring clarity and accuracy for your financial planning."
        ] })
      ]
    }
  );
}, fj = "_container_kygpr_1", pj = "_list_kygpr_6", _j = "_listItem_kygpr_21", mj = "_loanTermCard_kygpr_25", gj = "_title_kygpr_29", vj = "_strikeTitle_kygpr_36", $j = "_atilWrapper_kygpr_43", bj = "_atilSvg_kygpr_61", xj = "_subTitle_kygpr_69", yj = "_text_kygpr_76", wj = "_aprinfo_kygpr_86", Cj = "_flexCard_kygpr_95", jj = "_interestBanner_kygpr_118", Nj = "_textsWrap_kygpr_132", Rn = {
  container: fj,
  list: pj,
  listItem: _j,
  loanTermCard: mj,
  title: gj,
  strikeTitle: vj,
  atilWrapper: $j,
  atilSvg: bj,
  subTitle: xj,
  text: yj,
  aprinfo: wj,
  flexCard: Cj,
  interestBanner: jj,
  textsWrap: Nj
}, UR = (e) => {
  const { loanTerms: t, interestBanner: n, className: s, showInterestRateBanner: r } = e;
  return /* @__PURE__ */ i.jsxs("section", { className: R(Rn.container, s), children: [
    /* @__PURE__ */ i.jsx(E, { role: "list", className: Rn.list, children: t.map((o) => /* @__PURE__ */ i.jsxs(E, { className: Rn.flexCard, children: [
      (o == null ? void 0 : o.showAdditionalField) && /* @__PURE__ */ i.jsxs("div", { className: Rn.atilWrapper, children: [
        /* @__PURE__ */ i.jsx(I, { className: Rn.aprinfo, children: "Best prices available today" }),
        /* @__PURE__ */ i.jsx(U, { name: "atilBird", className: Rn.atilSvg })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: Rn.textsWrap, children: [
        o != null && o.showAdditionalField ? /* @__PURE__ */ i.jsx(ee, { fontWeight: "700", order: 6, className: Rn.strikeTitle, children: /* @__PURE__ */ i.jsx("s", { children: o.title }) }) : /* @__PURE__ */ i.jsx(ee, { fontWeight: "700", order: 4, className: Rn.title, children: o.title }),
        (o == null ? void 0 : o.showAdditionalField) && /* @__PURE__ */ i.jsx(ee, { fontWeight: "700", order: 4, className: Rn.subTitle, children: o.subTitle }),
        /* @__PURE__ */ i.jsx(I, { component: "p", className: Rn.text, children: o.text })
      ] })
    ] }, o.title)) }),
    r && /* @__PURE__ */ i.jsx(I, { className: Rn.interestBanner, component: "p", children: n })
  ] });
}, Sj = "_root_l8qk1_1", kj = "_title_l8qk1_11", Ej = "_description_l8qk1_22", Ij = "_infoText_l8qk1_38", Pj = "_infoTipOuter_l8qk1_45", bi = {
  root: Sj,
  title: kj,
  description: Ej,
  infoText: Ij,
  infoTipOuter: Pj
}, zR = ({
  id: e,
  children: t,
  className: n,
  infoText: s,
  loaderText: r,
  toggleText: o,
  headerText: a = ""
}) => {
  const [l, d] = O(!1);
  return /* @__PURE__ */ i.jsxs(
    Jo,
    {
      px: "md",
      py: "md",
      shadow: "xs",
      radius: "md",
      className: R(bi.root, n),
      id: e,
      children: [
        /* @__PURE__ */ i.jsxs(E, { className: bi.infoTipOuter, children: [
          /* @__PURE__ */ i.jsx(U, { name: "tip" }),
          /* @__PURE__ */ i.jsx(Ce, { fw: "700", color: "dimmed", className: bi.title, children: a }),
          /* @__PURE__ */ i.jsx(
            Ce,
            {
              size: "sm",
              color: "dimmed",
              className: bi.description,
              onClick: () => d((c) => !c),
              children: l ? o : r
            }
          )
        ] }),
        l && /* @__PURE__ */ i.jsx(E, { children: /* @__PURE__ */ i.jsx(Ce, { component: "p", className: bi.infoText, children: s }) }),
        t
      ]
    }
  );
}, Tj = "_block_35rg5_1", Rj = "_question_35rg5_12", Lj = "_answer_35rg5_27", Oj = "_accordion_35rg5_36", go = {
  block: Tj,
  question: Rj,
  answer: Lj,
  accordion: Oj
}, HR = (e) => {
  const { faqData: t } = e;
  return /* @__PURE__ */ i.jsx(
    Qt,
    {
      variant: "contained",
      multiple: !0,
      className: go.accordion,
      chevron: /* @__PURE__ */ i.jsx(U, { name: "faqRedArrow" }),
      id: "faq-accordion",
      children: t.map((n) => /* @__PURE__ */ i.jsxs(Qt.Item, { value: n.title, className: go.block, children: [
        /* @__PURE__ */ i.jsx(Qt.Control, { className: go.question, children: /* @__PURE__ */ i.jsx("div", { dangerouslySetInnerHTML: { __html: n.title } }) }),
        /* @__PURE__ */ i.jsx(Qt.Panel, { className: go.answer, children: n.answer })
      ] }, n.title))
    }
  );
}, Fj = "_root_gdq4f_1", Aj = "_iconWrap_gdq4f_14", Mj = "_supportMailWrap_gdq4f_19", Dj = "_emailWrapper_gdq4f_26", Bj = "_csSubtitle_gdq4f_31", Wj = "_contactWrap_gdq4f_39", Uj = "_contactNo_gdq4f_50", Rs = {
  root: Fj,
  iconWrap: Aj,
  supportMailWrap: Mj,
  emailWrapper: Dj,
  csSubtitle: Bj,
  contactWrap: Wj,
  contactNo: Uj
}, qR = (e) => /* @__PURE__ */ i.jsxs(Jo, { px: "md", py: "md", shadow: "xs", radius: "md", className: R(Rs.root), children: [
  /* @__PURE__ */ i.jsx(E, { className: Rs.iconWrap, children: /* @__PURE__ */ i.jsx(U, { name: "teleCallPerson" }) }),
  /* @__PURE__ */ i.jsx(ee, { className: "displayInline", order: 3, variant: "blue", fontWeight: "700", children: "Still have questions?" }),
  /* @__PURE__ */ i.jsx(I, { className: Rs.csSubtitle, component: "p", children: "Your Relationship Manager is available. Schedule a phone call." }),
  /* @__PURE__ */ i.jsxs(E, { className: Rs.contactWrap, children: [
    /* @__PURE__ */ i.jsx(ee, { className: Rs.contactNo, order: 5, variant: "yellow", fontWeight: "700", children: "+1-202-417-3800 (U.S.)" }),
    /* @__PURE__ */ i.jsx(ee, { className: Rs.contactNo, order: 5, variant: "yellow", fontWeight: "700", children: "+1-647-503-4607 (Canada)" })
  ] }),
  /* @__PURE__ */ i.jsx(Vn, { my: "xs", className: "customDivider" }),
  /* @__PURE__ */ i.jsxs(E, { className: Rs.supportMailWrap, children: [
    /* @__PURE__ */ i.jsx(E, { className: Rs.emailWrapper, children: /* @__PURE__ */ i.jsx(U, { name: "supportEmail" }) }),
    /* @__PURE__ */ i.jsx(ee, { className: "displayInline supportEmail", order: 5, variant: "blue", fontWeight: "700", children: "mpower.me@mpowerfinancing.com" })
  ] })
] }), zj = "_modal_s5zn0_1", Hj = "_modalBody_s5zn0_16", qj = "_modalIcon_s5zn0_29", Gj = "_modalDivider_s5zn0_41", Vj = "_modalTitle_s5zn0_54", Yj = "_modalText_s5zn0_65", Kj = "_coaFlex_s5zn0_82", Jj = "_flexLeftItem_s5zn0_94", Zj = "_flexRightItem_s5zn0_107", Xj = "_coaTotalFlex_s5zn0_121", Qj = "_bottomLine_s5zn0_130", eN = "_modalIconCOA_s5zn0_136", tN = "_modalIconCOA_s5zn0_136", nN = "_modalInner_s5zn0_148", sN = "_coaDataWrapper_s5zn0_152", rN = "_coaTotalBck_s5zn0_163", St = {
  modal: zj,
  modalBody: Hj,
  modalIcon: qj,
  modalDivider: Gj,
  modalTitle: Vj,
  modalText: Yj,
  coaFlex: Kj,
  flexLeftItem: Jj,
  flexRightItem: Zj,
  coaTotalFlex: Xj,
  bottomLine: Qj,
  modalIconCOA: eN,
  modalIconCoa: tN,
  modalInner: nN,
  coaDataWrapper: sN,
  coaTotalBck: rN
}, GR = (e) => {
  var l, d, c;
  const { open: t, onClose: n, coaData: s, showHeading: r = !1 } = e, o = (s == null ? void 0 : s.tutionCost) + (s == null ? void 0 : s.healthInsurance) + (s == null ? void 0 : s.booksAndSupplies), a = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: "100%",
      radius: "lg",
      classNames: { content: St.modal, body: St.modalBody, inner: St.modalInner },
      opened: t,
      onClose: n,
      children: [
        /* @__PURE__ */ i.jsx(U, { name: "infoCircle", className: St.modalIconCOA }),
        /* @__PURE__ */ i.jsx(Vn, { className: St.modalDivider }),
        r && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx(ee, { order: a ? 5 : 4, variant: "blue", children: U0 }),
          /* @__PURE__ */ i.jsx($t, { h: 30 })
        ] }),
        /* @__PURE__ */ i.jsxs(ee, { order: 4, className: St.modalTitle, fontWeight: "700", children: [
          "Estimated annual costs ",
          (s == null ? void 0 : s.schoolCountry) === fc.canada ? "*" : ""
        ] }),
        (s == null ? void 0 : s.schoolCountry) === fc.canada && /* @__PURE__ */ i.jsx(ee, { order: 6, fontWeight: "400", children: "*These costs are subject to CAD exchange rate fluctuations" }),
        /* @__PURE__ */ i.jsxs(E, { className: St.coaDataWrapper, children: [
          /* @__PURE__ */ i.jsxs(E, { className: St.coaFlex, children: [
            /* @__PURE__ */ i.jsx(I, { className: St.flexLeftItem, children: /* @__PURE__ */ i.jsx("b", { children: "Tuition and fees:  " }) }),
            /* @__PURE__ */ i.jsxs(I, { className: St.flexRightItem, children: [
              "US",
              (l = s == null ? void 0 : s.tutionCost) == null ? void 0 : l.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })
            ] })
          ] }),
          (s == null ? void 0 : s.healthInsurance) > 0 && /* @__PURE__ */ i.jsxs(E, { className: St.coaFlex, children: [
            /* @__PURE__ */ i.jsx(I, { className: St.flexLeftItem, children: /* @__PURE__ */ i.jsx("b", { children: "Health Insurance:  " }) }),
            /* @__PURE__ */ i.jsxs(I, { className: St.flexRightItem, children: [
              "US",
              (d = s == null ? void 0 : s.healthInsurance) == null ? void 0 : d.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })
            ] })
          ] }),
          (s == null ? void 0 : s.booksAndSupplies) > 0 && /* @__PURE__ */ i.jsxs(E, { className: St.coaFlex, children: [
            /* @__PURE__ */ i.jsx(I, { className: St.flexLeftItem, children: /* @__PURE__ */ i.jsx("b", { children: "Books and supplies:  " }) }),
            /* @__PURE__ */ i.jsxs(I, { className: St.flexRightItem, children: [
              "US",
              (c = s == null ? void 0 : s.booksAndSupplies) == null ? void 0 : c.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })
            ] })
          ] }),
          /* @__PURE__ */ i.jsxs(E, { className: R(St.coaFlex, St.coaTotalBck), children: [
            /* @__PURE__ */ i.jsx(I, { className: St.flexLeftItem, children: /* @__PURE__ */ i.jsx("b", { children: "TOTAL" }) }),
            /* @__PURE__ */ i.jsx(I, { className: St.flexRightItem, children: /* @__PURE__ */ i.jsxs("b", { children: [
              " ",
              "US",
              o.toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ i.jsx(I, { className: St.bottomLine, children: "Note: This does not include living expenses" })
      ]
    }
  );
}, iN = "_modal_1386e_1", oN = "_modalBody_1386e_18", aN = "_modalIcon_1386e_33", lN = "_modalDivider_1386e_45", dN = "_modalTitle_1386e_58", cN = "_modalText_1386e_69", uN = "_button_1386e_86", ir = {
  modal: iN,
  modalBody: oN,
  modalIcon: aN,
  modalDivider: lN,
  modalTitle: dN,
  modalText: cN,
  button: uN
}, VR = (e) => {
  const {
    open: t,
    onClose: n,
    title: s,
    subtitle: r,
    buttonText: o,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    popupButtonClick: a = () => {
    }
  } = e, l = () => {
    a();
  };
  return /* @__PURE__ */ i.jsxs(
    Nn,
    {
      size: "100%",
      radius: "lg",
      classNames: { content: ir.modal, body: ir.modalBody },
      opened: t,
      onClose: n,
      children: [
        /* @__PURE__ */ i.jsx(U, { name: "infoCircle", className: ir.modalIcon }),
        /* @__PURE__ */ i.jsx(Vn, { className: ir.modalDivider }),
        /* @__PURE__ */ i.jsx(ee, { order: 3, className: ir.modalTitle, fontWeight: "700", children: s }),
        /* @__PURE__ */ i.jsx(
          "div",
          {
            className: ir.modalText,
            dangerouslySetInnerHTML: { __html: r || "" }
          }
        ),
        o && /* @__PURE__ */ i.jsx(Jt, { onClick: l, className: ir.button, children: o })
      ]
    }
  );
}, hN = "_label_qlg8f_1", fN = "_arrow_qlg8f_7", pN = "_root_qlg8f_21", _N = "_newRoot_qlg8f_31", mN = "_input_qlg8f_35", gN = "_newInput_qlg8f_61", vN = "_countryCode_qlg8f_76", $N = "_newCountryCode_qlg8f_88", bN = "_autoCompleteDropdown_qlg8f_92", xN = "_newAutoCompleteDropdown_qlg8f_118", yN = "_option_qlg8f_125", wN = "_phoneNumberStyle_qlg8f_138", CN = "_columnStyle_qlg8f_146", jN = "_errorStyle_qlg8f_153", NN = "_dropdownError_qlg8f_166", SN = "_wrapperStyle_qlg8f_179", kN = "_avatar_qlg8f_183", EN = "_optionText_qlg8f_199", IN = "_autoCompleteOptions_qlg8f_206", PN = "_textWrapper_qlg8f_212", TN = "_sectionIcon_qlg8f_225", RN = "_inner_qlg8f_229", LN = "_placeholder_qlg8f_243", lt = {
  label: hN,
  arrow: fN,
  root: pN,
  newRoot: _N,
  input: mN,
  newInput: gN,
  countryCode: vN,
  newCountryCode: $N,
  autoCompleteDropdown: bN,
  newAutoCompleteDropdown: xN,
  option: yN,
  phoneNumberStyle: wN,
  columnStyle: CN,
  errorStyle: jN,
  dropdownError: NN,
  wrapperStyle: SN,
  avatar: kN,
  optionText: EN,
  autoCompleteOptions: IN,
  textWrapper: PN,
  sectionIcon: TN,
  inner: RN,
  placeholder: LN
}, ON = oe.forwardRef(
  ({ value: e, emoji: t, code: n, ...s }, r) => /* @__PURE__ */ i.jsx("div", { ref: r, ...s, children: e })
);
ON.displayName = "PhoneNumberCode";
const Cp = ({ customSectionIcon: e }) => /* @__PURE__ */ i.jsx(E, { justify: "center", align: "end", className: R(lt.sectionIcon, e), children: /* @__PURE__ */ i.jsx(U, { name: "inputSearchIcon" }) }), jp = oe.memo(({ customSectionIcon: e }) => /* @__PURE__ */ i.jsx(E, { justify: "center", align: "end", children: /* @__PURE__ */ i.jsx(U, { name: "inputDoubleArrows" }) }));
jp.displayName = "RightRenderer";
Cp.displayName = "LeftRenderer";
const tl = /* @__PURE__ */ new Set(["undefined", "null", "+undefined"]), nl = {
  justify: "center",
  align: "center",
  display: "flex",
  className: lt.columnStyle,
  classNames: { inner: lt.inner }
}, FN = {
  justify: "flex-start",
  align: "center",
  display: "flex"
}, Np = ({
  id: e,
  label: t,
  countryCodes: n = [],
  onChange: s,
  error: r,
  validity: o,
  defaultValue: a,
  status: l = !0,
  userInput: d = "",
  IncomingselectedCountryData: c,
  isNewDesignValid: u = !1,
  rightSection: h,
  readOnly: p,
  disabled: f,
  onKeyDownCallback: m,
  customPhoneNumberStyle: g,
  customInnerGridStyle: v,
  customLabelClass: _,
  customRootClass: $,
  customColumnClass: y,
  textFieldDisableState: P,
  autoCompleteDisableState: j,
  phoneNumberDisableStyles: b,
  customSectionIcon: N,
  customErrorStyle: C,
  customDdropdownError: S,
  isProfileFlow: F,
  metaData: W,
  customError: D,
  withAsterisk: B,
  disableCodeField: q = !1,
  prefillOnlyCodeField: G = !1,
  requireAdditionalCheck: z = !1
}) => {
  var rs;
  const re = Fi(() => {
    var Ne;
    if (!a)
      return {
        code: "",
        phone: "",
        isValid: !1,
        isPossible: !1,
        error: ""
      };
    const J = (Ne = a == null ? void 0 : a.toString()) == null ? void 0 : Ne.trim();
    if (tl != null && tl.has(J == null ? void 0 : J.toLowerCase()))
      return {
        code: "",
        phone: "",
        isValid: !1,
        isPossible: !1,
        error: ""
      };
    const $e = J == null ? void 0 : J.replace(/[^\d+]/g, ""), je = $e == null ? void 0 : $e.replace(/\D/g, "");
    if ((je == null ? void 0 : je.length) < 4)
      return {
        code: "",
        phone: je,
        isValid: !1,
        isPossible: !1,
        error: ""
      };
    try {
      const Te = v1($e);
      if (!Te)
        return {
          code: "",
          phone: je,
          isValid: !1,
          isPossible: !1,
          error: "Invalid phone format"
        };
      const Kn = Te == null ? void 0 : Te.country, kn = Te == null ? void 0 : Te.countryCallingCode, Qr = Te == null ? void 0 : Te.nationalNumber, xr = $1($e), ei = ul($e), ti = n.find(
        (js) => (js == null ? void 0 : js.isoCode) === Kn || (js == null ? void 0 : js.code) === kn
      );
      let yr = "";
      return xr ? ei || (yr = "Phone number is not valid") : yr = "Phone length is incorrect", {
        code: (ti == null ? void 0 : ti.value) || "",
        phone: Qr || "",
        country: Kn,
        isValid: ei,
        isPossible: xr,
        error: yr
      };
    } catch {
      return {
        code: "",
        phone: je,
        isValid: !1,
        isPossible: !1,
        error: "Invalid phone number"
      };
    }
  }, [a, n]), X = a === void 0 ? "" : (rs = a == null ? void 0 : a.toString()) == null ? void 0 : rs.split("-")[0], Q = a === void 0 ? "" : a == null ? void 0 : a.split("-")[1], [M, he] = O(
    z ? re == null ? void 0 : re.code : X
  ), le = Ve("(max-width: 767px)"), [ce, we] = O(
    z ? re == null ? void 0 : re.phone : Q
  ), ue = dn(null), [pe, Pe] = O(""), [Y, ie] = O(!1), [ve, Ue] = O(""), [ze, He] = O(!1), [ft, et] = O(""), Ye = Fi(() => {
    var J;
    try {
      if (M) {
        const $e = M == null ? void 0 : M.split(" - "), je = (J = n.find((Ne) => (Ne == null ? void 0 : Ne.value) === M)) == null ? void 0 : J.key;
        return je || (!(r != null && r.fieldErrors[e]) && $e[0].length === 0 ? "" : (r != null && r.fieldErrors[e] && $e[0].length === 0, "Invalid"));
      }
    } catch {
    }
  }, [n, M]), [Mt, Zt] = O();
  ne(() => {
    var J;
    try {
      if (M) {
        const $e = M == null ? void 0 : M.split(" - "), je = $e && $e[0], Ne = (J = n.find((Te) => {
          if ((Te == null ? void 0 : Te.emoji) === je)
            return Zt(Te == null ? void 0 : Te.key), Te;
        })) == null ? void 0 : J.code;
        if (!Ne) {
          et("");
          return;
        }
        et(ce ? `+${Ne}-${ce}` : `+${Ne}`);
      } else
        et("");
    } catch {
    }
  }, [M, ce]), ne(() => {
    (M == null ? void 0 : M.length) === 1 && we(""), s && s(ce ? `${M}-${ce}` : `${M}`, Mt);
  }, [ce, M, s, Mt]), ne(() => {
    var J;
    if (M) {
      const $e = c && c || "", je = n.filter((Ne) => {
        const Te = W ? W === (Ne == null ? void 0 : Ne.key) : !0;
        return $e === (Ne == null ? void 0 : Ne.key) && Ne.code === M.split("+")[1] && Te ? (Zt(Ne == null ? void 0 : Ne.key), !0) : !!(!$e && Ne.code === M.split("+")[1] && Te);
      });
      je != null && je.length && he((J = je[0]) == null ? void 0 : J.value);
    }
  }, [c]), ne(() => {
    r != null && r.fieldErrors[e] && Ye === "Invalid" ? Pe("Required") : Pe(""), (r && l === !1 || a) && ie(!0);
  }, [r]);
  const kt = () => {
    var J, $e;
    return (ce == null ? void 0 : ce.length) > 0 && Ye !== "Invalid" && !ul(ce, Ye) || (ce == null ? void 0 : ce.length) === 0 && !q && !G ? "Please enter a valid phone number" : (J = r == null ? void 0 : r.fieldErrors) != null && J.referenceMobile && (($e = r == null ? void 0 : r.fieldErrors) == null ? void 0 : $e.referenceMobile[0]) === "Your reference cannot have the same phone number as you" ? "Your reference cannot have the same phone number as you" : null;
  }, fe = Y ? kt() : null;
  ne(() => {
    const J = kt();
    Ue(J ? J.toString() : "");
  }, [kt]);
  const tt = () => {
    var $e, je;
    n.filter((Ne) => Ne.value === M).length > 0 ? ($e = ue.current) == null || $e.focus() : (M.length && Pe("Required"), !M.length && we(""), ((je = document == null ? void 0 : document.activeElement) == null ? void 0 : je.id) === `${e}-autocomplete` ? He(!1) : a != null && a.length && He(!0));
  };
  ne(() => {
    var Ne, Te;
    const J = M == null ? void 0 : M.split(" ");
    let $e = 0;
    const je = (J == null ? void 0 : J[(J == null ? void 0 : J.length) - 1]) === "+";
    if ((J == null ? void 0 : J.length) > 0) {
      const Kn = (Ne = J == null ? void 0 : J[(J == null ? void 0 : J.length) - 1]) == null ? void 0 : Ne.length, kn = (J == null ? void 0 : J.length) > 1 ? (Te = J == null ? void 0 : J[(J == null ? void 0 : J.length) - 2]) == null ? void 0 : Te.length : 0;
      $e = Kn > 0 ? Kn : kn;
    }
    (je || !$e) && he(""), Pe(""), tt(), yt();
  }, [M, pe]);
  const pt = (J) => {
    const $e = J || d;
    return n.filter((je) => Object.values(je).some(
      (Ne) => Ne.toString().toLowerCase() === ($e == null ? void 0 : $e.toLowerCase())
    ));
  }, nt = (J) => {
    const $e = J || d;
    return n.filter((je) => Object.values(je).some(
      (Ne) => Ne.toString().toLowerCase().includes($e == null ? void 0 : $e.toLowerCase())
    ));
  }, yt = () => {
    const J = pt();
    return (J == null ? void 0 : J.length) > 0 ? J : nt();
  }, Z = ({ option: J }) => {
    const {
      emoji: $e = "",
      valueWithName: je = "",
      value: Ne = "",
      name: Te = "",
      code: Kn = "",
      codeWithPlus: kn = ""
    } = J || {};
    return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(ss, { gap: "sm", wrap: "nowrap", justify: "flex-start", className: lt.optionText, children: [
      /* @__PURE__ */ i.jsx("div", { className: lt.avatar, children: $e }),
      /* @__PURE__ */ i.jsx("div", { className: lt.textWrapper, children: /* @__PURE__ */ i.jsx(Ce, { size: "md", fw: 500, truncate: "end", children: `${Te}(${kn})` }) })
    ] }) });
  };
  ne(() => {
    m && m(
      "",
      ve,
      M === "" || pe ? "Invalid" : "",
      M,
      ce,
      Mt
    );
  }, [M, pe]);
  const Le = () => {
    He(!0), m && m("", ve, M === "" || pe, M, ce, Mt);
  }, _t = (J) => {
    m && m(J, ve, (Ye === "Invalid" ? "Invalid" : M === "" || pe) ? "Invalid" : ""), He(!1);
    let je = J == null ? void 0 : J.split("-");
    je = (je == null ? void 0 : je.length) > 1 ? je[1] : J;
    const Ne = pt(je), Te = nt(je);
    ((Te == null ? void 0 : Te.length) || (Ne == null ? void 0 : Ne.length)) && he(J);
  }, tn = pe || Ye === "Invalid" ? F ? "Select code from dropdown" : "Please select a valid country code from the dropdown" : null, $n = {
    id: `${e}-autocomplete`,
    className: lt.countryCode,
    classNames: {
      input: lt.input,
      dropdown: lt.autoCompleteDropdown,
      option: lt.option
    },
    data: n,
    withScrollArea: !1,
    value: M,
    onChange: _t,
    onDropdownClose: Le,
    rightSectionWidth: 10,
    error: ze && tn
  }, Sn = {
    ...$n,
    classNames: {
      ...$n.classNames,
      input: R(lt.newInput, j),
      dropdown: `${lt.autoCompleteDropdown} ${lt.newAutoCompleteDropdown}`,
      error: R(lt.dropdownError, S),
      options: lt.autoCompleteOptions,
      section: R(lt.sectionIcon, N),
      inner: lt.inner,
      placeholder: lt.placeholder
    },
    filter: yt,
    placeholder: le ? "Country" : "Country code",
    leftSection: /* @__PURE__ */ i.jsx(Cp, { customSectionIcon: N }),
    rightSection: /* @__PURE__ */ i.jsx(jp, { customSectionIcon: N }),
    renderOption: n && Z,
    limit: 20
  }, Yn = F && !(M != null && M.length);
  return /* @__PURE__ */ i.jsxs(
    Ku.Wrapper,
    {
      label: t,
      className: R(lt, _, $),
      required: B,
      children: [
        " ",
        /* @__PURE__ */ i.jsxs(
          T,
          {
            gutter: 0,
            className: R(
              lt.phoneNumberStyle,
              f ? b : g
            ),
            children: [
              /* @__PURE__ */ i.jsx(T.Col, { span: { base: 5 }, className: R(lt.columnStyle), children: /* @__PURE__ */ i.jsx(
                T,
                {
                  ...nl,
                  className: R(nl.className, v),
                  classNames: { inner: R(nl.classNames, v) },
                  children: /* @__PURE__ */ i.jsxs(T.Col, { span: { base: 12 }, children: [
                    /* @__PURE__ */ i.jsx(
                      "input",
                      {
                        type: "hidden",
                        name: e,
                        id: e + "hidden",
                        "data-testid": e + "hidden",
                        value: ft
                      }
                    ),
                    /* @__PURE__ */ i.jsx(
                      Ju,
                      {
                        ...Sn,
                        "aria-controls": "",
                        disabled: f || q,
                        readOnly: p
                      }
                    )
                  ] })
                }
              ) }),
              /* @__PURE__ */ i.jsx(T.Col, { span: { base: 7 }, children: /* @__PURE__ */ i.jsx(T, { ...FN, children: /* @__PURE__ */ i.jsxs(T.Col, { span: 12, pl: 30, className: y, children: [
                /* @__PURE__ */ i.jsx(
                  Ko,
                  {
                    id: e,
                    autoFocus: !0,
                    classNames: {
                      input: R(`${lt.input} ${lt.newInput}`, P),
                      error: R(lt.errorStyle, C),
                      wrapper: lt.wrapperStyle
                    },
                    value: ce,
                    onChange: (J) => {
                      const $e = J.currentTarget.value, je = $e == null ? void 0 : $e.replace(/[^0-9+]/g, "");
                      je.length <= 40 && we(je);
                    },
                    ref: ue,
                    readOnly: p || M === "" || (pe == null ? void 0 : pe.length) !== 0,
                    type: "text",
                    onWheel: (J) => {
                      ue && ue.current && ue.current.blur && ue.current.blur(), J.preventDefault();
                    },
                    placeholder: "Mobile phone number",
                    error: D != null && D.length ? D : Yn ? "" : !(tn != null && tn.length) && fe,
                    disabled: f || M === "" || (pe == null ? void 0 : pe.length) !== 0,
                    rightSection: h,
                    ...m && {
                      onKeyUp: (J) => m(
                        J,
                        ve,
                        tn,
                        M,
                        ce,
                        Mt
                      )
                    }
                  }
                ),
                /* @__PURE__ */ i.jsx("input", { type: "hidden", name: o, id: o, value: ve })
              ] }) }) })
            ]
          }
        )
      ]
    }
  );
}, AN = "_root_12y83_1", MN = "_rootRB_12y83_27", DN = "_rootRB_12y83_27", BN = "_title_12y83_45", WN = "_descCollapsed_12y83_57", UN = "_descExpanded_12y83_70", zN = "_horizontalAlign_12y83_77", HN = "_control_12y83_82", qN = "_collapse_12y83_86", GN = "_contentCollapsed_12y83_96", VN = "_contentExpanded_12y83_110", YN = "_btnCollapsed_12y83_122", KN = "_btnExpanded_12y83_129", JN = "_center_12y83_137", ZN = "_collapsed_12y83_141", Ht = {
  root: AN,
  rootRB: MN,
  rootRb: DN,
  title: BN,
  descCollapsed: WN,
  descExpanded: UN,
  horizontalAlign: zN,
  control: HN,
  collapse: qN,
  contentCollapsed: GN,
  contentExpanded: VN,
  btnCollapsed: YN,
  btnExpanded: KN,
  center: JN,
  collapsed: ZN
}, YR = ({
  id: e,
  children: t,
  className: n,
  RB: s,
  headerText: r = "Tip",
  showButon: o = !0,
  expand: a = !1
}) => {
  const [l, d] = O(a);
  return ne(() => {
    d(a);
  }, [a]), /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsxs(
    Jo,
    {
      shadow: "xs",
      p: 12,
      className: R(s ? Ht.rootRB : Ht.root, !l && Ht.center, n),
      id: e,
      children: [
        /* @__PURE__ */ i.jsxs(ss, { classNames: { root: Ht.horizontalAlign }, children: [
          /* @__PURE__ */ i.jsx(U, { name: "tip", size: 22 }),
          /* @__PURE__ */ i.jsx(Ce, { fw: "700", className: Ht.title, children: r })
        ] }),
        /* @__PURE__ */ i.jsxs(
          E,
          {
            direction: l ? "column" : "row",
            align: l ? "initial" : "center",
            className: l ? Ht.expanded : Ht.collapsed,
            children: [
              /* @__PURE__ */ i.jsx(Ce, { className: l ? Ht.descExpanded : Ht.descCollapsed, children: /* @__PURE__ */ i.jsx("div", { className: l ? Ht.expand : Ht.collapse, children: /* @__PURE__ */ i.jsxs(Ce, { className: l ? Ht.contentExpanded : Ht.contentCollapsed, children: [
                t,
                " ",
                l && o && /* @__PURE__ */ i.jsx(
                  Ee,
                  {
                    className: l ? Ht.btnExpanded : Ht.btnCollapsed,
                    onClick: () => d(!l),
                    children: l ? "View less" : "View more"
                  }
                )
              ] }) }) }),
              o && !l && /* @__PURE__ */ i.jsx(
                Ee,
                {
                  className: l ? Ht.btnExpanded : Ht.btnCollapsed,
                  onClick: () => d(!l),
                  children: l ? "View less" : "View more"
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, XN = "_root_qtcgy_1", QN = "_input_qtcgy_15", eS = "_wrapper_qtcgy_30", tS = "_error_qtcgy_34", nS = "_section_qtcgy_39", sS = "_option_qtcgy_47", rS = "_options_qtcgy_60", iS = "_dropdown_qtcgy_68", oS = "_label_qtcgy_92", us = {
  root: XN,
  input: QN,
  wrapper: eS,
  error: tS,
  section: nS,
  option: sS,
  options: rS,
  dropdown: iS,
  label: oS
}, aS = ({
  placeholder: e,
  label: t,
  id: n,
  defaultValue: s,
  error: r,
  className: o,
  getOptions: a = () => [],
  updatedValue: l = (m) => {
  },
  checkIconPosition: d = "right",
  allowDeselect: c = !1,
  clientSideError: u = !1,
  rightSectionIcon: h,
  disabled: p = !1,
  customClasses: f
}) => {
  const [m, g] = O(s), [v, _] = O(!1), [$, y] = O([]), P = (j) => {
    g(j), l(j), _(!!(j && !u));
  };
  return ne(() => {
    g(s);
  }, [s]), ne(() => {
    y(a());
  }, []), /* @__PURE__ */ i.jsx(
    Vl,
    {
      classNames: {
        root: R(us.root, f == null ? void 0 : f.root),
        option: R(us.option, f == null ? void 0 : f.option),
        input: R(us.input, f == null ? void 0 : f.input),
        label: R(us.label, f == null ? void 0 : f.label),
        dropdown: R(us.dropdown, f == null ? void 0 : f.dropdown),
        error: R(us.error, f == null ? void 0 : f.error),
        section: R(us.section, f == null ? void 0 : f.section),
        options: R(us.options, f == null ? void 0 : f.options)
      },
      "data-testid": n,
      className: R(o, us.selectRoot),
      id: n,
      name: n,
      value: m,
      onChange: P,
      error: v ? [] : ((r == null ? void 0 : r.fieldErrors[n]) || []).join(", "),
      data: $,
      placeholder: e,
      label: t,
      checkIconPosition: d,
      withScrollArea: !1,
      allowDeselect: c,
      rightSection: h,
      disabled: p,
      renderOption: ({ option: j }) => {
        const b = j;
        return /* @__PURE__ */ i.jsx(i.Fragment, { children: (b == null ? void 0 : b.customLabel) ?? (b == null ? void 0 : b.label) });
      }
    }
  );
}, KR = () => /* @__PURE__ */ i.jsx(oe.Fragment, { children: /* @__PURE__ */ i.jsx(E, { justify: "center", align: "center", direction: "column", gap: 0, children: /* @__PURE__ */ i.jsx(U, { name: "nerdWalletReviewIc" }) }) }), lS = "_radioGroup_16tkt_1", dS = "_radio_16tkt_1", cS = "_radioSelected_16tkt_39", uS = "_body_16tkt_64", hS = "_labelWrapper_16tkt_69", fS = "_inner_16tkt_74", pS = "_errorMessage_16tkt_78", or = {
  radioGroup: lS,
  radio: dS,
  radioSelected: cS,
  body: uS,
  labelWrapper: hS,
  inner: fS,
  errorMessage: pS
}, JR = ({
  id: e,
  defaultValue: t,
  error: n,
  options: s,
  label: r,
  description: o,
  radioLabel: a,
  updatedValue: l,
  onChange: d
}) => {
  const [c, u] = O(t || "");
  ne(() => {
    u(t || "");
  }, [t]);
  const h = (p) => {
    u(p), l && l(p), d && d(p);
  };
  return /* @__PURE__ */ i.jsx(
    Yp,
    {
      className: or.radioGroup,
      classNames: { error: or.errorMessage },
      value: c,
      label: r,
      description: o,
      id: e,
      name: e,
      "data-testid": e,
      onChange: h,
      error: ((n == null ? void 0 : n.fieldErrors[e]) || []).join(", "),
      children: s.map((p, f) => /* @__PURE__ */ i.jsx(
        vt,
        {
          value: p.id,
          classNames: {
            labelWrapper: or.labelWrapper,
            body: or.body,
            root: c === p.id ? or.radioSelected : or.radio,
            inner: or.inner
          },
          style: {
            width: `${100 / s.length}%`,
            borderRight: f !== s.length - 1 ? "1px solid #a7b1c7" : "none"
          },
          label: a || /* @__PURE__ */ i.jsxs(E, { gap: 8, fw: 600, children: [
            c === p.id && /* @__PURE__ */ i.jsx("span", { children: /* @__PURE__ */ i.jsx(U, { name: "greenTick", color: "black", size: "16", strokeWidth: "3" }) }),
            /* @__PURE__ */ i.jsx("span", { children: p.name })
          ] })
        },
        p.id
      ))
    }
  );
}, _S = "_sampleContainer_cxk5n_1", mS = "_sampleAccordion_cxk5n_5", gS = "_sampleAccControl_cxk5n_15", vS = "_sampleAccLabel_cxk5n_21", $S = "_sampleAccItem_cxk5n_28", bS = "_indicator_cxk5n_37", xS = "_indicators_cxk5n_48", yS = "_control_cxk5n_55", wS = "_centerAlign_cxk5n_59", CS = "_viewport_cxk5n_65", jS = "_carouselContainer_cxk5n_69", NS = "_dropzone_cxk5n_74", SS = "_iframe_cxk5n_90", kS = "_image_cxk5n_97", ES = "_error_cxk5n_104", IS = "_previewLink_cxk5n_108", PS = "_inner_cxk5n_125", TS = "_deleteButton_cxk5n_132", RS = "_idSelectedBanner_cxk5n_149", LS = "_idSelectedText_cxk5n_164", OS = "_fileSelected_cxk5n_171", FS = "_uploadError_cxk5n_175", ct = {
  sampleContainer: _S,
  sampleAccordion: mS,
  sampleAccControl: gS,
  sampleAccLabel: vS,
  sampleAccItem: $S,
  indicator: bS,
  indicators: xS,
  control: yS,
  centerAlign: wS,
  viewport: CS,
  carouselContainer: jS,
  dropzone: NS,
  iframe: SS,
  image: kS,
  error: ES,
  previewLink: IS,
  inner: PS,
  deleteButton: TS,
  idSelectedBanner: RS,
  idSelectedText: LS,
  fileSelected: OS,
  uploadError: FS
}, AS = 1048576, MS = (e, t) => {
  if (e === "file-too-large")
    return `The file size exceeds the ${t / AS} MB limit. Please upload a smaller file.`;
}, DS = ({ sampleText: e, sampleImages: t }) => {
  const n = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(
    Qt,
    {
      chevronPosition: "right",
      classNames: { root: ct.sampleAccordion, label: ct.sampleAccLabel },
      chevron: /* @__PURE__ */ i.jsx(U, { name: "chevronDown" }),
      defaultValue: n ? void 0 : "1",
      children: /* @__PURE__ */ i.jsxs(Qt.Item, { value: "1", className: ct.sampleAccItem, children: [
        /* @__PURE__ */ i.jsx(Qt.Control, { className: ct.sampleAccControl, children: "Click here to preview the sample" }),
        /* @__PURE__ */ i.jsxs(Qt.Panel, { className: ct.sampleAccPanel, children: [
          /* @__PURE__ */ i.jsx(Hn, { className: ct.sampleContainer, children: /* @__PURE__ */ i.jsx(Hn, { className: ct.sampleInner, children: e }) }),
          /* @__PURE__ */ i.jsx(
            Od,
            {
              slideSize: (t == null ? void 0 : t.length) === 1 ? "100%" : "70%",
              slideGap: "md",
              align: "start",
              withIndicators: (t == null ? void 0 : t.length) !== 1,
              classNames: {
                viewport: ct.viewport,
                container: ct.carouselContainer,
                indicator: ct.indicator,
                control: ct.control,
                indicators: ct.indicators,
                slide: R(ct.slide, { [ct.centerAlign]: (t == null ? void 0 : t.length) === 1 })
              },
              children: t == null ? void 0 : t.map((s, r) => /* @__PURE__ */ i.jsx(Od.Slide, { children: s }, r))
            }
          )
        ] })
      ] })
    }
  );
}, BS = (e) => {
  const { label: t, file: n } = e, s = n instanceof File, r = s ? URL.createObjectURL(n) : n.toString(), o = () => {
    URL.revokeObjectURL(r);
  }, a = s ? n.type : xp(r), l = s ? n.name : yp(r);
  return [it.docx, it.doc].some(
    (c) => c === a
  ) ? /* @__PURE__ */ i.jsx(on, { className: ct.previewLink, href: r, children: l }) : a === it.pdf ? /* @__PURE__ */ i.jsx(
    "iframe",
    {
      "aria-label": t,
      src: r,
      onLoad: o,
      loading: "lazy",
      className: ct.iframe
    }
  ) : /* @__PURE__ */ i.jsx(
    "img",
    {
      "aria-label": t,
      alt: t,
      src: r,
      onLoad: o,
      loading: "lazy",
      className: ct.image
    }
  );
}, WS = ({ fileInfo: e, error: t }) => {
  const { name: n, file: s, onDrop: r, label: o, accept: a, maxSize: l, renderPlaceholder: d } = e, c = dn(null), u = Xr(), [h, p] = O("");
  ne(() => {
    var g;
    if (!c.current) return;
    const m = new DataTransfer();
    s instanceof File && ((g = m == null ? void 0 : m.items) == null || g.add(s), c.current.files = m == null ? void 0 : m.files);
  }, [s]);
  const f = (m) => {
    p(""), r(m[0]);
  };
  return /* @__PURE__ */ i.jsxs(E, { direction: "column", w: "100%", children: [
    /* @__PURE__ */ i.jsx(
      qr,
      {
        "aria-label": `Upload ${o}`,
        onDrop: f,
        className: ct.dropzone,
        classNames: {
          inner: ct.inner,
          root: R({ [ct.fileSelected]: s, [ct.uploadError]: h })
        },
        accept: a,
        multiple: !1,
        maxSize: l,
        onReject: (m) => {
          var v, _;
          r(null);
          const g = m[0];
          p(
            MS((v = g.errors[0]) == null ? void 0 : v.code, l) ?? ((_ = g.errors[0]) == null ? void 0 : _.message)
          );
        },
        children: /* @__PURE__ */ i.jsx(qr.Idle, { children: s ? /* @__PURE__ */ i.jsxs(E, { direction: "column", align: "center", gap: 10, pos: "relative", children: [
          /* @__PURE__ */ i.jsx(BS, { file: s, label: o }),
          /* @__PURE__ */ i.jsxs("div", { className: ct.idSelectedBanner, children: [
            /* @__PURE__ */ i.jsx("span", { className: ct.idSelectedText, children: "Document Selected " }),
            /* @__PURE__ */ i.jsx("span", { children: /* @__PURE__ */ i.jsx(U, { name: "filledGreenTick", size: "21" }) })
          ] }),
          /* @__PURE__ */ i.jsxs(Ee, { className: ct.deleteButton, onClick: () => r(null), children: [
            /* @__PURE__ */ i.jsx(U, { name: "iconEdit" }),
            /* @__PURE__ */ i.jsx("span", { children: "Replace document" })
          ] })
        ] }) : d({ uploadError: h }) })
      }
    ),
    /* @__PURE__ */ i.jsx(
      "input",
      {
        ref: c,
        name: s instanceof File ? n : void 0,
        type: "file",
        id: u,
        hidden: !0
      }
    ),
    /* @__PURE__ */ i.jsx("div", { className: ct.error, style: { paddingTop: "8px" }, children: h || (t == null ? void 0 : t.fieldErrors[n]) })
  ] });
}, ZR = (e) => {
  const t = Ve("(max-width: 767px)"), { filesArr: n = [], sampleDocument: s, error: r, showSampleDocument: o, helperText: a } = e;
  return /* @__PURE__ */ i.jsxs(E, { gap: 20, w: "100%", direction: t ? "column" : "row", children: [
    o && /* @__PURE__ */ i.jsx(DS, { ...s }),
    t && a,
    /* @__PURE__ */ i.jsx(E, { direction: t ? "column" : "row", h: "100%", w: "100%", gap: 20, children: n.map((l, d) => /* @__PURE__ */ i.jsx(WS, { fileInfo: l, error: r }, d)) })
  ] });
}, US = "_googleSignInWrap_1wzpy_1", zS = "_signInContent_1wzpy_9", HS = "_signInDivider_1wzpy_14", qS = "_externalSignInText_1wzpy_20", GS = "_dividerRoot_1wzpy_26", VS = "_ssoErrorStyle_1wzpy_30", YS = "_wrapper_1wzpy_38", KS = "_ssoNudge_1wzpy_42", hs = {
  googleSignInWrap: US,
  signInContent: zS,
  signInDivider: HS,
  externalSignInText: qS,
  dividerRoot: GS,
  ssoErrorStyle: VS,
  wrapper: YS,
  ssoNudge: KS
}, XR = ({
  ssoLoginData: e = [],
  onClickAction: t,
  isSsoFlowInitiated: n,
  ssoError: s = "",
  loginButtonText: r = "Continue with ",
  deviderText: o = "OR",
  ssoErrorMsg: a = ""
}) => {
  const l = (d) => {
    t && t(d);
  };
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: e == null ? void 0 : e.map((d, c) => /* @__PURE__ */ i.jsxs("div", { className: hs.wrapper, children: [
    /* @__PURE__ */ i.jsx("span", { className: hs.ssoNudge, children: "Most used" }),
    /* @__PURE__ */ i.jsx(
      E,
      {
        justify: "center",
        align: "center",
        className: hs.googleSignInWrap,
        onClick: () => l(d),
        children: /* @__PURE__ */ i.jsxs(E, { align: "center", className: hs.signInContent, children: [
          /* @__PURE__ */ i.jsx(U, { name: (d == null ? void 0 : d.ssoLoginImg) ?? "" }),
          /* @__PURE__ */ i.jsx(Ce, { className: hs.externalSignInText, children: n ? /* @__PURE__ */ i.jsx(
            ts,
            {
              color: "yellow",
              type: "dots",
              size: "md",
              customLoaderRootStyle: hs.customLoaderRootStyle
            }
          ) : `${r} ${d == null ? void 0 : d.ssoLoginName}` })
        ] })
      }
    ),
    (s == null ? void 0 : s.length) > 0 || a && /* @__PURE__ */ i.jsx(Ce, { className: hs.ssoErrorStyle, children: a != null && a.length ? a : "Something went wrong, kindly try again." }),
    /* @__PURE__ */ i.jsx(
      Vn,
      {
        classNames: { root: hs.dividerRoot },
        my: "xs",
        label: /* @__PURE__ */ i.jsx(Ce, { className: hs.signInDivider, children: o }),
        labelPosition: "center"
      }
    )
  ] }, d.ssoLoginName)) });
}, JS = "_notificationDescription_yrh6w_1", ZS = "_notificationRoot_yrh6w_11", XS = "_progressSection_yrh6w_20", QS = "_notificationTitle_yrh6w_24", sl = {
  notificationDescription: JS,
  notificationRoot: ZS,
  progressSection: XS,
  notificationTitle: QS
}, QR = ({
  flowType: e,
  progressbarSize: t,
  notificationOption: n
}) => {
  const [s, r] = O(0), [o, a] = O(!1);
  return ne(() => {
    if (e)
      try {
        a(!0), r(0);
        const l = n == null ? void 0 : n.progressBarDuration, d = 50, c = 100 / (l / d);
        let u = 0;
        const h = setInterval(() => {
          u += c, r(Math.min(u, 100)), u >= 100 && clearInterval(h);
        }, d), p = setTimeout(() => {
          a(!1), clearInterval(h);
        }, l);
        return () => {
          clearInterval(h), clearTimeout(p);
        };
      } catch {
      }
  }, []), /* @__PURE__ */ i.jsx(i.Fragment, { children: o && /* @__PURE__ */ i.jsx(
    Zu,
    {
      withCloseButton: n == null ? void 0 : n.withCloseButton,
      withBorder: n == null ? void 0 : n.withBorder,
      icon: n == null ? void 0 : n.icon,
      color: n == null ? void 0 : n.color,
      title: n == null ? void 0 : n.title,
      classNames: {
        description: sl.notificationDescription,
        root: sl.notificationRoot,
        title: sl.notificationTitle
      },
      children: /* @__PURE__ */ i.jsx(
        Qu,
        {
          color: n == null ? void 0 : n.progressBarColor,
          value: s,
          size: t,
          striped: !0,
          animated: !0
        }
      )
    }
  ) });
}, ek = "_infoFlex_1dgjm_1", tk = "_infoText_1dgjm_26", qu = {
  infoFlex: ek,
  infoText: tk
}, eL = (e) => {
  const { message: t, className: n } = e;
  return /* @__PURE__ */ i.jsxs(E, { className: R(qu.infoFlex, n), children: [
    /* @__PURE__ */ i.jsx(U, { name: "yellowAlert" }),
    /* @__PURE__ */ i.jsx(I, { className: qu.infoText, children: t })
  ] });
}, Id = (e) => ({
  paddingRight: e % 2 === 0 ? 40 : 20,
  paddingLeft: e % 2 !== 0 ? 40 : 20
}), nk = "_customGridCol_1eqcm_1", sk = "_textFieldContentEmail_1eqcm_10", rk = "_notEditTextFieldContentEmail_1eqcm_26", ik = "_unverified_1eqcm_46", ok = "_verified_1eqcm_55", ak = "_loader_1eqcm_70", lk = "_asteriskClass_1eqcm_75", Ls = {
  customGridCol: nk,
  textFieldContentEmail: sk,
  notEditTextFieldContentEmail: rk,
  unverified: ik,
  verified: ok,
  loader: ak,
  asteriskClass: lk
}, tL = ({
  emails: e,
  errors: t,
  onEmailChange: n,
  isEditing: s,
  verifyClick: r,
  triggerOtp: o,
  loader: a
}) => {
  const l = Ve("(max-width: 767px)"), [d, c] = O(null), u = (h) => {
    const p = (h == null ? void 0 : h.type) === pa;
    c(p ? null : h.id), (p ? r : () => o("email", h.email, id.VERIFICATION, ""))();
  };
  return ne(() => {
    a || c(null);
  }, [a]), /* @__PURE__ */ i.jsx(i.Fragment, { children: e == null ? void 0 : e.map((h, p) => {
    const f = ((h == null ? void 0 : h.type) === pa || !s) && h.email, g = d === h.id && /* @__PURE__ */ i.jsx("span", { className: Ls.loader, children: /* @__PURE__ */ i.jsx(ts, { color: "yellow", type: "dots", size: "xs" }) }), v = () => !h.isVerified && !s ? /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Ls.unverified,
        onClick: () => u(h),
        children: [
          "(Click to verify) ",
          g
        ]
      }
    ) : h.reverify ? /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Ls.unverified,
        onClick: () => u(h),
        children: [
          "(Click to reverify) ",
          g
        ]
      }
    ) : h.isVerified ? /* @__PURE__ */ i.jsxs(Ee, { className: Ls.verified, children: [
      "Verified ",
      /* @__PURE__ */ i.jsx("img", { src: "/images/done.webp" })
    ] }) : "";
    return /* @__PURE__ */ i.jsx(
      fr,
      {
        span: { lg: 6 },
        className: Ls.customGridCol,
        style: l ? {} : Id(p),
        children: /* @__PURE__ */ i.jsx(
          Di,
          {
            defaultValue: h.email,
            updatedValue: (_) => n(h.id, _, h.type, h == null ? void 0 : h.savedEmail),
            readOnly: s ? (h == null ? void 0 : h.type) === pa : !0,
            label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
              h.label,
              h.showAsterisk && /* @__PURE__ */ i.jsxs("span", { "aria-label": "required", className: Ls.asteriskClass, children: [
                " ",
                "*"
              ] }),
              " ",
              /* @__PURE__ */ i.jsx("span", { children: f && v() })
            ] }),
            id: h.id,
            error: t,
            className: s ? Ls.textFieldContentEmail : Ls.notEditTextFieldContentEmail,
            placeholder: h.placeHolder
          }
        )
      },
      h.id
    );
  }) });
}, dk = "_customGridCol_1toyb_1", ck = "_textFieldContentEmail_1toyb_10", uk = "_unverified_1toyb_20", hk = "_verified_1toyb_28", fk = "_phoneNumberStyles_1toyb_43", pk = "_innerGridStyle_1toyb_57", _k = "_customLabelClass_1toyb_66", mk = "_customRootClass_1toyb_70", gk = "_textFieldNonEditableState_1toyb_74", vk = "_autoCompleteNonEditableState_1toyb_86", $k = "_textFieldDisableState_1toyb_92", bk = "_autoCompleteDisableState_1toyb_104", xk = "_phoneNumberDisableStyles_1toyb_110", yk = "_customSectionIcon_1toyb_126", wk = "_customErrorStyle_1toyb_132", Ck = "_customDdropdownError_1toyb_136", jk = "_updatePolicy_1toyb_140", Nk = "_loader_1toyb_148", Sk = "_verifySpan_1toyb_153", kk = "_asteriskClass_1toyb_157", Rt = {
  customGridCol: dk,
  textFieldContentEmail: ck,
  unverified: uk,
  verified: hk,
  phoneNumberStyles: fk,
  innerGridStyle: pk,
  customLabelClass: _k,
  customRootClass: mk,
  textFieldNonEditableState: gk,
  autoCompleteNonEditableState: vk,
  textFieldDisableState: $k,
  autoCompleteDisableState: bk,
  phoneNumberDisableStyles: xk,
  customSectionIcon: yk,
  customErrorStyle: wk,
  customDdropdownError: Ck,
  updatePolicy: jk,
  loader: Nk,
  verifySpan: Sk,
  asteriskClass: kk
}, nL = ({
  phoneNumbersList: e,
  onPhoneChange: t,
  isEditing: n,
  countryCodes: s,
  onPhoneKeyDown: r,
  triggerPhoneOtp: o,
  loader: a
}) => {
  const [l, d] = O(null), c = Ve("(max-width: 767px)"), u = (h) => {
    d(h.id), !a && o(h);
  };
  return ne(() => {
    a || d(null);
  }, [a]), /* @__PURE__ */ i.jsx(i.Fragment, { children: e == null ? void 0 : e.map((h, p) => {
    var _;
    const f = !n && h.phone, g = l === h.id && /* @__PURE__ */ i.jsx("span", { className: Rt.loader, children: /* @__PURE__ */ i.jsx(ts, { color: "yellow", type: "dots", size: "xs" }) }), v = () => !h.isVerified && h.verificationMode ? /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Rt.unverified,
        onClick: () => u(h),
        children: [
          "(Click to verify) ",
          g
        ]
      }
    ) : h.reverify ? /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Rt.unverified,
        onClick: () => u(h),
        children: [
          "(Click to reverify) ",
          g
        ]
      }
    ) : h.isVerified ? /* @__PURE__ */ i.jsxs(I, { component: "p", className: Rt.verified, children: [
      "Verified",
      /* @__PURE__ */ i.jsx("img", { src: "/images/done.webp" })
    ] }) : "";
    return /* @__PURE__ */ i.jsx(
      fr,
      {
        span: { lg: 6 },
        className: Rt.customGridCol,
        style: c ? {} : Id(p),
        children: /* @__PURE__ */ i.jsx(
          Np,
          {
            id: h.id,
            label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
              h.label,
              h.showAsterisk && /* @__PURE__ */ i.jsxs("span", { "aria-label": "required", className: Rt.asteriskClass, children: [
                " ",
                "*"
              ] }),
              " ",
              /* @__PURE__ */ i.jsx("span", { className: Rt.verifySpan, children: f && v() })
            ] }),
            countryCodes: h.type === "school" ? H0 : s,
            defaultValue: h.phone,
            isNewDesignValid: !0,
            readOnly: !n,
            disabled: !n,
            customPhoneNumberStyle: Rt.phoneNumberStyles,
            customInnerGridStyle: Rt.innerGridStyle,
            customLabelClass: Rt.customLabelClass,
            customRootClass: Rt.customRootClass,
            customColumnClass: Rt.customColumnClass,
            textFieldDisableState: n ? Rt.textFieldDisableState : Rt.textFieldNonEditableState,
            autoCompleteDisableState: n ? Rt.autoCompleteDisableState : Rt.autoCompleteNonEditableState,
            phoneNumberDisableStyles: Rt.phoneNumberDisableStyles,
            customSectionIcon: Rt.customSectionIcon,
            customErrorStyle: Rt.customErrorStyle,
            customDdropdownError: Rt.customDdropdownError,
            onChange: ($, y) => t($, y, h.id, h.type),
            validity: "validityPhoneNumber",
            IncomingselectedCountryData: h.selectedCountryData,
            userInput: h.codeInput,
            isProfileFlow: !0,
            onKeyDownCallback: ($, y, P, j, b, N) => {
              r(
                $,
                y,
                P,
                j,
                b,
                N,
                h.id,
                "regularPhone",
                h.savedPhoneNo
              );
            },
            customError: h.customError,
            metaData: (_ = h == null ? void 0 : h.metadata) == null ? void 0 : _.mobile_region
          }
        )
      },
      h.id
    );
  }) });
}, Ek = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  text: (e) => {
    const t = new RegExp("^[a-zA-Z_ ]$"), n = String.fromCharCode(e.charCode ? e.charCode : e.which);
    if (!t.test(n))
      return e.preventDefault(), !1;
  },
  number: (e) => {
    const t = new RegExp("^[0-9_-]$"), n = String.fromCharCode(e.charCode ? e.charCode : e.which);
    if (!t.test(n))
      return e.preventDefault(), !1;
  }
}, Ik = "_customGridCol_7y8qs_1", Pk = "_referenceCol_7y8qs_1", Tk = "_textFieldContentEmail_7y8qs_12", Rk = "_gridCol_7y8qs_28", Lk = "_gridColRelationship_7y8qs_39", Ok = "_unverified_7y8qs_51", Fk = "_verified_7y8qs_60", Ak = "_phoneNumberStyles_7y8qs_75", Mk = "_innerGridStyle_7y8qs_89", Dk = "_customLabelClass_7y8qs_98", Bk = "_customRootClass_7y8qs_104", Wk = "_textFieldDisableState_7y8qs_108", Uk = "_autoCompleteDisableState_7y8qs_120", zk = "_phoneNumberDisableStyles_7y8qs_126", Hk = "_customSectionIcon_7y8qs_142", qk = "_customErrorStyle_7y8qs_148", Gk = "_customDdropdownError_7y8qs_152", Vk = "_notEditTextFieldContentEmail_7y8qs_156", Yk = "_loader_7y8qs_176", Kk = "_verifySpan_7y8qs_181", Fe = {
  customGridCol: Ik,
  referenceCol: Pk,
  textFieldContentEmail: Tk,
  gridCol: Rk,
  gridColRelationship: Lk,
  unverified: Ok,
  verified: Fk,
  phoneNumberStyles: Ak,
  innerGridStyle: Mk,
  customLabelClass: Dk,
  customRootClass: Bk,
  textFieldDisableState: Wk,
  autoCompleteDisableState: Uk,
  phoneNumberDisableStyles: zk,
  customSectionIcon: Hk,
  customErrorStyle: qk,
  customDdropdownError: Gk,
  notEditTextFieldContentEmail: Vk,
  loader: Yk,
  verifySpan: Kk
}, sL = ({
  referenceList: e,
  errors: t,
  onPhoneChange: n,
  onEmailChange: s,
  isEditing: r,
  countryCodes: o,
  onPhoneKeyDown: a,
  triggerOtp: l,
  loader: d = !0,
  triggerPhoneOtp: c,
  onNameChange: u,
  referenceRelations: h,
  onRelationChange: p
}) => {
  const [f, m] = O(null), [g, v] = O(null), _ = () => ({
    paddingRight: 40,
    paddingLeft: 20
  }), $ = () => ({
    paddingRight: 20,
    paddingLeft: 40
  }), y = Ve("(max-width: 767px)"), P = (b) => {
    m(b.emailId), !d && l("email", b.email, id.REFERENCE_EMAIL_CONFIRMATION, "");
  }, j = (b) => {
    v(b.id), !d && c(b);
  };
  return ne(() => {
    d || (m(null), v(null));
  }, [d]), /* @__PURE__ */ i.jsx(i.Fragment, { children: e == null ? void 0 : e.map((b) => {
    var G;
    const N = !r && b.email, C = !r && b.phone, S = f === b.emailId, F = g === b.id, W = S && /* @__PURE__ */ i.jsx("span", { className: Fe.loader, children: /* @__PURE__ */ i.jsx(ts, { color: "yellow", type: "dots", size: "xs" }) }), D = F && /* @__PURE__ */ i.jsx("span", { className: Fe.loader, children: /* @__PURE__ */ i.jsx(ts, { color: "yellow", type: "dots", size: "xs" }) }), B = () => b.isEmailVerified ? /* @__PURE__ */ i.jsxs(Ee, { className: Fe.verified, children: [
      "Verified",
      /* @__PURE__ */ i.jsx("img", { src: "/images/done.webp" })
    ] }) : /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Fe.unverified,
        onClick: () => P(b),
        children: [
          "(Click to verify) ",
          W
        ]
      }
    ), q = () => !b.isPhoneVerified && b.verificationMode ? /* @__PURE__ */ i.jsxs(
      Ee,
      {
        className: Fe.unverified,
        onClick: () => j(b),
        children: [
          "(Click to verify) ",
          D
        ]
      }
    ) : b.isPhoneVerified ? /* @__PURE__ */ i.jsxs(Ee, { className: Fe.verified, children: [
      "Verified",
      /* @__PURE__ */ i.jsx("img", { src: "/images/done.webp" })
    ] }) : "";
    return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(
        fr,
        {
          span: { lg: 6 },
          className: R(Fe.customGridCol, Fe.referenceCol),
          style: y ? {} : _,
          children: /* @__PURE__ */ i.jsx(
            Di,
            {
              defaultValue: b.name,
              updatedValue: (z) => u(z, b),
              readOnly: !r,
              label: /* @__PURE__ */ i.jsx(i.Fragment, { children: b.nameLabel }),
              id: b.nameId,
              error: t,
              className: r ? Fe.textFieldContentEmail : Fe.notEditTextFieldContentEmail,
              placeholder: b.nameLabel,
              onlyTextAllowed: !0,
              maxLength: "40",
              keyPress: Ek.text
            }
          )
        },
        b.id
      ),
      /* @__PURE__ */ i.jsx(
        fr,
        {
          span: { lg: 6 },
          className: R(Fe.customGridCol, Fe.referenceCol),
          style: y ? {} : $,
          children: /* @__PURE__ */ i.jsx(
            Di,
            {
              defaultValue: b.email,
              updatedValue: (z) => s(
                b.emailId,
                z,
                b.type,
                b.savedEmail
              ),
              readOnly: !r,
              label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                b.emailLabel,
                " ",
                /* @__PURE__ */ i.jsxs("span", { children: [
                  " ",
                  N && B()
                ] })
              ] }),
              id: b.emailId,
              error: t,
              className: r ? Fe.textFieldContentEmail : Fe.notEditTextFieldContentEmail,
              placeholder: b.emailPlaceholder
            }
          )
        },
        b.emailId
      ),
      /* @__PURE__ */ i.jsx(fr, { span: { lg: 6 }, className: R(Fe.gridCol, Fe.referenceCol), children: /* @__PURE__ */ i.jsx(
        Np,
        {
          id: b.id,
          label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            b.phoneLabel,
            " ",
            /* @__PURE__ */ i.jsx("span", { className: Fe.verifySpan, children: C && q() })
          ] }),
          countryCodes: o,
          defaultValue: b.phone,
          isNewDesignValid: !0,
          readOnly: !r,
          disabled: !r,
          customPhoneNumberStyle: Fe.phoneNumberStyles,
          customInnerGridStyle: Fe.innerGridStyle,
          customLabelClass: Fe.customLabelClass,
          customRootClass: Fe.customRootClass,
          customColumnClass: Fe.customColumnClass,
          textFieldDisableState: r ? Fe.textFieldDisableState : Fe.textFieldNonEditableState,
          autoCompleteDisableState: r ? Fe.autoCompleteDisableState : Fe.autoCompleteNonEditableState,
          phoneNumberDisableStyles: Fe.phoneNumberDisableStyles,
          customSectionIcon: Fe.customSectionIcon,
          customErrorStyle: Fe.customErrorStyle,
          customDdropdownError: Fe.customDdropdownError,
          onChange: (z, re) => n(z, re, b.id, b.type),
          validity: "validityPhoneNumber",
          IncomingselectedCountryData: b.selectedCountryData,
          userInput: b.codeInput,
          isProfileFlow: !0,
          onKeyDownCallback: (z, re, X, Q, M, he) => {
            a(
              z,
              re,
              X,
              Q,
              M,
              he,
              b.id,
              "reference",
              b.savedPhoneNo
            );
          },
          customError: b.customPhoneError,
          metaData: (G = b == null ? void 0 : b.metadata) == null ? void 0 : G.mobile_region
        }
      ) }),
      /* @__PURE__ */ i.jsx(
        fr,
        {
          span: { lg: 6 },
          className: R(Fe.gridColRelationship, Fe.referenceCol),
          style: y ? {} : $,
          children: /* @__PURE__ */ i.jsx(
            aS,
            {
              id: b.relationshipId,
              getOptions: () => h,
              disabled: !r,
              updatedValue: (z) => p(z, b),
              error: t,
              defaultValue: b.relationship ?? "",
              checkIconPosition: "right",
              allowDeselect: !1,
              className: r ? Fe.textFieldContentEmail : Fe.notEditTextFieldContentEmail,
              placeholder: b.relationShipLabel,
              label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                b.relationShipLabel,
                " "
              ] })
            }
          )
        }
      )
    ] });
  }) });
}, Jk = "_customGridCol_1lh5p_1", Zk = "_textFieldContentEmail_1lh5p_10", Xk = "_unverified_1lh5p_26", Qk = "_verified_1lh5p_35", Gu = {
  customGridCol: Jk,
  textFieldContentEmail: Zk,
  unverified: Xk,
  verified: Qk
}, rL = ({ addressList: e }) => {
  const t = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: e == null ? void 0 : e.map((n, s) => /* @__PURE__ */ i.jsx(
    fr,
    {
      span: { lg: 6 },
      className: Gu.customGridCol,
      style: t ? {} : Id(s),
      children: /* @__PURE__ */ i.jsx(
        Di,
        {
          defaultValue: n.value,
          readOnly: n.disabled,
          label: n.label,
          id: n.id,
          className: Gu.textFieldContentEmail,
          placeholder: n.placeHolder
        }
      )
    },
    n.id
  )) });
}, eE = "_signInText_8hujf_1", tE = "_infoText_8hujf_12", nE = "_strenthinfoText_8hujf_18", sE = "_mainContainer_8hujf_24", rE = "_headerText_8hujf_34", iE = "_loginText_8hujf_39", oE = "_centerDiv_8hujf_44", aE = "_link_8hujf_51", lE = "_ankerFont_8hujf_58", dE = "_validationText_8hujf_66", cE = "_button_8hujf_77", uE = "_firstInfoText_8hujf_97", hE = "_password_8hujf_105", fE = "_passwordStrengthContainer_8hujf_121", fs = {
  signInText: eE,
  infoText: tE,
  strenthinfoText: nE,
  mainContainer: sE,
  headerText: rE,
  loginText: iE,
  centerDiv: oE,
  link: aE,
  ankerFont: lE,
  validationText: dE,
  button: cE,
  firstInfoText: uE,
  password: hE,
  passwordStrengthContainer: fE
}, iL = ({
  errors: e = null,
  onChange: t,
  userFirstName: n,
  userLastName: s
}) => {
  var j;
  Ve("(max-width: 767px)");
  const r = {
    charCount: !1,
    upperCase: !1,
    splChar: !1
  }, [o, a] = O(r), [l, d] = O(!1), [c, u] = O(""), [h, p] = O(""), [f, m] = O(""), [g, v] = O(null), _ = (b) => {
    a(r);
    const N = /[^a-zA-Z0-9]/, C = {
      charCount: b.length > 7 && !(b != null && b.toLowerCase().includes(n == null ? void 0 : n.toLowerCase())) && !(b != null && b.toLowerCase().includes(s == null ? void 0 : s.toLowerCase())),
      upperCase: /[A-Z]/g.test(b) && /[a-z]/g.test(b),
      splChar: /\d/.test(b) && N.test(b)
    };
    v(f && f !== b ? "Passwords do not match" : ""), u(b), a(C);
    let S = !1;
    S = Object.values(C).every((F) => F === !0), d(S), P(b, f, h);
  }, $ = (b) => {
    m(b), P(c, b, h), v(b !== c ? "Passwords do not match" : "");
  }, y = (b) => {
    p(b), P(c, f, b);
  }, P = (b, N, C) => {
    const S = b === N && Object.values(o).every((F) => F === !0) && (C == null ? void 0 : C.length) > 4;
    t(b, N, C, S);
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    (e || g) && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(Ce, { className: fs.validationText, children: g || ((j = (e == null ? void 0 : e.fieldErrors.confirmNewPassword) || []) == null ? void 0 : j.join(", ")) }),
      /* @__PURE__ */ i.jsx($t, { h: 30 })
    ] }),
    /* @__PURE__ */ i.jsx(
      ca,
      {
        id: "oldPassword",
        placeholder: "Enter your old password",
        label: "Old Password",
        defaultValue: "",
        updatedValue: (b) => y(b),
        className: fs.password,
        maxLength: "20"
      }
    ),
    /* @__PURE__ */ i.jsx(ee, { order: 6, fontWeight: "400", variant: "black", className: fs.firstInfoText, children: "If this is your first time resetting, please check your email for the code." }),
    /* @__PURE__ */ i.jsx(
      ca,
      {
        id: "newPassword",
        placeholder: "Enter your new password ",
        label: "New password",
        updatedValue: (b) => _(b),
        defaultValue: "",
        maxLength: "20",
        className: fs.password
      }
    ),
    /* @__PURE__ */ i.jsx("div", { className: fs.passwordStrengthContainer, children: /* @__PURE__ */ i.jsxs(E, { direction: "column", gap: 0, children: [
      /* @__PURE__ */ i.jsxs(E, { align: "center", gap: "xs", children: [
        /* @__PURE__ */ i.jsx("div", { children: o.charCount ? /* @__PURE__ */ i.jsx(U, { name: "smGreenCheck" }) : /* @__PURE__ */ i.jsx(U, { name: "smGreyCheck" }) }),
        /* @__PURE__ */ i.jsx(ee, { order: 6, fontWeight: "400", variant: "black", className: fs.infoText, children: "Create a new 8-character password without your first or last name" })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { align: "center", gap: "xs", children: [
        /* @__PURE__ */ i.jsx("div", { children: o.upperCase ? /* @__PURE__ */ i.jsx(U, { name: "smGreenCheck" }) : /* @__PURE__ */ i.jsx(U, { name: "smGreyCheck" }) }),
        /* @__PURE__ */ i.jsx(ee, { order: 6, fontWeight: "400", variant: "black", className: fs.infoText, children: "Must contain one uppercase & lowercase letter (A-Z, a-z)" })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { align: "center", gap: "xs", children: [
        /* @__PURE__ */ i.jsx("div", { children: o.splChar ? /* @__PURE__ */ i.jsx(U, { name: "smGreenCheck" }) : /* @__PURE__ */ i.jsx(U, { name: "smGreyCheck" }) }),
        /* @__PURE__ */ i.jsx(ee, { order: 6, fontWeight: "400", variant: "black", className: fs.infoText, children: "Must contain one number (0-9) & one symbol (!, @, #, etc)" })
      ] })
    ] }) }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    /* @__PURE__ */ i.jsx(
      ca,
      {
        id: "confirmNewPassword",
        placeholder: "Enter and confirm your new password",
        label: "Confirm your new password",
        defaultValue: "",
        maxLength: "20",
        updatedValue: (b) => $(b),
        className: fs.password
      }
    ),
    /* @__PURE__ */ i.jsx($t, { h: 20 })
  ] });
}, pE = "_accTitleWrap_k7f6u_1", _E = "_toggleButton_k7f6u_7", mE = "_toggleButtonExpanded_k7f6u_23", gE = "_control_k7f6u_28", vE = "_transparentContainer_k7f6u_37", $E = "_panel_k7f6u_47", bE = "_content_k7f6u_52", xE = "_updatePolicy_k7f6u_56", yE = "_consentText_k7f6u_61", wE = "_buttonsWrap_k7f6u_66", CE = "_textBtn_k7f6u_74", Os = {
  accTitleWrap: pE,
  toggleButton: _E,
  toggleButtonExpanded: mE,
  control: gE,
  transparentContainer: vE,
  panel: $E,
  content: bE,
  updatePolicy: xE,
  consentText: yE,
  buttonsWrap: wE,
  textBtn: CE
}, oL = ({
  showUserConsentBlock: e = !1,
  triggerOtp: t,
  acceptConsentClick: n,
  declineConsentClick: s,
  currentNotificationStatus: r,
  email: o,
  loader: a,
  accordionTitle: l = "Privacy terms",
  consentText: d,
  accordionConsentText: c,
  acceptButtonText: u = "Agree and continue",
  declineButtonText: h = "decline",
  updateButtonText: p = "Update privacy",
  loadingText: f = "Loading....."
}) => {
  const [m, g] = O(a), v = (_, $, y) => {
    t(_, $, y, ""), g(!0);
  };
  return ne(() => {
    g(a);
  }, [a]), /* @__PURE__ */ i.jsx(i.Fragment, { children: e ? /* @__PURE__ */ i.jsx(
    Qt,
    {
      radius: "lg",
      chevronPosition: "left",
      defaultValue: "customization",
      classNames: Os,
      children: /* @__PURE__ */ i.jsxs(Qt.Item, { value: "customization", children: [
        /* @__PURE__ */ i.jsx(Qt.Control, { children: /* @__PURE__ */ i.jsx(ys, { className: Os.accTitleWrap, fw: "700", order: 3, children: /* @__PURE__ */ i.jsx(ys, { variant: "blue", order: 4, fw: "700", pt: 14, pb: 8, children: l }) }) }),
        /* @__PURE__ */ i.jsx(Qt.Panel, { children: /* @__PURE__ */ i.jsx(T, { justify: "flex-start", children: /* @__PURE__ */ i.jsxs("div", { className: Os.transparentContainer, children: [
          /* @__PURE__ */ i.jsx(I, { className: Os.consentText, children: c }),
          /* @__PURE__ */ i.jsxs(E, { className: Os.buttonsWrap, children: [
            /* @__PURE__ */ i.jsx(qe, { variant: "filled", onClick: n, uppercase: !0, children: u }),
            /* @__PURE__ */ i.jsx(qe, { variant: "outline", onClick: s, uppercase: !0, children: h })
          ] })
        ] }) }) })
      ] })
    }
  ) : /* @__PURE__ */ i.jsxs(E, { className: Os.updatePolicy, children: [
    /* @__PURE__ */ i.jsx(U, { name: r ? "greenNotFilledCheck" : "redCross" }),
    /* @__PURE__ */ i.jsx(I, { className: Os.consentText, children: d }),
    /* @__PURE__ */ i.jsx(
      Ee,
      {
        disabled: m,
        onClick: () => v("email", o, id.CONSENT),
        className: Os.textBtn,
        children: m ? f : p
      }
    )
  ] }) });
}, jE = "_container_1ebtn_1", NE = "_linkStyle_1ebtn_7", SE = "_textWrapper_1ebtn_12", kE = "_emailIcon_1ebtn_16", EE = "_error_1ebtn_20", IE = "_displayVal_1ebtn_26", PE = "_resendBtn_1ebtn_30", Fr = {
  container: jE,
  linkStyle: NE,
  textWrapper: SE,
  emailIcon: kE,
  error: EE,
  displayVal: IE,
  resendBtn: PE
}, aL = ({ callbackAction: e, otpState: t, triggerOtp: n }) => {
  const [s, r] = O(""), [o, a] = O(t.loading), [l, d] = O(t.error || ""), [c, u] = O(30), [h, p] = O(!0), f = (v) => {
    r(v);
  }, m = () => {
    (s == null ? void 0 : s.length) === 6 ? (a(!0), e(s, t == null ? void 0 : t.value, t == null ? void 0 : t.type, t == null ? void 0 : t.purpose)) : d("Please enter valid otp");
  };
  ne(() => {
    d((t == null ? void 0 : t.error) || "");
  }, [t == null ? void 0 : t.error]), ne(() => {
    a(t == null ? void 0 : t.loading);
  }, [t.loading]), ne(() => {
    let v;
    return h && (v = setInterval(() => {
      u((_) => _ <= 1 ? (clearInterval(v), p(!1), 30) : _ - 1);
    }, 1e3)), () => clearInterval(v);
  }, [h]);
  const g = async () => {
    n(t.type, t.value, t.purpose, t.communicationMedium), p(!0), u(30), r(""), d("");
  };
  return /* @__PURE__ */ i.jsxs(E, { classNames: { root: Fr.dsc }, justify: "center", align: "center", direction: "column", children: [
    t.type === "email" ? /* @__PURE__ */ i.jsx(U, { name: "emailSentConfirm", className: Fr.emailIcon }) : /* @__PURE__ */ i.jsx(U, { name: "validateContact" }),
    /* @__PURE__ */ i.jsx(E, { justify: "center", align: "center", children: /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "yellow", fontWeight: "700", children: t.type === "email" ? "Verify your email" : "Verify your mobile number" }) }),
    /* @__PURE__ */ i.jsxs(
      E,
      {
        classNames: { root: Fr.textWrapper },
        justify: "center",
        align: "center",
        direction: "column",
        children: [
          /* @__PURE__ */ i.jsx(Ce, { size: "md", color: "#41434C", fw: "400", children: "We've sent a verification code to" }),
          /* @__PURE__ */ i.jsxs(Ce, { size: "md", color: "#41434C", fw: "700", className: Fr.displayVal, children: [
            t.communicationMedium,
            " ",
            t.value
          ] }),
          /* @__PURE__ */ i.jsxs(Ce, { size: "md", color: "#41434C", fw: "400", children: [
            "Enter the code to verify and continue.",
            " "
          ] })
        ]
      }
    ),
    /* @__PURE__ */ i.jsx(E, { justify: "center", align: "center", children: /* @__PURE__ */ i.jsx(
      Kp,
      {
        type: /^[0-9]*$/,
        inputType: "tel",
        inputMode: "numeric",
        id: "esignCode",
        name: "esignCode",
        length: 6,
        onChange: f,
        value: s
      }
    ) }),
    l && /* @__PURE__ */ i.jsx(Ce, { className: Fr.error, children: l }),
    /* @__PURE__ */ i.jsx($t, { h: 15 }),
    /* @__PURE__ */ i.jsx(
      qe,
      {
        variant: "filled",
        onClick: m,
        disabled: (s == null ? void 0 : s.length) !== 6,
        uppercase: !0,
        loading: o,
        children: "Verify"
      }
    ),
    /* @__PURE__ */ i.jsx(
      qe,
      {
        variant: "outline",
        onClick: g,
        disabled: h,
        className: Fr.resendBtn,
        children: h ? `Re-send OTP code in ${c}s` : "Resend OTP"
      }
    )
  ] });
}, TE = "_repaymentJourneyWrapper_gx8i2_1", RE = "_journeyContainer_gx8i2_15", LE = "_period_gx8i2_28", OE = "_periodWithBorder_gx8i2_41", FE = "_iconContainer_gx8i2_54", AE = "_periodTitle_gx8i2_63", ME = "_periodDuration_gx8i2_70", DE = "_periodAmount_gx8i2_76", BE = "_paymentType_gx8i2_82", WE = "_description_gx8i2_89", UE = "_note_gx8i2_96", Dn = {
  repaymentJourneyWrapper: TE,
  journeyContainer: RE,
  period: LE,
  periodWithBorder: OE,
  iconContainer: FE,
  periodTitle: AE,
  periodDuration: ME,
  periodAmount: DE,
  paymentType: BE,
  description: WE,
  note: UE
}, lL = ({
  repaymentAmounts: e,
  repaymentPhases: t,
  showBorderBetweenPeriods: n = !1
}) => {
  const s = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(ee, { variant: "blue", order: s ? 4 : 3, fontWeight: "700", children: "Repayment journey" }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    /* @__PURE__ */ i.jsxs("div", { className: Dn.repaymentJourneyWrapper, children: [
      /* @__PURE__ */ i.jsx("div", { className: Dn.journeyContainer, children: t == null ? void 0 : t.map((r, o) => /* @__PURE__ */ i.jsxs(
        "div",
        {
          className: `${Dn.period} ${n && o === 0 ? Dn.periodWithBorder : ""}`,
          children: [
            /* @__PURE__ */ i.jsx("div", { className: Dn.iconContainer, children: /* @__PURE__ */ i.jsx(U, { name: r.icon }) }),
            /* @__PURE__ */ i.jsx(I, { component: "h3", className: Dn.periodTitle, children: r.title }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Dn.periodDuration, children: r.duration }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Dn.periodAmount, children: e != null && e[r.key] ? `${Je(
              e == null ? void 0 : e[r.key]
            )}/Month` : "" }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Dn.paymentType, children: r.paymentType }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Dn.description, children: r.description })
          ]
        },
        r.key
      )) }),
      /* @__PURE__ */ i.jsx(I, { component: "p", className: Dn.note, children: "Note: The interest-only period is capped to a maximum of 30 months from the date of disbursement." })
    ] })
  ] });
}, zE = "_wrapper_10qeq_1", HE = "_benefitsContainer_10qeq_5", qE = "_benefitItem_10qeq_11", GE = "_iconContainer_10qeq_19", VE = "_textContainer_10qeq_33", YE = "_title_10qeq_38", Ar = {
  wrapper: zE,
  benefitsContainer: HE,
  benefitItem: qE,
  iconContainer: GE,
  textContainer: VE,
  title: YE
}, dL = ({
  benefits: e
}) => {
  const t = Ve("(max-width: 767px)");
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs(ee, { fontWeight: "700", variant: "blue", order: t ? 4 : 3, children: [
      "Unlock free exclusive benefits ",
      !t && "with e-sign!"
    ] }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    /* @__PURE__ */ i.jsx("div", { className: Ar.wrapper, children: /* @__PURE__ */ i.jsx("div", { className: Ar.benefitsContainer, children: e.map((n, s) => /* @__PURE__ */ i.jsxs("div", { className: Ar.benefitItem, children: [
      /* @__PURE__ */ i.jsx("div", { className: Ar.iconContainer, children: /* @__PURE__ */ i.jsx(U, { name: n.icon, style: { transform: `scale(${n.scale})` } }) }),
      /* @__PURE__ */ i.jsx("div", { className: Ar.textContainer, children: /* @__PURE__ */ i.jsx("div", { className: Ar.title, children: n.title }) })
    ] }, s)) }) })
  ] });
}, Sp = (e = {}) => {
  try {
    if (typeof window < "u") {
      const t = (window == null ? void 0 : window.dataLayer) || [];
      t == null || t.push({
        ...e
      });
    }
  } catch {
  }
}, KE = "_cardContent_154uh_1", JE = "_header_154uh_11", ZE = "_title_154uh_17", XE = "_viewButton_154uh_23", QE = "_viewLessButton_154uh_52", eI = "_exampleText_154uh_82", tI = "_timeline_154uh_89", nI = "_timelineContent_154uh_94", sI = "_timelineItem1_154uh_101", rI = "_timelineItem2_154uh_107", iI = "_timelineItem3_154uh_113", oI = "_timelineItemTitle_154uh_119", aI = "_timelineItemText_154uh_126", lI = "_timelineLine_154uh_131", dI = "_timelineDot_154uh_141", cI = "_timelineDot1_154uh_151", uI = "_timelineDot2_154uh_155", hI = "_timelineDot3_154uh_159", fI = "_timelineDot4_154uh_163", pI = "_disbursement_154uh_167", _I = "_disbursementLabel_154uh_171", mI = "_disbursementBar_154uh_179", gI = "_disbursementPrimary_154uh_187", vI = "_disbursementSecondary_154uh_214", $I = "_disbursementUnused_154uh_230", bI = "_total_154uh_246", xI = "_totalContent_154uh_251", yI = "_totalLine_154uh_257", wI = "_totalText_154uh_263", CI = "_viewLessContainer_154uh_270", Se = {
  cardContent: KE,
  header: JE,
  title: ZE,
  viewButton: XE,
  viewLessButton: QE,
  exampleText: eI,
  timeline: tI,
  timelineContent: nI,
  timelineItem1: sI,
  timelineItem2: rI,
  timelineItem3: iI,
  timelineItemTitle: oI,
  timelineItemText: aI,
  timelineLine: lI,
  timelineDot: dI,
  timelineDot1: cI,
  timelineDot2: uI,
  timelineDot3: hI,
  timelineDot4: fI,
  disbursement: pI,
  disbursementLabel: _I,
  disbursementBar: mI,
  disbursementPrimary: gI,
  disbursementSecondary: vI,
  disbursementUnused: $I,
  total: bI,
  totalContent: xI,
  totalLine: yI,
  totalText: wI,
  viewLessContainer: CI
}, jI = ({
  oppID: e,
  onToggle: t
}) => {
  const [n, s] = O(!1), r = (o) => {
    o && o.stopPropagation();
    const a = {
      testVersion: JSON.stringify({
        pageName: "newAtilpage",
        userEvent: "viewMoreCardClick",
        ...e ? { oppID: e } : {}
      })
    };
    Sp(a);
    const l = !n;
    s(l), t == null || t(l);
  };
  return /* @__PURE__ */ i.jsxs("div", { className: Se.cardContent, onClick: (o) => o == null ? void 0 : o.stopPropagation(), children: [
    /* @__PURE__ */ i.jsxs("div", { className: Se.header, children: [
      /* @__PURE__ */ i.jsx(I, { className: Se.title, children: "Only pay on disbursed funds!" }),
      !n && /* @__PURE__ */ i.jsx(
        Ee,
        {
          onClick: (o) => r(o),
          className: Se.viewButton,
          type: "button",
          children: /* @__PURE__ */ i.jsxs("span", { children: [
            "View more ",
            /* @__PURE__ */ i.jsx(U, { name: "dropdownArrow" })
          ] })
        }
      )
    ] }),
    n && /* @__PURE__ */ i.jsxs("div", { className: Se.accordion, children: [
      /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.exampleText, children: "[ Example only ]" }),
      /* @__PURE__ */ i.jsxs("div", { className: Se.timeline, children: [
        /* @__PURE__ */ i.jsxs("div", { className: Se.timelineContent, children: [
          /* @__PURE__ */ i.jsxs("div", { className: Se.timelineItem1, children: [
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemTitle, children: "FALL" }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemText, children: "You're charged interest on only US$25,000." })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { className: Se.timelineItem2, children: [
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemTitle, children: "SPRING" }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemText, children: "Now interest is charged on US$25,000 + US$10,000." })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { className: Se.timelineItem3, children: [
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemTitle, children: "NOT USED" }),
            /* @__PURE__ */ i.jsx(I, { component: "p", className: Se.timelineItemText, children: "No interest is charged on undisbursed funds." })
          ] })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: Se.timelineLine, children: [
          /* @__PURE__ */ i.jsx("div", { className: `${Se.timelineDot} ${Se.timelineDot1}` }),
          /* @__PURE__ */ i.jsx("div", { className: `${Se.timelineDot} ${Se.timelineDot2}` }),
          /* @__PURE__ */ i.jsx("div", { className: `${Se.timelineDot} ${Se.timelineDot3}` }),
          /* @__PURE__ */ i.jsx("div", { className: `${Se.timelineDot} ${Se.timelineDot4}` })
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: Se.disbursement, children: /* @__PURE__ */ i.jsxs("div", { className: Se.disbursementBar, children: [
        /* @__PURE__ */ i.jsxs("div", { className: Se.disbursementPrimary, children: [
          /* @__PURE__ */ i.jsx("span", { children: "Disbursement:   " }),
          "US$25,000"
        ] }),
        /* @__PURE__ */ i.jsx("div", { className: Se.disbursementSecondary, children: "US$10,000" }),
        /* @__PURE__ */ i.jsx("div", { className: Se.disbursementUnused, children: "US$15,000" })
      ] }) }),
      /* @__PURE__ */ i.jsx("div", { className: Se.total, children: /* @__PURE__ */ i.jsxs("div", { className: Se.totalContent, children: [
        /* @__PURE__ */ i.jsx("div", { className: Se.totalLine }),
        /* @__PURE__ */ i.jsx("span", { className: Se.totalText, children: "Total Approved for - US$50,000" }),
        /* @__PURE__ */ i.jsx("div", { className: Se.totalLine })
      ] }) }),
      /* @__PURE__ */ i.jsx("div", { className: Se.viewLessContainer, children: /* @__PURE__ */ i.jsx(
        Ee,
        {
          onClick: (o) => r(o),
          className: Se.viewLessButton,
          type: "button",
          children: /* @__PURE__ */ i.jsxs("span", { children: [
            "View less ",
            /* @__PURE__ */ i.jsx(U, { name: "dropdownArrow" })
          ] })
        }
      ) })
    ] })
  ] });
}, NI = "_spaceAdjusted_wpt54_1", SI = "_tipContainer_wpt54_13", kI = "_imgContainer_wpt54_22", EI = "_imgWrap_wpt54_26", II = "_tipText_wpt54_31", pn = {
  spaceAdjusted: NI,
  tipContainer: SI,
  imgContainer: kI,
  imgWrap: EI,
  tipText: II
}, cL = ({
  hideVisa: e
}) => {
  var s, r, o;
  const t = [
    {
      icon: "/images/fundIcon.png",
      content: /* @__PURE__ */ i.jsx("span", { className: pn == null ? void 0 : pn.tipText, children: (s = ls == null ? void 0 : ls.secureFund) == null ? void 0 : s.title }),
      wrapperClass: pn.tipWrapper
    },
    {
      icon: "/images/noVisa.png",
      content: /* @__PURE__ */ i.jsxs("span", { className: pn == null ? void 0 : pn.tipText, children: [
        /* @__PURE__ */ i.jsx("b", { children: (r = ls == null ? void 0 : ls.noVisaYet) == null ? void 0 : r.title }),
        " ",
        (o = ls == null ? void 0 : ls.noVisaYet) == null ? void 0 : o.details
      ] }),
      wrapperClass: `${pn.tipWrapper} ${pn.spaceAdjusted}`
    }
  ], n = e ? t.filter((a, l) => l !== 1) : t;
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(
    E,
    {
      justify: "center",
      align: "center",
      direction: "row",
      columnGap: { base: "sm" },
      classNames: { root: pn.tipContainer },
      children: n.map((a, l) => /* @__PURE__ */ i.jsxs(
        E,
        {
          justify: "center",
          align: "center",
          direction: "row",
          columnGap: { base: "sm" },
          classNames: { root: a.wrapperClass },
          children: [
            /* @__PURE__ */ i.jsx(E, { classNames: { root: pn.imgContainer }, align: "end", children: /* @__PURE__ */ i.jsx("img", { className: pn == null ? void 0 : pn.imgWrap, src: a.icon }) }),
            a.content
          ]
        },
        l
      ))
    }
  ) });
}, PI = "_card_1tvx9_1", TI = "_cardCode_1tvx9_12", RI = "_cardRow_1tvx9_21", LI = "_cardTitle_1tvx9_26", OI = "_summaryData_1tvx9_42", FI = "_summaryRow_1tvx9_52", AI = "_leftHeader_1tvx9_69", MI = "_rightHeader_1tvx9_86", Xt = {
  card: PI,
  cardCode: TI,
  cardRow: RI,
  cardTitle: LI,
  summaryData: OI,
  summaryRow: FI,
  leftHeader: AI,
  rightHeader: MI
}, uL = ({
  cardData: e,
  aprClick: t,
  oppID: n,
  onViewMoreToggle: s,
  hidePath2Success: r
}) => {
  var o;
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(cn, { className: Xt.card, onClick: (a) => a.stopPropagation(), children: [
    /* @__PURE__ */ i.jsxs(E, { className: Xt.summaryData, children: [
      /* @__PURE__ */ i.jsx(E, { className: Xt.cardRow, children: /* @__PURE__ */ i.jsx(I, { className: Xt.cardTitle, children: "Summary" }) }),
      /* @__PURE__ */ i.jsxs(E, { className: Xt.summaryRow, children: [
        /* @__PURE__ */ i.jsx(I, { className: Xt.leftHeader, children: "Academic period:" }),
        /* @__PURE__ */ i.jsx(I, { className: Xt.rightHeader, children: e == null ? void 0 : e.academicPeriod })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { className: Xt.summaryRow, children: [
        /* @__PURE__ */ i.jsx(I, { className: Xt.leftHeader, children: "Loan payment starts in:" }),
        /* @__PURE__ */ i.jsxs(I, { className: Xt.rightHeader, children: [
          e != null && e.loanStartsIn ? (o = Re(e == null ? void 0 : e.loanStartsIn)) == null ? void 0 : o.format("D MMM YYYY") : "",
          " ",
          /* @__PURE__ */ i.jsx("span", { children: "(est)" })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs(E, { className: Xt.summaryRow, children: [
        /* @__PURE__ */ i.jsxs(I, { className: Xt.leftHeader, children: [
          "Fixed interest rate: ",
          /* @__PURE__ */ i.jsx("br", {}),
          " ",
          /* @__PURE__ */ i.jsx("span", { children: "with 0.25% auto pay discount. Fixed rate for the life of the loan." })
        ] }),
        /* @__PURE__ */ i.jsxs(I, { className: Xt.rightHeader, children: [
          " ",
          e == null ? void 0 : e.interestRate,
          " ",
          /* @__PURE__ */ i.jsx("span", { style: { cursor: "pointer" }, onClick: t, children: e == null ? void 0 : e.apr })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs(
        E,
        {
          className: Xt.summaryRow,
          style: {
            border: "none !important",
            visibility: r ? "hidden" : "visible"
          },
          children: [
            /* @__PURE__ */ i.jsx(I, { className: Xt.leftHeader, children: "Path2Success:" }),
            /* @__PURE__ */ i.jsxs(I, { className: Xt.rightHeader, children: [
              " ",
              "Free career, visa and community benefits included in your loan offer"
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ i.jsx(jI, { oppID: n, onToggle: s })
  ] }) });
}, DI = "_card_we7ut_1", BI = "_cardContent_we7ut_10", WI = "_cardHeader_we7ut_17", UI = "_logoContainer_we7ut_25", zI = "_logo_we7ut_25", HI = "_cardTitle_we7ut_38", qI = "_cardDescription_we7ut_46", GI = "_cardFooter_we7ut_56", VI = "_cardContainer_we7ut_63", YI = "_exploreButton_we7ut_63", KI = "_lockMessage_we7ut_79", JI = "_lockIcon_we7ut_87", ZI = "_imageWrapper_we7ut_101", XI = "_headerImage_we7ut_106", QI = "_contentContainer_we7ut_113", eP = "_logoWrapper_we7ut_127", tP = "_logoText_we7ut_153", nP = "_title_we7ut_161", sP = "_description_we7ut_170", rP = "_layer_we7ut_185", Ln = {
  card: DI,
  cardContent: BI,
  cardHeader: WI,
  logoContainer: UI,
  logo: zI,
  cardTitle: HI,
  cardDescription: qI,
  cardFooter: GI,
  cardContainer: VI,
  exploreButton: YI,
  lockMessage: KI,
  lockIcon: JI,
  imageWrapper: ZI,
  headerImage: XI,
  contentContainer: QI,
  logoWrapper: eP,
  logoText: tP,
  title: nP,
  description: sP,
  layer: rP
}, iP = ({
  service: e,
  showExploreButton: t,
  email: n
}) => {
  const {
    logo: s,
    title: r,
    description: o,
    titleImage: a,
    lockMessage: l,
    buttonText: d,
    buttonClickNavigation: c,
    partnerName: u
  } = e, h = (p, f) => {
    Sp({
      event: "userProvidedData",
      leadsUserData: {
        emailID: n,
        exploreButtonURL: p,
        customEvent: "MarketplaceExploreButton",
        partnerName: f
      }
    }), window == null || window.open(p, "_blank");
  };
  return /* @__PURE__ */ i.jsx(cn, { className: Ln.card, children: /* @__PURE__ */ i.jsxs("div", { className: Ln.cardContainer, children: [
    /* @__PURE__ */ i.jsx("div", { className: Ln.imageWrapper, children: /* @__PURE__ */ i.jsx("img", { src: a, className: Ln.headerImage }) }),
    /* @__PURE__ */ i.jsxs("div", { className: Ln.contentContainer, children: [
      !t && /* @__PURE__ */ i.jsxs("div", { className: Ln.layer, children: [
        /* @__PURE__ */ i.jsx(U, { name: "iconLock" }),
        /* @__PURE__ */ i.jsx(Ce, { component: "p", children: l })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: Ln.logoContainer, children: /* @__PURE__ */ i.jsxs(E, { className: Ln.logoWrapper, children: [
        /* @__PURE__ */ i.jsx("div", { className: Ln.logo, children: /* @__PURE__ */ i.jsx("img", { src: s }) }),
        /* @__PURE__ */ i.jsx(E, { className: Ln.logoText, children: r })
      ] }) }),
      /* @__PURE__ */ i.jsx(Ce, { component: "p", className: Ln.description, children: o }),
      /* @__PURE__ */ i.jsx(
        qe,
        {
          className: Ln.exploreButton,
          onClick: () => h(c, u),
          children: d
        }
      )
    ] })
  ] }) });
}, oP = "_container_b21es_1", aP = "_tabs_b21es_6", lP = "_tabsWRap_b21es_28", dP = "_tabsList_b21es_45", cP = "_tab_b21es_6", uP = "_activeTab_b21es_77", hP = "_contentSection_b21es_97", fP = "_sectionTitle_b21es_112", pP = "_cardsContainer_b21es_129", Fs = {
  container: oP,
  tabs: aP,
  tabsWRap: lP,
  tabsList: dP,
  tab: cP,
  activeTab: uP,
  contentSection: hP,
  sectionTitle: fP,
  cardsContainer: pP
}, hL = ({
  showExploreButton: e,
  backgroundImageUrl: t,
  tabItems: n,
  email: s
}) => {
  const r = Ve("(max-width: 767px)"), [o, a] = O("career");
  return /* @__PURE__ */ i.jsx("div", { className: Fs.container, children: /* @__PURE__ */ i.jsxs(Xi, { value: o, onChange: a, children: [
    /* @__PURE__ */ i.jsx(Xi.List, { className: Fs.tabs, children: n == null ? void 0 : n.map((l) => /* @__PURE__ */ i.jsx(
      Xi.Tab,
      {
        value: l.value,
        className: o === l.value ? Fs.activeTab : Fs.tab,
        children: /* @__PURE__ */ i.jsxs(E, { className: Fs.tabsWRap, children: [
          " ",
          /* @__PURE__ */ i.jsx(U, { name: l.icon, style: { transform: `scale(${l.scale})` } }),
          r ? l.mobileLabel : l.label
        ] })
      },
      l.value
    )) }),
    /* @__PURE__ */ i.jsx($t, { h: 20 }),
    n == null ? void 0 : n.map((l) => {
      var d;
      return /* @__PURE__ */ i.jsxs(
        Xi.Panel,
        {
          value: l.value,
          className: Fs.contentSection,
          style: { backgroundImage: `url(${t})` },
          children: [
            /* @__PURE__ */ i.jsx("h2", { className: Fs.sectionTitle, children: "Choose from our top partner(s)" }),
            /* @__PURE__ */ i.jsx("div", { className: Fs.cardsContainer, children: (d = q0[l == null ? void 0 : l.value]) == null ? void 0 : d.map(
              (c) => /* @__PURE__ */ i.jsx(
                iP,
                {
                  service: c,
                  showExploreButton: e,
                  email: s
                },
                c.title
              )
            ) })
          ]
        },
        l.value
      );
    })
  ] }) });
}, _P = "_linkedinList_cq8pk_1", mP = "_highlight_cq8pk_9", ar = {
  linkedinList: _P,
  highlight: mP
}, fL = (e) => {
  const { opened: t, closePopup: n } = e;
  return /* @__PURE__ */ i.jsxs(
    Y7,
    {
      opened: t,
      onCancel: n,
      onConfirm: n,
      size: "md",
      isCustomBodyClassRequire: !0,
      customBodyClass: ar.modalBody,
      children: [
        /* @__PURE__ */ i.jsx(ee, { order: 4, variant: "blue", children: "How to Get Your LinkedIn URL" }),
        /* @__PURE__ */ i.jsx($t, { h: 25 }),
        /* @__PURE__ */ i.jsxs(Be, { spacing: "xs", size: "sm", type: "ordered", className: ar.linkedinList, children: [
          /* @__PURE__ */ i.jsx(Be.Item, { className: ar.linkedinList, children: "Log into Linkedin." }),
          /* @__PURE__ */ i.jsxs(Be.Item, { className: ar.linkedinList, children: [
            "Click the ",
            /* @__PURE__ */ i.jsx("b", { children: '"Me"' }),
            " at the top of your LinkedIn homepage."
          ] }),
          /* @__PURE__ */ i.jsxs(Be.Item, { className: ar.linkedinList, children: [
            "Copy the URL from your browser's address bar. e.g.",
            " ",
            /* @__PURE__ */ i.jsx("span", { className: ar.highlight, children: "https://www.linkedin.com/in/your-name" }),
            /* @__PURE__ */ i.jsx("img", { src: "/images/linkedin1.png" })
          ] }),
          /* @__PURE__ */ i.jsxs(Be.Item, { className: ar.linkedinList, children: [
            "Paste the URL into the URL profile field.",
            /* @__PURE__ */ i.jsx("img", { src: "/images/linkedin2.png" })
          ] })
        ] })
      ]
    }
  );
}, gP = "_alertContainer_17so7_1", vP = "_iconContainer_17so7_21", $P = "_alertIcon_17so7_38", bP = "_contentContainer_17so7_51", xP = "_alertTitle_17so7_57", yP = "_alertDescription_17so7_70", Mr = {
  alertContainer: gP,
  iconContainer: vP,
  alertIcon: $P,
  contentContainer: bP,
  alertTitle: xP,
  alertDescription: yP
}, pL = ({ className: e = "" }) => /* @__PURE__ */ i.jsxs("div", { className: `${Mr.alertContainer} ${e}`, children: [
  /* @__PURE__ */ i.jsx("div", { className: Mr.iconContainer, children: /* @__PURE__ */ i.jsx(U, { name: "kickbackAlert", className: Mr.alertIcon }) }),
  /* @__PURE__ */ i.jsxs("div", { className: Mr.contentContainer, children: [
    /* @__PURE__ */ i.jsx(ys, { order: 5, className: Mr.alertTitle, children: "Difference detected" }),
    /* @__PURE__ */ i.jsx(Ce, { className: Mr.alertDescription, children: "We found some differences between your entered information and your ID document." })
  ] })
] }), wP = "_radioCard_b00l6_1", CP = "_selected_b00l6_24", jP = "_unselected_b00l6_29", NP = "_detailLabel_b00l6_34", SP = "_detailValue_b00l6_44", kP = "_differentValue_b00l6_59", EP = "_cardContent_b00l6_63", IP = "_radioSection_b00l6_75", PP = "_radio_b00l6_1", TP = "_contentSection_b00l6_94", RP = "_header_b00l6_107", LP = "_title_b00l6_120", OP = "_subtitle_b00l6_133", FP = "_details_b00l6_140", AP = "_detailRow_b00l6_146", MP = "_backgroundImage_b00l6_161", DP = "_bgImage_b00l6_174", BP = "_optionWrap_b00l6_186", WP = "_higlightText_b00l6_203", UP = "_mpowerIcon_b00l6_213", Lt = {
  radioCard: wP,
  selected: CP,
  unselected: jP,
  detailLabel: NP,
  detailValue: SP,
  differentValue: kP,
  cardContent: EP,
  radioSection: IP,
  radio: PP,
  contentSection: TP,
  header: RP,
  title: LP,
  subtitle: OP,
  details: FP,
  detailRow: AP,
  backgroundImage: MP,
  bgImage: DP,
  optionWrap: BP,
  higlightText: WP,
  mpowerIcon: UP
}, _L = ({
  id: e,
  name: t,
  value: n,
  checked: s,
  onChange: r,
  title: o,
  subtitle: a,
  details: l,
  backgroundImage: d,
  isRecommended: c = !1,
  className: u = ""
}) => /* @__PURE__ */ i.jsx(
  cn,
  {
    className: `${Lt.radioCard} ${s ? Lt.selected : Lt.unselected} ${u}`,
    onClick: () => r(n),
    children: /* @__PURE__ */ i.jsxs("div", { className: Lt.cardContent, children: [
      /* @__PURE__ */ i.jsx("div", { className: Lt.radioSection, children: /* @__PURE__ */ i.jsx(
        vt,
        {
          id: e,
          name: t,
          value: n,
          checked: s,
          onChange: () => r(n),
          className: Lt.radio,
          variant: "outline"
        }
      ) }),
      /* @__PURE__ */ i.jsxs("div", { className: Lt.contentSection, children: [
        /* @__PURE__ */ i.jsxs("div", { className: Lt.header, children: [
          /* @__PURE__ */ i.jsx(Ce, { className: Lt.title, children: o }),
          c && /* @__PURE__ */ i.jsxs(E, { align: "center", gap: 6, className: Lt.optionWrap, children: [
            /* @__PURE__ */ i.jsx(
              "img",
              {
                src: "/images/mpower-white-logo.png",
                alt: "mpower",
                className: Lt.mpowerIcon
              }
            ),
            /* @__PURE__ */ i.jsx(Ce, { className: Lt.higlightText, children: "MPOWER Recommended" })
          ] })
        ] }),
        a && /* @__PURE__ */ i.jsx(Ce, { className: Lt.subtitle, children: a }),
        /* @__PURE__ */ i.jsx("div", { className: Lt.details, children: l == null ? void 0 : l.map((h, p) => /* @__PURE__ */ i.jsxs("div", { className: Lt.detailRow, children: [
          /* @__PURE__ */ i.jsxs(Ce, { className: Lt.detailLabel, children: [
            h == null ? void 0 : h.label,
            ":"
          ] }),
          /* @__PURE__ */ i.jsx(
            Ce,
            {
              className: `${Lt.detailValue} ${h != null && h.isDifferent ? Lt.differentValue : ""}`,
              children: h == null ? void 0 : h.value
            }
          )
        ] }, p)) })
      ] }),
      d && /* @__PURE__ */ i.jsx("div", { className: Lt.backgroundImage, children: /* @__PURE__ */ i.jsx(yi, { src: d, alt: "Background", className: Lt.bgImage }) })
    ] })
  }
), mL = ({ error: e }) => /* @__PURE__ */ i.jsx(T, { pt: 20, children: /* @__PURE__ */ i.jsx(T.Col, { span: 12, children: e ? /* @__PURE__ */ i.jsx(Jp, { title: "Oops !! Something went wrong while saving your data !", color: "red" }) : null }) }), zP = "_body_x6t5g_1", HP = "_inner_x6t5g_13", qP = "_label_x6t5g_30", vo = {
  body: zP,
  inner: HP,
  label: qP
}, gL = ({
  incomingData: e,
  defaultValue: t,
  id: n,
  name: s,
  error: r
}) => {
  var l;
  const [o, a] = O(t || []);
  return /* @__PURE__ */ i.jsx(
    $r.Group,
    {
      value: o,
      onChange: a,
      defaultValue: o,
      id: n,
      error: (l = r == null ? void 0 : r.fieldErrors) == null ? void 0 : l[n],
      children: /* @__PURE__ */ i.jsx(ss, { mt: "xs", children: e == null ? void 0 : e.map((d, c) => /* @__PURE__ */ i.jsx(
        $r,
        {
          value: d.value,
          name: s,
          classNames: { body: vo.body, label: vo.label, inner: vo.inner },
          label: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx(U, { name: d.icon }),
            /* @__PURE__ */ i.jsx(Ce, { className: vo.label, children: d.label })
          ] })
        },
        c
      )) })
    }
  );
}, GP = "_sidebar_2yct1_1", VP = "_stepList_2yct1_17", YP = "_stepItem_2yct1_26", KP = "_stepLeft_2yct1_33", JP = "_stepCircle_2yct1_41", ZP = "_stepCirclePending_2yct1_53", XP = "_stepCircleActive_2yct1_58", QP = "_stepCircleCompleted_2yct1_63", eT = "_stepConnector_2yct1_68", tT = "_stepConnectorCompleted_2yct1_76", nT = "_stepContent_2yct1_80", sT = "_stepLabel_2yct1_85", rT = "_stepLabelPending_2yct1_94", iT = "_stepLabelActive_2yct1_98", oT = "_stepLabelCompleted_2yct1_102", aT = "_stepDescription_2yct1_106", lT = "_checkIcon_2yct1_114", dT = "_activeDotsIcon_2yct1_121", qt = {
  sidebar: GP,
  stepList: VP,
  stepItem: YP,
  stepLeft: KP,
  stepCircle: JP,
  stepCirclePending: ZP,
  stepCircleActive: XP,
  stepCircleCompleted: QP,
  stepConnector: eT,
  stepConnectorCompleted: tT,
  stepContent: nT,
  stepLabel: sT,
  stepLabelPending: rT,
  stepLabelActive: iT,
  stepLabelCompleted: oT,
  stepDescription: aT,
  checkIcon: lT,
  activeDotsIcon: dT
};
function cT({
  steps: e,
  activeStep: t,
  completedSteps: n = []
}) {
  return /* @__PURE__ */ i.jsx("aside", { className: qt.sidebar, children: /* @__PURE__ */ i.jsx("ul", { className: qt.stepList, children: e.map((s, r) => {
    const o = n.includes(r), a = r === t, l = !o && !a, d = r === e.length - 1;
    return /* @__PURE__ */ i.jsxs("li", { className: qt.stepItem, children: [
      /* @__PURE__ */ i.jsxs("div", { className: qt.stepLeft, children: [
        /* @__PURE__ */ i.jsxs(
          "div",
          {
            className: R(qt.stepCircle, {
              [qt.stepCirclePending]: l,
              [qt.stepCircleActive]: a,
              [qt.stepCircleCompleted]: o
            }),
            children: [
              o && /* @__PURE__ */ i.jsx(
                "svg",
                {
                  width: "16",
                  height: "12",
                  viewBox: "0 0 16 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ i.jsx(
                    "path",
                    {
                      d: "M1.5 6L6 10.5L14.5 1.5",
                      stroke: "white",
                      strokeWidth: "2.2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  )
                }
              ),
              a && /* @__PURE__ */ i.jsx("span", { className: qt.activeDotsIcon, children: "•••" })
            ]
          }
        ),
        !d && /* @__PURE__ */ i.jsx(
          "div",
          {
            className: R(qt.stepConnector, {
              [qt.stepConnectorCompleted]: o
            })
          }
        )
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: qt.stepContent, children: [
        /* @__PURE__ */ i.jsx(
          "p",
          {
            className: R(qt.stepLabel, {
              [qt.stepLabelPending]: l,
              [qt.stepLabelActive]: a,
              [qt.stepLabelCompleted]: o
            }),
            children: s.label
          }
        ),
        s.description && /* @__PURE__ */ i.jsx("p", { className: qt.stepDescription, children: s.description })
      ] })
    ] }, r);
  }) }) });
}
const uT = "_topBar_ghl90_1", hT = "_stepsRow_ghl90_15", fT = "_stepWrapper_ghl90_23", pT = "_connectorCompleted_ghl90_42", _T = "_stepCircle_ghl90_46", mT = "_stepCirclePending_ghl90_58", gT = "_stepCircleActive_ghl90_63", vT = "_stepCircleCompleted_ghl90_68", $T = "_stepLabel_ghl90_73", bT = "_stepLabelActive_ghl90_83", xT = "_stepLabelCompleted_ghl90_87", yT = "_checkIcon_ghl90_91", wT = "_activeDot_ghl90_98", Cn = {
  topBar: uT,
  stepsRow: hT,
  stepWrapper: fT,
  connectorCompleted: pT,
  stepCircle: _T,
  stepCirclePending: mT,
  stepCircleActive: gT,
  stepCircleCompleted: vT,
  stepLabel: $T,
  stepLabelActive: bT,
  stepLabelCompleted: xT,
  checkIcon: yT,
  activeDot: wT
};
function CT({
  steps: e,
  activeStep: t,
  completedSteps: n = []
}) {
  return /* @__PURE__ */ i.jsx("div", { className: Cn.topBar, children: /* @__PURE__ */ i.jsx("div", { className: Cn.stepsRow, children: e.map((s, r) => {
    const o = n.includes(r), a = r === t, l = !o && !a;
    return /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: R(Cn.stepWrapper, {
          [Cn.connectorCompleted]: o
        }),
        children: [
          /* @__PURE__ */ i.jsxs(
            "div",
            {
              className: R(Cn.stepCircle, {
                [Cn.stepCirclePending]: l,
                [Cn.stepCircleActive]: a,
                [Cn.stepCircleCompleted]: o
              }),
              children: [
                o && /* @__PURE__ */ i.jsx("span", { className: Cn.checkIcon, children: "✓" }),
                a && /* @__PURE__ */ i.jsx("span", { className: Cn.activeDot })
              ]
            }
          ),
          /* @__PURE__ */ i.jsx(
            "span",
            {
              className: R(Cn.stepLabel, {
                [Cn.stepLabelActive]: a,
                [Cn.stepLabelCompleted]: o
              }),
              children: s.label
            }
          )
        ]
      },
      r
    );
  }) }) });
}
const jT = "_wrapper_1emp8_1", NT = "_sidebarCol_1emp8_15", ST = "_mainCol_1emp8_26", kT = "_contentCard_1emp8_31", ET = "_pageHeading_1emp8_43", IT = "_pageTitle_1emp8_47", PT = "_pageSubtitle_1emp8_60", lr = {
  wrapper: jT,
  sidebarCol: NT,
  mainCol: ST,
  contentCard: kT,
  pageHeading: ET,
  pageTitle: IT,
  pageSubtitle: PT
};
function vL({
  steps: e,
  activeStep: t,
  completedSteps: n = [],
  title: s,
  subtitle: r,
  children: o
}) {
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(CT, { steps: e, activeStep: t, completedSteps: n }),
    /* @__PURE__ */ i.jsxs("div", { className: lr.wrapper, children: [
      /* @__PURE__ */ i.jsx("div", { className: lr.sidebarCol, children: /* @__PURE__ */ i.jsx(
        cT,
        {
          steps: e,
          activeStep: t,
          completedSteps: n
        }
      ) }),
      /* @__PURE__ */ i.jsx("div", { className: lr.mainCol, children: /* @__PURE__ */ i.jsxs("div", { className: lr.contentCard, children: [
        /* @__PURE__ */ i.jsxs("div", { className: lr.pageHeading, children: [
          /* @__PURE__ */ i.jsx("h1", { className: lr.pageTitle, children: s }),
          r && /* @__PURE__ */ i.jsx("p", { className: lr.pageSubtitle, children: r })
        ] }),
        o
      ] }) })
    ] })
  ] });
}
const TT = new Intl.DateTimeFormat("en-US"), $L = (e) => TT.format(e), bL = (e) => {
  const { href: t, rel: n = "noopener", target: s = "_blank" } = e, r = document.createElement("a");
  r.rel = n, r.target = s, r.href = t, r.click(), r.remove();
}, dr = (e) => () => {
  var t;
  return typeof navigator < "u" && !!((t = navigator.userAgent) != null && t.match(e));
}, xi = {
  Android: dr(/Android/i),
  BlackBerry: dr(/BlackBerry/i),
  iOS: dr(/iPhone|iPad|iPod/i),
  Opera: dr(/Opera Mini/i),
  Windows: () => dr(/IEMobile/i)() || dr(/Windows Phone/i)() || dr(/WPDesktop/i)(),
  any: () => xi.Android() || xi.BlackBerry() || xi.iOS() || xi.Opera() || xi.Windows()
}, RT = {
  white: "#FFF",
  black: "#000",
  colors: {
    dark: [
      "#243D74",
      "#FFAF0F",
      "#F5FAFF",
      "#F05437",
      "#2D4B91",
      "#5C6972",
      "#1E3C78",
      "#1E3C7827",
      "#32B4F0",
      "#9EDBF6c"
    ]
  },
  primaryColor: "dark",
  // breakpoints: breakpointWidths(),
  fontFamily: "Montserrat, sans-serif",
  headings: {
    fontFamily: "Zilla Slab, serif",
    fontWeight: "400",
    sizes: {
      h1: {
        fontSize: "4.5rem",
        lineHeight: "5.4rem"
      },
      h2: {
        fontSize: "2.875rem",
        lineHeight: "3.375rem"
      },
      h3: {
        fontSize: "2.1rem",
        lineHeight: "2.6rem"
      },
      h4: {
        fontSize: "1.5rem",
        lineHeight: "2rem"
      },
      h5: {
        fontSize: "1.25rem",
        lineHeight: "2rem"
      },
      h6: {
        fontSize: "1.125rem",
        lineHeight: "1.75rem"
      }
    }
  },
  components: {
    Modal: {
      styles: () => ({
        root: {
          zIndex: Z0.MODAL
        },
        modal: {
          borderRadius: ws(16)
        },
        close: {
          svg: {
            width: ws(16),
            height: ws(16),
            color: gn.brightGrey
          }
        }
      })
    }
  }
}, xL = ({ children: e }) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
  /* @__PURE__ */ i.jsx(Zp, { defaultColorScheme: "light", forceColorScheme: "light" }),
  /* @__PURE__ */ i.jsx(Xp, { theme: RT, defaultColorScheme: "light", forceColorScheme: "light", children: e })
] });
export {
  WR as APRModal,
  vL as AchPageLayout,
  cT as AchProgressSidebar,
  CT as AchProgressTopBar,
  wR as AddNewApplicationCard,
  NR as AdditionalFundingSlider,
  KT as AppShell,
  yR as ApplicationCard,
  mR as ApplicationDetails,
  MR as ApplicationInProgressModal,
  rR as ApplicationTip,
  CR as ApplicationsTable,
  XT as BorrowerLayout,
  qe as Button,
  GR as COAModal,
  qT as Checkbox,
  gL as CheckboxGroup,
  IR as Code,
  gn as ColorPallet,
  hR as CompleteTaskBar,
  FR as ConfirmEmailBanner,
  tL as ContactibilityEmailList,
  nL as ContactibilityPhoneList,
  sL as ContactibilityReferenceList,
  Vw as CustomCalender,
  qR as CustomerSupport,
  Sw as DashboardApplicationTask,
  vR as DashboardApplicationTasks,
  ER as DashboardButtonsSet,
  c2 as DashboardHeader,
  uR as DashboardMobileWave,
  fR as DashboardProgressCard,
  bR as DashboardWave,
  tR as DatePicker,
  pL as DifferenceAlert,
  pR as DisbursementSchedule,
  OR as DisbursementSelectionCard,
  TR as DisbursementTable,
  ZR as DocumentsUpload,
  aR as ExamTestScore,
  dL as ExclusiveBenefits,
  HR as FAQAccordion,
  nR as FinancialCard1,
  lR as FooterButtons,
  Y7 as GeneralInfoPopup,
  GT as HeaderMain,
  U as Icon,
  p2 as InPageInfo,
  VR as InfoModal,
  zR as Infotip,
  VT as JobList,
  fL as LinkedinGuide,
  ts as Loader,
  LR as LoanCard,
  RR as LoanChartCard,
  _R as LoanDocuments,
  DR as LoanPaymentCard,
  uL as LoanSummary,
  B4 as LoanTermCard,
  Sd as LoanTermCollapse,
  $R as LoanTerms,
  UR as LoanTermsBox,
  PR as LoansTable,
  cL as MPOWERFundBenefits,
  oR as MonthPicker,
  iP as MpowerStudentServiceCard,
  hL as MpowerStudentServices,
  KR as NerdWalletReview,
  QT as NonEligibleLayout,
  ch as Notification,
  sR as NumberField,
  aL as OTP,
  jR as PageStepper,
  ca as PasswordTextfield,
  jI as PaymentSampleChart,
  AR as PayoffConfirmationModal,
  UT as PhoneNumber,
  Np as PhoneNumberTextfield,
  i0 as PredictiveSearch,
  BR as PredictiveSearchArea,
  QR as ProgressBarNotification,
  iR as ProgressStepper,
  _L as RadioCard,
  gR as RecentActivity,
  lL as RepaymentJourney,
  mL as SFError,
  YT as Select,
  aS as SelectDropdown,
  x0 as SingleSelect,
  E0 as SingleSelectEligibility,
  JR as SingleSelectNew,
  eR as SingleSelectWithIcon,
  WT as Slider,
  YR as SpoilerTip,
  XR as SsoLogin,
  dR as StartNewAppBanner,
  m9 as TaskAccordion,
  I as Text,
  kR as TextArea,
  Di as TextField,
  xL as ThemeProvider,
  HT as Tip,
  ee as Title,
  cR as UniversityCard,
  iL as UpdatePassword,
  zT as UploadDocumentCard,
  xR as UploadMultipleDocuments,
  Q9 as UploadSingleDocument,
  SR as UploadSingleDocumentCard,
  rL as UserAddress,
  oL as UserConsent,
  eL as WarningMessage,
  Z0 as Z_INDEX,
  Je as formatCurrency,
  $L as formatDate,
  xp as getFileMimeTypeFromURL,
  yp as getFileNameFromURL,
  xi as isMobile,
  bL as openLink,
  ws as rem,
  ZT as removeMultipleKeysFromLS,
  _n as safeLocalStorage,
  JT as safeSessionStorage
};
